import { memo, forwardRef, createElement, useId } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/IconAbcRectangleFilled/IconAbcRectangleFilled.tsx
var IconAbcRectangleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.796 6.008q.747 0 1.133.484.396.473.396 1.364v2.134q0 .87-.385 1.364-.385.484-1.144.484-.615 0-.99-.418-.023-.022-.044-.011-.022 0-.022.033v.176q0 .056-.044.099a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099V8.182q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.287q.055 0 .088.044.044.033.044.088v2.233q0 .022.022.022.044 0 .088-.055.374-.374.946-.374m-.022 1.958a.7.7 0 0 0-.143-.451.46.46 0 0 0-.374-.176.49.49 0 0 0-.341.132.58.58 0 0 0-.176.352v2.2q.032.22.176.352a.49.49 0 0 0 .34.132.46.46 0 0 0 .375-.176.7.7 0 0 0 .143-.451zm-5.448-1.958q.935 0 1.518.506.582.506.583 1.331v3.773q0 .056-.044.099a.12.12 0 0 1-.088.033H7.808a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-.242q0-.033-.022-.044-.023-.01-.044.022-.363.463-1.122.484a1.8 1.8 0 0 1-1.111-.352q-.462-.352-.462-1.342 0-1.023.56-1.408.572-.385 1.64-.385h.506q.054 0 .055-.055v-.275a.7.7 0 0 0-.165-.484.48.48 0 0 0-.396-.198.46.46 0 0 0-.32.121.53.53 0 0 0-.153.319q-.011.132-.143.132l-1.32-.011q-.132 0-.132-.132.054-.802.627-1.276.57-.484 1.452-.484m-.11 4.631a.7.7 0 0 0 .45-.165.57.57 0 0 0 .21-.462v-.517q0-.055-.055-.055H7.17a.68.68 0 0 0-.484.176q-.177.165-.176.462 0 .275.132.418.143.143.374.143m8.344.704q.561.495 1.53.495.967 0 1.517-.484.561-.484.561-1.298v-.253a.1.1 0 0 0-.044-.088.1.1 0 0 0-.088-.044l-1.287-.011a.14.14 0 0 0-.099.044.12.12 0 0 0-.033.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.176.7.7 0 0 1-.143-.462v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.231 0 .374.165.154.165.154.407v.132q0 .132.132.132l1.287-.055a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-.198q0-.792-.56-1.287-.55-.495-1.519-.495t-1.529.506q-.55.506-.55 1.342v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconAbcRectangleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.796 6.008q.747 0 1.133.484.396.473.396 1.364v2.134q0 .87-.386 1.364-.385.483-1.144.484-.615 0-.99-.418-.021-.023-.043-.011-.022 0-.022.033v.176q0 .055-.044.099a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.1V8.183q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.288q.055 0 .088.044.043.033.043.088v2.233q0 .021.023.022.043 0 .088-.055.374-.374.945-.374m-.023 1.958a.7.7 0 0 0-.143-.451.46.46 0 0 0-.373-.176.49.49 0 0 0-.341.132.58.58 0 0 0-.176.352v2.2q.032.22.176.352a.49.49 0 0 0 .34.132.46.46 0 0 0 .375-.176.7.7 0 0 0 .143-.451zm-5.448-1.958q.936 0 1.518.506.583.505.583 1.33v3.774q0 .055-.044.099a.12.12 0 0 1-.088.033H7.807a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.1v-.241q0-.033-.022-.044t-.044.022q-.363.463-1.122.484a1.8 1.8 0 0 1-1.11-.352q-.463-.352-.463-1.342 0-1.023.561-1.408.572-.385 1.64-.385h.505q.055 0 .055-.055v-.275a.7.7 0 0 0-.165-.484.48.48 0 0 0-.396-.198.46.46 0 0 0-.319.12.53.53 0 0 0-.154.32q-.01.132-.143.132l-1.32-.011q-.132 0-.132-.132.056-.803.627-1.276.573-.484 1.452-.484m-.11 4.63a.7.7 0 0 0 .451-.164.57.57 0 0 0 .21-.462v-.517q0-.055-.056-.055h-.45a.68.68 0 0 0-.485.176q-.176.165-.176.462 0 .274.132.418.143.143.374.143m8.345.705q.561.495 1.529.495t1.518-.484q.56-.485.56-1.298v-.253a.1.1 0 0 0-.043-.088.1.1 0 0 0-.088-.044l-1.287-.011a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.176.7.7 0 0 1-.143-.462v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.231 0 .374.165.154.164.154.407v.132q0 .132.132.132l1.287-.055a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.1v-.197q0-.792-.561-1.287-.55-.495-1.518-.495-.967 0-1.53.506-.55.505-.55 1.342v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconAbcRectangleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.796 6.008q.747 0 1.133.484.396.473.396 1.364v2.134q0 .87-.385 1.364-.385.484-1.144.484-.617 0-.99-.418-.023-.022-.044-.011-.022 0-.022.033v.176q0 .056-.044.099a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099V8.182q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.287q.054 0 .088.044.044.033.044.088v2.233q0 .022.022.022.043 0 .088-.055.373-.374.946-.374m-.022 1.958a.7.7 0 0 0-.143-.451.46.46 0 0 0-.374-.176.49.49 0 0 0-.341.132.58.58 0 0 0-.176.352v2.2q.033.22.176.352a.49.49 0 0 0 .34.132.46.46 0 0 0 .375-.176.7.7 0 0 0 .143-.451zm-5.449-1.958q.936 0 1.518.506.584.506.583 1.331v3.773q0 .056-.044.099a.12.12 0 0 1-.088.033H7.807a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-.242q0-.033-.022-.044t-.044.022q-.363.463-1.122.484a1.8 1.8 0 0 1-1.11-.352q-.463-.352-.463-1.342 0-1.023.561-1.408.572-.385 1.64-.385h.505q.055 0 .055-.055v-.275a.7.7 0 0 0-.165-.484.48.48 0 0 0-.396-.198.46.46 0 0 0-.319.121.53.53 0 0 0-.154.319q-.01.132-.143.132l-1.32-.011q-.132 0-.132-.132.055-.802.627-1.276.573-.484 1.452-.484m-.11 4.631a.7.7 0 0 0 .451-.165.57.57 0 0 0 .21-.462v-.517q0-.055-.056-.055h-.45a.68.68 0 0 0-.485.176q-.176.165-.176.462 0 .275.132.418.144.143.374.143m8.345.704q.561.495 1.529.495t1.518-.484q.561-.484.561-1.298v-.253a.1.1 0 0 0-.044-.088.1.1 0 0 0-.088-.044l-1.287-.011a.14.14 0 0 0-.099.044.12.12 0 0 0-.033.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.176.7.7 0 0 1-.143-.462v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.231 0 .374.165.154.165.154.407v.132q0 .132.132.132l1.287-.055a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-.198q0-.792-.561-1.287-.55-.495-1.518-.495t-1.529.506q-.55.506-.55 1.342v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconAbcRectangleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.796 6.008q.747 0 1.133.484.396.473.396 1.364v2.134q0 .87-.385 1.364-.385.484-1.144.484-.617 0-.99-.418-.023-.022-.044-.011-.022 0-.022.033v.176q0 .056-.044.099a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099V8.182q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.287q.054 0 .088.044.044.033.044.088v2.233q0 .022.022.022.043 0 .088-.055.373-.374.946-.374m-.022 1.958a.7.7 0 0 0-.143-.451.46.46 0 0 0-.374-.176.49.49 0 0 0-.341.132.58.58 0 0 0-.176.352v2.2q.033.22.176.352a.49.49 0 0 0 .34.132.46.46 0 0 0 .375-.176.7.7 0 0 0 .143-.451zm-5.449-1.958q.936 0 1.518.506.584.506.583 1.331v3.773q0 .056-.044.099a.12.12 0 0 1-.088.033H7.807a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-.242q0-.033-.022-.044t-.044.022q-.363.463-1.122.484a1.8 1.8 0 0 1-1.11-.352q-.463-.352-.463-1.342 0-1.023.561-1.408.572-.385 1.64-.385h.505q.055 0 .055-.055v-.275a.7.7 0 0 0-.165-.484.48.48 0 0 0-.396-.198.46.46 0 0 0-.319.121.53.53 0 0 0-.154.319q-.01.132-.143.132l-1.32-.011q-.132 0-.132-.132.055-.802.627-1.276.573-.484 1.452-.484m-.11 4.631a.7.7 0 0 0 .451-.165.57.57 0 0 0 .21-.462v-.517q0-.055-.056-.055h-.45a.68.68 0 0 0-.485.176q-.176.165-.176.462 0 .275.132.418.144.143.374.143m8.345.704q.561.495 1.529.495t1.518-.484q.561-.484.561-1.298v-.253a.1.1 0 0 0-.044-.088.1.1 0 0 0-.088-.044l-1.287-.011a.14.14 0 0 0-.099.044.12.12 0 0 0-.033.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.176.7.7 0 0 1-.143-.462v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.231 0 .374.165.154.165.154.407v.132q0 .132.132.132l1.287-.055a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-.198q0-.792-.561-1.287-.55-.495-1.518-.495t-1.529.506q-.55.506-.55 1.342v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconAbcRectangleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.795 6.009q.749 0 1.133.483.396.473.396 1.364v2.135q0 .869-.385 1.364-.385.483-1.144.483-.615 0-.99-.417-.022-.023-.044-.011-.021 0-.022.033v.175q0 .055-.044.1a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.099-.034.16.16 0 0 1-.033-.099V8.182q0-.055.033-.088a.14.14 0 0 1 .1-.044h1.286q.055 0 .088.044.044.034.044.088v2.233q0 .023.022.023.045 0 .088-.056.375-.373.946-.373m-.022 1.957a.7.7 0 0 0-.143-.45.46.46 0 0 0-.374-.177.49.49 0 0 0-.34.133.58.58 0 0 0-.177.351v2.2q.033.22.176.353a.49.49 0 0 0 .341.132.46.46 0 0 0 .374-.176.7.7 0 0 0 .143-.452zM7.125 10.01q.935 0 1.518.505.583.507.583 1.332v3.772q0 .055-.044.1a.12.12 0 0 1-.088.033H7.807a.16.16 0 0 1-.1-.034.16.16 0 0 1-.032-.099v-.242q0-.032-.022-.043-.023-.011-.044.021-.363.463-1.122.485a1.8 1.8 0 0 1-1.111-.353q-.462-.351-.462-1.341 0-1.023.56-1.408.573-.386 1.64-.386h.506q.055 0 .055-.055v-.274a.7.7 0 0 0-.165-.485.48.48 0 0 0-.396-.198.46.46 0 0 0-.32.121.53.53 0 0 0-.153.32q-.01.132-.143.132l-1.32-.012q-.132 0-.132-.132.056-.802.627-1.276.572-.483 1.452-.484m-.11 4.63a.7.7 0 0 0 .45-.164.57.57 0 0 0 .21-.463v-.517q0-.054-.055-.054h-.451a.68.68 0 0 0-.484.175q-.176.165-.176.463 0 .274.132.417.143.144.374.143m8.345.705q.56.495 1.529.495.967 0 1.518-.485.56-.483.56-1.297v-.254a.1.1 0 0 0-.043-.088.1.1 0 0 0-.088-.043l-1.287-.011a.14.14 0 0 0-.1.043.12.12 0 0 0-.032.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.175.7.7 0 0 1-.143-.463v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.23 0 .374.165.154.165.154.408v.131q0 .133.132.133l1.287-.056a.12.12 0 0 0 .088-.032.14.14 0 0 0 .044-.1v-.197q0-.793-.561-1.287-.55-.495-1.518-.495t-1.53.505q-.55.506-.55 1.343v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconAbcRectangleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.8 4h12.4A3.8 3.8 0 0 1 22 7.8v8.4a3.8 3.8 0 0 1-3.8 3.8H5.8A3.8 3.8 0 0 1 2 16.2V7.8A3.8 3.8 0 0 1 5.8 4m6.796 6.008q.747 0 1.133.484.396.473.396 1.364v2.134q0 .87-.385 1.364-.385.484-1.144.484-.617 0-.99-.418-.023-.022-.044-.011-.022 0-.022.033v.176q0 .056-.044.099a.12.12 0 0 1-.088.033H10.12a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099V8.182q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.287q.054 0 .088.044.044.033.044.088v2.233q0 .022.022.022.043 0 .088-.055.373-.374.946-.374m-.022 1.958a.7.7 0 0 0-.143-.451.46.46 0 0 0-.374-.176.49.49 0 0 0-.341.132.58.58 0 0 0-.176.352v2.2q.033.22.176.352a.49.49 0 0 0 .34.132.46.46 0 0 0 .375-.176.7.7 0 0 0 .143-.451zm-5.449-1.958q.936 0 1.518.506.584.506.583 1.331v3.773q0 .056-.044.099a.12.12 0 0 1-.088.033H7.807a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-.242q0-.033-.022-.044t-.044.022q-.363.463-1.122.484a1.8 1.8 0 0 1-1.11-.352q-.463-.352-.463-1.342 0-1.023.561-1.408.572-.385 1.64-.385h.505q.055 0 .055-.055v-.275a.7.7 0 0 0-.165-.484.48.48 0 0 0-.396-.198.46.46 0 0 0-.319.121.53.53 0 0 0-.154.319q-.01.132-.143.132l-1.32-.011q-.132 0-.132-.132.055-.802.627-1.276.573-.484 1.452-.484m-.11 4.631a.7.7 0 0 0 .451-.165.57.57 0 0 0 .21-.462v-.517q0-.055-.056-.055h-.45a.68.68 0 0 0-.485.176q-.176.165-.176.462 0 .275.132.418.144.143.374.143m8.345.704q.561.495 1.529.495t1.518-.484q.561-.484.561-1.298v-.253a.1.1 0 0 0-.044-.088.1.1 0 0 0-.088-.044l-1.287-.011a.14.14 0 0 0-.099.044.12.12 0 0 0-.033.088v.143a.6.6 0 0 1-.154.407.47.47 0 0 1-.374.165.47.47 0 0 1-.385-.176.7.7 0 0 1-.143-.462v-1.892a.7.7 0 0 1 .143-.462.47.47 0 0 1 .385-.176q.231 0 .374.165.154.165.154.407v.132q0 .132.132.132l1.287-.055a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-.198q0-.792-.561-1.287-.55-.495-1.518-.495t-1.529.506q-.55.506-.55 1.342v2.134q0 .858.55 1.353",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconAbcRectangleFilled/IconAbcRectangleFilled.tsx
var IconAbcRectangleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconAbcRectangleFilledMonochromeExtralight,
          "monochrome|light": IconAbcRectangleFilledMonochromeLight,
          "monochrome|regular": IconAbcRectangleFilledMonochromeRegular,
          "monochrome|medium": IconAbcRectangleFilledMonochromeMedium,
          "monochrome|semibold": IconAbcRectangleFilledMonochromeSemibold,
          "monochrome|bold": IconAbcRectangleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M101.091 146.053a28 28 0 0 1 1.909-1.207l23.901-13.8c5.74-3.313 7.706-10.652 4.393-16.392-3.314-5.739-10.653-7.706-16.393-4.392l-23.9 13.799a52 52 0 0 0-26 45.033v34.077c0 6.627 5.372 12 12 12 6.626 0 12-5.373 12-12v-34.077q0-1.136.09-2.257l38.116 22.006c5.739 3.314 13.078 1.348 16.392-4.392 3.314-5.739 1.347-13.079-4.392-16.392zM77 271.309c-6.627 0-12 5.373-12 12v27.598a52 52 0 0 0 26 45.033l23.9 13.798c5.739 3.314 13.078 1.348 16.392-4.392 3.314-5.739 1.347-13.078-4.392-16.392L103 335.155a28 28 0 0 1-1.909-1.207l41.58-24.006c5.739-3.314 7.706-10.653 4.392-16.392-3.314-5.74-10.653-7.706-16.392-4.393l-41.58 24.007q-.09-1.121-.091-2.257v-27.598c0-6.627-5.373-12-12-12M185.521 83.346c3.313 5.74 10.653 7.706 16.392 4.392l23.9-13.798a28 28 0 0 1 2-1.05v46.043c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12V72.89q1.016.481 2 1.05l23.9 13.798c5.739 3.314 13.078 1.347 16.392-4.392s1.347-13.079-4.392-16.392l-23.9-13.799a52 52 0 0 0-52 0l-23.9 13.799c-5.739 3.313-7.706 10.653-4.392 16.392M174.3 390.177c-3.313 5.739-1.347 13.079 4.393 16.392l35.12 20.277a52 52 0 0 0 52 0l35.12-20.277c5.74-3.314 7.706-10.653 4.393-16.392-3.314-5.74-10.653-7.706-16.393-4.393l-35.12 20.277q-.984.568-2 1.05V361.13c0-6.627-5.373-12-12-12s-12 5.373-12 12v45.981a28 28 0 0 1-2-1.05l-35.12-20.276c-5.74-3.314-13.079-1.348-16.393 4.392m174.029-275.525c-3.313 5.74-1.347 13.079 4.393 16.393l23.904 13.801q.984.567 1.909 1.207l-38.116 22.006c-5.739 3.314-7.706 10.653-4.392 16.393 3.314 5.739 10.653 7.706 16.392 4.392l38.116-22.006q.09 1.12.091 2.256v34.079c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12v-34.079a52 52 0 0 0-26-45.033l-23.904-13.801c-5.74-3.314-13.079-1.347-16.393 4.392M332.563 293.55c-3.314 5.74-1.347 13.079 4.392 16.392l41.579 24.006q-.925.64-1.908 1.207l-23.9 13.799c-5.74 3.313-7.706 10.652-4.392 16.392 3.313 5.739 10.652 7.706 16.392 4.392l23.9-13.798a52 52 0 0 0 26-45.034v-27.597c0-6.627-5.373-12-12-12-6.628 0-12 5.373-12 12v27.597q0 1.137-.091 2.258l-41.58-24.006c-5.739-3.314-13.079-1.348-16.392 4.392M228 288v-48h24v48c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m287.569 226.392-41.569 24-12-20.784 41.569-24c5.74-3.314 13.079-1.347 16.393 4.392s1.347 13.079-4.393 16.392",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m192.43 226.392 41.57 24 12-20.784-41.57-24c-5.739-3.314-13.078-1.347-16.392 4.392s-1.347 13.079 4.392 16.392",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M228 288v-48h24v48c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M92 171.981v31.19c0 8.284-6.716 15-15 15s-15-6.716-15-15v-34.077a55 55 0 0 1 27.5-47.631l23.901-13.799c7.175-4.142 16.349-1.684 20.491 5.49s1.684 16.348-5.491 20.49L107 146l33.707 19.461c7.174 4.142 9.632 13.316 5.49 20.49s-13.316 9.633-20.49 5.49zm-15 96.328c-8.284 0-15 6.716-15 15v27.598a55 55 0 0 0 27.5 47.631l23.9 13.799c7.174 4.142 16.348 1.684 20.49-5.491s1.684-16.348-5.49-20.49L107 334.001l37.171-21.461c7.174-4.142 9.632-13.316 5.49-20.49-4.142-7.175-13.316-9.633-20.49-5.491L92 308.02v-24.711c0-8.284-6.716-15-15-15M182.923 84.846c4.142 7.174 13.316 9.632 20.49 5.49l21.4-12.355v40.952c0 8.285 6.716 15 15 15s15-6.715 15-15V77.981l21.4 12.355c7.174 4.142 16.348 1.684 20.49-5.49s1.684-16.348-5.49-20.49l-23.9-13.799a55 55 0 0 0-55 0l-23.9 13.799c-7.174 4.142-9.632 13.316-5.49 20.49m-11.221 303.831c-4.142 7.174-1.684 16.348 5.491 20.49l35.12 20.277a55 55 0 0 0 55 0l35.12-20.277c7.175-4.142 9.633-13.316 5.491-20.49-4.142-7.175-13.316-9.633-20.491-5.491l-32.62 18.834v-40.89c0-8.284-6.716-15-15-15s-15 6.716-15 15v40.89l-32.62-18.833c-7.175-4.143-16.349-1.684-20.491 5.49m174.029-275.525c-4.142 7.175-1.684 16.349 5.491 20.491l21.404 12.358-33.707 19.46c-7.174 4.142-9.632 13.316-5.49 20.491s13.316 9.632 20.491 5.49l33.706-19.46v31.191c0 8.284 6.715 15 15 15s15-6.716 15-15v-34.078a55 55 0 0 0-27.5-47.632l-23.904-13.801c-7.175-4.142-16.349-1.684-20.491 5.49M329.965 292.05c-4.142 7.174-1.684 16.348 5.49 20.49l37.17 21.461-21.399 12.355c-7.175 4.142-9.633 13.316-5.491 20.49 4.143 7.174 13.316 9.632 20.491 5.49l23.9-13.798a55 55 0 0 0 27.5-47.632v-27.597c0-8.284-6.716-15-15-15-8.285 0-15 6.716-15 15v24.711l-37.171-21.46c-7.174-4.143-16.348-1.684-20.49 5.49M225 288v-48h30v48c0 8.285-6.716 15-15 15s-15-6.715-15-15",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m289.069 228.991-41.569 24-15-25.981 41.569-24c7.175-4.142 16.348-1.684 20.491 5.49 4.142 7.175 1.684 16.348-5.491 20.491",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m190.93 228.991 41.57 24 15-25.981-41.57-24c-7.174-4.142-16.348-1.684-20.49 5.49s-1.684 16.348 5.49 20.491",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M225 288v-48h30v48c0 8.285-6.716 15-15 15s-15-6.715-15-15",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M95 177.177v25.994c0 9.941-8.059 18-18 18s-18-8.059-18-18v-34.077a58 58 0 0 1 29-50.229l23.901-13.799c8.61-4.971 19.618-2.021 24.589 6.588 4.97 8.609 2.021 19.618-6.589 24.589L113 146l29.207 16.863c8.609 4.97 11.559 15.979 6.588 24.588s-15.979 11.559-24.588 6.588zm-18 88.132c-9.941 0-18 8.059-18 18v27.598a58 58 0 0 0 29 50.229l23.9 13.799c8.609 4.97 19.618 2.02 24.588-6.589s2.021-19.618-6.588-24.588l-16.9-9.757 32.671-18.863c8.609-4.97 11.559-15.979 6.588-24.588s-15.979-11.559-24.588-6.589L95 302.824v-19.515c0-9.941-8.059-18-18-18M180.325 86.346c4.97 8.61 15.979 11.559 24.588 6.588l16.9-9.757v35.756c0 9.941 8.059 18 18 18s18-8.059 18-18V83.177l16.9 9.757c8.609 4.971 19.618 2.021 24.588-6.588s2.021-19.618-6.588-24.589l-23.9-13.798a58 58 0 0 0-58 0l-23.9 13.798c-8.609 4.971-11.559 15.98-6.588 24.589m-11.221 300.831c-4.97 8.609-2.021 19.618 6.589 24.588l35.12 20.277a58 58 0 0 0 58 0l35.12-20.277c8.61-4.97 11.559-15.979 6.589-24.588-4.971-8.61-15.979-11.559-24.589-6.589l-28.12 16.236V361.13c0-9.941-8.059-18-18-18s-18 8.059-18 18v35.694l-28.12-16.236c-8.61-4.97-19.618-2.02-24.589 6.589m174.029-275.525c-4.97 8.61-2.021 19.618 6.589 24.589l16.904 9.76-29.207 16.862c-8.609 4.971-11.559 15.979-6.588 24.589s15.979 11.559 24.589 6.588l29.206-16.862v25.995c0 9.941 8.058 18 18 18s18-8.059 18-18v-34.078a58 58 0 0 0-29-50.23l-23.904-13.801c-8.61-4.971-19.618-2.021-24.589 6.588M327.367 290.55c-4.971 8.609-2.021 19.618 6.588 24.588l32.67 18.863-16.899 9.757c-8.609 4.97-11.559 15.979-6.589 24.588 4.971 8.609 15.98 11.559 24.589 6.588l23.9-13.798a58 58 0 0 0 29-50.23v-27.597c0-9.941-8.059-18-18-18s-18 8.059-18 18v19.515l-32.671-18.862c-8.609-4.971-19.618-2.021-24.588 6.588M222 288v-48h36v48c0 9.942-8.059 18-18 18s-18-8.058-18-18",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m290.569 231.589-41.569 24-18-31.177 41.569-24c8.609-4.971 19.618-2.021 24.589 6.588 4.97 8.609 2.02 19.618-6.589 24.589",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m189.43 231.589 41.57 24 18-31.177-41.57-24c-8.609-4.971-19.617-2.021-24.588 6.588s-2.021 19.618 6.588 24.589",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M222 288v-48h36v48c0 9.942-8.059 18-18 18s-18-8.058-18-18",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M98.334 182.953v20.217c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335v-34.077a61.34 61.34 0 0 1 30.668-53.117l23.901-13.8c10.204-5.891 23.252-2.395 29.144 7.81s2.395 23.252-7.809 29.144l-11.899 6.869 22.472 12.974c10.204 5.892 13.701 18.94 7.809 29.145-5.891 10.204-18.94 13.7-29.144 7.809zM77 261.973c-11.783 0-21.335 9.552-21.335 21.335v27.598a61.33 61.33 0 0 0 30.668 53.117l23.899 13.799c10.205 5.891 23.253 2.395 29.144-7.809 5.892-10.205 2.396-23.253-7.809-29.144L119.669 334l27.668-15.974c10.204-5.892 13.701-18.94 7.809-29.145-5.891-10.204-18.94-13.7-29.144-7.809l-27.668 15.974v-13.738c0-11.783-9.552-21.335-21.335-21.335Zm100.436-173.96c5.892 10.204 18.94 13.7 29.145 7.809l11.897-6.87v29.98c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-29.98l11.897 6.87c10.205 5.891 23.253 2.395 29.144-7.81 5.892-10.204 2.396-23.252-7.809-29.144l-23.9-13.798a61.34 61.34 0 0 0-61.335 0l-23.899 13.798c-10.205 5.892-13.701 18.94-7.81 29.145m-11.22 297.495c-5.892 10.205-2.395 23.253 7.809 29.145l35.12 20.276a61.33 61.33 0 0 0 61.335 0l35.121-20.277c10.204-5.891 13.701-18.939 7.809-29.144-5.891-10.204-18.94-13.7-29.144-7.809l-23.118 13.347v-27.917c0-11.783-9.552-21.335-21.335-21.335s-21.335 9.552-21.335 21.335v27.917l-23.118-13.347c-10.204-5.891-23.253-2.395-29.144 7.809m174.029-275.524c-5.891 10.204-2.395 23.253 7.809 29.144L359.955 146l-22.472 12.974c-10.204 5.891-13.701 18.94-7.809 29.144 5.891 10.204 18.94 13.701 29.144 7.809l22.472-12.974v20.219c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-34.078a61.34 61.34 0 0 0-30.668-53.118l-23.904-13.801c-10.204-5.892-23.252-2.395-29.144 7.809Zm-15.767 178.898c-5.891 10.204-2.395 23.252 7.81 29.144L359.954 334l-11.897 6.868c-10.204 5.892-13.7 18.94-7.809 29.145 5.892 10.204 18.94 13.7 29.144 7.809l23.9-13.799a61.34 61.34 0 0 0 30.668-53.118v-27.597c0-11.783-9.552-21.335-21.335-21.335s-21.335 9.552-21.335 21.335v13.739l-27.668-15.975c-10.205-5.891-23.253-2.395-29.145 7.81ZM218.665 288v-48h42.67v48c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M218.665 292v-52h42.67v52c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m295.668 232.476-45.034 26-21.335-36.953 45.034-26c10.204-5.892 23.252-2.395 29.144 7.809s2.395 23.253-7.809 29.144",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m184.333 232.476 45.033 26 21.335-36.953-45.033-26c-10.204-5.892-23.253-2.395-29.144 7.809-5.892 10.205-2.395 23.253 7.809 29.144",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M99.5 184.97v18.2c0 12.426-10.075 22.5-22.5 22.5-12.427 0-22.5-10.074-22.5-22.5v-34.077a62.5 62.5 0 0 1 31.25-54.126l23.9-13.799c10.762-6.214 24.523-2.527 30.736 8.235s2.526 24.522-8.236 30.736l-10.151 5.86 20.724 11.965c10.762 6.214 14.449 19.974 8.236 30.736s-19.974 14.449-30.736 8.236L99.499 184.97ZM77 260.808c-12.427 0-22.5 10.074-22.501 22.5v27.598a62.5 62.5 0 0 0 31.25 54.126l23.9 13.799c10.761 6.213 24.522 2.526 30.735-8.236 6.214-10.761 2.526-24.522-8.235-30.735l-10.15-5.86 25.921-14.966c10.761-6.213 14.448-19.974 8.235-30.735-6.213-10.762-19.974-14.449-30.735-8.236l-25.921 14.965v-11.72c0-12.426-10.073-22.5-22.5-22.5Zm99.427-172.213c6.213 10.762 19.974 14.449 30.735 8.236l10.15-5.86v27.961c0 12.427 10.073 22.5 22.5 22.5s22.5-10.073 22.5-22.5V90.971l10.15 5.86c10.761 6.213 24.522 2.526 30.735-8.236s2.526-24.522-8.235-30.736l-23.9-13.798a62.5 62.5 0 0 0-62.5 0l-23.9 13.798c-10.761 6.214-14.449 19.974-8.235 30.736m-11.221 296.331c-6.213 10.762-2.526 24.522 8.236 30.735l35.12 20.277a62.5 62.5 0 0 0 62.5 0l35.12-20.277c10.762-6.213 14.449-19.974 8.236-30.735-6.213-10.762-19.974-14.449-30.736-8.236l-21.37 12.338v-25.899c0-12.426-10.074-22.5-22.5-22.5s-22.5 10.074-22.5 22.5v25.9l-21.37-12.339c-10.762-6.213-24.523-2.526-30.736 8.236m174.029-275.525c-6.213 10.762-2.526 24.523 8.236 30.736L357.625 146l-20.724 11.965c-10.762 6.213-14.449 19.974-8.236 30.736 6.213 10.761 19.974 14.448 30.736 8.235l20.724-11.965v18.201c0 12.426 10.073 22.5 22.5 22.5s22.5-10.074 22.5-22.5v-34.078a62.5 62.5 0 0 0-31.25-54.127l-23.904-13.801c-10.762-6.213-24.523-2.526-30.736 8.235m-15.766 178.898c-6.214 10.762-2.527 24.522 8.235 30.736L357.624 334l-10.149 5.859c-10.762 6.214-14.449 19.974-8.236 30.736s19.974 14.449 30.736 8.236l23.9-13.799a62.5 62.5 0 0 0 31.25-54.127v-27.597c0-12.426-10.074-22.5-22.5-22.5s-22.5 10.074-22.5 22.5v11.721l-25.921-14.966c-10.762-6.213-24.522-2.526-30.735 8.236M217.5 288v-48h45v48c0 12.426-10.073 22.5-22.5 22.5s-22.5-10.074-22.5-22.5",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M217.5 292v-52h45v52c0 12.426-10.073 22.5-22.5 22.5s-22.5-10.074-22.5-22.5",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m296.25 233.485-45.033 26-22.5-38.971 45.033-26c10.762-6.213 24.523-2.526 30.736 8.236 6.213 10.761 2.526 24.522-8.236 30.735",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m183.75 233.485 45.034 26 22.5-38.971-45.034-26c-10.761-6.213-24.522-2.526-30.735 8.236-6.213 10.761-2.526 24.522 8.235 30.735",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M101.406 187.569v15.602c0 13.255-10.745 24-24 24s-24-10.745-24-24v-34.077a64 64 0 0 1 32-55.425l23.902-13.8c11.479-6.627 26.157-2.694 32.784 8.785 6.628 11.479 2.695 26.157-8.784 32.785L125.407 146l20.206 11.666c11.479 6.628 15.412 21.306 8.784 32.785-6.627 11.479-21.305 15.412-32.784 8.785zm-24 71.74c-13.255 0-24 10.746-24 24v27.598a64 64 0 0 0 32 55.425l23.9 13.799c11.479 6.627 26.157 2.694 32.785-8.785s2.694-26.157-8.785-32.784l-7.9-4.561 23.671-13.667c11.479-6.627 15.412-21.305 8.784-32.784-6.627-11.479-21.305-15.412-32.784-8.785l-23.671 13.666v-9.122c0-13.254-10.745-24-24-24m98.129-169.963c6.627 11.479 21.305 15.412 32.784 8.785l7.9-4.561v25.363c0 13.255 10.745 24 24 24s24-10.745 24-24V93.57l7.9 4.56c11.479 6.628 26.157 2.695 32.785-8.784s2.694-26.157-8.785-32.785l-23.9-13.798a64 64 0 0 0-64 0l-23.9 13.798c-11.479 6.628-15.412 21.306-8.784 32.785m-11.221 294.831c-6.627 11.479-2.694 26.157 8.785 32.785l35.12 20.276a64 64 0 0 0 64 0l35.121-20.277c11.479-6.627 15.412-21.305 8.784-32.784-6.627-11.479-21.305-15.412-32.784-8.785l-19.121 11.039V361.13c0-13.254-10.745-24-24-24s-24 10.746-24 24v25.301l-19.12-11.039c-11.479-6.627-26.157-2.694-32.785 8.785m174.029-275.525c-6.627 11.479-2.694 26.158 8.785 32.785l7.904 4.564-20.206 11.666c-11.479 6.627-15.412 21.306-8.785 32.785s21.306 15.412 32.785 8.784l20.206-11.666v15.603c0 13.254 10.745 24 24 24s24-10.746 24-24v-34.079a64 64 0 0 0-32-55.425l-23.904-13.801c-11.479-6.628-26.157-2.695-32.785 8.784M322.577 287.55c-6.628 11.479-2.695 26.157 8.784 32.785l23.671 13.666-7.9 4.56c-11.479 6.628-15.412 21.306-8.785 32.785s21.306 15.412 32.785 8.785l23.9-13.799a64 64 0 0 0 32-55.426v-27.597c0-13.254-10.745-24-24-24s-24 10.746-24 24v9.123l-23.671-13.667c-11.479-6.627-26.157-2.694-32.784 8.785M216 288v-48h48v48c0 13.255-10.745 24-24 24s-24-10.745-24-24",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m293.569 236.785-41.569 24-24-41.569 41.569-24c11.479-6.628 26.157-2.695 32.785 8.784s2.694 26.157-8.785 32.785",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m186.43 236.785 41.57 24 24-41.569-41.57-24c-11.479-6.628-26.157-2.695-32.784 8.784-6.628 11.479-2.695 26.157 8.784 32.785",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M216 288v-48h48v48c0 13.255-10.745 24-24 24s-24-10.745-24-24",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconAr/IconAr.tsx
var IconAr = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconArMonochromeExtralight,
        "monochrome|light": IconArMonochromeLight,
        "monochrome|regular": IconArMonochromeRegular,
        "monochrome|medium": IconArMonochromeMedium,
        "monochrome|semibold": IconArMonochromeSemibold,
        "monochrome|bold": IconArMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconArrowDownMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M41.87 22.613a1.2 1.2 0 0 0-1.693.1l-14.97 16.84V5.31a1.2 1.2 0 1 0-2.4 0v34.244L7.837 22.713a1.2 1.2 0 0 0-1.794 1.594l17.067 19.2a1.2 1.2 0 0 0 1.794 0l17.067-19.2a1.2 1.2 0 0 0-.1-1.694",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M28.04 14.926a1 1 0 0 0-1.412.083l-9.63 10.834V3.54a1 1 0 1 0-2 0v22.303L5.368 15.01a1 1 0 1 0-1.495 1.329l11.378 12.8a1 1 0 0 0 1.494 0l11.378-12.8a1 1 0 0 0-.083-1.412",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21.125 11.087a.9.9 0 0 0-1.27.075l-6.962 7.83V2.66a.9.9 0 1 0-1.8 0v16.333l-6.96-7.831a.9.9 0 0 0-1.346 1.196l8.534 9.6a.9.9 0 0 0 1.345 0l8.533-9.6a.9.9 0 0 0-.074-1.27",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.931 8.217a.8.8 0 0 0-1.13.066L9.8 13.911V1.99a.8.8 0 1 0-1.6 0v11.92L3.198 8.284a.8.8 0 1 0-1.196 1.063l6.4 7.2a.8.8 0 0 0 1.196 0l6.4-7.2a.8.8 0 0 0-.067-1.129",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.186 7.276a.75.75 0 0 0-1.059.062L8.75 12.264V1.77a.75.75 0 1 0-1.5 0v10.494L2.87 7.338a.75.75 0 1 0-1.121.997l5.688 6.4a.75.75 0 0 0 1.122 0l5.688-6.4a.75.75 0 0 0-.062-1.059",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.672 5.432a.6.6 0 0 0-.847.05l-3.218 3.62V1.33a.6.6 0 0 0-1.2 0v7.772l-3.218-3.62a.6.6 0 0 0-.897.797l4.266 4.8a.6.6 0 0 0 .897 0l4.267-4.8a.6.6 0 0 0-.05-.847",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowDown/IconArrowDown.tsx
var IconArrowDown = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowDownMonochromeExtralight,
          "monochrome|light": IconArrowDownMonochromeLight,
          "monochrome|regular": IconArrowDownMonochromeRegular,
          "monochrome|medium": IconArrowDownMonochromeMedium,
          "monochrome|semibold": IconArrowDownMonochromeSemibold,
          "monochrome|bold": IconArrowDownMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M228 142c0-6.627 5.373-12 12-12s12 5.373 12 12v167.03l71.515-71.515c4.686-4.686 12.284-4.686 16.97 0 4.687 4.686 4.687 12.284 0 16.971l-92 92c-4.686 4.686-12.284 4.686-16.97 0l-92-92-.216-.222c-4.469-4.701-4.398-12.136.216-16.749s12.047-4.685 16.749-.216l.221.216L228 309.03z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-376c97.202 0 176 78.798 176 176s-78.798 176-176 176-176-78.798-176-176 78.798-176 176-176",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M225 142c0-8.284 6.716-15 15-15s15 6.716 15 15v159.787l66.394-66.393c5.857-5.858 15.355-5.858 21.212 0 5.858 5.858 5.858 15.355 0 21.213l-92 92c-5.857 5.858-15.355 5.858-21.212 0l-92-92c-5.858-5.858-5.858-15.355 0-21.213 5.766-5.766 15.059-5.857 20.935-.271l.277.271L225 301.787z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-370c93.888 0 170 76.112 170 170s-76.112 170-170 170-170-76.112-170-170 76.112-170 170-170",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M222 142c0-9.941 8.059-18 18-18s18 8.059 18 18v152.545l61.272-61.272c7.03-7.03 18.426-7.03 25.456 0 7.029 7.029 7.029 18.425 0 25.455l-92 92c-7.03 7.029-18.426 7.029-25.456 0l-92-92c-7.029-7.03-7.029-18.426 0-25.455 6.92-6.92 18.072-7.029 25.124-.325l.332.325L222 294.545z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-364c90.575 0 164 73.425 164 164s-73.425 164-164 164-164-73.425-164-164 73.425-164 164-164",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M218.665 142c0-11.783 9.552-21.335 21.335-21.335s21.335 9.552 21.335 21.335v144.494l55.579-55.58c8.332-8.331 21.84-8.331 30.172 0 8.332 8.332 8.332 21.84 0 30.172l-92 92c-8.332 8.332-21.84 8.332-30.172 0l-92-92c-8.332-8.332-8.332-21.84 0-30.172 8.202-8.201 21.419-8.329 29.777-.384l.395.384 55.579 55.58z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-357.33c86.891 0 157.33 70.439 157.33 157.33S326.891 397.331 240 397.331 82.67 326.892 82.67 240.001 153.109 82.671 240 82.671",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M217.5 142c0-12.426 10.074-22.5 22.5-22.5s22.5 10.074 22.5 22.5v141.68l53.59-53.59c8.787-8.787 23.033-8.787 31.82 0s8.787 23.034 0 31.821l-92 92c-8.787 8.786-23.033 8.786-31.82 0l-92-92-.405-.416c-8.38-8.815-8.245-22.755.405-31.405 8.649-8.649 22.589-8.784 31.404-.405l.416.405 53.59 53.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-355c85.604 0 155 69.396 155 155s-69.396 155-155 155-155-69.396-155-155 69.396-155 155-155",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowDownCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M216 142c0-13.254 10.745-24 24-24s24 10.746 24 24v138.059l51.029-51.029c9.373-9.373 24.569-9.373 33.942 0 9.372 9.372 9.372 24.568 0 33.941l-92 92c-9.373 9.373-24.569 9.373-33.942 0l-92-92-.432-.443c-8.938-9.403-8.794-24.272.432-33.498s24.096-9.371 33.498-.433l.444.433L216 280.059z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240 440.001c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200m0-352c83.947 0 152 68.053 152 152s-68.053 152-152 152-152-68.053-152-152 68.053-152 152-152",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconArrowDownCircle/IconArrowDownCircle.tsx
var IconArrowDownCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowDownCircleMonochromeExtralight,
          "monochrome|light": IconArrowDownCircleMonochromeLight,
          "monochrome|regular": IconArrowDownCircleMonochromeRegular,
          "monochrome|medium": IconArrowDownCircleMonochromeMedium,
          "monochrome|semibold": IconArrowDownCircleMonochromeSemibold,
          "monochrome|bold": IconArrowDownCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200M240 130c-6.627 0-12 5.373-12 12v167.029l-71.515-71.514-.221-.216c-4.702-4.469-12.136-4.397-16.749.216-4.614 4.613-4.685 12.047-.216 16.749l.216.221 92 92c4.686 4.687 12.284 4.687 16.97 0l92-92c4.687-4.686 4.687-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0L252 309.029V142c0-6.627-5.373-12-12-12" })
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200M240 127c-8.284 0-15 6.716-15 15v159.787l-66.394-66.393-.277-.271c-5.876-5.586-15.169-5.496-20.935.271-5.858 5.857-5.858 15.355 0 21.212l92 92c5.857 5.858 15.355 5.858 21.212 0l92-92c5.858-5.857 5.858-15.355 0-21.212-5.857-5.858-15.355-5.858-21.212 0L255 301.787V142c0-8.284-6.716-15-15-15" })
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200M240 124c-9.941 0-18 8.059-18 18v152.545l-61.272-61.273-.332-.325c-7.052-6.703-18.204-6.594-25.124.325-7.029 7.03-7.029 18.426 0 25.456l92 92c7.03 7.029 18.426 7.029 25.456 0l92-92c7.029-7.03 7.029-18.426 0-25.456-7.03-7.029-18.426-7.029-25.456 0L258 294.545V142c0-9.941-8.059-18-18-18" })
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200m.001 80.664c-11.783 0-21.335 9.552-21.335 21.335v144.493l-55.579-55.579-.395-.385c-8.358-7.945-21.575-7.816-29.777.385-8.332 8.332-8.332 21.84 0 30.172l92 92c8.332 8.332 21.84 8.332 30.172 0l92-92c8.332-8.332 8.332-21.84 0-30.172s-21.84-8.332-30.172 0l-55.579 55.579V142c0-11.783-9.552-21.335-21.335-21.335" })
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200m0 79.499c-12.426 0-22.5 10.074-22.5 22.5v141.68l-53.59-53.59-.416-.405c-8.815-8.38-22.755-8.245-31.404.405s-8.785 22.589-.405 31.404l.405.416 92 92c8.787 8.787 23.033 8.787 31.82 0l92-92c8.787-8.787 8.787-23.033 0-31.82s-23.033-8.787-31.82 0l-53.59 53.59V142c0-12.426-10.074-22.5-22.5-22.5" })
        }
      );
    }
  )
);
var IconArrowDownCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 40.001c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200M240 118c-13.255 0-24 10.745-24 24v138.059l-51.029-51.03-.444-.432c-9.402-8.938-24.272-8.794-33.498.432s-9.37 24.096-.432 33.498l.432.444 92 92c9.373 9.372 24.569 9.372 33.942 0l92-92c9.372-9.373 9.372-24.569 0-33.942-9.373-9.372-24.569-9.372-33.942 0L264 280.059V142c0-13.255-10.745-24-24-24" })
        }
      );
    }
  )
);

// src/IconArrowDownCircleFilled/IconArrowDownCircleFilled.tsx
var IconArrowDownCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowDownCircleFilledMonochromeExtralight,
          "monochrome|light": IconArrowDownCircleFilledMonochromeLight,
          "monochrome|regular": IconArrowDownCircleFilledMonochromeRegular,
          "monochrome|medium": IconArrowDownCircleFilledMonochromeMedium,
          "monochrome|semibold": IconArrowDownCircleFilledMonochromeSemibold,
          "monochrome|bold": IconArrowDownCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M32.152 21.151a1.2 1.2 0 1 1 1.697 1.697l-9 9a1.2 1.2 0 0 1-1.697 0l-9-9a1.2 1.2 0 1 1 1.697-1.697l6.951 6.952V8a1.2 1.2 0 0 1 2.4 0v20.103zM7.2 32a1.2 1.2 0 1 0-2.4 0v5A4.2 4.2 0 0 0 9 41.2h30a4.2 4.2 0 0 0 4.2-4.2v-5a1.2 1.2 0 1 0-2.4 0v5a1.8 1.8 0 0 1-1.8 1.8H9A1.8 1.8 0 0 1 7.2 37z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21.293 13.96a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L15 18.253V5.333a1 1 0 1 1 2 0v12.92zM5 21.334a1 1 0 1 0-2 0v3.333a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-3.334a1 1 0 1 0-2 0v3.334a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.864 10.364a.9.9 0 1 1 1.272 1.272l-4.5 4.5a.9.9 0 0 1-1.272 0l-4.5-4.5a.9.9 0 1 1 1.272-1.272l2.964 2.963V4a.9.9 0 1 1 1.8 0v9.327zM3.9 16a.9.9 0 0 0-1.8 0v2.2a2.7 2.7 0 0 0 2.7 2.7h14.4a2.7 2.7 0 0 0 2.7-2.7V16a.9.9 0 0 0-1.8 0v2.2a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M11.81 7.685a.8.8 0 0 1 1.13 1.13l-3.375 3.376a.8.8 0 0 1-1.13 0L5.058 8.816A.8.8 0 1 1 6.19 7.685L8.2 9.694V3a.8.8 0 0 1 1.6 0v6.694zM3.05 12a.8.8 0 0 0-1.6 0v1.6a2.2 2.2 0 0 0 2.2 2.2h10.7a2.2 2.2 0 0 0 2.2-2.2V12a.8.8 0 0 0-1.6 0v1.6a.6.6 0 0 1-.6.6H3.65a.6.6 0 0 1-.6-.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.47 6.803a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V2.667a.75.75 0 0 1 1.5 0v5.856zm-7.72 3.863a.75.75 0 0 0-1.5 0v1.267a2.15 2.15 0 0 0 2.15 2.15h9.2a2.15 2.15 0 0 0 2.15-2.15v-1.267a.75.75 0 0 0-1.5 0v1.267a.65.65 0 0 1-.65.65H3.4a.65.65 0 0 1-.65-.65z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToBracketMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.826 5.076a.6.6 0 1 1 .848.848l-2.25 2.25a.6.6 0 0 1-.848 0l-2.25-2.25a.6.6 0 0 1 .848-.848L5.4 6.3V2a.6.6 0 0 1 1.2 0V6.3zM2.1 8A.6.6 0 0 0 .9 8v1a1.6 1.6 0 0 0 1.6 1.6h7A1.6 1.6 0 0 0 11.1 9V8a.6.6 0 1 0-1.2 0v1a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowDownToBracket/IconArrowDownToBracket.tsx
var IconArrowDownToBracket = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowDownToBracketMonochromeExtralight,
          "monochrome|light": IconArrowDownToBracketMonochromeLight,
          "monochrome|regular": IconArrowDownToBracketMonochromeRegular,
          "monochrome|medium": IconArrowDownToBracketMonochromeMedium,
          "monochrome|semibold": IconArrowDownToBracketMonochromeSemibold,
          "monochrome|bold": IconArrowDownToBracketMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M240.016 65.996c6.627 0 12 5.373 12 12v219.03l77.514-77.515c4.687-4.686 12.285-4.686 16.971 0s4.686 12.284 0 16.97l-98 98c-4.686 4.687-12.284 4.687-16.971 0l-98-98c-4.686-4.686-4.686-12.284 0-16.97 4.687-4.686 12.285-4.686 16.971 0l77.515 77.515V77.996c0-6.627 5.372-12 12-12m174 336c0 6.628-5.373 12-12 12h-324c-6.628 0-12-5.372-12-12 0-6.627 5.372-12 12-12h324c6.627 0 12 5.373 12 12",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M240.008 62.998c8.284 0 15 6.716 15 15v211.787l72.393-72.394c5.858-5.857 15.356-5.857 21.213 0s5.858 15.356 0 21.214l-98 98c-5.857 5.858-15.355 5.858-21.213 0l-98-98c-5.858-5.858-5.858-15.356 0-21.214s15.356-5.857 21.213 0l72.394 72.394V77.998c0-8.284 6.716-15 15-15m177 339c0 8.284-6.716 15-15 15h-324c-8.284 0-15-6.716-15-15s6.715-15 15-15h324c8.284 0 15 6.716 15 15",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M240 60c9.941 0 18 8.059 18 18v204.544l67.272-67.272c7.03-7.029 18.426-7.029 25.456 0 7.029 7.03 7.029 18.426 0 25.456l-98 98c-7.03 7.029-18.426 7.029-25.456 0l-98-98c-7.029-7.03-7.029-18.426 0-25.456 7.03-7.029 18.426-7.029 25.456 0L222 282.544V78c0-9.941 8.059-18 18-18m180 342c0 9.941-8.059 18-18 18H78c-9.941 0-18-8.059-18-18s8.059-18 18-18h324c9.941 0 18 8.059 18 18",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M240.013 56.67c11.782 0 21.333 9.551 21.333 21.333V274.5l61.582-61.582c8.331-8.331 21.839-8.331 30.17 0 8.331 8.332 8.331 21.839 0 30.17l-98 98c-8.331 8.331-21.839 8.331-30.17 0l-98-98c-8.331-8.331-8.331-21.838 0-30.17 8.331-8.331 21.839-8.331 30.17 0L218.68 274.5V78.003c0-11.782 9.551-21.333 21.333-21.333m183.333 345.333c0 11.782-9.551 21.334-21.333 21.334h-324c-11.782 0-21.333-9.552-21.333-21.334s9.55-21.333 21.333-21.333h324c11.782 0 21.333 9.551 21.333 21.333",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M240.008 55.488c12.426 0 22.5 10.074 22.5 22.5v193.68l59.59-59.59c8.787-8.786 23.033-8.786 31.82 0 8.787 8.787 8.787 23.033 0 31.82l-98 98c-8.787 8.787-23.033 8.787-31.82 0l-98-98c-8.787-8.787-8.787-23.033 0-31.82s23.033-8.786 31.82 0l59.59 59.59V77.988c0-12.426 10.073-22.5 22.5-22.5m184.5 346.5c0 12.427-10.074 22.5-22.5 22.5h-324c-12.427 0-22.5-10.073-22.5-22.5s10.073-22.5 22.5-22.5h324c12.426 0 22.5 10.074 22.5 22.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowDownToLineMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M239.984 53.984c13.255 0 24 10.746 24 24v190.059l57.03-57.029c9.372-9.373 24.568-9.373 33.941 0s9.373 24.568 0 33.941l-98 98c-9.373 9.373-24.569 9.373-33.941 0l-98-98c-9.373-9.373-9.373-24.569 0-33.941s24.568-9.373 33.941 0l57.029 57.029V77.984c0-13.254 10.746-24 24-24m186 348c0 13.255-10.745 24-24 24h-324c-13.254 0-24-10.745-24-24 0-13.254 10.746-24 24-24h324c13.255 0 24 10.746 24 24",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowDownToLine/IconArrowDownToLine.tsx
var IconArrowDownToLine = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowDownToLineMonochromeExtralight,
          "monochrome|light": IconArrowDownToLineMonochromeLight,
          "monochrome|regular": IconArrowDownToLineMonochromeRegular,
          "monochrome|medium": IconArrowDownToLineMonochromeMedium,
          "monochrome|semibold": IconArrowDownToLineMonochromeSemibold,
          "monochrome|bold": IconArrowDownToLineMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowLeftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M25.697 6.123a1.2 1.2 0 0 1-.1 1.694l-16.84 14.97H43a1.2 1.2 0 0 1 0 2.4H8.756l16.841 14.97a1.2 1.2 0 1 1-1.594 1.793l-19.2-17.067a1.2 1.2 0 0 1 0-1.793l19.2-17.067a1.2 1.2 0 0 1 1.694.1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M17.277 3.949a1 1 0 0 1-.083 1.412L6.36 14.99h22.303a1 1 0 1 1 0 2H6.36l10.834 9.63a1 1 0 0 1-1.328 1.495l-12.8-11.378a1 1 0 0 1 0-1.494l12.8-11.378a1 1 0 0 1 1.411.083",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.073 2.862a.9.9 0 0 1-.075 1.27l-7.83 6.961H21.5a.9.9 0 1 1 0 1.8H5.167l7.83 6.961a.9.9 0 1 1-1.195 1.345l-9.6-8.533a.9.9 0 0 1 0-1.345l9.6-8.534a.9.9 0 0 1 1.27.075",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.898 2.063a.8.8 0 0 1-.066 1.13L4.204 8.195h11.921a.8.8 0 1 1 0 1.6H4.205l5.627 5.002a.8.8 0 1 1-1.063 1.196l-7.2-6.4a.8.8 0 0 1 0-1.196l7.2-6.4a.8.8 0 0 1 1.129.066",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.83 1.808a.75.75 0 0 1-.062 1.06L3.843 7.245h10.494a.75.75 0 0 1 0 1.5H3.843l4.925 4.378a.75.75 0 1 1-.996 1.121l-6.4-5.689a.75.75 0 0 1 0-1.121l6.4-5.689a.75.75 0 0 1 1.059.062",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.648 1.331a.6.6 0 0 1-.05.847l-3.62 3.219h7.772a.6.6 0 1 1 0 1.2H2.978l3.62 3.218a.6.6 0 1 1-.797.897l-4.8-4.267a.6.6 0 0 1 0-.897l4.8-4.267a.6.6 0 0 1 .847.05",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowLeft/IconArrowLeft.tsx
var IconArrowLeft = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowLeftMonochromeExtralight,
          "monochrome|light": IconArrowLeftMonochromeLight,
          "monochrome|regular": IconArrowLeftMonochromeRegular,
          "monochrome|medium": IconArrowLeftMonochromeMedium,
          "monochrome|semibold": IconArrowLeftMonochromeSemibold,
          "monochrome|bold": IconArrowLeftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.524 2.476a.6.6 0 0 1 0 .848L6.15 6.7H19.1a.6.6 0 1 1 0 1.2H6.15l3.375 3.375a.6.6 0 0 1-.848.85l-4.4-4.4a.6.6 0 0 1 0-.85l4.4-4.4a.6.6 0 0 1 .848 0m4.952 9.4a.6.6 0 0 1 .848 0l4.4 4.4a.6.6 0 0 1 0 .848l-4.4 4.4a.6.6 0 0 1-.848-.849l3.376-3.375H4.9a.6.6 0 1 1 0-1.2h12.952l-3.376-3.376a.6.6 0 0 1 0-.848",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.63 2.37a.75.75 0 0 1 0 1.06L6.51 6.55H19.1a.75.75 0 0 1 0 1.5H6.51l3.12 3.12a.75.75 0 0 1-1.06 1.06l-4.4-4.4a.75.75 0 0 1 0-1.06l4.4-4.4a.75.75 0 0 1 1.06 0m4.74 9.4a.75.75 0 0 1 1.06 0l4.4 4.4a.75.75 0 0 1 0 1.06l-4.4 4.4a.75.75 0 0 1-1.06-1.06l3.12-3.12H4.9a.75.75 0 0 1 0-1.5h12.59l-3.12-3.12a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.736 2.264a.9.9 0 0 1 0 1.272L6.873 6.4H19.1a.9.9 0 1 1 0 1.8H6.873l2.863 2.864a.9.9 0 0 1-1.272 1.272l-4.4-4.4a.9.9 0 0 1 0-1.272l4.4-4.4a.9.9 0 0 1 1.272 0m4.528 9.4a.9.9 0 0 1 1.272 0l4.4 4.4a.9.9 0 0 1 0 1.272l-4.4 4.4a.9.9 0 1 1-1.272-1.272l2.863-2.864H4.9a.9.9 0 1 1 0-1.8h12.227l-2.863-2.864a.9.9 0 0 1 0-1.272",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.854 2.146a1.067 1.067 0 0 1 0 1.508l-2.579 2.58H19.1a1.067 1.067 0 1 1 0 2.133H7.275l2.58 2.579a1.067 1.067 0 0 1-1.51 1.508l-4.4-4.4a1.067 1.067 0 0 1 0-1.508l4.4-4.4a1.067 1.067 0 0 1 1.51 0m4.292 9.4a1.067 1.067 0 0 1 1.508 0l4.4 4.4a1.067 1.067 0 0 1 0 1.508l-4.4 4.4a1.067 1.067 0 0 1-1.508-1.508l2.579-2.58H4.9a1.067 1.067 0 1 1 0-2.133h11.825l-2.58-2.579a1.067 1.067 0 0 1 0-1.508",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.895 2.105c.44.44.44 1.152 0 1.59l-2.48 2.48H19.1a1.125 1.125 0 0 1 0 2.25H7.416l2.48 2.48a1.125 1.125 0 1 1-1.592 1.59l-4.4-4.4a1.125 1.125 0 0 1 0-1.59l4.4-4.4c.44-.44 1.152-.44 1.591 0m4.21 9.4c.439-.44 1.151-.44 1.59 0l4.4 4.4a1.125 1.125 0 0 1 0 1.59l-4.4 4.4a1.125 1.125 0 1 1-1.59-1.59l2.479-2.48H4.9a1.125 1.125 0 0 1 0-2.25h11.684l-2.48-2.48a1.125 1.125 0 0 1 0-1.59",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftArrowRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.949 2.05a1.2 1.2 0 0 1 0 1.698L7.597 6.099H19.1a1.2 1.2 0 0 1 0 2.4H7.597l2.352 2.352a1.2 1.2 0 1 1-1.698 1.697l-4.4-4.4a1.2 1.2 0 0 1 0-1.697l4.4-4.4a1.2 1.2 0 0 1 1.698 0m4.103 9.4a1.2 1.2 0 0 1 1.697 0l4.4 4.4a1.2 1.2 0 0 1 0 1.698l-4.4 4.4a1.2 1.2 0 1 1-1.697-1.697l2.35-2.352H4.9a1.2 1.2 0 1 1 0-2.4h11.503l-2.351-2.351a1.2 1.2 0 0 1 0-1.697",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowLeftArrowRight/IconArrowLeftArrowRight.tsx
var IconArrowLeftArrowRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowLeftArrowRightMonochromeExtralight,
          "monochrome|light": IconArrowLeftArrowRightMonochromeLight,
          "monochrome|regular": IconArrowLeftArrowRightMonochromeRegular,
          "monochrome|medium": IconArrowLeftArrowRightMonochromeMedium,
          "monochrome|semibold": IconArrowLeftArrowRightMonochromeSemibold,
          "monochrome|bold": IconArrowLeftArrowRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M22.506 10.667c0-.69.56-1.25 1.25-1.25h17.577a1.25 1.25 0 1 1 0 2.5H23.756c-.69 0-1.25-.56-1.25-1.25m-6.137 4.275a1.25 1.25 0 0 1-.06 1.766L9.836 22.75h31.496a1.25 1.25 0 0 1 0 2.5H9.837l6.471 6.041a1.25 1.25 0 0 1-1.706 1.828l-8.788-8.205a1.25 1.25 0 0 1 0-1.828l8.789-8.205a1.25 1.25 0 0 1 1.766.06m24.964 23.641H23.756a1.25 1.25 0 0 1 0-2.5h17.577a1.25 1.25 0 1 1 0 2.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.837 7.111a1 1 0 0 1 1-1h11.718a1 1 0 1 1 0 2H15.837a1 1 0 0 1-1-1m-3.802 2.737a1 1 0 0 1-.05 1.413l-4.004 3.74h20.574a1 1 0 1 1 0 2H6.981l4.005 3.738a1 1 0 0 1-1.365 1.462l-5.86-5.47a1 1 0 0 1 0-1.462l5.86-5.47a1 1 0 0 1 1.413.049m16.52 16.041H15.837a1 1 0 0 1 0-2h11.718a1 1 0 1 1 0 2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.978 5.333a.9.9 0 0 1 .9-.9h8.789a.9.9 0 0 1 0 1.8h-8.789a.9.9 0 0 1-.9-.9m-2.592 1.95a.9.9 0 0 1-.044 1.272L5.616 11.1h15.05a.9.9 0 0 1 0 1.8H5.617l2.726 2.544a.9.9 0 1 1-1.228 1.316l-4.395-4.102a.9.9 0 0 1 0-1.316l4.395-4.103a.9.9 0 0 1 1.272.044m12.28 12.283h-8.788a.9.9 0 1 1 0-1.8h8.789a.9.9 0 0 1 0 1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.108 4a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8M6.38 5.377a.8.8 0 0 1-.038 1.131L4.529 8.2H15.5a.8.8 0 0 1 0 1.6H4.53l1.812 1.692a.8.8 0 1 1-1.092 1.17L1.954 9.585a.8.8 0 0 1 0-1.17L5.25 5.34a.8.8 0 0 1 1.13.038M8.108 14a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.219 3.555a.7.7 0 0 1 .7-.7h5.859a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 0 1-.7-.7M5.663 4.787a.7.7 0 0 1-.034.99L3.998 7.3h9.78a.7.7 0 1 1 0 1.4h-9.78l1.631 1.523a.7.7 0 0 1-.955 1.024l-2.93-2.735a.7.7 0 0 1 0-1.024l2.93-2.735a.7.7 0 0 1 .99.034m8.115 8.357h-5.86a.7.7 0 1 1 0-1.4h5.86a.7.7 0 1 1 0 1.4",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowLeftFromLine3HorizontalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.339 2.667a.6.6 0 0 1 .6-.6h4.394a.6.6 0 1 1 0 1.2H5.94a.6.6 0 0 1-.6-.6m-1.037.872a.6.6 0 0 1-.029.849L3.19 5.4h7.144a.6.6 0 1 1 0 1.2H3.19l1.084 1.013a.6.6 0 0 1-.819.877L1.257 6.44a.6.6 0 0 1 0-.877L3.454 3.51a.6.6 0 0 1 .848.03m6.031 6.395H5.94a.6.6 0 0 1 0-1.2h4.394a.6.6 0 1 1 0 1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowLeftFromLine3Horizontal/IconArrowLeftFromLine3Horizontal.tsx
var IconArrowLeftFromLine3Horizontal = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowLeftFromLine3HorizontalMonochromeExtralight,
          "monochrome|light": IconArrowLeftFromLine3HorizontalMonochromeLight,
          "monochrome|regular": IconArrowLeftFromLine3HorizontalMonochromeRegular,
          "monochrome|medium": IconArrowLeftFromLine3HorizontalMonochromeMedium,
          "monochrome|semibold": IconArrowLeftFromLine3HorizontalMonochromeSemibold,
          "monochrome|bold": IconArrowLeftFromLine3HorizontalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M22.303 6.123a1.2 1.2 0 0 0 .1 1.694l16.84 14.97H5a1.2 1.2 0 0 0 0 2.4h34.244l-16.841 14.97a1.2 1.2 0 0 0 1.594 1.793l19.2-17.067a1.2 1.2 0 0 0 0-1.793l-19.2-17.067a1.2 1.2 0 0 0-1.694.1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.72 3.949a1 1 0 0 0 .082 1.412l10.834 9.63H3.333a1 1 0 1 0 0 2h22.303l-10.834 9.63a1 1 0 0 0 1.329 1.495l12.8-11.378a1 1 0 0 0 0-1.494L16.13 3.866a1 1 0 0 0-1.412.083",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.927 2.862a.9.9 0 0 0 .075 1.27l7.83 6.961H2.5a.9.9 0 1 0 0 1.8h16.333l-7.83 6.961a.9.9 0 1 0 1.195 1.345l9.6-8.533a.9.9 0 0 0 0-1.345l-9.6-8.534a.9.9 0 0 0-1.27.075",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.102 2.063a.8.8 0 0 0 .066 1.13l5.628 5.002H1.875a.8.8 0 1 0 0 1.6h11.92l-5.627 5.002a.8.8 0 0 0 1.063 1.196l7.2-6.4a.8.8 0 0 0 0-1.196l-7.2-6.4a.8.8 0 0 0-1.129.066",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.173 1.808a.75.75 0 0 0 .062 1.06l4.926 4.378H1.667a.75.75 0 1 0 0 1.5H12.16l-4.926 4.378a.75.75 0 1 0 .997 1.121l6.4-5.689a.75.75 0 0 0 0-1.121l-6.4-5.689a.75.75 0 0 0-1.06.062",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.351 1.331a.6.6 0 0 0 .05.847l3.62 3.219H1.25a.6.6 0 0 0 0 1.2h7.772l-3.62 3.218a.6.6 0 1 0 .797.897l4.8-4.267a.6.6 0 0 0 0-.897l-4.8-4.267a.6.6 0 0 0-.848.05",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowRight/IconArrowRight.tsx
var IconArrowRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowRightMonochromeExtralight,
          "monochrome|light": IconArrowRightMonochromeLight,
          "monochrome|regular": IconArrowRightMonochromeRegular,
          "monochrome|medium": IconArrowRightMonochromeMedium,
          "monochrome|semibold": IconArrowRightMonochromeSemibold,
          "monochrome|bold": IconArrowRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M25.494 37.334c0 .69-.56 1.25-1.25 1.25H6.667a1.25 1.25 0 1 1 0-2.5h17.577c.69 0 1.25.56 1.25 1.25m6.137-4.276a1.25 1.25 0 0 1 .06-1.766l6.472-6.042H6.667a1.25 1.25 0 0 1 0-2.5h31.496l-6.471-6.041a1.25 1.25 0 0 1 1.706-1.828l8.788 8.206a1.25 1.25 0 0 1 0 1.827l-8.788 8.205a1.25 1.25 0 0 1-1.767-.06M6.667 9.417h17.577a1.25 1.25 0 0 1 0 2.5H6.667a1.25 1.25 0 1 1 0-2.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M17.163 24.889a1 1 0 0 1-1 1H4.445a1 1 0 1 1 0-2h11.718a1 1 0 0 1 1 1m3.803-2.737a1 1 0 0 1 .048-1.413l4.005-3.74H4.445a1 1 0 1 1 0-2h20.574l-4.005-3.738a1 1 0 0 1 1.365-1.462l5.86 5.47a1 1 0 0 1 0 1.462l-5.86 5.47a1 1 0 0 1-1.413-.049M4.445 6.111h11.718a1 1 0 0 1 0 2H4.445a1 1 0 1 1 0-2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.022 18.667a.9.9 0 0 1-.9.9H3.333a.9.9 0 0 1 0-1.8h8.79a.9.9 0 0 1 .9.9m2.592-1.95a.9.9 0 0 1 .044-1.272l2.726-2.545H3.334a.9.9 0 1 1 0-1.8h15.05l-2.726-2.544a.9.9 0 0 1 1.229-1.316l4.394 4.102a.9.9 0 0 1 0 1.316l-4.394 4.103a.9.9 0 0 1-1.273-.044M3.334 4.434h8.788a.9.9 0 0 1 0 1.8H3.333a.9.9 0 1 1 0-1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.892 14a.8.8 0 0 1-.8.8H2.5a.8.8 0 0 1 0-1.6h6.592a.8.8 0 0 1 .8.8m1.728-1.377a.8.8 0 0 1 .038-1.131L13.471 9.8H2.5a.8.8 0 1 1-.001-1.6h10.97l-1.812-1.692a.8.8 0 0 1 1.092-1.17l3.296 3.077a.8.8 0 0 1 0 1.17L12.75 12.66a.8.8 0 0 1-1.13-.038M9.892 4a.8.8 0 0 1-.8.8H2.5a.8.8 0 1 1 0-1.6h6.592a.8.8 0 0 1 .8.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.781 12.445a.7.7 0 0 1-.7.7H2.222a.7.7 0 1 1 0-1.4h5.86a.7.7 0 0 1 .7.7m1.555-1.232a.7.7 0 0 1 .034-.99L12.003 8.7h-9.78a.7.7 0 1 1 0-1.4h9.78L10.37 5.777a.7.7 0 1 1 .956-1.024l2.93 2.735a.7.7 0 0 1 0 1.024l-2.93 2.735a.7.7 0 0 1-.99-.034M2.222 2.856h5.86a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 1 1 0-1.4",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromLine3HorizontalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.661 9.333a.6.6 0 0 1-.6.6H1.667a.6.6 0 0 1 0-1.2H6.06a.6.6 0 0 1 .6.6m1.037-.872a.6.6 0 0 1 .029-.849L8.81 6.6H1.667a.6.6 0 0 1 0-1.2H8.81L7.727 4.387a.6.6 0 0 1 .819-.877l2.197 2.051a.6.6 0 0 1 0 .877L8.546 8.49a.6.6 0 0 1-.848-.03M1.667 2.066H6.06a.6.6 0 0 1 0 1.2H1.667a.6.6 0 0 1 0-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowRightFromLine3Horizontal/IconArrowRightFromLine3Horizontal.tsx
var IconArrowRightFromLine3Horizontal = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowRightFromLine3HorizontalMonochromeExtralight,
          "monochrome|light": IconArrowRightFromLine3HorizontalMonochromeLight,
          "monochrome|regular": IconArrowRightFromLine3HorizontalMonochromeRegular,
          "monochrome|medium": IconArrowRightFromLine3HorizontalMonochromeMedium,
          "monochrome|semibold": IconArrowRightFromLine3HorizontalMonochromeSemibold,
          "monochrome|bold": IconArrowRightFromLine3HorizontalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.8 13A7.2 7.2 0 0 1 12 5.8h14a7.2 7.2 0 0 1 7.2 7.2v.611a1.2 1.2 0 1 1-2.4 0v-.61A4.8 4.8 0 0 0 26 8.2H12A4.8 4.8 0 0 0 7.2 13v22a4.8 4.8 0 0 0 4.8 4.8h14a4.8 4.8 0 0 0 4.8-4.8v-.611a1.2 1.2 0 0 1 2.4 0V35a7.2 7.2 0 0 1-7.2 7.2H12A7.2 7.2 0 0 1 4.8 35zm32.352 4.151a1.2 1.2 0 0 1 1.697 0l6 6a1.2 1.2 0 0 1 0 1.698l-6 6a1.2 1.2 0 0 1-1.697-1.698l3.951-3.95H22a1.2 1.2 0 0 1 0-2.401h19.103l-3.952-3.951a1.2 1.2 0 0 1 0-1.698",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3 8.667a5 5 0 0 1 5-5h9.333a5 5 0 0 1 5 5v.407a1 1 0 1 1-2 0v-.407a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v14.666a3 3 0 0 0 3 3h9.333a3 3 0 0 0 3-3v-.407a1 1 0 1 1 2 0v.407a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5zm21.626 2.626a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L26.92 17H14.667a1 1 0 0 1 0-2h12.252l-2.293-2.293a1 1 0 0 1 0-1.414",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.1 6.5A3.9 3.9 0 0 1 6 2.6h7a3.9 3.9 0 0 1 3.9 3.9v.306a.9.9 0 1 1-1.8 0V6.5A2.1 2.1 0 0 0 13 4.4H6a2.1 2.1 0 0 0-2.1 2.1v11c0 1.16.94 2.1 2.1 2.1h7a2.1 2.1 0 0 0 2.1-2.1v-.306a.9.9 0 0 1 1.8 0v.306a3.9 3.9 0 0 1-3.9 3.9H6a3.9 3.9 0 0 1-3.9-3.9zm16.264 1.864a.9.9 0 0 1 1.273 0l3 3a.9.9 0 0 1 0 1.272l-3 3a.9.9 0 0 1-1.273-1.272l1.463-1.464H11a.9.9 0 0 1 0-1.8h8.827l-1.463-1.464a.9.9 0 0 1 0-1.272",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.45 4.875a3.05 3.05 0 0 1 3.05-3.05h5.25a3.05 3.05 0 0 1 3.05 3.05v.23a.8.8 0 1 1-1.6 0v-.23c0-.8-.65-1.45-1.45-1.45H4.5c-.8 0-1.45.65-1.45 1.45v8.25c0 .8.65 1.45 1.45 1.45h5.25c.8 0 1.45-.65 1.45-1.45v-.23a.8.8 0 0 1 1.6 0v.23a3.05 3.05 0 0 1-3.05 3.05H4.5a3.05 3.05 0 0 1-3.05-3.05zm12.234 1.31a.8.8 0 0 1 1.132 0l2.25 2.25a.8.8 0 0 1 0 1.13l-2.25 2.25a.8.8 0 1 1-1.132-1.13l.885-.885h-6.32a.8.8 0 1 1 0-1.6h6.32l-.885-.884a.8.8 0 0 1 0-1.132",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.25 4.333A2.75 2.75 0 0 1 4 1.583h4.667a2.75 2.75 0 0 1 2.75 2.75v.204a.75.75 0 0 1-1.5 0v-.204c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v7.334c0 .69.56 1.25 1.25 1.25h4.667c.69 0 1.25-.56 1.25-1.25v-.204a.75.75 0 0 1 1.5 0v.204a2.75 2.75 0 0 1-2.75 2.75H4a2.75 2.75 0 0 1-2.75-2.75zM12.136 5.47a.75.75 0 0 1 1.061 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l.719-.72H7.333a.75.75 0 0 1 0-1.5h5.523l-.72-.72a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowRightFromRectanglePortraitMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M.9 3.25c0-1.16.94-2.1 2.1-2.1h3.5c1.16 0 2.1.94 2.1 2.1v.153a.6.6 0 0 1-1.2 0V3.25a.9.9 0 0 0-.9-.9H3a.9.9 0 0 0-.9.9v5.5a.9.9 0 0 0 .9.9h3.5a.9.9 0 0 0 .9-.9v-.153a.6.6 0 0 1 1.2 0v.153a2.1 2.1 0 0 1-2.1 2.1H3a2.1 2.1 0 0 1-2.1-2.1zm8.176.826a.6.6 0 0 1 .848 0l1.5 1.5a.6.6 0 0 1 0 .848l-1.5 1.5a.6.6 0 0 1-.848-.848L9.55 6.6H5.5a.6.6 0 1 1 0-1.2H9.55l-.475-.476a.6.6 0 0 1 0-.848",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowRightFromRectanglePortrait/IconArrowRightFromRectanglePortrait.tsx
var IconArrowRightFromRectanglePortrait = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowRightFromRectanglePortraitMonochromeExtralight,
          "monochrome|light": IconArrowRightFromRectanglePortraitMonochromeLight,
          "monochrome|regular": IconArrowRightFromRectanglePortraitMonochromeRegular,
          "monochrome|medium": IconArrowRightFromRectanglePortraitMonochromeMedium,
          "monochrome|semibold": IconArrowRightFromRectanglePortraitMonochromeSemibold,
          "monochrome|bold": IconArrowRightFromRectanglePortraitMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M34 20H14l10 10z" })
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M22.667 13.334H9.333L16 20z" })
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M17 10H7l5 5z" })
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M12.75 7.5h-7.5L9 11.25z" })
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.333 6.667H4.667L8 10z" })
        }
      );
    }
  )
);
var IconArrowTriangleDownMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.5 5h-5L6 7.5z" })
        }
      );
    }
  )
);

// src/IconArrowTriangleDown/IconArrowTriangleDown.tsx
var IconArrowTriangleDown = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowTriangleDownMonochromeExtralight,
          "monochrome|light": IconArrowTriangleDownMonochromeLight,
          "monochrome|regular": IconArrowTriangleDownMonochromeRegular,
          "monochrome|medium": IconArrowTriangleDownMonochromeMedium,
          "monochrome|semibold": IconArrowTriangleDownMonochromeSemibold,
          "monochrome|bold": IconArrowTriangleDownMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.2 24C7.2 14.72 14.722 7.2 24 7.2a16.74 16.74 0 0 1 11.627 4.673l-1.566 1.566c-.945.945-.276 2.56 1.06 2.56H40a1.5 1.5 0 0 0 1.5-1.5V9.622c0-1.336-1.616-2.005-2.56-1.06l-1.616 1.615A19.14 19.14 0 0 0 24 4.8C13.396 4.8 4.8 13.396 4.8 24S13.396 43.2 24 43.2 43.2 34.604 43.2 24a1.2 1.2 0 0 0-2.4 0c0 9.278-7.522 16.8-16.8 16.8S7.2 33.278 7.2 24" })
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5 16C5 9.925 9.925 5 16 5a10.96 10.96 0 0 1 7.61 3.057l-.903.903c-.63.63-.184 1.707.707 1.707h3.253a1 1 0 0 0 1-1V6.414c0-.89-1.078-1.337-1.707-.707l-.936.935A12.96 12.96 0 0 0 16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13a1 1 0 1 0-2 0c0 6.075-4.925 11-11 11S5 22.075 5 16" })
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.9 12a8.1 8.1 0 0 1 13.727-5.827l-.632.632A.7.7 0 0 0 17.49 8h2.61a.7.7 0 0 0 .7-.7V4.69a.7.7 0 0 0-1.195-.495L18.9 4.9A9.87 9.87 0 0 0 12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9a.9.9 0 1 0-1.8 0 8.1 8.1 0 0 1-16.2 0" })
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.05 9a5.95 5.95 0 0 1 10.03-4.33l-.476.477a.5.5 0 0 0 .353.853H15a.5.5 0 0 0 .5-.5V3.457a.5.5 0 0 0-.854-.353l-.434.434A7.55 7.55 0 1 0 16.55 9a.8.8 0 0 0-1.6 0 5.95 5.95 0 0 1-11.9 0" })
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.8 8a5.2 5.2 0 0 1 8.746-3.803l-.453.454a.4.4 0 0 0 .283.683h1.967a.4.4 0 0 0 .4-.4V2.966a.4.4 0 0 0-.683-.283l-.382.382A6.8 6.8 0 1 0 14.8 8a.8.8 0 0 0-1.6 0A5.2 5.2 0 0 1 2.8 8" })
        }
      );
    }
  )
);
var IconArrowTriangleHeadClockwiseMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.15 6a3.85 3.85 0 0 1 6.47-2.82l-.308.308A.3.3 0 0 0 8.524 4H10a.3.3 0 0 0 .3-.3V2.224a.3.3 0 0 0-.512-.212l-.248.248A5.15 5.15 0 1 0 11.15 6a.65.65 0 1 0-1.3 0 3.85 3.85 0 0 1-7.7 0" })
        }
      );
    }
  )
);

// src/IconArrowTriangleHeadClockwise/IconArrowTriangleHeadClockwise.tsx
var IconArrowTriangleHeadClockwise = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowTriangleHeadClockwiseMonochromeExtralight,
          "monochrome|light": IconArrowTriangleHeadClockwiseMonochromeLight,
          "monochrome|regular": IconArrowTriangleHeadClockwiseMonochromeRegular,
          "monochrome|medium": IconArrowTriangleHeadClockwiseMonochromeMedium,
          "monochrome|semibold": IconArrowTriangleHeadClockwiseMonochromeSemibold,
          "monochrome|bold": IconArrowTriangleHeadClockwiseMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M20 14v20l10-10z" })
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M13.333 9.333v13.333L20 16z" })
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10 7v10l5-5z" })
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.5 5.25v7.5L11.25 9z" })
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.667 4.667v6.667L10 8z" })
        }
      );
    }
  )
);
var IconArrowTriangleRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5 3.5v5L7.5 6z" })
        }
      );
    }
  )
);

// src/IconArrowTriangleRight/IconArrowTriangleRight.tsx
var IconArrowTriangleRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowTriangleRightMonochromeExtralight,
          "monochrome|light": IconArrowTriangleRightMonochromeLight,
          "monochrome|regular": IconArrowTriangleRightMonochromeRegular,
          "monochrome|medium": IconArrowTriangleRightMonochromeMedium,
          "monochrome|semibold": IconArrowTriangleRightMonochromeSemibold,
          "monochrome|bold": IconArrowTriangleRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M14 28h20L24 18z" })
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9.333 18.667h13.334L16 12z" })
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7 14h10l-5-5z" })
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.25 10.5h7.5L9 6.75z" })
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.667 9.334h6.666L8 6z" })
        }
      );
    }
  )
);
var IconArrowTriangleUpMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.5 7h5L6 4.5z" })
        }
      );
    }
  )
);

// src/IconArrowTriangleUp/IconArrowTriangleUp.tsx
var IconArrowTriangleUp = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowTriangleUpMonochromeExtralight,
          "monochrome|light": IconArrowTriangleUpMonochromeLight,
          "monochrome|regular": IconArrowTriangleUpMonochromeRegular,
          "monochrome|medium": IconArrowTriangleUpMonochromeMedium,
          "monochrome|semibold": IconArrowTriangleUpMonochromeSemibold,
          "monochrome|bold": IconArrowTriangleUpMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUpMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.143 25.384a1.2 1.2 0 0 0 1.694-.1l14.97-16.84v34.243a1.2 1.2 0 1 0 2.4 0V8.443l14.97 16.841a1.2 1.2 0 0 0 1.793-1.594L24.904 4.49a1.2 1.2 0 0 0-1.794 0L6.043 23.69a1.2 1.2 0 0 0 .1 1.694",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.956 17.072a1 1 0 0 0 1.412-.083l9.63-10.834v22.303a1 1 0 1 0 2 0V6.155l9.63 10.834a1 1 0 1 0 1.495-1.329L16.745 2.86a1 1 0 0 0-1.495 0L3.874 15.66a1 1 0 0 0 .083 1.412",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.862 12.916a.9.9 0 0 0 1.27-.075l6.961-7.83v16.332a.9.9 0 0 0 1.8 0V5.01l6.961 7.831a.9.9 0 1 0 1.345-1.196l-8.533-9.6a.9.9 0 0 0-1.345 0l-8.534 9.6a.9.9 0 0 0 .075 1.27",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.069 9.78a.8.8 0 0 0 1.129-.066L8.2 4.087v11.92a.8.8 0 0 0 1.6 0V4.088l5.002 5.627a.8.8 0 0 0 1.196-1.063l-6.4-7.2a.8.8 0 0 0-1.196 0l-6.4 7.2a.8.8 0 0 0 .067 1.13",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.812 8.723A.75.75 0 0 0 2.87 8.66l4.378-4.925v10.494a.75.75 0 0 0 1.5 0V3.735l4.378 4.925a.75.75 0 1 0 1.121-.996l-5.688-6.4a.75.75 0 0 0-1.122 0l-5.688 6.4a.75.75 0 0 0 .062 1.059",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.341 6.57a.6.6 0 0 0 .847-.05L5.407 2.9v7.772a.6.6 0 0 0 1.2 0V2.9l3.218 3.62a.6.6 0 0 0 .897-.797L6.455.923a.6.6 0 0 0-.897 0l-4.267 4.8a.6.6 0 0 0 .05.847",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowUp/IconArrowUp.tsx
var IconArrowUp = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUpMonochromeExtralight,
          "monochrome|light": IconArrowUpMonochromeLight,
          "monochrome|regular": IconArrowUpMonochromeRegular,
          "monochrome|medium": IconArrowUpMonochromeMedium,
          "monochrome|semibold": IconArrowUpMonochromeSemibold,
          "monochrome|bold": IconArrowUpMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.151 11.151a1.2 1.2 0 0 1 1.697 0l7 7a1.2 1.2 0 1 1-1.697 1.697L17.2 14.897V36a1.2 1.2 0 0 1-2.4 0V14.897l-4.952 4.951a1.2 1.2 0 1 1-1.697-1.697zM32.848 36.848a1.2 1.2 0 0 1-1.697 0l-7-7a1.2 1.2 0 1 1 1.697-1.697l4.952 4.952V12a1.2 1.2 0 0 1 2.4 0v21.103l4.951-4.952a1.2 1.2 0 1 1 1.697 1.697z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.667 7a1 1 0 0 1 .707.293l4.666 4.667a1 1 0 1 1-1.414 1.414l-2.96-2.96V24a1 1 0 1 1-2 0V10.414l-2.959 2.96a1 1 0 0 1-1.414-1.414L9.96 7.293A1 1 0 0 1 10.667 7M21.333 25a1 1 0 0 1-.707-.293L15.96 20.04a1 1 0 1 1 1.414-1.414l2.96 2.96V8a1 1 0 0 1 2 0v13.586l2.959-2.96a1 1 0 0 1 1.414 1.414l-4.667 4.667a1 1 0 0 1-.707.293",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.364 5.364a.9.9 0 0 1 1.272 0l3.5 3.5a.9.9 0 1 1-1.272 1.272L8.9 8.174V18a.9.9 0 1 1-1.8 0V8.173l-1.964 1.963a.9.9 0 1 1-1.272-1.272zM16.637 18.637a.9.9 0 0 1-1.273 0l-3.5-3.5a.9.9 0 1 1 1.272-1.273l1.964 1.963V6a.9.9 0 1 1 1.8 0v9.827l1.964-1.963a.9.9 0 1 1 1.273 1.272z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.435 3.935a.8.8 0 0 1 1.13 0L9.192 6.56A.8.8 0 1 1 8.06 7.69L6.8 6.433V13.5a.8.8 0 0 1-1.6 0V6.432L3.94 7.69A.8.8 0 1 1 2.81 6.56zM12.566 14.066a.8.8 0 0 1-1.132 0L8.81 11.44a.8.8 0 0 1 1.13-1.132l1.26 1.26V4.5a.8.8 0 0 1 1.6 0v7.069l1.26-1.26a.8.8 0 0 1 1.13 1.132z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.333 3.25a.75.75 0 0 1 .53.22l2.334 2.333a.75.75 0 0 1-1.06 1.06L6.082 5.812V12a.75.75 0 0 1-1.5 0V5.81L3.53 6.865a.75.75 0 1 1-1.06-1.061L4.803 3.47a.75.75 0 0 1 .53-.22M10.667 12.75a.75.75 0 0 1-.53-.22l-2.334-2.333a.75.75 0 0 1 1.06-1.06l1.054 1.052V4a.75.75 0 0 1 1.5 0v6.19l1.053-1.054a.75.75 0 1 1 1.06 1.061l-2.333 2.333a.75.75 0 0 1-.53.22",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpArrowDownMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.576 2.576a.6.6 0 0 1 .848 0l1.75 1.75a.6.6 0 0 1-.848.848L4.6 4.448V9a.6.6 0 0 1-1.2 0V4.448l-.726.726a.6.6 0 0 1-.848-.848zM8.424 9.424a.6.6 0 0 1-.848 0l-1.75-1.75a.6.6 0 1 1 .848-.848l.726.725V3a.6.6 0 0 1 1.2 0V7.55l.726-.725a.6.6 0 0 1 .848.848z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowUpArrowDown/IconArrowUpArrowDown.tsx
var IconArrowUpArrowDown = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUpArrowDownMonochromeExtralight,
          "monochrome|light": IconArrowUpArrowDownMonochromeLight,
          "monochrome|regular": IconArrowUpArrowDownMonochromeRegular,
          "monochrome|medium": IconArrowUpArrowDownMonochromeMedium,
          "monochrome|semibold": IconArrowUpArrowDownMonochromeSemibold,
          "monochrome|bold": IconArrowUpArrowDownMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.3 22.116a1.3 1.3 0 0 1 1.3 1.3v13.556a4.7 4.7 0 0 0 4.7 4.7h20a4.7 4.7 0 0 0 4.7-4.7V23.416a1.3 1.3 0 0 1 2.6 0v13.556a7.3 7.3 0 0 1-7.3 7.3h-20a7.3 7.3 0 0 1-7.3-7.3V23.416a1.3 1.3 0 0 1 1.3-1.3M24.3 7l9.452 9.453a1.3 1.3 0 1 1-1.838 1.838L24.3 10.677l-7.614 7.614a1.3 1.3 0 0 1-1.839-1.838z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24.3 10.405a1.3 1.3 0 0 1 1.3 1.3v15.6a1.3 1.3 0 0 1-2.6 0v-15.6a1.3 1.3 0 0 1 1.3-1.3",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.333 13.24a1.1 1.1 0 0 1 1.1 1.1v9.038a2.9 2.9 0 0 0 2.9 2.9h13.334a2.9 2.9 0 0 0 2.9-2.9V14.34a1.1 1.1 0 0 1 2.2 0v9.037a5.1 5.1 0 0 1-5.1 5.1H9.333a5.1 5.1 0 0 1-5.1-5.1V14.34a1.1 1.1 0 0 1 1.1-1.1M16 3.066l6.467 6.467a1.1 1.1 0 1 1-1.556 1.556L16 6.178l-4.911 4.91a1.1 1.1 0 0 1-1.556-1.555z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 5.433a1.1 1.1 0 0 1 1.1 1.1v10.4a1.1 1.1 0 0 1-2.2 0v-10.4a1.1 1.1 0 0 1 1.1-1.1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4 9.856a.9.9 0 0 1 .9.9v6.777c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-6.778a.9.9 0 0 1 1.8 0v6.778a3.9 3.9 0 0 1-3.9 3.9H7a3.9 3.9 0 0 1-3.9-3.9v-6.778a.9.9 0 0 1 .9-.9M12 2.194l4.903 4.903A.9.9 0 0 1 15.63 8.37L12 4.74 8.37 8.37a.9.9 0 0 1-1.273-1.273z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 4a.9.9 0 0 1 .9.9v7.8a.9.9 0 0 1-1.8 0V4.9A.9.9 0 0 1 12 4",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3 7.267a.8.8 0 0 1 .8.8v5.083c0 .801.65 1.45 1.45 1.45h7.5c.8 0 1.45-.649 1.45-1.45V8.067a.8.8 0 1 1 1.6 0v5.083a3.05 3.05 0 0 1-3.05 3.05h-7.5a3.05 3.05 0 0 1-3.05-3.05V8.067a.8.8 0 0 1 .8-.8M9 1.469l3.766 3.765a.8.8 0 0 1-1.132 1.132L9 3.73 6.366 6.366a.8.8 0 1 1-1.132-1.132z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 2.875a.8.8 0 0 1 .8.8v5.85a.8.8 0 0 1-1.6 0v-5.85a.8.8 0 0 1 .8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.667 6.42a.75.75 0 0 1 .75.75v4.519c0 .69.56 1.25 1.25 1.25h6.666c.69 0 1.25-.56 1.25-1.25V7.17a.75.75 0 0 1 1.5 0v4.519a2.75 2.75 0 0 1-2.75 2.75H4.667a2.75 2.75 0 0 1-2.75-2.75V7.17a.75.75 0 0 1 .75-.75M8 1.25l3.375 3.375a.75.75 0 1 1-1.06 1.06L8 3.373 5.686 5.686a.75.75 0 1 1-1.06-1.06z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 2.517a.75.75 0 0 1 .75.75v5.2a.75.75 0 1 1-1.5 0v-5.2a.75.75 0 0 1 .75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpFromBracketMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2 4.778a.6.6 0 0 1 .6.6v3.389a.9.9 0 0 0 .9.9h5a.9.9 0 0 0 .9-.9v-3.39a.6.6 0 0 1 1.2 0v3.39a2.1 2.1 0 0 1-2.1 2.1h-5a2.1 2.1 0 0 1-2.1-2.1v-3.39a.6.6 0 0 1 .6-.6M6 .885l2.557 2.557a.6.6 0 1 1-.848.849l-1.71-1.71-1.708 1.71a.6.6 0 1 1-.849-.849z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 1.85a.6.6 0 0 1 .6.6v3.9a.6.6 0 0 1-1.2 0v-3.9a.6.6 0 0 1 .6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconArrowUpFromBracket/IconArrowUpFromBracket.tsx
var IconArrowUpFromBracket = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUpFromBracketMonochromeExtralight,
          "monochrome|light": IconArrowUpFromBracketMonochromeLight,
          "monochrome|regular": IconArrowUpFromBracketMonochromeRegular,
          "monochrome|medium": IconArrowUpFromBracketMonochromeMedium,
          "monochrome|semibold": IconArrowUpFromBracketMonochromeSemibold,
          "monochrome|bold": IconArrowUpFromBracketMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14 9.2A4.8 4.8 0 0 0 9.2 14v20a4.8 4.8 0 0 0 4.8 4.8h20a4.8 4.8 0 0 0 4.8-4.8v-9a1.2 1.2 0 0 1 2.4 0v9a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 34V14A7.2 7.2 0 0 1 14 6.8h9a1.2 1.2 0 1 1 0 2.4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M31 7.2a1.2 1.2 0 0 1 0-2.4h11A1.2 1.2 0 0 1 43.2 6v11a1.2 1.2 0 0 1-2.4 0V8.897L25.849 23.85a1.2 1.2 0 0 1-1.698-1.698l14.952-14.95z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.333 6.333a4 4 0 0 0-4 4v11.334a4 4 0 0 0 4 4h11.334a4 4 0 0 0 4-4v-5a1 1 0 1 1 2 0v5a6 6 0 0 1-6 6H10.333a6 6 0 0 1-6-6V10.333a6 6 0 0 1 6-6h5a1 1 0 0 1 0 2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19.667 4a1 1 0 0 1 1-1H28a1 1 0 0 1 1 1v7.333a1 1 0 1 1-2 0V6.414l-9.626 9.626a1 1 0 1 1-1.414-1.414L25.586 5h-4.92a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 4.9A3.1 3.1 0 0 0 4.9 8v8A3.1 3.1 0 0 0 8 19.1h8a3.1 3.1 0 0 0 3.1-3.1v-3.5a.9.9 0 1 1 1.8 0V16a4.9 4.9 0 0 1-4.9 4.9H8A4.9 4.9 0 0 1 3.1 16V8A4.9 4.9 0 0 1 8 3.1h3.5a.9.9 0 1 1 0 1.8z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.6 3a.9.9 0 0 1 .9-.9H21a.9.9 0 0 1 .9.9v5.5a.9.9 0 1 1-1.8 0V5.173l-6.964 6.963a.9.9 0 0 1-1.272-1.272L18.827 3.9H15.5a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 3.8A2.2 2.2 0 0 0 3.8 6v6A2.2 2.2 0 0 0 6 14.2h6a2.2 2.2 0 0 0 2.2-2.2V9.375a.8.8 0 1 1 1.6 0V12a3.8 3.8 0 0 1-3.8 3.8H6A3.8 3.8 0 0 1 2.2 12V6A3.8 3.8 0 0 1 6 2.2h2.625a.8.8 0 1 1 0 1.6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.625 3.05a.8.8 0 1 1 0-1.6h4.125a.8.8 0 0 1 .8.8v4.125a.8.8 0 0 1-1.6 0V4.181l-5.01 5.01a.8.8 0 1 1-1.13-1.132l5.009-5.009z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.167 3.417a1.75 1.75 0 0 0-1.75 1.75v5.666c0 .967.783 1.75 1.75 1.75h5.666a1.75 1.75 0 0 0 1.75-1.75v-2.5a.75.75 0 0 1 1.5 0v2.5a3.25 3.25 0 0 1-3.25 3.25H5.167a3.25 3.25 0 0 1-3.25-3.25V5.167a3.25 3.25 0 0 1 3.25-3.25h2.5a.75.75 0 1 1 0 1.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.583 2a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 .75.75v3.667a.75.75 0 0 1-1.5 0V3.81L8.864 8.197a.75.75 0 0 1-1.06-1.06l4.385-4.387h-1.856a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconArrowUpRightFromSquareMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4 2.6A1.4 1.4 0 0 0 2.6 4v4A1.4 1.4 0 0 0 4 9.4h4A1.4 1.4 0 0 0 9.4 8V6.25a.6.6 0 1 1 1.2 0V8A2.6 2.6 0 0 1 8 10.6H4A2.6 2.6 0 0 1 1.4 8V4A2.6 2.6 0 0 1 4 1.4h1.75a.6.6 0 0 1 0 1.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.15 1.5a.6.6 0 0 1 .6-.6h2.75a.6.6 0 0 1 .6.6v2.75a.6.6 0 1 1-1.2 0V2.949L6.674 6.174a.6.6 0 0 1-.848-.848L9.052 2.1H7.75a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconArrowUpRightFromSquare/IconArrowUpRightFromSquare.tsx
var IconArrowUpRightFromSquare = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUpRightFromSquareMonochromeExtralight,
          "monochrome|light": IconArrowUpRightFromSquareMonochromeLight,
          "monochrome|regular": IconArrowUpRightFromSquareMonochromeRegular,
          "monochrome|medium": IconArrowUpRightFromSquareMonochromeMedium,
          "monochrome|semibold": IconArrowUpRightFromSquareMonochromeSemibold,
          "monochrome|bold": IconArrowUpRightFromSquareMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M401.996 89.996h-324c-6.627 0-12-5.372-12-12 0-6.627 5.373-12 12-12h324c6.628 0 12 5.373 12 12 0 6.628-5.372 12-12 12m-170.485 55.515c4.686-4.686 12.284-4.686 16.97 0l98 98c4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0l-77.515-77.514v219.029c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12V182.967l-77.515 77.514c-4.686 4.687-12.284 4.687-16.97 0-4.686-4.686-4.686-12.284 0-16.97z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M402.008 92.998h-324c-8.284 0-15-6.716-15-15s6.715-15 15-15h324c8.284 0 15 6.716 15 15s-6.716 15-15 15m-172.607 50.393c5.858-5.857 15.356-5.857 21.213 0l98 98c5.858 5.858 5.858 15.356 0 21.214s-15.355 5.858-21.213 0l-72.393-72.394v211.787c0 8.284-6.716 15-15 15s-15-6.716-15-15V190.211l-72.394 72.394c-5.857 5.858-15.355 5.858-21.213 0s-5.858-15.356 0-21.214z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M402 96H78c-9.941 0-18-8.059-18-18s8.059-18 18-18h324c9.941 0 18 8.059 18 18s-8.059 18-18 18m-174.728 45.272c7.03-7.029 18.426-7.029 25.456 0l98 98c7.029 7.03 7.029 18.426 0 25.456-7.03 7.029-18.426 7.029-25.456 0L258 197.456V402c0 9.941-8.059 18-18 18s-18-8.059-18-18V197.456l-67.272 67.272c-7.03 7.029-18.426 7.029-25.456 0-7.029-7.029-7.029-18.426 0-25.456z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M401.994 99.327h-324c-11.783 0-21.334-9.551-21.334-21.333 0-11.783 9.551-21.334 21.334-21.334h324c11.782 0 21.333 9.551 21.333 21.334s-9.551 21.333-21.333 21.333m-162 33.334a21.33 21.33 0 0 1 15.084 6.249l98 98c8.332 8.331 8.332 21.838 0 30.169-8.331 8.332-21.838 8.332-30.169 0l-61.582-61.581v196.496c0 11.783-9.551 21.334-21.333 21.334-11.783 0-21.334-9.551-21.334-21.334V205.498l-61.582 61.581c-8.331 8.332-21.838 8.332-30.169 0-8.332-8.331-8.332-21.838 0-30.169l98-98c4-4.001 9.427-6.249 15.085-6.249",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M401.988 100.488h-324c-12.426 0-22.5-10.073-22.5-22.5s10.074-22.5 22.5-22.5h324c12.427 0 22.5 10.074 22.5 22.5s-10.073 22.5-22.5 22.5m-177.91 37.591c8.787-8.786 23.033-8.786 31.82 0l98 98c8.787 8.787 8.787 23.033 0 31.82s-23.033 8.787-31.82 0l-59.59-59.59v193.68c0 12.427-10.073 22.5-22.5 22.5s-22.5-10.073-22.5-22.5v-193.68l-59.59 59.59c-8.787 8.787-23.033 8.787-31.82 0s-8.786-23.033 0-31.82z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUpToLineMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M402.004 101.984h-324c-13.255 0-24-10.745-24-24 0-13.254 10.745-24 24-24h324c13.255 0 24 10.746 24 24 0 13.255-10.745 24-24 24M223.033 137.02c9.373-9.373 24.569-9.373 33.941 0l98 98c9.373 9.372 9.373 24.568 0 33.941-9.372 9.372-24.568 9.372-33.941 0l-57.029-57.03V401.99c0 13.255-10.745 24-24 24s-24-10.745-24-24V211.931l-57.03 57.03c-9.372 9.372-24.568 9.372-33.941 0-9.372-9.373-9.372-24.569 0-33.941z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowUpToLine/IconArrowUpToLine.tsx
var IconArrowUpToLine = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUpToLineMonochromeExtralight,
          "monochrome|light": IconArrowUpToLineMonochromeLight,
          "monochrome|regular": IconArrowUpToLineMonochromeRegular,
          "monochrome|medium": IconArrowUpToLineMonochromeMedium,
          "monochrome|semibold": IconArrowUpToLineMonochromeSemibold,
          "monochrome|bold": IconArrowUpToLineMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.849 7.152a1.2 1.2 0 0 1 0 1.697L8.897 16.8H30c6.186 0 11.2 5.014 11.2 11.2S36.186 39.2 30 39.2h-5a1.2 1.2 0 0 1 0-2.4h5a8.8 8.8 0 1 0 0-17.6H8.897l7.952 7.951a1.2 1.2 0 0 1-1.697 1.698l-8.586-8.586a3.2 3.2 0 0 1 0-4.526l8.586-8.585a1.2 1.2 0 0 1 1.697 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M11.374 4.626a1 1 0 0 1 0 1.414L6.414 11H20a7.667 7.667 0 0 1 0 15.333h-3.333a1 1 0 0 1 0-2H20A5.667 5.667 0 0 0 20 13H6.414l4.96 4.96a1 1 0 1 1-1.414 1.414L4.236 13.65a2.333 2.333 0 0 1 0-3.3L9.96 4.626a1 1 0 0 1 1.414 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.636 3.364a.9.9 0 0 1 0 1.272L5.173 8.1H15a5.9 5.9 0 1 1 0 11.8h-2.5a.9.9 0 0 1 0-1.8H15a4.1 4.1 0 1 0 0-8.2H5.173l3.463 3.464a.9.9 0 0 1-1.272 1.272L3.07 10.345a1.9 1.9 0 0 1 0-2.687l4.293-4.293a.9.9 0 0 1 1.272 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.566 2.434a.8.8 0 0 1 0 1.132L4.18 5.95h7.07a4.55 4.55 0 0 1 0 9.1H9.374a.8.8 0 0 1 0-1.6h1.875a2.95 2.95 0 0 0 0-5.9H4.181l2.385 2.384a.8.8 0 1 1-1.132 1.132l-3.22-3.22a1.55 1.55 0 0 1 0-2.192l3.22-3.22a.8.8 0 0 1 1.132 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.864 2.136a.75.75 0 0 1 0 1.061L3.81 5.25H10a4.083 4.083 0 0 1 0 8.167H8.333a.75.75 0 1 1 0-1.5H10a2.583 2.583 0 1 0 0-5.167H3.81l2.054 2.053a.75.75 0 1 1-1.061 1.06L1.941 7.003a1.417 1.417 0 0 1 0-2.004l2.862-2.862a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnLeftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.424 1.576a.6.6 0 0 1 0 .848L2.95 3.9H7.5a3.1 3.1 0 1 1 0 6.2H6.25a.6.6 0 0 1 0-1.2H7.5a1.9 1.9 0 0 0 0-3.8H2.95l1.475 1.476a.6.6 0 1 1-.848.848L1.429 5.278a1.1 1.1 0 0 1 0-1.556l2.147-2.146a.6.6 0 0 1 .848 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowUturnLeft/IconArrowUturnLeft.tsx
var IconArrowUturnLeft = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUturnLeftMonochromeExtralight,
          "monochrome|light": IconArrowUturnLeftMonochromeLight,
          "monochrome|regular": IconArrowUturnLeftMonochromeRegular,
          "monochrome|medium": IconArrowUturnLeftMonochromeMedium,
          "monochrome|semibold": IconArrowUturnLeftMonochromeSemibold,
          "monochrome|bold": IconArrowUturnLeftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.576 3.576a.6.6 0 0 1 .848 0L20.72 7.87a1.597 1.597 0 0 1 0 2.263l-4.296 4.295a.6.6 0 0 1-.848-.848l3.98-3.981H9a4.4 4.4 0 0 0 0 8.8h2.5a.6.6 0 0 1 0 1.2H9A5.6 5.6 0 1 1 9 8.4h10.552l-3.976-3.976a.6.6 0 0 1 0-.848",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.47 3.47a.75.75 0 0 1 1.06 0l4.296 4.295a1.747 1.747 0 0 1 0 2.475l-4.296 4.295a.75.75 0 0 1-1.06-1.06l3.724-3.725H9a4.25 4.25 0 1 0 0 8.5h2.5a.75.75 0 1 1 0 1.5H9a5.75 5.75 0 0 1 0-11.5h10.19l-3.72-3.72a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.364 3.363a.9.9 0 0 1 1.273 0l4.295 4.295a1.897 1.897 0 0 1 0 2.687l-4.295 4.296a.9.9 0 1 1-1.273-1.273L18.832 9.9H9a4.1 4.1 0 1 0 0 8.2h2.5a.9.9 0 0 1 0 1.8H9A5.9 5.9 0 1 1 9 8.1h9.827l-3.463-3.464a.9.9 0 0 1 0-1.273",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.246 3.246a1.067 1.067 0 0 1 1.508 0L21.05 7.54a2.063 2.063 0 0 1 0 2.923l-4.295 4.295a1.067 1.067 0 0 1-1.508-1.508l3.184-3.184H9a3.933 3.933 0 1 0 0 7.866h2.5a1.067 1.067 0 0 1 0 2.134H9A6.067 6.067 0 0 1 9 7.933h9.425l-3.18-3.179a1.067 1.067 0 0 1 0-1.508",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.205 3.205c.44-.44 1.152-.44 1.591 0L21.091 7.5a2.12 2.12 0 0 1 0 3.005l-.502-.502.502.502-4.295 4.296a1.125 1.125 0 0 1-1.591-1.591l3.084-3.085H9a3.875 3.875 0 0 0 0 7.75h2.5a1.125 1.125 0 0 1 0 2.25H9a6.125 6.125 0 0 1 0-12.25h9.285l-3.08-3.079a1.125 1.125 0 0 1 0-1.591",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconArrowUturnRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.151 3.152a1.2 1.2 0 0 1 1.697 0l4.296 4.295a2.197 2.197 0 0 1 0 3.112l-4.296 4.295a1.2 1.2 0 0 1-1.697-1.697l2.956-2.956H9a3.8 3.8 0 1 0 0 7.6h2.5a1.2 1.2 0 1 1 0 2.4H9A6.2 6.2 0 0 1 9 7.8h9.103L15.15 4.849a1.2 1.2 0 0 1 0-1.697",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconArrowUturnRight/IconArrowUturnRight.tsx
var IconArrowUturnRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconArrowUturnRightMonochromeExtralight,
          "monochrome|light": IconArrowUturnRightMonochromeLight,
          "monochrome|regular": IconArrowUturnRightMonochromeRegular,
          "monochrome|medium": IconArrowUturnRightMonochromeMedium,
          "monochrome|semibold": IconArrowUturnRightMonochromeSemibold,
          "monochrome|bold": IconArrowUturnRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconAwardMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22.35 13.407a2 2 0 0 1 3.3 0l1.475 2.152a2 2 0 0 0 1.084.788l2.502.738a2 2 0 0 1 1.02 3.138L30.14 22.29a2 2 0 0 0-.414 1.275l.072 2.608a2 2 0 0 1-2.67 1.94l-2.458-.875a2 2 0 0 0-1.34 0l-2.458.874a2 2 0 0 1-2.67-1.939l.072-2.608a2 2 0 0 0-.414-1.275l-1.591-2.067a2 2 0 0 1 1.02-3.138l2.502-.738a2 2 0 0 0 1.084-.788zm.505 3.509L24 15.246l1.145 1.67a4.4 4.4 0 0 0 2.385 1.733l1.943.573-1.235 1.605a4.4 4.4 0 0 0-.911 2.804l.055 2.025-1.908-.679a4.4 4.4 0 0 0-2.948 0l-1.908.679.055-2.025a4.4 4.4 0 0 0-.91-2.804l-1.236-1.605 1.943-.573a4.4 4.4 0 0 0 2.385-1.733",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 39a18 18 0 0 0 5.945-1.005l6.952 6.952c1.087 1.087 2.938.648 3.421-.811l1.292-3.905 4.224-1.521a2.065 2.065 0 0 0 .76-3.404l-6.412-6.413A17.9 17.9 0 0 0 42 21c0-9.941-8.059-18-18-18S6 11.059 6 21c0 2.831.654 5.51 1.818 7.893l-6.413 6.414a2.065 2.065 0 0 0 .76 3.403L6.39 40.23l1.292 3.905c.483 1.46 2.334 1.898 3.42.811l6.953-6.952A18 18 0 0 0 24 39m0-2.4c8.616 0 15.6-6.984 15.6-15.6S32.616 5.4 24 5.4 8.4 12.384 8.4 21 15.384 36.6 24 36.6m14.21 6.266-5.896-5.897a18.1 18.1 0 0 0 6.625-5.924l5.586 5.585-3.881 1.398a2.07 2.07 0 0 0-1.261 1.294zM3.475 36.63l5.586-5.585a18.1 18.1 0 0 0 6.626 5.924L9.79 42.866l-1.173-3.544a2.07 2.07 0 0 0-1.26-1.294z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.01 8.778a1.2 1.2 0 0 1 1.98 0l1.12 1.634a1.2 1.2 0 0 0 .65.473l1.9.56a1.2 1.2 0 0 1 .613 1.883l-1.209 1.57a1.2 1.2 0 0 0-.248.765l.055 1.98a1.2 1.2 0 0 1-1.602 1.164l-1.867-.664a1.2 1.2 0 0 0-.804 0l-1.867.664a1.2 1.2 0 0 1-1.601-1.164l.054-1.98a1.2 1.2 0 0 0-.248-.765l-1.209-1.57a1.2 1.2 0 0 1 .612-1.883l1.9-.56a1.2 1.2 0 0 0 .651-.473zm.53 2.765.46-.672.46.672a3.2 3.2 0 0 0 1.735 1.26l.78.23-.496.645a3.2 3.2 0 0 0-.662 2.04l.022.813-.767-.272a3.2 3.2 0 0 0-2.144 0l-.767.272.022-.813a3.2 3.2 0 0 0-.662-2.04l-.497-.645.781-.23a3.2 3.2 0 0 0 1.735-1.26",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 26c1.31 0 2.572-.21 3.752-.598l4.705 4.704c.83.83 2.243.495 2.612-.62l.83-2.51 2.725-.982a1.577 1.577 0 0 0 .58-2.598l-4.325-4.325C27.6 17.53 28 15.812 28 14c0-6.627-5.372-12-12-12C9.373 2 4 7.373 4 14c0 1.812.402 3.53 1.12 5.07L.796 23.397a1.577 1.577 0 0 0 .581 2.599l2.725.981.83 2.51a1.577 1.577 0 0 0 2.612.62l4.705-4.704C13.428 25.79 14.69 26 16 26m0-2c5.523 0 10-4.477 10-10S21.523 4 16 4 6 8.477 6 14s4.477 10 10 10m9.386 4.206-3.659-3.658a12.06 12.06 0 0 0 4.117-3.684l3.475 3.475-2.29.825c-.456.164-.811.528-.963.988zM2.68 24.34l3.475-3.475a12.06 12.06 0 0 0 4.117 3.684l-3.659 3.659-.68-2.055a1.58 1.58 0 0 0-.962-.988z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m19.932 13.864 3.578 3.577c.69.69.428 1.865-.491 2.196l-1.975.711-.6 1.814a1.333 1.333 0 0 1-2.207.524l-4.181-4.181 1.272-1.273 3.645 3.645.434-1.31c.128-.389.428-.696.813-.835l1.496-.539-3.057-3.057zm-17.648 4.33 1.496.538c.385.139.685.447.813.835l.434 1.31 3.645-3.645 1.272 1.273-4.18 4.18a1.332 1.332 0 0 1-2.208-.523l-.6-1.814-1.975-.71a1.333 1.333 0 0 1-.49-2.197l3.577-3.577 1.273 1.272z" }),
            /* @__PURE__ */ jsx("path", { d: "M12 17.7a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m0 1.8a9 9 0 1 1 0-18 9 9 0 0 1 0 18" }),
            /* @__PURE__ */ jsx("path", { d: "m12 8.33-.243.354a2.6 2.6 0 0 1-1.41 1.024l-.41.122.261.34a2.6 2.6 0 0 1 .538 1.656l-.011.43.404-.144c.563-.2 1.179-.2 1.742 0l.404.143-.011-.429a2.6 2.6 0 0 1 .538-1.657l.261-.34-.411-.12a2.6 2.6 0 0 1-1.41-1.025zm.825-1.626.737 1.076a1 1 0 0 0 .542.394l1.252.368a1 1 0 0 1 .51 1.57l-.796 1.033a1 1 0 0 0-.207.638l.036 1.303a1 1 0 0 1-1.335.97l-1.229-.437a1 1 0 0 0-.67 0l-1.23.437a1 1 0 0 1-1.334-.97l.036-1.303a1 1 0 0 0-.207-.638l-.796-1.034a1 1 0 0 1 .51-1.569l1.252-.368a1 1 0 0 0 .542-.394l.737-1.076a1 1 0 0 1 1.65 0" })
          ]
        }
      );
    }
  )
);
var IconAwardMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.588 4.636a.5.5 0 0 1 .824 0l.77 1.123a.5.5 0 0 0 .271.197l1.306.384a.5.5 0 0 1 .255.785l-.83 1.079a.5.5 0 0 0-.104.318l.037 1.361a.5.5 0 0 1-.667.485l-1.282-.456a.5.5 0 0 0-.336 0l-1.282.456a.5.5 0 0 1-.667-.485l.037-1.36a.5.5 0 0 0-.103-.32l-.83-1.078a.5.5 0 0 1 .254-.785l1.306-.384a.5.5 0 0 0 .271-.197zm.302 1.858.11-.16.11.16a1.8 1.8 0 0 0 .975.709l.186.054-.118.154a1.8 1.8 0 0 0-.373 1.147l.006.194-.183-.065a1.8 1.8 0 0 0-1.206 0l-.183.065.006-.194a1.8 1.8 0 0 0-.373-1.147l-.118-.154.186-.054a1.8 1.8 0 0 0 .975-.71",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 14.216c.614 0 1.208-.084 1.77-.242l2.663 2.662c.586.586 1.585.35 1.846-.438l.414-1.252 1.37-.494c.769-.276.988-1.259.41-1.836l-2.429-2.43a6.545 6.545 0 1 0-12.089 0l-2.428 2.43a1.115 1.115 0 0 0 .41 1.837l1.37.493.414 1.252a1.115 1.115 0 0 0 1.846.438l2.662-2.662A6.6 6.6 0 0 0 9 14.216m0-1.6a4.945 4.945 0 1 0 0-9.891 4.945 4.945 0 0 0 0 9.89m5.008 2.332-1.655-1.655a6.6 6.6 0 0 0 1.865-1.67l1.583 1.583-.872.314a1.12 1.12 0 0 0-.68.699zm-11.81-1.742 1.584-1.583a6.6 6.6 0 0 0 1.865 1.67l-1.654 1.655-.242-.73a1.12 1.12 0 0 0-.68-.697z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.588 4.147a.5.5 0 0 1 .824 0l.61.89a.5.5 0 0 0 .27.196l1.034.305a.5.5 0 0 1 .255.784l-.657.854a.5.5 0 0 0-.103.319l.03 1.077a.5.5 0 0 1-.668.485l-1.015-.361a.5.5 0 0 0-.335 0l-1.016.361a.5.5 0 0 1-.667-.485l.03-1.077a.5.5 0 0 0-.104-.319l-.657-.854a.5.5 0 0 1 .255-.784l1.033-.305a.5.5 0 0 0 .271-.197zm.38 1.568L8 5.668l.032.047a1.7 1.7 0 0 0 .921.67l.054.015-.034.045a1.7 1.7 0 0 0-.352 1.083l.002.056-.053-.019a1.7 1.7 0 0 0-1.14 0l-.053.02.002-.057a1.7 1.7 0 0 0-.352-1.083L6.993 6.4l.054-.016a1.7 1.7 0 0 0 .921-.67",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 12.455c.517 0 1.018-.069 1.494-.197l2.35 2.35c.539.539 1.458.32 1.698-.404l.355-1.072 1.175-.423a1.025 1.025 0 0 0 .378-1.69l-2.14-2.14a5.727 5.727 0 1 0-10.619 0l-2.14 2.14a1.025 1.025 0 0 0 .377 1.69l1.175.423.355 1.072c.24.725 1.16.943 1.699.403l2.35-2.35c.475.13.976.197 1.493.197m0-1.5A4.227 4.227 0 1 0 8 2.5a4.227 4.227 0 0 0 0 8.455m4.36 2.047-1.382-1.382c.6-.366 1.129-.84 1.557-1.394l1.325 1.325-.689.248a1.02 1.02 0 0 0-.626.642zM2.14 11.551l1.325-1.325a5.8 5.8 0 0 0 1.557 1.394L3.64 13.002l-.185-.56a1.02 1.02 0 0 0-.626-.643z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m9.74 6.485 1.627 1.626a.797.797 0 0 1-.294 1.313l-.81.292-.243.736a.797.797 0 0 1-1.32.313l-1.9-1.9.848-.85 1.438 1.439.1-.302a.8.8 0 0 1 .486-.499l.397-.143-1.177-1.177zM1.932 8.51l.397.143c.23.083.41.267.487.5l.1.3 1.437-1.437.849.848-1.9 1.9a.797.797 0 0 1-1.32-.312l-.244-.736-.81-.292A.797.797 0 0 1 .634 8.11L2.26 6.485l.848.848z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 7.982A2.89 2.89 0 1 0 6 2.2a2.89 2.89 0 0 0 0 5.782m0 1.2A4.09 4.09 0 1 0 6 1a4.09 4.09 0 0 0 0 8.182",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconAward/IconAward.tsx
var IconAward = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconAwardMonochromeExtralight,
          "monochrome|light": IconAwardMonochromeLight,
          "monochrome|regular": IconAwardMonochromeRegular,
          "monochrome|medium": IconAwardMonochromeMedium,
          "monochrome|semibold": IconAwardMonochromeSemibold,
          "monochrome|bold": IconAwardMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconAwardFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m6.187 30.95-4.57 4.569a1.765 1.765 0 0 0 .65 2.909l4.362 1.57 1.338 4.044a1.765 1.765 0 0 0 2.923.693l5.008-5.007a20.48 20.48 0 0 1-9.711-8.779M32.102 39.728l5.007 5.007a1.765 1.765 0 0 0 2.924-.694l1.338-4.043 4.362-1.57a1.765 1.765 0 0 0 .65-2.91l-4.57-4.568a20.48 20.48 0 0 1-9.71 8.778" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 39c9.941 0 18-8.059 18-18S33.941 3 24 3 6 11.059 6 21s8.059 18 18 18m2.852-22.838-1.532-2.236a1.6 1.6 0 0 0-2.64 0l-1.532 2.236a1.6 1.6 0 0 1-.868.63l-2.6.767a1.6 1.6 0 0 0-.816 2.51l1.653 2.149c.225.291.342.652.332 1.02l-.075 2.71a1.6 1.6 0 0 0 2.136 1.551l2.554-.908a1.6 1.6 0 0 1 1.072 0l2.554.908a1.6 1.6 0 0 0 2.136-1.552l-.075-2.71a1.6 1.6 0 0 1 .332-1.02l1.653-2.148a1.6 1.6 0 0 0-.816-2.51l-2.6-.767a1.6 1.6 0 0 1-.868-.63",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m3.827 20.506-2.96 2.961a1.477 1.477 0 0 0 .543 2.434l2.77.997.846 2.557a1.477 1.477 0 0 0 2.447.58l3.271-3.271a13.85 13.85 0 0 1-6.917-6.258M21.256 26.764l3.272 3.271c.777.778 2.1.464 2.446-.58l.846-2.557 2.77-.997a1.477 1.477 0 0 0 .544-2.434l-2.96-2.96a13.85 13.85 0 0 1-6.918 6.257" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 26c6.627 0 12-5.373 12-12S22.627 2 16 2 4 7.373 4 14s5.373 12 12 12m1.875-15.264-.885-1.292a1.2 1.2 0 0 0-1.98 0l-.885 1.291a1.2 1.2 0 0 1-.65.473l-1.502.443a1.2 1.2 0 0 0-.612 1.883l.955 1.24a1.2 1.2 0 0 1 .248.765l-.043 1.565a1.2 1.2 0 0 0 1.602 1.163l1.475-.524a1.2 1.2 0 0 1 .804 0l1.475.524a1.2 1.2 0 0 0 1.602-1.163l-.043-1.565a1.2 1.2 0 0 1 .248-.765l.955-1.24a1.2 1.2 0 0 0-.612-1.883l-1.502-.443a1.2 1.2 0 0 1-.65-.473",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.724 15.208.49 17.44c-.69.69-.428 1.865.491 2.196l1.975.711.6 1.814a1.333 1.333 0 0 0 2.207.524l2.484-2.484a10.44 10.44 0 0 1-5.523-4.995M15.753 20.202l2.483 2.484a1.333 1.333 0 0 0 2.208-.524l.6-1.814 1.975-.711a1.332 1.332 0 0 0 .49-2.196l-2.233-2.233a10.44 10.44 0 0 1-5.523 4.994" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 19.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18m1.386-11.478-.561-.818a1 1 0 0 0-1.65 0l-.561.818a1 1 0 0 1-.542.394l-.952.28a1 1 0 0 0-.51 1.57l.605.787a1 1 0 0 1 .207.637l-.027.992a1 1 0 0 0 1.335.97l.935-.333a1 1 0 0 1 .67 0l.935.333a1 1 0 0 0 1.335-.97l-.027-.992a1 1 0 0 1 .207-.637l.605-.787a1 1 0 0 0-.51-1.57l-.952-.28a1 1 0 0 1-.542-.394",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.994 11.42.35 13.063c-.53.531-.329 1.434.377 1.688l1.47.53.446 1.348c.24.724 1.158.942 1.697.403L6.172 15.2a7.88 7.88 0 0 1-4.178-3.78",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "m11.828 15.2 1.832 1.832c.539.539 1.457.321 1.697-.403l.446-1.348 1.47-.53a1.024 1.024 0 0 0 .377-1.688l-1.644-1.644a7.88 7.88 0 0 1-4.178 3.781" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 14.625a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5m1.05-8.594-.473-.688a.7.7 0 0 0-1.154 0l-.473.688a.7.7 0 0 1-.379.276l-.801.236a.7.7 0 0 0-.357 1.099l.51.661a.7.7 0 0 1 .144.447l-.023.834a.7.7 0 0 0 .935.68l.786-.28a.7.7 0 0 1 .47 0l.786.28a.7.7 0 0 0 .935-.68l-.023-.834a.7.7 0 0 1 .145-.447l.509-.661a.7.7 0 0 0-.357-1.099l-.801-.236a.7.7 0 0 1-.38-.276",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m1.766 10.188-1.44 1.44a.888.888 0 0 0 .328 1.463l1.317.475.4 1.209a.888.888 0 0 0 1.471.349l1.604-1.604a7.03 7.03 0 0 1-3.68-3.332m.706 3.052.02-.007-.011-.029z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "m10.554 13.52 1.604 1.604a.888.888 0 0 0 1.471-.35l.4-1.208 1.317-.475a.888.888 0 0 0 .327-1.464l-1.44-1.439a7.03 7.03 0 0 1-3.68 3.332" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 13A6 6 0 1 0 8 1a6 6 0 0 0 0 12m.937-7.632-.442-.646a.6.6 0 0 0-.99 0l-.442.646a.6.6 0 0 1-.326.236l-.75.221a.6.6 0 0 0-.306.942l.477.62a.6.6 0 0 1 .124.383l-.021.782a.6.6 0 0 0 .8.582L7.8 8.87a.6.6 0 0 1 .402 0l.737.263a.6.6 0 0 0 .801-.582l-.021-.782a.6.6 0 0 1 .124-.383l.477-.62a.6.6 0 0 0-.306-.942l-.75-.22a.6.6 0 0 1-.326-.237",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconAwardFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsxs("g", { clipPath: `url(#${_id})`, children: [
              /* @__PURE__ */ jsx("path", { d: "M1.264 7.631.21 8.685a.716.716 0 0 0 .264 1.18l.964.348.293.884a.716.716 0 0 0 1.186.281l1.18-1.18a5.32 5.32 0 0 1-2.833-2.567M7.903 10.198l1.18 1.18a.716.716 0 0 0 1.187-.281l.292-.884.965-.347a.716.716 0 0 0 .263-1.18L10.736 7.63a5.32 5.32 0 0 1-2.833 2.567" }),
              /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M6 9.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.713-5.71-.383-.559a.4.4 0 0 0-.66 0l-.383.56a.4.4 0 0 1-.217.157l-.65.192a.4.4 0 0 0-.204.627l.413.537a.4.4 0 0 1 .083.255l-.018.678a.4.4 0 0 0 .533.388l.639-.227a.4.4 0 0 1 .268 0l.639.227a.4.4 0 0 0 .533-.388l-.018-.678a.4.4 0 0 1 .083-.255l.413-.537a.4.4 0 0 0-.204-.627l-.65-.192a.4.4 0 0 1-.217-.158",
                  clipRule: "evenodd"
                }
              )
            ] }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconAwardFilled/IconAwardFilled.tsx
var IconAwardFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconAwardFilledMonochromeExtralight,
          "monochrome|light": IconAwardFilledMonochromeLight,
          "monochrome|regular": IconAwardFilledMonochromeRegular,
          "monochrome|medium": IconAwardFilledMonochromeMedium,
          "monochrome|semibold": IconAwardFilledMonochromeSemibold,
          "monochrome|bold": IconAwardFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBellMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 6.8c-7.262 0-13.15 5.888-13.15 13.15v7.631c0 .684-.272 1.338-.754 1.82l-.799.799c-.27.27-.31.316-.338.354a.85.85 0 0 0-.148.358c-.007.046-.011.105-.011.49 0 .887.016 1.035.045 1.12a.85.85 0 0 0 .534.534c.084.029.23.044 1.11.044h27.022c.88 0 1.028-.015 1.112-.044a.85.85 0 0 0 .532-.533c.03-.086.045-.234.045-1.121 0-.383-.004-.443-.012-.49a.85.85 0 0 0-.147-.358c-.026-.037-.066-.082-.338-.354l-.799-.799a2.57 2.57 0 0 1-.754-1.82v-7.63C37.15 12.687 31.264 6.8 24 6.8M8.45 19.95C8.45 11.362 15.412 4.4 24 4.4s15.55 6.962 15.55 15.55v7.631c0 .046.019.09.052.123l.798.799.044.044c.2.2.39.39.547.607.294.41.485.88.566 1.37.043.266.043.534.043.822v.207c.001.636.002 1.225-.17 1.737a3.25 3.25 0 0 1-2.04 2.04c-.51.173-1.098.172-1.729.17h-6.31v.85a7.35 7.35 0 0 1-14.7 0v-.85H10.34c-.631.002-1.217.003-1.728-.17a3.25 3.25 0 0 1-2.042-2.04c-.172-.512-.171-1.101-.17-1.737v-.214c0-.284 0-.551.043-.815.08-.494.274-.962.567-1.37.157-.218.347-.408.55-.61l.04-.041.799-.799a.17.17 0 0 0 .051-.123zm10.6 15.55v.85a4.95 4.95 0 0 0 9.9 0v-.85z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBellMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 4.733A8.567 8.567 0 0 0 7.433 13.3v5.088c0 .508-.202.995-.56 1.354l-.533.533a8 8 0 0 0-.2.205l-.004.005v.001a.37.37 0 0 0-.067.207c-.002.052-.002.12-.002.241 0 .275 0 .44.007.563a1 1 0 0 0 .013.123c.037.106.12.19.227.227.007.002.04.008.121.013.122.007.285.007.558.007h18.015c.272 0 .436 0 .558-.007a1 1 0 0 0 .122-.013.37.37 0 0 0 .225-.225s.008-.031.013-.125c.007-.123.007-.288.007-.563a9 9 0 0 0-.003-.271v-.014l-.002-.007v-.001a.4.4 0 0 0-.063-.155c.002.003-.003-.005-.035-.04l-.17-.171-.532-.533a1.92 1.92 0 0 1-.56-1.355V13.3A8.567 8.567 0 0 0 16 4.733M5.433 13.3C5.433 7.464 10.164 2.733 16 2.733S26.567 7.464 26.567 13.3v5.053l.508.507.032.032c.13.13.269.269.383.428.214.298.353.64.412.997.032.194.032.389.031.576v.15c.002.413.003.84-.124 1.214a2.37 2.37 0 0 1-1.485 1.486c-.373.126-.8.125-1.21.124H21.1v.367a5.1 5.1 0 1 1-10.2 0v-.367H6.886c-.41.001-.835.002-1.209-.124a2.37 2.37 0 0 1-1.486-1.486c-.126-.375-.125-.801-.124-1.214v-.154c0-.184 0-.379.031-.572.059-.36.2-.7.413-.997a3.5 3.5 0 0 1 .415-.46l.507-.508zM12.9 23.867v.367a3.1 3.1 0 0 0 6.2 0v-.367z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBellMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 3.7a6.275 6.275 0 0 0-6.275 6.275v3.816c0 .421-.168.825-.465 1.122l-.4.4-.139.142a.1.1 0 0 0-.019.046v.023l-.002.177c0 .208 0 .326.005.413l.006.061a.13.13 0 0 0 .064.065l.06.005c.086.005.204.005.41.005h13.51c.207 0 .324 0 .411-.005l.06-.005a.12.12 0 0 0 .064-.064l.005-.061c.005-.088.005-.206.005-.414l-.001-.176-.001-.024a.1.1 0 0 0-.019-.046l-.016-.017-.124-.126-.399-.4a1.59 1.59 0 0 1-.465-1.121V9.975A6.275 6.275 0 0 0 12 3.7M3.925 9.975a8.075 8.075 0 0 1 16.15 0v3.727l.337.337.025.025c.096.096.209.209.302.338.175.243.288.521.335.811.026.159.026.317.026.455v.117c.001.304.002.65-.101.956a1.92 1.92 0 0 1-1.208 1.209c-.305.102-.65.101-.952.1h-2.863v.125a3.975 3.975 0 1 1-7.95 0v-.125H5.16c-.301.001-.646.002-.95-.1A1.93 1.93 0 0 1 3 16.74c-.103-.305-.102-.651-.101-.955v-.12c0-.136 0-.294.025-.452.048-.292.163-.57.336-.81.094-.131.206-.243.303-.34l.024-.024.337-.337zm5.9 8.075v.125a2.175 2.175 0 0 0 4.35 0v-.125z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBellMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 2.9a4.58 4.58 0 0 0-4.581 4.581v2.862c0 .35-.14.684-.386.93l-.3.3-.082.084-.001.119c0 .141 0 .224.003.284.059.002.14.003.28.003h10.134c.139 0 .22 0 .28-.003a8 8 0 0 0 .002-.404l-.083-.084-.3-.299a1.32 1.32 0 0 1-.385-.93V7.481A4.58 4.58 0 0 0 9 2.9M2.819 7.481a6.181 6.181 0 0 1 12.362 0v2.744l.216.216.02.02c.07.07.163.162.239.268.142.198.234.425.273.66.021.13.021.26.021.36v.091c.001.224.002.505-.082.755-.157.463-.52.829-.985.986-.25.084-.53.083-.752.082h-2.024a3.106 3.106 0 0 1-6.213 0H3.869c-.221 0-.502.002-.751-.082a1.57 1.57 0 0 1-.986-.986c-.084-.25-.083-.531-.082-.755v-.092c0-.1 0-.23.02-.358.04-.238.133-.465.274-.661.077-.107.168-.198.24-.27l.019-.018.216-.216zm4.675 6.182a1.506 1.506 0 0 0 3.012 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBellMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 2.617A4.033 4.033 0 0 0 3.967 6.65v2.544c0 .32-.128.628-.354.854l-.266.266-.05.05-.013.014v.304l.213.002h9.007c.098 0 .163 0 .211-.002.002-.049.002-.115.002-.215v-.09l-.013-.012-.05-.05-.267-.267a1.2 1.2 0 0 1-.354-.854V6.65A4.033 4.033 0 0 0 8 2.617M2.467 6.65a5.533 5.533 0 0 1 11.067 0v2.423l.18.18.017.018a1.433 1.433 0 0 1 .466.847c.02.118.02.236.02.326v.081c0 .197.002.454-.075.683a1.43 1.43 0 0 1-.9.9c-.229.078-.485.077-.681.076h-1.762a2.8 2.8 0 0 1-5.598 0H3.439c-.195 0-.451.002-.68-.075a1.43 1.43 0 0 1-.9-.9c-.078-.23-.077-.487-.076-.684v-.082c0-.089 0-.207.02-.325.035-.217.12-.424.25-.604.07-.097.153-.18.216-.244l.017-.017.18-.18zm4.235 5.534a1.3 1.3 0 0 0 2.596 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBellMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 2a2.99 2.99 0 0 0-2.987 2.988v1.907c0 .25-.1.49-.277.667l-.2.2L2.5 7.8v.176h7v-.176l-.036-.037-.2-.2a.94.94 0 0 1-.276-.667V4.988A2.99 2.99 0 0 0 6 2M1.813 4.988a4.188 4.188 0 0 1 8.375 0v1.801l.124.125.013.012a1.113 1.113 0 0 1 .375.906v.062c0 .147.002.346-.058.524-.111.329-.368.588-.698.699-.178.06-.377.059-.523.058H8.136a2.138 2.138 0 0 1-4.272 0H2.58c-.146 0-.345.002-.523-.058a1.11 1.11 0 0 1-.699-.699c-.06-.178-.059-.377-.058-.524v-.062c0-.066 0-.158.015-.25.027-.168.094-.329.194-.468.054-.076.12-.14.167-.188l.012-.012.125-.125zm3.254 4.187a.938.938 0 0 0 1.867 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBell/IconBell.tsx
var IconBell = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBellMonochromeExtralight,
          "monochrome|light": IconBellMonochromeLight,
          "monochrome|regular": IconBellMonochromeRegular,
          "monochrome|medium": IconBellMonochromeMedium,
          "monochrome|semibold": IconBellMonochromeSemibold,
          "monochrome|bold": IconBellMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBellFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M23.988 3.8c-9.155 0-16.577 7.422-16.577 16.578v7.698l-.758.758c-.202.201-.43.428-.62.693a3.9 3.9 0 0 0-.682 1.648c-.052.32-.052.642-.052.923v.245c-.002.627-.004 1.33.206 1.952A3.91 3.91 0 0 0 7.96 36.75c.62.209 1.32.207 1.943.205h5.9510000000000005v.004h16.267v-.004h5.9510000000000005c.623.002 1.325.004 1.944-.205a3.91 3.91 0 0 0 2.455-2.456c.209-.621.207-1.325.205-1.952v-.24c0-.285 0-.606-.052-.928a3.9 3.9 0 0 0-.681-1.648c-.19-.263-.419-.492-.617-.69l-.76-.76v-7.7c0-9.155-7.423-16.577-16.579-16.577M31.733 39.76H16.244a8.137 8.137 0 0 0 15.489 0" })
        }
      );
    }
  )
);
var IconBellFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M15.992 2.533c-6.103 0-11.051 4.948-11.051 11.052v5.133l-.506.505a4 4 0 0 0-.413.462c-.234.327-.39.703-.454 1.098a4 4 0 0 0-.035.616v.163c-.001.418-.003.887.137 1.301.26.772.867 1.378 1.638 1.638.413.139.88.138 1.295.136h3.967v.003h10.845v-.003h3.967c.415.002.883.003 1.296-.136a2.6 2.6 0 0 0 1.636-1.638c.14-.414.139-.883.137-1.3v-.161c0-.19 0-.404-.034-.619a2.6 2.6 0 0 0-.454-1.098c-.127-.176-.28-.328-.412-.46l-.507-.507v-5.133c0-6.104-4.948-11.052-11.052-11.052M21.155 26.507H10.83a5.425 5.425 0 0 0 10.325 0" })
        }
      );
    }
  )
);
var IconBellFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.994 1.9a8.29 8.29 0 0 0-8.289 8.289v3.85l-.379.378c-.1.1-.214.214-.31.347a1.96 1.96 0 0 0-.34.823c-.027.16-.026.322-.026.462v.123c-.001.313-.002.665.102.975.196.58.65 1.033 1.229 1.228.31.105.66.104.97.103h2.9770000000000003v.002h8.133v-.002h2.976c.31 0 .662.002.972-.103a1.95 1.95 0 0 0 1.227-1.227c.104-.311.104-.663.102-.976v-.12c0-.143 0-.304-.026-.465a1.95 1.95 0 0 0-.34-.823 3 3 0 0 0-.309-.345l-.38-.38v-3.85A8.29 8.29 0 0 0 11.994 1.9M15.866 19.88H8.122a4.068 4.068 0 0 0 7.744 0" })
        }
      );
    }
  )
);
var IconBellFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.995 1.425A6.217 6.217 0 0 0 2.78 7.642v2.887l-.284.284c-.076.075-.161.16-.233.26-.132.184-.22.395-.256.617-.02.12-.02.241-.019.347v.092c0 .235-.002.499.077.732.146.434.487.774.921.92.233.079.495.078.729.077h2.231v.002h6.1v-.002h2.232c.234.001.497.002.73-.076.434-.147.774-.488.92-.921.078-.233.077-.497.077-.732v-.09c0-.107 0-.228-.02-.348a1.5 1.5 0 0 0-.255-.618c-.071-.1-.157-.185-.232-.26l-.285-.284V7.642a6.217 6.217 0 0 0-6.217-6.217M11.9 14.91H6.09a3.051 3.051 0 0 0 5.808 0" })
        }
      );
    }
  )
);
var IconBellFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.996 1.267A5.526 5.526 0 0 0 2.47 6.793v2.566l-.252.252c-.067.067-.143.143-.207.231a1.3 1.3 0 0 0-.227.55 2 2 0 0 0-.017.307v.082c-.001.21-.002.444.068.65.13.387.433.69.819.82.206.069.44.068.647.068h1.984v.001h5.422v-.002h1.984c.208.001.442.002.648-.068.387-.13.688-.434.818-.818.07-.207.07-.442.069-.65V10.7c0-.095 0-.202-.018-.31a1.3 1.3 0 0 0-.227-.549c-.063-.087-.14-.164-.205-.23l-.254-.253V6.793a5.526 5.526 0 0 0-5.526-5.526M10.578 13.253H5.415a2.712 2.712 0 0 0 5.163 0" })
        }
      );
    }
  )
);
var IconBellFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.997.95a4.144 4.144 0 0 0-4.144 4.144V7.02l-.19.19c-.05.05-.107.107-.155.173a1 1 0 0 0-.17.412c-.013.08-.013.16-.013.23v.062c0 .157-.001.332.051.488.098.29.325.516.614.614.155.052.33.051.486.051h1.488v.001H8.03v-.001h1.488c.156 0 .331.001.486-.051a.98.98 0 0 0 .614-.614c.052-.156.052-.331.051-.488v-.06c0-.071 0-.152-.013-.232a1 1 0 0 0-.17-.412 1.4 1.4 0 0 0-.154-.173l-.19-.19V5.094A4.144 4.144 0 0 0 5.997.95M7.933 9.94H4.061a2.034 2.034 0 0 0 3.872 0" })
        }
      );
    }
  )
);

// src/IconBellFilled/IconBellFilled.tsx
var IconBellFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBellFilledMonochromeExtralight,
          "monochrome|light": IconBellFilledMonochromeLight,
          "monochrome|regular": IconBellFilledMonochromeRegular,
          "monochrome|medium": IconBellFilledMonochromeMedium,
          "monochrome|semibold": IconBellFilledMonochromeSemibold,
          "monochrome|bold": IconBellFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.9 2.3a.6.6 0 0 1 .6.6v18.2a.6.6 0 1 1-1.2 0V2.9a.6.6 0 0 1 .6-.6m16.2 3.1H8.2a.6.6 0 0 1 0-1.2h11.9a.6.6 0 1 1 0 1.2M7.6 12a.6.6 0 0 1 .6-.6h11.9a.6.6 0 0 1 0 1.2H8.2a.6.6 0 0 1-.6-.6m8.6 7.8h-8a.6.6 0 1 1 0-1.2h8a.6.6 0 0 1 0 1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.45 19.2a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75M7.45 12a.75.75 0 0 1 .75-.75h11.9a.75.75 0 0 1 0 1.5H8.2a.75.75 0 0 1-.75-.75M7.45 4.8a.75.75 0 0 1 .75-.75h11.9a.75.75 0 0 1 0 1.5H8.2a.75.75 0 0 1-.75-.75M3.9 2.15a.75.75 0 0 1 .75.75v18.2a.75.75 0 0 1-1.5 0V2.9a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.3 19.2a.9.9 0 0 1 .9-.9h8a.9.9 0 0 1 0 1.8h-8a.9.9 0 0 1-.9-.9M7.3 12a.9.9 0 0 1 .9-.9h11.9a.9.9 0 0 1 0 1.8H8.2a.9.9 0 0 1-.9-.9M7.3 4.8a.9.9 0 0 1 .9-.9h11.9a.9.9 0 0 1 0 1.8H8.2a.9.9 0 0 1-.9-.9M3.9 2a.9.9 0 0 1 .9.9v18.2a.9.9 0 1 1-1.8 0V2.9a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.134 19.2c0-.589.477-1.066 1.067-1.066h8a1.067 1.067 0 0 1 0 2.133h-8c-.59 0-1.067-.478-1.067-1.067M7.134 12c0-.59.477-1.067 1.067-1.067h11.9a1.067 1.067 0 0 1 0 2.134H8.2c-.59 0-1.067-.478-1.067-1.067M7.134 4.8c0-.589.477-1.067 1.067-1.067h11.9a1.067 1.067 0 1 1 0 2.134H8.2c-.59 0-1.067-.478-1.067-1.067M3.9 1.834c.59 0 1.067.477 1.067 1.066v18.2a1.067 1.067 0 0 1-2.133 0V2.9c0-.589.477-1.066 1.066-1.066",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.075 19.2c0-.621.504-1.125 1.125-1.125h8a1.125 1.125 0 0 1 0 2.25h-8A1.125 1.125 0 0 1 7.075 19.2M7.075 12c0-.621.504-1.125 1.125-1.125h11.9a1.125 1.125 0 0 1 0 2.25H8.2A1.125 1.125 0 0 1 7.075 12M7.075 4.8c0-.621.504-1.125 1.125-1.125h11.9a1.125 1.125 0 0 1 0 2.25H8.2A1.125 1.125 0 0 1 7.075 4.8M3.9 1.775c.622 0 1.125.504 1.125 1.125v18.2a1.125 1.125 0 0 1-2.25 0V2.9c0-.621.504-1.125 1.125-1.125",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBlockQuoteMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.001 19.201a1.2 1.2 0 0 1 1.2-1.2h8a1.2 1.2 0 0 1 0 2.4h-8a1.2 1.2 0 0 1-1.2-1.2M7.001 12.001a1.2 1.2 0 0 1 1.2-1.2h11.9a1.2 1.2 0 0 1 0 2.4h-11.9a1.2 1.2 0 0 1-1.2-1.2M7.001 4.801a1.2 1.2 0 0 1 1.2-1.2h11.9a1.2 1.2 0 0 1 0 2.4h-11.9a1.2 1.2 0 0 1-1.2-1.2M3.901 1.701a1.2 1.2 0 0 1 1.2 1.2v18.2a1.2 1.2 0 0 1-2.4 0v-18.2a1.2 1.2 0 0 1 1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBlockQuote/IconBlockQuote.tsx
var IconBlockQuote = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBlockQuoteMonochromeExtralight,
          "monochrome|light": IconBlockQuoteMonochromeLight,
          "monochrome|regular": IconBlockQuoteMonochromeRegular,
          "monochrome|medium": IconBlockQuoteMonochromeMedium,
          "monochrome|semibold": IconBlockQuoteMonochromeSemibold,
          "monochrome|bold": IconBlockQuoteMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBoldMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.8 11.158A4.36 4.36 0 0 1 15.158 6.8H24a9.2 9.2 0 0 1 5.96 16.21c4.14.897 7.24 4.581 7.24 8.99a9.2 9.2 0 0 1-9.2 9.2H15.79a4.99 4.99 0 0 1-4.99-4.99zM13.2 25.2v11.01a2.59 2.59 0 0 0 2.59 2.59H28a6.8 6.8 0 1 0 0-13.6zm0-2.4H24a6.8 6.8 0 1 0 0-13.6h-8.842a1.96 1.96 0 0 0-1.958 1.958z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBoldMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7 7.439a3.105 3.105 0 0 1 3.105-3.106H16a6.333 6.333 0 0 1 4.386 10.903 6.333 6.333 0 0 1-1.719 12.43h-8.14A3.526 3.526 0 0 1 7 24.14zm2 9.56v7.141c0 .843.683 1.527 1.526 1.527h8.14a4.333 4.333 0 0 0 0-8.667zm0-2h7a4.333 4.333 0 0 0 0-8.666h-5.895C9.495 6.333 9 6.828 9 7.44z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBoldMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.1 5.579C5.1 4.21 6.21 3.1 7.58 3.1H12a4.9 4.9 0 0 1 3.57 8.257A4.902 4.902 0 0 1 14 20.9H7.895A2.795 2.795 0 0 1 5.1 18.105zM6.9 12.9v5.205c0 .55.445.995.995.995H14a3.1 3.1 0 1 0 0-6.2zm0-1.8H12a3.1 3.1 0 1 0 0-6.2H7.58a.68.68 0 0 0-.679.679z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBoldMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.7 4.184c0-1.096.888-1.984 1.984-1.984H9a3.8 3.8 0 0 1 2.893 6.264A3.801 3.801 0 0 1 10.5 15.8H5.921A2.22 2.22 0 0 1 3.7 13.579zM5.3 9.8v3.779c0 .343.278.621.621.621H10.5a2.2 2.2 0 0 0 0-4.4zm0-1.6H9a2.2 2.2 0 1 0 0-4.4H5.684a.384.384 0 0 0-.384.384z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBoldMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.25 3.72c0-.996.807-1.803 1.803-1.803H8a3.417 3.417 0 0 1 2.636 5.59 3.418 3.418 0 0 1-1.303 6.576h-4.07A2.013 2.013 0 0 1 3.25 12.07zm1.5 5.03v3.32c0 .284.23.513.513.513h4.07a1.917 1.917 0 1 0 0-3.833zm0-1.5H8a1.917 1.917 0 1 0 0-3.833H5.053a.303.303 0 0 0-.303.302z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBoldMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.4 2.79c0-.768.622-1.39 1.39-1.39H6a2.6 2.6 0 0 1 2.037 4.215A2.6 2.6 0 0 1 7 10.6H3.947A1.547 1.547 0 0 1 2.4 9.053zM3.6 6.6v2.453c0 .191.155.347.347.347H7a1.4 1.4 0 1 0 0-2.8zm0-1.2H6a1.4 1.4 0 1 0 0-2.8H3.79a.19.19 0 0 0-.19.19z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBold/IconBold.tsx
var IconBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBoldMonochromeExtralight,
          "monochrome|light": IconBoldMonochromeLight,
          "monochrome|regular": IconBoldMonochromeRegular,
          "monochrome|medium": IconBoldMonochromeMedium,
          "monochrome|semibold": IconBoldMonochromeSemibold,
          "monochrome|bold": IconBoldMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBookmarkMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M34 6.8H14a3.6 3.6 0 0 0-3.6 3.6v30.07l10.21-6.38a6.4 6.4 0 0 1 6.785 0L37.6 40.47V10.4A3.6 3.6 0 0 0 34 6.8M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M22.667 4.933H9.333a2 2 0 0 0-2 2V26.26l6.195-3.872a4.67 4.67 0 0 1 4.947 0l6.192 3.87V6.934a2 2 0 0 0-2-2m-13.334-2a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.131l7.215-4.509a2.67 2.67 0 0 1 2.827 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M17 4H7a1.2 1.2 0 0 0-1.2 1.2v13.953l4.187-2.617a3.8 3.8 0 0 1 4.028 0l4.185 2.616V5.2A1.2 1.2 0 0 0 17 4M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12.75 3.25h-7.5a.65.65 0 0 0-.65.65v10.014l2.758-1.724a3.1 3.1 0 0 1 3.286 0l2.756 1.723V3.9a.65.65 0 0 0-.65-.65m-7.5-1.6A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M11.333 2.967H4.667a.5.5 0 0 0-.5.5v8.76l2.332-1.457a2.83 2.83 0 0 1 3.004 0l2.33 1.457v-8.76a.5.5 0 0 0-.5-.5m-6.666-1.5a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8.5 2.3h-5a.3.3 0 0 0-.3.3v6.435l1.635-1.021a2.2 2.2 0 0 1 2.332 0L8.8 9.034V2.6a.3.3 0 0 0-.3-.3m-5-1.2A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkHierarchicalExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 6.8H14a3.6 3.6 0 0 0-3.6 3.6v30.07l10.21-6.38a6.4 6.4 0 0 1 6.785 0L37.6 40.47V10.4A3.6 3.6 0 0 0 34 6.8M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 6.8H14a3.6 3.6 0 0 0-3.6 3.6v30.07l10.21-6.38a6.4 6.4 0 0 1 6.785 0L37.6 40.47V10.4A3.6 3.6 0 0 0 34 6.8"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBookmarkHierarchicalLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 7.4H14a3 3 0 0 0-3 3v28.988l9.293-5.807a7 7 0 0 1 7.42 0L37 39.387V10.4a3 3 0 0 0-3-3m-20-3a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.529 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696v-30.79a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 7.4H14a3 3 0 0 0-3 3v28.988l9.293-5.807a7 7 0 0 1 7.42 0L37 39.387V10.4a3 3 0 0 0-3-3"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBookmarkHierarchicalRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 8H14a2.4 2.4 0 0 0-2.4 2.4v27.905l8.375-5.233a7.6 7.6 0 0 1 8.056 0l8.369 5.232V10.4A2.4 2.4 0 0 0 34 8M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 8H14a2.4 2.4 0 0 0-2.4 2.4v27.905l8.375-5.233a7.6 7.6 0 0 1 8.056 0l8.369 5.232V10.4A2.4 2.4 0 0 0 34 8"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBookmarkHierarchicalMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 8.667H14c-.957 0-1.733.776-1.733 1.733v26.703l7.355-4.597a8.27 8.27 0 0 1 8.762.001l7.35 4.594V10.4c0-.957-.777-1.733-1.734-1.733M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 8.667H14c-.957 0-1.733.776-1.733 1.733v26.703l7.355-4.597a8.27 8.27 0 0 1 8.762.001l7.35 4.594V10.4c0-.957-.777-1.733-1.734-1.733"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBookmarkHierarchicalSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 8.9H14a1.5 1.5 0 0 0-1.5 1.5v26.28l6.998-4.372a8.5 8.5 0 0 1 9.01 0L35.5 36.68V10.4A1.5 1.5 0 0 0 34 8.9M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 8.9H14a1.5 1.5 0 0 0-1.5 1.5v26.28l6.998-4.372a8.5 8.5 0 0 1 9.01 0L35.5 36.68V10.4A1.5 1.5 0 0 0 34 8.9"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBookmarkHierarchicalBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M34 9.2H14a1.2 1.2 0 0 0-1.2 1.2v25.74l6.54-4.086a8.8 8.8 0 0 1 9.327.001L35.2 36.14V10.4A1.2 1.2 0 0 0 34 9.2M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.529 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696v-30.79a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillOpacity: 0.25,
                d: "M34 9.2H14a1.2 1.2 0 0 0-1.2 1.2v25.74l6.54-4.086a8.8 8.8 0 0 1 9.327.001L35.2 36.14V10.4A1.2 1.2 0 0 0 34 9.2"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconBookmark/IconBookmark.tsx
var IconBookmark = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBookmarkMonochromeExtralight,
          "monochrome|light": IconBookmarkMonochromeLight,
          "monochrome|regular": IconBookmarkMonochromeRegular,
          "monochrome|medium": IconBookmarkMonochromeMedium,
          "monochrome|semibold": IconBookmarkMonochromeSemibold,
          "monochrome|bold": IconBookmarkMonochromeBold,
          "hierarchical|extralight": IconBookmarkHierarchicalExtralight,
          "hierarchical|light": IconBookmarkHierarchicalLight,
          "hierarchical|regular": IconBookmarkHierarchicalRegular,
          "hierarchical|medium": IconBookmarkHierarchicalMedium,
          "hierarchical|semibold": IconBookmarkHierarchicalSemibold,
          "hierarchical|bold": IconBookmarkHierarchicalBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.334 2.933a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.13l7.215-4.508a2.67 2.67 0 0 1 2.826 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.25 1.65A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.667 1.467a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBookmarkFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.5 1.1A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBookmarkFilled/IconBookmarkFilled.tsx
var IconBookmarkFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBookmarkFilledMonochromeExtralight,
          "monochrome|light": IconBookmarkFilledMonochromeLight,
          "monochrome|regular": IconBookmarkFilledMonochromeRegular,
          "monochrome|medium": IconBookmarkFilledMonochromeMedium,
          "monochrome|semibold": IconBookmarkFilledMonochromeSemibold,
          "monochrome|bold": IconBookmarkFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBubbleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m38.066 31.787.417-.826a16.86 16.86 0 0 0 1.804-7.617c0-9.358-7.586-16.944-16.943-16.944S6.4 13.986 6.4 23.344s7.586 16.943 16.944 16.943c2.815 0 5.464-.685 7.795-1.895l.836-.434 8.428 2.32zm-5.82 8.734a19.26 19.26 0 0 1-8.903 2.166C12.66 42.687 4 34.027 4 23.344S12.66 4 23.344 4c10.683 0 19.343 8.66 19.343 19.344 0 3.128-.743 6.083-2.061 8.698l2.302 8.364c.401 1.458-.938 2.797-2.396 2.396z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m24.95 21.149.348-.688a10.84 10.84 0 0 0 1.16-4.899c0-6.017-4.878-10.895-10.896-10.895-6.017 0-10.895 4.878-10.895 10.895 0 6.018 4.878 10.896 10.895 10.896 1.812 0 3.515-.44 5.013-1.219l.696-.361 5.092 1.401zm-3.453 5.865a12.84 12.84 0 0 1-5.935 1.444c-7.122 0-12.895-5.773-12.895-12.896 0-7.122 5.773-12.895 12.895-12.895S28.458 8.44 28.458 15.562c0 2.086-.495 4.056-1.374 5.8l1.535 5.575a1.3 1.3 0 0 1-1.598 1.598z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m18.393 15.83.313-.62a7.8 7.8 0 0 0 .838-3.538 7.872 7.872 0 1 0-7.872 7.872 7.8 7.8 0 0 0 3.621-.88l.627-.326 3.423.942zm-2.27 4.43a9.6 9.6 0 0 1-4.451 1.083C6.33 21.344 2 17.014 2 11.673 2 6.33 6.33 2 11.672 2c5.341 0 9.671 4.33 9.671 9.672a9.6 9.6 0 0 1-1.03 4.349l1.151 4.182a.974.974 0 0 1-1.198 1.198z" })
        }
      );
    }
  )
);
var IconBubbleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m13.528 11.846.278-.55a5.654 5.654 0 1 0-2.451 2.48l.557-.29 2.237.616zm-1.436 3.35a7.254 7.254 0 1 1 3.143-3.18l.863 3.136a.73.73 0 0 1-.899.899z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m11.942 10.521.26-.516a4.948 4.948 0 1 0-2.145 2.17l.523-.27 1.886.519zm-1.193 2.986a6.448 6.448 0 1 1 2.794-2.827l.767 2.789a.65.65 0 0 1-.8.798z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m8.877 7.883.208-.413a3.636 3.636 0 1 0-1.577 1.595l.418-.217 1.316.363zM8.06 10.13a4.836 4.836 0 1 1 2.095-2.12l.576 2.091c.1.365-.235.7-.6.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBubble/IconBubble.tsx
var IconBubble = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBubbleMonochromeExtralight,
          "monochrome|light": IconBubbleMonochromeLight,
          "monochrome|regular": IconBubbleMonochromeRegular,
          "monochrome|medium": IconBubbleMonochromeMedium,
          "monochrome|semibold": IconBubbleMonochromeSemibold,
          "monochrome|bold": IconBubbleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M40.626 32.042a19.26 19.26 0 0 0 2.061-8.699C42.687 12.66 34.027 4 23.344 4S4 12.66 4 23.344c0 10.683 8.66 19.343 19.344 19.343 3.21 0 6.237-.782 8.901-2.166l8.287 2.281c1.458.401 2.797-.938 2.396-2.396z" })
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M27.084 21.361a12.84 12.84 0 0 0 1.374-5.799c0-7.122-5.774-12.895-12.896-12.895S2.667 8.44 2.667 15.562c0 7.123 5.773 12.896 12.895 12.896 2.14 0 4.158-.521 5.935-1.444l5.524 1.52a1.3 1.3 0 0 0 1.598-1.597z" })
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M20.313 16.02a9.6 9.6 0 0 0 1.03-4.348C21.344 6.33 17.014 2 11.673 2 6.33 2 2 6.33 2 11.672c0 5.341 4.33 9.671 9.672 9.671a9.6 9.6 0 0 0 4.45-1.082l4.144 1.14a.974.974 0 0 0 1.198-1.198z" })
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M15.235 12.016a7.254 7.254 0 1 0-3.143 3.18l3.107.855a.73.73 0 0 0 .899-.899z" })
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M13.542 10.68a6.448 6.448 0 1 0-2.793 2.827l2.762.76a.65.65 0 0 0 .798-.798z" })
        }
      );
    }
  )
);
var IconBubbleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.156 8.01a4.836 4.836 0 1 0-2.095 2.12l2.072.57c.364.1.7-.234.599-.598z" })
        }
      );
    }
  )
);

// src/IconBubbleFilled/IconBubbleFilled.tsx
var IconBubbleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBubbleFilledMonochromeExtralight,
          "monochrome|light": IconBubbleFilledMonochromeLight,
          "monochrome|regular": IconBubbleFilledMonochromeRegular,
          "monochrome|medium": IconBubbleFilledMonochromeMedium,
          "monochrome|semibold": IconBubbleFilledMonochromeSemibold,
          "monochrome|bold": IconBubbleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M26.992 193.501C26.992 111.321 97.815 46 183.524 46c70.251 0 130.31 43.75 149.863 104.775 67.889 13.894 119.629 70.816 119.629 139.993 0 23.295-5.907 45.294-16.358 64.718l16.869 62.958c2.452 9.148-5.92 17.516-15.065 15.065l-64.182-17.198c-21.762 11.3-46.748 17.707-73.264 17.707-65.596 0-122.022-39.272-143.158-94.99-11.963-1.86-23.478-5-34.378-9.268l-69.948 18.743h-.001c-9.143 2.449-17.515-5.916-15.063-15.064l15.358-57.321c-16.903-23.523-26.834-51.963-26.834-82.617m123.883 119.727a136 136 0 0 1-1.859-22.46c0-79.833 68.794-143.25 152-143.25q2.804 0 5.585.095C287.161 102.437 239.688 70 183.524 70c-73.936 0-132.532 56.011-132.532 123.501 0 27.123 9.375 52.24 25.384 72.691l3.693 4.717-13.174 49.167 58.243-15.607 3.793 1.601a138 138 0 0 0 21.944 7.158m150.141-141.71c-71.433 0-128 54.107-128 119.25 0 11.723 1.813 23.035 5.188 33.718 15.491 49.038 64.271 85.532 122.812 85.532 24.155 0 46.683-6.225 65.895-16.999l4.258-2.388 53.931 14.451-14.187-52.948 2.536-4.328c9.94-16.963 15.567-36.386 15.567-57.038 0-58.595-45.674-108.184-106.906-117.64a138 138 0 0 0-21.094-1.61",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M23.992 193.501C23.992 109.485 96.343 43 183.524 43c70.843 0 131.657 43.734 152.176 105.196 68.29 14.752 120.316 72.397 120.316 142.572 0 23.39-5.828 45.5-16.154 65.085l16.563 61.814v.001c3.049 11.378-7.364 21.787-18.739 18.739l-63.064-16.898c-21.938 11.186-47.025 17.509-73.606 17.509-66.144 0-123.268-39.23-145.335-95.302a165.6 165.6 0 0 1-35.885-10.203l-70.488 18.888c-11.374 3.047-21.787-7.359-18.738-18.739l16.228-60.566c-14.447-22.617-22.806-49.176-22.806-77.595m123.246 115.711a139.5 139.5 0 0 1-1.222-18.444c0-81.669 70.323-146.25 155-146.25q.441 0 .882.002C281.853 102.724 236.748 73 183.524 73c-72.465 0-129.532 54.847-129.532 120.501 0 24.417 7.796 47.16 21.3 66.215l4.073 5.749-13.228 49.368 56.095-15.031 4.879 2.201a134.6 134.6 0 0 0 20.127 7.209m153.778-134.694c-69.962 0-125 52.944-125 116.25 0 11.412 1.764 22.419 5.048 32.814 15.076 47.722 62.648 83.436 119.952 83.436 23.636 0 45.659-6.091 64.427-16.615l5.324-2.986 50.09 13.422-13.167-49.14 3.17-5.41c9.683-16.522 15.156-35.424 15.156-55.521 0-56.952-44.427-105.419-104.364-114.675a135 135 0 0 0-20.636-1.575",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M20.992 193.501C20.992 107.648 94.872 40 183.524 40c71.441 0 133.01 43.735 154.473 105.633 68.702 15.592 121.019 73.964 121.019 145.135 0 23.48-5.75 45.698-15.954 65.437l16.26 60.686.001.001c3.647 13.609-8.808 26.059-22.414 22.412l-61.956-16.601c-22.109 11.074-47.292 17.315-73.937 17.315-66.699 0-124.519-39.203-147.497-95.628a168.3 168.3 0 0 1-38.656-11.717l-65.778 17.626h-.002c-13.602 3.644-26.058-8.802-22.411-22.413l15.631-58.338c-13.531-22.377-21.31-48.347-21.31-76.047m122.742 111.575a143 143 0 0 1-.718-14.308c0-82.218 69.652-147.218 154.024-149.204C276.552 103.087 233.811 76 183.524 76c-70.993 0-126.532 53.683-126.532 117.501 0 23.079 7.153 44.624 19.618 62.858l4.668 6.828-11.898 44.404 49.013-13.134 6.067 2.982a131 131 0 0 0 19.274 7.637m157.282-127.558c-68.49 0-122 51.78-122 113.25 0 11.1 1.716 21.803 4.909 31.91 14.66 46.407 61.023 81.34 117.091 81.34 23.116 0 44.635-5.956 62.96-16.232l6.388-3.582 46.251 12.393-12.147-45.333 3.804-6.491c9.424-16.082 14.744-34.464 14.744-54.005 0-55.309-43.18-102.654-101.822-111.71a132 132 0 0 0-20.178-1.54",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M17.656 193.5c0-87.894 75.579-156.836 165.867-156.836 72.114 0 134.519 43.753 157.009 106.135 69.172 16.508 121.818 75.692 121.818 147.968 0 23.577-5.665 45.909-15.736 65.813l15.929 59.446v.002c4.311 16.089-10.412 30.807-26.497 26.497l-60.741-16.275c-22.291 10.949-47.578 17.102-74.29 17.102-67.323 0-125.915-39.189-149.882-96.007a172 172 0 0 1-32.84-9.603l-66.346 17.777-.002.001c-16.082 4.307-30.807-10.407-26.495-26.498l15.025-56.077c-14.46-23.243-22.819-50.408-22.819-79.445m122.337 106.835a147 147 0 0 1-.313-9.568c0-82.421 68.274-147.662 151.772-152.319-20.786-34.865-60.904-59.114-107.929-59.114-69.357 0-123.197 52.39-123.197 114.166 0 23.301 7.518 45.009 20.581 63.18l5.902 8.21-10.714 39.983 45.755-12.26 6.999 3.22a127 127 0 0 0 11.144 4.502m161.022-119.483c-66.854 0-118.665 50.486-118.665 109.915 0 10.754 1.662 21.118 4.754 30.906 14.198 44.944 59.217 79.009 113.911 79.009 22.539 0 43.497-5.806 61.329-15.806l7.572-4.246 41.981 11.249-11.012-41.099 4.509-7.694c9.137-15.593 14.286-33.395 14.286-52.319 0-53.482-41.794-99.581-98.996-108.414a129 129 0 0 0-19.669-1.501",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M16.492 193.501c0-88.607 76.172-158.001 167.032-158.001 72.352 0 135.048 43.763 157.891 106.314 69.339 16.824 122.101 76.292 122.101 148.954 0 23.609-5.636 45.98-15.66 65.941l15.813 59.017v.001c4.544 16.956-10.973 32.467-27.925 27.924l-60.318-16.162c-22.353 10.907-47.675 17.029-74.41 17.029-67.543 0-126.404-39.187-150.711-96.143a173 173 0 0 1-35.128-10.663L48.25 355.645l-.002.001c-16.948 4.539-32.466-10.967-27.923-27.925l15.957-59.55c-12.597-22.194-19.79-47.632-19.79-74.67m122.234 105.144q-.21-3.915-.21-7.877c0-82.469 67.77-147.782 150.938-153.363-20.841-33.623-60.043-56.905-105.93-56.905-68.786 0-122.032 51.938-122.032 113.001 0 21.489 6.463 41.595 17.802 58.783l5.57 8.443-11.12 41.5 45.673-12.239 7.548 3.666a126 126 0 0 0 11.761 4.991m162.29-116.627c-66.283 0-117.5 50.034-117.5 108.75a101.2 101.2 0 0 0 4.7 30.555c14.036 44.433 58.586 78.195 112.8 78.195 22.337 0 43.099-5.754 60.759-15.657l7.985-4.478 40.491 10.85-10.617-39.621 4.756-8.115c9.036-15.421 14.126-33.021 14.126-51.729 0-52.844-41.31-98.507-98.009-107.263a127.6 127.6 0 0 0-19.491-1.487",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M14.992 193.501C14.992 103.976 91.93 34 183.524 34c72.658 0 135.73 43.778 159.023 106.547 69.556 17.228 122.469 77.063 122.469 150.221 0 23.65-5.599 46.07-15.564 66.102l15.666 58.467v.002c4.843 18.071-11.695 34.602-29.761 29.761l-59.778-16.017c-22.432 10.851-47.798 16.935-74.563 16.935-67.827 0-127.034-39.188-151.776-96.321a174.4 174.4 0 0 1-34.843-10.687l-63.76 17.084-.001.001c-18.063 4.838-34.602-11.689-29.76-29.762v-.001l14.978-55.896c-13.26-22.763-20.862-49-20.862-76.935M137.124 296.44a149 149 0 0 1-.108-5.672c0-82.513 67.105-147.91 149.827-154.673C265.968 104.055 227.945 82 183.524 82c-68.05 0-120.532 51.356-120.532 111.501 0 21.81 6.753 42.184 18.571 59.472l6.224 9.104-9.922 37.028 41.152-11.027 8.089 3.976a125 125 0 0 0 10.018 4.386m163.892-112.922c-65.547 0-116 49.453-116 107.25a99.7 99.7 0 0 0 4.63 30.103c13.829 43.775 57.774 77.147 111.37 77.147 22.078 0 42.588-5.687 60.025-15.465l8.518-4.777 38.57 10.335-10.106-37.716 5.072-8.656c8.908-15.201 13.921-32.54 13.921-50.971 0-52.022-40.687-97.125-96.737-105.78a126 126 0 0 0-19.263-1.47",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBubbleLeftBubbleRight/IconBubbleLeftBubbleRight.tsx
var IconBubbleLeftBubbleRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBubbleLeftBubbleRightMonochromeExtralight,
          "monochrome|light": IconBubbleLeftBubbleRightMonochromeLight,
          "monochrome|regular": IconBubbleLeftBubbleRightMonochromeRegular,
          "monochrome|medium": IconBubbleLeftBubbleRightMonochromeMedium,
          "monochrome|semibold": IconBubbleLeftBubbleRightMonochromeSemibold,
          "monochrome|bold": IconBubbleLeftBubbleRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M28.992 194.501C28.992 112.321 99.815 47 185.524 47c57.507 0 108.312 29.406 135.52 73.58a189 189 0 0 0-20.021-1.062c-96.897 0-180 74.238-180 171.25 0 13.963 1.722 27.455 4.959 40.322l-72.45 19.413h-.001c-9.143 2.449-17.515-5.916-15.063-15.065l16.102-60.096c-16.139-23.174-25.578-50.957-25.578-80.841"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M149.023 290.768c0-79.833 68.794-143.25 152-143.25s152 63.417 152 143.25c0 23.295-5.908 45.294-16.359 64.718l16.869 62.958c2.452 9.148-5.919 17.516-15.064 15.065l-64.183-17.198c-21.762 11.3-46.748 17.707-73.263 17.707-83.206 0-152-63.418-152-143.25",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M183.524 43c-87.18 0-159.532 66.485-159.532 150.501 0 28.543 8.432 55.209 22.995 77.89L30.57 332.662c-3.05 11.379 7.364 21.786 18.737 18.739h.002l71.773-19.232c-3.307-13.207-5.066-27.058-5.066-41.401 0-100.085 85.664-176.25 185-176.25 6.389 0 12.721.315 18.978.931C291.863 71.803 240.906 43 183.524 43"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M146.024 290.768c0-81.669 70.323-146.25 155-146.25s155 64.581 155 146.25c0 23.39-5.828 45.501-16.154 65.085l16.563 61.814v.001c3.049 11.378-7.364 21.787-18.739 18.739l-63.064-16.898c-21.938 11.186-47.025 17.509-73.606 17.509-84.677 0-155-64.582-155-146.25"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M183.524 40C94.872 40 20.992 107.648 20.992 193.501c0 27.351 7.586 53.018 20.805 75.203l-16.125 60.182c-3.647 13.611 8.808 26.057 22.411 22.413h.002l67.091-17.978c-3.368-13.572-5.16-27.807-5.16-42.553 0-103.773 88.737-182.25 191-182.25 6.233 0 12.415.291 18.53.862C290.321 67.368 239.911 40 183.524 40"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M301.025 141.516c-86.149 0-158 65.744-158 149.25 0 83.505 71.851 149.25 158 149.25 26.645 0 51.828-6.241 73.937-17.315l61.956 16.601c13.606 3.647 26.061-8.803 22.414-22.412v-.001l-16.261-60.686c10.204-19.739 15.954-41.957 15.954-65.437 0-83.506-71.851-149.25-158-149.25"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M319.839 104.05a204 204 0 0 0-18.824-.868c-104.862 0-196.335 80.531-196.335 187.585 0 16.684 2.222 32.724 6.37 47.915l-59.103 15.837-.002.001c-16.082 4.307-30.807-10.408-26.495-26.499l14.838-55.377c-14.346-23.177-22.632-50.233-22.632-79.144 0-87.894 75.579-156.836 165.867-156.836 55.886 0 106.136 26.414 136.316 67.386",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M301.027 138.182c-87.785 0-161.335 67.038-161.335 152.585 0 85.546 73.55 152.585 161.335 152.585 26.712 0 51.998-6.153 74.29-17.102l60.74 16.275c16.085 4.31 30.809-10.408 26.498-26.497l-.001-.002-15.928-59.446c10.07-19.904 15.736-42.236 15.736-65.813 0-85.547-73.55-152.585-161.335-152.585",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M183.524 35.5c-90.86 0-167.032 69.394-167.032 158.001 0 27.524 7.454 53.388 20.471 75.859l-15.638 58.361c-4.543 16.958 10.975 32.464 27.923 27.925l.002-.001 57.873-15.507c-4.301-15.639-6.607-32.166-6.607-49.37 0-109.615 93.607-191.75 200.5-191.75 5.707 0 11.376.234 16.994.694C287.356 60.527 238.088 35.5 183.524 35.5"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M138.516 290.768c0-86.26 74.144-153.75 162.5-153.75 88.357 0 162.5 67.49 162.5 153.75 0 23.609-5.636 45.98-15.66 65.941l15.813 59.017.001.001c4.543 16.956-10.974 32.467-27.925 27.924l-60.318-16.162c-22.354 10.907-47.675 17.029-74.411 17.029-88.356 0-162.5-67.491-162.5-153.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconBubbleLeftBubbleRightFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M183.524 34C91.929 34 14.992 103.976 14.992 193.501c0 27.58 7.41 53.507 20.361 76.07l-15.477 57.762c-4.842 18.073 11.697 34.6 29.76 29.762l.002-.001 52.566-14.085c-4.675-16.509-7.188-34.001-7.188-52.241 0-112.998 96.426-197.25 206-197.25q7.182 0 14.278.477C284.163 57.21 236.275 34 183.524 34"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M137.017 290.768c0-87.178 74.908-155.25 164-155.25s164 68.072 164 155.25c0 23.65-5.6 46.07-15.565 66.102l15.666 58.467.001.002c4.842 18.071-11.695 34.602-29.762 29.761l-59.778-16.017c-22.432 10.851-47.798 16.935-74.562 16.935-89.092 0-164-68.073-164-155.25",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconBubbleLeftBubbleRightFilled/IconBubbleLeftBubbleRightFilled.tsx
var IconBubbleLeftBubbleRightFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBubbleLeftBubbleRightFilledMonochromeExtralight,
          "monochrome|light": IconBubbleLeftBubbleRightFilledMonochromeLight,
          "monochrome|regular": IconBubbleLeftBubbleRightFilledMonochromeRegular,
          "monochrome|medium": IconBubbleLeftBubbleRightFilledMonochromeMedium,
          "monochrome|semibold": IconBubbleLeftBubbleRightFilledMonochromeSemibold,
          "monochrome|bold": IconBubbleLeftBubbleRightFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBullhornMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M33.23 6.354C37.974 4.378 43.2 7.862 43.2 13v18c0 5.138-5.227 8.622-9.97 6.646l-6.03-2.513V38a3.2 3.2 0 0 1-3.2 3.2h-4a3.2 3.2 0 0 1-3.2-3.2v-6.8H6A1.2 1.2 0 0 1 4.8 30V14A1.2 1.2 0 0 1 6 12.8h11.76zM16.8 15.2H7.2v13.6h9.6zm2.4 16.6 5.6 2.333V38a.8.8 0 0 1-.8.8h-4a.8.8 0 0 1-.8-.8zm0-2.6V14.8l14.954-6.23C37.316 7.251 40.8 9.574 40.8 13v18c0 3.425-3.484 5.748-6.646 4.43z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBullhornMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M22.077 4.051C25.37 2.68 29 5.1 29 8.667v12c0 3.568-3.63 5.987-6.923 4.615l-3.744-1.56v1.611A2.333 2.333 0 0 1 16 27.668h-2.667A2.333 2.333 0 0 1 11 25.333V21H4a1 1 0 0 1-1-1V9.333a1 1 0 0 1 1-1h7.8zM11 10.334H5V19h6zM13 21.5l3.333 1.389v2.445c0 .184-.149.333-.333.333h-2.667a.333.333 0 0 1-.333-.334zm0-2.166V10l9.846-4.102C24.822 5.074 27 6.526 27 8.667v12c0 2.14-2.178 3.592-4.154 2.769z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBullhornMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.5 2.9c2.569-1.07 5.4.817 5.4 3.6v9c0 2.783-2.831 4.67-5.4 3.6l-2.6-1.083V19a1.9 1.9 0 0 1-1.9 1.9h-2A1.9 1.9 0 0 1 8.1 19v-3.1H3a.9.9 0 0 1-.9-.9V7a.9.9 0 0 1 .9-.9h5.82zm-8.4 5H3.9v6.2h4.2zm1.8 8.45 2.2.917V19a.1.1 0 0 1-.1.1h-2a.1.1 0 0 1-.1-.1zm0-1.95V7.6l7.292-3.038A2.1 2.1 0 0 1 20.1 6.5v9a2.1 2.1 0 0 1-2.908 1.939z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBullhornMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.077 2.06c2.009-.838 4.223.639 4.223 2.815v6.75c0 2.176-2.214 3.652-4.223 2.815L10.3 13.7v.55a1.55 1.55 0 0 1-1.55 1.55h-1.5a1.55 1.55 0 0 1-1.55-1.55v-2.2H2a.8.8 0 0 1-.8-.8v-6a.8.8 0 0 1 .8-.8h4.34zM5.7 6.05H2.8v4.4h2.9zm1.6 6.4 1.4.583V14.2H7.3zm0-1.733V5.783l5.392-2.247A1.45 1.45 0 0 1 14.7 4.875v6.75a1.45 1.45 0 0 1-2.008 1.338z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBullhornMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.942 1.795c1.812-.755 3.808.576 3.808 2.538v6c0 1.963-1.996 3.294-3.808 2.539l-1.525-.636v.43c0 .783-.635 1.417-1.417 1.417H6.667a1.417 1.417 0 0 1-1.417-1.416V10.75H2a.75.75 0 0 1-.75-.75V4.667a.75.75 0 0 1 .75-.75h3.85zM5.25 5.417h-2.5V9.25h2.5zm1.5 5.708 1.167.486v.972H6.75zm0-1.625V5.167l4.77-1.987a1.25 1.25 0 0 1 1.73 1.153v6a1.25 1.25 0 0 1-1.73 1.154z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconBullhornMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.192 1.312A2.1 2.1 0 0 1 11.1 3.25v4.5A2.1 2.1 0 0 1 8.192 9.69L7.1 9.233V9.5A1.1 1.1 0 0 1 6 10.6H5a1.1 1.1 0 0 1-1.1-1.1V8.1H1.5a.6.6 0 0 1-.6-.6v-4a.6.6 0 0 1 .6-.6h2.88zM3.9 4.1H2.1v2.8h1.8zm1.2 4.3.8.333V9.4h-.8zm0-1.3V3.9l3.554-1.48a.9.9 0 0 1 1.246.83v4.5a.9.9 0 0 1-1.246.83z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconBullhorn/IconBullhorn.tsx
var IconBullhorn = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBullhornMonochromeExtralight,
          "monochrome|light": IconBullhornMonochromeLight,
          "monochrome|regular": IconBullhornMonochromeRegular,
          "monochrome|medium": IconBullhornMonochromeMedium,
          "monochrome|semibold": IconBullhornMonochromeSemibold,
          "monochrome|bold": IconBullhornMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.2 14.5A1.8 1.8 0 0 1 6 12.7h9.137v18.25H6a1.8 1.8 0 0 1-1.8-1.8zM35.67 5.146c3.82-1.593 8.032 1.216 8.03 5.356-.003 7.406-.005 15.213.003 22.635.005 4.144-4.21 6.961-8.036 5.368l-18.13-7.55V12.7h.003zM17.537 33.455V38.6a3.2 3.2 0 0 0 3.2 3.2h3.6a3.2 3.2 0 0 0 3.2-3.2v-.98z" })
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.8 9.666a1.2 1.2 0 0 1 1.2-1.2h5.69v11.768H4a1.2 1.2 0 0 1-1.2-1.2zM23.78 3.43c2.547-1.061 5.355.811 5.353 3.571-.002 4.794-.003 9.84.002 14.658.002 2.762-2.807 4.64-5.357 3.578L11.69 20.204V8.466h.002zM11.69 22.237v3.496c0 1.178.956 2.133 2.134 2.133h2.4a2.133 2.133 0 0 0 2.133-2.133v-.72z" })
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M17.835 2.573c1.91-.796 4.017.608 4.016 2.678-.002 3.487-.003 7.153 0 10.668.002 2.072-2.105 3.48-4.017 2.683l-9.065-3.774V6.35h.002q4.532-1.89 9.064-3.777M8.769 16.578V19.3a1.6 1.6 0 0 0 1.6 1.6h1.8a1.6 1.6 0 0 0 1.6-1.6v-.64zM6.969 6.35H3a.9.9 0 0 0-.9.9v6.725a.9.9 0 0 0 .9.9h3.968z" })
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M13.376 1.93a2.175 2.175 0 0 1 3.012 2.008 6039 6039 0 0 0 0 7.73 2.177 2.177 0 0 1-3.013 2.013L6.576 10.85V4.762h.002zM6.576 12.358v2.117a1.2 1.2 0 0 0 1.2 1.2h1.35a1.2 1.2 0 0 0 1.2-1.2v-.556zM4.976 4.762H2.25a.675.675 0 0 0-.675.675v4.794c0 .373.302.675.675.675h2.726z" })
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.89 1.715a1.933 1.933 0 0 1 2.677 1.786v6.787a1.935 1.935 0 0 1-2.678 1.789L5.846 9.56V4.233h.001zM5.846 10.919v1.948c0 .589.477 1.066 1.066 1.066h1.2c.59 0 1.067-.477 1.067-1.066v-.56zM4.346 4.233H2a.6.6 0 0 0-.6.6v4.184a.6.6 0 0 0 .6.6h2.346z" })
        }
      );
    }
  )
);
var IconBullhornFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.184 3.174H1.5a.45.45 0 0 0-.45.45v3.063c0 .249.201.45.45.45h1.684zM8.917 1.286a1.45 1.45 0 0 1 2.008 1.339v5.01a1.45 1.45 0 0 1-2.009 1.34L4.384 7.09V3.173zM4.384 8.138V9.65a.8.8 0 0 0 .8.8h.9a.8.8 0 0 0 .8-.8v-.47z" })
        }
      );
    }
  )
);

// src/IconBullhornFilled/IconBullhornFilled.tsx
var IconBullhornFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconBullhornFilledMonochromeExtralight,
          "monochrome|light": IconBullhornFilledMonochromeLight,
          "monochrome|regular": IconBullhornFilledMonochromeRegular,
          "monochrome|medium": IconBullhornFilledMonochromeMedium,
          "monochrome|semibold": IconBullhornFilledMonochromeSemibold,
          "monochrome|bold": IconBullhornFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#2F3438",
              fillRule: "evenodd",
              d: "M31.857 17.899a1.2 1.2 0 0 1-1.697.017 8.5 8.5 0 0 0-5.964-2.436 8.52 8.52 0 0 0 0 17.04 8.5 8.5 0 0 0 5.964-2.436 1.2 1.2 0 1 1 1.68 1.714 10.9 10.9 0 0 1-7.644 3.122c-6.03 0-10.92-4.89-10.92-10.92s4.89-10.92 10.92-10.92c2.976 0 5.676 1.192 7.644 3.122a1.2 1.2 0 0 1 .017 1.697M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21.38 12.072a1 1 0 0 1-1.414.014 5.48 5.48 0 1 0 0 7.827 1 1 0 0 1 1.4 1.428 7.48 7.48 0 1 1 0-10.683 1 1 0 0 1 .015 1.414M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.112 9.13a.857.857 0 0 1-1.212.011 4.003 4.003 0 1 0 0 5.717.857.857 0 0 1 1.2 1.225 5.717 5.717 0 1 1 0-8.166.857.857 0 0 1 .012 1.212M12 20.285a8.286 8.286 0 1 0 0-16.572 8.286 8.286 0 0 0 0 16.572M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.196 6.957a.8.8 0 0 1-1.131.011 2.845 2.845 0 1 0 0 4.063.8.8 0 0 1 1.12 1.143 4.445 4.445 0 1 1 0-6.349.8.8 0 0 1 .011 1.132M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.87 6.211a.75.75 0 0 1-1.062.01 2.49 2.49 0 1 0 0 3.556.75.75 0 0 1 1.05 1.072 3.99 3.99 0 1 1 0-5.699c.296.29.301.766.011 1.061M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.178 4.685a.6.6 0 0 1-.848.008 1.83 1.83 0 1 0 0 2.614.6.6 0 1 1 .84.857 3.03 3.03 0 1 1 0-4.328.6.6 0 0 1 .008.849M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCCircle/IconCCircle.tsx
var IconCCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCCircleMonochromeExtralight,
          "monochrome|light": IconCCircleMonochromeLight,
          "monochrome|regular": IconCCircleMonochromeRegular,
          "monochrome|medium": IconCCircleMonochromeMedium,
          "monochrome|semibold": IconCCircleMonochromeSemibold,
          "monochrome|bold": IconCCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.324-20a8.52 8.52 0 0 1 8.52-8.52c2.322 0 4.426.928 5.964 2.436a1.2 1.2 0 1 0 1.68-1.714 10.9 10.9 0 0 0-7.644-3.122c-6.03 0-10.92 4.89-10.92 10.92s4.89 10.92 10.92 10.92c2.976 0 5.676-1.192 7.644-3.122a1.2 1.2 0 1 0-1.68-1.713 8.5 8.5 0 0 1-5.964 2.435 8.52 8.52 0 0 1-8.52-8.52",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.333 29.667c7.364 0 13.334-5.97 13.334-13.334S23.697 3 16.333 3 3 8.97 3 16.333s5.97 13.334 13.333 13.334m-5.349-13.334A5.48 5.48 0 0 1 20.3 12.42a1 1 0 1 0 1.4-1.428 7.48 7.48 0 1 0 0 10.683 1 1 0 1 0-1.4-1.428 5.48 5.48 0 0 1-9.316-3.913",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.138 12a3.96 3.96 0 0 1 6.732-2.828.9.9 0 0 0 1.26-1.285 5.76 5.76 0 1 0 0 8.227.9.9 0 1 0-1.26-1.286A3.96 3.96 0 0 1 8.138 12",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M6.229 9a2.845 2.845 0 0 1 4.836-2.032.8.8 0 0 0 1.12-1.142 4.445 4.445 0 1 0 0 6.349.8.8 0 1 0-1.12-1.143A2.845 2.845 0 0 1 6.229 9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M5.575 8A2.49 2.49 0 0 1 9.808 6.22a.75.75 0 1 0 1.05-1.07 3.99 3.99 0 1 0 0 5.699.75.75 0 0 0-1.05-1.072A2.49 2.49 0 0 1 5.575 8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.219 6A1.83 1.83 0 0 1 7.33 4.693a.6.6 0 0 0 .84-.857 3.03 3.03 0 1 0 0 4.328.6.6 0 0 0-.84-.857A1.83 1.83 0 0 1 4.22 6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCCircleFilled/IconCCircleFilled.tsx
var IconCCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCCircleFilledMonochromeExtralight,
          "monochrome|light": IconCCircleFilledMonochromeLight,
          "monochrome|regular": IconCCircleFilledMonochromeRegular,
          "monochrome|medium": IconCCircleFilledMonochromeMedium,
          "monochrome|semibold": IconCCircleFilledMonochromeSemibold,
          "monochrome|bold": IconCCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCalculatorMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M35 5.4H13A3.6 3.6 0 0 0 9.4 9v29.556a3.6 3.6 0 0 0 3.6 3.6h22a3.6 3.6 0 0 0 3.6-3.6V9A3.6 3.6 0 0 0 35 5.4M13 3a6 6 0 0 0-6 6v29.556a6 6 0 0 0 6 6h22a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.028 12.606a1.2 1.2 0 0 1 1.2-1.2h15.544a1.2 1.2 0 1 1 0 2.4H16.228a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M19.278 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0" })
          ]
        }
      );
    }
  )
);
var IconCalculatorMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 3.734H8a1.6 1.6 0 0 0-1.6 1.6v21.333a1.6 1.6 0 0 0 1.6 1.6h16a1.6 1.6 0 0 0 1.6-1.6V5.334a1.6 1.6 0 0 0-1.6-1.6m-16-2.4a4 4 0 0 0-4 4v21.333a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V5.334a4 4 0 0 0-4-4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.667 8.467a1.2 1.2 0 0 1 1.2-1.2h10.266a1.2 1.2 0 1 1 0 2.4H10.867a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M12.667 14A1.333 1.333 0 1 1 10 14a1.333 1.333 0 0 1 2.667 0M17.333 14a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 14a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 22 14M12.667 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 18.667a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M12.667 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 23.334a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0" })
          ]
        }
      );
    }
  )
);
var IconCalculatorMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18 2.8H6A1.2 1.2 0 0 0 4.8 4v16A1.2 1.2 0 0 0 6 21.2h12a1.2 1.2 0 0 0 1.2-1.2V4A1.2 1.2 0 0 0 18 2.8M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.25 6.35a.9.9 0 0 1 .9-.9h7.7a.9.9 0 1 1 0 1.8h-7.7a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M9.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
          ]
        }
      );
    }
  )
);
var IconCalculatorMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.53 2.8h-7a1.4 1.4 0 0 0-1.4 1.4v9.89a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4V4.2a1.4 1.4 0 0 0-1.4-1.4m-7-1.6a3 3 0 0 0-3 3v9.89a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4.2a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.78 5.546a.8.8 0 0 1 .8-.8h4.9a.8.8 0 0 1 0 1.6h-4.9a.8.8 0 0 1-.8-.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M8.36 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M8.36 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0" })
          ]
        }
      );
    }
  )
);
var IconCalculatorMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11 2.5H5A1.5 1.5 0 0 0 3.5 4v8.667a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 11 2.5M5 1a3 3 0 0 0-3 3v8.667a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5 5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 5",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M7.4 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.4 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
          ]
        }
      );
    }
  )
);
var IconCalculatorMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.318 2.2h-4.5a.8.8 0 0 0-.8.8v6a.8.8 0 0 0 .8.8h4.5a.8.8 0 0 0 .8-.8V3a.8.8 0 0 0-.8-.8M3.818 1a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4.5a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.1 3.9a.6.6 0 0 1 .6-.6h2.74a.6.6 0 0 1 0 1.2H4.7a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M5.72 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.92 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" })
          ]
        }
      );
    }
  )
);

// src/IconCalculator/IconCalculator.tsx
var IconCalculator = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCalculatorMonochromeExtralight,
          "monochrome|light": IconCalculatorMonochromeLight,
          "monochrome|regular": IconCalculatorMonochromeRegular,
          "monochrome|medium": IconCalculatorMonochromeMedium,
          "monochrome|semibold": IconCalculatorMonochromeSemibold,
          "monochrome|bold": IconCalculatorMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCalendarMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 3.8A1.2 1.2 0 0 1 17.2 5v1h13.6V5a1.2 1.2 0 0 1 2.4 0v1H36a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h2.8V5A1.2 1.2 0 0 1 16 3.8m14.8 4.6V11a1.2 1.2 0 0 0 2.4 0V8.4H36a3.6 3.6 0 0 1 3.6 3.6v2.8H8.4V12A3.6 3.6 0 0 1 12 8.4h2.8V11a1.2 1.2 0 0 0 2.4 0V8.4zM8.4 17.2V36a3.6 3.6 0 0 0 3.6 3.6h24a3.6 3.6 0 0 0 3.6-3.6V17.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.667 2.333a1 1 0 0 1 1 1V4h8.666v-.667a1 1 0 1 1 2 0V4H24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h1.667v-.667a1 1 0 0 1 1-1M20.333 6v1.333a1 1 0 1 0 2 0V6H24a2 2 0 0 1 2 2v1.666H6V8a2 2 0 0 1 2-2h1.667v1.333a1 1 0 1 0 2 0V6zM6 11.666V24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V11.667z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 1.6a.9.9 0 0 1 .9.9V3h6.2v-.5a.9.9 0 1 1 1.8 0V3H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.1v-.5a.9.9 0 0 1 .9-.9m7.1 3.2v.7a.9.9 0 1 0 1.8 0v-.7H18A1.2 1.2 0 0 1 19.2 6v1.1H4.8V6A1.2 1.2 0 0 1 6 4.8h1.1v.7a.9.9 0 0 0 1.8 0v-.7zM4.8 8.9V18A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V8.9z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 1.125a.75.75 0 0 1 .75.75v.375h4.5v-.375a.75.75 0 0 1 1.5 0v.375h.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 2.25h.75v-.375a.75.75 0 0 1 .75-.75m5.25 2.625v.375a.75.75 0 0 0 1.5 0V3.75h.75a.75.75 0 0 1 .75.75v.75H3.75V4.5a.75.75 0 0 1 .75-.75h.75v.375a.75.75 0 0 0 1.5 0V3.75zm-7.5 3v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6.75z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.333.967a.7.7 0 0 1 .7.7V2h3.934v-.333a.7.7 0 1 1 1.4 0V2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.633v-.333a.7.7 0 0 1 .7-.7M9.967 3.4v.267a.7.7 0 1 0 1.4 0V3.4H12a.6.6 0 0 1 .6.6v.633H3.4V4a.6.6 0 0 1 .6-.6h.633v.267a.7.7 0 1 0 1.4 0V3.4zM3.4 6.033V12a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6V6.033z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 .65a.6.6 0 0 1 .6.6v.25h2.8v-.25a.6.6 0 0 1 1.2 0v.25H9A1.5 1.5 0 0 1 10.5 3v6A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h.4v-.25a.6.6 0 0 1 .6-.6M7.4 2.7v.05a.6.6 0 0 0 1.2 0V2.7H9a.3.3 0 0 1 .3.3v.4H2.7V3a.3.3 0 0 1 .3-.3h.4v.05a.6.6 0 0 0 1.2 0V2.7zM2.7 4.6V9a.3.3 0 0 0 .3.3h6a.3.3 0 0 0 .3-.3V4.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCalendar/IconCalendar.tsx
var IconCalendar = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCalendarMonochromeExtralight,
          "monochrome|light": IconCalendarMonochromeLight,
          "monochrome|regular": IconCalendarMonochromeRegular,
          "monochrome|medium": IconCalendarMonochromeMedium,
          "monochrome|semibold": IconCalendarMonochromeSemibold,
          "monochrome|bold": IconCalendarMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 3.8A1.2 1.2 0 0 1 17.2 5v1h13.6V5a1.2 1.2 0 0 1 2.4 0v1H36a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h2.8V5A1.2 1.2 0 0 1 16 3.8M8.4 17.2V36a3.6 3.6 0 0 0 3.6 3.6h24a3.6 3.6 0 0 0 3.6-3.6V17.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.667 2.333a1 1 0 0 1 1 1V4h8.666v-.667a1 1 0 1 1 2 0V4H24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h1.667v-.667a1 1 0 0 1 1-1M6 11.666V24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V11.667z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 1.6a.9.9 0 0 1 .9.9V3h6.2v-.5a.9.9 0 1 1 1.8 0V3H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.1v-.5a.9.9 0 0 1 .9-.9M4.8 8.9V18A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V8.9z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 1.125a.75.75 0 0 1 .75.75v.375h4.5v-.375a.75.75 0 0 1 1.5 0v.375h.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 2.25h.75v-.375a.75.75 0 0 1 .75-.75M3.75 6.75v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6.75z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.333.967a.7.7 0 0 1 .7.7V2h3.934v-.333a.7.7 0 1 1 1.4 0V2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.633v-.333a.7.7 0 0 1 .7-.7M3.4 6.033V12a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6V6.033z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCalendarFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 .65a.6.6 0 0 1 .6.6v.25h2.8v-.25a.6.6 0 0 1 1.2 0v.25H9A1.5 1.5 0 0 1 10.5 3v6A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h.4v-.25a.6.6 0 0 1 .6-.6M2.7 4.6V9a.3.3 0 0 0 .3.3h6a.3.3 0 0 0 .3-.3V4.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCalendarFilled/IconCalendarFilled.tsx
var IconCalendarFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCalendarFilledMonochromeExtralight,
          "monochrome|light": IconCalendarFilledMonochromeLight,
          "monochrome|regular": IconCalendarFilledMonochromeRegular,
          "monochrome|medium": IconCalendarFilledMonochromeMedium,
          "monochrome|semibold": IconCalendarFilledMonochromeSemibold,
          "monochrome|bold": IconCalendarFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCameraMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19.21 10a.81.81 0 0 0-.717.43l-2.062 3.916a1.22 1.22 0 0 1-1.077.646H9.49c-1.564 0-2.831 1.253-2.831 2.8V35.2c0 1.546 1.267 2.8 2.83 2.8H38.51c1.564 0 2.832-1.254 2.832-2.8V17.792c0-1.547-1.268-2.8-2.832-2.8h-5.966c-.445 0-.855-.242-1.067-.63L29.32 10.42A.81.81 0 0 0 28.61 10zm-2.87-.678A3.24 3.24 0 0 1 19.21 7.6h9.399c1.188 0 2.28.644 2.846 1.678l1.813 3.314h5.242c2.904 0 5.258 2.328 5.258 5.2V35.2c0 2.872-2.354 5.2-5.258 5.2H9.49c-2.904 0-5.258-2.328-5.258-5.2V17.792c0-2.872 2.354-5.2 5.258-5.2h5.128z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M23.95 31.1c3.127 0 5.662-2.507 5.662-5.6s-2.535-5.6-5.662-5.6c-3.128 0-5.663 2.507-5.663 5.6s2.535 5.6 5.663 5.6m0 2.4c4.467 0 8.089-3.582 8.089-8s-3.622-8-8.09-8c-4.467 0-8.089 3.582-8.089 8s3.622 8 8.09 8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCameraMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.807 6.867c-.126 0-.241.069-.3.179l-1.374 2.61c-.174.331-.52.538-.897.538h-3.91c-.93 0-1.685.747-1.685 1.667v11.606c0 .92.755 1.666 1.686 1.666h19.347c.93 0 1.685-.746 1.685-1.666V11.86c0-.92-.755-1.667-1.686-1.667h-3.977c-.371 0-.713-.2-.89-.524L19.37 7.041a.34.34 0 0 0-.296-.174zm-2.093-.745a2.36 2.36 0 0 1 2.093-1.255h6.266c.866 0 1.663.47 2.075 1.223l1.15 2.104h3.376c2.047 0 3.707 1.642 3.707 3.667v11.606c0 2.025-1.66 3.666-3.707 3.666H6.326c-2.048 0-3.708-1.641-3.708-3.666V11.86c0-2.025 1.66-3.667 3.708-3.667h3.296z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.966 20.333c1.862 0 3.371-1.492 3.371-3.333 0-1.84-1.51-3.333-3.37-3.333-1.862 0-3.371 1.492-3.371 3.333s1.509 3.333 3.37 3.333m0 2c2.979 0 5.393-2.387 5.393-5.333 0-2.945-2.414-5.333-5.393-5.333S10.574 14.055 10.574 17s2.414 5.333 5.392 5.333",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCameraMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.605 5.3a.1.1 0 0 0-.09.054l-1.03 1.958a.91.91 0 0 1-.808.484H4.745c-.614 0-1.112.492-1.112 1.1V17.6c0 .607.498 1.1 1.112 1.1h14.51c.614 0 1.112-.492 1.112-1.1V8.896c0-.608-.498-1.1-1.112-1.1h-2.983a.91.91 0 0 1-.8-.472l-1.079-1.972a.1.1 0 0 0-.089-.052zm-1.704-.778A1.92 1.92 0 0 1 9.605 3.5h4.7c.705 0 1.354.382 1.69.996l.82 1.5h2.44c1.62 0 2.933 1.298 2.933 2.9V17.6c0 1.602-1.313 2.9-2.933 2.9H4.745c-1.62 0-2.932-1.298-2.932-2.9V8.896c0-1.602 1.312-2.9 2.932-2.9h2.38z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.975 14.95c1.228 0 2.224-.985 2.224-2.2s-.996-2.2-2.224-2.2-2.225.985-2.225 2.2.996 2.2 2.225 2.2m0 1.8c2.234 0 4.045-1.79 4.045-4s-1.811-4-4.045-4-4.045 1.79-4.045 4 1.811 4 4.045 4",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCameraMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m7.234 4.1-.759 1.441a.81.81 0 0 1-.717.43h-2.2a.704.704 0 0 0-.707.7V13.2c0 .387.317.7.708.7H14.44c.391 0 .708-.313.708-.7V6.672c0-.387-.317-.7-.708-.7h-2.237a.81.81 0 0 1-.712-.42L10.699 4.1zm-1.42-.766a1.57 1.57 0 0 1 1.39-.834h3.524a1.57 1.57 0 0 1 1.379.813l.58 1.059h1.754c1.285 0 2.326 1.03 2.326 2.3V13.2c0 1.27-1.041 2.3-2.326 2.3H3.56c-1.285 0-2.326-1.03-2.326-2.3V6.672c0-1.27 1.041-2.3 2.326-2.3h1.708z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.981 10.963c.782 0 1.416-.627 1.416-1.4 0-.774-.634-1.4-1.416-1.4s-1.416.626-1.416 1.4.634 1.4 1.416 1.4m0 1.6c1.675 0 3.034-1.344 3.034-3 0-1.657-1.359-3-3.034-3s-3.033 1.343-3.033 3c0 1.656 1.358 3 3.033 3",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCameraMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m6.485 3.733-.65 1.234a.81.81 0 0 1-.717.43H3.163a.536.536 0 0 0-.539.534v5.802c0 .295.241.534.54.534h9.673c.298 0 .54-.24.54-.534V5.93a.536.536 0 0 0-.54-.533h-1.989a.81.81 0 0 1-.711-.42l-.681-1.244zm-1.397-.81c.256-.486.763-.79 1.315-.79h3.133c.545 0 1.046.295 1.305.77l.49.894h1.506c1.191 0 2.157.955 2.157 2.133v5.803c0 1.178-.966 2.134-2.157 2.134H3.163c-1.191 0-2.157-.956-2.157-2.134V5.931c0-1.179.966-2.134 2.157-2.134h1.464z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.983 9.567c.596 0 1.079-.478 1.079-1.067 0-.59-.483-1.067-1.079-1.067-.595 0-1.078.478-1.078 1.067 0 .59.483 1.067 1.078 1.067m0 1.6c1.49 0 2.697-1.194 2.697-2.667S9.472 5.833 7.983 5.833 5.287 7.027 5.287 8.5s1.207 2.667 2.696 2.667",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCameraMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m4.864 2.8-.487.925a.61.61 0 0 1-.539.323H2.372a.4.4 0 0 0-.404.4V8.8c0 .221.18.4.404.4h7.255c.224 0 .405-.179.405-.4V4.448c0-.22-.181-.4-.405-.4H8.136a.61.61 0 0 1-.534-.315l-.51-.933zm-1.048-.608c.191-.364.572-.592.986-.592h2.35c.408 0 .784.221.978.577l.368.671h1.13a1.61 1.61 0 0 1 1.617 1.6V8.8c0 .884-.724 1.6-1.618 1.6H2.372A1.61 1.61 0 0 1 .754 8.8V4.448c0-.884.725-1.6 1.618-1.6H3.47z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.987 7.175a.805.805 0 0 0 .81-.8c0-.442-.363-.8-.81-.8a.805.805 0 0 0-.809.8c0 .442.362.8.81.8m0 1.2a2.01 2.01 0 0 0 2.023-2c0-1.104-.906-2-2.023-2a2.01 2.01 0 0 0-2.022 2c0 1.105.905 2 2.022 2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconCamera/IconCamera.tsx
var IconCamera = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCameraMonochromeExtralight,
          "monochrome|light": IconCameraMonochromeLight,
          "monochrome|regular": IconCameraMonochromeRegular,
          "monochrome|medium": IconCameraMonochromeMedium,
          "monochrome|semibold": IconCameraMonochromeSemibold,
          "monochrome|bold": IconCameraMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCameraFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 11.44h6.681l2.273-4.364A2 2 0 0 1 18.728 6h10.347a2 2 0 0 1 1.76 1.048l2.375 4.392H40a4 4 0 0 1 4 4v20.694a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V15.44a4 4 0 0 1 4-4m22.265 13.762a6.32 6.32 0 1 1-12.639 0 6.32 6.32 0 0 1 12.639 0m2.4 0a8.72 8.72 0 1 1-17.439 0 8.72 8.72 0 0 1 17.439 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCameraFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.167 7.627h4.62l1.469-2.82A1.5 1.5 0 0 1 12.586 4h6.698a1.5 1.5 0 0 1 1.32.786l1.536 2.84h4.693a2.5 2.5 0 0 1 2.5 2.5v14.13a2.5 2.5 0 0 1-2.5 2.5H5.167a2.5 2.5 0 0 1-2.5-2.5v-14.13a2.5 2.5 0 0 1 2.5-2.5m14.61 9.174a3.813 3.813 0 1 1-7.626 0 3.813 3.813 0 0 1 7.625 0m2 0a5.813 5.813 0 1 1-11.626 0 5.813 5.813 0 0 1 11.625 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCameraFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 5.72h3.34l1.137-2.182A1 1 0 0 1 9.364 3h5.173a1 1 0 0 1 .88.524l1.188 2.196H20a2 2 0 0 1 2 2v10.347a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.72a2 2 0 0 1 2-2m10.533 6.88a2.56 2.56 0 1 1-5.12 0 2.56 2.56 0 0 1 5.12 0m1.8 0a4.36 4.36 0 1 1-8.72 0 4.36 4.36 0 0 1 8.72 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCameraFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3 4.29h2.505l.783-1.502a1 1 0 0 1 .887-.538h3.58a1 1 0 0 1 .879.524l.82 1.516H15a1.5 1.5 0 0 1 1.5 1.5v7.76a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V5.79A1.5 1.5 0 0 1 3 4.29m7.65 5.16a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0m1.6 0a3.27 3.27 0 1 1-6.54 0 3.27 3.27 0 0 1 6.54 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCameraFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.833 3.813h2.06l.665-1.275A1 1 0 0 1 6.445 2h3.048a1 1 0 0 1 .88.524l.697 1.29h2.097a1.5 1.5 0 0 1 1.5 1.5v6.564a1.5 1.5 0 0 1-1.5 1.5H2.833a1.5 1.5 0 0 1-1.5-1.5V5.313a1.5 1.5 0 0 1 1.5-1.5m6.655 4.588a1.506 1.506 0 1 1-3.013 0 1.506 1.506 0 0 1 3.013 0m1.4 0a2.906 2.906 0 1 1-5.813 0 2.906 2.906 0 0 1 5.813 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCameraFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2 2.86h1.67l.569-1.091a.5.5 0 0 1 .443-.269h2.587a.5.5 0 0 1 .44.262l.593 1.098H10a1 1 0 0 1 1 1v5.173a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.86a1 1 0 0 1 1-1M7.166 6.3a1.18 1.18 0 1 1-2.36 0 1.18 1.18 0 0 1 2.36 0m1 0a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCameraFilled/IconCameraFilled.tsx
var IconCameraFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCameraFilledMonochromeExtralight,
          "monochrome|light": IconCameraFilledMonochromeLight,
          "monochrome|regular": IconCameraFilledMonochromeRegular,
          "monochrome|medium": IconCameraFilledMonochromeMedium,
          "monochrome|semibold": IconCameraFilledMonochromeSemibold,
          "monochrome|bold": IconCameraFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCartMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.8 6A1.2 1.2 0 0 1 3 4.8h5.23a1.8 1.8 0 0 1 1.76 1.419l.746 3.444h29.626a3.2 3.2 0 0 1 3.081 4.064L39.71 27.05a7.2 7.2 0 0 1-6.933 5.257H19.991a7.2 7.2 0 0 1-6.933-5.257L8.603 11.152 7.746 7.2H3A1.2 1.2 0 0 1 1.8 6m9.55 6.063 4.02 14.34a4.8 4.8 0 0 0 4.621 3.505h12.785a4.8 4.8 0 0 0 4.622-3.505l3.735-13.324a.8.8 0 0 0-.77-1.016zM18.762 43.38a4.19 4.19 0 1 0 0-8.38 4.19 4.19 0 0 0 0 8.38m0-2.4a1.79 1.79 0 1 0 0-3.58 1.79 1.79 0 0 0 0 3.58M38.38 39.19a4.19 4.19 0 1 1-8.38 0 4.19 4.19 0 0 1 8.38 0m-2.4 0a1.79 1.79 0 1 1-3.58 0 1.79 1.79 0 0 1 3.58 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCartMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1 4a1 1 0 0 1 1-1h3.487a1.4 1.4 0 0 1 1.368 1.104l.464 2.138h19.59a2.333 2.333 0 0 1 2.246 2.963l-2.49 8.883a5 5 0 0 1-4.814 3.65h-8.523a5 5 0 0 1-4.815-3.65L5.541 7.483 5.003 5H2a1 1 0 0 1-1-1m6.83 4.242 2.609 9.306a3 3 0 0 0 2.889 2.19h8.523a3 3 0 0 0 2.889-2.19l2.49-8.883a.333.333 0 0 0-.322-.423zM12.508 28.92a2.794 2.794 0 1 0 0-5.587 2.794 2.794 0 0 0 0 5.588m0-2a.794.794 0 1 0 0-1.587.794.794 0 0 0 0 1.588M25.587 26.127a2.794 2.794 0 1 1-5.587 0 2.794 2.794 0 0 1 5.587 0m-2 0a.794.794 0 1 1-1.587 0 .794.794 0 0 1 1.587 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCartMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M.1 2.5a.9.9 0 0 1 .9-.9h2.758a1.2 1.2 0 0 1 1.173.946l.348 1.607h15.402a1.9 1.9 0 0 1 1.83 2.413l-2.01 7.168a3.9 3.9 0 0 1-3.754 2.848h-6.94a3.9 3.9 0 0 1-3.755-2.848L3.679 5.27 3.274 3.4H1a.9.9 0 0 1-.9-.9m5.64 3.453 2.045 7.296a2.1 2.1 0 0 0 2.022 1.533h6.94a2.1 2.1 0 0 0 2.022-1.533l2.009-7.169a.1.1 0 0 0-.097-.127zM9.38 22.19a2.095 2.095 0 1 0 0-4.19 2.095 2.095 0 0 0 0 4.19m0-1.6a.495.495 0 1 1 0-.99.495.495 0 0 1 0 .99M19.19 20.095a2.095 2.095 0 1 1-4.19 0 2.095 2.095 0 0 1 4.19 0m-1.6 0a.495.495 0 1 0-.99 0 .495.495 0 0 0 .99 0" })
        }
      );
    }
  )
);
var IconCartMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M.325 2.25a.8.8 0 0 1 .8-.8h1.962c.482 0 .9.337 1.001.808l.22 1.016h10.828c1.027 0 1.77.98 1.493 1.968l-1.4 4.997a3.05 3.05 0 0 1-2.938 2.227H7.497a3.05 3.05 0 0 1-2.937-2.227L2.886 4.267 2.623 3.05H1.125a.8.8 0 0 1-.8-.8m4.393 2.624 1.383 4.933a1.45 1.45 0 0 0 1.396 1.059h4.794c.65 0 1.221-.433 1.397-1.059l1.382-4.933z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M8.3 14.375a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12.836 15.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" })
          ]
        }
      );
    }
  )
);
var IconCartMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M.25 2A.75.75 0 0 1 1 1.25h1.743a.95.95 0 0 1 .929.749l.189.872h9.593c.938 0 1.617.896 1.364 1.799l-1.245 4.442a2.75 2.75 0 0 1-2.648 2.007H6.664a2.75 2.75 0 0 1-2.648-2.007l-1.488-5.31L2.3 2.75H1A.75.75 0 0 1 .25 2m3.995 2.371L5.46 8.707c.151.54.643.912 1.204.912h4.262a1.25 1.25 0 0 0 1.203-.912l1.215-4.336z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M7.3 12.817a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0M11.293 13.967a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3" })
          ]
        }
      );
    }
  )
);
var IconCartMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M.15 1.5a.6.6 0 0 1 .6-.6h1.307a.75.75 0 0 1 .733.591l.136.625h7.165a1.1 1.1 0 0 1 1.059 1.397l-.934 3.33a2.1 2.1 0 0 1-2.022 1.534H4.998a2.1 2.1 0 0 1-2.022-1.533L1.859 2.86l-.164-.76H.75a.6.6 0 0 1-.6-.6m3.083 1.816.898 3.204a.9.9 0 0 0 .867.657h3.196a.9.9 0 0 0 .867-.657l.898-3.204z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M5.6 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M9.457 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0" })
          ]
        }
      );
    }
  )
);

// src/IconCart/IconCart.tsx
var IconCart = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCartMonochromeExtralight,
          "monochrome|light": IconCartMonochromeLight,
          "monochrome|regular": IconCartMonochromeRegular,
          "monochrome|medium": IconCartMonochromeMedium,
          "monochrome|semibold": IconCartMonochromeSemibold,
          "monochrome|bold": IconCartMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCheckMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M40.884 13.783a1.25 1.25 0 0 1 0 1.767L19.55 36.884a1.25 1.25 0 0 1-1.768 0L7.116 26.217a1.25 1.25 0 0 1 1.768-1.768l9.783 9.783 20.45-20.45a1.25 1.25 0 0 1 1.767 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M27.374 9.07a1 1 0 0 1 0 1.415L13.152 24.707a1 1 0 0 1-1.415 0l-7.11-7.11a1 1 0 0 1 1.413-1.415l6.404 6.404L25.96 9.07a1 1 0 0 1 1.415 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.637 6.697a.9.9 0 0 1 0 1.273L9.97 18.636a.9.9 0 0 1-1.273 0l-5.333-5.333a.9.9 0 0 1 1.272-1.273l4.697 4.697 10.03-10.03a.9.9 0 0 1 1.274 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.566 4.935a.8.8 0 0 1 0 1.13l-8 8a.8.8 0 0 1-1.132 0l-4-4a.8.8 0 0 1 1.132-1.13L7 12.369l7.434-7.434a.8.8 0 0 1 1.132 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.828 4.394a.7.7 0 0 1 0 .99l-7.11 7.111a.7.7 0 0 1-.99 0L2.171 8.94a.7.7 0 1 1 .99-.99l3.06 3.06 6.616-6.616a.7.7 0 0 1 .99 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.424 3.243a.6.6 0 0 1 0 .848L5.091 9.424a.6.6 0 0 1-.849 0L1.576 6.758a.6.6 0 1 1 .848-.849l2.243 2.243 4.909-4.91a.6.6 0 0 1 .848 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCheck/IconCheck.tsx
var IconCheck = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCheckMonochromeExtralight,
          "monochrome|light": IconCheckMonochromeLight,
          "monochrome|regular": IconCheckMonochromeRegular,
          "monochrome|medium": IconCheckMonochromeMedium,
          "monochrome|semibold": IconCheckMonochromeSemibold,
          "monochrome|bold": IconCheckMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCheckCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M416 240c0-97.202-78.798-176-176-176S64 142.798 64 240s78.798 176 176 176v24c-110.457 0-200-89.543-200-200S129.543 40 240 40s200 89.543 200 200-89.543 200-200 200v-24c97.202 0 176-78.798 176-176" }),
            /* @__PURE__ */ jsx("path", { d: "M346.742 166.591c5.565 5.565 5.565 14.587 0 20.152L208.408 330.077c-5.565 5.565-14.587 5.565-20.152 0l-63-60c-5.565-5.565-5.565-14.588 0-20.153s14.587-5.565 20.152 0l52.924 49.924 128.257-133.257c5.565-5.565 14.588-5.565 20.153 0" }),
            /* @__PURE__ */ jsx("path", { d: "M326.589 166.591c5.565-5.565 14.588-5.565 20.153 0s5.565 14.587 0 20.152L208.408 330.077c-5.565 5.565-14.587 5.565-20.152 0l-63-60c-5.478-5.478-5.564-14.307-.257-19.89l.257-.263c5.565-5.565 14.587-5.565 20.152 0l52.924 49.924zm13.082 7.071a4.25 4.25 0 0 0-5.984-.027l-135.015 140.28-60.125-56.717-.107-.1-.103-.103a4.249 4.249 0 0 0-6.055 5.964l62.87 59.876.088.084.087.087a4.25 4.25 0 0 0 5.979.027l138.24-143.234.061-.064.064-.063a4.25 4.25 0 0 0 0-6.01" })
          ]
        }
      );
    }
  )
);
var IconCheckCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240.005 40.005c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200m0 30c-93.889 0-170 76.111-170 170s76.111 170 170 170 170-76.112 170-170-76.112-170-170-170" }),
            /* @__PURE__ */ jsx("path", { d: "M348.34 188.343c6.444-6.444 6.444-16.891 0-23.334-6.443-6.444-16.891-6.444-23.334 0L198.34 296.675l-53.333-48.333c-6.444-6.444-16.891-6.444-23.335 0-6.443 6.444-6.443 16.891 0 23.334l65 60c6.444 6.444 16.891 6.444 23.335 0z" })
          ]
        }
      );
    }
  )
);
var IconCheckCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 40c110.457 0 200 89.543 200 200s-89.543 200-200 200S40 350.457 40 240 129.543 40 240 40m0 36c-90.575 0-164 73.425-164 164s73.425 164 164 164 164-73.425 164-164S330.575 76 240 76" }),
            /* @__PURE__ */ jsx("path", { d: "M345.749 193.75c7.224-7.224 7.224-18.938 0-26.163-7.225-7.224-18.938-7.224-26.163 0L198.334 293.839l-48.919-46.918c-7.224-7.225-18.938-7.225-26.162 0s-7.225 18.938 0 26.163l62 60c7.224 7.224 18.938 7.224 26.162 0z" })
          ]
        }
      );
    }
  )
);
var IconCheckCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 40c110.457 0 200 89.543 200 200s-89.543 200-200 200S40 350.457 40 240 129.543 40 240 40m0 42.67c-86.891 0-157.33 70.439-157.33 157.33S153.109 397.33 240 397.33 397.33 326.891 397.33 240 326.891 82.67 240 82.67" }),
            /* @__PURE__ */ jsx("path", { d: "M340.809 200.809c7.81-7.811 7.81-20.474 0-28.285-7.811-7.81-20.474-7.81-28.285 0L205.333 291.716l-49.858-45.858c-7.81-7.811-20.473-7.811-28.284 0-7.81 7.81-7.81 20.473 0 28.284l64 60c7.811 7.81 20.474 7.81 28.284 0z" })
          ]
        }
      );
    }
  )
);
var IconCheckCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M239.99 39.99c110.457 0 200 89.543 200 200s-89.543 200-200 200-200-89.543-200-200 89.543-200 200-200m0 45c-85.604 0-155 69.396-155 155s69.396 155 155 155 155-69.396 155-155-69.396-155-155-155" }),
            /* @__PURE__ */ jsx("path", { d: "M340.444 200.447c7.615-7.615 7.615-19.962 0-27.577s-19.962-7.616-27.577 0L203.322 292.414l-48.211-46.211c-7.616-7.615-19.962-7.615-27.578 0s-7.615 19.962 0 27.577l62 60c7.616 7.615 19.962 7.615 27.578 0z" })
          ]
        }
      );
    }
  )
);
var IconCheckCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 40c110.457 0 200 89.543 200 200s-89.543 200-200 200S40 350.457 40 240 129.543 40 240 40m0 48c-83.947 0-152 68.053-152 152s68.053 152 152 152 152-68.053 152-152S323.947 88 240 88" }),
            /* @__PURE__ */ jsx("path", { d: "M341.517 201.513c8.201-8.201 8.201-21.497 0-29.698s-21.498-8.201-29.699 0L203.334 290.299l-50.151-45.151c-8.201-8.201-21.497-8.201-29.698 0s-8.201 21.498 0 29.699l65 60c8.201 8.201 21.497 8.201 29.698 0s123.334-133.334 123.334-133.334" })
          ]
        }
      );
    }
  )
);

// src/IconCheckCircle/IconCheckCircle.tsx
var IconCheckCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCheckCircleMonochromeExtralight,
          "monochrome|light": IconCheckCircleMonochromeLight,
          "monochrome|regular": IconCheckCircleMonochromeRegular,
          "monochrome|medium": IconCheckCircleMonochromeMedium,
          "monochrome|semibold": IconCheckCircleMonochromeSemibold,
          "monochrome|bold": IconCheckCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m11.674-26.326a1.425 1.425 0 1 0-2.015-2.015L19.333 29.985l-4.992-4.993a1.425 1.425 0 0 0-2.015 2.016l6 6a1.425 1.425 0 0 0 2.015 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 29.334c7.364 0 13.334-5.97 13.334-13.334S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.334 16 29.334m7.89-17.445a1.1 1.1 0 1 0-1.556-1.555l-9.445 9.444-3.222-3.222a1.1 1.1 0 1 0-1.556 1.555l4 4a1.1 1.1 0 0 0 1.556 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m5.987-13.012a.925.925 0 1 0-1.308-1.309l-7.012 7.013-2.346-2.346a.925.925 0 0 0-1.308 1.308l3 3a.925.925 0 0 0 1.308 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m4.53-9.72a.75.75 0 0 0-1.06-1.06l-5.22 5.22-1.72-1.72a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333m4.015-8.651a.65.65 0 0 0-.92-.92l-4.65 4.652-1.541-1.54a.65.65 0 1 0-.92.919l2 2a.65.65 0 0 0 .92 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m3.038-6.462a.525.525 0 1 0-.743-.743L4.833 7.257 3.705 6.13a.525.525 0 0 0-.743.742l1.5 1.5a.525.525 0 0 0 .743 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCheckCircleFilled/IconCheckCircleFilled.tsx
var IconCheckCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCheckCircleFilledMonochromeExtralight,
          "monochrome|light": IconCheckCircleFilledMonochromeLight,
          "monochrome|regular": IconCheckCircleFilledMonochromeRegular,
          "monochrome|medium": IconCheckCircleFilledMonochromeMedium,
          "monochrome|semibold": IconCheckCircleFilledMonochromeSemibold,
          "monochrome|bold": IconCheckCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCheckSealMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M34.926 14.771a2.4 2.4 0 0 1-1.697-1.697l-.9-3.359a.1.1 0 0 0-.123-.07l-3.358.9a2.4 2.4 0 0 1-2.318-.621l-2.46-2.46a.1.1 0 0 0-.14 0l-2.46 2.46a2.4 2.4 0 0 1-2.318.62l-3.358-.9a.1.1 0 0 0-.123.071l-.9 3.36a2.4 2.4 0 0 1-1.697 1.696l-3.358.9a.1.1 0 0 0-.071.123l.9 3.358a2.4 2.4 0 0 1-.621 2.319l-2.46 2.458a.1.1 0 0 0 0 .142l2.46 2.458a2.4 2.4 0 0 1 .62 2.319l-.9 3.358a.1.1 0 0 0 .072.123l3.358.9a2.4 2.4 0 0 1 1.697 1.697l.9 3.358a.1.1 0 0 0 .123.071l3.358-.9a2.4 2.4 0 0 1 2.319.621l2.458 2.46a.1.1 0 0 0 .142 0l2.459-2.46a2.4 2.4 0 0 1 2.318-.62l3.358.9a.1.1 0 0 0 .123-.072l.9-3.358a2.4 2.4 0 0 1 1.697-1.697l3.359-.9a.1.1 0 0 0 .07-.123l-.9-3.358a2.4 2.4 0 0 1 .622-2.319l2.458-2.458a.1.1 0 0 0 0-.142l-2.458-2.458a2.4 2.4 0 0 1-.622-2.319l.9-3.358a.1.1 0 0 0-.07-.123zM19.774 8.226l-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9-2.46-2.46a2.5 2.5 0 0 0-3.535 0z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M30.445 19.148a1.2 1.2 0 0 1 .008 1.697l-7.925 8a1.2 1.2 0 0 1-1.736-.033l-3.676-4a1.2 1.2 0 0 1 1.768-1.624l2.824 3.074 7.04-7.107a1.2 1.2 0 0 1 1.697-.008",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCheckSealMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22.961 10.015A2 2 0 0 1 21.547 8.6l-.514-1.917-1.917.513a2 2 0 0 1-1.931-.517L15.78 5.276 14.378 6.68a2 2 0 0 1-1.932.517l-1.917-.513-.514 1.917A2 2 0 0 1 8.6 10.015l-1.917.514.513 1.917a2 2 0 0 1-.517 1.932L5.276 15.78l1.404 1.403a2 2 0 0 1 .517 1.932l-.513 1.918 1.917.513a2 2 0 0 1 1.414 1.414l.514 1.918 1.917-.514a2 2 0 0 1 1.932.518l1.403 1.403 1.403-1.404a2 2 0 0 1 1.932-.517l1.918.514.513-1.918a2 2 0 0 1 1.414-1.414l1.918-.514-.514-1.917a2 2 0 0 1 .518-1.931l1.403-1.404-1.404-1.403a2 2 0 0 1-.517-1.932l.514-1.917zm-6.708 16.742h-.002zm2.346-21.492-1.875-1.874a1.333 1.333 0 0 0-1.886 0l-1.875 1.874-2.56-.686a1.333 1.333 0 0 0-1.634.943l-.686 2.561-2.561.686a1.333 1.333 0 0 0-.943 1.633l.686 2.561-1.874 1.875c-.521.52-.521 1.365 0 1.886l1.874 1.875-.686 2.56c-.19.712.232 1.443.943 1.634l2.561.686.686 2.561c.19.711.922 1.134 1.633.943l2.561-.686 1.875 1.875c.52.52 1.365.52 1.886 0l1.875-1.875 2.56.686a1.333 1.333 0 0 0 1.634-.943l.686-2.56 2.561-.687a1.333 1.333 0 0 0 .943-1.633l-.686-2.561 1.875-1.875c.52-.52.52-1.365 0-1.886l-1.875-1.875.686-2.56a1.333 1.333 0 0 0-.943-1.634l-2.561-.686-.686-2.561a1.333 1.333 0 0 0-1.633-.943z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M20.455 12.641a1 1 0 0 1-.03 1.414l-5.558 5.333a1 1 0 0 1-1.384 0l-2.175-2.087a1 1 0 1 1 1.384-1.443l1.483 1.423 4.866-4.67a1 1 0 0 1 1.414.03",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCheckSealMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.308 7.965a1.8 1.8 0 0 1-1.273-1.273l-.308-1.148-1.148.308a1.8 1.8 0 0 1-1.738-.466l-.84-.84-.841.84a1.8 1.8 0 0 1-1.739.466l-1.148-.308-.308 1.148a1.8 1.8 0 0 1-1.273 1.273l-1.148.308.308 1.148a1.8 1.8 0 0 1-.466 1.739l-.84.84.84.84a1.8 1.8 0 0 1 .466 1.74l-.308 1.147 1.148.308a1.8 1.8 0 0 1 1.273 1.273l.308 1.148 1.148-.308a1.8 1.8 0 0 1 1.739.466l.84.84.84-.84a1.8 1.8 0 0 1 1.74-.466l1.147.308.308-1.148a1.8 1.8 0 0 1 1.273-1.273l1.148-.308-.308-1.148a1.8 1.8 0 0 1 .466-1.739l.84-.84-.84-.84a1.8 1.8 0 0 1-.466-1.74l.308-1.147zm.466-1.739-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514-1.407-1.406a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.514 1.92-1.921.515a1 1 0 0 0-.707 1.225l.514 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.514 1.921a1 1 0 0 0 .707 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.921.514a1 1 0 0 0 1.225-.707l.515-1.92 1.92-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.434 9.36a.9.9 0 0 1 .006 1.273l-3.963 4a.9.9 0 0 1-1.302-.024l-1.838-2a.9.9 0 0 1 1.326-1.218l1.2 1.305 3.298-3.33a.9.9 0 0 1 1.273-.005",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCheckSealMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.916 6.215a1.6 1.6 0 0 1-1.131-1.131l-.166-.62-.62.166a1.6 1.6 0 0 1-1.545-.414L9 3.763l-.453.453A1.6 1.6 0 0 1 7 4.63l-.62-.166-.166.62a1.6 1.6 0 0 1-1.13 1.131l-.62.166.166.62a1.6 1.6 0 0 1-.415 1.545L3.763 9l.453.454a1.6 1.6 0 0 1 .415 1.545l-.167.62.62.166a1.6 1.6 0 0 1 1.131 1.131l.166.62.62-.166a1.6 1.6 0 0 1 1.546.414l.453.453.454-.453a1.6 1.6 0 0 1 1.545-.414l.62.166.166-.62a1.6 1.6 0 0 1 1.131-1.131l.62-.166-.166-.62a1.6 1.6 0 0 1 .414-1.545L14.237 9l-.453-.454a1.6 1.6 0 0 1-.414-1.545l.166-.62zm-2.331-3.13-.878-.878a1 1 0 0 0-1.414 0l-.878.878-1.199-.321a1 1 0 0 0-1.225.707L4.67 4.67l-1.489.399a.7.7 0 0 0-.495.857l.399 1.489-.878.878a1 1 0 0 0 0 1.414l.878.878-.321 1.199a1 1 0 0 0 .707 1.225l1.199.321.399 1.489a.7.7 0 0 0 .857.495l1.49-.399.877.878a1 1 0 0 0 1.414 0l.878-.878 1.2.321a1 1 0 0 0 1.224-.707l.321-1.199 1.49-.399a.7.7 0 0 0 .494-.857l-.399-1.49.878-.877a1 1 0 0 0 0-1.414l-.878-.878.322-1.2a1 1 0 0 0-.708-1.224L13.33 4.67l-.399-1.49a.7.7 0 0 0-.857-.494z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.663 6.932a.8.8 0 0 1 .005 1.131l-2.971 3a.8.8 0 0 1-1.158-.022l-1.378-1.5A.8.8 0 0 1 7.339 8.46l.811.882 2.382-2.404a.8.8 0 0 1 1.131-.005",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCheckSealMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.978 11.858a1.5 1.5 0 0 1 1.061-.44h1.38V10.04c0-.398.158-.78.439-1.06l.975-.976-.975-.975a1.5 1.5 0 0 1-.44-1.061v-1.38H10.04a1.5 1.5 0 0 1-1.06-.439l-.976-.975-.975.975a1.5 1.5 0 0 1-1.061.44h-1.38v1.379a1.5 1.5 0 0 1-.439 1.06l-.975.976.975.975a1.5 1.5 0 0 1 .44 1.061v1.38h1.38a1.5 1.5 0 0 1 1.06.439l.975.975zm-1.682-10.1a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88L8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.395 6.134a.75.75 0 0 1 .005 1.06L7.758 9.861a.75.75 0 0 1-1.085-.02L5.448 8.507a.75.75 0 0 1 1.104-1.014l.694.754 2.088-2.108a.75.75 0 0 1 1.06-.005",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCheckSealMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.68 8.84a1.2 1.2 0 0 1 .85-.351h.959v-.96a1.2 1.2 0 0 1 .351-.848l.679-.679-.679-.678a1.2 1.2 0 0 1-.351-.849v-.96h-.96a1.2 1.2 0 0 1-.848-.35l-.679-.68-.678.68a1.2 1.2 0 0 1-.849.35h-.96v.96a1.2 1.2 0 0 1-.35.849l-.68.678.68.679a1.2 1.2 0 0 1 .35.848v.96h.96a1.2 1.2 0 0 1 .849.351l.678.679zM1.497 6.71l.82.82v1.159a1 1 0 0 0 1 1h1.16l.82.82a1 1 0 0 0 1.413 0l.82-.82h1.16a1 1 0 0 0 1-1v-1.16l.82-.82a1 1 0 0 0 0-1.414l-.82-.82v-1.16a1 1 0 0 0-1-1h-1.16l-.82-.82a1 1 0 0 0-1.414 0l-.82.82h-1.16a1 1 0 0 0-1 1v1.16l-.82.82a1 1 0 0 0 0 1.414",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.822 4.574a.6.6 0 0 1 .004.848l-1.98 2a.6.6 0 0 1-.869-.016l-.919-1a.6.6 0 0 1 .884-.812l.493.537 1.539-1.553a.6.6 0 0 1 .848-.004",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconCheckSeal/IconCheckSeal.tsx
var IconCheckSeal = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCheckSealMonochromeExtralight,
          "monochrome|light": IconCheckSealMonochromeLight,
          "monochrome|regular": IconCheckSealMonochromeRegular,
          "monochrome|medium": IconCheckSealMonochromeMedium,
          "monochrome|semibold": IconCheckSealMonochromeSemibold,
          "monochrome|bold": IconCheckSealMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M25.768 5.768a2.5 2.5 0 0 0-3.536 0l-2.458 2.458-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9zm4.685 15.077a1.2 1.2 0 1 0-1.705-1.69l-7.04 7.107-2.824-3.074a1.2 1.2 0 1 0-1.768 1.624l3.676 4a1.2 1.2 0 0 0 1.736.032z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.94 3.607a1.33 1.33 0 0 0-1.88 0l-1.878 1.877-2.564-.687a1.33 1.33 0 0 0-1.629.94l-.687 2.565-2.564.687c-.71.19-1.13.92-.94 1.629l.687 2.564-1.878 1.877a1.33 1.33 0 0 0 0 1.881l1.878 1.878-.688 2.564c-.19.71.231 1.439.94 1.629l2.565.687.687 2.564c.19.71.92 1.13 1.63.94l2.563-.686 1.878 1.877c.52.52 1.361.52 1.88 0l1.878-1.877 2.564.687a1.33 1.33 0 0 0 1.63-.94l.686-2.565 2.564-.687c.71-.19 1.131-.92.941-1.629l-.687-2.564 1.877-1.878a1.33 1.33 0 0 0 0-1.88l-1.877-1.878.687-2.564a1.33 1.33 0 0 0-.94-1.629l-2.565-.687-.687-2.564a1.33 1.33 0 0 0-1.629-.94l-2.564.686zm3.504 10.43a1 1 0 0 0-1.42-1.408l-4.546 4.59-1.741-1.896a1 1 0 0 0-1.473 1.354l2.45 2.666a1 1 0 0 0 1.447.027z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.707 2.707a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.515 1.92-1.92.515a1 1 0 0 0-.708 1.225l.515 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.515 1.921a1 1 0 0 0 .708 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.92.514a1 1 0 0 0 1.226-.707l.514-1.92 1.921-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225l-1.92-.515-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514zm2.732 7.926a.9.9 0 1 0-1.278-1.266l-3.299 3.33-1.2-1.306a.9.9 0 0 0-1.325 1.218l1.838 2a.9.9 0 0 0 1.302.024z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.707 2.207a1 1 0 0 0-1.414 0l-.878.878-1.2-.321a1 1 0 0 0-1.224.707L4.67 4.67l-1.2.321a1 1 0 0 0-.707 1.225l.322 1.199-.878.878a1 1 0 0 0 0 1.414l.878.878-.322 1.199a1 1 0 0 0 .708 1.225l1.199.321.321 1.2a1 1 0 0 0 1.225.706l1.199-.321.878.878a1 1 0 0 0 1.414 0l.878-.878 1.199.321a1 1 0 0 0 1.225-.707l.321-1.199 1.2-.321a1 1 0 0 0 .706-1.225l-.321-1.2.878-.877a1 1 0 0 0 0-1.414l-.878-.878.321-1.2a1 1 0 0 0-.707-1.224L13.33 4.67l-.321-1.2a1 1 0 0 0-1.225-.706l-1.2.32zm1.961 5.856a.8.8 0 0 0-1.136-1.126L8.15 9.341l-.811-.882A.8.8 0 0 0 6.16 9.54l1.378 1.5a.8.8 0 0 0 1.157.022z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879l1.329-1.33a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88zm1.69-7.053A.75.75 0 0 0 9.334 6.14L7.246 8.247l-.694-.754a.75.75 0 0 0-1.104 1.014l1.225 1.334a.75.75 0 0 0 1.085.02z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconCheckSealFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.71 10.509a1 1 0 0 1-1.415 0l-.82-.82h-1.16a1 1 0 0 1-1-1v-1.16l-.82-.82a1 1 0 0 1 0-1.414l.82-.82v-1.16a1 1 0 0 1 1-1h1.16l.82-.82a1 1 0 0 1 1.414 0l.82.82h1.16a1 1 0 0 1 1 1v1.16l.82.82a1 1 0 0 1 0 1.414l-.82.82v1.16a1 1 0 0 1-1 1h-1.16zm1.116-5.087a.6.6 0 1 0-.852-.844L5.435 6.13l-.493-.537a.6.6 0 0 0-.884.812l.919 1a.6.6 0 0 0 .868.016z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCheckSealFilled/IconCheckSealFilled.tsx
var IconCheckSealFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCheckSealFilledMonochromeExtralight,
          "monochrome|light": IconCheckSealFilledMonochromeLight,
          "monochrome|regular": IconCheckSealFilledMonochromeRegular,
          "monochrome|medium": IconCheckSealFilledMonochromeMedium,
          "monochrome|semibold": IconCheckSealFilledMonochromeSemibold,
          "monochrome|bold": IconCheckSealFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconChevronDownMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.423 13.453a1.2 1.2 0 0 1 1.694.1l16.88 18.99 16.882-18.99a1.2 1.2 0 1 1 1.794 1.594l-17.405 19.58a1.7 1.7 0 0 1-2.54 0L5.322 15.147a1.2 1.2 0 0 1 .1-1.694" })
        }
      );
    }
  )
);
var IconChevronDownMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.486 8.714a1 1 0 0 1 1.411.083L16.002 21.29 27.106 8.797a1 1 0 0 1 1.495 1.329L17.123 23.039a1.5 1.5 0 0 1-2.242 0L3.403 10.126a1 1 0 0 1 .083-1.412",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.502 6.467a.9.9 0 0 1 1.27.075l8.217 9.243 8.216-9.243a.9.9 0 0 1 1.346 1.196l-8.515 9.58a1.4 1.4 0 0 1-2.093 0l-8.515-9.58a.9.9 0 0 1 .074-1.27" })
        }
      );
    }
  )
);
var IconChevronDownMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.809 4.782a.8.8 0 0 1 1.129.067l6.069 6.827 6.069-6.827a.8.8 0 1 1 1.195 1.063l-6.293 7.08a1.3 1.3 0 0 1-1.943 0l-6.293-7.08a.8.8 0 0 1 .067-1.13",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.552 4.24a.75.75 0 0 0-.063 1.058l5.552 6.247a1.25 1.25 0 0 0 1.869 0l5.552-6.247a.75.75 0 1 0-1.12-.996l-5.366 6.036L2.61 4.302a.75.75 0 0 0-1.058-.062",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.201 3.182a.6.6 0 0 1 .847.05l3.996 4.495 3.997-4.496a.6.6 0 1 1 .896.798l-4.07 4.58a1.1 1.1 0 0 1-1.645 0l-4.07-4.58a.6.6 0 0 1 .05-.847",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconChevronDown/IconChevronDown.tsx
var IconChevronDown = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconChevronDownMonochromeExtralight,
          "monochrome|light": IconChevronDownMonochromeLight,
          "monochrome|regular": IconChevronDownMonochromeRegular,
          "monochrome|medium": IconChevronDownMonochromeMedium,
          "monochrome|semibold": IconChevronDownMonochromeSemibold,
          "monochrome|bold": IconChevronDownMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M27.657 7a1.2 1.2 0 0 1 1.2-1.2H41A1.2 1.2 0 0 1 42.2 7v12.143a1.2 1.2 0 0 1-2.4 0V8.2H28.857a1.2 1.2 0 0 1-1.2-1.2M7 27.657a1.2 1.2 0 0 1 1.2 1.2V39.8h10.943a1.2 1.2 0 0 1 0 2.4H7A1.2 1.2 0 0 1 5.8 41V28.857a1.2 1.2 0 0 1 1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M18.238 4.667a1 1 0 0 1 1-1h8.095a1 1 0 0 1 1 1v8.095a1 1 0 1 1-2 0V5.667h-7.095a1 1 0 0 1-1-1M4.667 18.237a1 1 0 0 1 1 1v7.096h7.095a1 1 0 1 1 0 2H4.667a1 1 0 0 1-1-1v-8.095a1 1 0 0 1 1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.529 3.5a.9.9 0 0 1 .9-.9H20.5a.9.9 0 0 1 .9.9v6.072a.9.9 0 1 1-1.8 0V4.4H14.43a.9.9 0 0 1-.9-.9M3.5 13.53a.9.9 0 0 1 .9.9V19.6h5.172a.9.9 0 1 1 0 1.8H3.5a.9.9 0 0 1-.9-.9V14.43a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.107 2.5a.75.75 0 0 1 .75-.75H15.5a.75.75 0 0 1 .75.75v4.643a.75.75 0 0 1-1.5 0V3.25h-3.893a.75.75 0 0 1-.75-.75M2.5 10.107a.75.75 0 0 1 .75.75v3.893h3.893a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75v-4.643a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.871 2.5a.7.7 0 0 1 .7-.7H13.5a.7.7 0 0 1 .7.7v3.928a.7.7 0 1 1-1.4 0V3.2H9.571a.7.7 0 0 1-.7-.7M2.5 8.87a.7.7 0 0 1 .7.7V12.8H6.43a.7.7 0 1 1 0 1.4H2.5a.7.7 0 0 1-.7-.7V9.57a.7.7 0 0 1 .7-.7",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronDownLeftChevronUpRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.355 2.133a.6.6 0 0 1 .6-.6h2.678a.6.6 0 0 1 .6.6v2.679a.6.6 0 1 1-1.2 0V2.733H6.955a.6.6 0 0 1-.6-.6M2.133 6.355a.6.6 0 0 1 .6.6v2.078h2.079a.6.6 0 0 1 0 1.2H2.133a.6.6 0 0 1-.6-.6V6.955a.6.6 0 0 1 .6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconChevronDownLeftChevronUpRight/IconChevronDownLeftChevronUpRight.tsx
var IconChevronDownLeftChevronUpRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconChevronDownLeftChevronUpRightMonochromeExtralight,
          "monochrome|light": IconChevronDownLeftChevronUpRightMonochromeLight,
          "monochrome|regular": IconChevronDownLeftChevronUpRightMonochromeRegular,
          "monochrome|medium": IconChevronDownLeftChevronUpRightMonochromeMedium,
          "monochrome|semibold": IconChevronDownLeftChevronUpRightMonochromeSemibold,
          "monochrome|bold": IconChevronDownLeftChevronUpRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconChevronLeftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M32.897 5.203a1.2 1.2 0 0 1-.1 1.694l-18.99 16.88 18.99 16.882a1.2 1.2 0 1 1-1.594 1.794l-19.58-17.405a1.7 1.7 0 0 1 0-2.54l19.58-17.405a1.2 1.2 0 0 1 1.694.1" })
        }
      );
    }
  )
);
var IconChevronLeftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M22.078 3.486a1 1 0 0 1-.083 1.411L9.503 16.002l12.492 11.104a1 1 0 1 1-1.329 1.495L7.753 17.123a1.5 1.5 0 0 1 0-2.242L20.666 3.403a1 1 0 0 1 1.412.083",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronLeftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M16.673 2.502a.9.9 0 0 1-.075 1.27L7.355 11.99l9.243 8.216a.9.9 0 0 1-1.196 1.345l-9.58-8.515a1.4 1.4 0 0 1 0-2.092l9.58-8.516a.9.9 0 0 1 1.27.075" })
        }
      );
    }
  )
);
var IconChevronLeftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.596 1.809a.8.8 0 0 1-.067 1.129L5.702 9.007l6.827 6.069a.8.8 0 1 1-1.063 1.195l-7.08-6.293a1.3 1.3 0 0 1 0-1.943l7.08-6.293a.8.8 0 0 1 1.13.067",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronLeftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M11.225 1.572a.75.75 0 0 0-1.06-.062L3.92 7.062a1.25 1.25 0 0 0 0 1.868l6.246 5.553a.75.75 0 1 0 .996-1.122L5.126 7.996l6.036-5.365a.75.75 0 0 0 .063-1.06",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronLeftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.449 1.151a.6.6 0 0 1-.05.847L3.903 5.994 8.4 9.99a.6.6 0 0 1-.797.897l-4.58-4.07a1.1 1.1 0 0 1 0-1.645l4.58-4.07a.6.6 0 0 1 .847.05",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconChevronLeft/IconChevronLeft.tsx
var IconChevronLeft = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconChevronLeftMonochromeExtralight,
          "monochrome|light": IconChevronLeftMonochromeLight,
          "monochrome|regular": IconChevronLeftMonochromeRegular,
          "monochrome|medium": IconChevronLeftMonochromeMedium,
          "monochrome|semibold": IconChevronLeftMonochromeSemibold,
          "monochrome|bold": IconChevronLeftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconChevronRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.103 5.203a1.2 1.2 0 0 0 .1 1.694l18.99 16.88-18.99 16.881a1.2 1.2 0 1 0 1.594 1.794l19.58-17.404a1.7 1.7 0 0 0 0-2.541L16.797 5.103a1.2 1.2 0 0 0-1.694.1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.92 3.486a1 1 0 0 0 .082 1.411l12.493 11.105-12.493 11.104a1 1 0 1 0 1.329 1.495l12.913-11.478a1.5 1.5 0 0 0 0-2.242L11.33 3.403a1 1 0 0 0-1.412.083",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.327 2.502a.9.9 0 0 0 .075 1.27l9.243 8.217-9.243 8.216a.9.9 0 1 0 1.196 1.345l9.58-8.515a1.4 1.4 0 0 0 0-2.092l-9.58-8.516a.9.9 0 0 0-1.27.075" })
        }
      );
    }
  )
);
var IconChevronRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.402 1.809a.8.8 0 0 0 .067 1.129l6.827 6.069-6.827 6.069a.8.8 0 1 0 1.063 1.195l7.08-6.293a1.3 1.3 0 0 0 0-1.943l-7.08-6.293a.8.8 0 0 0-1.13.067",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.773 1.572a.75.75 0 0 1 1.059-.062l6.246 5.552a1.25 1.25 0 0 1 0 1.868l-6.246 5.553a.75.75 0 1 1-.997-1.122l6.036-5.365-6.036-5.365a.75.75 0 0 1-.062-1.06",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.551 1.151a.6.6 0 0 0 .05.847l4.496 3.996L3.6 9.99a.6.6 0 0 0 .798.897l4.58-4.07a1.1 1.1 0 0 0 0-1.645l-4.58-4.07a.6.6 0 0 0-.848.05",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconChevronRight/IconChevronRight.tsx
var IconChevronRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconChevronRightMonochromeExtralight,
          "monochrome|light": IconChevronRightMonochromeLight,
          "monochrome|regular": IconChevronRightMonochromeRegular,
          "monochrome|medium": IconChevronRightMonochromeMedium,
          "monochrome|semibold": IconChevronRightMonochromeSemibold,
          "monochrome|bold": IconChevronRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconChevronUpMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M42.573 34.548a1.2 1.2 0 0 1-1.694-.1l-16.881-18.99-16.881 18.99a1.2 1.2 0 1 1-1.794-1.594l17.404-19.58a1.7 1.7 0 0 1 2.541 0l17.405 19.58a1.2 1.2 0 0 1-.1 1.694" })
        }
      );
    }
  )
);
var IconChevronUpMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M28.518 23.29a1 1 0 0 1-1.412-.084L16.002 10.714 4.897 23.206a1 1 0 1 1-1.495-1.328L14.881 8.965a1.5 1.5 0 0 1 2.242 0L28.6 21.878a1 1 0 0 1-.083 1.412",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronUpMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M21.476 17.535a.9.9 0 0 1-1.27-.075l-8.217-9.243-8.216 9.243a.9.9 0 0 1-1.346-1.195l8.516-9.58a1.4 1.4 0 0 1 2.092 0l8.515 9.58a.9.9 0 0 1-.074 1.27" })
        }
      );
    }
  )
);
var IconChevronUpMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.205 13.228a.8.8 0 0 1-1.13-.066L9.008 6.335l-6.069 6.827a.8.8 0 1 1-1.196-1.063l6.293-7.08a1.3 1.3 0 0 1 1.943 0l6.293 7.08a.8.8 0 0 1-.066 1.13",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronUpMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.4 11.764a.75.75 0 0 0 .063-1.06L8.91 4.46a1.25 1.25 0 0 0-1.868 0L1.49 10.705a.75.75 0 1 0 1.12.996l5.366-6.036 5.365 6.036a.75.75 0 0 0 1.06.063",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconChevronUpMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.888 8.816a.6.6 0 0 1-.848-.05L6.044 4.272 2.048 8.767a.6.6 0 0 1-.896-.798l4.07-4.58a1.1 1.1 0 0 1 1.645 0l4.07 4.58a.6.6 0 0 1-.05.847",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconChevronUp/IconChevronUp.tsx
var IconChevronUp = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconChevronUpMonochromeExtralight,
          "monochrome|light": IconChevronUpMonochromeLight,
          "monochrome|regular": IconChevronUpMonochromeRegular,
          "monochrome|medium": IconChevronUpMonochromeMedium,
          "monochrome|semibold": IconChevronUpMonochromeSemibold,
          "monochrome|bold": IconChevronUpMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20" })
        }
      );
    }
  )
);
var IconCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16" })
        }
      );
    }
  )
);
var IconCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10" })
        }
      );
    }
  )
);
var IconCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0" })
        }
      );
    }
  )
);
var IconCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0" })
        }
      );
    }
  )
);
var IconCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0" })
        }
      );
    }
  )
);

// src/IconCircleFilled/IconCircleFilled.tsx
var IconCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCircleFilledMonochromeExtralight,
          "monochrome|light": IconCircleFilledMonochromeLight,
          "monochrome|regular": IconCircleFilledMonochromeRegular,
          "monochrome|medium": IconCircleFilledMonochromeMedium,
          "monochrome|semibold": IconCircleFilledMonochromeSemibold,
          "monochrome|bold": IconCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconClockMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 7.2C14.722 7.2 7.2 14.722 7.2 24S14.722 40.8 24 40.8 40.8 33.278 40.8 24 33.278 7.2 24 7.2M4.8 24C4.8 13.396 13.396 4.8 24 4.8S43.2 13.396 43.2 24 34.604 43.2 24 43.2 4.8 34.604 4.8 24M23 10.8a1.2 1.2 0 0 1 1.2 1.2v10a2.8 2.8 0 0 0 2.8 2.8h6a1.2 1.2 0 1 1 0 2.4h-6a5.2 5.2 0 0 1-5.2-5.2V12a1.2 1.2 0 0 1 1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16m12.333-9a1 1 0 0 1 1 1v6.667c0 .92.747 1.666 1.667 1.666h4a1 1 0 1 1 0 2h-4a3.667 3.667 0 0 1-3.667-3.666V8a1 1 0 0 1 1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 3.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9m9.4-6.9a.9.9 0 0 1 .9.9v5a1.1 1.1 0 0 0 1.1 1.1h3a.9.9 0 0 1 0 1.8h-3a2.9 2.9 0 0 1-2.9-2.9V6a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 3.05a5.95 5.95 0 1 0 0 11.9 5.95 5.95 0 0 0 0-11.9M1.45 9a7.55 7.55 0 1 1 15.1 0 7.55 7.55 0 0 1-15.1 0m7.175-5.3a.8.8 0 0 1 .8.8v3.75a.7.7 0 0 0 .7.7h2.25a.8.8 0 0 1 0 1.6h-2.25a2.3 2.3 0 0 1-2.3-2.3V4.5a.8.8 0 0 1 .8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M1.25 8a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0m6.417-4.75a.75.75 0 0 1 .75.75v3.333c0 .322.26.584.583.584h2a.75.75 0 0 1 0 1.5H9a2.083 2.083 0 0 1-2.083-2.084V4a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("g", { clipPath: `url(#${_id})`, children: /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 2.1a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8M.9 6a5.1 5.1 0 1 1 10.2 0A5.1 5.1 0 0 1 .9 6m4.85-3.6a.6.6 0 0 1 .6.6v2.5c0 .22.179.4.4.4h1.5a.6.6 0 1 1 0 1.2h-1.5a1.6 1.6 0 0 1-1.6-1.6V3a.6.6 0 0 1 .6-.6",
                clipRule: "evenodd"
              }
            ) }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconClock/IconClock.tsx
var IconClock = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconClockMonochromeExtralight,
          "monochrome|light": IconClockMonochromeLight,
          "monochrome|regular": IconClockMonochromeRegular,
          "monochrome|medium": IconClockMonochromeMedium,
          "monochrome|semibold": IconClockMonochromeSemibold,
          "monochrome|bold": IconClockMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconClockFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m.2-32a1.2 1.2 0 1 0-2.4 0v10.001A5.2 5.2 0 0 0 27 27.2h6a1.2 1.2 0 1 0 0-2.4h-6A2.8 2.8 0 0 1 24.2 22z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 29.333c7.364 0 13.334-5.97 13.334-13.333S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333M16.334 8a1 1 0 1 0-2 0v6.667A3.666 3.666 0 0 0 18 18.333h4a1 1 0 0 0 0-2h-4c-.921 0-1.666-.745-1.666-1.666z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.4-16a.9.9 0 1 0-1.8 0v5a2.9 2.9 0 0 0 2.9 2.9h3a.9.9 0 1 0 0-1.8h-3a1.1 1.1 0 0 1-1.1-1.1z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.5 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m.425-12a.8.8 0 1 0-1.6 0v3.75a2.3 2.3 0 0 0 2.3 2.3h2.25a.8.8 0 0 0 0-1.6h-2.25a.7.7 0 0 1-.7-.7z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334M8.417 4a.75.75 0 0 0-1.5 0v3.334c0 1.15.932 2.083 2.083 2.083h2a.75.75 0 0 0 0-1.5H9a.583.583 0 0 1-.583-.583z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconClockFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m.35-8a.6.6 0 0 0-1.2 0v2.5a1.6 1.6 0 0 0 1.6 1.6h1.5a.6.6 0 0 0 0-1.2h-1.5a.4.4 0 0 1-.4-.4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconClockFilled/IconClockFilled.tsx
var IconClockFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconClockFilledMonochromeExtralight,
          "monochrome|light": IconClockFilledMonochromeLight,
          "monochrome|regular": IconClockFilledMonochromeRegular,
          "monochrome|medium": IconClockFilledMonochromeMedium,
          "monochrome|semibold": IconClockFilledMonochromeSemibold,
          "monochrome|bold": IconClockFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCreditCardMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M38 10.4H10A3.6 3.6 0 0 0 6.4 14v20a3.6 3.6 0 0 0 3.6 3.6h28a3.6 3.6 0 0 0 3.6-3.6V14a3.6 3.6 0 0 0-3.6-3.6M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5 18.8a1.2 1.2 0 0 1 1.2-1.2h35.6a1.2 1.2 0 0 1 0 2.4H6.2A1.2 1.2 0 0 1 5 18.8M30 25.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 0 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M25.333 7.334H6.667a2 2 0 0 0-2 2v13.333a2 2 0 0 0 2 2h18.666a2 2 0 0 0 2-2V9.334a2 2 0 0 0-2-2m-18.666-2a4 4 0 0 0-4 4v13.333a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4V9.334a4 4 0 0 0-4-4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4 12.334a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M20 17a1 1 0 0 1 1-1h3.333a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19 5.8H5A1.2 1.2 0 0 0 3.8 7v10A1.2 1.2 0 0 0 5 18.2h14a1.2 1.2 0 0 0 1.2-1.2V7A1.2 1.2 0 0 0 19 5.8M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3 9.1a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9M15 12.6a.9.9 0 0 1 .9-.9h2.2a.9.9 0 1 1 0 1.8h-2.2a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.25 4.6H3.75a.65.65 0 0 0-.65.65v7.5c0 .359.291.65.65.65h10.5a.65.65 0 0 0 .65-.65v-7.5a.65.65 0 0 0-.65-.65M3.75 3A2.25 2.25 0 0 0 1.5 5.25v7.5A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25v-7.5A2.25 2.25 0 0 0 14.25 3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.25 6.7a.8.8 0 0 1 .8-.8h11.9a.8.8 0 0 1 0 1.6H3.05a.8.8 0 0 1-.8-.8M11.25 9.325a.8.8 0 0 1 .8-.8h1.4a.8.8 0 0 1 0 1.6h-1.4a.8.8 0 0 1-.8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.667 4.167H3.333a.5.5 0 0 0-.5.5v6.666a.5.5 0 0 0 .5.5h9.334a.5.5 0 0 0 .5-.5V4.667a.5.5 0 0 0-.5-.5m-9.334-1.5a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2 5.917a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M10 8.25a.75.75 0 0 1 .75-.75h1.167a.75.75 0 0 1 0 1.5H10.75a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.5 3.2h-7a.3.3 0 0 0-.3.3v5a.3.3 0 0 0 .3.3h7a.3.3 0 0 0 .3-.3v-5a.3.3 0 0 0-.3-.3M2.5 2A1.5 1.5 0 0 0 1 3.5v5A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5v-5A1.5 1.5 0 0 0 9.5 2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.5 4.9a.6.6 0 0 1 .6-.6h7.8a.6.6 0 1 1 0 1.2H2.1a.6.6 0 0 1-.6-.6M6.7 6.8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconCreditCard/IconCreditCard.tsx
var IconCreditCard = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCreditCardMonochromeExtralight,
          "monochrome|light": IconCreditCardMonochromeLight,
          "monochrome|regular": IconCreditCardMonochromeRegular,
          "monochrome|medium": IconCreditCardMonochromeMedium,
          "monochrome|semibold": IconCreditCardMonochromeSemibold,
          "monochrome|bold": IconCreditCardMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M10 8a6 6 0 0 0-6 6v3.6h40V14a6 6 0 0 0-6-6z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M44 20H4v14a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6zm-13 5.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 1 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6.667 5.333a4 4 0 0 0-4 4v2h26.666v-2a4 4 0 0 0-4-4z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M29.333 13.333H2.667v9.334a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4zM20.667 17a1 1 0 0 1 1-1H25a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5 4a3 3 0 0 0-3 3v1.3h20V7a3 3 0 0 0-3-3z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22 9.9H2V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zm-5.7 2a.8.8 0 0 0 0 1.6h2.4a.8.8 0 0 0 0-1.6z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M3.75 3A2.25 2.25 0 0 0 1.5 5.25v.875h15V5.25A2.25 2.25 0 0 0 14.25 3z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16.5 7.525h-15v5.225A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25zm-4.275 1.3a.7.7 0 1 0 0 1.4h1.8a.7.7 0 1 0 0-1.4z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M3.333 2.667a2 2 0 0 0-2 2v.8h13.334v-.8a2 2 0 0 0-2-2z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.667 6.667H1.333v4.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2zM10.933 7.8a.6.6 0 1 0 0 1.2H12.4a.6.6 0 1 0 0-1.2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconCreditCardFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.5 2A1.5 1.5 0 0 0 1 3.5v.7h10v-.7A1.5 1.5 0 0 0 9.5 2zM11 5.2H1v3.3A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5zM7 6.8a.5.5 0 0 1 .5-.5h1.2a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconCreditCardFilled/IconCreditCardFilled.tsx
var IconCreditCardFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCreditCardFilledMonochromeExtralight,
          "monochrome|light": IconCreditCardFilledMonochromeLight,
          "monochrome|regular": IconCreditCardFilledMonochromeRegular,
          "monochrome|medium": IconCreditCardFilledMonochromeMedium,
          "monochrome|semibold": IconCreditCardFilledMonochromeSemibold,
          "monochrome|bold": IconCreditCardFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCrownFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.667 39.796c0-.67.57-1.213 1.272-1.213h28.122c.702 0 1.272.544 1.272 1.213v2.039c0 1.38-1.173 2.498-2.622 2.498H11.29c-1.449 0-2.622-1.118-2.622-2.498zM41.042 7.304C44.284 7.059 47 9.654 47 12.876a5.59 5.59 0 0 1-3.883 5.336l-4.008 17.24a1.374 1.374 0 0 1-1.36 1.215H10.313a1.374 1.374 0 0 1-1.36-1.212L4.903 18.218A5.59 5.59 0 0 1 1 12.877c0-3.224 2.716-5.819 5.959-5.574 2.687.203 4.863 2.38 5.09 5.093a5.6 5.6 0 0 1-1.331 4.133l6.321 2.576 4.205-2.622a5.6 5.6 0 0 1-2.865-4.894c0-3.223 2.717-5.819 5.96-5.573 2.694.205 4.874 2.393 5.09 5.113a5.6 5.6 0 0 1-2.988 5.43l4.085 2.546 6.646-2.708a5.6 5.6 0 0 1-1.229-3.88c.173-2.762 2.367-5.007 5.1-5.213" })
        }
      );
    }
  )
);
var IconCrownFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.222 25.551c0-.427.364-.773.812-.773h17.932c.448 0 .812.346.812.773v1.3c0 .88-.748 1.594-1.672 1.594H7.894c-.923 0-1.672-.714-1.672-1.594zm20.645-20.72c2.067-.156 3.8 1.499 3.8 3.554a3.57 3.57 0 0 1-2.477 3.402l-2.556 10.994a.876.876 0 0 1-.866.775H7.272a.876.876 0 0 1-.867-.773L3.821 11.791a3.57 3.57 0 0 1-2.488-3.406c0-2.055 1.732-3.71 3.8-3.554 1.714.13 3.101 1.518 3.246 3.247a3.57 3.57 0 0 1-.849 2.636l4.031 1.643 2.682-1.672a3.57 3.57 0 0 1-1.827-3.12c0-2.057 1.732-3.711 3.8-3.555 1.718.13 3.108 1.526 3.246 3.26a3.57 3.57 0 0 1-1.905 3.463l2.604 1.624L24.4 10.63a3.57 3.57 0 0 1-.783-2.475c.11-1.76 1.51-3.192 3.251-3.324" })
        }
      );
    }
  )
);
var IconCrownFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.667 19.163c0-.32.272-.58.608-.58h13.45c.336 0 .608.26.608.58v.975c0 .66-.56 1.195-1.254 1.195H5.921c-.693 0-1.254-.534-1.254-1.195zM20.15 3.623C21.7 3.508 23 4.748 23 6.29a2.675 2.675 0 0 1-1.857 2.551l-1.917 8.246a.657.657 0 0 1-.65.58H5.454a.66.66 0 0 1-.65-.579L2.866 8.843A2.675 2.675 0 0 1 1 6.29c0-1.542 1.3-2.783 2.85-2.666 1.285.097 2.326 1.139 2.434 2.436a2.68 2.68 0 0 1-.636 1.977L8.67 9.268l2.011-1.254a2.68 2.68 0 0 1-1.37-2.34c0-1.543 1.3-2.784 2.85-2.666 1.288.098 2.331 1.144 2.435 2.445a2.68 2.68 0 0 1-1.43 2.597l1.954 1.218 3.178-1.296a2.68 2.68 0 0 1-.587-1.856c.082-1.32 1.132-2.394 2.439-2.492" })
        }
      );
    }
  )
);
var IconCrownFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 14.725c0-.262.223-.475.498-.475h11.004c.275 0 .498.213.498.475v.797c0 .54-.46.978-1.026.978H4.026C3.459 16.5 3 16.063 3 15.522zM15.669 2.01C16.937 1.914 18 2.93 18 4.19c0 .98-.64 1.81-1.52 2.089l-1.568 6.746a.54.54 0 0 1-.532.475H3.644a.54.54 0 0 1-.532-.474L1.527 6.281A2.19 2.19 0 0 1 0 4.191C0 2.93 1.063 1.914 2.332 2.01a2.18 2.18 0 0 1 1.991 1.993 2.2 2.2 0 0 1-.52 1.617l2.473 1.008 1.646-1.026A2.19 2.19 0 0 1 6.8 3.687c0-1.261 1.063-2.277 2.332-2.18a2.18 2.18 0 0 1 1.992 2 2.19 2.19 0 0 1-1.17 2.125l1.598.996 2.601-1.06a2.2 2.2 0 0 1-.48-1.518 2.18 2.18 0 0 1 1.995-2.04" })
        }
      );
    }
  )
);
var IconCrownFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.667 13.089c0-.234.198-.422.442-.422h9.782c.244 0 .442.188.442.422v.708c0 .48-.408.87-.912.87H3.58c-.504 0-.912-.39-.912-.87zm11.26-11.302A1.935 1.935 0 0 1 16 3.725c0 .87-.569 1.609-1.35 1.856l-1.395 5.996a.48.48 0 0 1-.473.423H3.24a.48.48 0 0 1-.472-.421l-1.41-5.996A1.945 1.945 0 0 1 0 3.725c0-1.121.945-2.024 2.073-1.939a1.95 1.95 0 0 1 1.308 3.21l2.198.896L7.04 4.98a1.95 1.95 0 0 1-.996-1.703c0-1.12.945-2.024 2.073-1.938a1.94 1.94 0 0 1 1.77 1.778A1.95 1.95 0 0 1 8.85 5.006l1.42.886 2.313-.942a1.95 1.95 0 0 1-.428-1.35 1.94 1.94 0 0 1 1.774-1.813" })
        }
      );
    }
  )
);
var IconCrownFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2 9.816c0-.174.149-.316.332-.316h7.336c.183 0 .332.142.332.316v.532c0 .36-.306.652-.684.652H2.684C2.306 11 2 10.708 2 10.348zm8.446-8.476A1.45 1.45 0 0 1 12 2.794a1.46 1.46 0 0 1-1.013 1.392L9.941 8.683A.36.36 0 0 1 9.587 9H2.429a.36.36 0 0 1-.354-.316L1.018 4.187A1.46 1.46 0 0 1 0 2.794c0-.841.709-1.518 1.554-1.454a1.455 1.455 0 0 1 1.263 1.903c-.06.185-.155.356-.282.504l1.65.672 1.096-.684a1.46 1.46 0 0 1-.747-1.277c0-.84.708-1.518 1.555-1.454a1.462 1.462 0 0 1 .548 2.75l1.065.665 1.734-.707a1.461 1.461 0 0 1 1.01-2.372" })
        }
      );
    }
  )
);

// src/IconCrownFilled/IconCrownFilled.tsx
var IconCrownFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCrownFilledMonochromeExtralight,
          "monochrome|light": IconCrownFilledMonochromeLight,
          "monochrome|regular": IconCrownFilledMonochromeRegular,
          "monochrome|medium": IconCrownFilledMonochromeMedium,
          "monochrome|semibold": IconCrownFilledMonochromeSemibold,
          "monochrome|bold": IconCrownFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M213.813 52.963a52 52 0 0 1 52 0l122.813 70.906a52 52 0 0 1 26 45.033v110.245l-12.996-24.535c-2.621-4.948-6.541-8.457-11.004-10.529v-75.181q0-1.132-.091-2.25l-138.509 80.085-.2 160.175a28 28 0 0 0 1.987-1.043l37.962-21.918 25.033 13.261-50.995 29.441a52 52 0 0 1-52 .001L91 355.747a52 52 0 0 1-26-45.033V168.902a52 52 0 0 1 26-45.033zm40 20.784a28 28 0 0 0-28 0L103 144.653q-.983.569-1.907 1.206l138.903 80.076.005-.003.03.017 138.51-80.084a28 28 0 0 0-1.915-1.212zm-25.987 333.178.2-160.188-138.935-80.094q-.09 1.121-.09 2.259L89 310.714a28 28 0 0 0 14 24.249l122.813 70.906q.99.572 2.013 1.056",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.543 325.453q.72.72 1.51 1.417c6.72 5.927 17.128 10.6 28.234 14.065l.133.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.835.91l.037.021c.357.207 2.071 1.2 3.226 3.16.715 1.213 1.496 3.012 1.496 5.281s-.781 4.069-1.496 5.282c-1.155 1.959-2.869 2.953-3.226 3.16l-.037.021c-.647.381-1.308.684-1.835.909-1.084.464-2.451.957-3.965 1.471-3.042 1.034-7.449 2.409-13.114 4.177l-.134.041c-11.976 3.737-23.14 8.879-29.744 15.482-6.604 6.604-11.745 17.768-15.482 29.744l-.041.134-.002.006c-1.767 5.663-3.142 10.067-4.175 13.108-.514 1.514-1.007 2.881-1.471 3.965a17 17 0 0 1-.909 1.836l-.021.036c-.208.357-1.201 2.071-3.16 3.226-1.213.715-3.013 1.496-5.282 1.496s-4.068-.781-5.282-1.496c-1.959-1.155-2.952-2.869-3.159-3.226l-.022-.036a17 17 0 0 1-.909-1.836c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.737-11.976-8.878-23.14-15.482-29.744-1.687-1.687-3.672-3.279-5.892-4.776-6.469-4.363-14.936-7.923-23.852-10.706l-.133-.041-.006-.002-3.498-1.093c-4.007-1.253-7.228-2.272-9.611-3.082-1.514-.514-2.881-1.007-3.964-1.471a16 16 0 0 1-1.836-.909l-.037-.021c-.357-.207-2.071-1.201-3.226-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.281c1.155-1.96 2.869-2.953 3.226-3.16l.037-.021a16 16 0 0 1 1.836-.91c1.083-.464 2.45-.957 3.964-1.471 3.042-1.033 7.449-2.408 13.115-4.176l.133-.042c11.976-3.737 23.14-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.042-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.007-2.881 1.471-3.964.226-.528.529-1.189.909-1.836l.022-.036c.207-.358 1.2-2.072 3.159-3.227 1.214-.715 3.013-1.496 5.282-1.496s4.069.781 5.282 1.496c1.959 1.155 2.952 2.869 3.16 3.227l.021.036c.38.647.683 1.308.909 1.836.398.929.818 2.068 1.254 3.329l.217.635c1.033 3.042 2.408 7.449 4.176 13.115l.042.133c3.737 11.976 8.878 23.141 15.482 29.744" })
          ]
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M212.312 50.376a55 55 0 0 1 55 0l122.813 70.906a55 55 0 0 1 27.5 47.632v115.908l-15.996-30.198c-3.194-6.031-8.318-9.925-14.004-11.682v-71.13l-132.602 76.669-.191 153.347 33.813-19.522 31.291 16.575-52.624 30.382a55 55 0 0 1-55 0L89.499 358.357A55 55 0 0 1 62 310.726V168.914a55 55 0 0 1 27.5-47.632zm40 25.981a25 25 0 0 0-25 0l-120.307 69.46 132.989 76.666.007-.004.029.017 132.605-76.671zm-27.48 325.494.191-153.37L92 171.794v138.932a25 25 0 0 0 12.5 21.651z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.543 325.465a37 37 0 0 0 3.995 3.43c6.661 4.982 15.932 8.989 25.749 12.052l.133.041c5.666 1.768 10.072 3.144 13.115 4.177 1.514.514 2.881 1.007 3.964 1.471.527.226 1.188.529 1.836.909l.036.021c.358.208 2.071 1.201 3.227 3.16.715 1.213 1.495 3.013 1.495 5.282s-.78 4.068-1.495 5.282c-1.156 1.959-2.869 2.952-3.227 3.159l-.036.022c-.648.38-1.309.683-1.836.909-1.083.464-2.45.957-3.964 1.471-3.043 1.033-7.449 2.408-13.115 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.744 15.482s-11.745 17.768-15.482 29.744l-.042.133-.002.007c-1.767 5.662-3.141 10.067-4.174 13.108-.514 1.514-1.008 2.881-1.471 3.965a16 16 0 0 1-.91 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.012 1.496-5.281 1.496-2.27 0-4.069-.781-5.282-1.496-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.909-1.835c-.464-1.084-.957-2.451-1.472-3.965-1.033-3.042-2.408-7.448-4.175-13.113l-.001-.002-.041-.133c-3.738-11.976-8.879-23.14-15.482-29.744a36 36 0 0 0-3.234-2.847c-6.706-5.254-16.314-9.453-26.511-12.635l-.133-.042-.005-.001c-2.765-.863-5.231-1.633-7.384-2.314a296 296 0 0 1-5.725-1.861c-1.514-.514-2.881-1.007-3.965-1.471a17 17 0 0 1-1.836-.909l-.036-.022c-.357-.207-2.071-1.2-3.226-3.159-.716-1.214-1.496-3.013-1.496-5.282s.78-4.069 1.496-5.282c1.155-1.959 2.869-2.952 3.226-3.16l.036-.021c.648-.38 1.309-.683 1.836-.909 1.084-.464 2.451-.957 3.965-1.471 3.042-1.033 7.449-2.409 13.115-4.177l.132-.041c11.977-3.737 23.141-8.878 29.745-15.482 6.603-6.604 11.744-17.768 15.482-29.744l.041-.133c1.768-5.666 3.143-10.073 4.176-13.115.515-1.514 1.008-2.881 1.472-3.965.225-.527.528-1.188.909-1.835l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.282-1.496s4.068.781 5.281 1.496a8.8 8.8 0 0 1 2.344 2.042c.454.559.72 1.018.816 1.184l.021.037c.381.647.684 1.308.91 1.835.463 1.084.957 2.451 1.471 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.042.134c3.737 11.976 8.878 23.14 15.482 29.744" })
          ]
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M210.813 47.77a58 58 0 0 1 58 0l122.813 70.907a58 58 0 0 1 29 50.229v121.571l-18.996-35.861c-3.748-7.076-10.152-11.21-17.004-12.403v-65.209l-126.604 73.201-.183 146.415 27.678-15.98 37.549 19.89-54.253 31.324a58 58 0 0 1-58 0L88 360.948a58 58 0 0 1-29-50.23V168.906a58 58 0 0 1 29-50.23zm40 31.177a22 22 0 0 0-22 0l-115.804 66.86 126.984 73.205.008-.005.029.016 126.609-73.204zM221.839 396.65l.183-146.445L95 176.979v133.739a22 22 0 0 0 11 19.053z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.543 325.457c1.851 1.851 4.06 3.587 6.545 5.209 6.381 4.166 14.58 7.583 23.2 10.273l.132.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.836.91l.036.021c.357.207 2.071 1.2 3.226 3.159.716 1.214 1.496 3.013 1.496 5.282s-.78 4.069-1.496 5.282c-1.155 1.959-2.869 2.952-3.226 3.16l-.036.021c-.648.38-1.309.684-1.836.909-1.084.464-2.451.957-3.965 1.471-3.042 1.033-7.448 2.409-13.114 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.744l-.041.134-.002.006c-1.767 5.662-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.881-1.472 3.965a16 16 0 0 1-.909 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.013 1.496-5.282 1.496s-4.068-.781-5.281-1.496c-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.91-1.835c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.737-11.976-8.878-23.14-15.482-29.744a34 34 0 0 0-.81-.782c-6.684-6.229-17.434-11.111-28.934-14.7l-.133-.041-.006-.002c-4.592-1.433-8.357-2.608-11.239-3.552a171 171 0 0 1-1.87-.623c-1.514-.514-2.881-1.007-3.964-1.471a16 16 0 0 1-1.836-.909l-.036-.021c-.358-.208-2.071-1.201-3.227-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.282c1.156-1.959 2.869-2.952 3.227-3.159l.036-.021a16 16 0 0 1 1.836-.91c1.083-.464 2.45-.957 3.964-1.471 3.043-1.033 7.449-2.408 13.115-4.176l.133-.042c11.977-3.737 23.141-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.042-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.007-2.881 1.471-3.964.226-.528.529-1.189.91-1.836l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.281-1.496 1.891 0 3.455.542 4.626 1.136q.352.18.656.36c1.96 1.155 2.953 2.869 3.16 3.226l.021.037c.381.647.684 1.308.909 1.836.464 1.083.957 2.45 1.472 3.964 1.033 3.042 2.408 7.449 4.176 13.114l.041.134c3.738 11.976 8.879 23.14 15.482 29.744" })
          ]
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M209.145 44.884a61.34 61.34 0 0 1 61.335 0l122.813 70.906a61.33 61.33 0 0 1 30.667 53.118l.001 127.868-22.332-42.157c-4.351-8.215-12.283-12.465-20.339-12.75v-59.083l-119.936 69.346-.173 138.709 20.856-12.041 42.892 22.721q.792.419 1.546.894l-55.995 32.329a61.34 61.34 0 0 1-61.335 0L86.332 363.838a61.34 61.34 0 0 1-30.667-53.118V168.908a61.34 61.34 0 0 1 30.667-53.118zm40 36.954a18.67 18.67 0 0 0-18.665 0l-110.797 63.969 120.308 69.356.01-.006.028.016 119.943-69.349zM218.511 390.88l-110.844-63.996a18.66 18.66 0 0 1-9.332-16.164V182.753l120.349 69.38z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.543 325.46c2.543 2.543 5.762 4.869 9.443 6.982 5.879 3.373 12.936 6.202 20.301 8.5l.133.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.964 1.471.528.226 1.189.529 1.836.909l.036.022c.358.207 2.072 1.2 3.227 3.159.715 1.214 1.496 3.013 1.496 5.282s-.781 4.069-1.496 5.282c-1.155 1.959-2.869 2.952-3.227 3.16l-.036.021c-.647.38-1.308.684-1.836.909-1.083.464-2.45.957-3.964 1.471-3.042 1.033-7.449 2.409-13.115 4.176l-.133.042c-11.976 3.737-23.141 8.878-29.744 15.482s-11.745 17.768-15.482 29.744l-.042.133-.002.007c-1.767 5.662-3.141 10.067-4.174 13.108-.514 1.514-1.007 2.881-1.471 3.965a16 16 0 0 1-.91 1.835l-.021.037c-.207.357-1.2 2.071-3.159 3.226-1.214.715-3.013 1.496-5.282 1.496s-4.069-.781-5.282-1.496c-1.959-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.909-1.835c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113l-.001-.002-.041-.133c-3.435-11.007-8.055-21.328-13.907-28.053a34 34 0 0 0-1.575-1.691c-6.604-6.604-17.768-11.745-29.744-15.482l-.134-.042-.007-.002-.006-.002c-5.659-1.766-10.061-3.139-13.101-4.172a84 84 0 0 1-2.31-.816 37 37 0 0 1-1.655-.655 16 16 0 0 1-1.836-.909l-.036-.021c-.357-.208-2.071-1.201-3.226-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.282c1.155-1.959 2.869-2.952 3.226-3.159l.036-.022c.648-.38 1.309-.683 1.836-.909 1.084-.464 2.451-.957 3.965-1.471 3.042-1.033 7.449-2.408 13.115-4.176l.133-.042c11.976-3.737 23.14-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.041-.133c1.768-5.666 3.143-10.073 4.177-13.115.514-1.514 1.007-2.881 1.471-3.965.225-.527.528-1.188.909-1.835l.021-.037c.207-.357 1.201-2.071 3.16-3.226 1.213-.715 3.013-1.496 5.282-1.496.449 0 .879.031 1.29.085 1.668.222 3.018.837 3.992 1.411 1.959 1.155 2.952 2.869 3.159 3.226l.021.037c.381.647.684 1.308.91 1.835.464 1.084.957 2.451 1.471 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.042.134c3.737 11.976 8.878 23.14 15.482 29.744" })
          ]
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M208.562 43.881a62.5 62.5 0 0 1 62.5 0l122.813 70.906a62.5 62.5 0 0 1 31.25 54.127v130.067l-23.496-44.357c-4.561-8.611-13.056-12.866-21.504-12.764v-57.048l-117.607 67.999-.17 136.017 18.474-10.666 44.107 23.364q1.37.726 2.627 1.616l-56.494 32.616a62.5 62.5 0 0 1-62.5 0L85.749 364.852a62.5 62.5 0 0 1-31.25-54.126V168.914a62.5 62.5 0 0 1 31.25-54.127zm40 38.971a17.5 17.5 0 0 0-17.5 0l-109.048 62.96 117.976 68.012.011-.006.027.016 117.615-68.004zM217.348 388.87l.17-136.059L99.5 184.775v125.951a17.5 17.5 0 0 0 8.75 15.155z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.542 325.465c2.777 2.777 6.36 5.295 10.471 7.559 5.665 3.12 12.333 5.757 19.274 7.923l.132.041c5.666 1.768 10.073 3.144 13.115 4.177 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.836.909l.036.021c.357.208 2.071 1.201 3.226 3.16.716 1.213 1.496 3.013 1.496 5.282s-.78 4.068-1.496 5.282c-1.155 1.959-2.869 2.952-3.226 3.159l-.036.022c-.648.38-1.309.683-1.836.909-1.084.464-2.451.957-3.965 1.471-3.042 1.033-7.448 2.408-13.114 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.744l-.041.133-.002.007c-1.767 5.662-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.881-1.472 3.965a16 16 0 0 1-.909 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.012 1.496-5.282 1.496s-4.068-.781-5.281-1.496c-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.91-1.835c-.463-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.284-10.524-7.652-20.421-13.144-27.147a35 35 0 0 0-2.338-2.597c-6.603-6.604-17.767-11.745-29.744-15.482l-.133-.042-.007-.002-.006-.002c-5.659-1.766-10.062-3.139-13.102-4.172-1.392-.473-2.66-.928-3.697-1.359q-.136-.056-.267-.112a17 17 0 0 1-1.836-.909l-.036-.022c-.358-.207-2.071-1.2-3.226-3.159-.716-1.214-1.496-3.013-1.496-5.282s.78-4.069 1.496-5.282c1.155-1.959 2.868-2.952 3.226-3.16l.036-.021c.648-.38 1.309-.683 1.836-.909 1.083-.464 2.451-.957 3.964-1.471 3.043-1.033 7.45-2.409 13.115-4.177l.133-.041c11.977-3.737 23.141-8.878 29.744-15.482s11.745-17.768 15.483-29.744l.041-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.008-2.881 1.471-3.965.226-.527.529-1.188.91-1.835l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.281-1.496l.126.001c2.21.028 3.965.793 5.156 1.495 1.96 1.155 2.953 2.869 3.16 3.226l.021.037c.381.647.684 1.308.909 1.835.464 1.084.957 2.451 1.472 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.041.134c3.738 11.976 8.879 23.14 15.482 29.744" })
          ]
        }
      );
    }
  )
);
var IconCubeBadgeSparkleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M207.813 42.559a64 64 0 0 1 64 0l122.813 70.906a64 64 0 0 1 32 55.425v132.813q-.36-.595-.686-1.21l-24.31-45.892c-4.831-9.121-14.076-13.355-23.004-12.7v-54.513l-114.608 66.265-.165 132.552 15.406-8.895 45.671 24.192a24 24 0 0 1 3.923 2.6l-57.04 32.932a64 64 0 0 1-64 0L85.001 366.128a64 64 0 0 1-32-55.426V168.89a64 64 0 0 1 32-55.425zm40 41.569a16 16 0 0 0-16 0l-106.797 61.659 114.975 66.282.011-.007.027.016 114.617-66.27zM215.852 386.25 109 324.559a16 16 0 0 1-8-13.857l.001-123.354 115.017 66.306z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M410.543 325.442c3.073 3.072 7.133 5.828 11.803 8.274 5.366 2.81 11.538 5.209 17.942 7.208l.133.041c5.665 1.768 10.072 3.143 13.114 4.176 1.514.515 2.882 1.008 3.965 1.471.527.226 1.188.529 1.836.91l.036.021c.357.207 2.071 1.2 3.226 3.16.716 1.213 1.496 3.012 1.496 5.281 0 2.27-.78 4.069-1.496 5.282-1.155 1.96-2.869 2.953-3.226 3.16l-.036.021c-.648.381-1.309.684-1.836.91-1.083.463-2.451.957-3.965 1.471-3.042 1.033-7.448 2.408-13.114 4.176l-.133.041c-11.977 3.738-23.141 8.879-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.745l-.041.133-.002.006c-1.767 5.663-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.882-1.471 3.965a16 16 0 0 1-.91 1.836l-.021.036c-.207.358-1.2 2.071-3.16 3.226-1.213.716-3.012 1.496-5.282 1.496s-4.068-.78-5.281-1.496c-1.96-1.155-2.953-2.868-3.16-3.226l-.021-.036a16 16 0 0 1-.91-1.836c-.463-1.083-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.175-13.113l-.001-.002-.041-.132c-3.096-9.919-7.154-19.281-12.208-25.956a37 37 0 0 0-3.275-3.789c-6.603-6.603-17.767-11.744-29.744-15.482l-.133-.041-.008-.003c-5.662-1.766-10.066-3.141-13.106-4.173-1.514-.514-2.882-1.008-3.965-1.471a18 18 0 0 1-1.393-.662 13 13 0 0 1-.443-.248l-.036-.021c-.358-.207-2.071-1.2-3.226-3.16-.716-1.213-1.496-3.012-1.496-5.282s.78-4.068 1.496-5.281c1.155-1.96 2.868-2.953 3.226-3.16l.036-.021a16 16 0 0 1 1.836-.91c1.083-.463 2.451-.956 3.965-1.471 3.042-1.033 7.449-2.408 13.114-4.176l.133-.041c11.977-3.738 23.141-8.879 29.744-15.482 6.604-6.604 11.745-17.768 15.483-29.745l.041-.133c1.768-5.666 3.143-10.072 4.176-13.114.514-1.514 1.008-2.882 1.471-3.965.226-.527.529-1.188.91-1.836l.021-.036c.207-.358 1.2-2.071 3.16-3.226.957-.565 2.278-1.169 3.907-1.4a10 10 0 0 1 1.374-.096c2.27 0 4.069.78 5.282 1.496 1.96 1.155 2.953 2.868 3.16 3.226l.021.036c.381.648.684 1.309.91 1.836.463 1.083.956 2.451 1.471 3.965 1.033 3.042 2.408 7.448 4.176 13.114l.041.133c3.738 11.977 8.879 23.141 15.482 29.745" })
          ]
        }
      );
    }
  )
);

// src/IconCubeBadgeSparkle/IconCubeBadgeSparkle.tsx
var IconCubeBadgeSparkle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconCubeBadgeSparkleMonochromeExtralight,
          "monochrome|light": IconCubeBadgeSparkleMonochromeLight,
          "monochrome|regular": IconCubeBadgeSparkleMonochromeRegular,
          "monochrome|medium": IconCubeBadgeSparkleMonochromeMedium,
          "monochrome|semibold": IconCubeBadgeSparkleMonochromeSemibold,
          "monochrome|bold": IconCubeBadgeSparkleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconDesktopMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.35 5.9A2.55 2.55 0 0 1 4.9 3.35h14.2a2.55 2.55 0 0 1 2.55 2.55v8.2a2.55 2.55 0 0 1-2.55 2.55H4.9a2.55 2.55 0 0 1-2.55-2.55zM4.9 4.45c-.8 0-1.45.65-1.45 1.45v8.2c0 .8.65 1.45 1.45 1.45h14.2c.8 0 1.45-.65 1.45-1.45V5.9c0-.8-.65-1.45-1.45-1.45zM7.95 20.1a.55.55 0 0 1 .55-.55h7a.55.55 0 1 1 0 1.1h-7a.55.55 0 0 1-.55-.55",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.9 19.55V16h2.2v3.55z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconDesktopMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.15 5.9A2.75 2.75 0 0 1 4.9 3.15h14.2a2.75 2.75 0 0 1 2.75 2.75v8.2a2.75 2.75 0 0 1-2.75 2.75H4.9a2.75 2.75 0 0 1-2.75-2.75zM4.9 4.65c-.69 0-1.25.56-1.25 1.25v8.2c0 .69.56 1.25 1.25 1.25h14.2c.69 0 1.25-.56 1.25-1.25V5.9c0-.69-.56-1.25-1.25-1.25zM7.75 20.1a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.5 19.7v-3.55h3v3.55z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconDesktopMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2 5.9A2.9 2.9 0 0 1 4.9 3h14.2A2.9 2.9 0 0 1 22 5.9v8.2a2.9 2.9 0 0 1-2.9 2.9H4.9A2.9 2.9 0 0 1 2 14.1zm2.9-1.1a1.1 1.1 0 0 0-1.1 1.1v8.2a1.1 1.1 0 0 0 1.1 1.1h14.2a1.1 1.1 0 0 0 1.1-1.1V5.9a1.1 1.1 0 0 0-1.1-1.1zM7.6 20.1a.9.9 0 0 1 .9-.9h7a.9.9 0 1 1 0 1.8h-7a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.1 19.7v-3.55h3.6v3.55z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconDesktopMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.833 5.9A3.067 3.067 0 0 1 4.9 2.833h14.2A3.067 3.067 0 0 1 22.167 5.9v8.2a3.067 3.067 0 0 1-3.067 3.067H4.9A3.067 3.067 0 0 1 1.833 14.1zM4.9 4.967a.933.933 0 0 0-.933.933v8.2c0 .516.418.933.933.933h14.2a.933.933 0 0 0 .933-.933V5.9a.933.933 0 0 0-.933-.933zM7.433 20.1c0-.59.478-1.067 1.067-1.067h7a1.067 1.067 0 1 1 0 2.134h-7c-.59 0-1.067-.478-1.067-1.067",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.867 20.15v-4h4.266v4z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconDesktopMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.775 5.9c0-1.726 1.4-3.125 3.125-3.125h14.2c1.726 0 3.125 1.4 3.125 3.125v8.2c0 1.726-1.4 3.125-3.125 3.125H4.9A3.125 3.125 0 0 1 1.775 14.1zM4.9 5.025a.875.875 0 0 0-.875.875v8.2c0 .483.392.875.875.875h14.2a.875.875 0 0 0 .875-.875V5.9a.875.875 0 0 0-.875-.875zM7.375 20.1c0-.621.504-1.125 1.125-1.125h7a1.125 1.125 0 0 1 0 2.25h-7A1.125 1.125 0 0 1 7.375 20.1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.75 19.7v-3.55h4.5v3.55z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconDesktopMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.7 5.9a3.2 3.2 0 0 1 3.2-3.2h14.2a3.2 3.2 0 0 1 3.2 3.2v8.2a3.2 3.2 0 0 1-3.2 3.2H4.9a3.2 3.2 0 0 1-3.2-3.2zm3.2-.8a.8.8 0 0 0-.8.8v8.2a.8.8 0 0 0 .8.8h14.2a.8.8 0 0 0 .8-.8V5.9a.8.8 0 0 0-.8-.8zM7.3 20.1a1.2 1.2 0 0 1 1.2-1.2h7a1.2 1.2 0 1 1 0 2.4h-7a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.6 19.7v-3.55h4.8v3.55z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconDesktop/IconDesktop.tsx
var IconDesktop = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconDesktopMonochromeExtralight,
          "monochrome|light": IconDesktopMonochromeLight,
          "monochrome|regular": IconDesktopMonochromeRegular,
          "monochrome|medium": IconDesktopMonochromeMedium,
          "monochrome|semibold": IconDesktopMonochromeSemibold,
          "monochrome|bold": IconDesktopMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.452 12.487c-.39 2.195-1.99 4.004-4.31 4.634a.6.6 0 0 0 .315 1.158c3.033-.824 5.067-3.36 5.27-6.351a7.5 7.5 0 0 0-.085-1.726c-.114-.686-.266-1.256-.512-1.8-.246-.543-.575-1.033-1.016-1.57l-.034-.038A3.94 3.94 0 0 0 6.25 5.6C4.105 5.6 2.3 7.183 2.3 9.4c0 2.045 1.347 4.2 3.65 4.2.566 0 1.168-.145 1.705-.368a4.6 4.6 0 0 0 1.232-.745zM20.452 12.487c-.39 2.195-1.99 4.004-4.31 4.634a.6.6 0 0 0 .315 1.158c3.033-.824 5.067-3.36 5.27-6.351a7.5 7.5 0 0 0-.085-1.726c-.114-.686-.266-1.256-.512-1.8-.246-.543-.575-1.033-1.016-1.57l-.034-.038A3.94 3.94 0 0 0 17.25 5.6c-2.145 0-3.95 1.583-3.95 3.8 0 2.045 1.347 4.2 3.65 4.2.566 0 1.168-.145 1.705-.368a4.6 4.6 0 0 0 1.232-.745z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.27 12.637c-.432 2.058-1.966 3.741-4.167 4.34a.75.75 0 0 0 .394 1.447c3.094-.84 5.172-3.431 5.38-6.486a7.6 7.6 0 0 0-.087-1.76c-.115-.695-.27-1.279-.523-1.837-.254-.56-.591-1.06-1.037-1.604l-.043-.048A4.1 4.1 0 0 0 6.25 5.45c-2.219 0-4.1 1.641-4.1 3.95 0 2.094 1.384 4.35 3.8 4.35.59 0 1.212-.15 1.763-.38a4.8 4.8 0 0 0 1.23-.733zM20.27 12.637c-.432 2.058-1.966 3.741-4.167 4.34a.75.75 0 0 0 .393 1.447c3.095-.84 5.174-3.431 5.381-6.486a7.6 7.6 0 0 0-.087-1.76c-.115-.695-.27-1.279-.523-1.837-.254-.56-.591-1.06-1.037-1.604l-.043-.048A4.1 4.1 0 0 0 17.25 5.45c-2.219 0-4.1 1.641-4.1 3.95 0 2.094 1.384 4.35 3.8 4.35.59 0 1.212-.15 1.763-.38a4.8 4.8 0 0 0 1.23-.733z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.082 12.787c-.47 1.92-1.937 3.48-4.018 4.044a.9.9 0 0 0 .472 1.737c3.155-.857 5.279-3.501 5.49-6.62a7.8 7.8 0 0 0-.088-1.795c-.117-.702-.274-1.3-.535-1.874-.26-.575-.606-1.087-1.057-1.637l-.051-.057A4.24 4.24 0 0 0 6.25 5.3C3.958 5.3 2 7 2 9.4c0 2.143 1.42 4.5 3.95 4.5.614 0 1.255-.156 1.82-.391a5 5 0 0 0 1.227-.722zM20.082 12.787c-.47 1.92-1.937 3.48-4.018 4.044a.9.9 0 0 0 .472 1.737c3.155-.857 5.279-3.501 5.49-6.62a7.8 7.8 0 0 0-.088-1.795c-.117-.702-.274-1.3-.535-1.874-.26-.575-.606-1.087-1.057-1.637l-.051-.057A4.24 4.24 0 0 0 17.25 5.3C14.958 5.3 13 7 13 9.4c0 2.143 1.42 4.5 3.95 4.5.614 0 1.255-.156 1.82-.391a5 5 0 0 0 1.227-.722z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.81 13.136c-.306.21-.64.387-.976.526-.58.242-1.243.404-1.884.404-2.655 0-4.117-2.47-4.117-4.667 0-2.502 2.043-4.266 4.417-4.266 1.24 0 2.363.513 3.164 1.335q.032.033.06.068c.458.557.813 1.081 1.081 1.673s.43 1.205.547 1.916q.154.932.09 1.834c-.216 3.19-2.389 5.894-5.612 6.77a1.067 1.067 0 0 1-.56-2.059c1.88-.51 3.24-1.852 3.79-3.534M19.81 13.136c-.306.21-.64.387-.976.526-.58.242-1.243.404-1.884.404-2.655 0-4.117-2.47-4.117-4.667 0-2.502 2.043-4.266 4.417-4.266 1.24 0 2.363.513 3.164 1.335q.032.033.06.068c.458.557.813 1.081 1.081 1.673s.43 1.205.547 1.916q.154.932.09 1.834c-.216 3.19-2.389 5.894-5.613 6.77a1.067 1.067 0 1 1-.559-2.059c1.88-.51 3.24-1.852 3.79-3.534",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.698 13.28a5.5 5.5 0 0 1-.841.437c-.586.244-1.256.409-1.907.409-2.699 0-4.175-2.51-4.175-4.725 0-2.538 2.073-4.325 4.475-4.325 1.257 0 2.395.52 3.206 1.352q.034.034.064.072c.46.56.818 1.089 1.089 1.686.27.598.433 1.216.551 1.93.104.625.133 1.244.091 1.848-.218 3.215-2.408 5.94-5.656 6.822a1.125 1.125 0 1 1-.59-2.171c1.8-.489 3.118-1.747 3.693-3.334M19.698 13.28a5.5 5.5 0 0 1-.841.437c-.586.244-1.256.409-1.907.409-2.699 0-4.175-2.51-4.175-4.725 0-2.538 2.073-4.325 4.475-4.325 1.257 0 2.395.52 3.206 1.352q.034.034.064.072c.46.56.817 1.089 1.089 1.686.27.598.433 1.216.551 1.93.104.625.133 1.244.091 1.848-.218 3.215-2.408 5.94-5.656 6.822a1.125 1.125 0 0 1-.59-2.171c1.8-.489 3.118-1.747 3.693-3.334",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteClosingMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.548 13.459a6 6 0 0 1-.663.327c-.593.246-1.273.414-1.935.414-2.756 0-4.25-2.56-4.25-4.8C1.7 6.816 3.81 5 6.25 5a4.54 4.54 0 0 1 3.26 1.375q.035.037.067.076c.462.563.825 1.098 1.1 1.704.274.605.438 1.23.557 1.949q.155.947.092 1.865c-.22 3.247-2.433 5.999-5.712 6.889a1.2 1.2 0 1 1-.629-2.316c1.698-.461 2.96-1.615 3.563-3.084M19.548 13.459c-.215.125-.439.234-.663.327-.593.246-1.273.414-1.935.414-2.756 0-4.25-2.56-4.25-4.8 0-2.584 2.11-4.4 4.55-4.4a4.54 4.54 0 0 1 3.26 1.375q.035.037.067.076c.462.563.825 1.098 1.1 1.704.274.605.438 1.23.557 1.949q.155.947.092 1.865c-.22 3.247-2.433 5.999-5.712 6.889a1.2 1.2 0 1 1-.629-2.316c1.698-.461 2.96-1.615 3.563-3.084",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconDoubleQuoteClosing/IconDoubleQuoteClosing.tsx
var IconDoubleQuoteClosing = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconDoubleQuoteClosingMonochromeExtralight,
          "monochrome|light": IconDoubleQuoteClosingMonochromeLight,
          "monochrome|regular": IconDoubleQuoteClosingMonochromeRegular,
          "monochrome|medium": IconDoubleQuoteClosingMonochromeMedium,
          "monochrome|semibold": IconDoubleQuoteClosingMonochromeSemibold,
          "monochrome|bold": IconDoubleQuoteClosingMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.23 6.143a.6.6 0 0 1-.422.736c-2.32.63-3.92 2.439-4.31 4.634h.565a4.6 4.6 0 0 1 1.232-.745c.537-.223 1.139-.368 1.705-.368 2.303 0 3.65 2.154 3.65 4.2 0 2.217-1.805 3.8-3.95 3.8a3.94 3.94 0 0 1-2.864-1.232c-.44-.537-.77-1.028-1.016-1.57-.246-.544-.398-1.114-.512-1.8a7.5 7.5 0 0 1-.085-1.726c.203-2.99 2.237-5.527 5.27-6.351a.6.6 0 0 1 .736.422m-11 0a.6.6 0 0 1-.423.736c-2.319.63-3.919 2.439-4.309 4.634h.565a4.6 4.6 0 0 1 1.232-.745C5.832 10.545 6.434 10.4 7 10.4c2.303 0 3.65 2.154 3.65 4.2 0 2.217-1.805 3.8-3.95 3.8a3.94 3.94 0 0 1-2.864-1.232c-.44-.537-.77-1.028-1.016-1.57-.246-.544-.398-1.114-.512-1.8a7.5 7.5 0 0 1-.085-1.726c.203-2.99 2.237-5.527 5.27-6.351a.6.6 0 0 1 .736.422",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.374 6.103a.75.75 0 0 1-.527.92c-2.2.598-3.735 2.281-4.167 4.34h.327c.356-.3.788-.55 1.23-.734.551-.229 1.173-.38 1.763-.38 2.416 0 3.8 2.256 3.8 4.35 0 2.31-1.881 3.95-4.1 3.95a4.1 4.1 0 0 1-2.98-1.286c-.446-.544-.783-1.045-1.037-1.604s-.408-1.143-.523-1.837a7.6 7.6 0 0 1-.087-1.76c.207-3.055 2.286-5.646 5.38-6.486a.75.75 0 0 1 .92.527m-11 0a.75.75 0 0 1-.527.92c-2.2.598-3.735 2.281-4.167 4.34h.327c.356-.3.788-.55 1.23-.734.551-.229 1.173-.38 1.763-.38 2.416 0 3.8 2.256 3.8 4.35 0 2.31-1.882 3.95-4.1 3.95a4.1 4.1 0 0 1-2.98-1.286c-.446-.544-.783-1.045-1.037-1.604s-.408-1.143-.523-1.837a7.6 7.6 0 0 1-.087-1.76c.208-3.055 2.286-5.646 5.38-6.486a.75.75 0 0 1 .92.527",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.518 6.064a.9.9 0 0 1-.632 1.104c-2.081.565-3.547 2.124-4.018 4.044h.085c.362-.296.79-.54 1.227-.721.564-.235 1.206-.391 1.82-.391 2.53 0 3.95 2.357 3.95 4.5 0 2.4-1.958 4.1-4.25 4.1a4.24 4.24 0 0 1-3.045-1.285l-.05-.057c-.452-.55-.798-1.063-1.059-1.637s-.418-1.172-.534-1.874a7.8 7.8 0 0 1-.089-1.796c.212-3.118 2.335-5.763 5.491-6.62a.9.9 0 0 1 1.104.633m-11 0a.9.9 0 0 1-.632 1.104c-2.081.565-3.548 2.124-4.018 4.044h.085c.362-.296.79-.54 1.227-.721.565-.235 1.206-.391 1.82-.391 2.53 0 3.95 2.357 3.95 4.5 0 2.4-1.958 4.1-4.25 4.1a4.24 4.24 0 0 1-3.045-1.285l-.05-.057c-.452-.55-.798-1.063-1.058-1.637-.261-.575-.419-1.172-.535-1.874a7.8 7.8 0 0 1-.089-1.796c.212-3.118 2.335-5.763 5.491-6.62a.9.9 0 0 1 1.104.633",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.68 6.02a1.067 1.067 0 0 1-.75 1.31c-1.88.51-3.24 1.852-3.79 3.534.306-.21.64-.387.976-.527.58-.241 1.243-.404 1.884-.404 2.655 0 4.117 2.47 4.117 4.667 0 2.502-2.043 4.267-4.417 4.267a4.4 4.4 0 0 1-3.164-1.335l-.06-.068c-.458-.557-.813-1.082-1.081-1.674s-.43-1.204-.547-1.915a8 8 0 0 1-.09-1.835c.216-3.19 2.389-5.894 5.613-6.77a1.067 1.067 0 0 1 1.308.75m-11 0a1.067 1.067 0 0 1-.75 1.31c-1.88.51-3.24 1.852-3.79 3.534.306-.21.64-.387.976-.527.58-.241 1.243-.404 1.884-.404 2.655 0 4.117 2.47 4.117 4.667 0 2.502-2.043 4.267-4.417 4.267a4.4 4.4 0 0 1-3.164-1.335l-.06-.068c-.458-.557-.813-1.082-1.081-1.674s-.43-1.204-.547-1.915a8 8 0 0 1-.09-1.835c.216-3.19 2.389-5.894 5.612-6.77a1.067 1.067 0 0 1 1.31.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.736 6.006c.163.6-.192 1.217-.791 1.38-1.8.489-3.117 1.747-3.693 3.334.268-.17.554-.317.841-.436.586-.244 1.257-.408 1.907-.408 2.7 0 4.175 2.508 4.175 4.725 0 2.538-2.072 4.324-4.475 4.324a4.47 4.47 0 0 1-3.206-1.352 1 1 0 0 1-.064-.072c-.459-.56-.817-1.088-1.088-1.686s-.433-1.216-.552-1.93a8 8 0 0 1-.091-1.848c.218-3.215 2.409-5.94 5.656-6.822.6-.163 1.218.191 1.38.79m-11 0c.163.6-.191 1.217-.791 1.38-1.8.489-3.117 1.747-3.693 3.334.268-.17.555-.317.841-.436C5.68 10.04 6.35 9.876 7 9.876c2.7 0 4.175 2.508 4.175 4.725 0 2.538-2.072 4.324-4.475 4.324a4.47 4.47 0 0 1-3.206-1.352 1 1 0 0 1-.064-.072c-.459-.56-.817-1.088-1.088-1.686s-.433-1.216-.552-1.93a8 8 0 0 1-.091-1.848c.218-3.215 2.409-5.94 5.656-6.822.6-.163 1.218.191 1.38.79",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconDoubleQuoteOpeningMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M19.808 5.986a1.2 1.2 0 0 1-.843 1.472c-1.698.461-2.96 1.615-3.564 3.083.216-.125.44-.234.664-.327.592-.246 1.273-.414 1.935-.414 2.756 0 4.25 2.56 4.25 4.8 0 2.584-2.11 4.4-4.55 4.4a4.54 4.54 0 0 1-3.26-1.375 1 1 0 0 1-.067-.076c-.462-.563-.825-1.098-1.1-1.704-.274-.605-.438-1.23-.557-1.949a8 8 0 0 1-.092-1.865c.22-3.247 2.433-5.999 5.712-6.889a1.2 1.2 0 0 1 1.472.843m-11 0a1.2 1.2 0 0 1-.843 1.472c-1.698.461-2.96 1.615-3.564 3.083a6 6 0 0 1 .664-.327C5.657 9.968 6.338 9.8 7 9.8c2.756 0 4.25 2.56 4.25 4.8 0 2.584-2.11 4.4-4.55 4.4a4.54 4.54 0 0 1-3.26-1.375 1 1 0 0 1-.068-.076c-.461-.563-.824-1.098-1.099-1.704-.274-.605-.438-1.23-.557-1.949a8 8 0 0 1-.092-1.865c.22-3.247 2.433-5.999 5.712-6.889a1.2 1.2 0 0 1 1.472.843",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconDoubleQuoteOpening/IconDoubleQuoteOpening.tsx
var IconDoubleQuoteOpening = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconDoubleQuoteOpeningMonochromeExtralight,
          "monochrome|light": IconDoubleQuoteOpeningMonochromeLight,
          "monochrome|regular": IconDoubleQuoteOpeningMonochromeRegular,
          "monochrome|medium": IconDoubleQuoteOpeningMonochromeMedium,
          "monochrome|semibold": IconDoubleQuoteOpeningMonochromeSemibold,
          "monochrome|bold": IconDoubleQuoteOpeningMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconEllipsisMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M15 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M27 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M39 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0" })
        }
      );
    }
  )
);
var IconEllipsisMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M18.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M27.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" })
        }
      );
    }
  )
);
var IconEllipsisMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M21 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0" })
        }
      );
    }
  )
);
var IconEllipsisMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.25 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M10.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.75 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
        }
      );
    }
  )
);
var IconEllipsisMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.667 8A1.333 1.333 0 1 1 2 8a1.333 1.333 0 0 1 2.667 0M9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M14 8a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 14 8" })
        }
      );
    }
  )
);
var IconEllipsisMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
        }
      );
    }
  )
);

// src/IconEllipsis/IconEllipsis.tsx
var IconEllipsis = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconEllipsisMonochromeExtralight,
          "monochrome|light": IconEllipsisMonochromeLight,
          "monochrome|regular": IconEllipsisMonochromeRegular,
          "monochrome|medium": IconEllipsisMonochromeMedium,
          "monochrome|semibold": IconEllipsisMonochromeSemibold,
          "monochrome|bold": IconEllipsisMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 21a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6" })
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M16 22.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 13.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 4.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5" })
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M12 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4" })
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9 12.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 2.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" })
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8 11.334A1.333 1.333 0 1 1 8 14a1.333 1.333 0 0 1 0-2.666M8 6.667a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667M8 2a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 8 2" })
        }
      );
    }
  )
);
var IconEllipsisVerticalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6 8.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2" })
        }
      );
    }
  )
);

// src/IconEllipsisVertical/IconEllipsisVertical.tsx
var IconEllipsisVertical = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconEllipsisVerticalMonochromeExtralight,
          "monochrome|light": IconEllipsisVerticalMonochromeLight,
          "monochrome|regular": IconEllipsisVerticalMonochromeRegular,
          "monochrome|medium": IconEllipsisVerticalMonochromeMedium,
          "monochrome|semibold": IconEllipsisVerticalMonochromeSemibold,
          "monochrome|bold": IconEllipsisVerticalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M24 18.2a1.2 1.2 0 0 1 1.2 1.2v8.4a1.2 1.2 0 0 1-2.4 0v-8.4a1.2 1.2 0 0 1 1.2-1.2M24 31.5a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.65 10.587 6.365 30.903c-2.666 4.8.804 10.697 6.294 10.697H35.23c5.49 0 8.96-5.898 6.294-10.697L30.238 10.587c-2.743-4.938-9.844-4.938-12.587 0M8.463 32.07l11.286-20.316c1.83-3.292 6.563-3.292 8.392 0l11.287 20.316c1.778 3.2-.536 7.131-4.196 7.131H12.658c-3.66 0-5.974-3.932-4.196-7.131",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1M16 20.867a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.417 6.864 3.893 20.408c-1.926 3.466.58 7.725 4.545 7.725h15.05c3.964 0 6.47-4.26 4.545-7.725L20.51 6.864c-1.982-3.567-7.11-3.567-9.092 0M5.641 21.379l7.525-13.544c1.219-2.195 4.375-2.195 5.594 0l7.525 13.544c1.185 2.133-.358 4.754-2.797 4.754H8.438c-2.44 0-3.982-2.621-2.797-4.754",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9M12 15.5a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.3 5.002 2.658 15.16c-1.555 2.8.47 6.24 3.672 6.24h11.286c3.203 0 5.227-3.44 3.672-6.24L15.643 5.002c-1.6-2.88-5.742-2.88-7.342 0M4.23 16.034 9.875 5.876c.914-1.646 3.282-1.646 4.196 0l5.643 10.158c.89 1.6-.268 3.566-2.098 3.566H6.33c-1.83 0-2.987-1.966-2.098-3.566",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6M9 11.2a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12a.8.8 0 0 1 .8-.8" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m6.182 3.315-4.573 8.23C.425 13.68 1.967 16.3 4.407 16.3h9.145c2.44 0 3.982-2.621 2.797-4.754l-4.572-8.23c-1.22-2.195-4.376-2.195-5.595 0m4.196.777 4.572 8.23a1.6 1.6 0 0 1-1.398 2.378H4.407a1.6 1.6 0 0 1-1.399-2.377l4.573-8.23c.61-1.098 2.187-1.098 2.797 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M8 5.35a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35M8 10.05a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V10.8a.75.75 0 0 1 .75-.75" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.272 3.19 1.509 9.96c-1.148 2.066.347 4.606 2.71 4.606h7.525c2.363 0 3.858-2.54 2.71-4.606L10.69 3.19c-1.18-2.126-4.238-2.126-5.42 0m-2.451 7.5 3.762-6.772c.61-1.098 2.188-1.098 2.797 0l3.762 6.772a1.6 1.6 0 0 1-1.398 2.377H4.219a1.6 1.6 0 0 1-1.398-2.377",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconExclamationTriangleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4M6 7.65a.6.6 0 0 1 .6.6v.05a.6.6 0 0 1-1.2 0v-.05a.6.6 0 0 1 .6-.6" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.888 2.356 1.066 7.435C.178 9.035 1.334 11 3.164 11h5.644c1.83 0 2.986-1.966 2.098-3.565l-2.822-5.08C7.169.71 4.802.71 3.888 2.356M3.164 9.8a1.2 1.2 0 0 1-1.049-1.783l2.822-5.079a1.2 1.2 0 0 1 2.098 0l2.822 5.08A1.2 1.2 0 0 1 8.807 9.8z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconExclamationTriangle/IconExclamationTriangle.tsx
var IconExclamationTriangle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconExclamationTriangleMonochromeExtralight,
          "monochrome|light": IconExclamationTriangleMonochromeLight,
          "monochrome|regular": IconExclamationTriangleMonochromeRegular,
          "monochrome|medium": IconExclamationTriangleMonochromeMedium,
          "monochrome|semibold": IconExclamationTriangleMonochromeSemibold,
          "monochrome|bold": IconExclamationTriangleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.364 30.903 17.65 10.587c2.743-4.938 9.844-4.938 12.587 0l11.287 20.316c2.666 4.8-.804 10.697-6.294 10.697H12.658c-5.49 0-8.96-5.898-6.294-10.697M24 18.1a1.3 1.3 0 0 1 1.3 1.3v8.4a1.3 1.3 0 1 1-2.6 0v-8.4a1.3 1.3 0 0 1 1.3-1.3m0 13.4a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m3.893 20.408 7.524-13.544c1.982-3.567 7.11-3.567 9.092 0l7.524 13.544c1.926 3.466-.58 7.725-4.546 7.725H8.439c-3.964 0-6.47-4.26-4.545-7.725M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1m0 8.934a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.657 15.16 8.301 5.002c1.6-2.88 5.742-2.88 7.342 0l5.644 10.158c1.555 2.8-.47 6.24-3.672 6.24H6.33c-3.203 0-5.227-3.44-3.672-6.24M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9m0 6.7a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m1.746 11.816 4.742-8.537c1.086-1.954 3.897-1.954 4.983 0l4.742 8.537c1.055 1.9-.318 4.234-2.491 4.234H4.237c-2.173 0-3.547-2.335-2.491-4.234M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6m0 5.4a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12.2a.8.8 0 0 1 .8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.51 9.961 5.271 3.19c1.18-2.126 4.238-2.126 5.42 0l3.762 6.772c1.147 2.067-.347 4.606-2.71 4.606H4.219c-2.363 0-3.858-2.54-2.71-4.606M8 5.351a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35m0 4.899a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V11a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconExclamationTriangleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m1.066 7.435 2.822-5.08C4.802.71 7.169.71 8.084 2.356l2.822 5.08c.888 1.6-.269 3.565-2.098 3.565H3.164c-1.83 0-2.986-1.966-2.098-3.565M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4m0 3.8a.6.6 0 0 1 .6.6v.05a.6.6 0 1 1-1.2 0V8.4a.6.6 0 0 1 .6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconExclamationTriangleFilled/IconExclamationTriangleFilled.tsx
var IconExclamationTriangleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconExclamationTriangleFilledMonochromeExtralight,
          "monochrome|light": IconExclamationTriangleFilledMonochromeLight,
          "monochrome|regular": IconExclamationTriangleFilledMonochromeRegular,
          "monochrome|medium": IconExclamationTriangleFilledMonochromeMedium,
          "monochrome|semibold": IconExclamationTriangleFilledMonochromeSemibold,
          "monochrome|bold": IconExclamationTriangleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconEyeMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240.995 186.006C283.062 186.539 317 220.806 317 263s-33.938 76.461-76.005 76.994q-.497.006-.995.006l-.995-.006C196.937 339.461 163 305.194 163 263s33.937-76.461 76.005-76.994q.497-.006.995-.006z" }),
            /* @__PURE__ */ jsx("path", { d: "M239.999 98c64.58 0 112.522 34.364 143.739 67.539 15.661 16.644 27.374 33.246 35.176 45.683 3.908 6.229 6.855 11.446 8.842 15.14a176 176 0 0 1 2.265 4.348 97 97 0 0 1 .761 1.547l.049.102.015.035.006.012c.001.006-.12.069-10.853 5.118l10.858-5.108c2.821 5.997.247 13.145-5.75 15.967-5.993 2.819-13.137.25-15.962-5.739l-.002-.004-.015-.033-.099-.206a97 97 0 0 0-.459-.926 150 150 0 0 0-1.953-3.747c-1.763-3.28-4.442-8.027-8.033-13.752-7.198-11.474-17.986-26.753-32.324-41.991C337.477 151.398 295.418 122 239.999 122c-55.33 0-97.369 29.925-126.183 61.14-14.346 15.542-25.142 31.128-32.347 42.837-3.596 5.842-6.277 10.687-8.043 14.036a156 156 0 0 0-1.959 3.827c-.21.428-.364.747-.46.948l-.099.212-.018.034c-2.779 6.013-9.904 8.637-15.92 5.862-6.017-2.778-8.644-9.907-5.867-15.924 17.832 8.229-.001.004.005-.01l.005-.013.017-.034.047-.103.165-.346c.138-.291.337-.703.594-1.226a181 181 0 0 1 2.261-4.425c1.984-3.761 4.927-9.072 8.832-15.417 7.795-12.666 19.5-29.58 35.152-46.538C127.367 133.076 175.33 98 240 98" })
          ]
        }
      );
    }
  )
);
var IconEyeMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M239.999 186C282.525 186 317 220.474 317 263s-34.475 77-77.001 77c-42.525 0-77-34.474-77-77s34.475-77 77-77" }),
            /* @__PURE__ */ jsx("path", { d: "M239.999 95c65.726 0 114.403 34.984 145.924 68.482 15.827 16.82 27.656 33.589 35.534 46.146 3.947 6.293 6.926 11.567 8.941 15.313a181 181 0 0 1 2.305 4.423q.396.792.614 1.241l.172.359.053.11.018.038.007.015c.001.006-.119.069-12.667 5.974l12.672-5.962c3.527 7.496.309 16.432-7.187 19.959-7.493 3.525-16.424.31-19.954-7.18l.003.007.001.004-.013-.029-.091-.188q-.134-.278-.441-.892a149 149 0 0 0-1.914-3.672c-1.735-3.227-4.381-7.915-7.934-13.578-7.122-11.353-17.794-26.467-31.966-41.528C335.597 153.778 294.274 125 239.999 125c-54.161 0-95.46 29.28-123.977 60.174-14.183 15.365-24.867 30.786-31.998 42.375-3.557 5.779-6.206 10.566-7.944 13.863a153 153 0 0 0-1.92 3.753c-.205.417-.352.725-.443.914l-.093.194-.006.012v.001c-3.471 7.522-12.383 10.805-19.905 7.333-7.521-3.472-10.804-12.383-7.333-19.905l13.224 6.103c-13.224-6.103-13.221-6.109-13.219-6.115l.007-.014.018-.039.052-.111.171-.362q.216-.457.612-1.261c.527-1.07 1.293-2.592 2.3-4.499 2.01-3.813 4.987-9.182 8.93-15.59 7.869-12.786 19.686-29.865 35.502-47C125.46 130.72 174.162 95 239.999 95" })
          ]
        }
      );
    }
  )
);
var IconEyeMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240.996 186.006c42.067.533 76.005 34.8 76.005 76.994 0 42.526-34.475 77-77 77l-.996-.006c-42.067-.533-76.004-34.8-76.004-76.994 0-42.526 34.474-77 77-77z" }),
            /* @__PURE__ */ jsx("path", { d: "M240.001 92c66.87 0 116.282 35.605 148.108 69.427 15.992 16.995 27.936 33.929 35.89 46.606 3.987 6.356 7 11.689 9.043 15.488 1.021 1.9 1.803 3.421 2.343 4.498q.406.809.631 1.276l.181.375.077.161.008.017c.002.007-.119.072-15.68 7.393l15.686-7.38c4.232 8.996.371 19.718-8.624 23.951-8.992 4.23-19.71.373-23.946-8.615l.004.009.003.008-.009-.02-.083-.172c-.084-.172-.225-.461-.423-.856a148 148 0 0 0-1.875-3.597c-1.708-3.175-4.32-7.806-7.832-13.405-7.047-11.233-17.604-26.181-31.611-41.066C333.718 156.157 293.13 128 240.001 128c-52.995 0-93.553 28.636-121.774 59.209-14.02 15.188-24.589 30.443-31.646 41.912-3.518 5.717-6.135 10.446-7.847 13.691a150 150 0 0 0-1.88 3.678c-.2.405-.343.701-.428.879l-.083.173.001.001c-4.166 9.026-14.86 12.966-23.886 8.801-9.026-4.166-12.967-14.861-8.801-23.887L60 240c-16.223-7.487-16.34-7.549-16.337-7.557l.008-.016.019-.042.056-.12q.067-.144.18-.38.223-.473.627-1.295a186 186 0 0 1 2.338-4.573c2.038-3.865 5.047-9.293 9.028-15.763 7.943-12.906 19.874-30.152 35.854-47.463 31.779-34.427 81.222-70.79 148.227-70.791" })
          ]
        }
      );
    }
  )
);
var IconEyeMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 186c42.526 0 77 34.474 77 77s-34.474 77-77 77-77-34.474-77-77 34.474-77 77-77" }),
            /* @__PURE__ */ jsx("path", { d: "M240 88.665c68.143 0 118.373 36.295 150.537 70.477 16.177 17.19 28.249 34.307 36.286 47.119 4.031 6.426 7.082 11.823 9.156 15.679a188 188 0 0 1 2.386 4.582c.277.552.494.994.651 1.316l.189.393.062.128.021.047.01.02c.001.009-.224.124-19.298 9.098l19.305-9.083c5.016 10.662.44 23.372-10.222 28.388-10.658 5.015-23.362.443-28.382-10.21l.004.01-.072-.15c-.078-.16-.213-.435-.404-.817-.384-.764-.995-1.955-1.832-3.513-1.677-3.117-4.251-7.683-7.72-13.212-6.963-11.1-17.392-25.864-31.215-40.554-27.836-29.581-67.606-57.048-119.462-57.048-51.697 0-91.432 27.92-119.323 58.136-13.839 14.991-24.281 30.062-31.257 41.398-3.475 5.647-6.055 10.312-7.736 13.499a147 147 0 0 0-1.84 3.595c-.192.392-.329.675-.407.841l-.076.159-.005.012.01-.022-.002-.001c-4.942 10.69-17.61 15.355-28.304 10.419-10.699-4.938-15.369-17.613-10.431-28.311L60 240c-19.06-8.797-19.363-8.946-19.364-8.956l.009-.02.022-.046.06-.129q.07-.153.188-.398c.156-.326.37-.774.647-1.334.551-1.12 1.344-2.695 2.38-4.657 2.068-3.922 5.113-9.414 9.138-15.954 8.024-13.039 20.082-30.469 36.243-47.977C121.432 125.745 171.697 88.665 240 88.665" })
          ]
        }
      );
    }
  )
);
var IconEyeMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 186c42.526 0 77 34.474 77 77s-34.474 77-77 77-77-34.474-77-77 34.474-77 77-77" }),
            /* @__PURE__ */ jsx("path", { d: "M240.001 87.5c68.588 0 119.103 36.536 151.386 70.843 16.24 17.259 28.357 34.44 36.424 47.299 4.046 6.45 7.109 11.871 9.194 15.748a182 182 0 0 1 2.402 4.61c.28.556.499 1.002.658 1.329l.193.4.062.131.023.049.01.02c.003.008-.076.055-20.014 9.436l20.021-9.42c5.291 11.244.464 24.648-10.78 29.939-11.239 5.288-24.638.468-29.932-10.767l-.062-.129a76 76 0 0 0-.397-.803c-.379-.756-.985-1.938-1.817-3.485-1.665-3.097-4.227-7.64-7.681-13.144-6.933-11.053-17.317-25.752-31.076-40.374-27.717-29.456-67.202-56.682-118.614-56.682-51.243 0-90.691 27.671-118.467 57.762-13.775 14.923-24.174 29.928-31.12 41.217-3.46 5.623-6.028 10.265-7.7 13.432a145 145 0 0 0-1.823 3.567c-.19.387-.325.666-.402.827l-.065.137-.001-.001c-5.212 11.274-18.572 16.193-29.85 10.988-11.283-5.208-16.208-18.575-11-29.858l20.02 9.241c-19.927-9.198-20.016-9.249-20.013-9.257l.009-.02.022-.049.062-.132.191-.405c.158-.33.376-.782.654-1.346.556-1.13 1.354-2.714 2.394-4.686 2.08-3.942 5.137-9.457 9.177-16.021 8.053-13.086 20.154-30.581 36.379-48.158C120.692 124.829 171.245 87.5 240 87.5" })
          ]
        }
      );
    }
  )
);
var IconEyeMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240.995 186.006C283.062 186.539 317 220.806 317 263c0 42.526-34.474 77-77 77l-.995-.006C196.937 339.461 163 305.194 163 263c0-42.526 34.474-77 77-77z" }),
            /* @__PURE__ */ jsx("path", { d: "M240.002 86c69.161 0 120.044 36.847 152.478 71.315 16.324 17.347 28.499 34.611 36.603 47.53 4.066 6.481 7.146 11.931 9.244 15.834a186 186 0 0 1 2.422 4.648 113 113 0 0 1 .928 1.891l.023.051.01.02c.004.009-.032.037-21.571 10.171l21.58-10.153c5.643 11.993.494 26.291-11.499 31.934-11.986 5.639-26.273.501-31.923-11.475l-.06-.122a68 68 0 0 0-.388-.787c-.373-.743-.973-1.912-1.797-3.446-1.652-3.071-4.197-7.585-7.631-13.058-6.896-10.993-17.221-25.61-30.898-40.144C329.958 160.916 290.841 134 240.002 134c-50.659 0-89.736 27.348-117.364 57.278-13.694 14.835-24.036 29.758-30.947 40.988-3.44 5.591-5.992 10.204-7.65 13.345a143 143 0 0 0-1.804 3.53 70 70 0 0 0-.464.958c-5.568 12.005-19.808 17.24-31.829 11.692-12.035-5.555-17.288-19.814-11.733-31.849l10.321 4.764 10.321 4.764c-20.6-9.509-20.638-9.536-20.634-9.545l.01-.021.023-.05.063-.136.196-.413q.24-.507.662-1.366a192 192 0 0 1 2.414-4.722c2.093-3.968 5.166-9.511 9.225-16.108 8.09-13.145 20.248-30.722 36.554-48.387C119.738 123.652 170.662 86 240.002 86" })
          ]
        }
      );
    }
  )
);

// src/IconEye/IconEye.tsx
var IconEye = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconEyeMonochromeExtralight,
        "monochrome|light": IconEyeMonochromeLight,
        "monochrome|regular": IconEyeMonochromeRegular,
        "monochrome|medium": IconEyeMonochromeMedium,
        "monochrome|semibold": IconEyeMonochromeSemibold,
        "monochrome|bold": IconEyeMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconFaceSmilingSafetyHelmetMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M190 336.7c-3.7-5.5-2.2-13 3.3-16.6 5.5-3.7 13-2.2 16.6 3.3 6 9 17.5 14.7 30 14.7s24-5.6 30-14.7c3.7-5.5 11.1-7 16.6-3.3s7 11.1 3.3 16.6c-10.4 15.6-29.6 25.3-50 25.3s-39.5-9.7-50-25.3ZM452 232c0 6.6-5.4 12-12 12h-36v26c0 90.4-73.6 164-164 164S76 360.4 76 270v-26H40c-6.6 0-12-5.4-12-12s5.4-12 12-12h18c.9-73.5 52.9-134.9 122.1-150.3 1.2-16.6 15-29.7 31.9-29.7h56c16.9 0 30.7 13.1 31.9 29.7C369 85.1 421 146.5 422 220h18c6.6 0 12 5.4 12 12M82 220h316c-.9-60.2-42.2-110.7-98-125.6V168c0 6.6-5.4 12-12 12s-12-5.4-12-12V72c0-2.3-1-4.4-2.5-5.8-1.4-1.3-3.4-2.2-5.5-2.2h-56c-2.1 0-4 .8-5.5 2.2-1.6 1.5-2.5 3.5-2.5 5.8v96c0 6.6-5.4 12-12 12s-12-5.4-12-12V94.4c-55.7 14.9-97.1 65.4-98 125.6m298 24H100v26c0 77.2 62.8 140 140 140s140-62.8 140-140z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M187.5 338.3c-4.6-6.9-2.7-16.2 4.1-20.8 6.9-4.6 16.2-2.7 20.8 4.1 5.5 8.2 16 13.3 27.5 13.3s22-5.1 27.5-13.3c4.6-6.9 13.9-8.7 20.8-4.1s8.7 13.9 4.1 20.8c-11 16.5-31.1 26.7-52.5 26.7s-41.5-10.2-52.5-26.7ZM455 232c0 8.3-6.7 15-15 15h-33.3q.3 1.5.3 3v20c0 92.1-74.9 167-167 167S73 362.1 73 270v-20q0-1.5.3-3H40c-8.3 0-15-6.7-15-15s6.7-15 15-15h15.1c2.3-72.8 53.8-133.5 122.2-149.7 2.3-17.1 17-30.3 34.7-30.3h56c17.7 0 32.4 13.2 34.7 30.3 68.5 16.2 120 76.9 122.2 149.7H440c8.3 0 15 6.7 15 15M85.1 217h309.8c-2.2-56.1-40.3-103.1-91.9-118.6V168c0 8.3-6.7 15-15 15s-15-6.7-15-15V72c0-2.8-2.2-5-5-5h-56c-2.8 0-5 2.2-5 5v96c0 8.3-6.7 15-15 15s-15-6.7-15-15V98.4c-51.6 15.5-89.8 62.5-91.9 118.6m292.2 30H102.7q.3 1.5.3 3v20c0 75.5 61.5 137 137 137s137-61.5 137-137v-20q0-1.5.3-3" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M185 340c-5.5-8.3-3.3-19.4 5-25 8.3-5.5 19.4-3.3 25 5 4.9 7.4 14.5 12 25 12s20.1-4.6 25-12c5.5-8.3 16.7-10.5 25-5s10.5 16.7 5 25c-11.7 17.5-32.3 28-55 28s-43.3-10.5-55-28m273-108c0 9.9-8.1 18-18 18h-30v20c0 93.7-76.3 170-170 170S70 363.7 70 270v-20H40c-9.9 0-18-8.1-18-18s8.1-18 18-18h12c0-76.8 53.7-141.2 125.5-157.8 6-13.1 19.2-22.2 34.5-22.2h56c15.3 0 28.5 9.1 34.5 22.2C374.3 72.8 428 137.3 428 214h12c9.9 0 18 8.1 18 18M88 214h304c0-55.5-36.1-102.7-86-119.5V168c0 9.9-8.1 18-18 18s-18-8.1-18-18V72c0-1.1-.9-2-2-2h-56c-1.1 0-2 .9-2 2v96c0 9.9-8.1 18-18 18s-18-8.1-18-18V94.5c-49.9 16.8-86 64-86 119.5m286 36H106v20c0 73.9 60.1 134 134 134s134-60.1 134-134z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M182.3 341.8c-6.5-9.8-3.9-23 5.9-29.6 9.8-6.5 23-3.9 29.6 5.9 4.3 6.5 12.9 10.5 22.3 10.5s17.9-4 22.3-10.5c6.5-9.8 19.8-12.4 29.6-5.9s12.4 19.8 5.9 29.6c-12.3 18.5-33.9 29.5-57.7 29.5s-45.4-11-57.7-29.5Zm279-109.8c0 11.8-9.6 21.3-21.3 21.3h-26.7V270c0 95.6-77.8 173.3-173.3 173.3S66.7 365.5 66.7 270v-16.7H40c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3h8.7c1.5-76.3 55-140.1 126.5-157.4C182 39.9 196 30.7 212 30.7h56c16.1 0 30 9.2 36.8 22.6 71.5 17.3 124.9 81.1 126.5 157.4h8.7c11.8 0 21.3 9.6 21.3 21.3M91.4 210.7h297.2c-1.4-51-34-94.2-79.3-111.4v65.8c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3V73.4h-53.3v91.7c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3V99.3c-45.3 17.2-77.9 60.5-79.3 111.4Zm279.3 42.6H109.3V270c0 72 58.6 130.7 130.7 130.7S370.7 342.1 370.7 270z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240 372.5c24.2 0 46.2-11.2 58.7-30 6.9-10.3 4.1-24.3-6.2-31.2s-24.3-4.1-31.2 6.2c-4.1 6.2-12.3 10-21.3 10s-17.2-3.9-21.3-10c-6.9-10.3-20.9-13.1-31.2-6.2s-13.1 20.9-6.2 31.2c12.5 18.8 34.5 30 58.7 30m200-163h-7.6c-2-76.2-55.5-139.7-126.8-157.2-7.1-13.5-21.3-22.8-37.6-22.8h-56c-16.3 0-30.5 9.3-37.6 22.8-71.3 17.5-124.8 81.1-126.8 157.2H40c-12.4 0-22.5 10.1-22.5 22.5s10.1 22.5 22.5 22.5h25.5V270c0 96.2 78.3 174.5 174.5 174.5S414.5 366.2 414.5 270v-15.5H440c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5M169.5 100.9V163c0 12.4 10.1 22.5 22.5 22.5s22.5-10.1 22.5-22.5V74.5h51V163c0 12.4 10.1 22.5 22.5 22.5s22.5-10.1 22.5-22.5v-62.1c43.7 17.3 75.1 59.2 76.9 108.6H92.6c1.8-49.4 33.2-91.3 76.9-108.6m200 169.1c0 71.4-58.1 129.5-129.5 129.5S110.5 341.4 110.5 270v-15.5h259z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M180 343.3c-7.4-11-4.4-25.9 6.6-33.3s25.9-4.4 33.3 6.6c3.8 5.7 11.7 9.3 20 9.3s16.3-3.7 20-9.3c7.4-11 22.3-14 33.3-6.6s14 22.3 6.6 33.3c-12.8 19.2-35.2 30.7-60 30.7s-47.1-11.5-60-30.7zM464 232c0 13.3-10.7 24-24 24h-24v14c0 97-79 176-176 176S64 367 64 270v-14H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h6.1c2.7-76.8 57.2-140.6 129.6-157.6C183.3 37 197.6 28 214 28h52c16.4 0 30.8 9 38.3 22.4 72.4 16.9 126.9 80.8 129.6 157.6h6.1c13.3 0 24 10.7 24 24M94.1 208h291.7c-2.4-48.1-33.2-88.8-75.9-105.6V162c0 13.3-10.7 24-24 24s-24-10.7-24-24V76h-44v86c0 13.3-10.7 24-24 24s-24-10.7-24-24v-59.6C127.2 119.3 96.4 160 94 208ZM368 256H112v14c0 70.6 57.4 128 128 128s128-57.4 128-128z" })
        }
      );
    }
  )
);

// src/IconFaceSmilingSafetyHelmet/IconFaceSmilingSafetyHelmet.tsx
var IconFaceSmilingSafetyHelmet = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFaceSmilingSafetyHelmetMonochromeExtralight,
          "monochrome|light": IconFaceSmilingSafetyHelmetMonochromeLight,
          "monochrome|regular": IconFaceSmilingSafetyHelmetMonochromeRegular,
          "monochrome|medium": IconFaceSmilingSafetyHelmetMonochromeMedium,
          "monochrome|semibold": IconFaceSmilingSafetyHelmetMonochromeSemibold,
          "monochrome|bold": IconFaceSmilingSafetyHelmetMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M190 336.7c-3.7-5.5-2.2-13 3.3-16.6 5.5-3.7 13-2.2 16.6 3.3 6 9 17.5 14.7 30 14.7s24-5.6 30-14.7c3.7-5.5 11.1-7 16.6-3.3s7 11.1 3.3 16.6c-10.4 15.6-29.6 25.3-50 25.3s-39.5-9.7-50-25.3ZM452 232c0 6.6-5.4 12-12 12h-36v26c0 90.4-73.6 164-164 164S76 360.4 76 270v-26H40c-6.6 0-12-5.4-12-12s5.4-12 12-12h18v-2c0-69.2 46.5-127.8 110-146.1V166c0 6.6 5.4 12 12 12s12-5.4 12-12V52c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v114c0 6.6 5.4 12 12 12s12-5.4 12-12V71.9c63.5 18.3 110 76.8 110 146.1v2h18c6.6 0 12 5.4 12 12m-72 12H100v26c0 77.2 62.8 140 140 140s140-62.8 140-140z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M187.5 338.3c-4.6-6.9-2.7-16.2 4.1-20.8 6.9-4.6 16.2-2.7 20.8 4.1 5.5 8.2 16 13.3 27.5 13.3s22-5.1 27.5-13.3c4.6-6.9 13.9-8.7 20.8-4.1s8.7 13.9 4.1 20.8c-11 16.5-31.1 26.7-52.5 26.7s-41.5-10.2-52.5-26.7ZM455 232c0 8.3-6.7 15-15 15h-33v23c0 92.1-74.9 167-167 167S73 362.1 73 270v-23H40c-8.3 0-15-6.7-15-15s6.7-15 15-15h15c.4-67.9 44.8-125.6 106-146.1V163c0 8.3 6.7 15 15 15s15-6.7 15-15V52c0-8.3 6.7-15 15-15h68c8.3 0 15 6.7 15 15v111c0 8.3 6.7 15 15 15s15-6.7 15-15V70.9C380.2 91.4 424.6 149 425 217h15c8.3 0 15 6.7 15 15m-78 15H103v23c0 75.5 61.5 137 137 137s137-61.5 137-137z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M185 340c-5.5-8.3-3.3-19.4 5-25 8.3-5.5 19.4-3.3 25 5 4.9 7.4 14.5 12 25 12s20.1-4.6 25-12c5.5-8.3 16.7-10.5 25-5s10.5 16.7 5 25c-11.7 17.5-32.3 28-55 28s-43.3-10.5-55-28m273-108c0 9.9-8.1 18-18 18h-30v20c0 93.7-76.3 170-170 170S70 363.7 70 270v-20H40c-9.9 0-18-8.1-18-18s8.1-18 18-18h12v-4c0-67 42-124.4 101-147.4V160c0 9.9 8.1 18 18 18s18-8.1 18-18V52c0-9.9 8.1-18 18-18h66c9.9 0 18 8.1 18 18v108c0 9.9 8.1 18 18 18s18-8.1 18-18V62.6c59 22.9 101 80.3 101 147.4v4h12c9.9 0 18 8.1 18 18m-84 18H106v20c0 73.9 60.1 134 134 134s134-60.1 134-134z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M182.3 341.8c-6.5-9.8-3.9-23 5.9-29.6 9.8-6.5 23-3.9 29.6 5.9 4.3 6.5 12.9 10.5 22.3 10.5s17.9-4 22.3-10.5c6.5-9.8 19.8-12.4 29.6-5.9s12.4 19.8 5.9 29.6c-12.3 18.5-33.9 29.5-57.7 29.5s-45.4-11-57.7-29.5Zm279-109.8c0 11.8-9.6 21.3-21.3 21.3h-26.7V270c0 95.6-77.8 173.3-173.3 173.3S66.7 365.5 66.7 270v-16.7H40c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3h8.7v-.7c0-68.4 42.8-127 103-150.4V154c0 9.9 8.1 18 18 18s18-8.1 18-18V50.2c.9-10.9 10.1-19.5 21.2-19.5h62c11.2 0 20.3 8.6 21.2 19.5v104.5c.4 9.6 8.3 17.3 18 17.3s18-8.1 18-18V59.6c60.2 23.4 103 82 103 150.4v.7h8.7c11.8 0 21.3 9.6 21.3 21.3Zm-90.6 21.3H109.3V270c0 72 58.6 130.7 130.7 130.7S370.7 342.1 370.7 270z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M180.9 342.8c-7.1-10.6-4.2-24.8 6.4-31.9s24.8-4.2 31.9 6.4c4 5.9 12.2 9.8 20.9 9.8s16.9-3.8 20.9-9.8c7.1-10.6 21.3-13.4 31.9-6.4 10.6 7.1 13.4 21.3 6.4 31.9-12.6 18.9-34.7 30.2-59.1 30.2s-46.5-11.3-59.1-30.2ZM462.5 232c0 12.4-10.1 22.5-22.5 22.5h-25.5V270c0 96.2-78.3 174.5-174.5 174.5S65.5 366.2 65.5 270v-15.5H40c-12.4 0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h7.5c.2-68.8 43.4-127.6 104-151.1V152c0 9.9 8.1 18 18 18s18-8.1 18-18V52c0-1 0-2 .2-3 1.5-11 10.9-19.5 22.3-19.5h60c11.4 0 20.8 8.5 22.3 19.5.1 1 .2 2 .2 3v100c0 9.9 8.1 18 18 18s18-8.1 18-18V58.4c60.6 23.5 103.8 82.3 104 151.1h7.5c12.4 0 22.5 10.1 22.5 22.5m-93 22.5h-259V270c0 71.4 58.1 129.5 129.5 129.5S369.5 341.4 369.5 270z" })
        }
      );
    }
  )
);
var IconFaceSmilingSafetyHelmetFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M240 374c24.7 0 47.1-11.5 60-30.7 7.4-11 4.4-25.9-6.6-33.3s-25.9-4.4-33.3 6.6c-3.8 5.7-11.7 9.3-20 9.3s-16.3-3.7-20-9.3c-7.4-11-22.3-14-33.3-6.6s-14 22.3-6.6 33.3c12.8 19.2 35.2 30.7 60 30.7Z" }),
            /* @__PURE__ */ jsx("path", { d: "M440 208h-6c-.8-69.2-44.7-128.1-106-151.4V148c0 9.9-8.1 18-18 18s-18-8.1-18-18V47.5c-.3-13-10.9-23.5-24-23.5h-56c-13.1 0-23.7 10.5-24 23.5V148c0 9.9-8.1 18-18 18s-18-8.1-18-18V56.6C90.7 79.9 46.9 138.8 46 208h-6c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v14c0 97 79 176 176 176s176-79 176-176v-14h24c13.3 0 24-10.7 24-24s-10.7-24-24-24m-72 62c0 70.6-57.4 128-128 128s-128-57.4-128-128v-14h256z" })
          ]
        }
      );
    }
  )
);

// src/IconFaceSmilingSafetyHelmetFilled/IconFaceSmilingSafetyHelmetFilled.tsx
var IconFaceSmilingSafetyHelmetFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFaceSmilingSafetyHelmetFilledMonochromeExtralight,
          "monochrome|light": IconFaceSmilingSafetyHelmetFilledMonochromeLight,
          "monochrome|regular": IconFaceSmilingSafetyHelmetFilledMonochromeRegular,
          "monochrome|medium": IconFaceSmilingSafetyHelmetFilledMonochromeMedium,
          "monochrome|semibold": IconFaceSmilingSafetyHelmetFilledMonochromeSemibold,
          "monochrome|bold": IconFaceSmilingSafetyHelmetFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconFireMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M372 291.366c0-31.389-11.69-54.139-26.938-73.564-7.741-9.861-16.304-18.748-24.907-27.637-8.416-8.697-17.096-17.618-24.073-26.854-20.856-27.606-30.491-53.505-34.873-72.744a154 154 0 0 1-1.927-9.934c-4.811 4.122-10.009 9.363-14.652 15.742-12.758 17.527-22.162 44.565-5.021 83.802a12 12 0 0 1-10.997 16.803c-23.102 0-39.875-5.622-51.595-15.006-9.589-7.676-14.897-17.152-17.748-26.01C138.309 183.743 108 234.002 108 291.366c0 39.603 17.537 68.055 42.579 86.943 25.402 19.16 58.762 28.573 89.421 28.573 30.805 0 64.164-9.91 89.554-29.369C354.634 358.292 372 329.791 372 291.366m24 0c0 46.68-21.497 81.936-51.848 105.196-30.041 23.024-68.682 34.32-104.152 34.32-35.066 0-73.706-10.658-103.873-33.413C105.6 374.444 84 339.138 84 291.366c0-70.225 39.536-129.235 61.24-156.475 2.023-2.539 3.918-4.927 5.496-6.664.799-.879 1.842-1.956 3.06-2.922 1.088-.863 3.309-2.45 6.456-3.048 1.744-.332 4.045-.515 6.635.089 2.266.529 4.066 1.5 5.43 2.451l.559.404.26.202c2.642 2.099 3.868 4.73 4.338 5.793.624 1.415 1.08 2.898 1.425 4.146.692 2.499 1.424 5.878 2.255 9.695 1.417 6.503 4.507 13.113 10.863 18.202 4.084 3.27 10.071 6.351 18.921 8.142-11.107-38.693-.72-68.512 14.288-89.13 8.432-11.585 18.118-20.029 25.629-25.56a115 115 0 0 1 9.439-6.28 82 82 0 0 1 2.87-1.629c.352-.19.638-.34.85-.45l.262-.133.089-.045.047-.023.013-.007a12 12 0 0 1 17.282 11.67l.002-.012.001-.015-.011.2c-.01.215-.024.593-.032 1.125a70 70 0 0 0 .121 4.955c.252 4.434.961 11.02 2.821 19.19 3.715 16.308 12.037 39.007 30.622 63.607 5.919 7.835 13.48 15.65 22.171 24.631 8.505 8.789 17.916 18.525 26.537 29.507C381.414 225.243 396 253.067 396 291.366" }),
            /* @__PURE__ */ jsx("path", { d: "M296 327.777c0 35.389-25.072 51.377-56 51.377s-56-15.988-56-51.377S234.735 251 240 251s56 41.388 56 76.777" })
          ]
        }
      );
    }
  )
);
var IconFireMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M369 291.366c0-30.525-11.328-52.641-26.299-71.712-7.63-9.72-16.086-18.501-24.701-27.403-8.382-8.662-17.202-17.72-24.312-27.131-21.139-27.982-30.938-54.28-35.404-73.886a162 162 0 0 1-1.004-4.743c-3.465 3.32-6.988 7.202-10.225 11.65-12.19 16.746-21.373 42.662-4.697 80.834a15 15 0 0 1-13.746 21.005c-23.585 0-41.08-5.744-53.47-15.664-8.231-6.589-13.467-14.43-16.749-22.125C137.876 190.453 111 237.854 111 291.366c0 38.582 17.029 66.176 41.386 84.548 24.805 18.71 57.506 27.968 87.614 27.968 30.222 0 62.92-9.737 87.729-28.749C352.15 356.416 369 328.759 369 291.366m30 0c0 47.712-22.013 83.813-53.022 107.578-30.624 23.469-69.925 34.938-105.978 34.938-35.617 0-74.917-10.813-105.68-34.017C103.108 376.323 81 340.159 81 291.366c0-71.27 40.072-130.957 61.894-158.345 1.994-2.503 3.962-4.985 5.623-6.811.842-.927 2.011-2.142 3.415-3.255 1.242-.985 3.916-2.915 7.759-3.646 2.022-.384 4.766-.61 7.877.116 2.917.68 5.174 1.968 6.798 3.147l.317.234.318.247c3.232 2.567 4.698 5.753 5.218 6.931.712 1.613 1.213 3.259 1.572 4.557.72 2.6 1.471 6.079 2.294 9.857 1.312 6.022 4.123 11.949 9.807 16.499 2.912 2.332 7.019 4.652 12.845 6.365-9.163-37.268 1.206-66.366 16.063-86.777 8.661-11.9 18.594-20.551 26.277-26.21a118 118 0 0 1 9.687-6.443 85 85 0 0 1 2.975-1.69q.555-.3.899-.475l.286-.147.1-.05.039-.019.017-.009.015-.007a15 15 0 0 1 21.602 14.605l.001-.012.002-.022.002-.032.002-.018-.009.153c-.008.184-.022.53-.029 1.027-.014.995-.004 2.6.117 4.74.243 4.286.932 10.705 2.752 18.695 3.631 15.941 11.789 38.24 30.09 62.465 5.786 7.659 13.208 15.336 21.934 24.353 8.492 8.776 18.009 18.618 26.741 29.741 17.753 22.615 32.7 51.074 32.7 90.236" }),
            /* @__PURE__ */ jsx("path", { d: "M294 331.035c0 34.125-24.177 49.542-54 49.542s-54-15.417-54-49.542S234.923 257 240 257s54 39.91 54 74.035" })
          ]
        }
      );
    }
  )
);
var IconFireMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M366 291.366c0-29.662-10.966-51.143-25.658-69.86-7.521-9.58-15.871-18.254-24.498-27.169-8.347-8.626-17.307-17.822-24.549-27.408-21.185-28.042-31.161-54.464-35.779-74.36a82 82 0 0 0-6.036 7.337c-11.62 15.965-20.584 40.759-4.373 77.868a18 18 0 0 1-16.495 25.206c-24.067 0-42.286-5.866-55.345-16.322a59 59 0 0 1-15.387-18.579C138.022 196.437 114 241.257 114 291.366c0 37.561 16.522 64.299 40.192 82.153 24.21 18.261 56.251 27.363 85.808 27.363 29.639 0 61.678-9.564 85.904-28.131C349.667 354.54 366 327.727 366 291.366m36 0c0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C100.616 378.201 78 341.18 78 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.747 2.7 1.519 6.28 2.334 10.019 1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 88 88 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055.064-.032.018-.009a18 18 0 0 1 25.922 17.526l.001-.015.003-.029.003-.043.003-.04-.006.106a31 31 0 0 0-.026.928 64 64 0 0 0 .112 4.528c.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974C386.69 222.247 402 251.34 402 291.366" }),
            /* @__PURE__ */ jsx("path", { d: "M292 329.293C292 362.154 268.719 377 240 377s-52-14.846-52-47.707S235.111 258 240 258s52 38.432 52 71.293" })
          ]
        }
      );
    }
  )
);
var IconFireMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M362.665 291.366c0-28.701-10.563-49.478-24.946-67.8-7.398-9.425-15.631-17.981-24.272-26.91-8.309-8.586-17.424-17.937-24.813-27.717-19.335-25.593-29.496-49.896-34.774-69.296a75 75 0 0 0-1.683 2.226c-10.989 15.097-19.709 38.644-4.014 74.571a21.334 21.334 0 0 1-19.551 29.876c-24.603-.001-43.627-6.003-57.43-17.054-5.721-4.581-10.135-9.702-13.528-14.97-18.985 28.162-40.319 70.358-40.319 117.074 0 36.426 15.957 62.211 38.865 79.491 23.548 17.761 54.855 26.69 83.8 26.69 28.991 0 60.295-9.371 83.875-27.442 23.03-17.65 38.79-43.525 38.79-78.739m42.67 0c0 49.891-23.103 87.774-55.504 112.606-31.851 24.41-72.547 36.245-109.831 36.245-36.78 0-77.473-11.142-109.494-35.294-32.66-24.634-55.84-62.607-55.841-113.557 0-73.476 41.203-134.591 63.274-162.292 1.935-2.428 4.056-5.109 5.89-7.126.934-1.027 2.369-2.532 4.167-3.958 1.568-1.243 5.2-3.894 10.513-4.904l.501-.091c2.568-.44 6.047-.66 9.997.261s6.971 2.659 9.08 4.189l.41.304.441.341c4.477 3.555 6.448 7.914 7.076 9.336.897 2.032 1.494 4.023 1.882 5.426.779 2.812 1.574 6.503 2.379 10.199 1.091 5.006 3.311 9.487 7.576 12.901q.137.109.28.219c-4.745-33.294 5.417-60 19.548-79.413 9.145-12.564 19.596-21.658 27.641-27.584 4.057-2.988 7.6-5.242 10.211-6.791a92 92 0 0 1 3.2-1.817q.608-.327 1.001-.529l.336-.17.124-.063.052-.026c.008-.003.018-.01.023-.011l.021-.011a21.335 21.335 0 0 1 30.725 20.772l.001.001.001-.018.003-.034.005-.069c-.005.117-.016.393-.022.82-.012.854-.005 2.308.107 4.29.226 3.97.87 10.035 2.604 17.646 3.455 15.168 11.266 36.622 28.968 60.054 5.506 7.289 12.632 14.674 21.43 23.765 8.467 8.75 18.209 18.816 27.172 30.235 18.341 23.364 34.053 53.162 34.053 94.148" }),
            /* @__PURE__ */ jsx("path", { d: "M292 329.293C292 362.154 268.719 377 240 377s-52-14.846-52-47.707S235.111 258 240 258s52 38.432 52 71.293" })
          ]
        }
      );
    }
  )
);
var IconFireMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M292 329.293C292 362.154 268.719 377 240 377s-52-14.846-52-47.707S235.111 258 240 258s52 38.432 52 71.293" }),
            /* @__PURE__ */ jsx("path", { d: "M361.5 291.366c0-28.366-10.423-48.896-24.698-67.081-7.355-9.37-15.547-17.884-24.192-26.818-8.295-8.573-17.465-17.977-24.906-27.826-18.688-24.737-28.859-48.288-34.336-67.426l-.249.34c-10.768 14.793-19.403 37.905-3.889 73.419a22.497 22.497 0 0 1-20.618 31.507c-24.79 0-44.094-6.05-58.158-17.31a63.5 63.5 0 0 1-12.804-13.777c-18.658 28.037-39.15 69.364-39.15 114.972 0 36.03 15.76 61.482 38.402 78.561 23.317 17.587 54.367 26.455 83.098 26.455 28.764 0 59.812-9.304 83.167-27.202 22.774-17.454 38.333-43.001 38.333-77.814m45 0c0 50.292-23.303 88.503-55.96 113.531-32.077 24.583-73.03 36.485-110.54 36.485-36.994 0-77.944-11.202-110.196-35.529C96.878 381.017 73.5 342.712 73.5 291.366c0-73.881 41.411-135.259 63.528-163.017 1.924-2.414 4.074-5.133 5.94-7.185.951-1.046 2.434-2.604 4.304-4.087 1.628-1.29 5.436-4.074 11.019-5.135l.522-.094c2.677-.459 6.318-.692 10.458.273 4.416 1.03 7.72 3.033 9.927 4.697 5.035 3.798 7.213 8.625 7.881 10.138.931 2.109 1.547 4.163 1.941 5.585.789 2.851 1.591 6.581 2.393 10.262.858 3.939 2.427 7.474 5.157 10.385-3.735-32.153 6.319-58.091 20.166-77.116 9.234-12.685 19.781-21.86 27.893-27.836a125 125 0 0 1 10.309-6.855 91 91 0 0 1 3.24-1.84 63 63 0 0 1 1.365-.715l.129-.064.054-.028.023-.011.022-.011a22.501 22.501 0 0 1 32.413 21.791l.004-.074q.003-.044 0 .035a24 24 0 0 0-.022.78 60 60 0 0 0 .105 4.208c.222 3.91.859 9.912 2.577 17.453 3.422 15.025 11.17 36.325 28.761 59.611 5.456 7.221 12.528 14.552 21.339 23.658 8.462 8.745 18.245 18.852 27.251 30.325 18.449 23.502 34.301 53.546 34.301 94.867" })
          ]
        }
      );
    }
  )
);
var IconFireMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M360 291.366c0-27.934-10.242-48.147-24.378-66.155-7.3-9.3-15.439-17.761-24.09-26.701-8.278-8.555-17.518-18.029-25.025-27.965-17.851-23.629-27.992-46.197-33.7-64.931-9.738 14.466-16.735 36.492-2.202 69.759a23.997 23.997 0 0 1-21.993 33.607c-25.031 0-44.697-6.111-59.095-17.638a65.2 65.2 0 0 1-11.823-12.293C139.468 206.89 120 247.133 120 291.366c0 35.519 15.506 60.543 37.806 77.363 23.018 17.362 53.738 26.153 82.194 26.153 28.473 0 59.19-9.217 82.254-26.893C344.699 350.788 360 325.663 360 291.366m48 0c0 50.807-23.562 89.441-56.548 114.721-32.367 24.806-73.65 36.795-111.452 36.795-37.27 0-78.549-11.28-111.1-35.831C95.632 381.957 72 343.223 72 291.366c0-74.404 41.679-136.12 63.855-163.953 1.91-2.396 4.096-5.161 6.002-7.258.973-1.07 2.52-2.696 4.484-4.253 1.705-1.352 5.739-4.307 11.67-5.434l.55-.099c2.816-.482 6.667-.732 11.051.291s7.729 2.95 10.041 4.629l.449.332.493.381c5 3.971 7.185 8.824 7.857 10.348.975 2.207 1.612 4.343 2.013 5.791.803 2.901 1.616 6.68 2.414 10.342.391 1.794.932 3.48 1.666 5.043-2.002-29.868 7.773-54.194 20.978-72.337 9.349-12.843 20.018-22.123 28.216-28.16a127 127 0 0 1 10.433-6.938 93 93 0 0 1 3.294-1.87q.63-.338 1.044-.552l.356-.182.136-.068.056-.027.025-.013.023-.012a24 24 0 0 1 34.566 23.347l.004-.04.004-.065.006-.075c-.005.088-.015.336-.021.733-.012.794-.004 2.184.105 4.1.217 3.836.842 9.753 2.54 17.205 3.38 14.842 11.047 35.942 28.497 59.039 5.389 7.134 12.39 14.396 21.218 23.519 8.456 8.738 18.292 18.899 27.354 30.442C391.966 219.251 408 249.613 408 291.366" }),
            /* @__PURE__ */ jsx("path", { d: "M292 329.293C292 362.154 268.719 377 240 377s-52-14.846-52-47.707S235.111 258 240 258s52 38.432 52 71.293" })
          ]
        }
      );
    }
  )
);

// src/IconFire/IconFire.tsx
var IconFire = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFireMonochromeExtralight,
          "monochrome|light": IconFireMonochromeLight,
          "monochrome|regular": IconFireMonochromeRegular,
          "monochrome|medium": IconFireMonochromeMedium,
          "monochrome|semibold": IconFireMonochromeSemibold,
          "monochrome|bold": IconFireMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconFireFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M262.266 42.746a18 18 0 0 1 25.922 17.526l.001-.015.003-.029.003-.043.003-.04-.006.106c-.007.152-.019.464-.026.928-.013.928-.005 2.462.112 4.528.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974 18.031 22.97 33.341 52.063 33.341 92.089 0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C101.116 378.201 78.5 341.18 78.5 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.747 2.7 1.519 6.28 2.334 10.019 1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 89 89 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055zM244 251c-5.265 0-56 41.389-56 76.777 0 35.389 25.072 51.376 56 51.376s56-15.987 56-51.376S249.265 251 244 251" })
        }
      );
    }
  )
);
var IconFireFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M261.766 42.746a18 18 0 0 1 25.922 17.526l.001-.015.003-.029.003-.043.003-.04-.006.106c-.007.152-.019.464-.026.928-.013.928-.005 2.462.112 4.528.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974C386.69 222.247 402 251.34 402 291.366c0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C100.616 378.201 78 341.18 78 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.747 2.7 1.519 6.28 2.334 10.019 1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 89 89 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055zM240 257c-5.077 0-54 39.91-54 74.035s24.177 49.542 54 49.542 54-15.417 54-49.542S245.077 257 240 257" })
        }
      );
    }
  )
);
var IconFireFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M262.266 42.746a18 18 0 0 1 25.922 17.526l.001-.015.003-.029.003-.043.003-.04-.006.106c-.007.152-.019.464-.026.928-.013.928-.005 2.462.112 4.528.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974 18.031 22.97 33.341 52.063 33.341 92.089 0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C101.116 378.201 78.5 341.18 78.5 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.747 2.7 1.519 6.28 2.334 10.019 1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 89 89 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055zM240 258c-4.889 0-52 38.432-52 71.293S211.281 377 240 377s52-14.846 52-47.707S244.889 258 240 258" })
        }
      );
    }
  )
);
var IconFireFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M261.766 42.746a18 18 0 0 1 25.922 17.526l.001-.015.003-.029.003-.043.003-.04-.006.106c-.007.152-.019.464-.026.928-.013.928-.005 2.462.112 4.528.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974C386.69 222.247 402 251.34 402 291.366c0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C100.616 378.201 78 341.18 78 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.747 2.7 1.519 6.28 2.334 10.019 1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 89 89 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055zM240 258c-4.889 0-52 38.432-52 71.293S211.281 377 240 377s52-14.846 52-47.707S244.889 258 240 258" })
        }
      );
    }
  )
);
var IconFireFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M261.266 42.746a18 18 0 0 1 25.975 16.32 17 17 0 0 1-.043 1.041q-.003.07-.008.139l.002-.018.003-.039-.003.062c-.007.152-.019.464-.026.928-.013.928-.005 2.462.112 4.528.235 4.135.903 10.388 2.682 18.198 3.548 15.575 11.542 37.474 29.559 61.322 5.653 7.484 12.935 15.023 21.695 24.076 8.48 8.763 18.104 18.711 26.945 29.974 18.031 22.97 33.341 52.063 33.341 92.089 0 48.744-22.529 85.689-54.197 109.959-31.205 23.915-71.167 35.557-107.803 35.557-36.168 0-76.128-10.968-107.486-34.621C100.116 378.201 77.5 341.18 77.5 291.366c0-72.314 40.608-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.961.886-.974 2.181-2.327 3.771-3.588 1.397-1.107 4.525-3.378 9.064-4.241l.441-.079c2.258-.387 5.27-.575 8.676.22 3.633.847 6.371 2.499 8.239 3.908 4.087 3.083 5.886 7.027 6.475 8.362.8 1.812 1.347 3.621 1.72 4.968.716 2.587 1.454 5.981 2.231 9.549l.103.47c1.206 5.54 3.738 10.783 8.75 14.796 1.708 1.367 3.938 2.777 6.854 4.044-7.171-35.634 3.144-63.81 17.754-83.88 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.61 89 89 0 0 1 3.082-1.748 60 60 0 0 1 1.256-.66l.113-.055zM240 258c-4.889 0-52 38.432-52 71.293S211.281 377 240 377s52-14.846 52-47.707S244.889 258 240 258" })
        }
      );
    }
  )
);
var IconFireFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M260.029 44.048a18.001 18.001 0 0 1 25.923 17.527l.001-.016.003-.028.006-.083-.006.105c-.007.152-.02.464-.026.928-.014.929-.005 2.462.112 4.528.235 4.135.902 10.388 2.682 18.198 3.547 15.575 11.541 37.474 29.558 61.323 5.654 7.484 12.936 15.023 21.696 24.075 8.48 8.763 18.103 18.711 26.945 29.974 18.031 22.97 33.341 52.063 33.341 92.089 0 48.744-22.529 85.689-54.198 109.959-31.204 23.915-71.167 35.557-107.802 35.557-36.168 0-76.128-10.968-107.487-34.621-31.897-24.06-54.513-61.08-54.513-110.895 0-72.314 40.607-132.678 62.548-160.214 1.966-2.467 4.006-5.044 5.749-6.96.885-.975 2.18-2.327 3.771-3.588 1.397-1.108 4.525-3.379 9.064-4.242l.441-.079c2.258-.386 5.27-.574 8.676.22 3.633.848 6.37 2.499 8.239 3.908 4.087 3.083 5.885 7.028 6.475 8.363.799 1.811 1.346 3.62 1.719 4.967.748 2.701 1.52 6.28 2.334 10.019 1.207 5.541 3.738 10.783 8.75 14.796 1.709 1.368 3.939 2.778 6.855 4.045-7.171-35.634 3.144-63.81 17.754-83.881 8.89-12.214 19.068-21.076 26.923-26.86a121 121 0 0 1 9.935-6.609 88 88 0 0 1 3.082-1.749 61 61 0 0 1 1.256-.66l.112-.055zM240 258c-4.889 0-52 38.432-52 71.293S211.281 377 240 377s52-14.846 52-47.707S244.889 258 240 258" })
        }
      );
    }
  )
);

// src/IconFireFilled/IconFireFilled.tsx
var IconFireFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFireFilledMonochromeExtralight,
          "monochrome|light": IconFireFilledMonochromeLight,
          "monochrome|regular": IconFireFilledMonochromeRegular,
          "monochrome|medium": IconFireFilledMonochromeMedium,
          "monochrome|semibold": IconFireFilledMonochromeSemibold,
          "monochrome|bold": IconFireFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconForwardFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 6.3 34.5v-21c0-.43.23-.826.602-1.04",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M23.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 23.3 34.5v-21c0-.43.23-.826.602-1.04",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconForwardFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 4.25 23V9a1 1 0 0 1 .502-.867",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 15.25 23V9a1 1 0 0 1 .502-.867",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconForwardFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 3.1 17V7a.9.9 0 0 1 .444-.776",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 11.1 17V7a.9.9 0 0 1 .444-.776",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconForwardFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconForwardFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.376 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 2 11.5v-7a.75.75 0 0 1 .376-.65",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.626 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 7.25 11.5v-7a.75.75 0 0 1 .376-.65",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconForwardFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 1.4 8.5v-5a.6.6 0 0 1 .296-.517",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 5.4 8.5v-5a.6.6 0 0 1 .296-.517",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconForwardFilled/IconForwardFilled.tsx
var IconForwardFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconForwardFilledMonochromeExtralight,
          "monochrome|light": IconForwardFilledMonochromeLight,
          "monochrome|regular": IconForwardFilledMonochromeRegular,
          "monochrome|medium": IconForwardFilledMonochromeMedium,
          "monochrome|semibold": IconForwardFilledMonochromeSemibold,
          "monochrome|bold": IconForwardFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconFunnelMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconFunnelMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconFunnelMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconFunnelMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconFunnelMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconFunnelMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconFunnel/IconFunnel.tsx
var IconFunnel = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFunnelMonochromeExtralight,
          "monochrome|light": IconFunnelMonochromeLight,
          "monochrome|regular": IconFunnelMonochromeRegular,
          "monochrome|medium": IconFunnelMonochromeMedium,
          "monochrome|semibold": IconFunnelMonochromeSemibold,
          "monochrome|bold": IconFunnelMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M39 4H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3V26.857l10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28v-8.762l6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M19 3H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2v-6.571l5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5V10l3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12.25 1.75h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5V8.919L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconFunnelFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9.5 1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714l2.098-2.283a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconFunnelFilled/IconFunnelFilled.tsx
var IconFunnelFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconFunnelFilledMonochromeExtralight,
          "monochrome|light": IconFunnelFilledMonochromeLight,
          "monochrome|regular": IconFunnelFilledMonochromeRegular,
          "monochrome|medium": IconFunnelFilledMonochromeMedium,
          "monochrome|semibold": IconFunnelFilledMonochromeSemibold,
          "monochrome|bold": IconFunnelFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconGearMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16m5.6-8a5.6 5.6 0 1 1-11.2 0 5.6 5.6 0 0 1 11.2 0",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m30.295 40.435 5.405-2.991 3.684.854a.97.97 0 0 0 .933-.278 20.8 20.8 0 0 0 4.496-7.428.97.97 0 0 0-.238-1L41.995 27v-5.987l2.58-2.595a.97.97 0 0 0 .237-1 20.8 20.8 0 0 0-4.495-7.432.97.97 0 0 0-.933-.278l-3.684.854-5.405-2.99-1.06-3.445a.98.98 0 0 0-.734-.674 22.7 22.7 0 0 0-9-.004.98.98 0 0 0-.737.675l-1.06 3.447-5.404 2.991-3.683-.854a.97.97 0 0 0-.933.278 20.8 20.8 0 0 0-4.497 7.433.97.97 0 0 0 .238 1l2.58 2.594v5.982l-2.58 2.594a.97.97 0 0 0-.237 1 20.8 20.8 0 0 0 4.496 7.428.97.97 0 0 0 .932.277l3.684-.854 5.405 2.99 1.06 3.45a.98.98 0 0 0 .735.674 22.8 22.8 0 0 0 8.999-.001.98.98 0 0 0 .738-.675zm5.05-5.537-7.059 3.906-1.09 3.543a20.5 20.5 0 0 1-6.39.002l-1.091-3.55-7.06-3.906-3.766.873a18.4 18.4 0 0 1-3.123-5.13l2.639-2.652V20.02l-2.64-2.653a18.4 18.4 0 0 1 3.125-5.134l3.766.873 7.059-3.906 1.09-3.548a20.242 20.242 0 0 1 6.39.002L28.286 9.2l7.058 3.906 3.766-.873a18.4 18.4 0 0 1 3.124 5.134l-2.639 2.653v7.968l2.639 2.653a18.4 18.4 0 0 1-3.124 5.129z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGearMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 19.533a3.533 3.533 0 1 0 0-7.066 3.533 3.533 0 0 0 0 7.066M21.333 16a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m18.69 25.733 4.843-2.68 2.467.572a12 12 0 0 0 1.92-3.15l-1.723-1.733v-5.477l1.724-1.733A12 12 0 0 0 26 8.379l-2.467.571-4.843-2.68-.714-2.322a13.3 13.3 0 0 0-3.952 0L13.31 6.27 8.467 8.95 6 8.38a12 12 0 0 0-1.921 3.152l1.724 1.734v5.473l-1.724 1.734A12 12 0 0 0 6 23.622l2.468-.572 4.843 2.68.714 2.324a13.4 13.4 0 0 0 3.952-.001zm5.11-.77-3.603 1.994-.65 2.11a.96.96 0 0 1-.738.67 15.192 15.192 0 0 1-5.62 0 .96.96 0 0 1-.736-.669l-.65-2.115L8.2 24.96l-2.275.527a.96.96 0 0 1-.93-.279 13.8 13.8 0 0 1-2.803-4.626.96.96 0 0 1 .233-.998l1.578-1.587v-3.988L2.424 12.42a.96.96 0 0 1-.233-.997c.62-1.721 1.581-3.287 2.805-4.63a.96.96 0 0 1 .93-.28l2.274.528 3.603-1.994.65-2.113a.96.96 0 0 1 .738-.672 15.131 15.131 0 0 1 5.62.002c.352.067.631.33.736.671l.65 2.112L23.8 7.04l2.274-.527a.96.96 0 0 1 .93.28 13.9 13.9 0 0 1 2.804 4.629.96.96 0 0 1-.233.998l-1.578 1.587v3.991l1.578 1.587c.262.263.359.65.233.998a13.9 13.9 0 0 1-2.804 4.626.96.96 0 0 1-.93.28z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGearMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4m4-2.2a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m13.64 18.994 3.943-2.182 1.746.405a8.6 8.6 0 0 0 1.077-1.76l-1.208-1.215V9.763l1.208-1.215a8.6 8.6 0 0 0-1.078-1.762l-1.745.404-3.942-2.182-.505-1.64a9.5 9.5 0 0 0-2.272 0l-.504 1.64L6.417 7.19l-1.745-.404a8.6 8.6 0 0 0-1.078 1.762l1.208 1.215v4.476l-1.208 1.215a8.6 8.6 0 0 0 1.077 1.76l1.746-.404 3.943 2.182.504 1.64a9.6 9.6 0 0 0 2.273 0zm4.21-.272-2.702 1.495-.444 1.444a.95.95 0 0 1-.74.668 11.5 11.5 0 0 1-3.93 0 .95.95 0 0 1-.737-.666l-.445-1.448-2.702-1.496-1.57.364a.95.95 0 0 1-.927-.281 10.4 10.4 0 0 1-1.957-3.225.94.94 0 0 1 .229-.997l1.077-1.083v-2.991L1.925 9.422a.94.94 0 0 1-.23-.996 10.4 10.4 0 0 1 1.958-3.227c.231-.26.59-.36.928-.282l1.569.364 2.702-1.496.445-1.446a.95.95 0 0 1 .74-.668 11.335 11.335 0 0 1 3.93.002.95.95 0 0 1 .736.666l.445 1.446 2.702 1.496 1.57-.364a.95.95 0 0 1 .927.282c.84.947 1.507 2.037 1.957 3.227a.94.94 0 0 1-.229.996l-1.077 1.084v2.993l1.077 1.084c.262.263.36.65.229.996a10.4 10.4 0 0 1-1.957 3.224.95.95 0 0 1-.928.283z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGearMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1.4-3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m1.55 10.828.702-.705V7.879l-.703-.706a.93.93 0 0 1-.223-.994 7.8 7.8 0 0 1 1.322-2.174.93.93 0 0 1 .924-.286l1.04.241L6.64 2.84l.29-.946a.94.94 0 0 1 .741-.663 8.6 8.6 0 0 1 2.662 0c.353.057.632.32.738.663l.29.946 2.027 1.121 1.04-.24a.93.93 0 0 1 .925.285 7.8 7.8 0 0 1 1.321 2.174.93.93 0 0 1-.223.994l-.702.706v2.246l.702.705c.262.263.361.651.223.995a7.8 7.8 0 0 1-1.321 2.172.93.93 0 0 1-.924.286l-1.04-.242-2.027 1.122-.29.944a.94.94 0 0 1-.741.663 8.6 8.6 0 0 1-2.662.001.94.94 0 0 1-.738-.662l-.29-.948-2.028-1.121-1.04.24a.93.93 0 0 1-.924-.284 7.8 7.8 0 0 1-1.321-2.173.93.93 0 0 1 .223-.995m11.6 1.516-3.129 1.732-.359 1.167a7 7 0 0 1-1.324 0l-.359-1.17-3.13-1.73-1.246.288a6 6 0 0 1-.607-.988l.856-.86V7.219l-.856-.86q.256-.523.608-.99l1.246.289 3.129-1.732.36-1.17a7 7 0 0 1 1.323.001l.36 1.17 3.128 1.73 1.246-.288q.35.468.607.99l-.855.86v3.566l.855.86a6 6 0 0 1-.607.988z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGearMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334M9.167 8a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m1.425 9.578.577-.58V7.004l-.577-.58c-.262-.263-.362-.651-.22-.993a7 7 0 0 1 1.108-1.824.93.93 0 0 1 .923-.287l.864.2 1.802-.997.239-.779a.93.93 0 0 1 .74-.66 7.6 7.6 0 0 1 2.24 0 .93.93 0 0 1 .738.66l.24.78 1.801.996.864-.2a.92.92 0 0 1 .923.287c.46.547.835 1.16 1.109 1.823.14.343.04.731-.22.994l-.578.58V9l.577.58c.262.262.362.65.22.993a7 7 0 0 1-1.108 1.821.93.93 0 0 1-.923.288l-.864-.2-1.802.996-.239.778a.93.93 0 0 1-.74.66 7.6 7.6 0 0 1-2.24.001.93.93 0 0 1-.737-.66l-.24-.78L4.1 12.48l-.865.2a.92.92 0 0 1-.921-.287 7 7 0 0 1-1.11-1.822c-.14-.342-.04-.73.22-.993m10.253 1.312-2.835 1.569-.313 1.018a6 6 0 0 1-1.059 0l-.313-1.02-2.836-1.569-1.087.252a5.4 5.4 0 0 1-.477-.776l.744-.747V6.385l-.744-.748q.205-.407.477-.777l1.087.252 2.836-1.57.313-1.019a6 6 0 0 1 1.058 0l.314 1.02 2.835 1.569 1.086-.252q.272.37.478.777l-.744.748v3.233l.744.748q-.206.406-.477.776z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGearMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsxs("g", { fillRule: "evenodd", clipPath: `url(#${_id})`, clipRule: "evenodd", children: [
              /* @__PURE__ */ jsx("path", { d: "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.8-2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0" }),
              /* @__PURE__ */ jsx("path", { d: "m4.564 10.555-.138-.447-1.351-.748-.513.119c-.338.078-.699-.02-.915-.292a5.2 5.2 0 0 1-.684-1.12c-.151-.338-.05-.728.212-.99l.326-.329V5.253l-.326-.329c-.262-.262-.364-.651-.213-.99.18-.401.41-.777.684-1.12.217-.272.578-.37.917-.292l.512.118 1.351-.747.137-.446c.106-.343.386-.61.742-.654a5.7 5.7 0 0 1 1.392 0c.355.045.634.311.74.653l.137.447 1.351.747.512-.118c.339-.079.7.02.917.292.273.343.504.719.683 1.12.151.339.05.728-.212.99l-.326.329V6.75l.326.328c.262.263.364.652.212.99q-.272.604-.683 1.12c-.217.271-.578.37-.917.292l-.512-.119-1.351.748-.137.444c-.105.343-.386.61-.742.654a5.7 5.7 0 0 1-1.392 0c-.355-.043-.634-.31-.74-.652m4.183-2.467L6.57 9.293l-.229.744a4.4 4.4 0 0 1-.68 0l-.229-.745-2.178-1.205-.795.184a4 4 0 0 1-.298-.483l.541-.545V4.758l-.541-.545q.131-.252.298-.484l.795.184L5.43 2.708l.229-.745a4.5 4.5 0 0 1 .68 0l.23.745 2.177 1.205.795-.184q.165.233.298.485l-.541.544v2.487l.54.544q-.13.251-.297.483z" })
            ] }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconGear/IconGear.tsx
var IconGear = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconGearMonochromeExtralight,
          "monochrome|light": IconGearMonochromeLight,
          "monochrome|regular": IconGearMonochromeRegular,
          "monochrome|medium": IconGearMonochromeMedium,
          "monochrome|semibold": IconGearMonochromeSemibold,
          "monochrome|bold": IconGearMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconGiftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.8 11A6.2 6.2 0 0 1 24 7.333a6.2 6.2 0 1 1 9.9 7.467H42a1.2 1.2 0 0 1 1.2 1.2v8a1.2 1.2 0 0 1-1.2 1.2h-.8V36a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 36V25.2H6A1.2 1.2 0 0 1 4.8 24v-8A1.2 1.2 0 0 1 6 14.8h8.1a6.17 6.17 0 0 1-1.3-3.8m6.2 3.8h3.8V11a3.8 3.8 0 1 0-3.8 3.8m6.2-3.8v3.8H29a3.8 3.8 0 1 0-3.8-3.8m-2.4 6.2H7.2v5.6h15.6zm2.4 5.6v-5.6h15.6v5.6zm-2.4 2.4H9.2V36a4.8 4.8 0 0 0 4.8 4.8h8.8zm2.4 15.6V25.2h13.6V36a4.8 4.8 0 0 1-4.8 4.8z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGiftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.333 7.333A4.333 4.333 0 0 1 16 4.564a4.333 4.333 0 0 1 6.985 5.102H28a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1h-.333v7a5 5 0 0 1-5 5H9.333a5 5 0 0 1-5-5v-7H4a1 1 0 0 1-1-1v-5.333a1 1 0 0 1 1-1h5.015a4.3 4.3 0 0 1-.682-2.334m4.334 2.334H15V7.333a2.333 2.333 0 1 0-2.333 2.334M17 7.333v2.334h2.333A2.333 2.333 0 1 0 17 7.333m-2 4.334H5V15h10zM17 15v-3.333h10V15zm-2 2H6.333v7a3 3 0 0 0 3 3H15zm2 10V17h8.667v7a3 3 0 0 1-3 3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGiftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.1 8a.9.9 0 0 1 .9-.9h18a.9.9 0 0 1 .9.9v4a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9zm1.8.9v2.2h16.2V8.9z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.1 5.5a3.4 3.4 0 1 1 6.8 0v3.4H9.5a3.4 3.4 0 0 1-3.4-3.4m3.4-1.6a1.6 1.6 0 1 0 0 3.2h1.6V5.5a1.6 1.6 0 0 0-1.6-1.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.9 5.5a3.4 3.4 0 1 0-6.8 0v3.4h3.4a3.4 3.4 0 0 0 3.4-3.4m-3.4-1.6a1.6 1.6 0 1 1 0 3.2h-1.6V5.5a1.6 1.6 0 0 1 1.6-1.6M3.1 12a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v6a3.9 3.9 0 0 1-3.9 3.9H7A3.9 3.9 0 0 1 3.1 18zm1.8.9V18c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-5.1z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 7.1a.9.9 0 0 1 .9.9v13a.9.9 0 1 1-1.8 0V8a.9.9 0 0 1 .9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconGiftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.45 4.125A2.675 2.675 0 0 1 9 2.217 2.675 2.675 0 0 1 13.325 5.2h2.425a.8.8 0 0 1 .8.8v3a.8.8 0 0 1-.75.798V13.5a3.05 3.05 0 0 1-3.05 3.05h-7.5A3.05 3.05 0 0 1 2.2 13.5V9.798A.8.8 0 0 1 1.45 9V6a.8.8 0 0 1 .8-.8h2.425a2.7 2.7 0 0 1-.225-1.075M7.125 5.2H8.2V4.125A1.075 1.075 0 1 0 7.125 5.2M9.8 4.125V5.2h1.075A1.075 1.075 0 1 0 9.8 4.125M8.2 6.8H3.05v1.4H8.2zm1.6 1.4V6.8h5.15v1.4zM8.2 9.8H3.8v3.7c0 .8.65 1.45 1.45 1.45H8.2zm1.6 5.15V9.8h4.4v3.7c0 .8-.65 1.45-1.45 1.45z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGiftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.917 3.667A2.417 2.417 0 0 1 8 1.917a2.417 2.417 0 0 1 3.903 2.667H14a.75.75 0 0 1 .75.75V8a.75.75 0 0 1-.667.745V12a2.75 2.75 0 0 1-2.75 2.75H4.667A2.75 2.75 0 0 1 1.917 12V8.745A.75.75 0 0 1 1.25 8V5.333a.75.75 0 0 1 .75-.75h2.097a2.4 2.4 0 0 1-.18-.916m2.416.916h.917v-.916a.917.917 0 1 0-.917.916m2.417-.916v.916h.917a.917.917 0 1 0-.917-.916m-1.5 2.416h-4.5V7.25h4.5zm1.5 1.167V6.083h4.5V7.25zm-1.5 1.5H3.417V12c0 .69.56 1.25 1.25 1.25H7.25zm1.5 4.5v-4.5h3.833V12c0 .69-.56 1.25-1.25 1.25z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGiftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("g", { clipPath: `url(#${_id})`, children: /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.9 2.75A1.85 1.85 0 0 1 6 1.386 1.85 1.85 0 0 1 8.983 3.4H10.5a.6.6 0 0 1 .6.6v2a.6.6 0 0 1-.5.592V9a2.1 2.1 0 0 1-2.1 2.1h-5A2.1 2.1 0 0 1 1.4 9V6.592A.6.6 0 0 1 .9 6V4a.6.6 0 0 1 .6-.6h1.517a1.9 1.9 0 0 1-.117-.65m1.85.65h.65v-.65a.65.65 0 1 0-.65.65m1.85-.65v.65h.65a.65.65 0 1 0-.65-.65M5.4 4.6H2.1v.8h3.3zm1.2.8v-.8h3.3v.8zM5.4 6.6H2.6V9a.9.9 0 0 0 .9.9h1.9zm1.2 3.3V6.6h2.8V9a.9.9 0 0 1-.9.9z",
                clipRule: "evenodd"
              }
            ) }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconGift/IconGift.tsx
var IconGift = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconGiftMonochromeExtralight,
          "monochrome|light": IconGiftMonochromeLight,
          "monochrome|regular": IconGiftMonochromeRegular,
          "monochrome|medium": IconGiftMonochromeMedium,
          "monochrome|semibold": IconGiftMonochromeSemibold,
          "monochrome|bold": IconGiftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconGiftFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19 4.2a6.2 6.2 0 0 0-4.9 10H6A1.8 1.8 0 0 0 4.2 16v8A1.8 1.8 0 0 0 6 25.8h16.8V14.2h2.4v11.6H42a1.8 1.8 0 0 0 1.8-1.8v-8a1.8 1.8 0 0 0-1.8-1.8h-8.1A6.2 6.2 0 1 0 24 6.733 6.19 6.19 0 0 0 19 4.2m3.8 10v-3.8a3.8 3.8 0 1 0-3.8 3.8zm6.2 0h-3.8v-3.8a3.8 3.8 0 1 1 3.8 3.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M41.8 28.2H25.2v15.6H34a7.8 7.8 0 0 0 7.8-7.8zM22.8 43.8V28.2H6.2V36a7.8 7.8 0 0 0 7.8 7.8z" })
          ]
        }
      );
    }
  )
);
var IconGiftFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.667 2.8a4.333 4.333 0 0 0-3.652 6.667H4a1.2 1.2 0 0 0-1.2 1.2V16A1.2 1.2 0 0 0 4 17.2h11V9.46h2v7.74h11a1.2 1.2 0 0 0 1.2-1.2v-5.333a1.2 1.2 0 0 0-1.2-1.2h-5.015A4.333 4.333 0 0 0 16 4.365 4.32 4.32 0 0 0 12.667 2.8m-.028 6.667h2.36V7.133L15 7.102a2.333 2.333 0 1 0-2.361 2.365m4.361 0h2.361A2.333 2.333 0 1 0 17 7.102v2.365",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M27.867 19.2H17v10h-2v-10H4.133V24a5.2 5.2 0 0 0 5.2 5.2h13.334a5.2 5.2 0 0 0 5.2-5.2z" })
          ]
        }
      );
    }
  )
);
var IconGiftFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.5 2.1a3.4 3.4 0 0 0-3 5H3a.9.9 0 0 0-.9.9v4a.9.9 0 0 0 .9.9h8.1V7.1h1.8v5.8H21a.9.9 0 0 0 .9-.9V8a.9.9 0 0 0-.9-.9h-3.5A3.4 3.4 0 0 0 12 3.196 3.4 3.4 0 0 0 9.5 2.1m11.4 12.6h-8v7.2H17a3.9 3.9 0 0 0 3.9-3.9zm-9.8 7.2v-7.2h-8V18A3.9 3.9 0 0 0 7 21.9zm1.8-14.8V5.48a1.6 1.6 0 1 1 1.6 1.62zm-1.8 0H9.5a1.6 1.6 0 1 1 1.6-1.62V7.1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGiftFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M15.675 11.3H9.8v5.125h2.95a2.925 2.925 0 0 0 2.925-2.925zM8.2 16.425V11.3H2.325v2.2a2.925 2.925 0 0 0 2.925 2.925zM7.125 1.45a2.675 2.675 0 0 0-2.391 3.875H2.25A.675.675 0 0 0 1.575 6v3c0 .373.302.675.675.675h.075L8.2 9.7V5.2H7.125A1.075 1.075 0 1 1 8.2 4.1v1.0999999999999999h1.6V4.1a1.075 1.075 0 1 1 1.075 1.1H9.8v4.5l5.875-.025h.075A.675.675 0 0 0 16.425 9V6a.675.675 0 0 0-.675-.675h-2.484A2.675 2.675 0 0 0 9 2.217a2.67 2.67 0 0 0-1.875-.767" })
        }
      );
    }
  )
);
var IconGiftFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.333 1.25a2.417 2.417 0 0 0-2.169 3.483H2a.6.6 0 0 0-.6.6V8a.6.6 0 0 0 .6.6h5.25V4.583h1.5V8.6H14a.6.6 0 0 0 .6-.6V5.333a.6.6 0 0 0-.6-.6h-2.164A2.417 2.417 0 0 0 8 1.916a2.4 2.4 0 0 0-1.667-.666m-.917 2.417a.917.917 0 0 1 1.834 0v.916h-.917a.917.917 0 0 1-.917-.916m5.168 0a.917.917 0 1 0-1.834 0v.916h.917c.506 0 .917-.41.917-.916",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M13.934 10.1H8.75v4.5h2.584a2.6 2.6 0 0 0 2.6-2.6zM7.25 14.6v-4.5H2.067V12a2.6 2.6 0 0 0 2.6 2.6z" })
          ]
        }
      );
    }
  )
);
var IconGiftFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.75.9A1.85 1.85 0 0 0 3.08 3.55H1.5a.45.45 0 0 0-.45.45v2a.45.45 0 0 0 .438.45H5.4V3.4h1.2v3.05h3.911A.45.45 0 0 0 10.95 6V4a.45.45 0 0 0-.45-.45H8.919A1.85 1.85 0 0 0 6 1.386 1.84 1.84 0 0 0 4.75.9m.65 2.5v-.65a.65.65 0 1 0-.65.65zm2.5-.65a.65.65 0 0 0-1.3 0v.65h.65a.65.65 0 0 0 .65-.65",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.45 7.65H6.6v3.3h1.9A1.95 1.95 0 0 0 10.45 9zM5.4 10.95v-3.3H1.55V9a1.95 1.95 0 0 0 1.95 1.95z" })
          ]
        }
      );
    }
  )
);

// src/IconGiftFilled/IconGiftFilled.tsx
var IconGiftFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconGiftFilledMonochromeExtralight,
          "monochrome|light": IconGiftFilledMonochromeLight,
          "monochrome|regular": IconGiftFilledMonochromeRegular,
          "monochrome|medium": IconGiftFilledMonochromeMedium,
          "monochrome|semibold": IconGiftFilledMonochromeSemibold,
          "monochrome|bold": IconGiftFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconGlobeMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M40.354 228a203 203 0 0 0 0 24c5.42 91.585 72.47 166.59 160.26 184.123A201 201 0 0 0 240 440c13.482 0 26.652-1.334 39.386-3.877 87.79-17.533 154.84-92.538 160.26-184.123a203 203 0 0 0 0-24c-5.42-91.585-72.47-166.59-160.26-184.123A201 201 0 0 0 240 40a201 201 0 0 0-39.387 3.877C112.824 61.41 45.773 136.415 40.354 228M174.843 76.455C113.428 100.944 69.047 159.027 64.403 228h74.861c1.328-51.807 11.207-98.95 26.916-134.295 2.694-6.062 5.584-11.83 8.663-17.25M139.264 252H64.403c4.644 68.973 49.025 127.056 110.44 151.545-3.079-5.42-5.969-11.188-8.663-17.25-15.709-35.345-25.588-82.488-26.916-134.295m72.551 161.755c-8.474-8.674-16.586-21.194-23.703-37.207-14.117-31.764-23.513-75.459-24.839-124.548h153.454c-1.326 49.089-10.722 92.784-24.839 124.548-7.117 16.013-15.229 28.533-23.703 37.207A177 177 0 0 1 240 416a177 177 0 0 1-28.185-2.245m93.342-10.21c61.415-24.489 105.796-82.572 110.44-151.545h-74.861c-1.328 51.807-11.207 98.95-26.916 134.295-2.694 6.062-5.584 11.83-8.663 17.25M340.736 228h74.861c-4.644-68.973-49.025-127.056-110.44-151.546 3.079 5.42 5.969 11.19 8.663 17.251 15.709 35.345 25.588 82.488 26.916 134.295M211.815 66.245A177 177 0 0 1 240 64c9.594 0 19.008.768 28.185 2.245 8.474 8.674 16.586 21.194 23.703 37.207 14.117 31.764 23.513 75.459 24.839 124.548H163.273c1.326-49.089 10.722-92.784 24.839-124.548 7.117-16.013 15.229-28.533 23.703-37.207",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGlobeMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M40.604 225.075a203 203 0 0 0-.554 15q.002 7.57.554 15c6.538 88.194 70.264 160.473 154.228 179.887a200.7 200.7 0 0 0 45.243 5.138c15.56 0 30.705-1.777 45.243-5.138 83.964-19.414 147.689-91.693 154.228-179.887a203 203 0 0 0 0-30c-6.539-88.194-70.264-160.472-154.228-179.887a200.6 200.6 0 0 0-45.243-5.138c-15.56 0-30.705 1.777-45.243 5.138-83.964 19.415-147.69 91.693-154.228 179.887M166.087 86.949c-52.575 25.45-90.057 77.18-95.385 138.126h65.711c1.626-50.976 11.488-97.42 27.093-132.531a217 217 0 0 1 2.581-5.595m-29.674 168.126h-65.71c5.327 60.946 42.809 112.676 95.384 138.126q-1.32-2.756-2.581-5.595c-15.605-35.111-25.467-81.555-27.093-132.531m73.74 152.401c-6.779-8.039-13.328-18.768-19.233-32.054-13.634-30.677-22.871-72.817-24.491-120.347H313.72c-1.619 47.53-10.856 89.67-24.491 120.347-5.904 13.286-12.453 24.015-19.233 32.054a171 171 0 0 1-29.921 2.624c-10.209 0-20.208-.9-29.922-2.624m103.909-14.275c52.575-25.45 90.058-77.18 95.385-138.126h-65.711c-1.626 50.976-11.487 97.42-27.092 132.531a217 217 0 0 1-2.582 5.595m29.674-168.126h65.711c-5.327-60.946-42.81-112.676-95.385-138.126q1.32 2.756 2.582 5.595c15.605 35.111 25.466 81.555 27.092 132.531m-133.583-152.4a171 171 0 0 1 29.922-2.625c10.209 0 20.208.9 29.921 2.624 6.78 8.04 13.329 18.768 19.233 32.054 13.635 30.677 22.872 72.817 24.491 120.347H166.429c1.62-47.53 10.857-89.67 24.491-120.347 5.905-13.285 12.454-24.015 19.233-32.054Z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGlobeMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M40.799 222A203 203 0 0 0 40 240c0 6.067.27 12.071.799 18 7.57 84.856 68.136 154.461 148.368 175.483C205.398 437.736 222.435 440 240 440s34.602-2.264 50.833-6.517C371.065 412.461 431.632 342.856 439.201 258c.529-5.929.799-11.933.799-18s-.27-12.071-.799-18c-7.569-84.856-68.136-154.461-148.368-175.483C274.602 42.264 257.565 40 240 40s-34.602 2.264-50.833 6.517C108.935 67.54 48.368 137.144 40.799 222M157.81 98.05C113.803 123.585 82.763 168.998 76.976 222h56.477c1.79-46.948 10.533-90.038 24.357-123.95M133.453 258H76.976c5.787 53.002 36.827 98.415 80.834 123.95-13.824-33.912-22.567-77.002-24.357-123.95m75.454 143.056c-5.333-7.171-10.52-16.163-15.312-26.945-13.151-29.589-22.217-70.167-24.114-116.111h141.038c-1.897 45.944-10.963 86.522-24.114 116.111-4.792 10.782-9.979 19.774-15.312 26.945A165 165 0 0 1 240 404a165 165 0 0 1-31.093-2.944M322.19 381.95c44.007-25.535 75.047-70.948 80.833-123.95h-56.476c-1.79 46.948-10.533 90.038-24.357 123.95M346.547 222h56.476c-5.786-53.002-36.826-98.415-80.833-123.95 13.824 33.912 22.567 77.002 24.357 123.95M208.907 78.944A165 165 0 0 1 240 76a165 165 0 0 1 31.093 2.944c5.333 7.17 10.52 16.163 15.312 26.945 13.151 29.589 22.217 70.167 24.114 116.111H169.481c1.897-45.944 10.963-86.522 24.114-116.111 4.792-10.782 9.979-19.774 15.312-26.945",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGlobeMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M41.124 218.667A202 202 0 0 0 40 240c0 7.206.381 14.324 1.124 21.333 8.613 81.224 65.846 147.935 142.044 170.477C201.183 437.139 220.257 440 240 440s38.817-2.861 56.832-8.19c76.198-22.542 133.431-89.253 142.044-170.477A202 202 0 0 0 440 240c0-7.206-.381-14.324-1.124-21.333-8.613-81.224-65.846-147.935-142.044-170.477C278.817 42.86 259.743 40 240 40s-38.817 2.86-56.832 8.19C106.97 70.732 49.737 137.443 41.124 218.667m108.124-107.205c-34.792 24.61-59.154 62.99-65.147 107.205h46.154c1.779-39.544 8.466-76.34 18.993-107.205m-18.993 149.871H84.101c5.993 44.215 30.355 82.595 65.147 107.205-10.527-30.865-17.214-67.661-18.993-107.205M208.112 394.1c-3.95-6.006-7.816-13.118-11.471-21.343-12.619-28.391-21.486-67.249-23.672-111.424h134.062c-2.186 44.175-11.053 83.033-23.672 111.424-3.655 8.225-7.521 15.337-11.471 21.343A158 158 0 0 1 240 397.333a158 158 0 0 1-31.888-3.233m122.64-25.562c34.792-24.61 59.154-62.99 65.147-107.205h-46.154c-1.779 39.544-8.466 76.34-18.993 107.205m18.993-149.871h46.154c-5.993-44.215-30.355-82.595-65.147-107.205 10.527 30.865 17.214 67.661 18.993 107.205M208.112 85.9A158 158 0 0 1 240 82.667a158 158 0 0 1 31.888 3.233c3.95 6.006 7.816 13.118 11.471 21.343 12.619 28.391 21.486 67.249 23.672 111.424H172.969c2.186-44.175 11.053-83.033 23.672-111.424 3.655-8.225 7.521-15.337 11.471-21.343",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGlobeMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M41.152 217.35a202 202 0 0 0-1.252 22.5c0 7.607.425 15.114 1.252 22.5 8.952 79.938 65.033 145.627 139.813 168.638 18.616 5.728 38.391 8.812 58.886 8.812 20.494 0 40.269-3.084 58.885-8.812 74.78-23.011 130.861-88.7 139.813-168.638a202 202 0 0 0 1.252-22.5c0-7.607-.425-15.114-1.252-22.5-8.952-79.938-65.033-145.627-139.813-168.638-18.616-5.729-38.391-8.812-58.885-8.812-20.495 0-40.27 3.083-58.886 8.812-74.78 23.01-130.86 88.7-139.813 168.638m105.075-100.978C114.613 140.38 92.501 176.25 86.522 217.35h42.492c1.75-36.924 7.772-71.447 17.213-100.978M129.014 262.35H86.522c5.979 41.1 28.091 76.97 59.705 100.977-9.441-29.53-15.463-64.053-17.213-100.977m78.784 129.131c-3.508-5.553-6.948-12.01-10.225-19.383-12.429-27.965-21.221-66.21-23.504-109.748h131.563c-2.283 43.538-11.075 81.783-23.504 109.748-3.277 7.373-6.717 13.83-10.225 19.383a155.6 155.6 0 0 1-32.052 3.319 155.6 155.6 0 0 1-32.053-3.319m125.676-28.154c31.614-24.007 53.726-59.877 59.705-100.977h-42.492c-1.75 36.924-7.772 71.447-17.213 100.977m17.213-145.977h42.492c-5.979-41.1-28.091-76.97-59.705-100.978 9.441 29.531 15.463 64.054 17.213 100.978M207.798 88.219a155.6 155.6 0 0 1 32.053-3.32 155.6 155.6 0 0 1 32.052 3.32c3.508 5.552 6.948 12.01 10.225 19.383 12.429 27.965 21.221 66.209 23.504 109.748H174.069c2.283-43.539 11.075-81.783 23.504-109.748 3.277-7.373 6.717-13.83 10.225-19.383",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconGlobeMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M41.425 216A202 202 0 0 0 40 240c0 8.122.484 16.131 1.425 24 9.37 78.351 64.038 142.784 137.065 166.363C197.868 436.62 218.539 440 240 440s42.132-3.38 61.51-9.637C374.537 406.784 429.205 342.351 438.575 264A202 202 0 0 0 440 240c0-8.122-.484-16.131-1.425-24-9.37-78.351-64.038-142.784-137.065-166.363C282.132 43.38 261.461 40 240 40s-42.132 3.38-61.51 9.637C105.463 73.216 50.795 137.649 41.425 216m101.314-92.813C115.106 146.219 95.773 178.872 89.884 216h37.829c1.693-33.576 6.911-65.163 15.026-92.813M127.713 264H89.884c5.89 37.128 25.222 69.781 52.855 92.813-8.115-27.65-13.333-59.237-15.026-92.813m80.079 124.581c-2.977-4.949-5.903-10.581-8.714-16.907-12.195-27.438-20.896-64.925-23.298-107.674h128.44c-2.402 42.749-11.103 80.236-23.298 107.674-2.811 6.326-5.737 11.958-8.714 16.907A152.6 152.6 0 0 1 240 392a152.6 152.6 0 0 1-32.208-3.419m129.469-31.768c27.633-23.032 46.966-55.685 52.855-92.813h-37.829c-1.693 33.576-6.911 65.163-15.026 92.813M352.287 216h37.829c-5.889-37.128-25.222-69.781-52.855-92.813 8.115 27.65 13.333 59.237 15.026 92.813M207.792 91.42A152.6 152.6 0 0 1 240 88a152.6 152.6 0 0 1 32.208 3.42c2.977 4.948 5.903 10.58 8.714 16.906 12.195 27.438 20.896 64.925 23.298 107.674H175.78c2.402-42.749 11.103-80.236 23.298-107.674 2.811-6.326 5.737-11.958 8.714-16.907Z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconGlobe/IconGlobe.tsx
var IconGlobe = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconGlobeMonochromeExtralight,
          "monochrome|light": IconGlobeMonochromeLight,
          "monochrome|regular": IconGlobeMonochromeRegular,
          "monochrome|medium": IconGlobeMonochromeMedium,
          "monochrome|semibold": IconGlobeMonochromeSemibold,
          "monochrome|bold": IconGlobeMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconGripVerticalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M17.333 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17.333 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8M21.333 40a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M34.667 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 44a4 4 0 1 0 0-8 4 4 0 0 0 0 8" })
        }
      );
    }
  )
);
var IconGripVerticalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.556 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M11.556 18.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.333M14.222 26.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M23.111 16a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 29.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333" })
        }
      );
    }
  )
);
var IconGripVerticalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.667 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.667 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M10.667 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17.333 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4" })
        }
      );
    }
  )
);
var IconGripVerticalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6.5 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M13 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" })
        }
      );
    }
  )
);
var IconGripVerticalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.778 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M5.778 9.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M7.111 13.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M10.222 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M11.555 8A1.333 1.333 0 1 1 8.89 8a1.333 1.333 0 0 1 2.666 0M10.222 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667" })
        }
      );
    }
  )
);
var IconGripVerticalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.333 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.333 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.333 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.667 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
        }
      );
    }
  )
);

// src/IconGripVertical/IconGripVertical.tsx
var IconGripVertical = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconGripVerticalMonochromeExtralight,
          "monochrome|light": IconGripVerticalMonochromeLight,
          "monochrome|regular": IconGripVerticalMonochromeRegular,
          "monochrome|medium": IconGripVerticalMonochromeMedium,
          "monochrome|semibold": IconGripVerticalMonochromeSemibold,
          "monochrome|bold": IconGripVerticalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHashtagMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.3 7.7a.6.6 0 0 1 .6-.6h17.2a.6.6 0 1 1 0 1.2H3.9a.6.6 0 0 1-.6-.6M2.3 16.3a.6.6 0 0 1 .6-.6h17.2a.6.6 0 1 1 0 1.2H2.9a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.378 21.08a.6.6 0 0 1-.486-.695L8.878 3.446a.6.6 0 1 1 1.182.208l-2.987 16.94a.6.6 0 0 1-.695.486M14.427 21.08a.6.6 0 0 1-.487-.695l2.987-16.939a.6.6 0 0 1 1.181.208l-2.986 16.94a.6.6 0 0 1-.695.486",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconHashtagMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.15 7.7a.75.75 0 0 1 .75-.75h17.2a.75.75 0 0 1 0 1.5H3.9a.75.75 0 0 1-.75-.75M2.15 16.3a.75.75 0 0 1 .75-.75h17.2a.75.75 0 1 1 0 1.5H2.9a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.352 21.228a.75.75 0 0 1-.608-.87L8.73 3.42a.75.75 0 0 1 1.477.26L7.22 20.62a.75.75 0 0 1-.869.608M14.4 21.228a.75.75 0 0 1-.608-.87L16.78 3.42a.75.75 0 1 1 1.477.26L15.27 20.62a.75.75 0 0 1-.869.608",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconHashtagMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3 7.7a.9.9 0 0 1 .9-.9h17.2a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9M2 16.3a.9.9 0 0 1 .9-.9h17.2a.9.9 0 0 1 0 1.8H2.9a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.326 21.375a.9.9 0 0 1-.73-1.043L8.583 3.393a.9.9 0 1 1 1.772.313L7.37 20.645a.9.9 0 0 1-1.043.73M14.374 21.375a.9.9 0 0 1-.73-1.043l2.987-16.939a.9.9 0 1 1 1.773.313l-2.987 16.939a.9.9 0 0 1-1.043.73",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconHashtagMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.833 7.7c0-.589.478-1.066 1.067-1.066h17.2a1.067 1.067 0 0 1 0 2.133H3.9c-.59 0-1.067-.477-1.067-1.066M1.833 16.3c0-.59.478-1.067 1.067-1.067h17.2a1.067 1.067 0 0 1 0 2.133H2.9c-.59 0-1.067-.477-1.067-1.067",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.297 21.54a1.067 1.067 0 0 1-.865-1.236L8.419 3.365a1.067 1.067 0 0 1 2.1.37l-2.986 16.94c-.102.58-.656.967-1.236.864M14.345 21.54a1.067 1.067 0 0 1-.865-1.236l2.987-16.939a1.067 1.067 0 1 1 2.1.37l-2.986 16.94c-.102.58-.655.967-1.236.864",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconHashtagMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.776 7.7c0-.621.503-1.125 1.125-1.125h17.2a1.125 1.125 0 0 1 0 2.25H3.9A1.125 1.125 0 0 1 2.776 7.7M1.775 16.299c0-.621.504-1.125 1.125-1.125h17.2a1.125 1.125 0 0 1 0 2.25H2.9a1.125 1.125 0 0 1-1.125-1.125",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.288 21.596a1.125 1.125 0 0 1-.913-1.303L8.362 3.354a1.125 1.125 0 1 1 2.216.39L7.59 20.685a1.125 1.125 0 0 1-1.303.912M14.336 21.596a1.125 1.125 0 0 1-.913-1.303L16.41 3.354a1.125 1.125 0 0 1 2.216.39l-2.987 16.94a1.125 1.125 0 0 1-1.303.912",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconHashtagMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.7 7.701a1.2 1.2 0 0 1 1.2-1.2h17.2a1.2 1.2 0 1 1 0 2.4H3.9a1.2 1.2 0 0 1-1.2-1.2M1.7 16.302a1.2 1.2 0 0 1 1.2-1.2h17.2a1.2 1.2 0 1 1 0 2.4H2.9a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.274 21.672a1.2 1.2 0 0 1-.974-1.39L8.287 3.343a1.2 1.2 0 0 1 2.363.417L7.664 20.7a1.2 1.2 0 0 1-1.39.973M14.322 21.672a1.2 1.2 0 0 1-.973-1.39l2.986-16.939a1.2 1.2 0 1 1 2.364.417L15.712 20.7a1.2 1.2 0 0 1-1.39.973",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconHashtag/IconHashtag.tsx
var IconHashtag = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHashtagMonochromeExtralight,
          "monochrome|light": IconHashtagMonochromeLight,
          "monochrome|regular": IconHashtagMonochromeRegular,
          "monochrome|medium": IconHashtagMonochromeMedium,
          "monochrome|semibold": IconHashtagMonochromeSemibold,
          "monochrome|bold": IconHashtagMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHeadsetMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M136 234c0-18.981-11.752-35.217-28.376-41.83C115.323 123.718 171.897 71 240 71s124.677 52.718 132.376 121.17C355.752 198.783 344 215.019 344 234v55c0 13.553 5.991 25.706 15.47 33.956-13.842 24.505-37.723 42.516-65.096 54.271C290.659 354.414 270.863 337 247 337c-26.51 0-48 21.49-48 48s21.49 48 48 48c19.632 0 36.511-11.786 43.948-28.668l.08-.028c35.832-12.767 70.801-35.627 90.14-70.983A45.3 45.3 0 0 0 389 334c24.853 0 45-20.147 45-45v-55c0-22.39-16.352-40.96-37.765-44.421C387.271 109.563 320.985 47 240 47S92.73 109.563 83.765 189.579C62.352 193.04 46 211.61 46 234v55c0 24.853 20.147 45 45 45s45-20.147 45-45zm-45-21c-11.598 0-21 9.402-21 21v55c0 11.598 9.402 21 21 21s21-9.402 21-21v-55c0-11.598-9.402-21-21-21m298 0c-11.598 0-21 9.402-21 21v55c0 11.598 9.402 21 21 21s21-9.402 21-21v-55c0-11.598-9.402-21-21-21M223 385c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeadsetMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M139 234c0-19.422-11.535-36.15-28.128-43.706C119.363 124.364 174.237 74 240 74s120.637 50.364 129.128 116.294C352.535 197.85 341 214.578 341 234v55c0 13.56 5.623 25.806 14.663 34.535-13.002 21.753-34.344 38.214-59.088 49.441C291.17 350.612 271.025 334 247 334c-28.167 0-51 22.833-51 51s22.833 51 51 51c20.395 0 37.995-11.972 46.153-29.272 35.246-12.77 69.832-35.33 89.621-70.128q3.059.398 6.226.4c26.51 0 48-21.49 48-48v-55c0-23.097-16.313-42.383-38.046-46.967C388.864 106.637 321.843 44 240 44S91.136 106.637 81.046 187.033C59.313 191.617 43 210.903 43 234v55c0 26.51 21.49 48 48 48s48-21.49 48-48zm-48-18c-9.941 0-18 8.059-18 18v55c0 9.941 8.059 18 18 18s18-8.059 18-18v-55c0-9.941-8.059-18-18-18m298 0c-9.941 0-18 8.059-18 18v55c0 9.941 8.059 18 18 18s18-8.059 18-18v-55c0-9.941-8.059-18-18-18M226 385c0-11.598 9.402-21 21-21s21 9.402 21 21-9.402 21-21 21-21-9.402-21-21",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeadsetMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M142 234c0-19.836-11.324-37.027-27.86-45.461C123.344 125.083 176.536 77 240 77s116.656 48.083 125.86 111.539C349.324 196.973 338 214.164 338 234v55c0 13.535 5.273 25.838 13.876 34.969-12.133 19.218-31.141 34.169-53.36 44.794C291.624 346.874 271.166 331 247 331c-29.823 0-54 24.177-54 54s24.177 54 54 54c21.151 0 39.462-12.16 48.322-29.871 34.691-12.781 68.892-35.069 89.07-69.334q2.277.204 4.608.205c28.167 0 51-22.833 51-51v-55c0-23.797-16.299-43.788-38.343-49.417C390.503 103.762 322.728 41 240 41S89.498 103.762 78.343 184.583C56.3 190.212 40 210.203 40 234v55c0 28.167 22.834 51 51 51 28.167 0 51-22.833 51-51zm-51-15c-8.284 0-15 6.716-15 15v55c0 8.284 6.716 15 15 15s15-6.716 15-15v-55c0-8.284-6.716-15-15-15m298 0c-8.284 0-15 6.716-15 15v55c0 8.284 6.716 15 15 15s15-6.716 15-15v-55c0-8.284-6.716-15-15-15M229 385c0-9.941 8.059-18 18-18s18 8.059 18 18-8.059 18-18 18-18-8.059-18-18",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeadsetMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M145.334 233.999c0-20.265-11.094-37.94-27.541-47.28 9.912-60.758 61.255-106.385 122.206-106.385s112.294 45.627 122.206 106.385c-16.446 9.34-27.541 27.015-27.541 47.28v55c0 13.472 4.903 25.798 13.021 35.293-11.135 16.624-27.746 29.943-47.274 39.822-8.349-21.338-29.116-36.45-53.412-36.45-31.665 0-57.335 25.67-57.335 57.335s25.67 57.335 57.335 57.335c21.982 0 41.075-12.371 50.696-30.53 34.133-12.798 67.94-34.816 88.505-68.541q1.39.07 2.799.071c30.008 0 54.335-24.327 54.335-54.335v-55c0-24.569-16.307-45.33-38.689-52.048-12.278-81.335-80.908-144.287-164.646-144.287S87.631 100.616 75.353 181.951c-22.382 6.718-38.689 27.479-38.689 52.048v55c0 30.008 24.327 54.335 54.335 54.335s54.335-24.327 54.335-54.335zm-54.335-11.665c-6.442 0-11.665 5.223-11.665 11.665v55c0 6.442 5.223 11.665 11.665 11.665 6.443 0 11.665-5.223 11.665-11.665v-55c0-6.442-5.222-11.665-11.665-11.665m298 0c-6.442 0-11.665 5.223-11.665 11.665v55c0 6.442 5.223 11.665 11.665 11.665s11.665-5.223 11.665-11.665v-55c0-6.442-5.223-11.665-11.665-11.665M232.334 384.999c0-8.099 6.566-14.665 14.665-14.665s14.665 6.566 14.665 14.665-6.566 14.665-14.665 14.665-14.665-6.566-14.665-14.665",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeadsetMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M146.5 234c0-20.408-11.015-38.244-27.424-47.885C129.215 126.288 179.916 81.5 240 81.5s110.785 44.788 120.924 104.615C344.515 195.756 333.5 213.592 333.5 234v55a55.27 55.27 0 0 0 12.728 35.369c-10.779 15.769-26.597 28.528-45.212 38.13C292.2 341.359 271.335 326.5 247 326.5c-32.309 0-58.5 26.191-58.5 58.5s26.191 58.5 58.5 58.5c22.271 0 41.634-12.445 51.517-30.759 33.95-12.804 67.628-34.736 88.318-68.282q1.077.04 2.165.041c30.652 0 55.5-24.848 55.5-55.5v-55c0-24.837-16.315-45.864-38.813-52.948C393.029 99.529 324.096 36.5 240 36.5S86.97 99.529 74.313 181.052C51.815 188.136 35.5 209.163 35.5 234v55c0 30.652 24.848 55.5 55.5 55.5s55.5-24.848 55.5-55.5zM91 223.5c-5.799 0-10.5 4.701-10.5 10.5v55c0 5.799 4.701 10.5 10.5 10.5s10.5-4.701 10.5-10.5v-55c0-5.799-4.701-10.5-10.5-10.5m298 0c-5.799 0-10.5 4.701-10.5 10.5v55c0 5.799 4.701 10.5 10.5 10.5s10.5-4.701 10.5-10.5v-55c0-5.799-4.701-10.5-10.5-10.5M233.5 385c0-7.456 6.044-13.5 13.5-13.5s13.5 6.044 13.5 13.5-6.044 13.5-13.5 13.5-13.5-6.044-13.5-13.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeadsetMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M148 234c0-20.587-10.914-38.624-27.271-48.643C131.147 126.72 181.026 83 240 83s108.853 43.72 119.271 102.357C342.914 195.376 332 213.413 332 234v55c0 13.395 4.62 25.71 12.354 35.44-10.315 14.704-25.141 26.751-42.602 35.983C292.363 339.541 271.38 325 247 325c-33.137 0-60 26.863-60 60s26.863 60 60 60c22.64 0 42.352-12.54 52.568-31.053 33.725-12.813 67.242-34.637 88.085-67.963q.672.016 1.347.016c31.48 0 57-25.52 57-57v-55c0-25.181-16.329-46.548-38.975-54.091C393.887 98.135 324.562 35 240 35S86.113 98.135 72.975 179.909C50.33 187.452 34 208.819 34 234v55c0 31.48 25.52 57 57 57s57-25.52 57-57zm-57-9a9 9 0 0 0-9 9v55a9 9 0 0 0 9 9 9 9 0 0 0 9-9v-55a9 9 0 0 0-9-9m298 0a9 9 0 0 0-9 9v55a9 9 0 0 0 9 9 9 9 0 0 0 9-9v-55a9 9 0 0 0-9-9M235 385c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconHeadset/IconHeadset.tsx
var IconHeadset = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHeadsetMonochromeExtralight,
          "monochrome|light": IconHeadsetMonochromeLight,
          "monochrome|regular": IconHeadsetMonochromeRegular,
          "monochrome|medium": IconHeadsetMonochromeMedium,
          "monochrome|semibold": IconHeadsetMonochromeSemibold,
          "monochrome|bold": IconHeadsetMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHeartMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.28 12.307c-1.24 1.427-2.08 3.477-2.08 6.228 0 2.688 1.063 5.337 2.763 7.848 1.698 2.51 3.985 4.81 6.311 6.774 2.322 1.96 4.65 3.557 6.4 4.665A56 56 0 0 0 24 39.22l.22-.125c.506-.29 1.233-.72 2.107-1.273 1.75-1.108 4.077-2.705 6.399-4.665 2.326-1.964 4.613-4.265 6.312-6.774 1.7-2.51 2.762-5.16 2.762-7.848 0-2.751-.84-4.801-2.08-6.228-1.248-1.435-2.962-2.31-4.822-2.6-3.738-.583-7.933 1.206-9.803 5.374a1.2 1.2 0 0 1-2.19 0c-1.87-4.168-6.065-5.957-9.803-5.374-1.86.29-3.574 1.165-4.821 2.6M24 40.59l-.56 1.061-.006-.003-.012-.006-.045-.024-.168-.091q-.22-.12-.622-.35a59 59 0 0 1-2.198-1.328c-1.812-1.147-4.235-2.808-6.663-4.858-2.424-2.047-4.887-4.508-6.751-7.262C5.112 24.977 3.8 21.862 3.8 18.535c0-3.264 1.008-5.892 2.67-7.803 1.654-1.903 3.9-3.027 6.262-3.396 4.076-.636 8.601.969 11.268 4.818 2.667-3.85 7.192-5.454 11.268-4.818 2.363.369 4.608 1.493 6.263 3.396 1.661 1.911 2.67 4.539 2.67 7.803 0 3.327-1.313 6.442-3.176 9.194-1.864 2.754-4.327 5.215-6.75 7.262-2.43 2.05-4.852 3.711-6.664 4.858a59 59 0 0 1-2.198 1.328 39 39 0 0 1-.79.44l-.045.025-.012.006-.005.003zm0 0 .56 1.061c-.35.185-.77.185-1.12 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeartMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.942 7.873C4.086 8.857 3.5 10.278 3.5 12.2c0 1.87.74 3.725 1.938 5.494 1.196 1.768 2.81 3.392 4.457 4.783a42 42 0 0 0 4.53 3.302A40 40 0 0 0 16 26.73l.083-.047c.358-.206.873-.51 1.491-.901a42 42 0 0 0 4.53-3.303c1.648-1.39 3.262-3.015 4.459-4.783 1.197-1.77 1.937-3.623 1.937-5.494 0-1.923-.586-3.344-1.442-4.328-.862-.991-2.047-1.597-3.337-1.799-2.597-.405-5.51.838-6.809 3.734a1 1 0 0 1-1.824 0c-1.3-2.896-4.212-4.139-6.809-3.734-1.29.202-2.475.808-3.337 1.799M16 27.872l-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z" })
        }
      );
    }
  )
);
var IconHeartMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.367 6.35c-.568.653-.967 1.606-.967 2.917 0 1.265.5 2.531 1.33 3.757.828 1.223 1.95 2.353 3.1 3.325A29 29 0 0 0 12 19.265c.248-.143.592-.348 1.003-.608.867-.549 2.02-1.34 3.166-2.308 1.151-.972 2.273-2.102 3.101-3.325.83-1.226 1.33-2.492 1.33-3.757 0-1.311-.399-2.264-.966-2.917-.573-.659-1.364-1.065-2.231-1.2a4.28 4.28 0 0 0-4.582 2.513.9.9 0 0 1-1.642 0A4.28 4.28 0 0 0 6.597 5.15c-.867.135-1.657.541-2.23 1.2M12 20.295l-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z" })
        }
      );
    }
  )
);
var IconHeartMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.37 4.845c-.404.464-.695 1.149-.695 2.106 0 .914.362 1.84.976 2.747.613.905 1.445 1.744 2.303 2.468A22 22 0 0 0 9 14.304a21.774 21.774 0 0 0 3.046-2.138c.859-.724 1.69-1.563 2.303-2.468.614-.907.976-1.833.976-2.747 0-.957-.29-1.642-.694-2.106a2.63 2.63 0 0 0-1.598-.859A3.09 3.09 0 0 0 9.73 5.8a.8.8 0 0 1-1.46 0 3.09 3.09 0 0 0-3.303-1.813 2.63 2.63 0 0 0-1.597.859M9 15.22l-.374.708-.002-.002-.005-.002-.018-.01a11 11 0 0 1-.305-.17 23.368 23.368 0 0 1-3.375-2.356c-.922-.78-1.872-1.726-2.595-2.795-.722-1.067-1.25-2.303-1.25-3.643 0-1.3.402-2.369 1.086-3.156a4.23 4.23 0 0 1 2.559-1.39A4.7 4.7 0 0 1 9 3.985a4.7 4.7 0 0 1 4.279-1.58 4.23 4.23 0 0 1 2.558 1.39c.685.787 1.087 1.857 1.087 3.156 0 1.34-.528 2.576-1.25 3.644-.724 1.068-1.673 2.015-2.596 2.794a23.4 23.4 0 0 1-3.68 2.526l-.018.01-.005.002-.001.001zm0 0 .374.708a.8.8 0 0 1-.748 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeartMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.024 4.332c-.352.405-.607 1.004-.607 1.846 0 .803.317 1.618.86 2.42.542.8 1.279 1.544 2.04 2.187A19.3 19.3 0 0 0 8 12.67a19.32 19.32 0 0 0 2.683-1.885c.76-.643 1.498-1.386 2.04-2.187.542-.802.86-1.617.86-2.42 0-.842-.255-1.44-.607-1.846a2.3 2.3 0 0 0-1.397-.75A2.705 2.705 0 0 0 8.684 5.17a.75.75 0 0 1-1.368 0A2.705 2.705 0 0 0 4.42 3.582a2.3 2.3 0 0 0-1.397.75M8 13.53l-.35.663h-.003l-.004-.003-.017-.01a11 11 0 0 1-.271-.15 20.809 20.809 0 0 1-3.006-2.098c-.822-.695-1.668-1.539-2.314-2.493C1.39 8.487.917 7.38.917 6.18c0-1.164.36-2.124.975-2.831A3.8 3.8 0 0 1 4.19 2.1 4.22 4.22 0 0 1 8 3.481a4.22 4.22 0 0 1 3.81-1.383 3.8 3.8 0 0 1 2.297 1.249c.616.707.976 1.667.976 2.83 0 1.202-.474 2.309-1.118 3.261-.646.954-1.493 1.798-2.315 2.492a21 21 0 0 1-3.277 2.25l-.016.009-.005.002h-.001s-.001.001-.351-.662m0 0 .35.663a.75.75 0 0 1-.7 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeartMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.296 3.274c-.257.296-.446.736-.446 1.36 0 .592.234 1.196.639 1.794.404.596.954 1.151 1.523 1.632A14.5 14.5 0 0 0 6 9.459q.172-.1.421-.257c.43-.272 1-.663 1.567-1.142.57-.48 1.12-1.036 1.523-1.632.404-.598.639-1.202.639-1.794 0-.624-.189-1.064-.447-1.36a1.7 1.7 0 0 0-1.025-.55 1.99 1.99 0 0 0-2.13 1.17.6.6 0 0 1-1.096 0 1.99 1.99 0 0 0-2.13-1.17c-.402.062-.765.25-1.026.55M6 10.148l-.28.53h-.002l-.004-.003-.012-.006-.044-.024-.16-.09a15.656 15.656 0 0 1-2.26-1.578C2.62 8.455 1.982 7.82 1.495 7.1 1.01 6.382.65 5.545.65 4.634c0-.88.273-1.61.74-2.148a2.9 2.9 0 0 1 1.747-.948A3.2 3.2 0 0 1 6 2.555a3.2 3.2 0 0 1 2.863-1.017 2.9 2.9 0 0 1 1.746.948c.468.538.74 1.268.74 2.148 0 .911-.358 1.748-.844 2.466-.487.72-1.125 1.355-1.743 1.877a15.7 15.7 0 0 1-2.42 1.668l-.044.024-.013.006-.003.002H6.28s-.001.001-.281-.53m0 0 .28.53a.6.6 0 0 1-.56 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconHeart/IconHeart.tsx
var IconHeart = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHeartMonochromeExtralight,
          "monochrome|light": IconHeartMonochromeLight,
          "monochrome|regular": IconHeartMonochromeRegular,
          "monochrome|medium": IconHeartMonochromeMedium,
          "monochrome|semibold": IconHeartMonochromeSemibold,
          "monochrome|bold": IconHeartMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHeartFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m24 41.808-.7 1.326-.006-.003-.014-.007-.049-.026-.18-.098a41 41 0 0 1-.667-.375 63 63 0 0 1-2.35-1.42c-1.938-1.226-4.528-3.003-7.127-5.196-2.592-2.188-5.233-4.826-7.235-7.785-2-2.955-3.422-6.318-3.422-9.922 0-3.526 1.09-6.38 2.9-8.461 1.8-2.072 4.242-3.293 6.806-3.693 4.331-.676 9.13.98 12.044 4.971 2.914-3.99 7.713-5.647 12.044-4.971 2.564.4 5.005 1.621 6.807 3.693 1.81 2.081 2.899 4.935 2.899 8.46 0 3.605-1.422 6.968-3.422 9.923-2.002 2.959-4.643 5.597-7.235 7.785-2.599 2.193-5.19 3.97-7.127 5.196a63 63 0 0 1-2.35 1.42 41 41 0 0 1-.847.473l-.05.026-.013.007-.005.003zm0 0 .7 1.326a1.5 1.5 0 0 1-1.4 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeartFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m16 27.872-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHeartFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m12 20.295-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z" })
        }
      );
    }
  )
);
var IconHeartFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m9 15.221-.315.597-.002-.001-.005-.003-.018-.01-.065-.034-.236-.133a23.266 23.266 0 0 1-3.356-2.343c-.919-.776-1.859-1.714-2.574-2.77C1.716 9.47 1.2 8.258 1.2 6.95c0-1.272.394-2.311 1.056-3.073A4.1 4.1 0 0 1 4.74 2.529 4.57 4.57 0 0 1 9 4.18a4.57 4.57 0 0 1 4.26-1.652c.934.145 1.825.59 2.484 1.348.663.762 1.056 1.801 1.056 3.073 0 1.308-.515 2.52-1.23 3.574-.714 1.056-1.654 1.994-2.572 2.77a23.3 23.3 0 0 1-3.658 2.51l-.017.01-.005.003h-.002zm0 0 .315.597a.68.68 0 0 1-.63 0z" })
        }
      );
    }
  )
);
var IconHeartFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m8 13.53-.28.53h-.002l-.005-.003-.015-.008-.058-.031-.21-.119a20.661 20.661 0 0 1-2.983-2.083c-.817-.689-1.652-1.522-2.288-2.461-.634-.937-1.092-2.015-1.092-3.177 0-1.13.35-2.055.939-2.732a3.65 3.65 0 0 1 2.207-1.198A4.06 4.06 0 0 1 8 3.716a4.06 4.06 0 0 1 3.787-1.468c.83.13 1.622.525 2.207 1.198.59.677.94 1.602.94 2.732 0 1.162-.459 2.24-1.093 3.177-.636.939-1.471 1.772-2.287 2.461a20.7 20.7 0 0 1-3.252 2.233l-.015.008-.005.002-.001.001zm0 0 .28.53a.6.6 0 0 1-.56 0z" })
        }
      );
    }
  )
);
var IconHeartFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m6 10.148-.21.397h-.002l-.003-.002-.012-.006a5 5 0 0 1-.2-.113 15.503 15.503 0 0 1-2.237-1.562c-.613-.516-1.24-1.142-1.716-1.846C1.144 6.313.8 5.506.8 4.634c0-.848.262-1.541.704-2.05a2.74 2.74 0 0 1 1.656-.898A3.05 3.05 0 0 1 6 2.787a3.05 3.05 0 0 1 2.84-1.101 2.74 2.74 0 0 1 1.656.899c.442.508.704 1.2.704 2.049 0 .871-.344 1.68-.82 2.382-.476.704-1.103 1.33-1.715 1.846a15.5 15.5 0 0 1-2.438 1.675l-.012.006-.003.002H6.21zm0 0 .21.398a.45.45 0 0 1-.42 0z" })
        }
      );
    }
  )
);

// src/IconHeartFilled/IconHeartFilled.tsx
var IconHeartFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHeartFilledMonochromeExtralight,
          "monochrome|light": IconHeartFilledMonochromeLight,
          "monochrome|regular": IconHeartFilledMonochromeRegular,
          "monochrome|medium": IconHeartFilledMonochromeMedium,
          "monochrome|semibold": IconHeartFilledMonochromeSemibold,
          "monochrome|bold": IconHeartFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHouseMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 1 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 1 0 1.5-1.874zM38 17.737l-14-11.2-14 11.2V35.4a4.5 4.5 0 0 0 4.5 4.5H19V29.7a5 5 0 1 1 10 0v10.2h4.5a4.5 4.5 0 0 0 4.5-4.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.249 1.562l.909-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 0 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.909.728a1 1 0 1 0 1.25-1.562zm8.508 9.368L16 4.614l-9.133 7.307V23.6a2.8 2.8 0 0 0 2.8 2.8h2.8v-6.6a3.533 3.533 0 1 1 7.066 0v6.6h2.8a2.8 2.8 0 0 0 2.8-2.8z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.562 1.797a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 1 0 1.125 1.406l.438-.35V17.7a3.75 3.75 0 0 0 3.75 3.75h2.85a.9.9 0 0 0 .9-.9v-5.7a1 1 0 1 1 2 0v5.7a.9.9 0 0 0 .9.9h2.85a3.75 3.75 0 0 0 3.75-3.75v-7.248l.437.35a.9.9 0 0 0 1.125-1.405zM18.7 9.012 12 3.652l-6.7 5.36V17.7a1.95 1.95 0 0 0 1.95 1.95H9.2v-4.8a2.8 2.8 0 1 1 5.6 0v4.8h1.95a1.95 1.95 0 0 0 1.95-1.95z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 0 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.937 2.937h2.138a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.137a2.937 2.937 0 0 0 2.938-2.937V8.099l.125.1a.8.8 0 0 0 1-1.249zm4.4 5.57L9 2.9 4.1 6.82v6.455c0 .739.599 1.337 1.337 1.337h1.338v-3.475a2.225 2.225 0 0 1 4.45 0v3.475h1.338c.738 0 1.337-.598 1.337-1.337z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171zm3.848 5L8 2.626 3.683 6.08v5.72c0 .635.515 1.15 1.15 1.15h1.15V9.9a2.017 2.017 0 0 1 4.034 0v3.05h1.15a1.15 1.15 0 0 0 1.15-1.15z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955zM9.2 4.578 6 2.018l-3.2 2.56V8.85c0 .456.37.825.825.825h.825v-2.25a1.55 1.55 0 0 1 3.1 0v2.25h.825c.456 0 .825-.37.825-.825z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconHouse/IconHouse.tsx
var IconHouse = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHouseMonochromeExtralight,
          "monochrome|light": IconHouseMonochromeLight,
          "monochrome|regular": IconHouseMonochromeRegular,
          "monochrome|medium": IconHouseMonochromeMedium,
          "monochrome|semibold": IconHouseMonochromeSemibold,
          "monochrome|bold": IconHouseMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconHouseFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 0 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 0 0 1.5-1.874z" })
        }
      );
    }
  )
);
var IconHouseFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.25 1.562l.908-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 1 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.91.728a1 1 0 1 0 1.249-1.562z" })
        }
      );
    }
  )
);
var IconHouseFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M12.562 1.798a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 0 0 1.125 1.405l.438-.35v7.098a3.9 3.9 0 0 0 3.9 3.9H10a.9.9 0 0 0 .9-.9V15a1.1 1.1 0 0 1 2.2 0v5.55a.9.9 0 0 0 .9.9h2.6a3.9 3.9 0 0 0 3.9-3.9v-7.098l.437.35a.9.9 0 0 0 1.125-1.405z" })
        }
      );
    }
  )
);
var IconHouseFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 1 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.938 2.937h2.137a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.138a2.937 2.937 0 0 0 2.937-2.937V8.099l.126.1a.8.8 0 1 0 .999-1.249z" })
        }
      );
    }
  )
);
var IconHouseFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconHouseFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955z" })
        }
      );
    }
  )
);

// src/IconHouseFilled/IconHouseFilled.tsx
var IconHouseFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconHouseFilledMonochromeExtralight,
          "monochrome|light": IconHouseFilledMonochromeLight,
          "monochrome|regular": IconHouseFilledMonochromeRegular,
          "monochrome|medium": IconHouseFilledMonochromeMedium,
          "monochrome|semibold": IconHouseFilledMonochromeSemibold,
          "monochrome|bold": IconHouseFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconInfoCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M24 19a1.2 1.2 0 0 1-1.2-1.2v-.2a1.2 1.2 0 0 1 2.4 0v.2A1.2 1.2 0 0 1 24 19M22.8 30.4a1.2 1.2 0 0 0 2.4 0V22a1.2 1.2 0 0 0-2.4 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 44c11.045 0 20-8.954 20-20S35.045 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconInfoCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M16 12.733a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1M15 20.5a1 1 0 1 0 2 0v-5.6a1 1 0 1 0-2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333m0-2c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconInfoCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 9.7a.9.9 0 0 1-.9-.9v-.1a.9.9 0 1 1 1.8 0v.1a.9.9 0 0 1-.9.9M11.1 15.5a.9.9 0 1 0 1.8 0v-4.2a.9.9 0 1 0-1.8 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1.8a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconInfoCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9 7.2a.8.8 0 0 1-.8-.8v-.075a.8.8 0 0 1 1.6 0V6.4a.8.8 0 0 1-.8.8M8.2 11.7a.8.8 0 0 0 1.6 0V8.55a.8.8 0 1 0-1.6 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconInfoCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M8 6.45a.75.75 0 0 1-.75-.75v-.067a.75.75 0 0 1 1.5 0V5.7a.75.75 0 0 1-.75.75M7.25 10.5a.75.75 0 0 0 1.5 0V7.7a.75.75 0 0 0-1.5 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconInfoCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5.4 7.9a.6.6 0 0 0 1.2 0v-2a.6.6 0 1 0-1.2 0zM5.4 4.3a.6.6 0 0 0 1.2 0v-.05a.6.6 0 1 0-1.2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconInfoCircle/IconInfoCircle.tsx
var IconInfoCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconInfoCircleMonochromeExtralight,
          "monochrome|light": IconInfoCircleMonochromeLight,
          "monochrome|regular": IconInfoCircleMonochromeRegular,
          "monochrome|medium": IconInfoCircleMonochromeMedium,
          "monochrome|semibold": IconInfoCircleMonochromeSemibold,
          "monochrome|bold": IconInfoCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-12.35c-.69 0-1.25-.56-1.25-1.25V22a1.25 1.25 0 1 1 2.5 0v8.4c0 .69-.56 1.25-1.25 1.25m0-12.8c-.69 0-1.25-.56-1.25-1.25v-.2a1.25 1.25 0 0 1 2.5 0v.2c0 .69-.56 1.25-1.25 1.25",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 29.333c7.363 0 13.333-5.97 13.333-13.333S23.363 2.667 15.999 2.667 2.666 8.636 2.666 16s5.97 13.333 13.333 13.333m0-7.666a1 1 0 0 1-1-1v-5.6a1 1 0 1 1 2 0v5.6a1 1 0 0 1-1 1m0-8.934a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-.9-6.5a.9.9 0 0 0 1.8 0v-4.2a.9.9 0 0 0-1.8 0zm0-6.7a.9.9 0 0 0 1.8 0v-.1a.9.9 0 1 0-1.8 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m-.8-4.7a.8.8 0 0 0 1.6 0V8.65a.8.8 0 1 0-1.6 0zm0-5.4a.8.8 0 1 0 1.6 0v-.075a.8.8 0 1 0-1.6 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333M7.25 10.4a.75.75 0 0 0 1.5 0V7.6a.75.75 0 1 0-1.5 0zm0-4.8a.75.75 0 0 0 1.5 0v-.067a.75.75 0 1 0-1.5 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconInfoCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m0-2.3a.6.6 0 0 1-.6-.6v-2a.6.6 0 0 1 1.2 0v2a.6.6 0 0 1-.6.6m0-3.8a.6.6 0 0 1-.6-.6v-.05a.6.6 0 0 1 1.2 0v.05a.6.6 0 0 1-.6.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconInfoCircleFilled/IconInfoCircleFilled.tsx
var IconInfoCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconInfoCircleFilledMonochromeExtralight,
          "monochrome|light": IconInfoCircleFilledMonochromeLight,
          "monochrome|regular": IconInfoCircleFilledMonochromeRegular,
          "monochrome|medium": IconInfoCircleFilledMonochromeMedium,
          "monochrome|semibold": IconInfoCircleFilledMonochromeSemibold,
          "monochrome|bold": IconInfoCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconItalicMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M27.97 8.8H18a1.2 1.2 0 0 0 0 2.4h8.41l-7.315 25.6H10a1.2 1.2 0 0 0 0 2.4h20a1.2 1.2 0 1 0 0-2.4h-8.41l7.315-25.6H38a1.2 1.2 0 1 0 0-2.4H27.97",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconItalicMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M18.642 5.667H12a1 1 0 1 0 0 2h5.341l-4.762 16.666H6.667a1 1 0 1 0 0 2H20a1 1 0 1 0 0-2h-5.34L19.42 7.667h5.912a1 1 0 1 0 0-2h-6.691",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconItalicMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.978 4.1H9a.9.9 0 1 0 0 1.8h3.807L9.32 18.1h-4.32a.9.9 0 0 0 0 1.8H15a.9.9 0 1 0 0-1.8h-3.807L14.68 5.9H19a.9.9 0 1 0 0-1.8h-5.022",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconItalicMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.48 2.95H6.75a.8.8 0 1 0 0 1.6h2.69l-2.543 8.9H3.75a.8.8 0 0 0 0 1.6h7.5a.8.8 0 1 0 0-1.6H8.56l2.543-8.9h3.147a.8.8 0 1 0 0-1.6H10.48",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconItalicMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.315 2.583H6a.75.75 0 1 0 0 1.5h2.339l-2.238 7.834H3.333a.75.75 0 1 0 0 1.5H10a.75.75 0 0 0 0-1.5H7.66L9.9 4.083h2.768a.75.75 0 0 0 0-1.5H9.315",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconItalicMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.986 1.9H4.5a.6.6 0 0 0 0 1.2h1.704L4.547 8.9H2.5a.6.6 0 0 0 0 1.2h5a.6.6 0 0 0 0-1.2H5.795l1.657-5.8H9.5a.6.6 0 0 0 0-1.2H6.986",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconItalic/IconItalic.tsx
var IconItalic = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconItalicMonochromeExtralight,
          "monochrome|light": IconItalicMonochromeLight,
          "monochrome|regular": IconItalicMonochromeRegular,
          "monochrome|medium": IconItalicMonochromeMedium,
          "monochrome|semibold": IconItalicMonochromeSemibold,
          "monochrome|bold": IconItalicMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M68 285.973V278c0-6.627 5.373-12 12-12s12 5.373 12 12v7.973c0 46.458 5.752 70.098 18.841 83.186C123.929 382.248 147.569 388 194.027 388H202c6.627 0 12 5.373 12 12s-5.373 12-12 12h-7.973c-45.964 0-79.337-5.051-100.157-25.87S68 331.937 68 285.973M412 285.973V278c0-6.627-5.373-12-12-12s-12 5.373-12 12v7.973c0 46.458-5.752 70.098-18.841 83.186C356.071 382.248 332.431 388 285.973 388H278c-6.627 0-12 5.373-12 12s5.373 12 12 12h7.973c45.964 0 79.337-5.051 100.157-25.87S412 331.937 412 285.973M68 194.027V202c0 6.627 5.373 12 12 12s12-5.373 12-12v-7.973c0-46.458 5.752-70.098 18.841-83.186C123.929 97.752 147.569 92 194.027 92H202c6.627 0 12-5.373 12-12s-5.373-12-12-12h-7.973c-45.964 0-79.337 5.05-100.157 25.87S68 148.063 68 194.027M412 194.027V202c0 6.627-5.373 12-12 12s-12-5.373-12-12v-7.973c0-46.458-5.752-70.098-18.841-83.186C356.071 97.752 332.431 92 285.973 92H278c-6.627 0-12-5.373-12-12s5.373-12 12-12h7.973c45.964 0 79.337 5.05 100.157 25.87S412 148.063 412 194.027M288 240c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48m24 0c0 39.765-32.235 72-72 72s-72-32.235-72-72 32.235-72 72-72 72 32.235 72 72"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M344 152c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M65 285.973V279c0-8.284 6.716-15 15-15s15 6.716 15 15v6.973c0 46.519 5.84 68.943 17.962 81.065S147.508 385 194.027 385H201c8.284 0 15 6.716 15 15s-6.716 15-15 15h-6.973c-45.902 0-80.492-4.963-102.278-26.749S65 331.875 65 285.973M415 285.973V281c0-8.284-6.716-15-15-15s-15 6.716-15 15v4.973c0 46.519-5.84 68.943-17.962 81.065S332.492 385 285.973 385H281c-8.284 0-15 6.716-15 15s6.716 15 15 15h4.973c45.902 0 80.492-4.963 102.278-26.749S415 331.875 415 285.973M65 194.027V201c0 8.284 6.716 15 15 15s15-6.716 15-15v-6.973c0-46.519 5.84-68.943 17.962-81.065S147.508 95 194.027 95H201c8.284 0 15-6.716 15-15s-6.716-15-15-15h-6.973c-45.902 0-80.492 4.963-102.278 26.749S65 148.125 65 194.027M415 194.027V199c0 8.284-6.716 15-15 15s-15-6.716-15-15v-4.973c0-46.519-5.84-68.943-17.962-81.065S332.492 95 285.973 95H281c-8.284 0-15-6.716-15-15s6.716-15 15-15h4.973c45.902 0 80.492 4.963 102.278 26.749S415 148.125 415 194.027M285 240c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45m30 0c0 41.421-33.579 75-75 75s-75-33.579-75-75 33.579-75 75-75 75 33.579 75 75"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M345 152c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17 17 7.611 17 17"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M62 285.973V280c0-9.941 8.059-18 18-18s18 8.059 18 18v5.973c0 46.581 5.927 67.788 17.083 78.944S147.446 382 194.027 382H200c9.941 0 18 8.059 18 18s-8.059 18-18 18h-5.973c-45.84 0-81.648-4.875-104.4-27.627S62 331.813 62 285.973M418 285.973V280c0-9.941-8.059-18-18-18s-18 8.059-18 18v5.973c0 46.581-5.927 67.788-17.083 78.944S332.554 382 285.973 382H280c-9.941 0-18 8.059-18 18s8.059 18 18 18h5.973c45.84 0 81.648-4.875 104.4-27.627S418 331.813 418 285.973M62 194.027V200c0 9.941 8.059 18 18 18s18-8.059 18-18v-5.973c0-46.581 5.927-67.788 17.083-78.944S147.446 98 194.027 98H200c9.941 0 18-8.059 18-18s-8.059-18-18-18h-5.973c-45.84 0-81.648 4.875-104.4 27.627S62 148.187 62 194.027M418 194.027V200c0 9.941-8.059 18-18 18s-18-8.059-18-18v-5.973c0-46.581-5.927-67.788-17.083-78.944S332.554 98 285.973 98H280c-9.941 0-18-8.059-18-18s8.059-18 18-18h5.973c45.84 0 81.648 4.875 104.4 27.627S418 148.187 418 194.027M282 240c0-23.196-18.804-42-42-42s-42 18.804-42 42 18.804 42 42 42 42-18.804 42-42m36 0c0 43.078-34.922 78-78 78s-78-34.922-78-78 34.922-78 78-78 78 34.922 78 78"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M346 152c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M58.664 285.972v-5.973c0-11.783 9.552-21.335 21.335-21.335s21.335 9.552 21.335 21.335v5.973c0 46.65 6.025 66.504 16.106 76.586s29.936 16.106 76.586 16.106h5.973l.551.007c11.528.292 20.784 9.729 20.784 21.328 0 11.783-9.552 21.335-21.335 21.335h-5.973c-45.771 0-82.931-4.778-106.757-28.605-23.827-23.826-28.605-60.986-28.605-106.757M421.334 285.972v-5.973c0-11.783-9.552-21.335-21.335-21.335s-21.335 9.552-21.335 21.335v5.973c0 46.65-6.025 66.504-16.106 76.586s-29.936 16.106-76.586 16.106h-5.973l-.551.007c-11.528.292-20.784 9.729-20.784 21.328 0 11.783 9.552 21.335 21.335 21.335h5.973c45.771 0 82.931-4.778 106.757-28.605 23.827-23.826 28.605-60.986 28.605-106.757M58.664 194.026v5.973c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-5.973c0-46.65 6.025-66.504 16.106-76.586s29.936-16.106 76.586-16.106h5.973l.551-.007c11.528-.292 20.784-9.73 20.784-21.328 0-11.783-9.552-21.335-21.335-21.335h-5.973c-45.771 0-82.931 4.778-106.757 28.605-23.827 23.826-28.605 60.986-28.605 106.757M421.334 194.026v5.973c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335v-5.973c0-46.65-6.025-66.504-16.106-76.586s-29.936-16.106-76.586-16.106h-5.973l-.551-.007c-11.528-.292-20.784-9.73-20.784-21.328 0-11.783 9.552-21.335 21.335-21.335h5.973c45.771 0 82.931 4.778 106.757 28.605 23.827 23.826 28.605 60.986 28.605 106.757M278.664 239.999c0-21.354-17.311-38.665-38.665-38.665s-38.665 17.311-38.665 38.665 17.311 38.665 38.665 38.665 38.665-17.311 38.665-38.665m42.67 0c0 44.92-36.415 81.335-81.335 81.335s-81.335-36.415-81.335-81.335 36.415-81.335 81.335-81.335 81.335 36.415 81.335 81.335"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M345.999 151.999c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M56.5 286.973V283c0-12.426 10.074-22.5 22.5-22.5s22.5 10.074 22.5 22.5v3.973c0 46.674 6.059 66.055 15.766 75.761 9.706 9.707 29.087 15.766 75.761 15.766H197c12.426 0 22.5 10.074 22.5 22.5s-10.074 22.5-22.5 22.5h-3.973c-45.747 0-83.38-4.743-107.582-28.945S56.5 332.72 56.5 286.973M423.5 286.973V283c0-12.426-10.074-22.5-22.5-22.5s-22.5 10.074-22.5 22.5v3.973c0 46.674-6.059 66.055-15.766 75.761-9.706 9.707-29.087 15.766-75.761 15.766H283c-12.426 0-22.5 10.074-22.5 22.5s10.074 22.5 22.5 22.5h3.973c45.747 0 83.38-4.743 107.582-28.945S423.5 332.72 423.5 286.973M56.5 193.027V197c0 12.426 10.074 22.5 22.5 22.5s22.5-10.074 22.5-22.5v-3.973c0-46.674 6.059-66.055 15.766-75.761 9.706-9.707 29.087-15.766 75.761-15.766H197c12.426 0 22.5-10.074 22.5-22.5S209.426 56.5 197 56.5h-3.973c-45.747 0-83.38 4.743-107.582 28.945S56.5 147.28 56.5 193.027M423.5 193.027V197c0 12.426-10.074 22.5-22.5 22.5s-22.5-10.074-22.5-22.5v-3.973c0-46.674-6.059-66.055-15.766-75.761-9.706-9.707-29.087-15.766-75.761-15.766H283c-12.426 0-22.5-10.074-22.5-22.5s10.074-22.5 22.5-22.5h3.973c45.747 0 83.38 4.743 107.582 28.945S423.5 147.28 423.5 193.027M277.5 240c0-20.711-16.789-37.5-37.5-37.5s-37.5 16.789-37.5 37.5 16.789 37.5 37.5 37.5 37.5-16.789 37.5-37.5m45 0c0 45.563-36.937 82.5-82.5 82.5s-82.5-36.937-82.5-82.5 36.937-82.5 82.5-82.5 82.5 36.937 82.5 82.5"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M346 152c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLensViewfinderMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M55 286.973V284c0-13.255 10.745-24 24-24s24 10.745 24 24v2.973c0 46.705 6.103 65.478 15.326 74.701S146.322 377 193.027 377H196c13.255 0 24 10.745 24 24s-10.745 24-24 24h-2.973c-45.717 0-83.957-4.7-108.642-29.385S55 332.69 55 286.973M425 286.973V284c0-13.255-10.745-24-24-24s-24 10.745-24 24v2.973c0 46.705-6.103 65.478-15.326 74.701S333.678 377 286.973 377H284c-13.255 0-24 10.745-24 24s10.745 24 24 24h2.973c45.717 0 83.957-4.7 108.642-29.385S425 332.69 425 286.973M55 193.027V196c0 13.255 10.745 24 24 24s24-10.745 24-24v-2.973c0-46.705 6.103-65.478 15.326-74.701S146.322 103 193.027 103H196c13.255 0 24-10.745 24-24s-10.745-24-24-24h-2.973c-45.717 0-83.957 4.7-108.642 29.385S55 147.31 55 193.027M425 193.027V196c0 13.255-10.745 24-24 24s-24-10.745-24-24v-2.973c0-46.705-6.103-65.478-15.326-74.701S333.678 103 286.973 103H284c-13.255 0-24-10.745-24-24s10.745-24 24-24h2.973c45.717 0 83.957 4.7 108.642 29.385S425 147.31 425 193.027M276 240c0-19.882-16.118-36-36-36s-36 16.118-36 36 16.118 36 36 36 36-16.118 36-36m48 0c0 46.392-37.608 84-84 84s-84-37.608-84-84 37.608-84 84-84 84 37.608 84 84"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                d: "M348.5 151.5c0 10.493-8.507 19-19 19s-19-8.507-19-19 8.507-19 19-19 19 8.507 19 19"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconLensViewfinder/IconLensViewfinder.tsx
var IconLensViewfinder = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLensViewfinderMonochromeExtralight,
          "monochrome|light": IconLensViewfinderMonochromeLight,
          "monochrome|regular": IconLensViewfinderMonochromeRegular,
          "monochrome|medium": IconLensViewfinderMonochromeMedium,
          "monochrome|semibold": IconLensViewfinderMonochromeSemibold,
          "monochrome|bold": IconLensViewfinderMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? "regular"}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.8 11A1.2 1.2 0 0 1 5 9.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 11m0 13A1.2 1.2 0 0 1 5 22.8h38a1.2 1.2 0 1 1 0 2.4H5A1.2 1.2 0 0 1 3.8 24m0 13A1.2 1.2 0 0 1 5 35.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 37",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.333 7.333a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 0 1 0 2H3.333a1 1 0 0 1-1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 12a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 18.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.075 4.125a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 9a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 13.875a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M.917 3.667a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667a.75.75 0 0 1-.75-.75M.917 8a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667A.75.75 0 0 1 .917 8M.917 12.333a.75.75 0 0 1 .75-.75h12.666a.75.75 0 1 1 0 1.5H1.667a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3HorizontalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "g",
            {
              stroke: "#2F3438",
              strokeLinecap: "round",
              strokeWidth: 1.2,
              clipPath: "url(#line-3-horizontal_bold_monochrome_svg__clip0_5127_79144)",
              children: /* @__PURE__ */ jsx("path", { d: "M1.25 2.75h9.5M1.25 6h9.5M1.25 9.25h9.5" })
            }
          )
        }
      );
    }
  )
);

// src/IconLine3Horizontal/IconLine3Horizontal.tsx
var IconLine3Horizontal = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLine3HorizontalMonochromeExtralight,
          "monochrome|light": IconLine3HorizontalMonochromeLight,
          "monochrome|regular": IconLine3HorizontalMonochromeRegular,
          "monochrome|medium": IconLine3HorizontalMonochromeMedium,
          "monochrome|semibold": IconLine3HorizontalMonochromeSemibold,
          "monochrome|bold": IconLine3HorizontalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 24.797a1.2 1.2 0 0 1 1.2 1.2v12a1.2 1.2 0 0 1-2.4 0v-12a1.2 1.2 0 0 1 1.2-1.2M24 16.799a1.2 1.2 0 0 1 1.2 1.2v20a1.2 1.2 0 1 1-2.4 0v-20a1.2 1.2 0 0 1 1.2-1.2M36 8.8a1.2 1.2 0 0 1 1.2 1.2v28a1.2 1.2 0 0 1-2.4 0V10A1.2 1.2 0 0 1 36 8.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 16.333a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M16 11a1 1 0 0 1 1 1v13.333a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1M24 5.667a1 1 0 0 1 1 1v18.666a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 12.1a.9.9 0 0 1 .9.9v6a.9.9 0 1 1-1.8 0v-6a.9.9 0 0 1 .9-.9M12 8.1a.9.9 0 0 1 .9.9v10a.9.9 0 1 1-1.8 0V9a.9.9 0 0 1 .9-.9M18 4.1a.9.9 0 0 1 .9.9v14a.9.9 0 1 1-1.8 0V5a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.5 8.95a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0v-4.5a.8.8 0 0 1 .8-.8M9 5.95a.8.8 0 0 1 .8.8v7.5a.8.8 0 0 1-1.6 0v-7.5a.8.8 0 0 1 .8-.8M13.5 2.95a.8.8 0 0 1 .8.8v10.5a.8.8 0 0 1-1.6 0V3.75a.8.8 0 0 1 .8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 7.917a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M8 5.25a.75.75 0 0 1 .75.75v6.667a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25M12 2.584a.75.75 0 0 1 .75.75v9.333a.75.75 0 0 1-1.5 0V3.334a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLine3VerticalIncreaseMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3 5.9a.6.6 0 0 1 .6.6v3a.6.6 0 0 1-1.2 0v-3a.6.6 0 0 1 .6-.6M6 3.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6M9 1.9a.6.6 0 0 1 .6.6v7a.6.6 0 0 1-1.2 0v-7a.6.6 0 0 1 .6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconLine3VerticalIncrease/IconLine3VerticalIncrease.tsx
var IconLine3VerticalIncrease = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLine3VerticalIncreaseMonochromeExtralight,
          "monochrome|light": IconLine3VerticalIncreaseMonochromeLight,
          "monochrome|regular": IconLine3VerticalIncreaseMonochromeRegular,
          "monochrome|medium": IconLine3VerticalIncreaseMonochromeMedium,
          "monochrome|semibold": IconLine3VerticalIncreaseMonochromeSemibold,
          "monochrome|bold": IconLine3VerticalIncreaseMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLinkMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M234.223 99.514C274.105 59.633 339.06 60.46 379.3 100.7s41.066 105.195 1.184 145.077l-37.655 37.655-.222.216c-4.701 4.469-12.136 4.397-16.749-.216s-4.685-12.047-.216-16.749l.216-.221 37.656-37.656c30.214-30.214 29.98-79.97-1.185-111.135s-80.921-31.4-111.135-1.185l-37.656 37.656-.222.216c-4.701 4.468-12.136 4.396-16.749-.216-4.612-4.613-4.684-12.048-.216-16.749l.216-.222zM137.39 196.35c4.701-4.469 12.136-4.397 16.749.216s4.685 12.048.216 16.749l-.216.222-37.656 37.655c-30.214 30.215-29.98 79.97 1.185 111.135s80.921 31.4 111.136 1.185l37.655-37.655.222-.216c4.701-4.469 12.136-4.397 16.749.216s4.684 12.048.216 16.749l-.216.221-37.656 37.656c-39.882 39.882-104.837 39.055-145.077-1.185s-41.066-105.195-1.184-145.076l37.655-37.656z" }),
            /* @__PURE__ */ jsx("path", { d: "M290.908 172.116c4.686-4.686 12.284-4.686 16.971 0 4.686 4.687 4.686 12.285 0 16.971L189.085 307.881c-4.686 4.686-12.285 4.686-16.971 0s-4.686-12.284 0-16.971z" })
          ]
        }
      );
    }
  )
);
var IconLinkMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M232.102 97.395c41.09-41.09 107.945-40.19 149.319 1.184 41.374 41.375 42.274 108.229 1.185 149.319l-37.656 37.656-.277.27c-5.876 5.586-15.17 5.496-20.936-.27s-5.856-15.06-.27-20.936l.27-.277 37.655-37.656c29.006-29.006 28.846-76.862-1.184-106.892s-77.887-30.191-106.893-1.185l-37.656 37.655-.277.27c-5.876 5.586-15.169 5.496-20.936-.27s-5.856-15.06-.27-20.936l.27-.277zM135.324 194.176c5.877-5.586 15.17-5.496 20.936.27 5.767 5.767 5.856 15.06.27 20.937l-.27.276-37.655 37.656c-29.006 29.006-28.846 76.862 1.184 106.893 30.031 30.03 77.887 30.191 106.893 1.184l37.656-37.655.277-.27c5.876-5.586 15.17-5.496 20.936.27s5.856 15.06.27 20.936l-.27.277-37.655 37.656c-41.091 41.09-107.945 40.189-149.32-1.185s-42.274-108.229-1.184-149.319l37.655-37.656z" }),
            /* @__PURE__ */ jsx("path", { d: "M288.787 169.997c5.858-5.858 15.355-5.858 21.213 0s5.858 15.355 0 21.213L191.206 310.004c-5.858 5.857-15.355 5.857-21.213 0s-5.858-15.356 0-21.214z" })
          ]
        }
      );
    }
  )
);
var IconLinkMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M229.984 95.273c42.299-42.298 111.054-41.324 153.563 1.185s43.482 111.263 1.184 153.562l-37.656 37.655-.332.324c-7.051 6.704-18.204 6.596-25.123-.324-6.92-6.919-7.028-18.072-.324-25.123l.324-.333 37.655-37.655c27.798-27.798 27.711-73.754-1.184-102.65-28.896-28.896-74.853-28.983-102.651-1.185l-37.655 37.656-.332.323c-7.052 6.704-18.204 6.596-25.124-.323s-7.027-18.072-.324-25.124l.324-.332zM133.262 192.001c7.052-6.703 18.204-6.596 25.124.324s7.027 18.072.324 25.124l-.324.332-37.656 37.655c-27.798 27.798-27.711 73.754 1.184 102.65 28.897 28.896 74.853 28.983 102.651 1.185l37.656-37.655.332-.324c7.052-6.704 18.204-6.596 25.123.324 6.92 6.919 7.028 18.072.324 25.123l-.324.333-37.655 37.655c-42.299 42.299-111.053 41.324-153.562-1.185S52.976 272.279 95.274 229.98l37.656-37.655z" }),
            /* @__PURE__ */ jsx("path", { d: "M286.67 167.875c7.029-7.029 18.426-7.029 25.455 0 7.03 7.03 7.03 18.427 0 25.456L193.332 312.125c-7.03 7.029-18.427 7.029-25.456 0s-7.03-18.426 0-25.456z" })
          ]
        }
      );
    }
  )
);
var IconLinkMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M227.621 92.915C271.263 49.273 342.13 50.33 385.9 94.1s44.826 114.636 1.184 158.278l-37.655 37.655-.394.384c-8.358 7.946-21.577 7.818-29.778-.384-8.202-8.201-8.33-21.42-.384-29.778l.384-.394 37.655-37.655c26.454-26.455 26.45-70.299-1.184-97.934-27.635-27.635-71.48-27.64-97.934-1.185l-37.656 37.656-.393.384c-8.359 7.945-21.577 7.817-29.779-.384s-8.33-21.421-.384-29.779l.384-.394zM130.96 189.583c8.359-7.946 21.577-7.818 29.779.384s8.33 21.42.384 29.778l-.384.394-37.655 37.655c-26.455 26.455-26.451 70.299 1.184 97.934s71.48 27.639 97.934 1.185l37.656-37.656.393-.383c8.359-7.946 21.577-7.818 29.779.383s8.329 21.421.384 29.779l-.384.394-37.656 37.655c-43.642 43.642-114.508 42.585-158.278-1.185S49.27 271.264 92.91 227.622l37.656-37.655z" }),
            /* @__PURE__ */ jsx("path", { d: "M284.307 165.517c8.331-8.332 21.84-8.332 30.172 0s8.332 21.84 0 30.172L195.685 314.483c-8.332 8.332-21.84 8.332-30.172 0s-8.332-21.84 0-30.172z" })
          ]
        }
      );
    }
  )
);
var IconLinkMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M226.799 92.09c44.111-44.111 115.715-43.026 159.926 1.185 44.21 44.21 45.295 115.814 1.184 159.925l-37.655 37.656-.416.404c-8.815 8.38-22.755 8.245-31.404-.404-8.65-8.65-8.784-22.589-.405-31.404l.405-.416 37.655-37.655c25.985-25.986 26.01-69.092-1.184-96.286s-70.301-27.17-96.287-1.185l-37.655 37.655-.415.405c-8.815 8.38-22.755 8.244-31.405-.405-8.649-8.649-8.784-22.589-.405-31.404l.405-.416zM130.16 188.737c8.815-8.379 22.754-8.245 31.404.405s8.784 22.589.405 31.404l-.405.415-37.656 37.656c-25.985 25.985-26.01 69.091 1.185 96.286 27.194 27.194 70.301 27.17 96.286 1.185l37.656-37.656.415-.405c8.815-8.379 22.755-8.244 31.405.405 8.649 8.65 8.784 22.59.404 31.404l-.404.416-37.656 37.656c-44.111 44.111-115.715 43.025-159.926-1.185s-45.295-115.815-1.184-159.926l37.655-37.655z" }),
            /* @__PURE__ */ jsx("path", { d: "M283.484 164.692c8.787-8.787 23.033-8.787 31.82 0s8.786 23.033 0 31.82L196.51 315.306c-8.787 8.786-23.033 8.786-31.82 0-8.787-8.787-8.787-23.033 0-31.82z" })
          ]
        }
      );
    }
  )
);
var IconLinkMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M225.738 91.03c44.715-44.715 117.27-43.592 162.048 1.186 44.777 44.777 45.899 117.331 1.184 162.046l-37.656 37.656-.443.432c-9.402 8.938-24.272 8.794-33.498-.432s-9.37-24.095-.432-33.498l.432-.443 37.656-37.656c25.38-25.381 25.442-67.537-1.185-94.164-26.627-26.628-68.784-26.566-94.165-1.185l-37.655 37.655-.444.432c-9.402 8.938-24.271 8.794-33.498-.432s-9.369-24.095-.432-33.498l.432-.443zM129.127 187.65c9.402-8.938 24.271-8.794 33.498.432s9.37 24.096.432 33.498l-.432.443-37.656 37.656c-25.38 25.381-25.443 67.537 1.184 94.165 26.628 26.627 68.785 26.566 94.166 1.185l37.655-37.656.444-.432c9.402-8.938 24.271-8.794 33.497.432s9.37 24.095.433 33.498l-.433.443-37.655 37.656c-44.716 44.715-117.27 43.593-162.048-1.185-44.777-44.778-45.9-117.332-1.184-162.047l37.655-37.656z" }),
            /* @__PURE__ */ jsx("path", { d: "M282.423 163.633c9.373-9.373 24.569-9.373 33.941 0s9.373 24.568 0 33.941L197.57 316.368c-9.372 9.372-24.568 9.372-33.941 0-9.372-9.373-9.372-24.569 0-33.941z" })
          ]
        }
      );
    }
  )
);

// src/IconLink/IconLink.tsx
var IconLink = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLinkMonochromeExtralight,
          "monochrome|light": IconLinkMonochromeLight,
          "monochrome|regular": IconLinkMonochromeRegular,
          "monochrome|medium": IconLinkMonochromeMedium,
          "monochrome|semibold": IconLinkMonochromeSemibold,
          "monochrome|bold": IconLinkMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconListBulletMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.6 12a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 12M8.6 24a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 24M8.6 36a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 36",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M6.4 12A1.2 1.2 0 1 1 4 12a1.2 1.2 0 0 1 2.4 0M6.4 24A1.2 1.2 0 1 1 4 24a1.2 1.2 0 0 1 2.4 0M6.4 36A1.2 1.2 0 1 1 4 36a1.2 1.2 0 0 1 2.4 0" })
          ]
        }
      );
    }
  )
);
var IconListBulletMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7 8a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 16a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 24a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 24a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
          ]
        }
      );
    }
  )
);
var IconListBulletMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.1 6a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 12a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 18a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M4 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
          ]
        }
      );
    }
  )
);
var IconListBulletMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.7 4.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 9a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 13.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 1 1 0 1.6H4.5a.8.8 0 0 1-.8-.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M3.1 4.55a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 8.95a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 13.45a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0" })
          ]
        }
      );
    }
  )
);
var IconListBulletMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.6 4a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 4M3.6 8a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 8M3.6 12a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 12",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M2.834 4.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 8.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 12.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" })
          ]
        }
      );
    }
  )
);
var IconListBulletMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.95 3a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 6a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 9a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M2.2 3A.6.6 0 1 1 1 3a.6.6 0 0 1 1.2 0M2.2 6.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0M2.2 9.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0" })
          ]
        }
      );
    }
  )
);

// src/IconListBullet/IconListBullet.tsx
var IconListBullet = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconListBulletMonochromeExtralight,
          "monochrome|light": IconListBulletMonochromeLight,
          "monochrome|regular": IconListBulletMonochromeRegular,
          "monochrome|medium": IconListBulletMonochromeMedium,
          "monochrome|semibold": IconListBulletMonochromeSemibold,
          "monochrome|bold": IconListBulletMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M326 298c6.627 0 12 5.373 12 12s-5.373 12-12 12H221c-6.627 0-12-5.373-12-12s5.373-12 12-12zm0-70c6.627 0 12 5.373 12 12s-5.373 12-12 12H221c-6.627 0-12-5.373-12-12s5.373-12 12-12zm0-70c6.627 0 12 5.373 12 12s-5.373 12-12 12H221c-6.627 0-12-5.373-12-12s5.373-12 12-12z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 396v24h-208v-24zm52-52V136c0-28.719-23.281-52-52-52h-208c-28.718 0-52 23.281-52 52v208c0 28.719 23.282 52 52 52v24c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-24c28.719 0 52-23.281 52-52" }),
            /* @__PURE__ */ jsx("path", { d: "m154.2 298 .31.004c6.484.164 11.69 5.472 11.69 11.996s-5.206 11.832-11.69 11.996l-.31.004h-.2c-6.627 0-12-5.373-12-12s5.373-12 12-12zm0-70 .31.004c6.484.164 11.69 5.472 11.69 11.996s-5.206 11.832-11.69 11.996l-.31.004h-.2c-6.627 0-12-5.373-12-12s5.373-12 12-12zm0-70 .31.004c6.484.164 11.69 5.472 11.69 11.996s-5.206 11.832-11.69 11.996l-.31.004h-.2c-6.627 0-12-5.373-12-12s5.373-12 12-12z" })
          ]
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m156.2 295 .387.005c8.105.205 14.613 6.84 14.613 14.995s-6.508 14.79-14.613 14.995l-.387.005h-.2c-8.284 0-15-6.716-15-15s6.716-15 15-15zm167.8 0c8.284 0 15 6.716 15 15s-6.716 15-15 15h-98c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-167.8-70 .387.005c8.105.205 14.613 6.84 14.613 14.995s-6.508 14.79-14.613 14.995l-.387.005h-.2c-8.284 0-15-6.716-15-15s6.716-15 15-15zm167.8 0c8.284 0 15 6.716 15 15s-6.716 15-15 15h-98c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-167.8-70 .387.005c8.105.205 14.613 6.84 14.613 14.995s-6.508 14.79-14.613 14.995l-.387.005h-.2c-8.284 0-15-6.716-15-15s6.716-15 15-15zm167.8 0c8.284 0 15 6.716 15 15s-6.716 15-15 15h-98c-8.284 0-15-6.716-15-15s6.716-15 15-15z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 390v30h-208v-30zm46-46V136c0-25.405-20.595-46-46-46h-208c-25.405 0-46 20.595-46 46v208c0 25.405 20.595 46 46 46v30c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-30c25.405 0 46-20.595 46-46" })
          ]
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m160.2 293 .439.006c9.186.233 16.561 7.752 16.561 16.994s-7.375 16.761-16.561 16.994l-.439.006h-.2c-9.389 0-17-7.611-17-17s7.611-17 17-17zm159.8 0c9.389 0 17 7.611 17 17s-7.611 17-17 17h-90c-9.389 0-17-7.611-17-17s7.611-17 17-17zm-159.8-70 .439.006c9.186.232 16.561 7.752 16.561 16.994s-7.375 16.762-16.561 16.994l-.439.006h-.2c-9.389 0-17-7.611-17-17s7.611-17 17-17zm159.8 0c9.389 0 17 7.611 17 17s-7.611 17-17 17h-90c-9.389 0-17-7.611-17-17s7.611-17 17-17zm-159.8-70 .439.006c9.186.232 16.561 7.752 16.561 16.994s-7.375 16.762-16.561 16.994l-.439.006h-.2c-9.389 0-17-7.611-17-17s7.611-17 17-17zm159.8 0c9.389 0 17 7.611 17 17s-7.611 17-17 17h-90c-9.389 0-17-7.611-17-17s7.611-17 17-17z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 384v36h-208v-36zm40-40V136c0-22.091-17.908-40-40-40h-208c-22.091 0-40 17.909-40 40v208c0 22.091 17.909 40 40 40v36c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-36c22.092 0 40-17.909 40-40" })
          ]
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m161.2 292 .465.006c9.726.247 17.535 8.208 17.535 17.994s-7.809 17.747-17.535 17.994l-.465.006h-.2c-9.941 0-18-8.059-18-18s8.059-18 18-18zm157.8 0c9.941 0 18 8.059 18 18s-8.059 18-18 18h-88c-9.941 0-18-8.059-18-18s8.059-18 18-18zm-157.8-70 .465.006c9.726.246 17.535 8.208 17.535 17.994s-7.809 17.748-17.535 17.994l-.465.006h-.2c-9.941 0-18-8.059-18-18s8.059-18 18-18zm157.8 0c9.941 0 18 8.059 18 18s-8.059 18-18 18h-88c-9.941 0-18-8.059-18-18s8.059-18 18-18zm-157.8-70 .465.006c9.726.246 17.535 8.208 17.535 17.994s-7.809 17.748-17.535 17.994l-.465.006h-.2c-9.941 0-18-8.059-18-18s8.059-18 18-18zm157.8 0c9.941 0 18 8.059 18 18s-8.059 18-18 18h-88c-9.941 0-18-8.059-18-18s8.059-18 18-18z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 377.33V420h-208v-42.67zm33.33-33.33V136c0-18.408-14.922-33.33-33.33-33.33h-208c-18.407 0-33.33 14.922-33.33 33.33v208c0 18.408 14.923 33.33 33.33 33.33V420c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-42.67c18.408 0 33.33-14.922 33.33-33.33" })
          ]
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m162.2 291 .49.006c10.267.26 18.51 8.665 18.51 18.994s-8.243 18.734-18.51 18.994l-.49.006h-.2c-10.493 0-19-8.507-19-19s8.507-19 19-19zm155.8 0c10.493 0 19 8.507 19 19s-8.507 19-19 19h-87c-10.493 0-19-8.507-19-19s8.507-19 19-19zm-155.8-70 .49.006c10.267.26 18.51 8.665 18.51 18.994s-8.243 18.734-18.51 18.994l-.49.006h-.2c-10.493 0-19-8.507-19-19s8.507-19 19-19zm155.8 0c10.493 0 19 8.507 19 19s-8.507 19-19 19h-87c-10.493 0-19-8.507-19-19s8.507-19 19-19zm-155.8-70 .49.006c10.267.26 18.51 8.665 18.51 18.994s-8.243 18.734-18.51 18.994l-.49.006h-.2c-10.493 0-19-8.507-19-19s8.507-19 19-19zm155.8 0c10.493 0 19 8.507 19 19s-8.507 19-19 19h-87c-10.493 0-19-8.507-19-19s8.507-19 19-19z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 375v45h-208v-45zm31-31V136c0-17.121-13.879-31-31-31h-208c-17.12 0-31 13.879-31 31v208c0 17.121 13.88 31 31 31v45c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-45c17.121 0 31-13.879 31-31" })
          ]
        }
      );
    }
  )
);
var IconListBulletSquareMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m162.2 290 .516.007c10.807.273 19.484 9.12 19.484 19.993s-8.677 19.72-19.484 19.993l-.516.007h-.2c-11.046 0-20-8.954-20-20s8.954-20 20-20zm155.8 0c11.046 0 20 8.954 20 20s-8.954 20-20 20h-84c-11.046 0-20-8.954-20-20s8.954-20 20-20zm-155.8-70 .517.007c10.807.274 19.483 9.12 19.483 19.993s-8.676 19.719-19.483 19.993l-.517.007h-.2c-11.046 0-20-8.954-20-20s8.954-20 20-20zm155.8 0c11.046 0 20 8.954 20 20s-8.954 20-20 20h-84c-11.046 0-20-8.954-20-20s8.954-20 20-20zm-155.8-70 .517.007c10.807.274 19.483 9.12 19.483 19.993s-8.676 19.719-19.483 19.993l-.517.007h-.2c-11.046 0-20-8.954-20-20s8.954-20 20-20zm155.8 0c11.046 0 20 8.954 20 20s-8.954 20-20 20h-84c-11.046 0-20-8.954-20-20s8.954-20 20-20z" }),
            /* @__PURE__ */ jsx("path", { d: "M343.755 372v48h-208v-48zm28-28V136c0-15.464-12.536-28-28-28h-208c-15.464 0-28 12.536-28 28v208c0 15.464 12.536 28 28 28v48c-41.645 0-75.468-33.497-75.994-75.018l-.006-.982V136c0-41.974 34.027-76 76-76h208l.983.006c41.521.526 75.017 34.348 75.017 75.994v208l-.005.982c-.522 41.194-33.818 74.49-75.012 75.012l-.983.006v-48c15.464 0 28-12.536 28-28" })
          ]
        }
      );
    }
  )
);

// src/IconListBulletSquare/IconListBulletSquare.tsx
var IconListBulletSquare = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconListBulletSquareMonochromeExtralight,
          "monochrome|light": IconListBulletSquareMonochromeLight,
          "monochrome|regular": IconListBulletSquareMonochromeRegular,
          "monochrome|medium": IconListBulletSquareMonochromeMedium,
          "monochrome|semibold": IconListBulletSquareMonochromeSemibold,
          "monochrome|bold": IconListBulletSquareMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM150 302c-6.627 0-12 5.373-12 12s5.373 12 12 12h.2l.31-.004c6.484-.164 11.69-5.472 11.69-11.996s-5.206-11.832-11.69-11.996l-.31-.004zm67 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h113l.31-.004c6.484-.164 11.69-5.472 11.69-11.996s-5.206-11.832-11.69-11.996L330 302zm-67-74c-6.627 0-12 5.373-12 12s5.373 12 12 12h.2l.31-.004c6.484-.164 11.69-5.472 11.69-11.996s-5.206-11.832-11.69-11.996l-.31-.004zm67 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h113c6.627 0 12-5.373 12-12s-5.373-12-12-12zm-67-74c-6.627 0-12 5.373-12 12s5.373 12 12 12h.2l.31-.004c6.484-.164 11.69-5.472 11.69-11.996s-5.206-11.832-11.69-11.996l-.31-.004zm67 0c-6.627 0-12 5.373-12 12s5.373 12 12 12h113c6.627 0 12-5.373 12-12s-5.373-12-12-12z" })
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM151 299c-8.284 0-15 6.716-15 15s6.716 15 15 15h.2l.387-.005c8.105-.205 14.613-6.84 14.613-14.995s-6.508-14.79-14.613-14.995L151.2 299zm71 0c-8.284 0-15 6.716-15 15s6.716 15 15 15h106c8.284 0 15-6.716 15-15s-6.716-15-15-15zm-71-74c-8.284 0-15 6.716-15 15s6.716 15 15 15h.2l.387-.005c8.105-.205 14.613-6.84 14.613-14.995s-6.508-14.79-14.613-14.995L151.2 225zm71 0c-8.284 0-15 6.716-15 15s6.716 15 15 15h106c8.284 0 15-6.716 15-15s-6.716-15-15-15zm-71-74c-8.284 0-15 6.716-15 15s6.716 15 15 15h.2l.387-.005c8.105-.205 14.613-6.84 14.613-14.995s-6.508-14.79-14.613-14.995L151.2 151zm71 0c-8.284 0-15 6.716-15 15s6.716 15 15 15h106c8.284 0 15-6.716 15-15s-6.716-15-15-15z" })
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM156 297c-9.389 0-17 7.611-17 17s7.611 17 17 17h.2l.439-.006c9.186-.233 16.561-7.752 16.561-16.994s-7.375-16.761-16.561-16.994L156.2 297zm74 0c-9.389 0-17 7.611-17 17s7.611 17 17 17h94c9.389 0 17-7.611 17-17s-7.611-17-17-17zm-74-74c-9.389 0-17 7.611-17 17s7.611 17 17 17h.2l.439-.006c9.186-.232 16.561-7.752 16.561-16.994s-7.375-16.762-16.561-16.994L156.2 223zm74 0c-9.389 0-17 7.611-17 17s7.611 17 17 17h94c9.389 0 17-7.611 17-17s-7.611-17-17-17zm-74-74c-9.389 0-17 7.611-17 17s7.611 17 17 17h.2l.439-.006c9.186-.232 16.561-7.752 16.561-16.994s-7.375-16.762-16.561-16.994L156.2 149zm74 0c-9.389 0-17 7.611-17 17s7.611 17 17 17h94c9.389 0 17-7.611 17-17s-7.611-17-17-17z" })
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM157 298c-9.941 0-18 8.059-18 18s8.059 18 18 18h.2l.465-.006c9.726-.247 17.535-8.208 17.535-17.994s-7.809-17.747-17.535-17.994L157.2 298zm70 0c-9.941 0-18 8.059-18 18s8.059 18 18 18h96c9.941 0 18-8.059 18-18s-8.059-18-18-18zm-70-76c-9.941 0-18 8.059-18 18s8.059 18 18 18h.2l.465-.006c9.726-.246 17.535-8.208 17.535-17.994s-7.809-17.748-17.535-17.994L157.2 222zm70 0c-9.941 0-18 8.059-18 18s8.059 18 18 18h96c9.941 0 18-8.059 18-18s-8.059-18-18-18zm-70-76c-9.941 0-18 8.059-18 18s8.059 18 18 18h.2l.465-.006c9.726-.246 17.535-8.208 17.535-17.994s-7.809-17.748-17.535-17.994L157.2 146zm70 0c-9.941 0-18 8.059-18 18s8.059 18 18 18h96c9.941 0 18-8.059 18-18s-8.059-18-18-18z" })
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM156 299c-10.493 0-19 8.507-19 19s8.507 19 19 19h.2l.49-.006c10.267-.26 18.51-8.665 18.51-18.994s-8.243-18.734-18.51-18.994l-.49-.006zm71 0c-10.493 0-19 8.507-19 19s8.507 19 19 19h97c10.493 0 19-8.507 19-19s-8.507-19-19-19zm-71-78c-10.493 0-19 8.507-19 19s8.507 19 19 19h.2l.49-.006c10.267-.26 18.51-8.665 18.51-18.994s-8.243-18.734-18.51-18.994l-.49-.006zm71 0c-10.493 0-19 8.507-19 19s8.507 19 19 19h97c10.493 0 19-8.507 19-19s-8.507-19-19-19zm-71-78c-10.493 0-19 8.507-19 19s8.507 19 19 19h.2l.49-.006c10.267-.26 18.51-8.665 18.51-18.994s-8.243-18.734-18.51-18.994l-.49-.006zm71 0c-10.493 0-19 8.507-19 19s8.507 19 19 19h97c10.493 0 19-8.507 19-19s-8.507-19-19-19z" })
        }
      );
    }
  )
);
var IconListBulletSquareFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M343.756 60c41.973 0 76 34.027 76 76v208c0 41.973-34.027 76-76 76h-208c-41.974 0-76.001-34.026-76.001-76V136c0-41.974 34.027-76 76.001-76zM152 300c-11.046 0-20 8.954-20 20s8.954 20 20 20h.2l.516-.007c10.807-.273 19.484-9.12 19.484-19.993s-8.677-19.72-19.484-19.993L152.2 300zm76 0c-11.046 0-20 8.954-20 20s8.954 20 20 20h100c11.046 0 20-8.954 20-20s-8.954-20-20-20zm-76-80c-11.046 0-20 8.954-20 20s8.954 20 20 20h.2l.517-.007c10.807-.274 19.483-9.12 19.483-19.993s-8.676-19.719-19.483-19.993L152.2 220zm76 0c-11.046 0-20 8.954-20 20s8.954 20 20 20h100c11.046 0 20-8.954 20-20s-8.954-20-20-20zm-76-80c-11.046 0-20 8.954-20 20s8.954 20 20 20h.2l.517-.007c10.807-.274 19.483-9.12 19.483-19.993s-8.676-19.719-19.483-19.993L152.2 140zm76 0c-11.046 0-20 8.954-20 20s8.954 20 20 20h100c11.046 0 20-8.954 20-20s-8.954-20-20-20z" })
        }
      );
    }
  )
);

// src/IconListBulletSquareFilled/IconListBulletSquareFilled.tsx
var IconListBulletSquareFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconListBulletSquareFilledMonochromeExtralight,
          "monochrome|light": IconListBulletSquareFilledMonochromeLight,
          "monochrome|regular": IconListBulletSquareFilledMonochromeRegular,
          "monochrome|medium": IconListBulletSquareFilledMonochromeMedium,
          "monochrome|semibold": IconListBulletSquareFilledMonochromeSemibold,
          "monochrome|bold": IconListBulletSquareFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 24.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2m0 2.4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M34.095 30.909C36.78 27.316 38.6 23.53 38.6 20c0-7.376-6.398-13.6-14.6-13.6S9.4 12.624 9.4 20c0 3.53 1.82 7.316 4.505 10.909 2.648 3.544 5.917 6.606 8.32 8.639a2.71 2.71 0 0 0 3.55 0c2.404-2.033 5.672-5.096 8.32-8.64M27.324 41.38C32.272 37.196 41 28.598 41 20c0-8.837-7.611-16-17-16S7 11.163 7 20c0 8.598 8.728 17.196 13.676 21.38a5.11 5.11 0 0 0 6.648 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22.41 20.366c1.77-2.37 2.923-4.807 2.923-7.033 0-4.674-4.062-8.666-9.333-8.666-5.27 0-9.333 3.992-9.333 8.666 0 2.226 1.152 4.664 2.923 7.033 1.74 2.329 3.894 4.348 5.485 5.694a1.406 1.406 0 0 0 1.85 0c1.59-1.346 3.745-3.365 5.485-5.694m-4.194 7.22c3.299-2.788 9.117-8.52 9.117-14.253 0-5.89-5.074-10.666-11.333-10.666S4.667 7.442 4.667 13.333c0 5.732 5.818 11.465 9.117 14.254a3.405 3.405 0 0 0 4.432 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 11.7a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m0 1.8a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16.567 15.095C17.881 13.337 18.7 11.573 18.7 10c0-3.323-2.895-6.2-6.7-6.2S5.3 6.677 5.3 10c0 1.573.82 3.337 2.133 5.095 1.286 1.721 2.883 3.22 4.067 4.22a.754.754 0 0 0 1 0c1.184-1 2.78-2.499 4.067-4.22m-2.905 5.595C16.136 18.598 20.5 14.3 20.5 10c0-4.418-3.806-8-8.5-8s-8.5 3.582-8.5 8c0 4.3 4.364 8.598 6.838 10.69.97.82 2.355.82 3.324 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 8.525a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3m0 1.6a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.225 11.172c.973-1.303 1.55-2.572 1.55-3.672 0-2.34-2.045-4.4-4.775-4.4S4.225 5.16 4.225 7.5c0 1.1.577 2.37 1.55 3.672.949 1.27 2.13 2.379 3.012 3.124.071.06.146.083.213.083a.33.33 0 0 0 .213-.083c.882-.745 2.063-1.855 3.012-3.124m-1.979 4.346c1.856-1.57 5.129-4.794 5.129-8.018 0-3.314-2.854-6-6.375-6s-6.375 2.686-6.375 6c0 3.224 3.273 6.449 5.129 8.018a1.915 1.915 0 0 0 2.492 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.804 9.884c.862-1.153 1.363-2.265 1.363-3.217 0-2.033-1.779-3.834-4.167-3.834S3.833 4.634 3.833 6.667c0 .952.501 2.064 1.363 3.217.838 1.122 1.883 2.104 2.664 2.764.05.042.099.055.14.055s.09-.013.14-.055c.78-.66 1.826-1.642 2.664-2.764m-1.696 3.91c1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334S2.333 3.721 2.333 6.667c0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLocationPinDotMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 5.55a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.043 7.368C8.686 6.508 9.05 5.69 9.05 5c0-1.479-1.296-2.8-3.05-2.8S2.95 3.521 2.95 5c0 .69.364 1.508 1.007 2.368.624.835 1.403 1.567 1.987 2.06.023.02.043.024.056.024a.1.1 0 0 0 .056-.023c.584-.494 1.363-1.226 1.987-2.061m-1.212 2.977C8.068 9.3 10.25 7.15 10.25 5c0-2.21-1.903-4-4.25-4S1.75 2.79 1.75 5c0 2.15 2.182 4.3 3.419 5.345.485.41 1.177.41 1.662 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconLocationPinDot/IconLocationPinDot.tsx
var IconLocationPinDot = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLocationPinDotMonochromeExtralight,
          "monochrome|light": IconLocationPinDotMonochromeLight,
          "monochrome|regular": IconLocationPinDotMonochromeRegular,
          "monochrome|medium": IconLocationPinDotMonochromeMedium,
          "monochrome|semibold": IconLocationPinDotMonochromeSemibold,
          "monochrome|bold": IconLocationPinDotMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M27.324 41.38a5.11 5.11 0 0 1-6.648 0C15.728 37.196 7 28.598 7 20c0-8.837 7.611-16 17-16s17 7.163 17 16c0 8.598-8.728 17.196-13.676 21.38M24 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12" })
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M18.216 27.587a3.405 3.405 0 0 1-4.432 0c-3.299-2.79-9.117-8.522-9.117-14.254C4.667 7.443 9.74 2.667 16 2.667s11.333 4.775 11.333 10.666c0 5.732-5.818 11.465-9.117 14.254M16 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8" })
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M13.662 20.69c-.97.82-2.355.82-3.324 0C7.864 18.598 3.5 14.3 3.5 10c0-4.418 3.806-8 8.5-8s8.5 3.582 8.5 8c0 4.3-4.364 8.598-6.838 10.69M12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" })
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.247 15.518a1.915 1.915 0 0 1-2.493 0c-1.856-1.57-5.129-4.794-5.129-8.018 0-3.314 2.854-6 6.375-6s6.375 2.686 6.375 6c0 3.224-3.273 6.449-5.129 8.018M9 10.125a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5" })
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8 1.333c-3.13 0-5.667 2.388-5.667 5.334 0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0 1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334M8 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4" })
        }
      );
    }
  )
);
var IconLocationPinDotFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.831 10.519c-.485.41-1.177.41-1.662 0C3.932 9.473 1.75 7.323 1.75 5.174c0-2.21 1.903-4 4.25-4s4.25 1.79 4.25 4c0 2.15-2.182 4.299-3.419 5.345M6 6.924a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" })
        }
      );
    }
  )
);

// src/IconLocationPinDotFilled/IconLocationPinDotFilled.tsx
var IconLocationPinDotFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLocationPinDotFilledMonochromeExtralight,
          "monochrome|light": IconLocationPinDotFilledMonochromeLight,
          "monochrome|regular": IconLocationPinDotFilledMonochromeRegular,
          "monochrome|medium": IconLocationPinDotFilledMonochromeMedium,
          "monochrome|semibold": IconLocationPinDotFilledMonochromeSemibold,
          "monochrome|bold": IconLocationPinDotFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLockMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.8H14A7.2 7.2 0 0 0 6.8 22v14a7.2 7.2 0 0 0 7.2 7.2h20a7.2 7.2 0 0 0 7.2-7.2V22a7.2 7.2 0 0 0-7.2-7.2h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 7.2v2.8h-9.6V12a4.8 4.8 0 1 1 9.6 0M9.2 22a4.8 4.8 0 0 1 4.8-4.8h20a4.8 4.8 0 0 1 4.8 4.8v14a4.8 4.8 0 0 1-4.8 4.8H14A4.8 4.8 0 0 1 9.2 36z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLockMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 3a5 5 0 0 0-5 5v1.667H9.333a5 5 0 0 0-5 5V24a5 5 0 0 0 5 5h13.333a5 5 0 0 0 5-5v-9.333a5 5 0 0 0-5-5H21V8a5 5 0 0 0-5-5m3 5v1.667h-6V8a3 3 0 1 1 6 0M6.333 14.667a3 3 0 0 1 3-3h13.333a3 3 0 0 1 3 3V24a3 3 0 0 1-3 3H9.333a3 3 0 0 1-3-3z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLockMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1M14.1 6v1.1H9.9V6a2.1 2.1 0 1 1 4.2 0m-9.2 5c0-1.16.94-2.1 2.1-2.1h10c1.16 0 2.1.94 2.1 2.1v7a2.1 2.1 0 0 1-2.1 2.1H7A2.1 2.1 0 0 1 4.9 18z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLockMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.7h-.7A3.05 3.05 0 0 0 2.2 8.25v5.25a3.05 3.05 0 0 0 3.05 3.05h7.5a3.05 3.05 0 0 0 3.05-3.05V8.25a3.05 3.05 0 0 0-3.05-3.05h-.7v-.7A3.05 3.05 0 0 0 9 1.45m1.45 3.05v.7h-2.9v-.7a1.45 1.45 0 1 1 2.9 0M3.8 8.25c0-.8.65-1.45 1.45-1.45h7.5c.801 0 1.45.65 1.45 1.45v5.25c0 .801-.649 1.45-1.45 1.45h-7.5c-.8 0-1.45-.649-1.45-1.45z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLockMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.583h-.583a2.75 2.75 0 0 0-2.75 2.75V12a2.75 2.75 0 0 0 2.75 2.75h6.667a2.75 2.75 0 0 0 2.75-2.75V7.333a2.75 2.75 0 0 0-2.75-2.75h-.584V4A2.75 2.75 0 0 0 8 1.25M9.25 4v.583h-2.5V4a1.25 1.25 0 1 1 2.5 0M3.417 7.333c0-.69.56-1.25 1.25-1.25h6.667c.69 0 1.25.56 1.25 1.25V12c0 .69-.56 1.25-1.25 1.25H4.667c-.69 0-1.25-.56-1.25-1.25z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconLockMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.4h-.4a2.1 2.1 0 0 0-2.1 2.1V9c0 1.16.94 2.1 2.1 2.1h5A2.1 2.1 0 0 0 10.6 9V5.5a2.1 2.1 0 0 0-2.1-2.1h-.4V3A2.1 2.1 0 0 0 6 .9M6.9 3v.4H5.1V3a.9.9 0 0 1 1.8 0M2.6 5.5a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 .9.9V9a.9.9 0 0 1-.9.9h-5a.9.9 0 0 1-.9-.9z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconLock/IconLock.tsx
var IconLock = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLockMonochromeExtralight,
          "monochrome|light": IconLockMonochromeLight,
          "monochrome|regular": IconLockMonochromeRegular,
          "monochrome|medium": IconLockMonochromeMedium,
          "monochrome|semibold": IconLockMonochromeSemibold,
          "monochrome|bold": IconLockMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconLockFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.2H14A7.8 7.8 0 0 0 6.2 22v14a7.8 7.8 0 0 0 7.8 7.8h20a7.8 7.8 0 0 0 7.8-7.8V22a7.8 7.8 0 0 0-7.8-7.8h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 9.4V12a4.8 4.8 0 1 0-9.6 0v2.2zM24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLockFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 3a5 5 0 0 0-5 5v1.467H9.334a5.2 5.2 0 0 0-5.2 5.2V24a5.2 5.2 0 0 0 5.2 5.2h13.333a5.2 5.2 0 0 0 5.2-5.2v-9.333a5.2 5.2 0 0 0-5.2-5.2H21V8a5 5 0 0 0-5-5m3 6.467V8a3 3 0 1 0-6 0v1.467zM16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLockFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1m2.1 5V6a2.1 2.1 0 1 0-4.2 0v1.1zM12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLockFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.825h-.7A2.925 2.925 0 0 0 2.325 8.25v5.25a2.925 2.925 0 0 0 2.925 2.925h7.5a2.925 2.925 0 0 0 2.925-2.925V8.25a2.925 2.925 0 0 0-2.925-2.925h-.7V4.5A3.05 3.05 0 0 0 9 1.45M7.55 4.5a1.45 1.45 0 1 1 2.9 0v.7h-2.9zM9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLockFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.733h-.584a2.6 2.6 0 0 0-2.6 2.6V12a2.6 2.6 0 0 0 2.6 2.6h6.667a2.6 2.6 0 0 0 2.6-2.6V7.333a2.6 2.6 0 0 0-2.6-2.6h-.583V4A2.75 2.75 0 0 0 8 1.25M6.75 4a1.25 1.25 0 1 1 2.5 0v.583h-2.5zM8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconLockFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.55h-.4A1.95 1.95 0 0 0 1.55 5.5V9a1.95 1.95 0 0 0 1.95 1.95h5A1.95 1.95 0 0 0 10.45 9V5.5A1.95 1.95 0 0 0 8.5 3.55h-.4V3A2.1 2.1 0 0 0 6 .9M5.1 3a.9.9 0 0 1 1.8 0v.4H5.1zM6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconLockFilled/IconLockFilled.tsx
var IconLockFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconLockFilledMonochromeExtralight,
          "monochrome|light": IconLockFilledMonochromeLight,
          "monochrome|regular": IconLockFilledMonochromeRegular,
          "monochrome|medium": IconLockFilledMonochromeMedium,
          "monochrome|semibold": IconLockFilledMonochromeSemibold,
          "monochrome|bold": IconLockFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M17.4 10.5a6.9 6.9 0 1 0-13.8 0 6.9 6.9 0 0 0 13.8 0m1.2 0c0 2.02-.743 3.867-1.966 5.285l4.79 4.791.077.094a.6.6 0 0 1-.831.831l-.094-.077-4.79-4.79A8.07 8.07 0 0 1 10.5 18.6a8.1 8.1 0 0 1-8.1-8.1 8.1 8.1 0 0 1 8.1-8.1 8.1 8.1 0 0 1 8.1 8.1" })
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.247 16.307a7.5 7.5 0 1 1 1.06-1.06l5.223 5.223a.75.75 0 1 1-1.06 1.06zM16.5 10.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.129 16.402a7.5 7.5 0 1 1 1.273-1.273l5.235 5.235a.9.9 0 1 1-1.273 1.272zM16.2 10.5a5.7 5.7 0 1 1-11.4 0 5.7 5.7 0 0 1 11.4 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.996 16.504a7.5 7.5 0 1 1 1.509-1.508l5.25 5.25a1.067 1.067 0 0 1-1.51 1.508zm.87-6.004a5.367 5.367 0 1 1-10.733 0 5.367 5.367 0 0 1 10.734 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.948 16.54a7.5 7.5 0 1 1 1.591-1.591l5.256 5.256a1.125 1.125 0 0 1-1.59 1.59zm.802-6.04a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMagnifyingGlassMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.887 16.584a7.5 7.5 0 1 1 1.697-1.697l5.265 5.264a1.2 1.2 0 1 1-1.698 1.698zM15.6 10.5a5.1 5.1 0 1 1-10.2 0 5.1 5.1 0 0 1 10.2 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconMagnifyingGlass/IconMagnifyingGlass.tsx
var IconMagnifyingGlass = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconMagnifyingGlassMonochromeExtralight,
          "monochrome|light": IconMagnifyingGlassMonochromeLight,
          "monochrome|regular": IconMagnifyingGlassMonochromeRegular,
          "monochrome|medium": IconMagnifyingGlassMonochromeMedium,
          "monochrome|semibold": IconMagnifyingGlassMonochromeSemibold,
          "monochrome|bold": IconMagnifyingGlassMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M7.2 12A4.8 4.8 0 0 1 12 7.2h4a1.2 1.2 0 0 0 0-2.4h-4A7.2 7.2 0 0 0 4.8 12v4a1.2 1.2 0 0 0 2.4 0zM40.596 12a4.8 4.8 0 0 0-4.8-4.8H32a1.2 1.2 0 0 1 0-2.4h3.796a7.2 7.2 0 0 1 7.2 7.2v4a1.2 1.2 0 0 1-2.4 0zM12 40.8A4.8 4.8 0 0 1 7.2 36v-4a1.2 1.2 0 0 0-2.4 0v4a7.2 7.2 0 0 0 7.2 7.2h4a1.2 1.2 0 0 0 0-2.4zM40.596 36a4.8 4.8 0 0 1-4.8 4.8H32a1.2 1.2 0 0 0 0 2.4h3.796a7.2 7.2 0 0 0 7.2-7.2v-4a1.2 1.2 0 0 0-2.4 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M30.554 28.563a10.55 10.55 0 0 0 2.622-6.975c0-5.847-4.74-10.588-10.588-10.588S12 15.74 12 21.588s4.74 10.588 10.588 10.588c2.31 0 4.448-.74 6.19-1.996l5.315 5.316a1.2 1.2 0 1 0 1.697-1.697zm-7.966 1.213a8.188 8.188 0 1 0 0-16.376 8.188 8.188 0 0 0 0 16.377",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5 8a3 3 0 0 1 3-3h2.667a1 1 0 1 0 0-2H8a5 5 0 0 0-5 5v2.667a1 1 0 1 0 2 0zM26.864 8a3 3 0 0 0-3-3h-2.53a1 1 0 1 1 0-2h2.53a5 5 0 0 1 5 5v2.667a1 1 0 0 1-2 0zM8 27a3 3 0 0 1-3-3v-2.667a1 1 0 1 0-2 0V24a5 5 0 0 0 5 5h2.667a1 1 0 1 0 0-2zM26.864 24a3 3 0 0 1-3 3h-2.53a1 1 0 1 0 0 2h2.53a5 5 0 0 0 5-5v-2.667a1 1 0 0 0-2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M20.5 18.89a7.059 7.059 0 1 0-1.481 1.347l3.568 3.568A1 1 0 0 0 24 22.391zm-5.441.561a5.059 5.059 0 1 0 0-10.117 5.059 5.059 0 0 0 0 10.117",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 3.9A2.1 2.1 0 0 0 3.9 6v2a.9.9 0 0 1-1.8 0V6A3.9 3.9 0 0 1 6 2.1h2a.9.9 0 0 1 0 1.8zM17.898 3.9c1.16 0 2.1.94 2.1 2.1v2a.9.9 0 1 0 1.8 0V6a3.9 3.9 0 0 0-3.9-3.9H16a.9.9 0 1 0 0 1.8zM6 20.1A2.1 2.1 0 0 1 3.9 18v-2a.9.9 0 1 0-1.8 0v2A3.9 3.9 0 0 0 6 21.9h2a.9.9 0 0 0 0-1.8zM17.898 20.1a2.1 2.1 0 0 0 2.1-2.1v-2a.9.9 0 1 1 1.8 0v2a3.9 3.9 0 0 1-3.9 3.9H16a.9.9 0 0 1 0-1.8z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.788 10.794a3.494 3.494 0 1 1-6.988 0 3.494 3.494 0 0 1 6.988 0m-.652 4.468a5.294 5.294 0 1 1 1.333-1.212l2.638 2.637a.9.9 0 1 1-1.273 1.273z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.25 3.05a1.2 1.2 0 0 0-1.2 1.2V6a.8.8 0 1 1-1.6 0V4.25a2.8 2.8 0 0 1 2.8-2.8H6a.8.8 0 1 1 0 1.6zM13.673 3.05a1.2 1.2 0 0 1 1.2 1.2V6a.8.8 0 0 0 1.6 0V4.25a2.8 2.8 0 0 0-2.8-2.8H12a.8.8 0 0 0 0 1.6zM4.25 14.95a1.2 1.2 0 0 1-1.2-1.2V12a.8.8 0 0 0-1.6 0v1.75a2.8 2.8 0 0 0 2.8 2.8H6a.8.8 0 0 0 0-1.6zM13.673 14.95a1.2 1.2 0 0 0 1.2-1.2V12a.8.8 0 0 1 1.6 0v1.75a2.8 2.8 0 0 1-2.8 2.8H12a.8.8 0 0 1 0-1.6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.493 11.514a3.97 3.97 0 1 1 1.186-1.077l1.74 1.74a.8.8 0 1 1-1.132 1.131zm.348-3.418a2.37 2.37 0 1 1-4.741 0 2.37 2.37 0 0 1 4.741 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.5 2.75a.75.75 0 0 0-.75.75v1.833a.75.75 0 1 1-1.5 0V3.5A2.25 2.25 0 0 1 3.5 1.25h1.833a.75.75 0 1 1 0 1.5zM12.432 2.75a.75.75 0 0 1 .75.75v1.833a.75.75 0 0 0 1.5 0V3.5a2.25 2.25 0 0 0-2.25-2.25h-1.765a.75.75 0 0 0 0 1.5zM3.5 13.25a.75.75 0 0 1-.75-.75v-1.833a.75.75 0 0 0-1.5 0V12.5a2.25 2.25 0 0 0 2.25 2.25h1.833a.75.75 0 0 0 0-1.5zM12.432 13.25a.75.75 0 0 0 .75-.75v-1.833a.75.75 0 0 1 1.5 0V12.5a2.25 2.25 0 0 1-2.25 2.25h-1.765a.75.75 0 0 1 0-1.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.292 10.255a3.53 3.53 0 1 1 1.112-1.01l1.373 1.374a.75.75 0 1 1-1.06 1.06zm.267-3.059a2.03 2.03 0 1 1-4.059 0 2.03 2.03 0 0 1 4.059 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMagnifyingGlassViewfinderMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.6 3.5a.9.9 0 0 1 .9-.9h1a.6.6 0 0 0 0-1.2h-1a2.1 2.1 0 0 0-2.1 2.1v1a.6.6 0 0 0 1.2 0zM9.4 3.5a.9.9 0 0 0-.9-.9H7.55a.6.6 0 0 1 0-1.2H8.5c1.16 0 2.1.94 2.1 2.1v1a.6.6 0 1 1-1.2 0zM3.5 9.4a.9.9 0 0 1-.9-.9v-1a.6.6 0 0 0-1.2 0v1c0 1.16.94 2.1 2.1 2.1h1a.6.6 0 1 0 0-1.2zM9.4 8.5a.9.9 0 0 1-.9.9H8a.6.6 0 0 0 0 1.2h.5a2.1 2.1 0 0 0 2.1-2.1V8a.6.6 0 1 0-1.2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.57 6.722a2.25 2.25 0 1 0-.876.82l.733.734a.6.6 0 1 0 .849-.849zM5.65 6.6a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconMagnifyingGlassViewfinder/IconMagnifyingGlassViewfinder.tsx
var IconMagnifyingGlassViewfinder = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconMagnifyingGlassViewfinderMonochromeExtralight,
          "monochrome|light": IconMagnifyingGlassViewfinderMonochromeLight,
          "monochrome|regular": IconMagnifyingGlassViewfinderMonochromeRegular,
          "monochrome|medium": IconMagnifyingGlassViewfinderMonochromeMedium,
          "monochrome|semibold": IconMagnifyingGlassViewfinderMonochromeSemibold,
          "monochrome|bold": IconMagnifyingGlassViewfinderMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconMinusMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M43.2 24a1.2 1.2 0 0 1-1.2 1.2H6a1.2 1.2 0 1 1 0-2.4h36a1.2 1.2 0 0 1 1.2 1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMinusMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M29 16a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h24a1 1 0 0 1 1 1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMinusMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21.9 12a.9.9 0 0 1-.9.9H3a.9.9 0 0 1 0-1.8h18a.9.9 0 0 1 .9.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMinusMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.55 9a.8.8 0 0 1-.8.8H2.25a.8.8 0 1 1 0-1.6h13.5a.8.8 0 0 1 .8.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMinusMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14.75 8a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconMinusMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M11.1 6a.6.6 0 0 1-.6.6h-9a.6.6 0 1 1 0-1.2h9a.6.6 0 0 1 .6.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconMinus/IconMinus.tsx
var IconMinus = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconMinusMonochromeExtralight,
          "monochrome|light": IconMinusMonochromeLight,
          "monochrome|regular": IconMinusMonochromeRegular,
          "monochrome|medium": IconMinusMonochromeMedium,
          "monochrome|semibold": IconMinusMonochromeSemibold,
          "monochrome|bold": IconMinusMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconMobileMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.3 4.4a2.6 2.6 0 0 1 2.6-2.6h8.2a2.6 2.6 0 0 1 2.6 2.6v15.2a2.6 2.6 0 0 1-2.6 2.6H7.9a2.6 2.6 0 0 1-2.6-2.6zM7.9 3a1.4 1.4 0 0 0-1.4 1.4v15.2A1.4 1.4 0 0 0 7.9 21h8.2a1.4 1.4 0 0 0 1.4-1.4V4.4A1.4 1.4 0 0 0 16.1 3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.4 18.3a.6.6 0 0 1 .6-.6h4a.6.6 0 1 1 0 1.2h-4a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMobileMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.15 4.4A2.75 2.75 0 0 1 7.9 1.65h8.2a2.75 2.75 0 0 1 2.75 2.75v15.2a2.75 2.75 0 0 1-2.75 2.75H7.9a2.75 2.75 0 0 1-2.75-2.75zM7.9 3.15c-.69 0-1.25.56-1.25 1.25v15.2c0 .69.56 1.25 1.25 1.25h8.2c.69 0 1.25-.56 1.25-1.25V4.4c0-.69-.56-1.25-1.25-1.25z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.25 18.3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMobileMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5 4.4a2.9 2.9 0 0 1 2.9-2.9h8.2A2.9 2.9 0 0 1 19 4.4v15.2a2.9 2.9 0 0 1-2.9 2.9H7.9A2.9 2.9 0 0 1 5 19.6zm2.9-1.1a1.1 1.1 0 0 0-1.1 1.1v15.2a1.1 1.1 0 0 0 1.1 1.1h8.2a1.1 1.1 0 0 0 1.1-1.1V4.4a1.1 1.1 0 0 0-1.1-1.1z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.1 18.3a.9.9 0 0 1 .9-.9h4a.9.9 0 1 1 0 1.8h-4a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMobileMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.833 4.4A3.067 3.067 0 0 1 7.9 1.333h8.2A3.067 3.067 0 0 1 19.167 4.4v15.2a3.067 3.067 0 0 1-3.067 3.067H7.9A3.067 3.067 0 0 1 4.833 19.6zM7.9 3.467a.933.933 0 0 0-.933.933v15.2c0 .515.418.933.933.933h8.2a.933.933 0 0 0 .933-.933V4.4a.933.933 0 0 0-.933-.933z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.933 18.3c0-.59.478-1.067 1.067-1.067h4a1.067 1.067 0 1 1 0 2.134h-4c-.59 0-1.067-.478-1.067-1.067",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMobileMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.775 4.4c0-1.726 1.4-3.126 3.125-3.126h8.2c1.726 0 3.125 1.4 3.125 3.125v15.2c0 1.726-1.399 3.125-3.125 3.125H7.9A3.125 3.125 0 0 1 4.775 19.6zM7.9 3.523a.875.875 0 0 0-.875.875v15.2c0 .484.392.875.875.875h8.2a.875.875 0 0 0 .875-.875V4.4a.875.875 0 0 0-.875-.875z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.875 18.3c0-.622.504-1.126 1.125-1.126h4a1.125 1.125 0 0 1 0 2.25h-4A1.125 1.125 0 0 1 8.875 18.3",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconMobileMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.7 4.4a3.2 3.2 0 0 1 3.2-3.2h8.2a3.2 3.2 0 0 1 3.2 3.2v15.2a3.2 3.2 0 0 1-3.2 3.2H7.9a3.2 3.2 0 0 1-3.2-3.2zm3.2-.8a.8.8 0 0 0-.8.8v15.2a.8.8 0 0 0 .8.8h8.2a.8.8 0 0 0 .8-.8V4.4a.8.8 0 0 0-.8-.8z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.8 18.3a1.2 1.2 0 0 1 1.2-1.2h4a1.2 1.2 0 0 1 0 2.4h-4a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconMobile/IconMobile.tsx
var IconMobile = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconMobileMonochromeExtralight,
          "monochrome|light": IconMobileMonochromeLight,
          "monochrome|regular": IconMobileMonochromeRegular,
          "monochrome|medium": IconMobileMonochromeMedium,
          "monochrome|semibold": IconMobileMonochromeSemibold,
          "monochrome|bold": IconMobileMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19 16.6a1.2 1.2 0 0 1 1.282-1.197l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 0 1-2.4 0zm2.4 1.2V25h4a3.6 3.6 0 0 0 0-7.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m13.467 10.067.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.266a1 1 0 1 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 1 1 0 4.4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-2 0c0 6.26-5.074 11.333-11.333 11.333S4.667 22.26 4.667 16 9.74 4.667 16 4.667 27.333 9.74 27.333 16",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10" }),
            /* @__PURE__ */ jsx("path", { d: "M10.1 7.4a.9.9 0 0 1 .9.9v8a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9" }),
            /* @__PURE__ */ jsx("path", { d: "M9.2 8.385c0-.544.44-.985.985-.985H12.7a3.3 3.3 0 0 1 0 6.6H9.2zM11 9.2v3h1.7a1.5 1.5 0 1 0 0-3z" })
          ]
        }
      );
    }
  )
);
var IconPCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.775 6.225a.8.8 0 0 1 .831-.8h1.919a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0zm1.6.8v2h1.15a1 1 0 1 0 0-2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.983 5.533a.75.75 0 0 1 .807-.75h1.677a2.35 2.35 0 1 1 0 4.7h-.984v1.384a.75.75 0 0 1-1.5 0zm1.5.75v1.7h.984a.85.85 0 0 0 0-1.7z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.05 3.55h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 0 1 0 1.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconPCircle/IconPCircle.tsx
var IconPCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPCircleMonochromeExtralight,
          "monochrome|light": IconPCircleMonochromeLight,
          "monochrome|regular": IconPCircleMonochromeRegular,
          "monochrome|medium": IconPCircleMonochromeMedium,
          "monochrome|semibold": IconPCircleMonochromeSemibold,
          "monochrome|bold": IconPCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-3.8-28.6q.041 0 .082.003l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 1 1-2.4 0v-16a1.2 1.2 0 0 1 1.2-1.2m1.2 9.6v-7.2h4a3.6 3.6 0 0 1 0 7.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 29.334c7.364 0 13.333-5.97 13.333-13.334S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.636 29.334 16 29.334m-2.533-19.267.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.267a1 1 0 0 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 0 1 0 4.4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M10.1 7.4l.042.001H12.7a3.3 3.3 0 0 1 0 6.6H11v2.3a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9m.9 4.8v-3h1.7a1.5 1.5 0 0 1 0 3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M7.575 5.425h1.95a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0v-6a.8.8 0 0 1 .8-.8m.8 3.6v-2h1.15a1 1 0 1 1 0 2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M6.733 4.783h1.734a2.35 2.35 0 0 1 0 4.7h-.984v1.383a.75.75 0 1 1-1.5 0V5.534a.75.75 0 0 1 .75-.75m.75 3.2v-1.7h.984a.85.85 0 0 1 0 1.7z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m-.95-7.45h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 1 1 0 1.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPCircleFilled/IconPCircleFilled.tsx
var IconPCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPCircleFilledMonochromeExtralight,
          "monochrome|light": IconPCircleFilledMonochromeLight,
          "monochrome|regular": IconPCircleFilledMonochromeRegular,
          "monochrome|medium": IconPCircleFilledMonochromeMedium,
          "monochrome|semibold": IconPCircleFilledMonochromeSemibold,
          "monochrome|bold": IconPCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPaperClipMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M23.151 9.01c4.374-4.374 11.466-4.374 15.84 0 4.373 4.373 4.373 11.465 0 15.839L27.41 36.428l-1.696-1.698 11.578-11.578a8.8 8.8 0 1 0-12.445-12.445L12.12 23.434a1.2 1.2 0 1 1-1.697-1.697z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.484 30.576a7.7 7.7 0 0 0 10.89 10.89l5.038-5.038-1.697-1.698-5.039 5.039a5.3 5.3 0 0 1-7.495-7.496L26.97 18.485l-1.697-1.697z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M27.394 14.666a4.2 4.2 0 0 1 5.94 5.94l-12.021 12.02a1.2 1.2 0 1 1-1.697-1.696l12.02-12.021a1.8 1.8 0 0 0-2.545-2.546l-9.664 9.664-1.697-1.697z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPaperClipMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.293 5.865a7.667 7.667 0 1 1 10.843 10.842l-7.72 7.72-1.414-1.415 7.72-7.72a5.667 5.667 0 1 0-8.015-8.013l-8.485 8.485a1 1 0 1 1-1.414-1.414z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.515 20.243a5.333 5.333 0 0 0 7.542 7.542l3.36-3.359-1.415-1.414-3.359 3.359a3.333 3.333 0 0 1-4.714-4.714l9.193-9.193-1.415-1.414z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.122 9.636a3 3 0 1 1 4.242 4.243l-8.014 8.013a1 1 0 0 1-1.414-1.414l8.014-8.014a1 1 0 0 0-1.414-1.414l-6.443 6.443-1.414-1.415z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPaperClipMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.363 4.293a5.9 5.9 0 0 1 8.344 8.343l-5.79 5.79-1.272-1.273 5.79-5.79a4.1 4.1 0 1 0-5.799-5.798L6.272 11.93A.9.9 0 0 1 5 10.656z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.53 15.076a4.15 4.15 0 0 0 5.869 5.869l2.519-2.52-1.273-1.272-2.52 2.52a2.35 2.35 0 0 1-3.322-3.324l6.894-6.895-1.273-1.272z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13.485 7.12a2.4 2.4 0 1 1 3.394 3.395l-6.01 6.01a.9.9 0 0 1-1.273-1.272l6.01-6.01a.6.6 0 0 0-.848-.85l-4.832 4.833-1.273-1.273z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPaperClipMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.434 3.131a4.55 4.55 0 1 1 6.435 6.435l-4.342 4.342-1.131-1.132 4.342-4.342a2.95 2.95 0 0 0-4.172-4.172L4.793 9.035a.8.8 0 0 1-1.131-1.131z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.06 11.219a3.237 3.237 0 1 0 4.578 4.578l1.89-1.89-1.132-1.13-1.89 1.889A1.637 1.637 0 1 1 5.19 12.35l5.171-5.17L9.23 6.047z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.026 5.252a1.925 1.925 0 1 1 2.722 2.723L8.24 12.483a.8.8 0 0 1-1.131-1.132l4.508-4.508a.325.325 0 0 0-.46-.46l-3.624 3.625-1.131-1.132z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPaperClipMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.47 2.756a4.083 4.083 0 0 1 5.774 5.774l-3.86 3.86-1.06-1.06 3.86-3.86A2.583 2.583 0 1 0 8.53 3.816L4.288 8.06a.75.75 0 1 1-1.061-1.06z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.58 9.944a2.917 2.917 0 0 0 4.125 4.125l1.68-1.68-1.061-1.06-1.68 1.68a1.417 1.417 0 0 1-2.003-2.004L9.237 6.41l-1.06-1.06z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.884 4.641a1.75 1.75 0 1 1 2.475 2.475l-4.007 4.007a.75.75 0 1 1-1.06-1.06l4.006-4.008a.25.25 0 0 0-.353-.353L6.724 8.923l-1.061-1.06z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPaperClipMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.576 2.04A3.1 3.1 0 0 1 9.96 6.424L7.065 9.32l-.848-.848L9.11 5.576a1.9 1.9 0 0 0-2.687-2.687L3.242 6.07a.6.6 0 1 1-.848-.849z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.659 7.432a2.225 2.225 0 0 0 3.147 3.147l1.259-1.26-.848-.848-1.26 1.26a1.025 1.025 0 1 1-1.45-1.45l3.448-3.448-.849-.848z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.636 3.455a1.35 1.35 0 1 1 1.91 1.909L5.54 8.369a.6.6 0 1 1-.848-.849l3.005-3.005a.15.15 0 1 0-.212-.212L5.069 6.72l-.849-.848z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconPaperClip/IconPaperClip.tsx
var IconPaperClip = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPaperClipMonochromeExtralight,
          "monochrome|light": IconPaperClipMonochromeLight,
          "monochrome|regular": IconPaperClipMonochromeRegular,
          "monochrome|medium": IconPaperClipMonochromeMedium,
          "monochrome|semibold": IconPaperClipMonochromeSemibold,
          "monochrome|bold": IconPaperClipMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.256 4.817a2.7 2.7 0 0 1 1.505.268l32.972 16.508a2.7 2.7 0 0 1 0 4.806l-.01.005-32.957 16.5c-.37.19-.777.29-1.192.295a2.696 2.696 0 0 1-2.718-2.154 2.7 2.7 0 0 1 .037-1.248l.006-.02L9.345 25.3H25.5a1.3 1.3 0 1 0 0-2.6H9.353l-4.4-14.547-.008-.034a2.7 2.7 0 0 1 .89-2.7l.005-.005.006-.004c.403-.33.893-.536 1.41-.593" })
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.93 3.211a2 2 0 0 0-2.16.24l-.009.009a2 2 0 0 0-.659 2l.007.027 2.953 9.763h10.855a.75.75 0 0 1 0 1.5H6.057l-2.984 9.712-.004.017a2.002 2.002 0 0 0 1.985 2.52 2 2 0 0 0 .88-.217l21.97-11 .01-.005a2 2 0 0 0 0-3.56z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.515 2.274a1.65 1.65 0 0 0-1.782.199l-.008.007a1.65 1.65 0 0 0-.544 1.65l.006.025L4.378 11.4H12.5a.6.6 0 1 1 0 1.2H4.374l-2.213 7.205-.004.015a1.65 1.65 0 0 0 1.636 2.08c.252-.004.5-.065.725-.18l16.478-8.25.007-.004a1.65 1.65 0 0 0 .655-2.328 1.65 1.65 0 0 0-.655-.608z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.442 1.594a1.36 1.36 0 0 0-1.471.164l-.008.006a1.36 1.36 0 0 0-.45 1.362l.006.023L3.153 8.55H9.25a.45.45 0 1 1 0 .9h-6.1L1.5 14.82l-.003.013a1.363 1.363 0 0 0 1.35 1.716 1.36 1.36 0 0 0 .598-.147l12.358-6.187.006-.004a1.362 1.362 0 0 0 0-2.425z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.06 1.417a1.21 1.21 0 0 0-1.308.145l-.007.006a1.21 1.21 0 0 0-.4 1.21l.006.02L2.803 7.6h5.42a.4.4 0 1 1 0 .8H2.8l-1.466 4.773-.003.011a1.212 1.212 0 0 0 1.2 1.527 1.2 1.2 0 0 0 .531-.132l10.985-5.5.006-.002a1.21 1.21 0 0 0 0-2.156z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPaperPlaneFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("g", { clipPath: `url(#${_id})`, children: /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.325 1.003a.97.97 0 0 0-1.053.117l-.006.005a.98.98 0 0 0-.322.975l.004.017L2.002 5.6H6a.4.4 0 1 1 0 .8H2L.935 9.861l-.002.01A.976.976 0 0 0 1.9 11.1a1 1 0 0 0 .427-.106l8.238-4.125.005-.002a.974.974 0 0 0 0-1.736z",
                clipRule: "evenodd"
              }
            ) }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconPaperPlaneFilled/IconPaperPlaneFilled.tsx
var IconPaperPlaneFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPaperPlaneFilledMonochromeExtralight,
          "monochrome|light": IconPaperPlaneFilledMonochromeLight,
          "monochrome|regular": IconPaperPlaneFilledMonochromeRegular,
          "monochrome|medium": IconPaperPlaneFilledMonochromeMedium,
          "monochrome|semibold": IconPaperPlaneFilledMonochromeSemibold,
          "monochrome|bold": IconPaperPlaneFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPauseMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11 11.9a3.2 3.2 0 0 1 3.2-3.2h2a3.2 3.2 0 0 1 3.2 3.2v24.2a3.2 3.2 0 0 1-3.2 3.2h-2a3.2 3.2 0 0 1-3.2-3.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M31.8 8.7a3.2 3.2 0 0 0-3.2 3.2v24.2a3.2 3.2 0 0 0 3.2 3.2h2a3.2 3.2 0 0 0 3.2-3.2V11.9a3.2 3.2 0 0 0-3.2-3.2z" })
          ]
        }
      );
    }
  )
);
var IconPauseMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.133 7.933A2.333 2.333 0 0 1 9.467 5.6H10.8a2.333 2.333 0 0 1 2.333 2.333v16.133A2.333 2.333 0 0 1 10.8 26.4H9.467a2.333 2.333 0 0 1-2.334-2.334z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M21.2 5.6a2.333 2.333 0 0 0-2.333 2.333v16.133A2.333 2.333 0 0 0 21.2 26.4h1.333a2.333 2.333 0 0 0 2.334-2.334V7.933A2.333 2.333 0 0 0 22.533 5.6z" })
          ]
        }
      );
    }
  )
);
var IconPauseMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M7.1 4.05a1.9 1.9 0 0 0-1.9 1.9v12.1c0 1.05.85 1.9 1.9 1.9h1a1.9 1.9 0 0 0 1.9-1.9V5.95a1.9 1.9 0 0 0-1.9-1.9zm8.8 0a1.9 1.9 0 0 0-1.9 1.9v12.1c0 1.05.85 1.9 1.9 1.9h1a1.9 1.9 0 0 0 1.9-1.9V5.95a1.9 1.9 0 0 0-1.9-1.9z" })
        }
      );
    }
  )
);
var IconPauseMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.325 2.912a1.55 1.55 0 0 0-1.55 1.55v9.075c0 .856.694 1.55 1.55 1.55h.75a1.55 1.55 0 0 0 1.55-1.55V4.462a1.55 1.55 0 0 0-1.55-1.55zm6.6 0a1.55 1.55 0 0 0-1.55 1.55v9.075c0 .856.694 1.55 1.55 1.55h.75a1.55 1.55 0 0 0 1.55-1.55V4.462a1.55 1.55 0 0 0-1.55-1.55z" })
        }
      );
    }
  )
);
var IconPauseMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.733 2.55c-.782 0-1.416.634-1.416 1.416v8.067c0 .783.634 1.417 1.416 1.417H5.4c.782 0 1.417-.634 1.417-1.417V3.966c0-.782-.635-1.416-1.417-1.416zm5.867 0c-.782 0-1.417.634-1.417 1.416v8.067c0 .783.635 1.417 1.417 1.417h.667c.782 0 1.416-.634 1.416-1.417V3.966c0-.782-.634-1.416-1.416-1.416z" })
        }
      );
    }
  )
);
var IconPauseMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.55 1.875a1.1 1.1 0 0 0-1.1 1.1v6.05a1.1 1.1 0 0 0 1.1 1.1h.5a1.1 1.1 0 0 0 1.1-1.1v-6.05a1.1 1.1 0 0 0-1.1-1.1zm4.4 0a1.1 1.1 0 0 0-1.1 1.1v6.05a1.1 1.1 0 0 0 1.1 1.1h.5a1.1 1.1 0 0 0 1.1-1.1v-6.05a1.1 1.1 0 0 0-1.1-1.1z" })
        }
      );
    }
  )
);

// src/IconPause/IconPause.tsx
var IconPause = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPauseMonochromeExtralight,
          "monochrome|light": IconPauseMonochromeLight,
          "monochrome|regular": IconPauseMonochromeRegular,
          "monochrome|medium": IconPauseMonochromeMedium,
          "monochrome|semibold": IconPauseMonochromeSemibold,
          "monochrome|bold": IconPauseMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPencilMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.4 35.243V39a.6.6 0 0 0 .6.6h3.757a.6.6 0 0 0 .425-.176l23.12-23.12a3.257 3.257 0 0 0-4.605-4.607L10.576 34.818a.6.6 0 0 0-.176.425M8 39v-3.757a3 3 0 0 1 .879-2.122L32 10.001a5.657 5.657 0 0 1 8 8L16.879 41.12a3 3 0 0 1-2.122.88H11a3 3 0 0 1-3-3",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m35.152 20.849-6-6 1.697-1.697 6 6z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPencilMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.333 23.495V26h2.505l15.414-15.414a1.77 1.77 0 0 0 0-2.505l1.415-1.414a3.77 3.77 0 0 1 0 5.333L11.252 27.414A2 2 0 0 1 9.838 28H7.333a2 2 0 0 1-2-2v-2.505a2 2 0 0 1 .586-1.414L21.333 6.667a3.77 3.77 0 0 1 5.334 0L25.252 8.08a1.77 1.77 0 0 0-2.504 0z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m23.293 14.04-4-4 1.414-1.414 4 4z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPencilMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.8 19.2h1.454L18.727 7.727a1.028 1.028 0 0 0-1.454-1.454L5.8 17.746zM4 20v-2.586a1 1 0 0 1 .293-.707L16 5a2.828 2.828 0 1 1 4 4L8.293 20.707a1 1 0 0 1-.707.293H5a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m17.364 10.637-3-3 1.272-1.273 3 3z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPencilMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.6 14.15h.737l8.532-8.531L15 6.75l-8.707 8.707a1 1 0 0 1-.707.293H4a1 1 0 0 1-1-1v-1.586a1 1 0 0 1 .293-.707L12 3.75a2.121 2.121 0 0 1 3 3l-1.131-1.131a.521.521 0 0 0-.738-.738L4.6 13.413z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m12.934 8.066-2.25-2.25 1.132-1.132 2.25 2.25z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPencilMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.167 12.5h.545l7.56-7.56a.386.386 0 0 0-.545-.546l-7.56 7.56zm-1.5.833V11.61c0-.176.07-.346.195-.471l7.804-7.805A1.886 1.886 0 0 1 13.333 6l-7.805 7.805a.67.67 0 0 1-.471.195H3.333a.667.667 0 0 1-.667-.667",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "m11.47 7.197-2-2 1.06-1.06 2 2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPencilMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.2 9.3h.303L9.15 3.65a.214.214 0 1 0-.302-.303L3.2 8.997zM2 10V8.707a.5.5 0 0 1 .146-.354L8 2.5a1.414 1.414 0 1 1 2 2l-5.854 5.854a.5.5 0 0 1-.353.146H2.5A.5.5 0 0 1 2 10",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPencil/IconPencil.tsx
var IconPencil = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPencilMonochromeExtralight,
          "monochrome|light": IconPencilMonochromeLight,
          "monochrome|regular": IconPencilMonochromeRegular,
          "monochrome|medium": IconPencilMonochromeMedium,
          "monochrome|semibold": IconPencilMonochromeSemibold,
          "monochrome|bold": IconPencilMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPencilFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8 41v-6.586a1 1 0 0 1 .293-.707l18.374-18.374a2 2 0 0 1 2.828 0l5.172 5.172a2 2 0 0 1 0 2.828L16.293 41.707a1 1 0 0 1-.707.293H9a1 1 0 0 1-1-1m28.505-22.333a2 2 0 0 0 2.828 0l3.253-3.253a2 2 0 0 0 0-2.828l-5.172-5.172a2 2 0 0 0-2.828 0l-3.252 3.252a2 2 0 0 0 0 2.829z" })
        }
      );
    }
  )
);
var IconPencilFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.333 27.333v-4.39c0-.177.07-.347.196-.472l12.249-12.249c.52-.52 1.364-.52 1.885 0l3.448 3.448c.52.52.52 1.365 0 1.886l-12.25 12.249a.67.67 0 0 1-.47.195H6a.667.667 0 0 1-.667-.667m19.004-14.889c.52.521 1.364.521 1.885 0l2.168-2.168c.521-.52.521-1.365 0-1.886l-3.447-3.447a1.333 1.333 0 0 0-1.886 0L20.89 7.11c-.52.52-.52 1.365 0 1.886z" })
        }
      );
    }
  )
);
var IconPencilFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4 20.5v-3.293a.5.5 0 0 1 .146-.353l9.187-9.187a1 1 0 0 1 1.415 0l2.585 2.586a1 1 0 0 1 0 1.414l-9.187 9.187a.5.5 0 0 1-.353.146H4.5a.5.5 0 0 1-.5-.5M18.253 9.333a1 1 0 0 0 1.414 0l1.626-1.626a1 1 0 0 0 0-1.414l-2.586-2.586a1 1 0 0 0-1.414 0l-1.626 1.626a1 1 0 0 0 0 1.415z" })
        }
      );
    }
  )
);
var IconPencilFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 15.375v-2.47c0-.1.04-.195.11-.265L10 5.75a.75.75 0 0 1 1.06 0L13 7.69a.75.75 0 0 1 0 1.06l-6.89 6.89a.38.38 0 0 1-.265.11h-2.47A.375.375 0 0 1 3 15.375M13.69 7a.75.75 0 0 0 1.06 0l1.22-1.22a.75.75 0 0 0 0-1.06l-1.94-1.94a.75.75 0 0 0-1.06 0L11.75 4a.75.75 0 0 0 0 1.06z" })
        }
      );
    }
  )
);
var IconPencilFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.667 13.667V11.47c0-.088.035-.173.097-.235L8.89 5.11c.26-.26.682-.26.943 0l1.724 1.724c.26.26.26.682 0 .943L5.43 13.902a.33.33 0 0 1-.236.098H3a.333.333 0 0 1-.333-.333m9.501-7.445c.26.26.683.26.943 0l1.084-1.084a.667.667 0 0 0 0-.943l-1.723-1.724a.667.667 0 0 0-.943 0l-1.084 1.084a.667.667 0 0 0 0 .943z" })
        }
      );
    }
  )
);
var IconPencilFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2 10.25V8.603a.25.25 0 0 1 .073-.176l4.594-4.594a.5.5 0 0 1 .707 0l1.293 1.293a.5.5 0 0 1 0 .707l-4.594 4.594a.25.25 0 0 1-.177.073H2.25a.25.25 0 0 1-.25-.25m7.126-5.583a.5.5 0 0 0 .707 0l.813-.814a.5.5 0 0 0 0-.707L9.354 1.853a.5.5 0 0 0-.708 0l-.813.814a.5.5 0 0 0 0 .707z" })
        }
      );
    }
  )
);

// src/IconPencilFilled/IconPencilFilled.tsx
var IconPencilFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPencilFilledMonochromeExtralight,
          "monochrome|light": IconPencilFilledMonochromeLight,
          "monochrome|regular": IconPencilFilledMonochromeRegular,
          "monochrome|medium": IconPencilFilledMonochromeMedium,
          "monochrome|semibold": IconPencilFilledMonochromeSemibold,
          "monochrome|bold": IconPencilFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPersonMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M240.018 237.748c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-172c40.869 0 74 33.131 74 74s-33.131 74-74 74-74-33.131-74-74 33.131-74 74-74M240.006 268.01c49.595 0 87.171 13.1 114.477 33.725 27.251 20.585 43.461 48.053 51.401 75.458l.198.703c4.011 14.748-.46 28.586-9.454 38.422-8.962 9.803-22.349 15.677-36.622 15.677h-240c-14.273 0-27.66-5.874-36.622-15.677-9.136-9.992-13.605-24.114-9.255-39.125 7.94-27.405 24.15-54.873 51.401-75.458 27.305-20.625 64.882-33.725 114.476-33.725m-100.011 52.876c22.5-16.996 54.775-28.876 100.011-28.876 45.237 0 77.512 11.88 100.012 28.876 22.554 17.036 36.105 39.831 42.815 62.987l.158.58c1.534 5.977-.147 11.376-4.074 15.671-4.228 4.624-11.092 7.871-18.911 7.871h-240c-7.818 0-14.682-3.247-18.91-7.871-4.053-4.434-5.714-10.043-3.916-16.251 6.71-23.156 20.261-45.951 42.815-62.987",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPersonMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M240.024 237.748c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-166c37.555 0 68 30.445 68 68s-30.445 68-68 68-68-30.445-68-68 30.444-68 68-68M240.012 265.01c50.14 0 88.379 13.252 116.285 34.332 27.839 21.028 44.38 49.079 52.475 77.016l.212.755c4.304 15.83-.517 30.709-10.136 41.23-9.554 10.449-23.756 16.652-38.836 16.652h-240c-15.08 0-29.282-6.203-38.836-16.652-9.772-10.688-14.592-25.874-9.924-41.985 8.095-27.937 24.637-55.988 52.475-77.016 27.906-21.08 66.146-34.332 116.285-34.332m-98.203 58.27c21.899-16.542 53.511-28.27 98.203-28.27s76.304 11.728 98.203 28.269c21.967 16.593 35.186 38.804 41.741 61.429l.131.477c1.266 4.914-.068 9.293-3.38 12.915-3.636 3.976-9.683 6.895-16.695 6.895h-240c-7.011 0-13.059-2.919-16.695-6.895-3.418-3.739-4.73-8.284-3.249-13.392 6.555-22.625 19.774-44.835 41.741-61.428",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPersonMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M240.002 262.049c50.684 0 89.586 13.404 118.093 34.937 28.426 21.472 45.299 50.108 53.548 78.577l.227.806c4.597 16.912-.573 32.833-10.818 44.037-10.146 11.097-25.163 17.628-41.05 17.628h-240c-15.886 0-30.903-6.531-41.05-17.628-10.407-11.382-15.577-27.632-10.59-44.843 8.249-28.469 25.122-57.105 53.548-78.577 28.507-21.533 67.408-34.937 118.092-34.937m0 36c-44.147 0-75.096 11.576-96.394 27.664-21.38 16.149-34.267 37.775-40.669 59.869-1.161 4.007-.201 7.489 2.582 10.532 3.044 3.33 8.277 5.92 14.481 5.92h240c6.205 0 11.438-2.59 14.482-5.92 2.696-2.948 3.681-6.308 2.684-10.158l-.102-.374c-6.402-22.094-19.289-43.72-40.669-59.869-21.299-16.088-52.247-27.664-96.395-27.664M240.014 237.787c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-160c34.242 0 62 27.758 62 62s-27.758 62-62 62-62-27.758-62-62 27.758-62 62-62",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPersonMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M239.984 258.724c51.286 0 90.929 13.564 120.104 35.599 29.075 21.962 46.319 51.256 54.739 80.312l.235.886c4.918 18.107-.63 35.173-11.563 47.135-10.804 11.817-26.732 18.724-43.515 18.724h-240c-16.784 0-32.712-6.907-43.516-18.724-11.109-12.154-16.668-29.59-11.328-48.021l.39-1.354c8.56-28.61 25.725-57.337 54.349-78.958 29.175-22.035 68.818-35.599 120.105-35.599m0 42.682c-43.538 0-73.745 11.398-94.375 26.979-20.404 15.412-32.866 35.986-39.193 57.136l-.287.989c-.806 2.784-.252 5.099 1.823 7.37 2.387 2.61 6.724 4.818 12.032 4.818h240c5.307 0 9.645-2.208 12.031-4.818 1.945-2.129 2.547-4.295 1.953-6.849l-.13-.521c-6.232-21.499-18.755-42.471-39.479-58.125-20.631-15.581-50.838-26.979-94.375-26.979m0-259.61c54.122 0 98.018 43.874 98.02 97.996 0 54.124-43.897 97.994-98.02 97.994-54.119-.006-97.995-43.874-97.995-97.994.003-54.118 43.878-97.989 97.995-97.995m0 42.683c-30.551.006-55.31 24.761-55.313 55.313 0 30.554 24.76 55.332 55.313 55.338 30.557 0 55.338-24.78 55.338-55.338-.003-30.556-24.782-55.313-55.338-55.313" })
        }
      );
    }
  )
);
var IconPersonMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M240.015 257.549c51.497.001 91.385 13.647 120.791 35.859 29.307 22.137 46.687 51.653 55.166 80.918l.235.879c5.036 18.533-.654 36.022-11.836 48.252-11.032 12.06-27.266 19.07-44.356 19.072h-240c-17.095 0-33.35-7.006-44.385-19.072-11.358-12.423-17.034-30.272-11.572-49.131 8.479-29.262 25.835-58.782 55.137-80.918 29.408-22.214 69.319-35.859 120.82-35.859m0 45c-43.326 0-73.294 11.342-93.691 26.748-20.498 15.483-32.882 36.243-39.053 57.539-.683 2.357-.248 4.239 1.582 6.24 2.157 2.359 6.168 4.453 11.162 4.453h240c4.991-.002 9.007-2.096 11.162-4.453 1.709-1.872 2.206-3.649 1.7-5.801l-.118-.439c-6.17-21.297-18.583-42.055-39.082-57.539-20.396-15.401-50.346-26.747-93.662-26.748m0-260.742c54.124 0 97.998 43.874 97.998 97.998-.007 54.118-43.878 97.998-97.998 97.998-54.118-.002-97.991-43.881-97.998-97.998 0-54.123 43.876-97.996 97.998-97.998m0 45c-29.269.002-52.998 23.728-52.998 52.998.007 29.264 23.733 52.996 52.998 52.998 29.267 0 52.991-23.733 52.998-52.998 0-29.271-23.727-52.998-52.998-52.998" })
        }
      );
    }
  )
);
var IconPersonMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M239.99 255.941c51.773 0 92.001 13.71 121.71 36.151 29.599 22.358 47.137 52.163 55.694 81.693l.255.909c5.184 19.076-.685 37.081-12.181 49.654-11.33 12.391-27.978 19.579-45.478 19.579h-240c-17.501 0-34.15-7.188-45.479-19.579-11.678-12.773-17.55-31.151-11.926-50.563 8.557-29.53 26.095-59.335 55.695-81.693 29.708-22.441 69.936-36.151 121.71-36.151m-92.779 74.452c20.097-15.181 49.721-26.452 92.779-26.452s72.681 11.271 92.778 26.452c20.206 15.262 32.429 35.719 38.522 56.751l.113.437c.218.969.138 1.596.027 2.027-.147.573-.516 1.397-1.387 2.35-1.86 2.035-5.462 3.969-10.053 3.969h-240c-4.592 0-8.194-1.934-10.054-3.969-.871-.953-1.24-1.777-1.387-2.35-.126-.492-.214-1.242.14-2.464 6.094-21.032 18.317-41.489 38.522-56.751M240.001 237.68c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-148c27.615 0 50 22.385 50 50s-22.385 50-50 50-50-22.386-50-50 22.386-50 50-50",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPerson/IconPerson.tsx
var IconPerson = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPersonMonochromeExtralight,
          "monochrome|light": IconPersonMonochromeLight,
          "monochrome|regular": IconPersonMonochromeRegular,
          "monochrome|medium": IconPersonMonochromeMedium,
          "monochrome|semibold": IconPersonMonochromeSemibold,
          "monochrome|bold": IconPersonMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.823 268c13.106.132 25.367 1.188 36.819 3.068l2.442.415.304.058c6.357 1.287 10.564 7.418 9.432 13.843s-7.18 10.748-13.595 9.785l-.306-.05-2.165-.368c-10.166-1.669-21.205-2.632-33.173-2.753l-2.579-.013c-45.237 0-77.512 11.881-100.012 28.876-22.554 17.037-36.105 39.831-42.815 62.988-1.798 6.208-.137 11.817 3.916 16.251 4.228 4.624 11.092 7.871 18.911 7.871h160c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12h-160c-14.273 0-27.66-5.875-36.623-15.677-9.136-9.993-13.605-24.115-9.255-39.125 7.94-27.406 24.15-54.873 51.401-75.458 27.306-20.626 64.882-33.726 114.477-33.726zM417.394 338.337l.31.004c6.484.164 11.69 5.472 11.69 11.996s-5.206 11.832-11.69 11.996l-.31.004h-38v38c0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12v-38h-38c-6.627 0-12-5.373-12-12 0-6.628 5.373-12 12-12h38v-38c0-6.628 5.373-12 12-12 6.628 0 12 5.372 12 12v38z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.013 237.724c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-172c40.869 0 74 33.13 74 74s-33.131 74-74 74-74-33.131-74-74 33.131-74 74-74",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.852 265.02c13.248.133 25.662 1.201 37.274 3.107l2.476.422.381.071c7.947 1.609 13.204 9.273 11.789 17.304s-8.975 13.436-16.993 12.231l-.382-.061-2.13-.364c-10.006-1.642-20.892-2.593-32.718-2.712l-2.549-.013c-44.692 0-76.304 11.729-98.203 28.27-21.967 16.593-35.186 38.803-41.741 61.428-1.48 5.108-.17 9.653 3.249 13.392 3.636 3.976 9.683 6.895 16.695 6.895h160c8.284 0 15 6.716 15 15s-6.716 15-15 15H120c-15.08 0-29.282-6.203-38.836-16.652-9.772-10.688-14.592-25.874-9.924-41.984 8.095-27.937 24.636-55.989 52.475-77.017 27.906-21.079 66.145-34.332 116.285-34.332zM417.393 335.356l.386.005c8.106.205 14.614 6.84 14.614 14.995s-6.508 14.79-14.614 14.996l-.386.004h-35v35c0 8.285-6.716 15-15 15-8.285 0-15-6.715-15-15v-35h-35c-8.285 0-15-6.715-15-15s6.715-15 15-15h35v-35c0-8.284 6.715-15 15-15s15 6.716 15 15v35z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.012 237.743c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-166c37.555 0 68 30.445 68 68s-30.445 68-68 68-68-30.444-68-68 30.444-68 68-68",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.882 262c13.391.135 25.957 1.215 37.73 3.147l2.511.427.456.087c9.536 1.93 15.845 11.126 14.148 20.764-1.699 9.637-10.77 16.123-20.391 14.679l-.459-.076-2.096-.356c-9.845-1.616-20.578-2.556-32.262-2.674l-2.519-.013c-44.147 0-75.096 11.576-96.395 27.664-21.38 16.15-34.267 37.776-40.669 59.87-1.16 4.007-.2 7.488 2.583 10.532 3.044 3.329 8.276 5.92 14.481 5.92h160c9.941 0 18 8.059 18 18s-8.059 18-18 18H120c-15.886 0-30.904-6.531-41.05-17.628-10.407-11.383-15.578-27.633-10.59-44.844 8.248-28.468 25.122-57.105 53.547-78.576 28.507-21.533 67.409-34.938 118.093-34.938zM417.393 332.337l.464.006c9.727.246 17.536 8.208 17.536 17.994s-7.809 17.748-17.536 17.994l-.464.006h-32v32c0 9.941-8.059 18-18 18s-18-8.059-18-18v-32h-32c-9.942 0-18-8.059-18-18s8.058-18 18-18h32v-32c0-9.941 8.058-18 18-18s18 8.059 18 18v32z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.012 237.724c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-160c34.241 0 62 27.758 62 62 0 34.241-27.759 62-62 62s-62-27.759-62-62 27.758-62 62-62",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.908 258.636c14.033.142 27.194 1.308 39.514 3.404l1.271.221.542.102c11.303 2.288 18.781 13.188 16.769 24.611s-12.766 19.111-24.17 17.398l-.543-.089-2.059-.349c-9.666-1.587-20.229-2.514-31.755-2.63l-2.485-.013c-43.541 0-73.754 11.407-94.385 26.99-20.403 15.412-32.851 35.978-39.178 57.128l-.297 1.008c-.807 2.784-.237 5.082 1.84 7.354 2.386 2.609 6.712 4.835 12.02 4.835h160l.551.007c11.528.292 20.784 9.73 20.784 21.328 0 11.599-9.256 21.036-20.784 21.329l-.551.006h-160c-16.783 0-32.708-6.896-43.512-18.713-11.113-12.154-16.674-29.587-11.333-48.021l.402-1.362c8.56-28.61 25.715-57.326 54.34-78.948 29.174-22.037 68.813-35.611 120.103-35.611z" }),
            /* @__PURE__ */ jsx("path", { d: "m417.385 328.973.55.006c11.529.293 20.785 9.73 20.785 21.329s-9.256 21.036-20.785 21.328l-.55.007H388.72v28.665c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335v-28.665h-28.665c-11.783 0-21.335-9.552-21.335-21.335s9.552-21.335 21.335-21.335h28.665v-28.665l.007-.551c.292-11.529 9.729-20.784 21.328-20.784s21.036 9.255 21.328 20.784l.007.551v28.665z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.004 237.694c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-153.33c30.558 0 55.33 24.772 55.33 55.33s-24.772 55.33-55.33 55.33-55.33-24.772-55.33-55.33 24.772-55.33 55.33-55.33",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.927 257.461c14.09.142 27.313 1.313 39.699 3.421l1.277.222.571.108c11.92 2.413 19.807 13.907 17.685 25.954s-13.462 20.154-25.489 18.349l-.574-.094-2.045-.348c-9.604-1.576-20.108-2.498-31.579-2.614l-2.472-.013c-43.33 0-73.285 11.348-93.683 26.755-20.499 15.484-32.888 36.233-39.059 57.53-.682 2.357-.248 4.242 1.582 6.244 2.156 2.358 6.165 4.457 11.16 4.457h160c12.426 0 22.5 10.073 22.5 22.5s-10.074 22.5-22.5 22.5H120c-17.097 0-33.338-7.024-44.371-19.092-11.36-12.425-17.057-30.27-11.592-49.132 8.48-29.265 25.85-58.777 55.157-80.914 29.408-22.214 69.304-35.848 120.806-35.848z" }),
            /* @__PURE__ */ jsx("path", { d: "m417.392 327.798.581.008c12.158.308 21.919 10.26 21.919 22.492s-9.761 22.184-21.919 22.492l-.581.008h-27.5v27.5c0 12.426-10.073 22.5-22.5 22.5s-22.5-10.074-22.5-22.5v-27.5h-27.5c-12.426 0-22.5-10.074-22.5-22.5s10.074-22.5 22.5-22.5h27.5v-27.5c0-12.427 10.074-22.5 22.5-22.5s22.5 10.073 22.5 22.5v27.5z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.011 237.685c-54.123 0-98-43.877-98-98 0-54.124 43.877-98 98-98 54.124 0 98 43.876 98 98 0 54.123-43.876 98-98 98m0-151c29.272 0 53 23.728 53 53s-23.728 53-53 53-53-23.729-53-53 23.729-53 53-53",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPersonBadgePlusMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M242.932 256.073c14.164.143 27.466 1.321 39.935 3.443l1.287.222.608.116c12.715 2.573 21.127 14.834 18.863 27.684s-14.359 21.499-27.188 19.572l-.611-.099-2.028-.345c-9.524-1.563-19.951-2.48-31.35-2.595l-2.458-.012c-43.058 0-72.682 11.27-92.779 26.451-20.205 15.262-32.428 35.719-38.522 56.751-.354 1.222-.266 1.972-.14 2.465.147.572.516 1.396 1.387 2.349 1.86 2.035 5.462 3.969 10.054 3.969h160c13.254 0 24 10.745 24 24s-10.746 24-24 24h-160c-17.501 0-34.15-7.188-45.479-19.579-11.678-12.772-17.55-31.151-11.926-50.563 8.557-29.53 26.095-59.334 55.695-81.693 29.708-22.441 69.936-36.15 121.71-36.15z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M240.001 237.797c-54.124 0-98-43.876-98-98s43.876-98 98-98 98 43.876 98 98-43.876 98-98 98m0-148c27.615 0 50 22.386 50 50s-22.385 50-50 50-50-22.386-50-50 22.386-50 50-50",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "m417.382 326.41.619.008c12.969.328 23.381 10.944 23.381 23.992s-10.412 23.664-23.381 23.992l-.619.008h-26v26c0 13.255-10.745 24-24 24s-24-10.745-24-24v-26h-26c-13.255 0-24-10.745-24-24s10.745-24 24-24h26v-26c0-13.255 10.745-24 24-24s24 10.745 24 24v26z" })
          ]
        }
      );
    }
  )
);

// src/IconPersonBadgePlus/IconPersonBadgePlus.tsx
var IconPersonBadgePlus = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPersonBadgePlusMonochromeExtralight,
          "monochrome|light": IconPersonBadgePlusMonochromeLight,
          "monochrome|regular": IconPersonBadgePlusMonochromeRegular,
          "monochrome|medium": IconPersonBadgePlusMonochromeMedium,
          "monochrome|semibold": IconPersonBadgePlusMonochromeSemibold,
          "monochrome|bold": IconPersonBadgePlusMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPersonFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.323 269.484c48.45.402 85.281 13.413 112.16 33.716 27.251 20.585 43.46 48.052 51.401 75.458l.198.703c4.011 14.748-.46 28.586-9.454 38.422-8.962 9.803-22.349 15.677-36.622 15.677h-240c-14.273 0-27.66-5.874-36.622-15.677-9.136-9.993-13.605-24.114-9.255-39.125l.377-1.284c8.072-26.978 24.198-53.911 51.024-74.174 27.305-20.625 64.882-33.725 114.476-33.725zM338.018 141.213c0 54.124-43.876 98-98 98s-98-43.876-98-98 43.876-98 98-98 98 43.876 98 98" })
        }
      );
    }
  )
);
var IconPersonFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.351 265.029c48.991.407 86.474 13.573 113.944 34.323 27.838 21.028 44.38 49.079 52.474 77.016l.212.755c4.305 15.83-.516 30.709-10.135 41.23-9.555 10.449-23.757 16.652-38.836 16.652h-240c-15.08 0-29.282-6.203-38.836-16.652-9.772-10.688-14.592-25.874-9.924-41.985l.386-1.309c8.228-27.503 24.685-55.008 52.089-75.707 27.906-21.08 66.145-34.332 116.285-34.332zM338.021 139.758c0 54.124-43.876 98-98 98s-98-43.876-98-98 43.876-98 98-98 98 43.876 98 98" })
        }
      );
    }
  )
);
var IconPersonFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.37 262c49.53.411 87.664 13.731 115.725 34.928 28.426 21.471 45.299 50.108 53.548 78.576l.227.807c4.597 16.911-.573 32.832-10.818 44.037-10.146 11.096-25.163 17.628-41.05 17.628h-240c-15.886 0-30.903-6.532-41.05-17.628-10.407-11.383-15.577-27.633-10.59-44.844l.392-1.334c8.386-28.027 25.174-56.106 53.156-77.242 28.507-21.533 67.408-34.938 118.092-34.938zM338.014 139.729c0 54.123-43.876 98-98 98s-98-43.877-98-98c0-54.124 43.876-98 98-98s98 43.876 98 98" })
        }
      );
    }
  )
);
var IconPersonFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.363 258.655c50.131.417 88.989 13.909 117.708 35.602 29.079 21.964 46.322 51.251 54.741 80.309l.243.864c4.923 18.114-.636 35.193-11.576 47.158-10.804 11.816-26.728 18.713-43.511 18.713h-240c-16.784 0-32.708-6.897-43.512-18.713C65.343 410.433 59.782 393 65.123 374.566l.401-1.362c8.56-28.61 25.716-57.326 54.34-78.947 29.175-22.038 68.814-35.611 120.104-35.611zM337.979 139.719c0 54.124-43.876 98-98 98-54.123 0-98-43.876-98-98s43.877-98 98-98c54.124 0 98 43.876 98 98" })
        }
      );
    }
  )
);
var IconPersonFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.261 257.471c50.34.418 89.452 13.97 118.4 35.837 29.307 22.136 46.678 51.65 55.157 80.915l.249.882c5.037 18.535-.658 36.019-11.84 48.25-11.034 12.067-27.275 19.091-44.371 19.091h-240c-17.097 0-33.338-7.024-44.371-19.091-11.36-12.425-17.057-30.271-11.592-49.132l.403-1.372c8.621-28.814 25.906-57.751 54.754-79.542 29.408-22.214 69.304-35.848 120.806-35.848zM337.867 139.699c0 54.124-43.876 98-98 98s-98-43.876-98-98 43.876-98 98-98 98 43.876 98 98" })
        }
      );
    }
  )
);
var IconPersonFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M242.388 255.99c50.61.421 90.048 14.051 119.292 36.141 29.6 22.358 47.138 52.163 55.694 81.693l.255.909c5.185 19.076-.685 37.081-12.18 49.654-11.33 12.391-27.979 19.579-45.479 19.579h-240c-17.5 0-34.149-7.188-45.478-19.579-11.678-12.773-17.55-31.151-11.926-50.563l.408-1.384c8.7-29.075 26.149-58.3 55.286-80.309 29.709-22.441 69.936-36.15 121.71-36.151zM337.982 139.719c0 54.124-43.876 98-98 98s-98-43.876-98-98 43.876-98 98-98 98 43.876 98 98" })
        }
      );
    }
  )
);

// src/IconPersonFilled/IconPersonFilled.tsx
var IconPersonFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPersonFilledMonochromeExtralight,
          "monochrome|light": IconPersonFilledMonochromeLight,
          "monochrome|regular": IconPersonFilledMonochromeRegular,
          "monochrome|medium": IconPersonFilledMonochromeMedium,
          "monochrome|semibold": IconPersonFilledMonochromeSemibold,
          "monochrome|bold": IconPersonFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPhoneMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.666 10.898c-.324.324-.515.581-.609.825-.656 1.718-.22 4.401 1.53 7.793 1.715 3.325 4.557 7.065 8.213 10.72 4.772 4.772 9.311 7.445 12.816 8.756 1.757.657 3.23.963 4.329 1.033.55.035.98.009 1.292-.049.155-.028.268-.062.347-.093.08-.032.107-.055.104-.052.814-.653 1.822-1.659 2.653-2.532a62 62 0 0 0 1.315-1.428l.078-.088.02-.023.005-.006.026-.03.028-.028c.137-.136.318-.418.36-.726.033-.237.005-.59-.446-1.04l-5.324-5.324a1.7 1.7 0 0 0-.82-.44c-.254-.048-.566-.027-.947.354l-2.532 2.533c-.29.29-.728.58-1.353.669-.598.085-1.257-.03-1.984-.329-1.422-.584-3.394-1.997-6.26-4.863-3.728-3.728-4.776-6.19-4.946-7.707-.133-1.19.598-2.066 1.076-2.543l1.88-1.88c.136-.137.317-.419.36-.726.033-.237.004-.59-.447-1.04L14.106 7.31a1.8 1.8 0 0 0-.423-.301 1.3 1.3 0 0 0-.54-.157.84.84 0 0 0-.353.058c-.12.047-.273.137-.45.313zM42.54 37.363l-.007.008-.084.095c-.073.082-.178.2-.31.345-.263.29-.633.693-1.059 1.141-.84.884-1.942 1.99-2.889 2.75-.434.349-.982.536-1.519.635-.553.102-1.188.127-1.88.083-1.383-.088-3.09-.46-5.016-1.18-3.86-1.443-8.684-4.317-13.673-9.307-3.777-3.777-6.79-7.713-8.65-11.317-1.823-3.535-2.677-7.03-1.637-9.75.274-.717.75-1.262 1.153-1.666l3.674-3.674c.799-.798 1.72-1.111 2.606-1.072 1.149.052 2.074.678 2.554 1.159l5.325 5.324c.969.969 1.265 2.066 1.126 3.066a3.78 3.78 0 0 1-1.04 2.094l-1.88 1.88a1.9 1.9 0 0 0-.34.426c-.053.1-.049.14-.047.154.08.727.688 2.708 4.256 6.276 2.813 2.812 4.51 3.943 5.477 4.34.468.193.684.18.733.173l.004-.001 2.522-2.522c.97-.97 2.095-1.202 3.086-1.017.915.171 1.651.68 2.075 1.103l5.324 5.324c.969.97 1.265 2.067 1.127 3.066a3.8 3.8 0 0 1-1.01 2.064",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.919 7.407c-.21.209-.313.357-.36.48-.407 1.062-.15 2.783 1.01 5.032 1.131 2.193 3.012 4.67 5.44 7.097 3.162 3.163 6.165 4.929 8.472 5.792 1.157.432 2.12.63 2.828.676.355.022.625.005.813-.03.156-.028.216-.062.221-.063.53-.427 1.19-1.085 1.74-1.663a41 41 0 0 0 .871-.947l.052-.058.013-.015.025-.028.023-.024a.72.72 0 0 0 .184-.37.4.4 0 0 0-.02-.201.9.9 0 0 0-.221-.323l-3.55-3.55a.94.94 0 0 0-.44-.238.4.4 0 0 0-.192.006.64.64 0 0 0-.262.175l-1.689 1.688a1.76 1.76 0 0 1-1.015.503c-.444.063-.92-.024-1.426-.232-.987-.405-2.324-1.37-4.24-3.286-2.498-2.498-3.233-4.18-3.354-5.257-.1-.89.449-1.533.774-1.86L12.87 9.46a.72.72 0 0 0 .183-.37.4.4 0 0 0-.019-.202.9.9 0 0 0-.222-.323l-3.55-3.55a1 1 0 0 0-.231-.163.7.7 0 0 0-.278-.083.4.4 0 0 0-.153.025.7.7 0 0 0-.232.164zm22.588 17.638-.002.001-.056.064a37 37 0 0 1-.917.996c-.561.59-1.303 1.335-1.946 1.851-.325.261-.726.395-1.102.464-.389.072-.83.089-1.302.059-.945-.06-2.104-.314-3.401-.8-2.602-.972-5.843-2.905-9.187-6.25-2.528-2.528-4.551-5.168-5.802-7.594C3.57 11.467 2.965 9.069 3.69 7.173c.198-.518.539-.905.815-1.18l2.449-2.45c.572-.572 1.24-.802 1.888-.773.83.037 1.492.488 1.835.83l3.55 3.55c.689.689.908 1.483.807 2.213a2.7 2.7 0 0 1-.75 1.51l-1.253 1.253a1 1 0 0 0-.198.249c.059.443.458 1.72 2.778 4.039 1.87 1.87 2.978 2.6 3.585 2.85.169.07.276.092.333.1l1.623-1.623c.695-.696 1.513-.868 2.235-.733a2.94 2.94 0 0 1 1.488.79l3.55 3.55c.688.689.908 1.482.807 2.212a2.7 2.7 0 0 1-.725 1.485",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.545 5.661c-.152.152-.212.245-.236.308-.28.734-.114 1.974.751 3.652.84 1.627 2.24 3.473 4.052 5.285 2.359 2.359 4.593 3.67 6.301 4.31.857.32 1.565.465 2.078.497.258.017.447.003.573-.02a1 1 0 0 0 .115-.03c.386-.313.868-.793 1.274-1.22a31 31 0 0 0 .65-.707l.039-.043.01-.01.021-.026.021-.02a.4.4 0 0 0 .056-.08.3.3 0 0 0 .04-.113.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185l-2.663-2.662a.56.56 0 0 0-.252-.137.15.15 0 0 0-.073 0 .33.33 0 0 0-.134.094l-1.266 1.267a1.47 1.47 0 0 1-.846.419c-.368.052-.753-.021-1.148-.184-.768-.315-1.789-1.057-3.229-2.497-1.883-1.883-2.463-3.174-2.558-4.032-.083-.74.373-1.267.623-1.517l.94-.94a.4.4 0 0 0 .056-.08.4.4 0 0 0 .04-.112.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185L6.84 3.867a.6.6 0 0 0-.136-.095.4.4 0 0 0-.147-.046.1.1 0 0 0-.053.009.4.4 0 0 0-.123.09zm16.946 13.224-.042.047q-.056.064-.157.175c-.133.147-.32.35-.534.576-.422.443-.984 1.009-1.474 1.402-.27.217-.599.324-.893.379-.307.056-.65.069-1.014.046-.727-.047-1.61-.24-2.594-.609-1.974-.738-4.422-2.2-6.944-4.722-1.903-1.904-3.431-3.897-4.379-5.733-.92-1.786-1.4-3.635-.832-5.12.16-.418.433-.726.644-.938L5.11 2.551c.458-.458 1-.647 1.529-.623.672.03 1.202.392 1.476.666l2.662 2.662c.55.55.73 1.192.648 1.787a2.2 2.2 0 0 1-.605 1.218l-.94.94a1 1 0 0 0-.097.11c.062.335.392 1.254 2.032 2.893 1.4 1.4 2.213 1.93 2.64 2.106q.09.036.144.05l1.16-1.16c.559-.56 1.222-.701 1.81-.591.53.099.95.39 1.194.633l2.662 2.663c.55.549.73 1.19.649 1.786a2.2 2.2 0 0 1-.582 1.194",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.497 4.334a.6.6 0 0 0-.149.187c-.19.498-.087 1.386.558 2.637.622 1.206 1.663 2.58 3.016 3.933 1.758 1.758 3.419 2.731 4.682 3.203.634.237 1.152.343 1.522.366.186.012.318.002.4-.013l.047-.01c.28-.23.628-.578.926-.891a23 23 0 0 0 .485-.527l.029-.032.007-.008.001-.002.018-.02.018-.018a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09l-1.997-1.997a.3.3 0 0 0-.123-.069.3.3 0 0 0-.044.037l-.95.949a1.23 1.23 0 0 1-.705.35c-.304.044-.616-.018-.926-.146-.6-.246-1.38-.817-2.463-1.9-1.42-1.42-1.878-2.414-1.954-3.098-.07-.617.311-1.048.503-1.24l.705-.705a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09L5.042 2.988l-.024-.02a.4.4 0 0 0-.046-.029.2.2 0 0 0-.053-.02l-.005.003a.3.3 0 0 0-.039.033zm9.415 6.569h-.002zm3.298 3.346-.03.033q-.042.049-.119.132c-.1.11-.24.264-.402.434-.317.333-.744.762-1.118 1.063a1.6 1.6 0 0 1-.726.31c-.242.044-.51.054-.79.036-.56-.036-1.235-.185-1.982-.464-1.498-.56-3.35-1.668-5.252-3.57-1.434-1.434-2.589-2.94-3.307-4.331-.695-1.347-1.076-2.776-.63-3.942.129-.338.349-.584.512-.747l1.378-1.378c.367-.368.807-.523 1.24-.504.545.024.97.317 1.19.536L8.17 3.854c.44.439.59.96.522 1.445-.06.439-.288.783-.49.985l-.704.705-.027.027c.067.261.346.917 1.478 2.049 1.047 1.047 1.643 1.43 1.939 1.552l.026.01.816-.816c.45-.45.99-.567 1.468-.477.429.08.766.314.962.51l1.996 1.996c.44.439.59.96.522 1.445-.059.424-.272.76-.468.964",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.08 4.017a.2.2 0 0 0-.02.033c-.156.406-.08 1.165.491 2.272.548 1.061 1.467 2.275 2.665 3.474 1.555 1.554 3.02 2.412 4.13 2.827.557.208 1.01.299 1.328.32a1.4 1.4 0 0 0 .35-.015c.241-.2.54-.498.8-.77a21 21 0 0 0 .43-.467l.024-.028.006-.007.002-.002.017-.02.014-.014-.024-.027-1.774-1.775-.009-.007-.022-.014-.837.836a1.2 1.2 0 0 1-.678.337c-.29.041-.584-.019-.87-.136-.55-.226-1.252-.744-2.217-1.708-1.269-1.27-1.692-2.17-1.763-2.807-.066-.591.3-1.002.473-1.175l.623-.623-.025-.027L4.42 2.72l-.012-.01-.019-.012-1.217 1.217a1 1 0 0 0-.092.102m11.394 8.709-.025.028-.106.118c-.09.099-.215.235-.36.387-.281.297-.664.682-1.002.953-.216.174-.47.254-.684.293a3 3 0 0 1-.725.034c-.508-.032-1.117-.167-1.787-.418-1.345-.503-3-1.495-4.7-3.194-1.28-1.28-2.312-2.624-2.956-3.872-.62-1.202-.974-2.503-.564-3.576.122-.318.327-.547.475-.695l1.225-1.225c.344-.344.76-.492 1.17-.474.513.023.91.297 1.116.503l1.774 1.774c.41.41.553.9.49 1.36-.058.413-.27.736-.46.926l-.614.613c.075.241.342.8 1.276 1.734.891.89 1.406 1.23 1.664 1.346l.683-.683c.421-.422.931-.534 1.384-.45.403.076.718.295.902.479l1.774 1.774c.41.41.553.9.49 1.36a1.66 1.66 0 0 1-.44.905",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.31 3.013q-.017.025-.015.025c-.117.304-.06.874.368 1.704.411.796 1.1 1.706 2 2.605 1.165 1.166 2.264 1.809 3.096 2.12.418.156.757.225.996.24a1 1 0 0 0 .263-.01c.181-.15.406-.374.6-.579a15 15 0 0 0 .322-.35l.019-.02.004-.006.001-.001.013-.015.011-.01-.018-.021-1.331-1.33-.006-.006-.017-.011-.627.627c-.272.271-.616.219-.787.166a2 2 0 0 1-.538-.29c-.364-.26-.874-.712-1.588-1.427-.555-.554-.851-1.058-.94-1.526-.094-.493.057-.87.234-1.109.028-.038.081-.104.112-.143l.023-.029a.5.5 0 0 0 .047-.067l.044-.09.068-.069-.018-.02L3.315 2.04l-.009-.007-.014-.01-.913.914a1 1 0 0 0-.069.076m8.546 6.532-.02.021a20 20 0 0 1-.348.379 8 8 0 0 1-.752.715c-.162.13-.353.19-.514.22a2.2 2.2 0 0 1-.543.025 4.8 4.8 0 0 1-1.34-.314c-1.009-.377-2.25-1.12-3.525-2.395-.96-.96-1.734-1.968-2.217-2.904-.465-.902-.731-1.877-.423-2.682.09-.239.245-.41.356-.522l.919-.918c.258-.258.57-.37.877-.356.385.017.683.223.837.377l1.331 1.331c.307.307.415.675.367 1.02-.036.26-.154.472-.275.618a2 2 0 0 1-.132.191c-.035.046-.054.07-.07.088l-.05.065c-.009.012-.041.055-.02.17.028.142.148.44.61.902.706.705 1.157 1.098 1.435 1.296l.021.015.393-.393c.316-.316.699-.4 1.038-.337.302.056.538.22.676.358l1.331 1.331c.307.307.415.675.367 1.02-.041.298-.191.534-.33.679",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPhone/IconPhone.tsx
var IconPhone = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPhoneMonochromeExtralight,
          "monochrome|light": IconPhoneMonochromeLight,
          "monochrome|regular": IconPhoneMonochromeRegular,
          "monochrome|medium": IconPhoneMonochromeMedium,
          "monochrome|semibold": IconPhoneMonochromeSemibold,
          "monochrome|bold": IconPhoneMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m11.138 6.022-4.267 4.267-.033.056c-1.38 2.362-.817 5.735.949 9.373 1.783 3.674 4.865 7.774 8.811 11.72 4.926 4.927 9.667 7.742 13.423 9.147 1.876.701 3.516 1.054 4.816 1.137.65.041 1.225.015 1.708-.074.477-.087.899-.243 1.208-.492.908-.729 1.983-1.805 2.82-2.686A64 64 0 0 0 41.926 37l.082-.092.02-.022c.338-.343.727-.944.83-1.683.107-.777-.111-1.657-.929-2.475l-5.324-5.324a3.4 3.4 0 0 0-1.709-.91c-.776-.144-1.663.026-2.462.824l-2.532 2.533a.65.65 0 0 1-.39.188c-.21.03-.555.006-1.098-.218-1.1-.452-2.877-1.665-5.705-4.493-2.81-2.81-3.883-4.72-4.27-5.884-.193-.578-.215-.969-.2-1.194q.011-.134.028-.196l2.452-2.452c.341-.341.738-.948.842-1.695.108-.777-.11-1.657-.928-2.475l-5.324-5.324c-.401-.401-1.171-.913-2.09-.954-.688-.03-1.418.205-2.08.868" })
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.426 4.014 4.58 6.86l-.022.037c-.92 1.575-.545 3.824.632 6.25 1.189 2.448 3.243 5.182 5.875 7.813 3.283 3.284 6.444 5.16 8.948 6.097 1.251.468 2.344.703 3.21.758.434.028.818.01 1.14-.049.317-.058.599-.162.805-.328.605-.486 1.322-1.203 1.88-1.79a42 42 0 0 0 .902-.98l.055-.062.012-.014c.226-.23.485-.63.554-1.122.071-.518-.074-1.105-.62-1.65l-3.549-3.55a2.27 2.27 0 0 0-1.139-.606c-.517-.097-1.109.017-1.64.549l-1.69 1.688a.43.43 0 0 1-.26.126c-.139.02-.369.004-.731-.145-.734-.302-1.918-1.11-3.804-2.996-1.873-1.873-2.588-3.147-2.846-3.922-.129-.386-.143-.646-.133-.796a1 1 0 0 1 .018-.131l1.635-1.635c.227-.227.492-.632.561-1.13.072-.518-.074-1.105-.619-1.65l-3.55-3.55c-.266-.267-.78-.608-1.393-.635-.458-.02-.945.137-1.386.578",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.569 3.01 3.435 5.145l-.016.028c-.69 1.182-.408 2.868.474 4.687.892 1.837 2.433 3.887 4.406 5.86 2.463 2.463 4.834 3.871 6.712 4.573.938.351 1.758.528 2.408.569q.49.03.854-.037c.238-.044.449-.122.604-.246.453-.364.99-.902 1.41-1.343a32 32 0 0 0 .676-.735l.041-.046.01-.01a1.54 1.54 0 0 0 .415-.842c.053-.389-.056-.829-.464-1.238l-2.663-2.662a1.7 1.7 0 0 0-.854-.455c-.388-.072-.832.013-1.23.412l-1.267 1.266a.33.33 0 0 1-.195.094c-.105.015-.277.003-.55-.108-.55-.226-1.438-.833-2.852-2.247-1.405-1.405-1.941-2.36-2.135-2.942-.096-.29-.107-.484-.1-.597a1 1 0 0 1 .014-.098l1.226-1.226c.171-.17.37-.474.421-.848.054-.388-.055-.828-.464-1.237L7.654 3.054c-.2-.2-.585-.457-1.045-.477-.343-.015-.709.103-1.04.434" })
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m4.177 2.258-1.6 1.6-.013.021c-.517.886-.306 2.151.356 3.515.669 1.378 1.824 2.915 3.304 4.395 1.847 1.848 3.625 2.903 5.034 3.43.704.263 1.318.396 1.806.427.244.015.46.005.64-.028s.337-.091.453-.184c.34-.274.744-.677 1.058-1.008a24 24 0 0 0 .507-.55l.031-.036.007-.008c.127-.129.273-.354.312-.63.04-.292-.042-.622-.349-.93l-1.996-1.996a1.28 1.28 0 0 0-.64-.34c-.292-.055-.625.009-.924.308l-.95.95a.24.24 0 0 1-.146.07c-.079.012-.208.003-.412-.081-.412-.17-1.079-.624-2.14-1.685-1.053-1.054-1.455-1.77-1.6-2.207a1.2 1.2 0 0 1-.075-.447 1 1 0 0 1 .01-.074l.92-.92c.128-.127.277-.355.315-.635.04-.291-.041-.622-.348-.928L5.741 2.29a1.24 1.24 0 0 0-.784-.357c-.258-.012-.532.077-.78.325",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.713 2.007 2.29 3.43l-.01.018c-.46.788-.273 1.912.316 3.125.594 1.224 1.621 2.591 2.937 3.907 1.642 1.642 3.222 2.58 4.474 3.048.625.234 1.172.352 1.605.38q.327.02.57-.025c.159-.03.3-.081.402-.164.303-.243.661-.602.94-.896.14-.147.263-.28.35-.376l.101-.113.028-.031.006-.007c.113-.115.243-.315.277-.561.036-.26-.037-.553-.31-.825l-1.774-1.775a1.14 1.14 0 0 0-.57-.303c-.259-.049-.554.008-.82.274l-.845.844a.22.22 0 0 1-.13.063c-.07.01-.185.002-.366-.072-.366-.151-.959-.555-1.901-1.498-.937-.937-1.295-1.574-1.424-1.962a1.1 1.1 0 0 1-.066-.397.4.4 0 0 1 .009-.066l.817-.817c.114-.114.246-.316.281-.565.036-.26-.037-.553-.31-.825L5.104 2.036a1.1 1.1 0 0 0-.697-.318.9.9 0 0 0-.693.29",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPhoneFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.785 1.505 1.718 2.572l-.008.014c-.345.59-.205 1.434.237 2.343.445.919 1.216 1.944 2.202 2.93 1.232 1.232 2.417 1.936 3.356 2.287.47.175.88.263 1.204.284q.246.015.427-.018a.7.7 0 0 0 .302-.123c.227-.182.496-.451.705-.672a16 16 0 0 0 .338-.367l.021-.023.005-.006a.77.77 0 0 0 .207-.42c.027-.195-.027-.415-.232-.62l-1.33-1.33a.85.85 0 0 0-.428-.228.67.67 0 0 0-.615.206l-.634.633a.16.16 0 0 1-.097.047.54.54 0 0 1-.275-.054c-.275-.113-.719-.416-1.426-1.123-.702-.703-.97-1.18-1.067-1.471a.8.8 0 0 1-.05-.299.3.3 0 0 1 .007-.049L5.18 3.9a.77.77 0 0 0 .21-.424c.027-.194-.027-.414-.232-.618l-1.33-1.331a.83.83 0 0 0-.523-.239.68.68 0 0 0-.52.217",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPhoneFilled/IconPhoneFilled.tsx
var IconPhoneFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPhoneFilledMonochromeExtralight,
          "monochrome|light": IconPhoneFilledMonochromeLight,
          "monochrome|regular": IconPhoneFilledMonochromeRegular,
          "monochrome|medium": IconPhoneFilledMonochromeMedium,
          "monochrome|semibold": IconPhoneFilledMonochromeSemibold,
          "monochrome|bold": IconPhoneFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPhotoMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M37 8.4H11A2.6 2.6 0 0 0 8.4 11v26a2.6 2.6 0 0 0 2.6 2.6h26a2.6 2.6 0 0 0 2.6-2.6V11A2.6 2.6 0 0 0 37 8.4M11 6a5 5 0 0 0-5 5v26a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.152 19.152a1.2 1.2 0 0 1 1.697 0l10.28 10.28 6.174-4.408a1.2 1.2 0 0 1 1.546.127l6.5 6.5a1.2 1.2 0 1 1-1.697 1.698l-5.782-5.782-6.172 4.41a1.2 1.2 0 0 1-1.547-.128L16 21.697 8.349 29.35A1.2 1.2 0 1 1 6.65 27.65zM28.5 18.6a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2m0 2.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPhotoMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 6H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M8 4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.28 12.62a1 1 0 0 1 1.4 0l6.31 6.187 3.71-2.6a1 1 0 0 1 1.275.105l4.392 4.307a1 1 0 0 1-1.4 1.428l-3.8-3.726-3.711 2.6a1 1 0 0 1-1.274-.104l-6.202-6.083-4.947 4.852a1 1 0 1 1-1.4-1.428zM19 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPhotoMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18 4.8H6A1.2 1.2 0 0 0 4.8 6v12A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V6A1.2 1.2 0 0 0 18 4.8M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.605 9.357a.9.9 0 0 1 1.26 0l4.643 4.554 2.682-1.879a.9.9 0 0 1 1.146.095l3.294 3.23a.9.9 0 1 1-1.26 1.285l-2.76-2.706-2.682 1.878a.9.9 0 0 1-1.146-.095l-4.547-4.458-3.605 3.535a.9.9 0 0 1-1.26-1.285zM14.25 8.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.7a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPhotoMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13.25 3.85h-8.5a.9.9 0 0 0-.9.9v8.5a.9.9 0 0 0 .9.9h8.5a.9.9 0 0 0 .9-.9v-8.5a.9.9 0 0 0-.9-.9m-8.5-1.6a2.5 2.5 0 0 0-2.5 2.5v8.5a2.5 2.5 0 0 0 2.5 2.5h8.5a2.5 2.5 0 0 0 2.5-2.5v-8.5a2.5 2.5 0 0 0-2.5-2.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.434 6.934a.8.8 0 0 1 1.13-.002l3.559 3.535 1.915-1.49a.8.8 0 0 1 1.11.124l2.203 2.692a.8.8 0 0 1-1.239 1.014l-1.707-2.088-1.855 1.443a.8.8 0 0 1-1.055-.064L6.002 8.63l-2.236 2.237a.8.8 0 0 1-1.132-1.132zM10.688 6.575a.388.388 0 1 0 0-.775.388.388 0 0 0 0 .775m0 1.3a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPhotoMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.5 3.5h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.647 6.25c.205 0 .4.084.542.232l2.777 2.904 1.526-1.14a.75.75 0 0 1 .991.082l2.06 2.154a.75.75 0 1 1-1.085 1.036l-1.6-1.673-1.527 1.14a.75.75 0 0 1-.99-.082L5.646 8.085l-2.105 2.202a.75.75 0 0 1-1.084-1.036l2.647-2.77a.75.75 0 0 1 .542-.231M9.5 5.8a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPhotoMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.5 3.5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm2-.8h5a.8.8 0 0 1 .8.8v2.973l-.527-.517a.6.6 0 0 0-.764-.063l-1.239.868-2.232-2.19a.6.6 0 0 0-.84 0L2.7 5.55V3.5a.8.8 0 0 1 .8-.8m-.8 4.527V8.5a.8.8 0 0 0 .8.8h5a.8.8 0 0 0 .8-.8v-.365a.6.6 0 0 1-.099-.078l-.912-.895-1.239.868a.6.6 0 0 1-.764-.063L4.118 5.84 2.743 7.19z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M8 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" })
          ]
        }
      );
    }
  )
);

// src/IconPhoto/IconPhoto.tsx
var IconPhoto = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPhotoMonochromeExtralight,
          "monochrome|light": IconPhotoMonochromeLight,
          "monochrome|regular": IconPhotoMonochromeRegular,
          "monochrome|medium": IconPhotoMonochromeMedium,
          "monochrome|semibold": IconPhotoMonochromeSemibold,
          "monochrome|bold": IconPhotoMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPinMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.4 21.6v-6H5.512a1.2 1.2 0 0 1-1.053-1.775l.19-.328a7.93 7.93 0 0 1 3.874-3.25l.357-3.87c-1.368-.783-2.21-1.953-2.617-2.642l-.16-.283c-.298-.563.146-1.152.7-1.152h10.385c.527 0 .953.534.74 1.066l-.052.105c-.334.586-1.221 1.938-2.763 2.837l.367 3.974c1.67.67 3.099 1.889 4.02 3.504l.073.154a1.214 1.214 0 0 1-1.128 1.66H12.6v6a.6.6 0 1 1-1.2 0m.017-10.7c-.647 0-1.28.092-1.884.268l-.257.082a6.73 6.73 0 0 0-3.603 2.872l-.161.278h12.937l.002-.001q.002 0 .005-.006l.003-.007-.003-.006a6.9 6.9 0 0 0-3.445-2.994l-.29-.107a6.9 6.9 0 0 0-2.254-.38zM7.538 3.5c.438.637 1.17 1.48 2.238 1.997l.374.18-.388 4.198a8 8 0 0 1 1.655-.175h1.05a8 8 0 0 1 1.772.197l-.395-4.278.367-.184c1.038-.52 1.767-1.32 2.215-1.935z" })
        }
      );
    }
  )
);
var IconPinMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#000",
              d: "M11.25 21.6v-5.85H5.512a1.35 1.35 0 0 1-1.185-1.998l.194-.334a8.08 8.08 0 0 1 3.86-3.275l.34-3.685c-1.349-.8-2.181-1.96-2.588-2.648l-.162-.287c-.358-.672.175-1.373.833-1.373h10.384l.123.008c.566.076.994.67.756 1.261l-.061.126c-.333.585-1.211 1.925-2.735 2.843l.35 3.79a8.24 8.24 0 0 1 4.008 3.533l.084.173a1.364 1.364 0 0 1-1.269 1.865H12.75V21.6a.75.75 0 0 1-1.5 0m.167-10.55c-.633 0-1.252.09-1.842.263l-.25.078a6.58 6.58 0 0 0-3.552 2.858h12.43a6.74 6.74 0 0 0-3.248-2.723l-.283-.106a6.7 6.7 0 0 0-2.205-.37zM7.83 3.65c.438.583 1.1 1.269 2.013 1.71l.468.227-.38 4.102q.73-.137 1.487-.139h1.05q.819.002 1.604.159l-.385-4.178.458-.23c.882-.442 1.538-1.093 1.982-1.651z"
            }
          )
        }
      );
    }
  )
);
var IconPinMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M11.1 21.6v-5.7H5.512a1.5 1.5 0 0 1-1.316-2.22l.197-.34A8.23 8.23 0 0 1 8.24 10.04l.324-3.501c-1.332-.816-2.155-1.966-2.561-2.652l-.164-.293C5.424 2.813 6.044 2 6.804 2h10.384c.723 0 1.316.736 1.02 1.473l-.071.147c-.333.584-1.203 1.912-2.71 2.847l.335 3.609a8.4 8.4 0 0 1 3.998 3.561l.093.193c.389.968-.32 2.07-1.409 2.07H12.9v5.7a.9.9 0 0 1-1.8 0m.317-10.4c-.618 0-1.223.088-1.8.257l-.245.077A6.43 6.43 0 0 0 6.043 14.1h11.884a6.6 6.6 0 0 0-3.027-2.435l-.277-.103a6.6 6.6 0 0 0-2.156-.362zm-3.28-7.4c.421.509 1.007 1.056 1.77 1.426l.56.273-.056.62-.313 3.387q.649-.105 1.319-.106h1.05q.73 0 1.436.124l-.377-4.082.55-.276c.733-.366 1.304-.884 1.726-1.366z" })
        }
      );
    }
  )
);
var IconPinMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.934 21.6v-5.533H5.512A1.667 1.667 0 0 1 4.05 13.6l.2-.347a8.4 8.4 0 0 1 3.834-3.33l.304-3.296c-1.312-.832-2.124-1.974-2.529-2.658l-.168-.297c-.48-.902.238-1.838 1.113-1.838h10.384c.83 0 1.518.848 1.176 1.699l-.083.17c-.332.583-1.19 1.9-2.677 2.853l.315 3.405a8.56 8.56 0 0 1 3.985 3.594l.056.106a1.68 1.68 0 0 1-1.516 2.406h-5.378V21.6a1.066 1.066 0 1 1-2.132 0m.483-10.233a6.3 6.3 0 0 0-1.753.25l-.24.075a6.27 6.27 0 0 0-3.062 2.241h11.242a6.43 6.43 0 0 0-2.766-2.113l-.27-.1a6.4 6.4 0 0 0-2.101-.353zm-2.912-7.4c.382.409.87.818 1.474 1.11l.666.321-.068.737-.295 3.176q.56-.076 1.135-.078h1.05q.634.001 1.25.094l-.367-3.983.652-.326a5.4 5.4 0 0 0 1.423-1.051z" })
        }
      );
    }
  )
);
var IconPinMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.875 21.6v-5.475H5.512a1.725 1.725 0 0 1-1.513-2.553l.202-.35a8.45 8.45 0 0 1 3.827-3.338l.3-3.226c-1.306-.837-2.115-1.976-2.52-2.66l-.167-.3c-.503-.943.249-1.923 1.163-1.923h10.384c.87 0 1.588.887 1.23 1.778l-.086.178c-.331.582-1.186 1.896-2.666 2.854l.309 3.336a8.6 8.6 0 0 1 3.98 3.605l.058.11a1.74 1.74 0 0 1-1.569 2.489h-5.319V21.6a1.125 1.125 0 0 1-2.25 0m.542-10.175a6.2 6.2 0 0 0-1.737.247l-.236.075a6.2 6.2 0 0 0-2.966 2.127h11.009a6.37 6.37 0 0 0-2.67-2l-.267-.1a6.4 6.4 0 0 0-2.083-.349zm-2.773-7.4c.362.37.814.734 1.361.999l.702.34-.36 3.879q.53-.068 1.07-.068h1.05q.6.002 1.185.083l-.292-3.183-.072-.765.688-.345c.516-.258.95-.595 1.306-.94z" })
        }
      );
    }
  )
);
var IconPinMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.8 21.6v-5.4H5.512a1.8 1.8 0 0 1-1.58-2.663l.205-.354a8.53 8.53 0 0 1 3.821-3.351l.29-3.137c-1.296-.843-2.1-1.976-2.504-2.658l-.17-.303c-.531-.999.264-2.034 1.23-2.034h10.384c.918 0 1.679.938 1.3 1.88l-.09.188c-.332.582-1.183 1.889-2.654 2.855l.3 3.248a8.7 8.7 0 0 1 3.977 3.618l.06.114c.573 1.187-.289 2.597-1.637 2.597H13.2v5.4a1.2 1.2 0 0 1-2.4 0m.617-10.1c-.59 0-1.166.084-1.716.245l-.234.073A6.13 6.13 0 0 0 6.632 13.8H17.33a6.3 6.3 0 0 0-2.54-1.856l-.265-.098a6.3 6.3 0 0 0-2.058-.347zM8.825 4.1c.334.32.738.626 1.213.857l.748.362-.355 3.839q.488-.058.986-.058h1.05q.558 0 1.102.07l-.36-3.904.732-.367a5.1 5.1 0 0 0 1.15-.799z" })
        }
      );
    }
  )
);

// src/IconPin/IconPin.tsx
var IconPin = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconPinMonochromeExtralight,
        "monochrome|light": IconPinMonochromeLight,
        "monochrome|regular": IconPinMonochromeRegular,
        "monochrome|medium": IconPinMonochromeMedium,
        "monochrome|semibold": IconPinMonochromeSemibold,
        "monochrome|bold": IconPinMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconPlayAppWindowMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM84 167v177c0 28.719 23.281 52 52 52h208c28.719 0 52-23.281 52-52V167zm52-83c-28.719 0-52 23.281-52 52v7h312v-7c0-28.719-23.281-52-52-52z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlayAppWindowMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM90 170v174c0 25.405 20.595 46 46 46h208c25.405 0 46-20.595 46-46V170zm46-80c-25.405 0-46 20.595-46 46v4h300v-4c0-25.405-20.595-46-46-46z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlayAppWindowMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM96 173v171c0 22.091 17.909 40 40 40h208c22.091 0 40-17.909 40-40V173zm40-77c-22.091 0-40 17.909-40 40v1h288v-1c0-22.091-17.909-40-40-40z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlayAppWindowMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM102.67 176.335V344c0 18.408 14.922 33.33 33.33 33.33h208c18.408 0 33.33-14.922 33.33-33.33V176.335zM136 102.67c-17.623 0-32.048 13.677-33.247 30.995h274.494c-1.199-17.318-15.624-30.995-33.247-30.995z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlayAppWindowMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM105 177.5V344c0 17.121 13.879 31 31 31h208c17.121 0 31-13.879 31-31V177.5zm31-72.5c-15.937 0-29.063 12.027-30.802 27.5h269.604C373.063 117.027 359.937 105 344 105z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlayAppWindowMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M190 222.66c0-14.211 15.385-23.094 27.692-15.988l83.078 47.965c12.307 7.106 12.307 24.87 0 31.976l-83.078 47.965C205.385 341.684 190 332.801 190 318.59z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M344.982 60.006C386.503 60.532 420 94.354 420 136v208l-.006.982c-.522 41.194-33.818 74.49-75.012 75.012L344 420H136c-41.646 0-75.468-33.497-75.994-75.018L60 344V136c0-41.974 34.026-76 76-76h208zM108 179v165c0 15.464 12.536 28 28 28h208c15.464 0 28-12.536 28-28V179zm28-71c-13.757 0-25.196 9.922-27.554 23h263.108c-2.358-13.078-13.797-23-27.554-23z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconPlayAppWindow/IconPlayAppWindow.tsx
var IconPlayAppWindow = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlayAppWindowMonochromeExtralight,
          "monochrome|light": IconPlayAppWindowMonochromeLight,
          "monochrome|regular": IconPlayAppWindowMonochromeRegular,
          "monochrome|medium": IconPlayAppWindowMonochromeMedium,
          "monochrome|semibold": IconPlayAppWindowMonochromeSemibold,
          "monochrome|bold": IconPlayAppWindowMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlayCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M31 22.268c1.333.77 1.333 2.694 0 3.464l-9 5.196c-1.333.77-3-.192-3-1.732V18.804c0-1.54 1.667-2.502 3-1.732z" })
          ]
        }
      );
    }
  )
);
var IconPlayCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M20.417 14.7c1 .578 1 2.022 0 2.599l-5.5 3.175a1.5 1.5 0 0 1-2.25-1.299v-6.35a1.5 1.5 0 0 1 2.25-1.3z" })
          ]
        }
      );
    }
  )
);
var IconPlayCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M15.5 11.134a1 1 0 0 1 0 1.732L11 15.464a1 1 0 0 1-1.5-.866V9.402a1 1 0 0 1 1.5-.866z" })
          ]
        }
      );
    }
  )
);
var IconPlayCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M11.55 8.307a.8.8 0 0 1 0 1.386l-3.225 1.862a.8.8 0 0 1-1.2-.693V7.138a.8.8 0 0 1 1.2-.693z" })
          ]
        }
      );
    }
  )
);
var IconPlayCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.433 7.48a.6.6 0 0 1 0 1.04l-3.2 1.847a.6.6 0 0 1-.9-.52V6.154a.6.6 0 0 1 .9-.52z" })
          ]
        }
      );
    }
  )
);
var IconPlayCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M7.6 5.48a.6.6 0 0 1 0 1.04L5.65 7.645a.6.6 0 0 1-.9-.52v-2.25a.6.6 0 0 1 .9-.52z" })
          ]
        }
      );
    }
  )
);

// src/IconPlayCircle/IconPlayCircle.tsx
var IconPlayCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlayCircleMonochromeExtralight,
          "monochrome|light": IconPlayCircleMonochromeLight,
          "monochrome|regular": IconPlayCircleMonochromeRegular,
          "monochrome|medium": IconPlayCircleMonochromeMedium,
          "monochrome|semibold": IconPlayCircleMonochromeSemibold,
          "monochrome|bold": IconPlayCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m7-18.269c1.333-.77 1.333-2.694 0-3.464l-9-5.196c-1.333-.77-3 .192-3 1.732v10.392c0 1.54 1.667 2.502 3 1.732z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.005 29.34c7.365 0 13.335-5.97 13.335-13.335S23.37 2.67 16.005 2.67 2.67 8.64 2.67 16.005 8.64 29.34 16.005 29.34m4.412-12.041c1-.577 1-2.02 0-2.598l-5.5-3.176a1.5 1.5 0 0 0-2.25 1.3v6.35a1.5 1.5 0 0 0 2.25 1.3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.5-9.134a1 1 0 0 0 0-1.732L11 8.536a1 1 0 0 0-1.5.866v5.196a1 1 0 0 0 1.5.866z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m2.55-6.807a.8.8 0 0 0 0-1.386L8.325 6.445a.8.8 0 0 0-1.2.693v3.724a.8.8 0 0 0 1.2.693z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.83 14.33a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m2.603-5.81a.6.6 0 0 0 0-1.04l-3.2-1.847a.6.6 0 0 0-.9.52v3.695c0 .462.5.75.9.52z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlayCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m1.6-4.48a.6.6 0 0 0 0-1.04L5.65 4.356a.6.6 0 0 0-.9.52v2.251c0 .462.5.75.9.52z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPlayCircleFilled/IconPlayCircleFilled.tsx
var IconPlayCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlayCircleFilledMonochromeExtralight,
          "monochrome|light": IconPlayCircleFilledMonochromeLight,
          "monochrome|regular": IconPlayCircleFilledMonochromeRegular,
          "monochrome|medium": IconPlayCircleFilledMonochromeMedium,
          "monochrome|semibold": IconPlayCircleFilledMonochromeSemibold,
          "monochrome|bold": IconPlayCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlayFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9 35.258V12.742c0-3.867 4.202-6.27 7.535-4.31l20.604 12.12c2.63 1.547 2.63 5.349 0 6.896l-20.604 12.12C13.202 41.528 9 39.125 9 35.258" })
        }
      );
    }
  )
);
var IconPlayFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6 23.505V8.495c0-2.578 2.801-4.18 5.023-2.873l13.736 8.08c1.753 1.03 1.753 3.565 0 4.596l-13.736 8.08C8.801 27.685 6 26.083 6 23.505" })
        }
      );
    }
  )
);
var IconPlayFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.5 17.629V6.371c0-1.934 2.101-3.135 3.768-2.155l10.301 6.06c1.315.773 1.315 2.675 0 3.448l-10.301 6.06c-1.667.98-3.768-.221-3.768-2.155" })
        }
      );
    }
  )
);
var IconPlayFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3.375 13.222V4.778c0-1.45 1.576-2.351 2.826-1.616l7.726 4.545a1.5 1.5 0 0 1 0 2.586l-7.726 4.545c-1.25.735-2.826-.166-2.826-1.616" })
        }
      );
    }
  )
);
var IconPlayFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 11.753V4.247c0-1.289 1.4-2.09 2.512-1.436l6.868 4.04a1.333 1.333 0 0 1 0 2.298l-6.868 4.04C4.4 13.843 3 13.042 3 11.753" })
        }
      );
    }
  )
);
var IconPlayFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.25 8.814V3.185a1.25 1.25 0 0 1 1.884-1.077l5.15 3.03a1 1 0 0 1 0 1.724l-5.15 3.03A1.25 1.25 0 0 1 2.25 8.814" })
        }
      );
    }
  )
);

// src/IconPlayFilled/IconPlayFilled.tsx
var IconPlayFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlayFilledMonochromeExtralight,
          "monochrome|light": IconPlayFilledMonochromeLight,
          "monochrome|regular": IconPlayFilledMonochromeRegular,
          "monochrome|medium": IconPlayFilledMonochromeMedium,
          "monochrome|semibold": IconPlayFilledMonochromeSemibold,
          "monochrome|bold": IconPlayFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlusMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M25.2 6a1.2 1.2 0 1 0-2.4 0v16.8H6a1.2 1.2 0 0 0 0 2.4h16.8V42a1.2 1.2 0 0 0 2.4 0V25.2H42a1.2 1.2 0 1 0 0-2.4H25.2z" })
        }
      );
    }
  )
);
var IconPlusMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M17 4a1 1 0 1 0-2 0v11H4a1 1 0 1 0 0 2h11v11a1 1 0 1 0 2 0V17h11a1 1 0 1 0 0-2H17z" })
        }
      );
    }
  )
);
var IconPlusMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M12.9 3a.9.9 0 1 0-1.8 0v8.1H3a.9.9 0 1 0 0 1.8h8.1V21a.9.9 0 0 0 1.8 0v-8.1H21a.9.9 0 0 0 0-1.8h-8.1z" })
        }
      );
    }
  )
);
var IconPlusMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9.8 2.25a.8.8 0 1 0-1.6 0V8.2H2.25a.8.8 0 0 0 0 1.6H8.2v5.95a.8.8 0 0 0 1.6 0V9.8h5.95a.8.8 0 0 0 0-1.6H9.8z" })
        }
      );
    }
  )
);
var IconPlusMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.75 2a.75.75 0 0 0-1.5 0v5.25H2a.75.75 0 0 0 0 1.5h5.25V14a.75.75 0 0 0 1.5 0V8.75H14a.75.75 0 0 0 0-1.5H8.75z" })
        }
      );
    }
  )
);
var IconPlusMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("g", { clipPath: `url(#${_id})`, children: /* @__PURE__ */ jsx("path", { d: "M6.6 1.5a.6.6 0 0 0-1.2 0v3.9H1.5a.6.6 0 0 0 0 1.2h3.9v3.9a.6.6 0 1 0 1.2 0V6.6h3.9a.6.6 0 1 0 0-1.2H6.6z" }) }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconPlus/IconPlus.tsx
var IconPlus = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlusMonochromeExtralight,
          "monochrome|light": IconPlusMonochromeLight,
          "monochrome|regular": IconPlusMonochromeRegular,
          "monochrome|medium": IconPlusMonochromeMedium,
          "monochrome|semibold": IconPlusMonochromeSemibold,
          "monochrome|bold": IconPlusMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlusCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.4 24c0 9.72 7.88 17.6 17.6 17.6S41.6 33.72 41.6 24 33.72 6.4 24 6.4 6.4 14.28 6.4 24M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 13.9a1.1 1.1 0 0 1 1.1 1.1v18a1.1 1.1 0 0 1-2.2 0V15a1.1 1.1 0 0 1 1.1-1.1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M34.1 24a1.1 1.1 0 0 1-1.1 1.1H15a1.1 1.1 0 0 1 0-2.2h18a1.1 1.1 0 0 1 1.1 1.1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlusCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.667 16c0 6.26 5.074 11.333 11.333 11.333S27.333 22.26 27.333 16 22.26 4.667 16 4.667 4.667 9.74 4.667 16M16 2.667C8.636 2.666 2.667 8.636 2.667 16S8.636 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 9.05a.95.95 0 0 1 .95.95v12a.95.95 0 0 1-1.9 0V10a.95.95 0 0 1 .95-.95",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22.95 16a.95.95 0 0 1-.95.95H10a.95.95 0 1 1 0-1.9h12a.95.95 0 0 1 .95.95",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlusCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.8 12a8.2 8.2 0 1 0 16.4 0 8.2 8.2 0 0 0-16.4 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 7.2a.8.8 0 0 1 .8.8v8a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16.8 12a.8.8 0 0 1-.8.8H8a.8.8 0 0 1 0-1.6h8a.8.8 0 0 1 .8.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlusCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.1 9a5.9 5.9 0 1 0 11.8 0A5.9 5.9 0 0 0 3.1 9M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 5.6a.65.65 0 0 1 .65.65v5.5a.65.65 0 1 1-1.3 0v-5.5A.65.65 0 0 1 9 5.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.4 9a.65.65 0 0 1-.65.65h-5.5a.65.65 0 0 1 0-1.3h5.5a.65.65 0 0 1 .65.65",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlusCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.834 8a5.167 5.167 0 1 0 10.333 0A5.167 5.167 0 0 0 2.834 8M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 4.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.1 8a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1 0-1.2h5a.6.6 0 0 1 .6.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconPlusCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.2 6a3.8 3.8 0 1 0 7.6 0 3.8 3.8 0 0 0-7.6 0M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 3.8a.45.45 0 0 1 .45.45v3.5a.45.45 0 1 1-.9 0v-3.5A.45.45 0 0 1 6 3.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.2 6a.45.45 0 0 1-.45.45h-3.5a.45.45 0 1 1 0-.9h3.5A.45.45 0 0 1 8.2 6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconPlusCircle/IconPlusCircle.tsx
var IconPlusCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlusCircleMonochromeExtralight,
          "monochrome|light": IconPlusCircleMonochromeLight,
          "monochrome|regular": IconPlusCircleMonochromeRegular,
          "monochrome|medium": IconPlusCircleMonochromeMedium,
          "monochrome|semibold": IconPlusCircleMonochromeSemibold,
          "monochrome|bold": IconPlusCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m1.1 11a1.1 1.1 0 0 0-2.2 0v7.9H15a1.1 1.1 0 0 0 0 2.2h7.9V33a1.1 1.1 0 0 0 2.2 0v-7.9H33a1.1 1.1 0 0 0 0-2.2h-7.9z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.636 29.334 16 29.334 29.333 23.364 29.333 16 23.363 2.667 16 2.667M16.95 10a.95.95 0 0 0-1.9 0v5.05H10a.95.95 0 0 0 0 1.9h5.05V22a.95.95 0 0 0 1.9 0v-5.05H22a.95.95 0 1 0 0-1.9h-5.05z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m.8 6a.8.8 0 0 0-1.6 0v3.2H8a.8.8 0 1 0 0 1.6h3.2V16a.8.8 0 1 0 1.6 0v-3.2H16a.8.8 0 0 0 0-1.6h-3.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m.65 4.75a.65.65 0 0 0-1.3 0v2.1h-2.1a.65.65 0 1 0 0 1.3h2.1v2.1a.65.65 0 1 0 1.3 0v-2.1h2.1a.65.65 0 1 0 0-1.3h-2.1z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333M8.6 5.5a.6.6 0 0 0-1.2 0v1.9H5.5a.6.6 0 0 0 0 1.2h1.9v1.9a.6.6 0 0 0 1.2 0V8.6h1.9a.6.6 0 1 0 0-1.2H8.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPlusCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1m.45 3.25a.45.45 0 1 0-.9 0v1.3h-1.3a.45.45 0 1 0 0 .9h1.3v1.3a.45.45 0 1 0 .9 0v-1.3h1.3a.45.45 0 1 0 0-.9h-1.3z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPlusCircleFilled/IconPlusCircleFilled.tsx
var IconPlusCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlusCircleFilledMonochromeExtralight,
          "monochrome|light": IconPlusCircleFilledMonochromeLight,
          "monochrome|regular": IconPlusCircleFilledMonochromeRegular,
          "monochrome|medium": IconPlusCircleFilledMonochromeMedium,
          "monochrome|semibold": IconPlusCircleFilledMonochromeSemibold,
          "monochrome|bold": IconPlusCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlusSquareMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M340 84H140c-30.928 0-56 25.072-56 56v200c0 30.928 25.072 56 56 56h200c30.928 0 56-25.072 56-56V140c0-30.928-25.072-56-56-56M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M228 325v-73h-73c-6.627 0-12-5.373-12-12s5.373-12 12-12h73v-73c0-6.627 5.373-12 12-12s12 5.373 12 12v73h73c6.627 0 12 5.373 12 12s-5.373 12-12 12h-73v73c0 6.627-5.373 12-12 12s-12-5.373-12-12" })
          ]
        }
      );
    }
  )
);
var IconPlusSquareMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80zm200 30H140c-27.614 0-50 22.386-50 50v200c0 27.614 22.386 50 50 50h200c27.614 0 50-22.386 50-50V140c0-27.614-22.386-50-50-50",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M225 322.5V255h-67.5c-8.284 0-15-6.716-15-15s6.716-15 15-15H225v-67.5c0-8.284 6.716-15 15-15s15 6.716 15 15V225h67.5c8.284 0 15 6.716 15 15s-6.716 15-15 15H255v67.5c0 8.284-6.716 15-15 15s-15-6.716-15-15" })
          ]
        }
      );
    }
  )
);
var IconPlusSquareMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80zm200 36H140c-24.301 0-44 19.699-44 44v200c0 24.301 19.699 44 44 44h200c24.301 0 44-19.699 44-44V140c0-24.301-19.699-44-44-44",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M222 315v-57h-57c-9.941 0-18-8.059-18-18s8.059-18 18-18h57v-57c0-9.941 8.059-18 18-18s18 8.059 18 18v57h57c9.941 0 18 8.059 18 18s-8.059 18-18 18h-57v57c0 9.941-8.059 18-18 18s-18-8.059-18-18" })
          ]
        }
      );
    }
  )
);
var IconPlusSquareMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80zm200 42.667H140c-20.619 0-37.333 16.714-37.333 37.333v200c0 20.619 16.714 37.333 37.333 37.333h200c20.619 0 37.333-16.714 37.333-37.333V140c0-20.619-16.714-37.333-37.333-37.333",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M218.665 310v-48.665H170c-11.783 0-21.335-9.552-21.335-21.335s9.552-21.335 21.335-21.335h48.665V170c0-11.783 9.552-21.335 21.335-21.335s21.335 9.552 21.335 21.335v48.665H310l.551.007c11.528.292 20.784 9.729 20.784 21.328 0 11.783-9.552 21.335-21.335 21.335h-48.665V310c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335" })
          ]
        }
      );
    }
  )
);
var IconPlusSquareMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80zm200 48H140c-17.673 0-32 14.327-32 32v200c0 17.673 14.327 32 32 32h200c17.673 0 32-14.327 32-32V140c0-17.673-14.327-32-32-32",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M217.5 305v-42.5H175c-12.426 0-22.5-10.074-22.5-22.5s10.074-22.5 22.5-22.5h42.5V175c0-12.426 10.074-22.5 22.5-22.5s22.5 10.074 22.5 22.5v42.5H305c12.426 0 22.5 10.074 22.5 22.5s-10.074 22.5-22.5 22.5h-42.5V305c0 12.426-10.074 22.5-22.5 22.5s-22.5-10.074-22.5-22.5" })
          ]
        }
      );
    }
  )
);
var IconPlusSquareMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M140 60c-44.183 0-80 35.817-80 80v200c0 44.183 35.817 80 80 80h200c44.183 0 80-35.817 80-80V140c0-44.183-35.817-80-80-80zm200 56H140c-13.255 0-24 10.745-24 24v200c0 13.255 10.745 24 24 24h200c13.255 0 24-10.745 24-24V140c0-13.255-10.745-24-24-24",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M216 300v-36h-36c-13.255 0-24-10.745-24-24s10.745-24 24-24h36v-36c0-13.255 10.745-24 24-24s24 10.745 24 24v36h36c13.255 0 24 10.745 24 24s-10.745 24-24 24h-36v36c0 13.255-10.745 24-24 24s-24-10.745-24-24" })
          ]
        }
      );
    }
  )
);

// src/IconPlusSquare/IconPlusSquare.tsx
var IconPlusSquare = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlusSquareMonochromeExtralight,
          "monochrome|light": IconPlusSquareMonochromeLight,
          "monochrome|regular": IconPlusSquareMonochromeRegular,
          "monochrome|medium": IconPlusSquareMonochromeMedium,
          "monochrome|semibold": IconPlusSquareMonochromeSemibold,
          "monochrome|bold": IconPlusSquareMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 138c-6.627 0-12 5.373-12 12v78h-78c-6.627 0-12 5.373-12 12s5.373 12 12 12h78v78c0 6.627 5.373 12 12 12s12-5.373 12-12v-78h78c6.627 0 12-5.373 12-12s-5.373-12-12-12h-78v-78c0-6.627-5.373-12-12-12" })
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 140c-8.284 0-15 6.716-15 15v70h-70c-8.284 0-15 6.716-15 15s6.716 15 15 15h70v70c0 8.284 6.716 15 15 15s15-6.716 15-15v-70h70c8.284 0 15-6.716 15-15s-6.716-15-15-15h-70v-70c0-8.284-6.716-15-15-15" })
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 142c-9.941 0-18 8.059-18 18v62h-62c-9.941 0-18 8.059-18 18s8.059 18 18 18h62v62c0 9.941 8.059 18 18 18s18-8.059 18-18v-62h62c9.941 0 18-8.059 18-18s-8.059-18-18-18h-62v-62c0-9.941-8.059-18-18-18" })
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 138.665c-11.783 0-21.335 9.552-21.335 21.335v58.665H160c-11.783 0-21.335 9.552-21.335 21.335s9.552 21.335 21.335 21.335h58.665V320c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-58.665H320c11.783 0 21.335-9.552 21.335-21.335 0-11.599-9.256-21.036-20.784-21.328l-.551-.007h-58.665V160c0-11.783-9.552-21.335-21.335-21.335" })
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 137.5c-12.426 0-22.5 10.074-22.5 22.5v57.5H160c-12.426 0-22.5 10.074-22.5 22.5s10.074 22.5 22.5 22.5h57.5V320c0 12.426 10.074 22.5 22.5 22.5s22.5-10.074 22.5-22.5v-57.5H320c12.426 0 22.5-10.074 22.5-22.5s-10.074-22.5-22.5-22.5h-57.5V160c0-12.426-10.074-22.5-22.5-22.5" })
        }
      );
    }
  )
);
var IconPlusSquareFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M348.262 60.337c39.764 0 72 32.235 72 72v216c0 39.764-32.236 72-72 72h-216c-39.765 0-72-32.236-72-72v-216c0-39.764 32.235-72 72-72zM240 136c-13.255 0-24 10.745-24 24v56h-56c-13.255 0-24 10.745-24 24s10.745 24 24 24h56v56c0 13.255 10.745 24 24 24s24-10.745 24-24v-56h56c13.255 0 24-10.745 24-24s-10.745-24-24-24h-56v-56c0-13.255-10.745-24-24-24" })
        }
      );
    }
  )
);

// src/IconPlusSquareFilled/IconPlusSquareFilled.tsx
var IconPlusSquareFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPlusSquareFilledMonochromeExtralight,
          "monochrome|light": IconPlusSquareFilledMonochromeLight,
          "monochrome|regular": IconPlusSquareFilledMonochromeRegular,
          "monochrome|medium": IconPlusSquareFilledMonochromeMedium,
          "monochrome|semibold": IconPlusSquareFilledMonochromeSemibold,
          "monochrome|bold": IconPlusSquareFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M42 9.672a8.571 8.571 0 0 1-14.463 6.225l-8.72 4.757c.212.747.326 1.535.326 2.35a8.5 8.5 0 0 1-.946 3.919l9.34 5.094a8.571 8.571 0 1 1-1.514 1.908l-9.224-5.031a8.571 8.571 0 1 1 1.038-10.44l8.186-4.465A8.571 8.571 0 1 1 42 9.672M10.571 29.176a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343M33.43 15.843a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343m0 28.571a6.171 6.171 0 1 0 0-12.342 6.171 6.171 0 0 0 0 12.342",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M28.267 6.514a5.714 5.714 0 0 1-9.486 4.293l-5.917 3.228a5.73 5.73 0 0 1-.377 3.8l6.294 3.434a5.714 5.714 0 1 1-1.264 1.589l-6.196-3.38a5.714 5.714 0 1 1 .728-7.276l5.468-2.984a5.714 5.714 0 1 1 10.75-2.704M7.314 19.117a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.43m15.238-8.889a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428m0 19.048a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.429",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16.714 9.071a4.286 4.286 0 1 0-3.845-2.39L8.75 8.927a4.286 4.286 0 1 0-.54 5.659l-.02.037 4.68 2.553a4.286 4.286 0 1 0 1.14-1.429l-4.782-2.609a4.27 4.27 0 0 0 .255-2.56l4.526-2.47c.738.602 1.68.962 2.706.962m0-1.8a2.486 2.486 0 1 0 0-4.971 2.486 2.486 0 0 0 0 4.971M5.286 13.938a2.486 2.486 0 1 0 0-4.972 2.486 2.486 0 0 0 0 4.972M19.2 19.07a2.486 2.486 0 1 1-4.971 0 2.486 2.486 0 0 1 4.971 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12.586 6.828a3.214 3.214 0 1 0-2.917-1.86L6.566 6.66a3.214 3.214 0 1 0-.36 4.305l-.05.093 3.513 1.917a3.214 3.214 0 1 0 .95-1.19L7 9.81a3.2 3.2 0 0 0 .177-1.774l3.444-1.878a3.2 3.2 0 0 0 1.966.67m0-1.5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m-8.572 5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m10.286 4a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.976 6.38A2.857 2.857 0 1 0 8.37 4.697L5.605 6.204a2.857 2.857 0 1 0-.3 3.853l-.06.113 3.125 1.705a2.857 2.857 0 1 0 .888-1.11L6.022 9a2.85 2.85 0 0 0 .152-1.511l3.084-1.682c.478.36 1.073.574 1.718.574m0-1.4a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.915M3.357 9.426a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.914m9.076 3.622a1.457 1.457 0 1 1-2.914 0 1.457 1.457 0 0 1 2.914 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconPoint3ConnectedSplitPathMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.257 4.566a2.143 2.143 0 1 0-1.984-1.333L4.18 4.374a2.143 2.143 0 1 0-.177 2.95l-.082.15 2.35 1.281a2.143 2.143 0 1 0 .763-.95L4.569 6.457a2.14 2.14 0 0 0 .1-.983l2.368-1.291c.346.24.767.381 1.221.381m0-1.2a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M2.543 6.699a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M9.2 9.565a.943.943 0 1 1-1.886 0 .943.943 0 0 1 1.886 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconPoint3ConnectedSplitPath/IconPoint3ConnectedSplitPath.tsx
var IconPoint3ConnectedSplitPath = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconPoint3ConnectedSplitPathMonochromeExtralight,
          "monochrome|light": IconPoint3ConnectedSplitPathMonochromeLight,
          "monochrome|regular": IconPoint3ConnectedSplitPathMonochromeRegular,
          "monochrome|medium": IconPoint3ConnectedSplitPathMonochromeMedium,
          "monochrome|semibold": IconPoint3ConnectedSplitPathMonochromeSemibold,
          "monochrome|bold": IconPoint3ConnectedSplitPathMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M25.056 27.441c-.074.938-.513 1.553-1.465 1.553-1.026 0-1.538-.747-1.538-1.714v-.337c0-1.875.908-3.12 2.812-4.262 1.773-1.07 2.403-1.949 2.403-3.384 0-1.729-1.333-2.915-3.282-2.915-1.772 0-2.944.879-3.413 2.475-.293.909-.747 1.23-1.48 1.23-.907 0-1.42-.541-1.42-1.435 0-.63.132-1.142.395-1.713.894-2.022 3.12-3.252 6.05-3.252 3.823 0 6.475 2.24 6.475 5.478 0 2.27-1.143 3.823-3.076 4.98-1.89 1.114-2.388 1.86-2.461 3.296M25.524 33.33c0 1.07-.835 1.89-1.933 1.89-1.07 0-1.92-.82-1.92-1.89s.85-1.89 1.92-1.89c1.098 0 1.933.82 1.933 1.89" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-2.4 0c0 9.72-7.88 17.6-17.6 17.6S6.4 33.72 6.4 24 14.28 6.4 24 6.4 41.6 14.28 41.6 24",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M16.788 18.294c-.05.625-.342 1.036-.977 1.036-.684 0-1.025-.498-1.025-1.143v-.225c0-1.25.605-2.08 1.874-2.841 1.182-.713 1.602-1.3 1.602-2.256 0-1.153-.889-1.944-2.187-1.944-1.182 0-1.963.586-2.276 1.65-.195.606-.498.821-.986.821-.606 0-.947-.361-.947-.957 0-.42.088-.762.263-1.142.596-1.348 2.08-2.168 4.034-2.168 2.548 0 4.316 1.494 4.316 3.652 0 1.514-.762 2.549-2.05 3.32-1.26.742-1.593 1.24-1.641 2.197M17.1 22.22c0 .713-.557 1.26-1.29 1.26-.712 0-1.278-.547-1.278-1.26s.566-1.26 1.279-1.26c.732 0 1.289.547 1.289 1.26" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M29.334 16c0 7.364-5.97 13.334-13.334 13.334S2.667 23.364 2.667 16 8.637 2.667 16 2.667 29.334 8.637 29.334 16m-2 0c0 6.26-5.074 11.334-11.334 11.334S4.667 22.26 4.667 16 9.741 4.667 16 4.667 27.334 9.741 27.334 16",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12.733 13.684c-.073.484-.322.784-.82.784-.557 0-.864-.396-.864-.93v-.14c0-.908.454-1.508 1.37-2.05.908-.55 1.215-.953 1.215-1.656 0-.798-.622-1.355-1.523-1.355-.813 0-1.355.403-1.59 1.143-.16.454-.432.637-.834.637-.506 0-.806-.307-.806-.798 0-.315.066-.586.205-.864.454-.997 1.597-1.612 3.105-1.612 1.985 0 3.348 1.128 3.348 2.783 0 1.121-.557 1.89-1.553 2.483-.96.557-1.194.909-1.253 1.575M12.99 16.606c0 .58-.469 1.04-1.062 1.04s-1.07-.46-1.07-1.04c0-.578.476-1.032 1.07-1.032.593 0 1.062.454 1.062 1.032" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.8 0a8.2 8.2 0 1 1-16.4 0 8.2 8.2 0 0 1 16.4 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9.563 10.138c-.055.363-.242.588-.616.588-.417 0-.648-.297-.648-.698v-.104c0-.681.34-1.132 1.027-1.538.681-.412.912-.714.912-1.242 0-.599-.467-1.016-1.142-1.016-.61 0-1.017.302-1.192.857-.121.34-.325.478-.627.478-.379 0-.604-.23-.604-.599 0-.236.05-.44.154-.648.34-.747 1.197-1.209 2.329-1.209 1.489 0 2.51.846 2.51 2.088 0 .84-.417 1.417-1.164 1.862-.72.417-.896.681-.94 1.18M9.755 12.33c0 .434-.352.78-.797.78a.79.79 0 0 1-.802-.78c0-.434.357-.775.802-.775s.797.34.797.775" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-1.45 0a6.05 6.05 0 1 1-12.1 0 6.05 6.05 0 0 1 12.1 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M8.422 8.956c-.049.322-.215.522-.547.522-.371 0-.576-.263-.576-.62v-.093c0-.605.303-1.005.913-1.367.605-.366.81-.635.81-1.103 0-.533-.415-.904-1.015-.904-.542 0-.903.269-1.06.762-.107.303-.288.425-.556.425-.337 0-.537-.205-.537-.532 0-.21.043-.391.136-.577.303-.664 1.065-1.074 2.07-1.074 1.324 0 2.232.752 2.232 1.856 0 .747-.371 1.26-1.035 1.655-.64.371-.796.605-.835 1.05M8.593 10.904a.696.696 0 0 1-.708.693.7.7 0 0 1-.713-.693c0-.386.317-.688.713-.688s.708.302.708.688" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0m-1.35 0A5.317 5.317 0 1 1 2.683 8a5.317 5.317 0 0 1 10.633 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconQuestionCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6.386 6.824c-.055.245-.198.388-.458.388-.311 0-.495-.212-.495-.513v-.051c0-.432.224-.718.656-.97.472-.282.615-.466.615-.803 0-.358-.278-.607-.68-.607-.36 0-.602.175-.719.501-.091.235-.256.337-.48.337-.289 0-.468-.18-.468-.458 0-.157.036-.296.11-.435.234-.484.82-.795 1.607-.795 1.04 0 1.74.571 1.74 1.425 0 .553-.267.93-.784 1.234-.487.282-.597.44-.644.747M6.536 8.267a.584.584 0 0 1-.6.575.583.583 0 0 1-.598-.575c0-.323.268-.575.597-.575.333 0 .6.252.6.575" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.9 6a3.9 3.9 0 1 1-7.8 0 3.9 3.9 0 0 1 7.8 0",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconQuestionCircle/IconQuestionCircle.tsx
var IconQuestionCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconQuestionCircleMonochromeExtralight,
          "monochrome|light": IconQuestionCircleMonochromeLight,
          "monochrome|regular": IconQuestionCircleMonochromeRegular,
          "monochrome|medium": IconQuestionCircleMonochromeMedium,
          "monochrome|semibold": IconQuestionCircleMonochromeSemibold,
          "monochrome|bold": IconQuestionCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.528-8.28c-.037.47-.257.777-.733.777-.512 0-.769-.373-.769-.857v-.168c0-.938.454-1.56 1.407-2.132.886-.534 1.2-.974 1.2-1.692 0-.864-.666-1.457-1.64-1.457-.886 0-1.472.44-1.706 1.238-.147.454-.374.615-.74.615-.454 0-.71-.271-.71-.718 0-.315.065-.571.197-.857.447-1.01 1.56-1.626 3.025-1.626 1.912 0 3.237 1.12 3.237 2.74 0 1.135-.57 1.911-1.538 2.49-.944.556-1.193.93-1.23 1.648m.234 2.945c0 .535-.417.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.426-.945.96-.945.55 0 .967.41.967.945",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.59-8.28c-.036.47-.256.777-.732.777-.513 0-.769-.373-.769-.857v-.168c0-.938.454-1.56 1.406-2.131.887-.535 1.202-.975 1.202-1.692 0-.865-.667-1.458-1.641-1.458-.886 0-1.472.44-1.707 1.238-.146.454-.373.615-.74.615-.453 0-.71-.27-.71-.718 0-.315.066-.571.198-.857.447-1.01 1.56-1.626 3.025-1.626 1.912 0 3.237 1.121 3.237 2.74 0 1.135-.571 1.911-1.538 2.49-.945.556-1.194.93-1.23 1.648m.235 2.945c0 .535-.417.945-.967.945a.94.94 0 0 1-.96-.945c0-.534.425-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-.142 13.72c-.535 0-.96.41-.96.945s.425.945.96.945c.55 0 .967-.41.967-.945s-.417-.945-.967-.945m.264-8.877c-1.465 0-2.578.616-3.025 1.626a1.9 1.9 0 0 0-.198.857c0 .447.257.718.71.718.367 0 .594-.161.74-.615.235-.799.82-1.238 1.707-1.238.974 0 1.64.593 1.64 1.458 0 .717-.314 1.157-1.2 1.692-.953.57-1.407 1.193-1.407 2.13v.17c0 .483.256.856.77.856.475 0 .695-.307.732-.776.036-.718.285-1.091 1.23-1.648.967-.579 1.538-1.355 1.538-2.49 0-1.619-1.325-2.74-3.237-2.74" })
          ]
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.653-8.28c-.037.47-.257.777-.733.777-.512 0-.769-.373-.769-.857v-.168c0-.938.454-1.56 1.407-2.132.886-.534 1.2-.974 1.2-1.692 0-.864-.666-1.457-1.64-1.457-.886 0-1.472.44-1.706 1.238-.147.454-.374.615-.74.615-.454 0-.71-.271-.71-.718 0-.315.065-.571.197-.857.447-1.01 1.56-1.626 3.025-1.626 1.912 0 3.237 1.12 3.237 2.74 0 1.135-.57 1.911-1.538 2.49-.944.556-1.193.93-1.23 1.648m.234 2.945c0 .535-.417.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.426-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-.08 13.72c-.534 0-.96.41-.96.945s.426.945.96.945c.55 0 .967-.41.967-.945s-.417-.945-.967-.945m.264-8.877c-1.465 0-2.578.615-3.025 1.626a1.9 1.9 0 0 0-.198.857c0 .447.257.718.71.718.367 0 .594-.161.74-.615.235-.799.82-1.238 1.707-1.238.974 0 1.64.593 1.64 1.457 0 .718-.314 1.158-1.2 1.692-.953.572-1.407 1.194-1.407 2.132v.168c0 .483.257.857.77.857.476 0 .695-.307.732-.776.037-.718.285-1.092 1.23-1.648.967-.579 1.538-1.355 1.538-2.49 0-1.62-1.325-2.74-3.237-2.74" })
          ]
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.67-8.446c-.037.469-.257.776-.733.776-.513 0-.769-.373-.769-.857v-.168c0-.938.454-1.56 1.406-2.131.886-.535 1.201-.975 1.201-1.692 0-.865-.666-1.458-1.64-1.458-.886 0-1.472.44-1.707 1.238-.146.454-.373.615-.74.615-.454 0-.71-.27-.71-.718 0-.315.066-.57.198-.857.447-1.01 1.56-1.626 3.025-1.626 1.911 0 3.237 1.121 3.237 2.74 0 1.135-.571 1.911-1.538 2.49-.945.557-1.194.93-1.23 1.648m.234 2.944c0 .535-.418.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.425-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-.063 13.553c-.535 0-.96.41-.96.945s.425.945.96.945c.55 0 .967-.41.967-.945s-.418-.945-.967-.945m.264-8.877c-1.465 0-2.578.616-3.025 1.626a1.9 1.9 0 0 0-.198.857c0 .447.256.718.71.718.367 0 .594-.161.74-.615.235-.798.82-1.238 1.707-1.238.974 0 1.64.593 1.64 1.458 0 .717-.315 1.157-1.2 1.692-.953.57-1.407 1.193-1.407 2.13v.17c0 .483.256.856.769.856.476 0 .696-.307.732-.776.037-.718.286-1.091 1.23-1.648.968-.579 1.539-1.355 1.539-2.49 0-1.619-1.326-2.74-3.237-2.74" })
          ]
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.522 0 10-4.478 10-10S17.522 2 12 2 2 6.477 2 12s4.477 10 10 10m.552-8.53c-.036.47-.256.777-.732.777-.513 0-.77-.374-.77-.857v-.169c0-.937.455-1.56 1.407-2.131.886-.535 1.201-.974 1.201-1.692 0-.864-.666-1.457-1.64-1.457-.887 0-1.473.439-1.707 1.237-.146.454-.373.616-.74.616-.454 0-.71-.271-.71-.718 0-.315.066-.571.198-.857.446-1.01 1.56-1.626 3.025-1.626 1.911 0 3.237 1.12 3.237 2.74 0 1.134-.572 1.91-1.538 2.49-.945.556-1.194.93-1.23 1.647m.235 2.945c0 .534-.418.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.425-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M12 2c5.522 0 10 4.477 10 10s-4.478 10-10 10S2 17.522 2 12 6.477 2 12 2m-.18 13.47c-.535 0-.96.41-.96.945s.425.945.96.945c.55 0 .967-.41.967-.945s-.418-.945-.967-.945m.264-8.877c-1.465 0-2.579.615-3.025 1.626a1.9 1.9 0 0 0-.198.857c0 .447.256.718.71.718.367 0 .594-.162.74-.616.234-.798.82-1.237 1.707-1.237.974 0 1.64.593 1.64 1.457 0 .718-.315 1.157-1.201 1.692-.952.571-1.406 1.194-1.406 2.131v.169c0 .483.256.857.769.857.476 0 .696-.308.732-.777.037-.717.286-1.091 1.23-1.648.967-.578 1.539-1.355 1.539-2.49 0-1.619-1.326-2.74-3.237-2.74" })
          ]
        }
      );
    }
  )
);
var IconQuestionCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.603-8.28c-.037.47-.257.777-.733.777-.512 0-.769-.373-.769-.857v-.168c0-.938.454-1.56 1.407-2.132.886-.534 1.2-.974 1.2-1.692 0-.864-.666-1.457-1.64-1.457-.886 0-1.472.44-1.706 1.238-.147.454-.374.615-.74.615-.454 0-.71-.271-.71-.718 0-.315.065-.571.197-.857.447-1.01 1.56-1.626 3.025-1.626 1.912 0 3.237 1.12 3.237 2.74 0 1.135-.571 1.911-1.538 2.49-.945.556-1.194.93-1.23 1.648m.234 2.945c0 .535-.417.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.426-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.134 4.843c-1.465 0-2.578.615-3.025 1.626a1.9 1.9 0 0 0-.198.857c0 .447.257.718.71.718.367 0 .594-.161.74-.615.235-.799.82-1.238 1.707-1.238.974 0 1.64.593 1.64 1.457 0 .718-.314 1.158-1.2 1.692-.953.572-1.407 1.194-1.407 2.132v.168c0 .483.257.857.77.857.475 0 .695-.307.732-.776.036-.718.285-1.092 1.23-1.648.967-.579 1.538-1.355 1.538-2.49 0-1.62-1.325-2.74-3.237-2.74m.703 9.822c0 .535-.417.945-.967.945a.94.94 0 0 1-.96-.945c0-.535.426-.945.96-.945.55 0 .967.41.967.945",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconQuestionCircleFilled/IconQuestionCircleFilled.tsx
var IconQuestionCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconQuestionCircleFilledMonochromeExtralight,
          "monochrome|light": IconQuestionCircleFilledMonochromeLight,
          "monochrome|regular": IconQuestionCircleFilledMonochromeRegular,
          "monochrome|medium": IconQuestionCircleFilledMonochromeMedium,
          "monochrome|semibold": IconQuestionCircleFilledMonochromeSemibold,
          "monochrome|bold": IconQuestionCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zM6 32a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z" })
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4 8a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v2.667a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zM4 21.333a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4V24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z" })
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 16a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" })
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h9a2.25 2.25 0 0 1 2.25 2.25V6a2.25 2.25 0 0 1-2.25 2.25h-9A2.25 2.25 0 0 1 2.25 6zM2.25 12A2.25 2.25 0 0 1 4.5 9.75h9A2.25 2.25 0 0 1 15.75 12v1.5a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25z" })
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.333a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM2 10.667a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z" })
        }
      );
    }
  )
);
var IconRectangleGrid1X2FilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M1.5 3A1.5 1.5 0 0 1 3 1.5h6A1.5 1.5 0 0 1 10.5 3v1A1.5 1.5 0 0 1 9 5.5H3A1.5 1.5 0 0 1 1.5 4zM1.5 8A1.5 1.5 0 0 1 3 6.5h6A1.5 1.5 0 0 1 10.5 8v1A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9z" })
        }
      );
    }
  )
);

// src/IconRectangleGrid1X2Filled/IconRectangleGrid1X2Filled.tsx
var IconRectangleGrid1X2Filled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconRectangleGrid1X2FilledMonochromeExtralight,
          "monochrome|light": IconRectangleGrid1X2FilledMonochromeLight,
          "monochrome|regular": IconRectangleGrid1X2FilledMonochromeRegular,
          "monochrome|medium": IconRectangleGrid1X2FilledMonochromeMedium,
          "monochrome|semibold": IconRectangleGrid1X2FilledMonochromeSemibold,
          "monochrome|bold": IconRectangleGrid1X2FilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconShieldMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M42 24V11.94c0-1.08-.86-1.94-1.94-2-7.37-.4-12.207-3.067-14.503-4.688-.902-.637-2.211-.637-3.114 0C20.147 6.873 15.31 9.54 7.94 9.94c-1.08.06-1.94.92-1.94 2V24s0 13.004 16.115 19.318a5.18 5.18 0 0 0 3.77 0C42 37.004 42 24 42 24m-33.6-.011.002.061q.003.096.02.316c.026.294.078.744.187 1.314.218 1.142.66 2.75 1.553 4.54 1.762 3.534 5.35 7.934 12.828 10.863a2.78 2.78 0 0 0 2.02 0c7.478-2.93 11.066-7.329 12.828-10.862a17.7 17.7 0 0 0 1.553-4.54c.109-.57.161-1.02.186-1.315a7 7 0 0 0 .023-.376V12.317c-7.729-.49-12.88-3.307-15.427-5.105A.33.33 0 0 0 24 7.174a.33.33 0 0 0-.173.038C21.281 9.01 16.13 11.828 8.4 12.317z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShieldMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M28 16V7.96c0-.72-.573-1.293-1.293-1.333-4.914-.267-8.138-2.045-9.67-3.126a1.85 1.85 0 0 0-2.075 0c-1.53 1.081-4.755 2.86-9.669 3.126C4.573 6.667 4 7.24 4 7.96V16s0 8.67 10.743 12.878a3.46 3.46 0 0 0 2.514 0C28 24.67 28 16 28 16m-22-.012.001.03q.001.053.013.192c.015.184.049.47.118.835a11.4 11.4 0 0 0 1 2.923c1.133 2.272 3.452 5.133 8.34 7.048.337.132.719.132 1.055 0 4.889-1.915 7.208-4.776 8.34-7.047.576-1.156.86-2.192 1-2.924A8 8 0 0 0 26 16.017v-.026l.001-.003V8.584c-4.922-.388-8.262-2.166-10-3.368-1.738 1.202-5.078 2.98-10 3.368z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShieldMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21 12V5.97c0-.54-.43-.97-.97-1-3.685-.2-6.103-1.533-7.252-2.344a1.39 1.39 0 0 0-1.556 0c-1.149.81-3.567 2.144-7.252 2.344-.54.03-.97.46-.97 1V12s0 6.502 8.057 9.659a2.6 2.6 0 0 0 1.886 0C21 18.502 21 12 21 12m-16.2-.014v.015q.001.035.01.131c.01.128.034.333.084.595.1.527.306 1.277.724 2.115.818 1.64 2.502 3.733 6.096 5.14.182.072.39.072.572 0 3.594-1.407 5.278-3.5 6.096-5.14a8.3 8.3 0 0 0 .724-2.115 6 6 0 0 0 .093-.726l.001-.015V6.713c-3.452-.325-5.857-1.543-7.2-2.438-1.343.895-3.748 2.113-7.2 2.438z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShieldMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.75 9V4.478a.76.76 0 0 0-.727-.75c-2.764-.15-4.578-1.15-5.44-1.759a1.04 1.04 0 0 0-1.167 0c-.861.609-2.675 1.609-5.438 1.759a.76.76 0 0 0-.728.75V9s0 4.877 6.043 7.244c.453.178.96.178 1.414 0C15.75 13.877 15.75 9 15.75 9m-11.9-.014v.004l.006.088c.008.088.024.233.06.42.072.378.22.918.521 1.522.587 1.178 1.804 2.702 4.44 3.735.078.03.168.03.246 0 2.636-1.033 3.853-2.557 4.44-3.735.301-.604.449-1.144.521-1.521a4 4 0 0 0 .066-.509V5.261C11.745 4.995 10.025 4.163 9 3.505c-1.025.658-2.745 1.49-5.15 1.756z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShieldMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M14 8V3.98a.674.674 0 0 0-.647-.667C10.897 3.18 9.284 2.291 8.52 1.751a.925.925 0 0 0-1.038 0c-.765.54-2.378 1.43-4.834 1.562A.674.674 0 0 0 2 3.98V8s0 4.335 5.371 6.44c.403.157.855.157 1.258 0C14 12.334 14 8 14 8M3.714 7.982l.005.062c.005.07.019.188.049.344.06.314.184.768.438 1.278.49.984 1.519 2.287 3.79 3.177h.007c2.272-.89 3.3-2.193 3.791-3.177.255-.51.378-.964.438-1.278a3 3 0 0 0 .054-.406V4.935C10.346 4.679 8.916 4.02 8 3.46c-.915.561-2.346 1.219-4.286 1.475z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShieldMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.5 6V2.985a.505.505 0 0 0-.485-.5c-1.843-.1-3.052-.767-3.626-1.172a.69.69 0 0 0-.778 0c-.574.405-1.783 1.072-3.626 1.172a.505.505 0 0 0-.485.5V6s0 3.251 4.029 4.83c.302.118.64.118.942 0C10.5 9.25 10.5 6 10.5 6m-7.8-.012.003.053c.005.054.016.146.039.267.046.24.14.59.336.98.377.756 1.164 1.749 2.888 2.424.021.008.047.008.068 0 1.724-.675 2.511-1.668 2.888-2.424.195-.39.29-.74.336-.98a3 3 0 0 0 .042-.32V3.626C7.789 3.439 6.687 2.923 6 2.494c-.687.429-1.789.945-3.3 1.132z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconShield/IconShield.tsx
var IconShield = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconShieldMonochromeExtralight,
          "monochrome|light": IconShieldMonochromeLight,
          "monochrome|regular": IconShieldMonochromeRegular,
          "monochrome|medium": IconShieldMonochromeMedium,
          "monochrome|semibold": IconShieldMonochromeSemibold,
          "monochrome|bold": IconShieldMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconShieldFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6 24V11.94c0-1.08.86-1.94 1.94-2 7.37-.4 12.207-3.067 14.503-4.688.902-.637 2.211-.637 3.114 0C27.853 6.873 32.69 9.54 40.06 9.94c1.08.06 1.94.92 1.94 2V24s0 13.004-16.114 19.318a5.18 5.18 0 0 1-3.771 0C6 37.004 6 24 6 24" })
        }
      );
    }
  )
);
var IconShieldFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4 16V7.96c0-.72.573-1.293 1.293-1.333 4.914-.267 8.138-2.045 9.67-3.126a1.85 1.85 0 0 1 2.075 0c1.53 1.081 4.755 2.86 9.669 3.126.72.04 1.293.613 1.293 1.333V16s0 8.67-10.743 12.878a3.46 3.46 0 0 1-2.514 0C4 24.67 4 16 4 16" })
        }
      );
    }
  )
);
var IconShieldFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 12V5.97c0-.54.43-.97.97-1 3.685-.2 6.103-1.533 7.252-2.344a1.39 1.39 0 0 1 1.556 0c1.149.81 3.567 2.144 7.252 2.344.54.03.97.46.97 1V12s0 6.502-8.057 9.659a2.6 2.6 0 0 1-1.886 0C3 18.502 3 12 3 12" })
        }
      );
    }
  )
);
var IconShieldFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.25 9V4.477c0-.405.322-.727.728-.75 2.763-.15 4.577-1.15 5.438-1.758a1.04 1.04 0 0 1 1.168 0c.861.608 2.675 1.609 5.439 1.758a.76.76 0 0 1 .727.75V9s0 4.877-6.043 7.244c-.453.178-.96.178-1.414 0C2.25 13.877 2.25 9 2.25 9" })
        }
      );
    }
  )
);
var IconShieldFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2 8V3.98c0-.36.287-.647.647-.667C5.103 3.18 6.716 2.291 7.48 1.751a.925.925 0 0 1 1.038 0c.765.54 2.378 1.43 4.834 1.562.36.02.647.307.647.667V8s0 4.335-5.371 6.44a1.73 1.73 0 0 1-1.258 0C2 12.334 2 8 2 8" })
        }
      );
    }
  )
);
var IconShieldFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M1.5 6V2.985c0-.27.215-.485.485-.5 1.843-.1 3.052-.767 3.626-1.172a.69.69 0 0 1 .778 0c.574.405 1.783 1.072 3.626 1.172.27.015.485.23.485.5V6s0 3.251-4.029 4.83c-.302.118-.64.118-.942 0C1.5 9.25 1.5 6 1.5 6" })
        }
      );
    }
  )
);

// src/IconShieldFilled/IconShieldFilled.tsx
var IconShieldFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconShieldFilledMonochromeExtralight,
          "monochrome|light": IconShieldFilledMonochromeLight,
          "monochrome|regular": IconShieldFilledMonochromeRegular,
          "monochrome|medium": IconShieldFilledMonochromeMedium,
          "monochrome|semibold": IconShieldFilledMonochromeSemibold,
          "monochrome|bold": IconShieldFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconShoppingBagMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 3.5a2.4 2.4 0 0 0-2.4 2.4c0 .35.003 1.031.007 1.7H14.4V5.9A2.4 2.4 0 0 0 12 3.5m3.6 4.1V5.9a3.6 3.6 0 1 0-7.2 0c0 .353.003 1.033.007 1.7h-.289a2.6 2.6 0 0 0-2.597 2.492l-.334 8A2.6 2.6 0 0 0 7.785 20.8h8.43a2.6 2.6 0 0 0 2.598-2.708l-.334-8A2.6 2.6 0 0 0 15.882 7.6zm-1.2 1.2v.6a.6.6 0 0 0 1.2 0v-.6h.282a1.4 1.4 0 0 1 1.398 1.342l.334 8a1.4 1.4 0 0 1-1.399 1.458h-8.43a1.4 1.4 0 0 1-1.399-1.459l.334-8A1.4 1.4 0 0 1 8.118 8.8h.296v.174l.003.43a.6.6 0 0 0 1.2-.008l-.002-.43-.001-.166z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconShoppingBagMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.118 6.7h7.764a3.5 3.5 0 0 1 3.497 3.354l.333 8a3.5 3.5 0 0 1-3.497 3.646h-8.43a3.5 3.5 0 0 1-3.497-3.646l.333-8A3.5 3.5 0 0 1 8.118 6.7m0 1.5a2 2 0 0 0-1.998 1.916l-.333 8A2 2 0 0 0 7.785 20.2h8.43a2 2 0 0 0 1.998-2.084l-.333-8A2 2 0 0 0 15.882 8.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 3.65A2.25 2.25 0 0 0 9.75 5.9a487 487 0 0 0 .015 3.065l.002.43-1.5.01-.002-.43L8.25 5.9a3.75 3.75 0 1 1 7.5 0v3.5h-1.5V5.9A2.25 2.25 0 0 0 12 3.65m-2.978 6.5a.75.75 0 0 1-.755-.745l1.5-.01a.75.75 0 0 1-.745.755m5.978 0a.75.75 0 0 1-.75-.75h1.5a.75.75 0 0 1-.75.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconShoppingBagMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.118 6.4h7.764a3.8 3.8 0 0 1 3.796 3.642l.334 8A3.8 3.8 0 0 1 16.215 22h-8.43a3.8 3.8 0 0 1-3.797-3.958l.334-8A3.8 3.8 0 0 1 8.118 6.4m0 1.8a2 2 0 0 0-1.998 1.917l-.333 8A2 2 0 0 0 7.785 20.2h8.43a2 2 0 0 0 1.998-2.083l-.333-8A2 2 0 0 0 15.882 8.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 3.8a2.1 2.1 0 0 0-2.1 2.1 489 489 0 0 0 .015 3.065l.002.429-1.8.012-.002-.43L8.1 5.9a3.9 3.9 0 1 1 7.8 0v3.5h-1.8V5.9A2.1 2.1 0 0 0 12 3.8m-2.977 6.5a.9.9 0 0 1-.906-.894l1.8-.012a.9.9 0 0 1-.894.906m5.977 0a.9.9 0 0 1-.9-.9h1.8a.9.9 0 0 1-.9.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconShoppingBagMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.118 6.067h7.764a4.133 4.133 0 0 1 4.13 3.961l.333 8a4.133 4.133 0 0 1-4.13 4.305h-8.43a4.133 4.133 0 0 1-4.13-4.305l.334-8a4.133 4.133 0 0 1 4.13-3.961m0 2.133a2 2 0 0 0-1.998 1.917l-.333 8A2 2 0 0 0 7.785 20.2h8.43a2 2 0 0 0 1.998-2.083l-.333-8A2 2 0 0 0 15.882 8.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 3.967A1.933 1.933 0 0 0 10.067 5.9c0 .413.004 1.284.008 2.056l.01 1.437-2.134.014-.009-1.439A489 489 0 0 1 7.933 5.9a4.067 4.067 0 1 1 8.134 0v3.499l-2.134.001V5.9A1.933 1.933 0 0 0 12 3.967m-2.976 6.5c-.589.003-1.07-.47-1.073-1.06l2.133-.014c.004.589-.47 1.07-1.06 1.074m5.976 0c-.59 0-1.067-.478-1.067-1.067l2.134-.001c0 .59-.478 1.068-1.067 1.068",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconShoppingBagMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.118 5.95h7.763a4.25 4.25 0 0 1 4.247 4.074l.333 8a4.25 4.25 0 0 1-4.246 4.426h-8.43a4.25 4.25 0 0 1-4.247-4.427l.334-8A4.25 4.25 0 0 1 9.118 5.95m0 2.25a2 2 0 0 0-1.998 1.917l-.334 8A2 2 0 0 0 8.785 20.2h8.43a2 2 0 0 0 1.998-2.083l-.334-8A2 2 0 0 0 16.882 8.2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13 4.025c-1.036 0-1.875.84-1.875 1.875 0 .413.004 1.284.008 2.056l.009 1.437-2.25.015-.009-1.439A489 489 0 0 1 8.875 5.9a4.125 4.125 0 0 1 8.25 0v3.5h-2.25V5.9c0-1.035-.84-1.875-1.875-1.875m-2.976 6.5a1.125 1.125 0 0 1-1.132-1.117l2.25-.015a1.125 1.125 0 0 1-1.118 1.132m5.976 0A1.125 1.125 0 0 1 14.875 9.4h2.25c0 .621-.504 1.125-1.125 1.125",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconShoppingBagMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.118 5.8h7.763a4.4 4.4 0 0 1 4.397 4.216l.333 8a4.4 4.4 0 0 1-4.396 4.583h-8.43a4.4 4.4 0 0 1-4.396-4.583l.333-8a4.4 4.4 0 0 1 4.396-4.217m0 2.4a2 2 0 0 0-1.998 1.916l-.333 8a2 2 0 0 0 1.998 2.083h8.43a2 2 0 0 0 1.998-2.083l-.333-8a2 2 0 0 0-1.999-1.917z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 4.1a1.8 1.8 0 0 0-1.8 1.8c0 .412.004 1.283.009 2.055l.008 1.434-1.2.01-1.2.008-.008-1.439c-.005-.77-.01-1.648-.01-2.069a4.2 4.2 0 1 1 8.4 0v3.5h-2.4V5.9A1.8 1.8 0 0 0 12 4.1m-2.975 6.5a1.2 1.2 0 0 1-1.208-1.193l1.2-.008 1.2-.01a1.2 1.2 0 0 1-1.192 1.21m5.975 0a1.2 1.2 0 0 1-1.2-1.2l2.4-.001a1.2 1.2 0 0 1-1.2 1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconShoppingBag/IconShoppingBag.tsx
var IconShoppingBag = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconShoppingBagMonochromeExtralight,
          "monochrome|light": IconShoppingBagMonochromeLight,
          "monochrome|regular": IconShoppingBagMonochromeRegular,
          "monochrome|medium": IconShoppingBagMonochromeMedium,
          "monochrome|semibold": IconShoppingBagMonochromeSemibold,
          "monochrome|bold": IconShoppingBagMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M43.4 17a1.2 1.2 0 0 1-1.2 1.2H24a1.2 1.2 0 0 1 0-2.4h18.2a1.2 1.2 0 0 1 1.2 1.2M14.2 17a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4H13a1.2 1.2 0 0 1 1.2 1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.3 20.6a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M43.4 31a1.2 1.2 0 0 1-1.2 1.2H36a1.2 1.2 0 0 1 0-2.4h6.2a1.2 1.2 0 0 1 1.2 1.2M24.7 31a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4h17.7a1.2 1.2 0 0 1 1.2 1.2",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M29.7 35a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M29.134 11.333a1 1 0 0 1-1 1H15.467a1 1 0 1 1 0-2h12.667a1 1 0 0 1 1 1M9.667 11.333a1 1 0 0 1-1 1h-4.8a1 1 0 1 1 0-2h4.8a1 1 0 0 1 1 1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.2 13.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666M29.133 20.667a1 1 0 0 1-1 1H24a1 1 0 1 1 0-2h4.133a1 1 0 0 1 1 1M17.667 20.667a1 1 0 0 1-1 1h-12.8a1 1 0 1 1 0-2h12.8a1 1 0 0 1 1 1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M19.8 22.933a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M22 8.5a.9.9 0 0 1-.9.9h-9.5a.9.9 0 1 1 0-1.8h9.5a.9.9 0 0 1 .9.9M7.4 8.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h3.6a.9.9 0 0 1 .9.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.15 9.7a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M22 15.5a.9.9 0 0 1-.9.9H18a.9.9 0 1 1 0-1.8h3.1a.9.9 0 0 1 .9.9M13.4 15.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h9.6a.9.9 0 0 1 .9.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.85 16.9a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.092 7.175a2.438 2.438 0 0 1-4.459 0H2.175a.8.8 0 0 1 0-1.6h2.328a2.439 2.439 0 0 1 4.72 0h6.602a.8.8 0 0 1 0 1.6zM7.7 6.188a.837.837 0 1 1-1.675 0 .837.837 0 0 1 1.675 0M13.428 12.422a2.438 2.438 0 0 1-4.58.003H2.175a.8.8 0 0 1 0-1.6H8.82a2.439 2.439 0 0 1 4.633.002l.046-.002h2.325a.8.8 0 1 1 0 1.6H13.5zm-1.453-.835a.838.838 0 1 1-1.675 0 .838.838 0 0 1 1.675 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.867 5.667a.8.8 0 0 1-.8.8H7.733a.8.8 0 0 1 0-1.6h6.334a.8.8 0 0 1 .8.8M5.133 5.667a.8.8 0 0 1-.8.8h-2.4a.8.8 0 0 1 0-1.6h2.4a.8.8 0 0 1 .8.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.03 6.3a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6M14.867 10.333a.8.8 0 0 1-.8.8H12a.8.8 0 1 1 0-1.6h2.067a.8.8 0 0 1 .8.8M9.133 10.333a.8.8 0 0 1-.8.8h-6.4a.8.8 0 1 1 0-1.6h6.4a.8.8 0 0 1 .8.8",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.97 11a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSliderHorizontalMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.15 4.25a.6.6 0 0 1-.6.6H5.8a.6.6 0 0 1 0-1.2h4.75a.6.6 0 0 1 .6.6M3.85 4.25a.6.6 0 0 1-.6.6h-1.8a.6.6 0 0 1 0-1.2h1.8a.6.6 0 0 1 .6.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.65 4.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M11.15 7.75a.6.6 0 0 1-.6.6H9a.6.6 0 0 1 0-1.2h1.55a.6.6 0 0 1 .6.6M6.85 7.75a.6.6 0 0 1-.6.6h-4.8a.6.6 0 0 1 0-1.2h4.8a.6.6 0 0 1 .6.6",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.45 8.3a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconSliderHorizontal/IconSliderHorizontal.tsx
var IconSliderHorizontal = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSliderHorizontalMonochromeExtralight,
          "monochrome|light": IconSliderHorizontalMonochromeLight,
          "monochrome|regular": IconSliderHorizontalMonochromeRegular,
          "monochrome|medium": IconSliderHorizontalMonochromeMedium,
          "monochrome|semibold": IconSliderHorizontalMonochromeSemibold,
          "monochrome|bold": IconSliderHorizontalMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M7.37 3.297a2.4 2.4 0 0 1 3.394 0l31.3 31.3a2.4 2.4 0 1 1-3.394 3.395l-31.3-31.3a2.4 2.4 0 0 1 0-3.395M9.94 16H9a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h5l10.698 9.17c1.298 1.112 3.302.19 3.302-1.519v-5.59z" }),
            /* @__PURE__ */ jsx("path", { d: "M28 27.273V8.348c0-1.708-2.004-2.63-3.302-1.518l-9.23 7.911z" })
          ]
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M4.913 2.198a1.6 1.6 0 0 1 2.263 0l20.867 20.867a1.6 1.6 0 1 1-2.263 2.263L4.913 4.46a1.6 1.6 0 0 1 0-2.263M6.626 10.667H6A3.333 3.333 0 0 0 2.667 14v4A3.333 3.333 0 0 0 6 21.333h3.333l7.133 6.114c.865.741 2.2.126 2.2-1.013v-3.727z" }),
            /* @__PURE__ */ jsx("path", { d: "M18.667 18.182V5.566c0-1.14-1.336-1.754-2.201-1.013l-6.154 5.274z" })
          ]
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M3.685 1.648a1.2 1.2 0 0 1 1.697 0l15.65 15.65a1.2 1.2 0 1 1-1.697 1.698L3.685 3.346a1.2 1.2 0 0 1 0-1.698M4.97 8H4.5A2.5 2.5 0 0 0 2 10.5v3A2.5 2.5 0 0 0 4.5 16H7l5.35 4.585a1 1 0 0 0 1.65-.76V17.03z" }),
            /* @__PURE__ */ jsx("path", { d: "M14 13.636V4.174a1 1 0 0 0-1.65-.76L7.733 7.37z" })
          ]
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.764 1.236a.9.9 0 0 1 1.272 0l11.738 11.738a.9.9 0 1 1-1.273 1.273L2.764 2.509a.9.9 0 0 1 0-1.273M3.727 6h-.352C2.339 6 1.5 6.84 1.5 7.875v2.25C1.5 11.161 2.34 12 3.375 12H5.25l4.012 3.439a.75.75 0 0 0 1.238-.57v-2.096z" }),
            /* @__PURE__ */ jsx("path", { d: "M10.5 10.227V3.131a.75.75 0 0 0-1.238-.57L5.8 5.528z" })
          ]
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.456 1.1a.8.8 0 0 1 1.132 0L14.02 11.532a.8.8 0 0 1-1.131 1.131L2.456 2.23a.8.8 0 0 1 0-1.13M3.313 5.333H3c-.92 0-1.667.747-1.667 1.667v2c0 .92.746 1.667 1.667 1.667h1.667l3.566 3.056a.667.667 0 0 0 1.1-.506v-1.863z" }),
            /* @__PURE__ */ jsx("path", { d: "M9.333 9.09V2.784a.667.667 0 0 0-1.1-.506L5.156 4.914z" })
          ]
        }
      );
    }
  )
);
var IconSpeakerSlashFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M1.842.824a.6.6 0 0 1 .849 0l7.825 7.825a.6.6 0 1 1-.848.849L1.842 1.673a.6.6 0 0 1 0-.849M2.485 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V8.515z" }),
            /* @__PURE__ */ jsx("path", { d: "M7 6.818v-4.73a.5.5 0 0 0-.825-.38L3.867 3.684z" })
          ]
        }
      );
    }
  )
);

// src/IconSpeakerSlashFilled/IconSpeakerSlashFilled.tsx
var IconSpeakerSlashFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSpeakerSlashFilledMonochromeExtralight,
          "monochrome|light": IconSpeakerSlashFilledMonochromeLight,
          "monochrome|regular": IconSpeakerSlashFilledMonochromeRegular,
          "monochrome|medium": IconSpeakerSlashFilledMonochromeMedium,
          "monochrome|semibold": IconSpeakerSlashFilledMonochromeSemibold,
          "monochrome|bold": IconSpeakerSlashFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.303c0 1.71-2.004 2.63-3.302 1.519L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M37.727 12.727a1.8 1.8 0 0 1 2.546 0c6.231 6.232 6.231 16.314 0 22.546a1.8 1.8 0 0 1-2.546-2.546 12.33 12.33 0 0 0 0-17.454 1.8 1.8 0 0 1 0-2.546m-5 5.362a1.8 1.8 0 0 1 2.546 0 8.36 8.36 0 0 1 0 11.822 1.8 1.8 0 0 1-2.546-2.546 4.76 4.76 0 0 0 0-6.73 1.8 1.8 0 0 1 0-2.546",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M25.152 8.485a1.2 1.2 0 0 1 1.697 0 10.62 10.62 0 0 1 0 15.03 1.2 1.2 0 1 1-1.697-1.697 8.22 8.22 0 0 0 0-11.636 1.2 1.2 0 0 1 0-1.697m-3.334 3.574a1.2 1.2 0 0 1 1.697 0 5.574 5.574 0 0 1 0 7.881 1.2 1.2 0 1 1-1.697-1.697 3.174 3.174 0 0 0 0-4.487 1.2 1.2 0 0 1 0-1.697",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.864 6.364a.9.9 0 0 1 1.272 0 7.966 7.966 0 0 1 0 11.272.9.9 0 1 1-1.272-1.273 6.166 6.166 0 0 0 0-8.727.9.9 0 0 1 0-1.272m-2.5 2.68a.9.9 0 0 1 1.272 0 4.18 4.18 0 0 1 0 5.911.9.9 0 0 1-1.272-1.272 2.38 2.38 0 0 0 0-3.366.9.9 0 0 1 0-1.273",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.148 4.773a.675.675 0 0 1 .954 0 5.974 5.974 0 0 1 0 8.454.675.675 0 0 1-.954-.954 4.624 4.624 0 0 0 0-6.546.675.675 0 0 1 0-.954m-1.875 2.01a.675.675 0 0 1 .954 0 3.136 3.136 0 0 1 0 4.434.675.675 0 0 1-.954-.955 1.786 1.786 0 0 0 0-2.524.675.675 0 0 1 0-.955",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.747-1.667-1.667V7c0-.92.746-1.667 1.667-1.667z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.576 4.242a.6.6 0 0 1 .848 0 5.31 5.31 0 0 1 0 7.516.6.6 0 1 1-.848-.85 4.11 4.11 0 0 0 0-5.817.6.6 0 0 1 0-.849M10.909 6.03a.6.6 0 0 1 .848 0 2.787 2.787 0 0 1 0 3.941.6.6 0 1 1-.848-.848c.62-.62.62-1.625 0-2.244a.6.6 0 0 1 0-.849",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSpeakerWave2FilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "m3.5 4 2.675-2.293a.5.5 0 0 1 .825.38v7.826a.5.5 0 0 1-.825.38L3.5 8H2.25C1.56 8 1 7.44 1 6.75v-1.5C1 4.56 1.56 4 2.25 4z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.432 3.182a.45.45 0 0 1 .636 0 3.983 3.983 0 0 1 0 5.636.45.45 0 0 1-.636-.636 3.083 3.083 0 0 0 0-4.364.45.45 0 0 1 0-.636m-1.25 1.34a.45.45 0 0 1 .636 0 2.09 2.09 0 0 1 0 2.956.45.45 0 0 1-.636-.637 1.19 1.19 0 0 0 0-1.682.45.45 0 0 1 0-.637",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconSpeakerWave2Filled/IconSpeakerWave2Filled.tsx
var IconSpeakerWave2Filled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSpeakerWave2FilledMonochromeExtralight,
          "monochrome|light": IconSpeakerWave2FilledMonochromeLight,
          "monochrome|regular": IconSpeakerWave2FilledMonochromeRegular,
          "monochrome|medium": IconSpeakerWave2FilledMonochromeMedium,
          "monochrome|semibold": IconSpeakerWave2FilledMonochromeSemibold,
          "monochrome|bold": IconSpeakerWave2FilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.304c0 1.708-2.004 2.63-3.302 1.518L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5zM33.132 26.72a1.6 1.6 0 0 0 2.262 2.262l3.328-3.327 3.327 3.327a1.6 1.6 0 1 0 2.263-2.262l-3.328-3.328 3.328-3.327a1.6 1.6 0 0 0-2.263-2.263l-3.327 3.327-3.328-3.327a1.6 1.6 0 1 0-2.262 2.263l3.327 3.327z" })
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667zM22.088 17.813a1.067 1.067 0 1 0 1.508 1.508l2.218-2.218 2.219 2.218a1.067 1.067 0 1 0 1.508-1.508l-2.218-2.218 2.218-2.219a1.067 1.067 0 0 0-1.508-1.508l-2.219 2.218-2.218-2.218a1.067 1.067 0 0 0-1.508 1.508l2.218 2.219z" })
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8zM17.697 8.901a.8.8 0 0 0-1.131 1.131l1.663 1.664-1.663 1.664a.8.8 0 0 0 1.131 1.131l1.664-1.664 1.663 1.664a.8.8 0 1 0 1.132-1.131l-1.664-1.664 1.664-1.664a.8.8 0 1 0-1.131-1.131l-1.664 1.664z" })
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6zM13.273 6.676a.6.6 0 1 0-.849.848l1.248 1.248-1.248 1.248a.6.6 0 0 0 .849.848l1.248-1.247 1.247 1.247a.6.6 0 0 0 .849-.848l-1.248-1.248 1.248-1.248a.6.6 0 0 0-.849-.848l-1.247 1.247z" })
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.746-1.667-1.667V7c0-.92.746-1.667 1.667-1.667zM11.798 5.934a.533.533 0 0 0-.754.754l1.109 1.11-1.11 1.109a.533.533 0 0 0 .755.754l1.11-1.11 1.108 1.11a.533.533 0 0 0 .755-.754l-1.11-1.11 1.11-1.109a.533.533 0 1 0-.755-.754l-1.109 1.11z" })
        }
      );
    }
  )
);
var IconSpeakerXFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.175 1.708 3.5 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V2.087a.5.5 0 0 0-.825-.38M8.283 7.245a.4.4 0 0 1 0-.565l.832-.832-.832-.832a.4.4 0 0 1 .566-.566l.831.832.832-.832a.4.4 0 0 1 .566.566l-.832.832.832.832a.4.4 0 0 1-.566.565l-.832-.831-.831.831a.4.4 0 0 1-.566 0" })
        }
      );
    }
  )
);

// src/IconSpeakerXFilled/IconSpeakerXFilled.tsx
var IconSpeakerXFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSpeakerXFilledMonochromeExtralight,
          "monochrome|light": IconSpeakerXFilledMonochromeLight,
          "monochrome|regular": IconSpeakerXFilledMonochromeRegular,
          "monochrome|medium": IconSpeakerXFilledMonochromeMedium,
          "monochrome|semibold": IconSpeakerXFilledMonochromeSemibold,
          "monochrome|bold": IconSpeakerXFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 90c-25.405 0-46 20.595-46 46v208c0 25.405 20.595 46 46 46h208c25.405 0 46-20.595 46-46V240c0-6.627 5.373-12 12-12s12 5.373 12 12v104c0 38.66-31.34 70-70 70H136c-38.66 0-70-31.34-70-70V136c0-38.66 31.34-70 70-70h104c6.627 0 12 5.373 12 12s-5.373 12-12 12z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M188.802 225.473a12 12 0 0 1 3.515-8.501L358.061 51.228c19.526-19.526 51.184-19.526 70.711 0 19.526 19.527 19.526 51.185 0 70.711L263.028 287.683a12 12 0 0 1-8.501 3.515l-53.672-.068c-6.616-.008-11.977-5.369-11.985-11.985zm24.007 4.949.046 36.723 36.723.046 132.878-132.878-36.769-36.77zM362.657 80.573l36.77 36.77 12.374-12.374c10.154-10.154 10.154-26.616 0-36.77s-26.616-10.154-36.769 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 93c-23.748 0-43 19.252-43 43v208c0 23.748 19.252 43 43 43h208c23.748 0 43-19.252 43-43V240c0-8.284 6.716-15 15-15s15 6.716 15 15v104c0 40.317-32.683 73-73 73H136c-40.317 0-73-32.683-73-73V136c0-40.317 32.683-73 73-73h104c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M185.802 225.476a15 15 0 0 1 4.394-10.625L355.94 49.107c20.697-20.698 54.255-20.698 74.953 0s20.698 54.256 0 74.953L265.149 289.804a15 15 0 0 1-10.625 4.394l-53.673-.068c-8.269-.01-14.971-6.712-14.981-14.981zm30.008 6.187.041 32.486 32.486.041 129.876-129.877-32.526-32.526zM366.9 80.573l32.527 32.527 10.253-10.253c8.982-8.982 8.982-23.545 0-32.527s-23.545-8.982-32.527 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 96c-22.091 0-40 17.909-40 40v208c0 22.091 17.909 40 40 40h208c22.091 0 40-17.909 40-40V240c0-9.941 8.059-18 18-18s18 8.059 18 18v104c0 41.974-34.026 76-76 76H136c-41.974 0-76-34.026-76-76V136c0-41.974 34.026-76 76-76h104c9.941 0 18 8.059 18 18s-8.059 18-18 18z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M182.802 225.48a18 18 0 0 1 5.273-12.75L353.818 46.986c21.87-21.87 57.327-21.87 79.196 0 21.87 21.87 21.87 57.326 0 79.196L267.27 291.925a18 18 0 0 1-12.75 5.273l-53.673-.068c-9.923-.013-17.964-8.054-17.977-17.977zm36.01 7.424.035 28.249 28.249.035 126.875-126.875-28.284-28.284zm152.33-152.33 28.285 28.284 8.131-8.132c7.811-7.81 7.811-20.474 0-28.284-7.81-7.81-20.473-7.81-28.284 0l-8.132 8.131Z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 99.333c-20.25 0-36.666 16.417-36.666 36.667v208c0 20.25 16.416 36.667 36.666 36.667h208c20.251 0 36.667-16.417 36.667-36.667V240c0-11.782 9.551-21.333 21.333-21.333s21.334 9.551 21.334 21.333v104c0 43.815-35.519 79.333-79.334 79.333H136c-43.814 0-79.333-35.518-79.333-79.333V136c0-43.815 35.519-79.333 79.333-79.333h104c11.782 0 21.334 9.55 21.334 21.333S251.782 99.333 240 99.333z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M179.468 225.484a21.34 21.34 0 0 1 6.249-15.113L351.46 44.628c23.172-23.172 60.741-23.172 83.913 0 23.172 23.171 23.172 60.74 0 83.912L269.629 294.284a21.34 21.34 0 0 1-15.113 6.249l-53.672-.068c-11.762-.015-21.294-9.546-21.309-21.308zm42.681 8.8.03 23.538 23.538.029 121.538-121.538-23.568-23.567zm151.71-151.71 23.568 23.567 7.774-7.773c6.508-6.508 6.508-17.06 0-23.568-6.509-6.508-17.06-6.508-23.568 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 100.5c-19.606 0-35.5 15.894-35.5 35.5v208c0 19.606 15.894 35.5 35.5 35.5h208c19.606 0 35.5-15.894 35.5-35.5V240c0-12.426 10.074-22.5 22.5-22.5s22.5 10.074 22.5 22.5v104c0 44.459-36.041 80.5-80.5 80.5H136c-44.459 0-80.5-36.041-80.5-80.5V136c0-44.459 36.041-80.5 80.5-80.5h104c12.426 0 22.5 10.073 22.5 22.5s-10.074 22.5-22.5 22.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M178.302 225.486a22.5 22.5 0 0 1 6.591-15.938L350.636 43.804c23.627-23.627 61.934-23.627 85.56 0s23.627 61.933 0 85.56L270.452 295.107a22.5 22.5 0 0 1-15.938 6.591l-53.672-.068c-12.405-.016-22.456-10.067-22.472-22.472zm45.012 9.28.028 21.892 21.892.028 118.373-118.373-21.92-21.92zM373.506 84.573l21.921 21.921 8.949-8.95c6.054-6.053 6.054-15.867 0-21.92-6.053-6.053-15.867-6.053-21.92 0l-8.95 8.95Z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareAndPencilMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M136 102c-18.778 0-34 15.222-34 34v208c0 18.778 15.222 34 34 34h208c18.778 0 34-15.222 34-34V240c0-13.255 10.745-24 24-24s24 10.745 24 24v104c0 45.287-36.713 82-82 82H136c-45.287 0-82-36.713-82-82V136c0-45.287 36.713-82 82-82h104c13.255 0 24 10.745 24 24s-10.745 24-24 24z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M176.802 225.488a24 24 0 0 1 7.03-17.001L349.576 42.743c24.212-24.212 63.468-24.212 87.681 0 24.212 24.213 24.212 63.469 0 87.681L271.513 296.168a24 24 0 0 1-17.001 7.03l-53.672-.068c-13.231-.017-23.953-10.739-23.97-23.97zm48.013 9.898.025 19.774 19.774.025 114.872-114.872-19.799-19.799zM373.628 86.573l19.799 19.799 9.889-9.889c5.467-5.467 5.467-14.331 0-19.799-5.468-5.467-14.332-5.467-19.799 0l-9.889 9.89Z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconSquareAndPencil/IconSquareAndPencil.tsx
var IconSquareAndPencil = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSquareAndPencilMonochromeExtralight,
          "monochrome|light": IconSquareAndPencilMonochromeLight,
          "monochrome|regular": IconSquareAndPencilMonochromeRegular,
          "monochrome|medium": IconSquareAndPencilMonochromeMedium,
          "monochrome|semibold": IconSquareAndPencilMonochromeSemibold,
          "monochrome|bold": IconSquareAndPencilMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM6 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4z" })
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4 7a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM4 20.4a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM17.4 7a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3zM17.4 20.4a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3z" })
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM13 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zM13 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2z" })
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2.25 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM2.25 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z" })
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M2 3.3A1.3 1.3 0 0 1 3.3 2h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9a1.3 1.3 0 0 1-1.3 1.3H3.3A1.3 1.3 0 0 1 2 6.2zM2 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9A1.3 1.3 0 0 1 6.2 14H3.3A1.3 1.3 0 0 1 2 12.7zM8.5 3.3A1.3 1.3 0 0 1 9.8 2h2.9A1.3 1.3 0 0 1 14 3.3v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3zM8.5 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9A1.3 1.3 0 0 1 14 9.8v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3z" })
        }
      );
    }
  )
);
var IconSquareGrid2X2FilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M1.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" })
        }
      );
    }
  )
);

// src/IconSquareGrid2X2Filled/IconSquareGrid2X2Filled.tsx
var IconSquareGrid2X2Filled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSquareGrid2X2FilledMonochromeExtralight,
          "monochrome|light": IconSquareGrid2X2FilledMonochromeLight,
          "monochrome|regular": IconSquareGrid2X2FilledMonochromeRegular,
          "monochrome|medium": IconSquareGrid2X2FilledMonochromeMedium,
          "monochrome|semibold": IconSquareGrid2X2FilledMonochromeSemibold,
          "monochrome|bold": IconSquareGrid2X2FilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M32 8.3H12a3.6 3.6 0 0 0-3.6 3.6v20a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6v-20A3.6 3.6 0 0 0 32 8.3M12 5.9a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 1 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M21.5 5.5H8a2 2 0 0 0-2 2V21a2 2 0 0 0 2 2h13.5a2 2 0 0 0 2-2V7.5a2 2 0 0 0-2-2M8 3.5a4 4 0 0 0-4 4V21a4 4 0 0 0 4 4h13.5a4 4 0 0 0 4-4V7.5a4 4 0 0 0-4-4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 4.35H6a1.2 1.2 0 0 0-1.2 1.2v10a1.2 1.2 0 0 0 1.2 1.2h10a1.2 1.2 0 0 0 1.2-1.2v-10a1.2 1.2 0 0 0-1.2-1.2M6 2.55a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M11.55 3.45h-6.8a.9.9 0 0 0-.9.9v6.8a.9.9 0 0 0 .9.9h6.8a.9.9 0 0 0 .9-.9v-6.8a.9.9 0 0 0-.9-.9m-6.8-1.6a2.5 2.5 0 0 0-2.5 2.5v6.8a2.5 2.5 0 0 0 2.5 2.5h6.8a2.5 2.5 0 0 0 2.5-2.5v-6.8a2.5 2.5 0 0 0-2.5-2.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.5 3.125H4a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5M4 1.625a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.6 2.4H3a.3.3 0 0 0-.3.3v4.6a.3.3 0 0 0 .3.3h4.6a.3.3 0 0 0 .3-.3V2.7a.3.3 0 0 0-.3-.3M3 1.2a1.5 1.5 0 0 0-1.5 1.5v4.6A1.5 1.5 0 0 0 3 8.8h4.6a1.5 1.5 0 0 0 1.5-1.5V2.7a1.5 1.5 0 0 0-1.5-1.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.45a3.15 3.15 0 0 1-3.15 3.15H3.5a.6.6 0 0 1 0-1.2h4.45A1.95 1.95 0 0 0 9.9 7.65V3.2a.6.6 0 0 1 .6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconSquareOnSquare/IconSquareOnSquare.tsx
var IconSquareOnSquare = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSquareOnSquareMonochromeExtralight,
          "monochrome|light": IconSquareOnSquareMonochromeLight,
          "monochrome|regular": IconSquareOnSquareMonochromeRegular,
          "monochrome|medium": IconSquareOnSquareMonochromeMedium,
          "monochrome|semibold": IconSquareOnSquareMonochromeSemibold,
          "monochrome|bold": IconSquareOnSquareMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6 11.9a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 0 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M4 7.5a4 4 0 0 1 4-4h13.5a4 4 0 0 1 4 4V21a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M3 5.55a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.25 4.35a2.5 2.5 0 0 1 2.5-2.5h6.8a2.5 2.5 0 0 1 2.5 2.5v6.8a2.5 2.5 0 0 1-2.5 2.5h-6.8a2.5 2.5 0 0 1-2.5-2.5z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2 3.625a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconSquareOnSquareFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M1.5 2.7A1.5 1.5 0 0 1 3 1.2h4.6a1.5 1.5 0 0 1 1.5 1.5v4.6a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.5A3.1 3.1 0 0 1 8 10.8H3.5a.6.6 0 0 1 0-1.2H8a1.9 1.9 0 0 0 1.9-1.9V3.2a.6.6 0 0 1 .6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconSquareOnSquareFilled/IconSquareOnSquareFilled.tsx
var IconSquareOnSquareFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconSquareOnSquareFilledMonochromeExtralight,
          "monochrome|light": IconSquareOnSquareFilledMonochromeLight,
          "monochrome|regular": IconSquareOnSquareFilledMonochromeRegular,
          "monochrome|medium": IconSquareOnSquareFilledMonochromeMedium,
          "monochrome|semibold": IconSquareOnSquareFilledMonochromeSemibold,
          "monochrome|bold": IconSquareOnSquareFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconStarMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStarMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.402l5.708-.602a.13.13 0 0 0 .107-.078zm2.239.917c-.011.006-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.017-.072.026a.15.15 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.033.042.063l4.264 3.842c.672.605.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.022.073.021a.15.15 0 0 0 .072-.028.14.14 0 0 0 .05-.06c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.15.15 0 0 0-.042-.066c-.01-.009-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.054-.047-.06A.15.15 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStarMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStarMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStarMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.587a.05.05 0 0 0 .04.03l2.818.297c1.334.14 1.871 1.795.875 2.693L12.23 9.837a.05.05 0 0 0-.015.048l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.771a.05.05 0 0 0-.015-.048L1.73 7.941c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.004-.007.004a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.771-.002.021.001.007a.1.1 0 0 0 .02.023.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.008.007.001a.1.1 0 0 0 .028-.012.1.1 0 0 0 .02-.023l.001-.007-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.004-.02-.004-2.818-.298a1.55 1.55 0 0 1-1.253-.91L8.079 2.945l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStarMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.987 1.852c.38-.895 1.647-.895 2.026 0l.855 2.016 2.127.236c.931.104 1.315 1.248.636 1.892L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.892l2.127-.236zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.218 1.51 1.432a1.1 1.1 0 0 1 .322 1.016L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.432-1.97-.218a1.1 1.1 0 0 1-.892-.664z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconStar/IconStar.tsx
var IconStar = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconStarMonochromeExtralight,
          "monochrome|light": IconStarMonochromeLight,
          "monochrome|regular": IconStarMonochromeRegular,
          "monochrome|medium": IconStarMonochromeMedium,
          "monochrome|semibold": IconStarMonochromeSemibold,
          "monochrome|bold": IconStarMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconStarFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M22.173 5.598c.705-1.58 2.95-1.58 3.654 0l4.334 9.723a2 2 0 0 0 1.616 1.174l10.586 1.118c1.722.181 2.415 2.316 1.13 3.474l-7.908 7.127a2 2 0 0 0-.618 1.9l2.209 10.413c.36 1.694-1.456 3.012-2.956 2.148L25 37.356a2 2 0 0 0-2 0l-9.22 5.319c-1.5.864-3.315-.454-2.956-2.148l2.209-10.413a2 2 0 0 0-.618-1.9l-7.907-7.127c-1.286-1.158-.593-3.293 1.129-3.474l10.586-1.118a2 2 0 0 0 1.617-1.174z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStarFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M14.782 5.732c.47-1.054 1.966-1.054 2.436 0l2.336 5.242c.194.435.605.733 1.078.784l5.708.602c1.148.121 1.61 1.544.753 2.316l-4.264 3.843c-.353.318-.51.801-.412 1.267l1.191 5.614c.24 1.13-.97 2.008-1.97 1.432l-4.972-2.868a1.33 1.33 0 0 0-1.332 0l-4.972 2.868c-1 .576-2.21-.303-1.97-1.432l1.19-5.614a1.33 1.33 0 0 0-.411-1.267l-4.264-3.843c-.857-.772-.395-2.195.753-2.316l5.708-.602c.473-.05.884-.349 1.077-.784z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.401l5.708-.603a.13.13 0 0 0 .107-.078zm2.239.917c-.011.007-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.018-.072.026a.14.14 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.034.042.063l4.264 3.842c.672.606.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.023.073.022a.14.14 0 0 0 .072-.03.14.14 0 0 0 .05-.059c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.14.14 0 0 0-.042-.066c-.01-.008-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.053-.047-.06A.14.14 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStarFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M11.087 4.299c.352-.79 1.474-.79 1.826 0l1.753 3.932a1 1 0 0 0 .808.587l4.281.452c.86.09 1.207 1.158.565 1.737l-3.198 2.882a1 1 0 0 0-.309.95l.893 4.211c.18.847-.728 1.506-1.477 1.074l-3.73-2.15a1 1 0 0 0-.999 0l-3.728 2.15c-.75.432-1.658-.227-1.478-1.074l.893-4.21a1 1 0 0 0-.309-.951L3.68 11.007c-.642-.58-.296-1.646.565-1.737l4.28-.452a1 1 0 0 0 .81-.587z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStarFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M8.087 3.05c.352-.791 1.474-.791 1.826 0l1.2 2.691a1 1 0 0 0 .809.588l2.931.309c.86.09 1.207 1.158.565 1.737l-2.19 1.973a1 1 0 0 0-.309.95l.612 2.884c.18.847-.728 1.506-1.478 1.074L9.5 13.783a1 1 0 0 0-1 0l-2.553 1.473c-.75.432-1.657-.227-1.478-1.074l.612-2.883a1 1 0 0 0-.309-.95l-2.19-1.974c-.642-.58-.296-1.646.565-1.737l2.931-.31a1 1 0 0 0 .809-.587z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStarFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M7.302 2.64a.8.8 0 0 1 1.462 0l1.153 2.587a.8.8 0 0 0 .647.47l2.817.297a.8.8 0 0 1 .452 1.39L11.728 9.28a.8.8 0 0 0-.247.76l.588 2.772a.8.8 0 0 1-1.182.859l-2.454-1.415a.8.8 0 0 0-.8 0L5.18 13.67a.8.8 0 0 1-1.182-.859l.588-2.771a.8.8 0 0 0-.247-.76L2.233 7.383a.8.8 0 0 1 .452-1.39l2.817-.297a.8.8 0 0 0 .647-.47z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.588a.05.05 0 0 0 .04.029l2.818.297c1.334.141 1.871 1.795.875 2.693L12.23 9.838a.05.05 0 0 0-.015.047l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.77a.05.05 0 0 0-.015-.048L1.73 7.94c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.005-.007.003a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.772-.002.02.001.008a.1.1 0 0 0 .02.022.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.009h.007a.1.1 0 0 0 .028-.011.1.1 0 0 0 .02-.023l.001-.008-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.003-.02-.005-2.818-.297a1.55 1.55 0 0 1-1.253-.91L8.079 2.944l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStarFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5.54 2.086a.5.5 0 0 1 .92 0l.878 2.07a.5.5 0 0 0 .405.302l2.186.243a.5.5 0 0 1 .289.86L8.551 7.14a.5.5 0 0 0-.146.461l.46 2.28a.5.5 0 0 1-.75.527L6.26 9.283a.5.5 0 0 0-.518 0L3.885 10.41a.5.5 0 0 1-.75-.526l.46-2.28a.5.5 0 0 0-.146-.463L1.782 5.56a.5.5 0 0 1 .289-.86l2.186-.242a.5.5 0 0 0 .405-.301z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.987 1.852c.38-.894 1.647-.894 2.026 0l.855 2.016 2.127.237c.931.103 1.315 1.247.636 1.891L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.891l2.127-.237zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.219 1.51 1.43a1.1 1.1 0 0 1 .322 1.017L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.431-1.97-.22a1.1 1.1 0 0 1-.892-.663z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconStarFilled/IconStarFilled.tsx
var IconStarFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconStarFilledMonochromeExtralight,
          "monochrome|light": IconStarFilledMonochromeLight,
          "monochrome|regular": IconStarFilledMonochromeRegular,
          "monochrome|medium": IconStarFilledMonochromeMedium,
          "monochrome|semibold": IconStarFilledMonochromeSemibold,
          "monochrome|bold": IconStarFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconStoreMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.11 6.85a1.26 1.26 0 0 0-1.26 1.26V20a7.15 7.15 0 0 0 4 6.42V37A4.15 4.15 0 0 0 13 41.15h22A4.15 4.15 0 0 0 39.15 37V26.42a7.15 7.15 0 0 0 4-6.42V8A1.15 1.15 0 0 0 42 6.85zM36.85 27.1q-.418.05-.85.05a7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6 3.26 7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6.85 3.21V37A1.85 1.85 0 0 0 13 38.85h22A1.85 1.85 0 0 0 36.85 37zM36 24.85A4.85 4.85 0 0 1 31.15 20V9.15h9.7V20A4.85 4.85 0 0 1 36 24.85M19.15 9.15h9.7V20a4.85 4.85 0 1 1-9.7 0zm-2.3 0h-9.7V20a4.85 4.85 0 1 0 9.7 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStoreMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4.073 4.334C3.481 4.334 3 4.813 3 5.406v7.927a5 5 0 0 0 2.667 4.423v5.91a4 4 0 0 0 4 4h12.666a4 4 0 0 0 4-4v-5.91A5 5 0 0 0 29 13.333v-8a1 1 0 0 0-1-1zm20.26 13.989q-.165.01-.333.01a5 5 0 0 1-4-1.999 5 5 0 0 1-4 2 5 5 0 0 1-4-2 4.99 4.99 0 0 1-4.333 1.989v5.344a2 2 0 0 0 2 2h12.666a2 2 0 0 0 2-2zM19 6.333v7a3 3 0 1 1-6 0v-7zm2 7v-7h6v7a3 3 0 1 1-6 0m-10-7H5v7a3 3 0 1 0 6 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStoreMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.055 3.1a.955.955 0 0 0-.955.955V10c0 1.464.807 2.74 2 3.407V17A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.593a3.9 3.9 0 0 0 2-3.407V4a.9.9 0 0 0-.9-.9zM18.1 13.9l-.1.001a3.9 3.9 0 0 1-3-1.408 3.9 3.9 0 0 1-3 1.408 3.9 3.9 0 0 1-3-1.408A3.9 3.9 0 0 1 5.9 13.9V17c0 1.16.94 2.1 2.1 2.1h8a2.1 2.1 0 0 0 2.1-2.1zM18 12.1a2.1 2.1 0 0 1-2.1-2.1V4.9h4.2V10a2.1 2.1 0 0 1-2.1 2.1M9.9 4.9h4.2V10a2.1 2.1 0 1 1-4.2 0zm-1.8 0H3.9V10a2.1 2.1 0 1 0 4.2 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStoreMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.291 2.2a.84.84 0 0 0-.841.841V7.5c0 1.119.602 2.096 1.5 2.627V12a3.8 3.8 0 0 0 3.8 3.8h4.5a3.8 3.8 0 0 0 3.8-3.8v-1.873a3.05 3.05 0 0 0 1.5-2.627V3a.8.8 0 0 0-.8-.8zm11.159 8.35a3.04 3.04 0 0 1-2.2-.99c-.558.608-1.36.99-2.25.99s-1.692-.382-2.25-.99a3.04 3.04 0 0 1-2.2.99V12a2.2 2.2 0 0 0 2.2 2.2h4.5a2.2 2.2 0 0 0 2.2-2.2zm-3-6.75v3.7a1.45 1.45 0 0 1-2.9 0V3.8zm1.6 3.7V3.8h2.9v3.7a1.45 1.45 0 0 1-2.9 0m-6.1-3.7h-2.9v3.7a1.45 1.45 0 0 0 2.9 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStoreMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.037 1.867a.837.837 0 0 0-.837.836v3.964c0 1.008.533 1.892 1.333 2.385v1.615A3.467 3.467 0 0 0 6 14.133h4a3.467 3.467 0 0 0 3.467-3.466V9.052A2.8 2.8 0 0 0 14.8 6.667v-4a.8.8 0 0 0-.8-.8zm9.83 7.597A2.8 2.8 0 0 1 10 8.626a2.8 2.8 0 0 1-2 .84 2.8 2.8 0 0 1-2-.84 2.8 2.8 0 0 1-1.867.838v1.203c0 1.03.836 1.866 1.867 1.866h4a1.867 1.867 0 0 0 1.867-1.866zM12 7.867a1.2 1.2 0 0 1-1.2-1.2v-3.2h2.4v3.2a1.2 1.2 0 0 1-1.2 1.2m-5.2-4.4h2.4v3.2a1.2 1.2 0 0 1-2.4 0zm-1.6 0H2.8v3.2a1.2 1.2 0 0 0 2.4 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconStoreMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.528 1.3a.727.727 0 0 0-.728.728V5c0 .772.398 1.452 1 1.844V8a2.7 2.7 0 0 0 2.7 2.7h3A2.7 2.7 0 0 0 10.2 8V6.844c.602-.392 1-1.072 1-1.844V2a.7.7 0 0 0-.7-.7H1.528M8.8 7.191a2.2 2.2 0 0 1-1.3-.582c-.393.367-.92.591-1.5.591s-1.107-.224-1.5-.59c-.347.323-.8.536-1.3.581V8a1.3 1.3 0 0 0 1.3 1.3h3A1.3 1.3 0 0 0 8.8 8zm-2-4.49V5a.8.8 0 1 1-1.6 0V2.7zM8.2 5V2.7h1.6V5a.8.8 0 1 1-1.6 0M3.8 2.7H2.2V5a.8.8 0 1 0 1.6 0z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconStore/IconStore.tsx
var IconStore = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconStoreMonochromeExtralight,
          "monochrome|light": IconStoreMonochromeLight,
          "monochrome|regular": IconStoreMonochromeRegular,
          "monochrome|medium": IconStoreMonochromeMedium,
          "monochrome|semibold": IconStoreMonochromeSemibold,
          "monochrome|bold": IconStoreMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconStoreFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6 10a2 2 0 0 1 2-2h8.703v10.649a5.351 5.351 0 0 1-10.703 0zM18.649 8H29.35v10.649a5.351 5.351 0 0 1-10.702 0zM42 10a2 2 0 0 0-2-2h-8.703v10.649a5.351 5.351 0 0 0 10.703 0z" }),
            /* @__PURE__ */ jsx("path", { d: "M36.648 25.82q.696-.001 1.352-.137v8.838a6 6 0 0 1-6 6H16a6 6 0 0 1-6-6v-8.837q.656.136 1.35.137a6.65 6.65 0 0 0 6.325-4.586 6.654 6.654 0 0 0 12.648 0 6.65 6.65 0 0 0 6.325 4.586" })
          ]
        }
      );
    }
  )
);
var IconStoreFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z" }),
            /* @__PURE__ */ jsx("path", { d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                stroke: "#fff",
                strokeWidth: 0.5,
                d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                stroke: "#fff",
                strokeWidth: 0.5,
                d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057Z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconStoreFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M15.334 12.11A4.13 4.13 0 0 1 12 13.8a4.13 4.13 0 0 1-3.333-1.689A4.13 4.13 0 0 1 4.1 13.613v3.386A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.386a4.128 4.128 0 0 1-4.567-1.502M21.125 10.282a2.54 2.54 0 0 1-2.458 1.918 2.533 2.533 0 0 1-2.533-2.534V3.8H20.2a1 1 0 0 1 1 1v4.866q0 .32-.075.616M4.1 11.88a2.533 2.533 0 0 0 3.767-2.19V3.8H3.8a1 1 0 0 0-1 1v4.866c0 .951.525 1.78 1.3 2.214" }),
            /* @__PURE__ */ jsx("path", { d: "M9.467 9.69a2.533 2.533 0 0 0 5.066-.024V3.8H9.467v5.889" })
          ]
        }
      );
    }
  )
);
var IconStoreFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.4 3.75a.6.6 0 0 1 .6-.6h3.113v3.843a1.857 1.857 0 0 1-3.713 0zM7.143 6.993V3.15h3.714v3.843a1.857 1.857 0 0 1-3.714 0M11.886 6.993V3.15H15a.6.6 0 0 1 .6.6v3.243a1.857 1.857 0 0 1-3.714 0" }),
            /* @__PURE__ */ jsx("path", { d: "M9 9.833c1.04 0 1.94-.6 2.371-1.474A2.64 2.64 0 0 0 14.1 9.81v3.136a2.1 2.1 0 0 1-2.1 2.1H6a2.1 2.1 0 0 1-2.1-2.1V9.81q.176.024.356.024c1.04 0 1.94-.6 2.372-1.474A2.64 2.64 0 0 0 9 9.833" })
          ]
        }
      );
    }
  )
);
var IconStoreFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M2.1 3.333c0-.313.254-.566.567-.566h2.8v3.45a1.684 1.684 0 0 1-3.367 0zM6.316 6.216v-3.45h3.368v3.45a1.684 1.684 0 0 1-3.368 0M10.532 6.216v-3.45h2.801c.313 0 .567.254.567.567v2.883a1.684 1.684 0 0 1-3.368 0" }),
            /* @__PURE__ */ jsx("path", { d: "M8 8.707c.936 0 1.742-.555 2.108-1.354a2.32 2.32 0 0 0 2.458 1.328v2.826a1.9 1.9 0 0 1-1.9 1.9H5.333a1.9 1.9 0 0 1-1.9-1.9V8.68q.171.026.35.026c.937 0 1.743-.555 2.108-1.354A2.32 2.32 0 0 0 8 8.707" })
          ]
        }
      );
    }
  )
);
var IconStoreFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "m9.422 6.435-.022.003h-.003zM2 2.1h2.076v2.562a1.238 1.238 0 1 1-2.476 0V2.5c0-.22.18-.4.4-.4m2.762 0h2.476v2.562a1.238 1.238 0 0 1-2.476 0zm3.162 0H10c.221 0 .4.18.4.4v2.162a1.238 1.238 0 0 1-2.476 0zm1.238 4.455q.12 0 .238-.016V8.63a1.4 1.4 0 0 1-1.4 1.4H4a1.4 1.4 0 0 1-1.4-1.4V6.54q.117.015.238.015c.693 0 1.293-.4 1.58-.982a1.763 1.763 0 0 0 3.163 0c.288.582.888.982 1.581.982",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconStoreFilled/IconStoreFilled.tsx
var IconStoreFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconStoreFilledMonochromeExtralight,
          "monochrome|light": IconStoreFilledMonochromeLight,
          "monochrome|regular": IconStoreFilledMonochromeRegular,
          "monochrome|medium": IconStoreFilledMonochromeMedium,
          "monochrome|semibold": IconStoreFilledMonochromeSemibold,
          "monochrome|bold": IconStoreFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTagMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.4 10v11.515a3.6 3.6 0 0 0 1.054 2.545l14 14a3.6 3.6 0 0 0 5.092 0L38.06 26.546a3.6 3.6 0 0 0 0-5.092l-14-14A3.6 3.6 0 0 0 21.515 6.4H10A3.6 3.6 0 0 0 6.4 10M4 21.515V10a6 6 0 0 1 6-6h11.515a6 6 0 0 1 4.242 1.757l14 14a6 6 0 0 1 0 8.486L28.243 39.757a6 6 0 0 1-8.486 0l-14-14A6 6 0 0 1 4 21.515",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M15.5 12.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0" })
          ]
        }
      );
    }
  )
);
var IconTagMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.667 6.668v7.676a2 2 0 0 0 .585 1.415l9.334 9.333a2 2 0 0 0 2.828 0l7.676-7.676a2 2 0 0 0 0-2.829l-9.333-9.333a2 2 0 0 0-1.414-.586H6.667a2 2 0 0 0-2 2m-2 7.676V6.668a4 4 0 0 1 4-4h7.676a4 4 0 0 1 2.828 1.172l9.334 9.333a4 4 0 0 1 0 5.657l-7.677 7.676a4 4 0 0 1-5.657 0l-9.333-9.333a4 4 0 0 1-1.171-2.829",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0" })
          ]
        }
      );
    }
  )
);
var IconTagMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.8 5v5.757c0 .319.126.624.351.849l7 7a1.2 1.2 0 0 0 1.697 0l5.758-5.758a1.2 1.2 0 0 0 0-1.697l-7-7a1.2 1.2 0 0 0-.849-.351H5A1.2 1.2 0 0 0 3.8 5m9.079-2.121 7 7a3 3 0 0 1 0 4.242L14.12 19.88a3 3 0 0 1-4.242 0l-7-7A3 3 0 0 1 2 10.757V5a3 3 0 0 1 3-3h5.757a3 3 0 0 1 2.122.879",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M8.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
          ]
        }
      );
    }
  )
);
var IconTagMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.1 3.75v4.318a.65.65 0 0 0 .19.46l5.25 5.25a.65.65 0 0 0 .92 0l4.318-4.318a.65.65 0 0 0 0-.92l-5.25-5.25a.65.65 0 0 0-.46-.19H3.75a.65.65 0 0 0-.65.65M1.5 8.068V3.75A2.25 2.25 0 0 1 3.75 1.5h4.318a2.25 2.25 0 0 1 1.591.659l5.25 5.25a2.25 2.25 0 0 1 0 3.182l-4.318 4.318a2.25 2.25 0 0 1-3.182 0l-5.25-5.25A2.25 2.25 0 0 1 1.5 8.068",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M6.75 5.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0" })
          ]
        }
      );
    }
  )
);
var IconTagMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.834 3.332V7.17a.5.5 0 0 0 .146.354l4.667 4.667a.5.5 0 0 0 .707 0l3.838-3.839a.5.5 0 0 0 0-.707L7.525 2.978a.5.5 0 0 0-.353-.146H3.333a.5.5 0 0 0-.5.5m-.915 5.252a2 2 0 0 1-.586-1.414V3.332a2 2 0 0 1 2-2h3.839a2 2 0 0 1 1.414.586l4.667 4.666a2 2 0 0 1 0 2.829L9.414 13.25a2 2 0 0 1-2.828 0z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
          ]
        }
      );
    }
  )
);
var IconTagMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.44 6.44A1.5 1.5 0 0 1 1 5.378V2.5A1.5 1.5 0 0 1 2.5 1h2.879a1.5 1.5 0 0 1 1.06.44l3.5 3.5a1.5 1.5 0 0 1 0 2.12L7.061 9.94a1.5 1.5 0 0 1-2.122 0zM2.2 2.5v2.879a.3.3 0 0 0 .088.212l3.5 3.5a.3.3 0 0 0 .424 0l2.879-2.879a.3.3 0 0 0 0-.424l-3.5-3.5a.3.3 0 0 0-.212-.088H2.5a.3.3 0 0 0-.3.3",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M4.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0" })
          ]
        }
      );
    }
  )
);

// src/IconTag/IconTag.tsx
var IconTag = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconTagMonochromeExtralight,
        "monochrome|light": IconTagMonochromeLight,
        "monochrome|regular": IconTagMonochromeRegular,
        "monochrome|medium": IconTagMonochromeMedium,
        "monochrome|semibold": IconTagMonochromeSemibold,
        "monochrome|bold": IconTagMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconTagFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 10v11.515a6 6 0 0 0 1.757 4.242l14 14a6 6 0 0 0 8.486 0l11.514-11.514a6 6 0 0 0 0-8.486l-14-14A6 6 0 0 0 21.515 4H10a6 6 0 0 0-6 6m7 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTagFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.667 6.667v7.676a4 4 0 0 0 1.171 2.828l9.333 9.334a4 4 0 0 0 5.657 0l7.677-7.677a4 4 0 0 0 0-5.657L17.17 3.838a4 4 0 0 0-2.828-1.171H6.667a4 4 0 0 0-4 4m4.667 2.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTagFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2 5v5.757a3 3 0 0 0 .879 2.122l7 7a3 3 0 0 0 4.242 0l5.758-5.758a3 3 0 0 0 0-4.242l-7-7A3 3 0 0 0 10.757 2H5a3 3 0 0 0-3 3m3.5 2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTagFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.5 3.75v4.318c0 .597.237 1.17.659 1.591l5.25 5.25a2.25 2.25 0 0 0 3.182 0l4.318-4.318a2.25 2.25 0 0 0 0-3.182l-5.25-5.25A2.25 2.25 0 0 0 8.068 1.5H3.75A2.25 2.25 0 0 0 1.5 3.75m2.625 1.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTagFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.334 3.334v3.838a2 2 0 0 0 .585 1.414l4.667 4.667a2 2 0 0 0 2.828 0l3.839-3.839a2 2 0 0 0 0-2.828L8.586 1.919a2 2 0 0 0-1.414-.586H3.333a2 2 0 0 0-2 2m2.333 1.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTagFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1 2.5v2.879c0 .398.158.779.44 1.06l3.5 3.5a1.5 1.5 0 0 0 2.12 0l2.88-2.878a1.5 1.5 0 0 0 0-2.122l-3.5-3.5A1.5 1.5 0 0 0 5.378 1H2.5A1.5 1.5 0 0 0 1 2.5m1.75 1a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTagFilled/IconTagFilled.tsx
var IconTagFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTagFilledMonochromeExtralight,
          "monochrome|light": IconTagFilledMonochromeLight,
          "monochrome|regular": IconTagFilledMonochromeRegular,
          "monochrome|medium": IconTagFilledMonochromeMedium,
          "monochrome|semibold": IconTagFilledMonochromeSemibold,
          "monochrome|bold": IconTagFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.5H3.9a.6.6 0 0 1 0-1.2h16.2a.6.6 0 1 1 0 1.2M17 9.9H7a.6.6 0 0 1 0-1.2h10a.6.6 0 1 1 0 1.2m3.1 5.4H3.9a.6.6 0 1 1 0-1.2h16.2a.6.6 0 1 1 0 1.2M6.4 20.1a.6.6 0 0 1 .6-.6h10a.6.6 0 1 1 0 1.2H7a.6.6 0 0 1-.6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.65H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5m-3.1 5.4H7a.75.75 0 1 1 0-1.5h10a.75.75 0 0 1 0 1.5m3.1 5.4H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5m-3.1 5.4H7a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.8H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8M17 10.2H7a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8m3.1 5.4H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8M17 21H7a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.967H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 0 1 0 2.134m-3.1 5.4H7a1.067 1.067 0 1 1 0-2.134h10a1.067 1.067 0 0 1 0 2.134m3.1 5.4H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 1 1 0 2.134m-3.1 5.4H7a1.067 1.067 0 0 1 0-2.134h10a1.067 1.067 0 1 1 0 2.134",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.024H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25m-3.1 5.4H7a1.125 1.125 0 1 1 0-2.25h10a1.125 1.125 0 1 1 0 2.25m3.1 5.4H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25m-3.1 5.4H7a1.125 1.125 0 0 1 0-2.25h10a1.125 1.125 0 1 1 0 2.25",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignCenterMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.1H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4M17 10.5H7a1.2 1.2 0 1 1 0-2.4h10a1.2 1.2 0 0 1 0 2.4m3.1 5.4H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4M5.8 20.1A1.2 1.2 0 0 1 7 18.9h10a1.2 1.2 0 0 1 0 2.4H7a1.2 1.2 0 0 1-1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTextAlignCenter/IconTextAlignCenter.tsx
var IconTextAlignCenter = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextAlignCenterMonochromeExtralight,
          "monochrome|light": IconTextAlignCenterMonochromeLight,
          "monochrome|regular": IconTextAlignCenterMonochromeRegular,
          "monochrome|medium": IconTextAlignCenterMonochromeMedium,
          "monochrome|semibold": IconTextAlignCenterMonochromeSemibold,
          "monochrome|bold": IconTextAlignCenterMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.5H3.9a.6.6 0 0 1 0-1.2h16.2a.6.6 0 1 1 0 1.2m-6.2 5.4h-10a.6.6 0 1 1 0-1.2h10a.6.6 0 1 1 0 1.2m6.2 5.4H3.9a.6.6 0 1 1 0-1.2h16.2a.6.6 0 1 1 0 1.2m-6.2 5.4h-10a.6.6 0 1 1 0-1.2h10a.6.6 0 1 1 0 1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.65H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5m-6.2 5.4h-10a.75.75 0 1 1 0-1.5h10a.75.75 0 0 1 0 1.5m6.2 5.4H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5M3.15 20.1a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.8H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8m-6.2 5.4h-10a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8m6.2 5.4H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8M13.9 21h-10a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.967H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 0 1 0 2.134m-6.2 5.4h-10a1.067 1.067 0 1 1 0-2.134h10a1.067 1.067 0 0 1 0 2.134m6.2 5.4H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 1 1 0 2.134m-6.2 5.4h-10a1.067 1.067 0 0 1 0-2.134h10a1.067 1.067 0 1 1 0 2.134",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.024H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25m-6.2 5.4h-10a1.125 1.125 0 1 1 0-2.25h10a1.125 1.125 0 1 1 0 2.25m6.2 5.4H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25M2.775 20.1c0-.62.504-1.125 1.125-1.125h10a1.125 1.125 0 1 1 0 2.25h-10A1.125 1.125 0 0 1 2.775 20.1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignLeftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.1H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4m-6.2 5.4h-10a1.2 1.2 0 1 1 0-2.4h10a1.2 1.2 0 0 1 0 2.4m6.2 5.4H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4m-6.2 5.4h-10a1.2 1.2 0 1 1 0-2.4h10a1.2 1.2 0 0 1 0 2.4",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTextAlignLeft/IconTextAlignLeft.tsx
var IconTextAlignLeft = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextAlignLeftMonochromeExtralight,
          "monochrome|light": IconTextAlignLeftMonochromeLight,
          "monochrome|regular": IconTextAlignLeftMonochromeRegular,
          "monochrome|medium": IconTextAlignLeftMonochromeMedium,
          "monochrome|semibold": IconTextAlignLeftMonochromeSemibold,
          "monochrome|bold": IconTextAlignLeftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.5H3.9a.6.6 0 0 1 0-1.2h16.2a.6.6 0 1 1 0 1.2m0 5.4h-10a.6.6 0 0 1 0-1.2h10a.6.6 0 1 1 0 1.2m0 5.4H3.9a.6.6 0 1 1 0-1.2h16.2a.6.6 0 1 1 0 1.2M9.5 20.1a.6.6 0 0 1 .6-.6h10a.6.6 0 1 1 0 1.2h-10a.6.6 0 0 1-.6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.65H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5m0 5.4h-10a.75.75 0 1 1 0-1.5h10a.75.75 0 0 1 0 1.5m0 5.4H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5m0 5.4h-10a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.8H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8m0 5.4h-10a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8m0 5.4H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8m0 5.4h-10a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.967H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 0 1 0 2.134m0 5.4h-10a1.067 1.067 0 1 1 0-2.134h10a1.067 1.067 0 1 1 0 2.134m0 5.4H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 1 1 0 2.134m0 5.4h-10a1.067 1.067 0 0 1 0-2.134h10a1.067 1.067 0 1 1 0 2.134",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.024H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25m0 5.4h-10a1.125 1.125 0 0 1 0-2.25h10a1.125 1.125 0 1 1 0 2.25m0 5.4H3.9a1.125 1.125 0 0 1 0-2.25h16.2a1.125 1.125 0 1 1 0 2.25m0 5.4h-10a1.125 1.125 0 0 1 0-2.25h10a1.125 1.125 0 1 1 0 2.25",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextAlignRightMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 5.1H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4m0 5.4h-10a1.2 1.2 0 1 1 0-2.4h10a1.2 1.2 0 0 1 0 2.4m0 5.4H3.9a1.2 1.2 0 1 1 0-2.4h16.2a1.2 1.2 0 0 1 0 2.4M8.9 20.1a1.2 1.2 0 0 1 1.2-1.2h10a1.2 1.2 0 0 1 0 2.4h-10a1.2 1.2 0 0 1-1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTextAlignRight/IconTextAlignRight.tsx
var IconTextAlignRight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextAlignRightMonochromeExtralight,
          "monochrome|light": IconTextAlignRightMonochromeLight,
          "monochrome|regular": IconTextAlignRightMonochromeRegular,
          "monochrome|medium": IconTextAlignRightMonochromeMedium,
          "monochrome|semibold": IconTextAlignRightMonochromeSemibold,
          "monochrome|bold": IconTextAlignRightMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextDocumentMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M36 6.4H12A3.6 3.6 0 0 0 8.4 10v28a3.6 3.6 0 0 0 3.6 3.6h14c7.511 0 13.6-6.089 13.6-13.6V10A3.6 3.6 0 0 0 36 6.4M12 4a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h14c8.837 0 16-7.163 16-16V10a6 6 0 0 0-6-6z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16 15.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 31.8a1.2 1.2 0 0 1 1.2-1.2h9.6a1.2 1.2 0 0 1 0 2.4h-9.6a1.2 1.2 0 0 1-1.2-1.2",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTextDocumentMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M24 4.667H8a2 2 0 0 0-2 2v18.666a2 2 0 0 0 2 2h9.333A8.667 8.667 0 0 0 26 18.667v-12a2 2 0 0 0-2-2m-16-2a4 4 0 0 0-4 4v18.666a4 4 0 0 0 4 4h9.333C23.224 29.333 28 24.558 28 18.667v-12a4 4 0 0 0-4-4z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.667 10.333a1 1 0 0 1 1-1h8.666a1 1 0 1 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 15.667a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 21a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTextDocumentMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18 3.8H6A1.2 1.2 0 0 0 4.8 5v14A1.2 1.2 0 0 0 6 20.2h7a6.2 6.2 0 0 0 6.2-6.2V5A1.2 1.2 0 0 0 18 3.8M6 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a8 8 0 0 0 8-8V5a3 3 0 0 0-3-3z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8 7.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 15.6a.9.9 0 0 1 .9-.9h4.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTextDocumentMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13.5 3.1h-9a.65.65 0 0 0-.65.65v10.5c0 .359.291.65.65.65h5.25a4.4 4.4 0 0 0 4.4-4.4V3.75a.65.65 0 0 0-.65-.65m-9-1.6a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 16.5h5.25a6 6 0 0 0 6-6V3.75A2.25 2.25 0 0 0 13.5 1.5z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6 5.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 8.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 11.8a.8.8 0 0 1 .8-.8h2.9a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTextDocumentMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 2.833H4a.5.5 0 0 0-.5.5v9.334a.5.5 0 0 0 .5.5h4.667A3.833 3.833 0 0 0 12.5 9.333v-6a.5.5 0 0 0-.5-.5m-8-1.5a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h4.667A5.333 5.333 0 0 0 14 9.333v-6a2 2 0 0 0-2-2z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.333 6.25a.75.75 0 0 1 .75-.75h3.834a.75.75 0 1 1 0 1.5H6.083a.75.75 0 0 1-.75-.75M5.333 9.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTextDocumentMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9 2.2H3a.3.3 0 0 0-.3.3v7a.3.3 0 0 0 .3.3h3.5A2.8 2.8 0 0 0 9.3 7V2.5a.3.3 0 0 0-.3-.3M3 1a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 11h3.5a4 4 0 0 0 4-4V2.5A1.5 1.5 0 0 0 9 1z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6M4 6.9a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconTextDocument/IconTextDocument.tsx
var IconTextDocument = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextDocumentMonochromeExtralight,
          "monochrome|light": IconTextDocumentMonochromeLight,
          "monochrome|regular": IconTextDocumentMonochromeRegular,
          "monochrome|medium": IconTextDocumentMonochromeMedium,
          "monochrome|semibold": IconTextDocumentMonochromeSemibold,
          "monochrome|bold": IconTextDocumentMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M10 4a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h16c8.837 0 16-7.163 16-16V8a4 4 0 0 0-4-4zm7.2 10.6a1.2 1.2 0 0 0 0 2.4h13.6a1.2 1.2 0 0 0 0-2.4zM16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2m1.2 6.8a1.2 1.2 0 0 0 0 2.4h9.6a1.2 1.2 0 0 0 0-2.4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6.667 2.667A2.667 2.667 0 0 0 4 5.333v21.334a2.667 2.667 0 0 0 2.667 2.666h10.666C23.224 29.333 28 24.558 28 18.667V5.333a2.667 2.667 0 0 0-2.667-2.666zm5 6.666a1 1 0 1 0 0 2h8.666a1 1 0 1 0 0-2zm-1 6.334a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1m1 4.333a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a8 8 0 0 0 8-8V4a2 2 0 0 0-2-2zm3.9 4.7a.9.9 0 1 0 0 1.8h6.2a.9.9 0 1 0 0-1.8zM8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9m.9 3.1a.9.9 0 1 0 0 1.8h4.2a.9.9 0 1 0 0-1.8z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M4 1.5a1.75 1.75 0 0 0-1.75 1.75v11.5c0 .966.784 1.75 1.75 1.75h5.75a6 6 0 0 0 6-6V3.25A1.75 1.75 0 0 0 14 1.5zm2.7 3.475a.7.7 0 1 0 0 1.4h4.6a.7.7 0 1 0 0-1.4zm-.7 3.7a.7.7 0 0 1 .7-.7h4.6a.7.7 0 1 1 0 1.4H6.7a.7.7 0 0 1-.7-.7m.7 2.3a.7.7 0 1 0 0 1.4h3.1a.7.7 0 1 0 0-1.4z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2 2.667c0-.737.597-1.334 1.333-1.334h9.334c.736 0 1.333.597 1.333 1.334v6.666a5.333 5.333 0 0 1-5.333 5.334H3.333A1.333 1.333 0 0 1 2 13.333zM5.334 6.25a.75.75 0 0 1 .75-.75h3.833a.75.75 0 0 1 0 1.5H6.084a.75.75 0 0 1-.75-.75m.75 2.85a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextDocumentFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.5 2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a4 4 0 0 1-4 4h-4a1 1 0 0 1-1-1zM4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6m.6 2a.6.6 0 0 0 0 1.2h1.8a.6.6 0 0 0 0-1.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTextDocumentFilled/IconTextDocumentFilled.tsx
var IconTextDocumentFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextDocumentFilledMonochromeExtralight,
          "monochrome|light": IconTextDocumentFilledMonochromeLight,
          "monochrome|regular": IconTextDocumentFilledMonochromeRegular,
          "monochrome|medium": IconTextDocumentFilledMonochromeMedium,
          "monochrome|semibold": IconTextDocumentFilledMonochromeSemibold,
          "monochrome|bold": IconTextDocumentFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.5H3.9a.6.6 0 0 1 0-1.2h16.2a.6.6 0 1 1 0 1.2M3.3 9.3a.6.6 0 0 1 .6-.6h16.2a.6.6 0 1 1 0 1.2H3.9a.6.6 0 0 1-.6-.6m16.8 6H3.9a.6.6 0 1 1 0-1.2h16.2a.6.6 0 1 1 0 1.2M3.3 20.1a.6.6 0 0 1 .6-.6h10a.6.6 0 1 1 0 1.2h-10a.6.6 0 0 1-.6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.65H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5M3.15 9.3a.75.75 0 0 1 .75-.75h16.2a.75.75 0 0 1 0 1.5H3.9a.75.75 0 0 1-.75-.75m16.95 6.15H3.9a.75.75 0 0 1 0-1.5h16.2a.75.75 0 0 1 0 1.5M3.15 20.1a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.8H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8M3 9.3a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9m17.1 6.3H3.9a.9.9 0 1 1 0-1.8h16.2a.9.9 0 1 1 0 1.8M13.9 21h-10a.9.9 0 1 1 0-1.8h10a.9.9 0 1 1 0 1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M20.1 4.967H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 0 1 0 2.134M2.833 9.3c0-.59.478-1.067 1.067-1.067h16.2a1.067 1.067 0 1 1 0 2.134H3.9c-.59 0-1.067-.478-1.067-1.067M20.1 15.767H3.9a1.067 1.067 0 0 1 0-2.134h16.2a1.067 1.067 0 1 1 0 2.134m-6.2 5.4h-10a1.067 1.067 0 0 1 0-2.134h10a1.067 1.067 0 1 1 0 2.134",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.775 3.9c0-.622.504-1.126 1.125-1.126h16.2a1.125 1.125 0 1 1 0 2.25H3.9A1.125 1.125 0 0 1 2.775 3.9M2.775 20.1c0-.622.504-1.126 1.125-1.126h10a1.125 1.125 0 1 1 0 2.25h-10A1.125 1.125 0 0 1 2.775 20.1M2.775 14.7c0-.622.504-1.126 1.125-1.126h16.2a1.125 1.125 0 1 1 0 2.25H3.9A1.125 1.125 0 0 1 2.775 14.7M2.775 9.3c0-.622.504-1.126 1.125-1.126h16.2a1.125 1.125 0 1 1 0 2.25H3.9A1.125 1.125 0 0 1 2.775 9.3",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTextJustifyLeftMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.7 3.9a1.2 1.2 0 0 1 1.2-1.2h16.2a1.2 1.2 0 0 1 0 2.4H3.9a1.2 1.2 0 0 1-1.2-1.2M2.7 20.1a1.2 1.2 0 0 1 1.2-1.2h10a1.2 1.2 0 0 1 0 2.4h-10a1.2 1.2 0 0 1-1.2-1.2M2.7 14.7a1.2 1.2 0 0 1 1.2-1.2h16.2a1.2 1.2 0 0 1 0 2.4H3.9a1.2 1.2 0 0 1-1.2-1.2M2.7 9.3a1.2 1.2 0 0 1 1.2-1.2h16.2a1.2 1.2 0 0 1 0 2.4H3.9a1.2 1.2 0 0 1-1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTextJustifyLeft/IconTextJustifyLeft.tsx
var IconTextJustifyLeft = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextJustifyLeftMonochromeExtralight,
          "monochrome|light": IconTextJustifyLeftMonochromeLight,
          "monochrome|regular": IconTextJustifyLeftMonochromeRegular,
          "monochrome|medium": IconTextJustifyLeftMonochromeMedium,
          "monochrome|semibold": IconTextJustifyLeftMonochromeSemibold,
          "monochrome|bold": IconTextJustifyLeftMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m378.7 131.6-26.7-4.7V116c0-38.6-31.4-70-70-70H116c-38.6 0-70 31.4-70 70v166c0 33.8 24 62 55.9 68.6 1.4 24.8 19.7 46.4 45.2 50.9L325.5 433c4.1.7 8.2 1.1 12.2 1.1 33.3 0 62.9-23.9 68.9-57.9l28.8-163.5c6.7-38-18.8-74.4-56.8-81.1ZM70 282V116c0-25.4 20.6-46 46-46h166c25.4 0 46 20.6 46 46v166c0 25.4-20.6 46-46 46H116c-25.4 0-46-20.6-46-46m341.8-73.5L383 372c-4.4 25-28.3 41.7-53.3 37.3l-178.4-31.5c-13.4-2.4-23.2-13.1-25.2-25.8H282c38.6 0 70-31.4 70-70V151.3l22.5 4c25 4.4 41.7 28.3 37.3 53.3ZM127 142c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12s-5.4 12-12 12H139c-6.6 0-12-5.4-12-12m0 62c0-6.6 5.4-12 12-12h80c6.6 0 12 5.4 12 12s-5.4 12-12 12h-80c-6.6 0-12-5.4-12-12" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m379.2 128.6-24.2-4.3v-8.4c0-40.3-32.7-73-73-73H116c-40.3 0-73 32.7-73 73v166c0 34.4 24 63.3 56.1 71 2.4 25.2 21.4 46.8 47.5 51.4L325 435.8c4.3.8 8.5 1.1 12.7 1.1 34.7 0 65.6-25 71.9-60.3l28.8-163.5c7-39.6-19.6-77.6-59.2-84.6ZM73 282V116c0-23.7 19.3-43 43-43h166c23.7 0 43 19.3 43 43v166c0 23.7-19.3 43-43 43H116c-23.7 0-43-19.3-43-43m335.8-74L380 371.5c-4.1 23.3-26.5 39-49.8 34.9l-178.4-31.5c-10.9-1.9-19.2-9.9-22-19.9H282c40.3 0 73-32.7 73-73V154.8l19 3.3c23.3 4.1 39 26.5 34.9 49.8ZM274 142c0 8.3-6.7 15-15 15H139c-8.3 0-15-6.7-15-15s6.7-15 15-15h120c8.3 0 15 6.7 15 15m-40 62c0 8.3-6.7 15-15 15h-80c-8.3 0-15-6.7-15-15s6.7-15 15-15h80c8.3 0 15 6.7 15 15" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m379.7 125.7-21.7-3.8v-5.8c0-41.9-34.1-76-76-76H116c-41.9 0-76 34.1-76 76v166c0 35.1 23.9 64.7 56.3 73.4 3.4 25.6 23 47.3 49.8 52L324.5 439c4.4.8 8.9 1.2 13.2 1.2 36.2 0 68.3-26 74.8-62.8l28.8-163.5c7.3-41.3-20.4-80.8-61.6-88ZM76 282V116c0-22.1 17.9-40 40-40h166c22.1 0 40 17.9 40 40v166c0 22.1-17.9 40-40 40H116c-22.1 0-40-17.9-40-40m329.9-74.5L377.1 371c-3.8 21.7-24.6 36.3-46.3 32.4l-178.4-31.5c-8.3-1.5-14.9-6.9-18.2-13.9H282c41.9 0 76-34.1 76-76V158.4l15.4 2.7c21.7 3.8 36.3 24.6 32.4 46.3ZM121 142c0-9.9 8.1-18 18-18h120c9.9 0 18 8.1 18 18s-8.1 18-18 18H139c-9.9 0-18-8.1-18-18m0 62c0-9.9 8.1-18 18-18h80c9.9 0 18 8.1 18 18s-8.1 18-18 18h-80c-9.9 0-18-8.1-18-18" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m380.3 122.4-18.9-3.3v-3c0-43.7-35.6-79.3-79.3-79.3H116c-43.7 0-79.3 35.6-79.3 79.3v166c0 35.9 23.9 66.2 56.7 76 4.4 26.1 24.7 47.8 52.2 52.7L324 442.2c4.6.8 9.3 1.2 13.8 1.2 37.8 0 71.3-27.1 78.1-65.6l28.8-163.5c7.6-43.1-21.3-84.3-64.4-91.9M79.3 282V116c0-20.2 16.4-36.7 36.7-36.7h166c20.2 0 36.7 16.4 36.7 36.7v166c0 20.2-16.4 36.7-36.7 36.7H116c-20.2 0-36.7-16.4-36.7-36.7m323.3-75.1-28.8 163.5c-3.5 19.9-22.6 33.2-42.5 29.7l-178.4-31.4c-5.2-.9-9.6-3.6-12.7-7.3H282c43.7 0 79.3-35.6 79.3-79.3V162.5l11.5 2c19.9 3.5 33.3 22.6 29.7 42.5ZM118.2 141c0-11.8 9.6-21.3 21.3-21.3h119c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3h-119c-11.8 0-21.3-9.6-21.3-21.3m0 64c0-11.8 9.6-21.3 21.3-21.3h79c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3h-79c-11.8 0-21.3-9.6-21.3-21.3" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m380.5 121.2-18-3.2v-2.1c0-44.4-36.1-80.5-80.5-80.5H116c-44.4 0-80.5 36.1-80.5 80.5v166c0 36.1 23.9 66.8 56.8 76.9 4.7 26.2 25.3 48 53 52.9l178.4 31.5c4.7.8 9.4 1.2 14 1.2 38.3 0 72.4-27.5 79.2-66.5l28.8-163.5c7.7-43.7-21.6-85.5-65.3-93.3ZM80.5 282V116c0-19.6 15.9-35.5 35.5-35.5h166c19.6 0 35.5 15.9 35.5 35.5v166c0 19.6-15.9 35.5-35.5 35.5H116c-19.6 0-35.5-15.9-35.5-35.5m321-75.3-28.8 163.5c-3.4 19.3-21.8 32.2-41.1 28.8l-178.4-31.5c-3.9-.7-7.4-2.5-10.1-5h139c44.4 0 80.5-36.1 80.5-80.5V163.8l10.2 1.8c19.3 3.4 32.2 21.8 28.8 41.1Zm-284-66.7c0-12.4 10.1-22.5 22.5-22.5h118c12.4 0 22.5 10.1 22.5 22.5s-10.1 22.5-22.5 22.5H140c-12.4 0-22.5-10.1-22.5-22.5m0 66c0-12.4 10.1-22.5 22.5-22.5h78c12.4 0 22.5 10.1 22.5 22.5s-10.1 22.5-22.5 22.5h-78c-12.4 0-22.5-10.1-22.5-22.5" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m380.7 119.8-16.7-3v-.8c0-45.2-36.8-82-82-82H116c-45.2 0-82 36.8-82 82v166c0 36.5 24 67.5 57 78.1 5.1 26.4 26 48.3 54 53.2l178.4 31.5c4.8.8 9.6 1.3 14.3 1.3 39 0 73.7-28 80.7-67.8l28.8-163.5c7.8-44.5-22-87.1-66.5-95M82 116c0-18.7 15.3-34 34-34h166c18.7 0 34 15.3 34 34v166c0 18.7-15.3 34-34 34H116c-18.7 0-34-15.3-34-34zm318 90.4-28.8 163.5c-3.3 18.5-20.9 30.8-39.4 27.6L153.4 366c-2.1-.4-4-1.1-5.7-2h134.4c45.2 0 82-36.8 82-82V165.6l8.4 1.5c18.5 3.3 30.8 20.9 27.6 39.4ZM117 139c0-13.3 10.7-24 24-24h116c13.3 0 24 10.7 24 24s-10.7 24-24 24H141c-13.3 0-24-10.7-24-24m0 68c0-13.3 10.7-24 24-24h76c13.3 0 24 10.7 24 24s-10.7 24-24 24h-76c-13.3 0-24-10.7-24-24" })
        }
      );
    }
  )
);

// src/IconTextRectangleOnRectangleAngled/IconTextRectangleOnRectangleAngled.tsx
var IconTextRectangleOnRectangleAngled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextRectangleOnRectangleAngledMonochromeExtralight,
          "monochrome|light": IconTextRectangleOnRectangleAngledMonochromeLight,
          "monochrome|regular": IconTextRectangleOnRectangleAngledMonochromeRegular,
          "monochrome|medium": IconTextRectangleOnRectangleAngledMonochromeMedium,
          "monochrome|semibold": IconTextRectangleOnRectangleAngledMonochromeSemibold,
          "monochrome|bold": IconTextRectangleOnRectangleAngledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m435.4 212.7-28.8 163.5c-3.2 18.4-13.5 34.5-28.8 45.2-11.9 8.3-25.8 12.7-40 12.7s-8.2-.4-12.3-1.1L162 404.2c-18.4-3.2-34.5-13.5-45.2-28.8 0 0-.1-.2-.2-.3 4.4.6 8.8.9 13.3.9h152c51.8 0 94-42.2 94-94V131.1l2.7.5c38 6.7 63.5 43.1 56.8 81.1M282 352H116c-38.6 0-70-31.4-70-70V116c0-38.6 31.4-70 70-70h166c38.6 0 70 31.4 70 70v166c0 38.6-31.4 70-70 70M121 211c0 6.6 5.4 12 12 12h88c6.6 0 12-5.4 12-12s-5.4-12-12-12h-88c-6.6 0-12 5.4-12 12m12-60h128c6.6 0 12-5.4 12-12s-5.4-12-12-12H133c-6.6 0-12 5.4-12 12s5.4 12 12 12" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m438.4 213.2-28.8 163.5c-3.4 19.2-14 35.9-30 47.1-12.4 8.7-26.9 13.2-41.7 13.2-4.3 0-8.5-.4-12.8-1.1l-163.5-28.8c-16.4-2.9-30.6-11.1-41.1-22.6 3.5.4 7 .5 10.6.5h151c56.8 0 103-46.2 103-103V129.9c36.4 9.5 60 45.6 53.4 83.3ZM282 355H116c-40.3 0-73-32.7-73-73V116c0-40.3 32.7-73 73-73h166c40.3 0 73 32.7 73 73v166c0 40.3-32.7 73-73 73M119 209c0 8.3 6.7 15 15 15h86c8.3 0 15-6.7 15-15s-6.7-15-15-15h-86c-8.3 0-15 6.7-15 15m15-59h126c8.3 0 15-6.7 15-15s-6.7-15-15-15H134c-8.3 0-15 6.7-15 15s6.7 15 15 15" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m441.3 213.7-28.8 163.5c-3.5 20-14.6 37.4-31.3 49.1-12.9 9-28 13.8-43.4 13.8-4.4 0-8.9-.4-13.4-1.2l-163.5-28.8c-13-2.3-25-7.8-34.9-16h155.9c46.1 0 85.8-28 103-68 5.8-13.5 9-28.4 9-44V129.8c33.1 12.8 53.7 47.8 47.3 84ZM282 358H116c-41.9 0-76-34.1-76-76V116c0-41.9 34.1-76 76-76h166c41.9 0 76 34.1 76 76v166c0 41.9-34.1 76-76 76M117 212c0 9.9 8.1 18 18 18h84c9.9 0 18-8.1 18-18s-8.1-18-18-18h-84c-9.9 0-18 8.1-18 18m18-58h124c9.9 0 18-8.1 18-18s-8.1-18-18-18H135c-9.9 0-18 8.1-18 18s8.1 18 18 18" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "m444.6 214.3-28.8 163.5c-3.7 20.9-15.3 39.1-32.6 51.2-13.5 9.4-29.2 14.4-45.3 14.4-4.6 0-9.3-.4-13.9-1.2l-163.5-28.8c-13.6-2.4-25.8-8.2-35.9-16.3h157.5c7.1 0 14.1-.7 20.9-1.9 31.5-5.8 58.5-24.4 75.4-50.3 11.8-18.1 18.7-39.7 18.7-62.8V127.3c33.5 14 54.2 49.8 47.6 87ZM361.3 116v166c0 43.7-35.6 79.3-79.3 79.3H116c-43.7 0-79.3-35.6-79.3-79.3V116c0-43.7 35.6-79.3 79.3-79.3h166c43.7 0 79.3 35.6 79.3 79.3M259 156c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H135c-11.8 0-21.3 9.6-21.3 21.3S123.3 156 135 156zm-40 36h-84c-11.8 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h84c11.8 0 21.3-9.6 21.3-21.3S230.7 192 219 192" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M445.8 214.5 417 378c-3.7 21.2-15.5 39.6-33.1 52-13.7 9.6-29.6 14.6-46 14.6q-7.05 0-14.1-1.2l-163.5-28.8c-12.9-2.3-24.5-7.5-34.4-14.9h156.6c10.4 0 20.4-1.4 30-3.9 25.5-6.8 47.6-21.9 63.1-42.3 15-19.7 23.9-44.2 23.9-70.8V127.1c32.8 14.8 52.8 50.4 46.3 87.4M282 362.5H116c-44.4 0-80.5-36.1-80.5-80.5V116c0-44.4 36.1-80.5 80.5-80.5h166c44.4 0 80.5 36.1 80.5 80.5v166c0 44.4-36.1 80.5-80.5 80.5M112.5 214c0 12.4 10.1 22.5 22.5 22.5h84c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5h-84c-12.4 0-22.5 10.1-22.5 22.5m22.5-57.5h124c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5H135c-12.4 0-22.5 10.1-22.5 22.5s10.1 22.5 22.5 22.5" })
        }
      );
    }
  )
);
var IconTextRectangleOnRectangleAngledFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M402 126.6V282c0 29.9-11 57.3-29.2 78.3-13.8 16-31.7 28.2-52 35.2-12.2 4.2-25.2 6.5-38.8 6.5H126.6c9.8 7 21.1 11.8 33.3 13.9l163.5 28.8c4.8.8 9.6 1.3 14.4 1.3 16.7 0 32.9-5.1 46.9-14.9 17.9-12.6 29.9-31.4 33.7-52.9l28.8-163.5c6.5-37-13-72.6-45.2-88.1" }),
            /* @__PURE__ */ jsx("path", { d: "M282 364c45.2 0 82-36.8 82-82V116c0-45.2-36.8-82-82-82H116c-45.2 0-82 36.8-82 82v166c0 38.5 26.7 70.9 62.6 79.7 6.2 1.5 12.7 2.3 19.4 2.3zM111 215c0-4.4 1.2-8.5 3.2-12 4.2-7.2 11.9-12 20.8-12h84c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84c-.9 0-1.8 0-2.7-.2-10.6-1.2-19.1-9.3-20.9-19.6-.2-1.4-.4-2.8-.4-4.2m148-106c11.1 0 20.4 7.5 23.2 17.8.5 2 .8 4.1.8 6.2 0 6.7-2.7 12.7-7.1 17-4.3 4.3-10.3 7-16.9 7H135c-4.4 0-8.5-1.2-12-3.2-7.2-4.1-12-11.9-12-20.8 0-13.3 10.7-24 24-24z" })
          ]
        }
      );
    }
  )
);

// src/IconTextRectangleOnRectangleAngledFilled/IconTextRectangleOnRectangleAngledFilled.tsx
var IconTextRectangleOnRectangleAngledFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTextRectangleOnRectangleAngledFilledMonochromeExtralight,
          "monochrome|light": IconTextRectangleOnRectangleAngledFilledMonochromeLight,
          "monochrome|regular": IconTextRectangleOnRectangleAngledFilledMonochromeRegular,
          "monochrome|medium": IconTextRectangleOnRectangleAngledFilledMonochromeMedium,
          "monochrome|semibold": IconTextRectangleOnRectangleAngledFilledMonochromeSemibold,
          "monochrome|bold": IconTextRectangleOnRectangleAngledFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconThumbsDownMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M252.896 430.772c32.256 0 55.575-30.488 46.796-61.184l-4.442-15.532c-6.627-23.171 10.975-46.186 35.324-46.186h34.045c45.66 0 80.05-41.084 71.524-85.445l-22.034-114.632c-6.529-33.971-36.557-58.555-71.523-58.555h-211.74v.035h-47.86c-22.338 0-40.447 17.908-40.447 40v164.363c0 22.091 18.11 40 40.447 40h53.215a71.8 71.8 0 0 0 6.872 12.833l69.358 102.886c9.019 13.38 24.204 21.417 40.465 21.417m0-24c-8.147 0-15.754-4.026-20.273-10.729l-69.357-102.887a47.7 47.7 0 0 1-7.749-20.449V73.238h187.069c23.311 0 43.329 16.389 47.683 39.036l22.033 114.632c5.684 29.574-17.243 56.964-47.683 56.964h-34.045c-40.445 0-69.684 38.229-58.677 76.717l4.443 15.532c4.398 15.378-7.285 30.653-23.444 30.653M82.986 269.636c-8.935 0-16.178-7.164-16.178-16V89.273c0-8.837 7.243-16 16.178-16h47.86V266.53q.001 1.556.07 3.106z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M248.864 433.87c34.269 0 59.043-32.39 49.716-65.001l-4.441-15.532c-6.079-21.256 10.068-42.369 32.405-42.369h34.045c47.562 0 83.386-42.797 74.504-89.006L413.06 107.33c-6.802-35.387-38.082-60.994-74.504-60.994H156.542v-.215h-72.53c-22.338 0-40.447 17.909-40.447 40v167.612c0 22.092 18.109 40 40.447 40h44.897a74.7 74.7 0 0 0 7.61 14.497l69.357 102.887c9.582 14.215 25.714 22.753 42.988 22.753M84.012 263.733c-5.585 0-10.113-4.477-10.113-10V86.121c0-5.523 4.528-10 10.113-10h39.769v187.612zM248.864 403.87c-7.132 0-13.792-3.525-17.748-9.393L161.759 291.59a44.8 44.8 0 0 1-5.217-10.469V76.336h182.014c21.853 0 40.621 15.365 44.702 36.597l22.033 114.631c5.329 27.726-16.165 53.404-44.702 53.404h-34.045c-42.457 0-73.151 40.13-61.596 80.533l4.443 15.533c3.85 13.464-6.379 26.836-20.527 26.836",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M247.331 436.797c36.281 0 62.509-34.292 52.635-68.818l-4.442-15.532c-5.531-19.341 9.162-38.552 29.487-38.552h34.045c49.464-.001 86.72-44.509 77.483-92.566l-22.033-114.632c-7.074-36.802-39.604-63.434-77.484-63.434H155.009v-.066h-72.53c-22.339 0-40.448 17.909-40.448 40V253.66c0 22.092 18.11 40 40.448 40h41.654a77.6 77.6 0 0 0 8.328 16.161l69.357 102.887c10.145 15.049 27.224 24.089 45.513 24.089M82.479 257.66c-2.234 0-4.045-1.791-4.045-4V83.197c0-2.209 1.81-4 4.044-4h36.128V257.66zM247.33 400.797c-6.117 0-11.83-3.024-15.224-8.058L162.75 289.853a41.67 41.67 0 0 1-7.133-23.298V79.263h181.405c20.397 0 37.913 14.34 41.722 34.157l22.033 114.632c4.974 25.877-15.087 49.842-41.721 49.843h-34.045c-44.469 0-76.617 42.031-64.515 84.349l4.442 15.533c3.303 11.549-5.471 23.02-17.607 23.02",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M249.018 440.104c38.516-.001 66.36-36.406 55.878-73.059l-4.443-15.532c-4.923-17.214 8.154-34.312 26.243-34.312h34.045c51.579 0 90.427-46.41 80.795-96.521l-22.033-114.632c-7.376-38.375-41.296-66.146-80.795-66.146H117.53v.201H77.426c-22.338 0-40.448 17.91-40.448 40v173.531c0 22.091 18.11 40 40.448 40h44.809a81 81 0 0 0 9.108 18.01L200.7 414.53c10.77 15.977 28.902 25.574 48.318 25.574m0-42.667c-4.991 0-9.652-2.467-12.42-6.574L167.24 287.977a38.36 38.36 0 0 1-6.567-21.449V82.569h178.035c18.778 0 34.905 13.203 38.411 31.447l22.033 114.631c4.579 23.824-13.89 45.887-38.411 45.887h-34.045c-46.705 0-80.469 44.146-67.758 88.591l4.443 15.532c2.694 9.422-4.463 18.779-14.363 18.78M80.122 82.77h36.938v168.197H80.122z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M246.391 442.793c40.304 0 69.441-38.096 58.472-76.45l-4.442-15.533c-4.436-15.512 7.348-30.919 23.648-30.919h34.045c53.27 0 93.392-47.933 83.445-99.687l-22.034-114.632c-7.618-39.633-42.65-68.313-83.444-68.313H160.44v-.066H77.39c-22.338 0-40.447 17.909-40.447 40v176.465c0 22.092 18.11 40 40.448 40h39.361a83.6 83.6 0 0 0 9.721 19.488l69.357 102.886c11.27 16.719 30.243 26.761 50.561 26.761M85.48 85.193h26.424v160.465H85.48zm160.911 309.6c-4.09 0-7.909-2.021-10.177-5.386l-69.358-102.886a35.72 35.72 0 0 1-6.113-19.97V85.259h175.338c17.483 0 32.497 12.292 35.762 29.277l22.033 114.632c4.263 22.18-12.932 42.723-35.762 42.723h-34.045c-48.493 0-83.55 45.836-70.352 91.983l4.442 15.532c2.208 7.72-3.656 15.387-11.768 15.387",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M246.337 443.008c40.305 0 69.442-38.096 58.473-76.45l-4.443-15.534c-4.436-15.511 7.349-30.919 23.65-30.919h34.044c53.269 0 93.392-47.932 83.444-99.686l-22.033-114.632c-7.618-39.633-42.651-68.313-83.445-68.313H158.333v-.466H77.44c-22.339 0-40.448 17.908-40.448 40v162c0 22.091 18.11 40 40.448 40h35.621a83.4 83.4 0 0 0 13.358 34.352l69.357 102.887c11.27 16.718 30.243 26.761 50.561 26.761m-160.809-358h24.269v146H85.528zm160.809 310c-4.089 0-7.908-2.021-10.176-5.386l-69.357-102.887a35.7 35.7 0 0 1-6.115-19.969V85.474h175.338c17.483 0 32.497 12.291 35.762 29.277l22.034 114.632c4.263 22.18-12.933 42.722-35.762 42.722h-34.044c-48.494 0-83.552 45.837-70.354 91.984l4.442 15.532c2.208 7.72-3.656 15.387-11.768 15.387",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconThumbsDown/IconThumbsDown.tsx
var IconThumbsDown = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconThumbsDownMonochromeExtralight,
          "monochrome|light": IconThumbsDownMonochromeLight,
          "monochrome|regular": IconThumbsDownMonochromeRegular,
          "monochrome|medium": IconThumbsDownMonochromeMedium,
          "monochrome|semibold": IconThumbsDownMonochromeSemibold,
          "monochrome|bold": IconThumbsDownMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M258.26 421.232c30.643 0 52.796-28.964 44.457-58.125l-4.22-14.755c-6.295-22.013 10.427-43.876 33.559-43.876h32.341c43.377 0 76.049-39.032 67.949-81.174l-20.932-108.9c-6.203-32.273-34.73-55.627-67.948-55.627H187.035c-22.091 0-40 17.909-40 40v181.92a40 40 0 0 0 6.833 22.36l65.95 97.832c8.569 12.711 22.994 20.345 38.442 20.345M123.035 290.952V58.808H85.847c-21.222 0-38.425 17.013-38.425 38v156.144c0 20.987 17.203 38 38.425 38z"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M113.94 291.05V55.818H86.811c-21.22 0-38.424 17.014-38.424 38V253.05c0 20.987 17.203 38 38.424 38zM254.422 424.18c32.555 0 56.09-30.771 47.23-61.751l-4.22-14.756c-5.775-20.193 9.565-40.25 30.785-40.25h32.343c45.184 0 79.216-40.657 70.778-84.556l-20.931-108.9c-6.461-33.618-36.177-57.944-70.779-57.944H183.94c-22.091 0-40 17.908-40 40v191.006a40 40 0 0 0 6.832 22.359l62.811 93.176c9.103 13.504 24.428 21.616 40.839 21.616"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M111.84 290.603V52.663H85.355c-21.222 0-38.425 17.012-38.425 38v161.94c0 20.986 17.203 38 38.425 38zM252.965 426.582c34.466 0 59.383-32.578 50.003-65.377l-4.22-14.756c-5.255-18.374 8.703-36.624 28.012-36.624h32.343c46.991 0 82.385-42.283 73.61-87.937l-20.932-108.901c-6.72-34.962-37.624-60.262-73.61-60.262H187.84c-22.092 0-40 17.908-40 40v206.944a40 40 0 0 0 6.832 22.358l55.056 81.671c9.637 14.297 25.862 22.884 43.237 22.884"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M254.567 429.722c36.591 0 63.044-34.585 53.085-69.406l-4.22-14.755c-4.677-16.354 7.747-32.596 24.931-32.596h32.342c49 0 85.906-44.091 76.756-91.696l-20.932-108.9c-7.007-36.456-39.232-62.838-76.756-62.838H194.99c-22.091 0-40 17.909-40 40V313.58a40 40 0 0 0 6.833 22.358l46.843 69.49c10.232 15.177 27.456 24.294 45.901 24.294M112.32 49.722H80.556c-21.222 0-38.425 17.013-38.425 38v164.853c0 20.987 17.203 38 38.425 38h31.764z"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M110.082 47.332H80.507c-21.221 0-38.425 17.013-38.425 38v167.643c0 20.986 17.204 38 38.425 38h29.575zM252.057 432.652c38.289 0 65.97-36.191 55.549-72.628l-4.22-14.755c-4.215-14.737 6.981-29.373 22.467-29.373h32.341c50.606 0 88.723-45.536 79.273-94.703l-20.932-108.9c-7.237-37.652-40.518-64.899-79.272-64.899H195.082c-22.091 0-40 17.91-40 40v235.011a40 40 0 0 0 6.832 22.359l42.11 62.465c10.707 15.883 28.731 25.423 48.033 25.423"
            }
          )
        }
      );
    }
  )
);
var IconThumbsDownFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M251.512 432.85c38.289-.001 65.969-36.191 55.549-72.628l-4.22-14.756c-4.215-14.737 6.98-29.373 22.466-29.373h32.342c50.606 0 88.722-45.536 79.272-94.702L415.989 112.49c-7.237-37.651-40.517-64.898-79.271-64.898H191.037c-22.091 0-40 17.909-40 40V317.41a40 40 0 0 0 6.832 22.359l45.61 67.657c10.706 15.882 28.731 25.423 48.033 25.423M103.037 277.498v-229.9H80.059c-21.222 0-38.425 17.014-38.425 38v153.9c0 20.987 17.203 38 38.425 38z"
            }
          )
        }
      );
    }
  )
);

// src/IconThumbsDownFilled/IconThumbsDownFilled.tsx
var IconThumbsDownFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconThumbsDownFilledMonochromeExtralight,
          "monochrome|light": IconThumbsDownFilledMonochromeLight,
          "monochrome|regular": IconThumbsDownFilledMonochromeRegular,
          "monochrome|medium": IconThumbsDownFilledMonochromeMedium,
          "monochrome|semibold": IconThumbsDownFilledMonochromeSemibold,
          "monochrome|bold": IconThumbsDownFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconThumbsUpMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M25.29 7.323c-.814 0-1.575.403-2.027 1.073l-6.936 10.289a4.76 4.76 0 0 0-.815 2.663v19.329H34.26c2.331 0 4.333-1.64 4.769-3.904L41.23 25.31c.568-2.957-1.724-5.696-4.768-5.696h-3.405c-4.044 0-6.968-3.823-5.867-7.672l.444-1.553c.44-1.538-.729-3.066-2.345-3.066m-4.046-.258a4.88 4.88 0 0 1 4.046-2.142c3.226 0 5.558 3.05 4.68 6.119l-.444 1.553c-.663 2.317 1.097 4.619 3.532 4.619h3.405c4.566 0 8.005 4.108 7.152 8.544l-2.203 11.463c-.653 3.397-3.656 5.856-7.153 5.856H13.085v-21.73c0-1.42.426-2.81 1.223-3.993z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M13.126 21.037H8.299a1.61 1.61 0 0 0-1.618 1.6v16.436c0 .884.725 1.6 1.618 1.6h4.827zm-4.827-2.4c-2.233 0-4.044 1.79-4.044 4v16.436c0 2.21 1.81 4 4.044 4h7.253V18.637z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconThumbsUpMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M16.59 5.075c-.475 0-.919.235-1.183.626l-4.624 6.86a2.98 2.98 0 0 0-.509 1.663v12.687H22.57a3.025 3.025 0 0 0 2.98-2.44l1.469-7.642c.355-1.849-1.078-3.56-2.98-3.56h-2.27c-2.83 0-4.877-2.676-4.106-5.37l.296-1.035c.257-.898-.425-1.789-1.369-1.789m-2.865-.483a3.46 3.46 0 0 1 2.865-1.517c2.285 0 3.937 2.16 3.315 4.333l-.296 1.036c-.406 1.417.671 2.824 2.16 2.824h2.27c3.17 0 5.559 2.853 4.967 5.934l-1.47 7.642c-.453 2.36-2.538 4.067-4.966 4.067H8.252V14.224c0-.987.295-1.952.849-2.773z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.413 14.417H5.6a.67.67 0 0 0-.674.667v11.174a.67.67 0 0 0 .674.667h2.813zm-2.813-2c-1.489 0-2.696 1.194-2.696 2.667v11.174c0 1.473 1.207 2.667 2.696 2.667h4.836V12.417z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconThumbsUpMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.367 3.96a.92.92 0 0 0-.761.403L8.138 9.507c-.233.345-.357.75-.357 1.165v9.365h9.07c1.02 0 1.896-.717 2.087-1.708l1.101-5.732c.25-1.294-.754-2.492-2.086-2.492h-1.702c-2.223 0-3.83-2.102-3.226-4.217l.222-.777a.907.907 0 0 0-.88-1.151m-2.276-.596a2.74 2.74 0 0 1 2.276-1.204c1.814 0 3.125 1.715 2.632 3.44l-.222.777c-.277.967.458 1.928 1.474 1.928h1.702c2.474 0 4.336 2.225 3.875 4.628l-1.102 5.732c-.354 1.84-1.98 3.172-3.874 3.172H5.962V10.672c0-.77.23-1.523.662-2.163z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.93 11.117H4.125a.2.2 0 0 0-.202.2v8.523c0 .11.09.2.202.2h1.807zm-1.806-1.8a2.01 2.01 0 0 0-2.022 2v8.523c0 1.105.905 2 2.022 2h3.627V9.317z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconThumbsUpMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M9.339 3.096a.56.56 0 0 0-.466.247L6.272 7.2c-.16.238-.246.518-.246.804v6.899h6.676c.704 0 1.309-.495 1.44-1.18l.827-4.298a1.455 1.455 0 0 0-1.44-1.72h-1.277c-1.752 0-3.018-1.656-2.541-3.323l.166-.582a.555.555 0 0 0-.538-.705m-1.812-.64a2.18 2.18 0 0 1 1.812-.96c1.444 0 2.488 1.366 2.095 2.74l-.166.582a1.014 1.014 0 0 0 .984 1.287h1.276c1.935 0 3.391 1.74 3.03 3.62l-.826 4.298a3.075 3.075 0 0 1-3.03 2.48H4.408V8.006c0-.602.18-1.19.518-1.691z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.005 8.589v6.307H4.39V8.59zm-.101-1.6c-.838 0-1.517.672-1.517 1.5v6.507c0 .829.68 1.5 1.517 1.5h3.104V6.99z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconThumbsUpMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.213 2.84a.41.41 0 0 0-.34.18L5.561 6.45a1.2 1.2 0 0 0-.203.665v6.043h5.844a1.21 1.21 0 0 0 1.192-.976l.735-3.821a1.204 1.204 0 0 0-1.192-1.424h-1.135c-1.617 0-2.785-1.528-2.345-3.066l.148-.518a.404.404 0 0 0-.392-.513m-1.686-.708a2.03 2.03 0 0 1 1.686-.892c1.343 0 2.314 1.27 1.949 2.548l-.148.518a.812.812 0 0 0 .788 1.03h1.135c1.775 0 3.113 1.598 2.781 3.324l-.734 3.82a2.82 2.82 0 0 1-2.782 2.278H3.74V7.115c0-.553.165-1.093.475-1.553z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.849 7.811v5.349h.88V7.811zm-.27-1.6a1.34 1.34 0 0 0-1.348 1.333v5.883a1.34 1.34 0 0 0 1.348 1.333h2.769V6.211z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconThumbsUpMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const _id = useId();
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsxs("g", { fillRule: "evenodd", clipPath: `url(#${_id})`, clipRule: "evenodd", children: [
              /* @__PURE__ */ jsx("path", { d: "M6.158 2.125a.3.3 0 0 0-.254.135L4.17 4.832a.9.9 0 0 0-.153.5v4.531H8.4a.91.91 0 0 0 .894-.732l.551-2.865a.903.903 0 0 0-.894-1.068H8.1c-1.212 0-2.089-1.146-1.759-2.3l.111-.388a.303.303 0 0 0-.294-.385m-1.264-.53a1.52 1.52 0 0 1 1.264-.67c1.008 0 1.736.952 1.462 1.911l-.111.389a.61.61 0 0 0 .59.773h.852c1.332 0 2.335 1.198 2.086 2.492l-.55 2.866A2.12 2.12 0 0 1 8.4 11.063H2.803V5.331c0-.415.124-.82.357-1.165z" }),
              /* @__PURE__ */ jsx("path", { d: "M2.138 6.225v3.65h.606v-3.65zm-.203-1.2c-.558 0-1.01.448-1.01 1v4.05c0 .552.452 1 1.01 1h2.023v-6.05z" })
            ] }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: _id, children: /* @__PURE__ */ jsx("path", { d: "M0 0h12v12H0z" }) }) })
          ]
        }
      );
    }
  )
);

// src/IconThumbsUp/IconThumbsUp.tsx
var IconThumbsUp = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconThumbsUpMonochromeExtralight,
          "monochrome|light": IconThumbsUpMonochromeLight,
          "monochrome|regular": IconThumbsUpMonochromeRegular,
          "monochrome|medium": IconThumbsUpMonochromeMedium,
          "monochrome|semibold": IconThumbsUpMonochromeSemibold,
          "monochrome|bold": IconThumbsUpMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M21.982 7.912a4.63 4.63 0 0 1 3.844-2.035c3.064 0 5.28 2.896 4.446 5.813l-.422 1.475c-.63 2.201 1.042 4.388 3.355 4.388h3.235c4.337 0 7.605 3.903 6.794 8.117l-2.093 10.89c-.62 3.227-3.473 5.563-6.794 5.563H18.703a4 4 0 0 1-4-4V19.93a4 4 0 0 1 .684-2.236zM12.304 18.905h-3.72c-2.121 0-3.842 1.701-3.842 3.8V38.32c0 2.098 1.72 3.8 3.843 3.8h3.718z" })
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M14.239 5.163a3.28 3.28 0 0 1 2.722-1.441c2.17 0 3.74 2.051 3.149 4.116l-.281.984c-.385 1.346.637 2.684 2.052 2.684h2.156c3.012 0 5.281 2.71 4.719 5.636l-1.396 7.26c-.43 2.242-2.411 3.863-4.718 3.863h-10.38A2.667 2.667 0 0 1 9.596 25.6V12.865c0-.531.158-1.05.455-1.49zM7.596 12.597H5.787c-1.415 0-2.561 1.134-2.561 2.533v10.616c0 1.399 1.146 2.533 2.561 2.533h1.809z" })
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M10.487 3.815a2.6 2.6 0 0 1 2.161-1.144c1.724 0 2.97 1.629 2.5 3.269l-.21.738c-.263.918.435 1.83 1.4 1.83h1.617c2.35 0 4.12 2.115 3.68 4.398L20.59 18.35c-.336 1.748-1.881 3.013-3.68 3.013H9.392a2 2 0 0 1-2-2V9.017a2 2 0 0 1 .342-1.118zM5.592 9.47H4.268a1.91 1.91 0 0 0-1.921 1.9v8.097c0 1.05.86 1.9 1.92 1.9h1.325z" })
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M9.546 1.886c-.691 0-1.337.342-1.72.91L6.068 5.404a1.5 1.5 0 0 0-.257.838v8.402a1.5 1.5 0 0 0 1.5 1.5h5.43c1.407 0 2.615-.99 2.878-2.357l.785-4.083c.343-1.785-1.04-3.439-2.878-3.439h-1.213a.963.963 0 0 1-.935-1.222l.158-.554c.374-1.305-.618-2.602-1.99-2.602M4.212 7.104v9.032H3.021c-.796 0-1.44-.638-1.44-1.425V8.529c0-.787.644-1.425 1.44-1.425z" })
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M8.402 1.578a1.93 1.93 0 0 0-1.602.848L5.397 4.508c-.149.22-.228.48-.228.745v7.834c0 .736.597 1.333 1.333 1.333h4.74a2.68 2.68 0 0 0 2.642-2.163l.698-3.63c.315-1.64-.956-3.157-2.643-3.157h-1.078a.77.77 0 0 1-.748-.98l.14-.49c.348-1.216-.575-2.422-1.851-2.422M3.669 6.3v8.122h-.986c-.707 0-1.28-.567-1.28-1.267V7.568c0-.7.573-1.266 1.28-1.266z" })
        }
      );
    }
  )
);
var IconThumbsUpFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M6.288 1.179c-.483 0-.933.238-1.2.635L3.946 3.506a1 1 0 0 0-.17.559V9.81a1 1 0 0 0 1 1h3.641c.969 0 1.801-.681 1.982-1.622l.523-2.723c.236-1.229-.716-2.367-1.982-2.367h-.808a.58.58 0 0 1-.562-.735l.106-.369c.26-.91-.432-1.815-1.389-1.815M2.576 10.81V5.062h-.574c-.53 0-.961.426-.961.95V9.86c0 .525.43.95.96.95z" })
        }
      );
    }
  )
);

// src/IconThumbsUpFilled/IconThumbsUpFilled.tsx
var IconThumbsUpFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconThumbsUpFilledMonochromeExtralight,
          "monochrome|light": IconThumbsUpFilledMonochromeLight,
          "monochrome|regular": IconThumbsUpFilledMonochromeRegular,
          "monochrome|medium": IconThumbsUpFilledMonochromeMedium,
          "monochrome|semibold": IconThumbsUpFilledMonochromeSemibold,
          "monochrome|bold": IconThumbsUpFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTicketMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M29.4 17.7a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM29.4 23.2a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM28.2 27.5a1.2 1.2 0 0 1 1.2 1.2v1.6a1.2 1.2 0 0 1-2.4 0v-1.6a1.2 1.2 0 0 1 1.2-1.2" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M7.2 8h16.244c.466 0 .863.324 1.01.765.694 2.078 2.111 3.502 3.746 3.502s3.052-1.424 3.746-3.502c.147-.441.544-.765 1.01-.765H40.8c2.32 0 4.2 1.91 4.2 4.267v23.466C45 38.09 43.12 40 40.8 40h-7.844c-.466 0-.863-.324-1.01-.765-.694-2.078-2.111-3.502-3.746-3.502s-3.052 1.424-3.746 3.502c-.147.441-.544.765-1.01.765H7.2C4.88 40 3 38.09 3 35.733V12.267C3 9.91 4.88 8 7.2 8m0 2.4h15.318c.982 2.202 2.893 4.267 5.682 4.267s4.7-2.065 5.682-4.267H40.8c.959 0 1.8.8 1.8 1.867v23.466c0 1.067-.841 1.867-1.8 1.867h-6.918c-.982-2.202-2.893-4.267-5.682-4.267s-4.7 2.065-5.682 4.267H7.2c-.959 0-1.8-.8-1.8-1.867V12.267c0-1.067.841-1.867 1.8-1.867",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTicketMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.333 12.333a1 1 0 0 1 1 1V14a1 1 0 1 1-2 0v-.667a1 1 0 0 1 1-1M18.333 17a1 1 0 0 1 1 1v.667a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.757 7.333H4.8c-.412 0-.8.349-.8.845v15.644c0 .496.388.845.8.845h9.957c.712-1.444 2.064-2.845 4.043-2.845s3.33 1.4 4.043 2.845H27.2c.412 0 .8-.349.8-.845V8.178c0-.496-.388-.845-.8-.845h-4.357c-.712 1.444-2.064 2.845-4.043 2.845s-3.33-1.4-4.043-2.845m.608-2H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.565c.465 0 .859-.326 1.028-.76.488-1.248 1.384-2.085 2.407-2.085s1.919.837 2.407 2.086c.17.433.563.759 1.028.759H27.2c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.965c-.465 0-.858.326-1.028.76-.488 1.248-1.384 2.085-2.407 2.085s-1.919-.837-2.407-2.086c-.17-.433-.563-.759-1.028-.759",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTicketMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M13.9 11.25a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9M13.9 14.75a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9" }),
            /* @__PURE__ */ jsx("path", { d: "M10.884 5.8c.575 1.068 1.65 2.133 3.216 2.133s2.64-1.065 3.216-2.133H20.4c.14 0 .3.122.3.333v11.734c0 .21-.16.333-.3.333h-3.084c-.575-1.068-1.65-2.133-3.216-2.133s-2.64 1.065-3.216 2.133H3.6c-.14 0-.3-.122-.3-.333V6.133c0-.21.16-.333.3-.333zm.44-1.8H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4" })
          ]
        }
      );
    }
  )
);
var IconTicketMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M10.55 6.837a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8M10.55 9.462a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.7 3h5.595c.465 0 .849.334 1.073.742.289.524.722.858 1.207.858s.918-.334 1.207-.858c.225-.408.608-.742 1.073-.742H15.3c.87 0 1.575.716 1.575 1.6v8.8c0 .884-.705 1.6-1.575 1.6h-2.445c-.465 0-.848-.334-1.073-.742-.289-.524-.722-.858-1.207-.858s-.918.334-1.207.858c-.224.408-.608.742-1.073.742H2.7c-.87 0-1.575-.716-1.575-1.6V4.6c0-.884.705-1.6 1.575-1.6m.025 10.4V4.6h5.29c.462.788 1.322 1.6 2.56 1.6s2.098-.812 2.56-1.6h2.14v8.8h-2.14c-.462-.788-1.322-1.6-2.56-1.6s-2.098.812-2.56 1.6z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTicketMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M10.267 7.863a.8.8 0 0 0-1.6 0v.267a.8.8 0 1 0 1.6 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.4 2.667h4.885c.465 0 .845.338 1.086.736.256.422.622.686 1.029.686s.773-.264 1.029-.686c.24-.398.62-.736 1.086-.736H13.6c.773 0 1.4.637 1.4 1.422v7.822c0 .786-.627 1.422-1.4 1.422h-2.085c-.465 0-.845-.338-1.086-.735-.256-.423-.622-.687-1.029-.687s-.773.264-1.029.687c-.24.397-.62.735-1.086.735H2.4c-.773 0-1.4-.636-1.4-1.422V4.09c0-.786.627-1.422 1.4-1.422m.1 9.166V4.167h4.58l.008.013c.42.69 1.2 1.409 2.312 1.409s1.893-.718 2.312-1.41l.008-.012h1.78v7.666h-1.78l-.008-.013c-.42-.69-1.2-1.409-2.312-1.409s-1.893.718-2.312 1.41l-.008.012z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTicketMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M7.7 5.85a.6.6 0 0 0-1.2 0v.133a.6.6 0 0 0 1.2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.8 2h3.465c.465 0 .833.354 1.128.714.18.22.408.353.657.353s.478-.132.657-.353C8.002 2.354 8.37 2 8.835 2H10.2c.58 0 1.05.478 1.05 1.067v5.866c0 .59-.47 1.067-1.05 1.067H8.835c-.465 0-.833-.354-1.128-.714-.18-.22-.408-.353-.657-.353s-.478.132-.657.353c-.295.36-.663.714-1.128.714H1.8C1.22 10 .75 9.522.75 8.933V3.067C.75 2.477 1.22 2 1.8 2m.15 6.8V3.2h3.248a1 1 0 0 1 .108.095q.071.073.157.178c.34.417.883.794 1.587.794s1.247-.377 1.587-.794q.087-.106.157-.178a1 1 0 0 1 .108-.095h1.148v5.6H8.902a1 1 0 0 1-.108-.095 3 3 0 0 1-.157-.178c-.34-.417-.883-.794-1.587-.794s-1.247.377-1.587.794q-.087.105-.157.178a1 1 0 0 1-.108.095z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconTicket/IconTicket.tsx
var IconTicket = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTicketMonochromeExtralight,
          "monochrome|light": IconTicketMonochromeLight,
          "monochrome|regular": IconTicketMonochromeRegular,
          "monochrome|medium": IconTicketMonochromeMedium,
          "monochrome|semibold": IconTicketMonochromeSemibold,
          "monochrome|bold": IconTicketMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTicketFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M22.65 8H7.2C4.88 8 3 9.91 3 12.267v23.466C3 38.09 4.88 40 7.2 40h15.45c.93 0 1.71-.657 2.094-1.504.758-1.67 2.023-2.763 3.456-2.763s2.698 1.094 3.456 2.763C32.041 39.343 32.82 40 33.75 40h7.05c2.32 0 4.2-1.91 4.2-4.267V12.267C45 9.91 43.12 8 40.8 8h-7.05c-.93 0-1.71.657-2.094 1.504-.758 1.67-2.023 2.763-3.456 2.763s-2.698-1.094-3.456-2.763C24.359 8.657 23.58 8 22.65 8m6.95 12.3a1.8 1.8 0 0 0-3.6 0v.4a1.8 1.8 0 0 0 3.6 0zm-1.8 5.2a1.8 1.8 0 0 1 1.8 1.8v.4a1.8 1.8 0 0 1-3.6 0v-.4a1.8 1.8 0 0 1 1.8-1.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTicketFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M15.1 5.333H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.3c.62 0 1.14-.439 1.396-1.003.505-1.113 1.349-1.842 2.304-1.842s1.799.729 2.304 1.842c.257.564.776 1.003 1.396 1.003h4.7c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.7c-.62 0-1.14.438-1.396 1.003C20.6 7.45 19.755 8.178 18.8 8.178s-1.799-.73-2.304-1.842c-.257-.565-.776-1.003-1.396-1.003m4.633 8.2a1.2 1.2 0 1 0-2.4 0v.267a1.2 1.2 0 1 0 2.4 0zM18.533 17a1.2 1.2 0 0 1 1.2 1.2v.267a1.2 1.2 0 1 1-2.4 0V18.2a1.2 1.2 0 0 1 1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTicketFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M11.325 4H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4m3.475 6.15a.9.9 0 1 0-1.8 0v.2a.9.9 0 1 0 1.8 0zm-.9 2.6a.9.9 0 0 1 .9.9v.2a.9.9 0 1 1-1.8 0v-.2a.9.9 0 0 1 .9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTicketFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.494 3H2.7c-.87 0-1.575.716-1.575 1.6v8.8c0 .884.705 1.6 1.575 1.6h5.794c.349 0 .64-.246.785-.564.284-.626.759-1.036 1.296-1.036s1.012.41 1.296 1.036c.144.318.436.564.785.564H15.3c.87 0 1.575-.716 1.575-1.6V4.6c0-.884-.705-1.6-1.575-1.6h-2.644c-.349 0-.64.246-.785.564-.284.626-.759 1.036-1.296 1.036s-1.012-.41-1.296-1.036C9.135 3.246 8.843 3 8.494 3M11.1 7.613a.675.675 0 1 0-1.35 0v.15a.675.675 0 1 0 1.35 0zm-.675 1.95c.373 0 .675.302.675.675v.15a.675.675 0 1 1-1.35 0v-.15c0-.373.302-.675.675-.675",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTicketFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M7.55 2.667H2.4c-.773 0-1.4.637-1.4 1.422v7.822c0 .786.627 1.422 1.4 1.422h5.15c.31 0 .57-.219.698-.501.253-.556.674-.92 1.152-.92s.9.364 1.152.92c.128.282.388.501.698.501h2.35c.773 0 1.4-.636 1.4-1.422V4.09c0-.786-.627-1.422-1.4-1.422h-2.35c-.31 0-.57.219-.698.501-.253.557-.674.921-1.152.921s-.9-.364-1.152-.92c-.128-.283-.388-.502-.698-.502m2.317 4.1a.6.6 0 0 0-1.2 0V6.9a.6.6 0 0 0 1.2 0zm-.6 1.733a.6.6 0 0 1 .6.6v.133a.6.6 0 0 1-1.2 0V9.1a.6.6 0 0 1 .6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTicketFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M5.662 2H1.8C1.22 2 .75 2.478.75 3.067v5.866C.75 9.523 1.22 10 1.8 10h3.862c.233 0 .428-.164.524-.376.19-.417.506-.69.864-.69s.675.273.864.69c.096.212.29.376.524.376H10.2c.58 0 1.05-.478 1.05-1.067V3.067c0-.59-.47-1.067-1.05-1.067H8.438c-.233 0-.428.164-.524.376-.19.417-.506.69-.864.69s-.675-.273-.864-.69C6.09 2.164 5.896 2 5.662 2M7.4 5.075a.45.45 0 1 0-.9 0v.1a.45.45 0 1 0 .9 0zm-.45 1.3a.45.45 0 0 1 .45.45v.1a.45.45 0 1 1-.9 0v-.1a.45.45 0 0 1 .45-.45",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTicketFilled/IconTicketFilled.tsx
var IconTicketFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTicketFilledMonochromeExtralight,
          "monochrome|light": IconTicketFilledMonochromeLight,
          "monochrome|regular": IconTicketFilledMonochromeRegular,
          "monochrome|medium": IconTicketFilledMonochromeMedium,
          "monochrome|semibold": IconTicketFilledMonochromeSemibold,
          "monochrome|bold": IconTicketFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTipRectangleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.686a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .055.033.099a.16.16 0 0 0 .099.033h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.055.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.786q0-.055.055-.055h.484q.351 0 .56.275.22.274.22.759 0 .473-.22.748",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.044.044.033.044.088v1.067q0 .056-.044.099a.12.12 0 0 1-.088.033H8.98q-.055 0-.055.055v6.182q0 .055-.044.099a.12.12 0 0 1-.088.033H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.786q0-.055-.055-.055h-1.32a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.532q0-.055.033-.088a.14.14 0 0 1 .099-.044zM11.365 16.1a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099V8.532q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.287q.055 0 .088.044.044.033.044.088v7.436q0 .055-.043.099a.12.12 0 0 1-.088.033z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 4.6H5.8a3.2 3.2 0 0 0-3.2 3.2v8.4a3.2 3.2 0 0 0 3.2 3.2h12.4a3.2 3.2 0 0 0 3.2-3.2V7.8a3.2 3.2 0 0 0-3.2-3.2M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTipRectangleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.686a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .056.033.099a.16.16 0 0 0 .099.033h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.055.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.786q0-.055.055-.055h.484q.351 0 .56.275.22.274.22.76 0 .472-.22.747",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.044.044.033.044.088V9.6q0 .055-.044.1a.12.12 0 0 1-.088.032H8.98q-.055 0-.055.055v6.182q0 .056-.044.099a.12.12 0 0 1-.088.033H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.786q0-.055-.055-.055h-1.32a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.532q0-.055.033-.088a.14.14 0 0 1 .099-.044zM11.365 16.1a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099V8.532q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.287q.055 0 .088.044.044.033.044.088v7.436q0 .056-.043.099a.12.12 0 0 1-.088.033z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 4.3H5.8a3.5 3.5 0 0 0-3.5 3.5v8.4a3.5 3.5 0 0 0 3.5 3.5h12.4a3.5 3.5 0 0 0 3.5-3.5V7.8a3.5 3.5 0 0 0-3.5-3.5M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTipRectangleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.686a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .055.033.099a.16.16 0 0 0 .099.033h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.055.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.786q0-.055.055-.055h.484q.351 0 .56.275.22.274.22.759 0 .473-.22.748",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.044.044.033.044.088v1.067q0 .056-.044.099a.12.12 0 0 1-.088.033H8.98q-.055 0-.055.055v6.182q0 .055-.044.099a.12.12 0 0 1-.088.033H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.786q0-.055-.055-.055h-1.32a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.532q0-.055.033-.088a.14.14 0 0 1 .099-.044zM11.365 16.1a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099V8.532q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.287q.055 0 .088.044.044.033.044.088v7.436q0 .055-.043.099a.12.12 0 0 1-.088.033z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 4H5.8A3.8 3.8 0 0 0 2 7.8v8.4A3.8 3.8 0 0 0 5.8 20h12.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 18.2 4M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTipRectangleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.686a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .055.033.099a.16.16 0 0 0 .099.033h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.055.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.786q0-.055.055-.055h.484q.351 0 .56.275.22.274.22.759 0 .473-.22.748",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.044.044.033.044.088v1.067q0 .056-.044.099a.12.12 0 0 1-.088.033H8.98q-.055 0-.055.055v6.182q0 .055-.044.099a.12.12 0 0 1-.088.033H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.786q0-.055-.055-.055h-1.32a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.532q0-.055.033-.088a.14.14 0 0 1 .099-.044zM11.365 16.1a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099V8.532q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.287q.055 0 .088.044.044.033.044.088v7.436q0 .055-.043.099a.12.12 0 0 1-.088.033z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 3.667H5.8A4.133 4.133 0 0 0 1.667 7.8v8.4A4.133 4.133 0 0 0 5.8 20.333h12.4a4.133 4.133 0 0 0 4.133-4.133V7.8A4.133 4.133 0 0 0 18.2 3.667M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTipRectangleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.685a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .055.033.1a.16.16 0 0 0 .099.032h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.054.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.785q0-.054.055-.055h.484q.352 0 .56.275.221.276.22.76.001.473-.22.747",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.043.044.034.044.088v1.067q0 .055-.044.1a.12.12 0 0 1-.088.032H8.98q-.054 0-.055.055v6.182q0 .055-.044.1a.12.12 0 0 1-.088.032H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.785q0-.054-.055-.055H6a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.531q0-.055.033-.088A.14.14 0 0 1 6 8.4zM11.365 16.1a.16.16 0 0 1-.1-.034.16.16 0 0 1-.032-.099V8.531q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.287q.055 0 .088.044.044.034.044.088v7.436q0 .055-.044.1a.12.12 0 0 1-.088.032z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 3.55H5.8A4.25 4.25 0 0 0 1.55 7.8v8.4a4.25 4.25 0 0 0 4.25 4.25h12.4a4.25 4.25 0 0 0 4.25-4.25V7.8a4.25 4.25 0 0 0-4.25-4.25M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTipRectangleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M17.189 8.686a2 2 0 0 0-1.078-.297h-2.222a.14.14 0 0 0-.1.044.12.12 0 0 0-.032.088v7.447q0 .055.033.099a.16.16 0 0 0 .099.033h1.287a.12.12 0 0 0 .088-.033.14.14 0 0 0 .044-.099v-2.926q0-.055.055-.055h.825q.891 0 1.44-.616.55-.616.55-1.639a2.7 2.7 0 0 0-.263-1.21 1.93 1.93 0 0 0-.726-.836m-.781 2.827a.68.68 0 0 1-.561.264h-.484q-.055 0-.055-.055V9.786q0-.055.055-.055h.484q.351 0 .56.275.22.274.22.759 0 .473-.22.748",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.355 8.4q.055 0 .088.044.044.033.044.088v1.067q0 .056-.044.099a.12.12 0 0 1-.088.033H8.98q-.055 0-.055.055v6.182q0 .055-.044.099a.12.12 0 0 1-.088.033H7.506a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V9.786q0-.055-.055-.055h-1.32a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099V8.532q0-.055.033-.088a.14.14 0 0 1 .099-.044zM11.365 16.1a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099V8.532q0-.055.034-.088a.14.14 0 0 1 .098-.044h1.287q.056 0 .088.044.044.033.044.088v7.436q0 .055-.043.099a.12.12 0 0 1-.088.033z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M18.2 3.4H5.8a4.4 4.4 0 0 0-4.4 4.4v8.4a4.4 4.4 0 0 0 4.4 4.4h12.4a4.4 4.4 0 0 0 4.4-4.4V7.8a4.4 4.4 0 0 0-4.4-4.4M3.8 7.8a2 2 0 0 1 2-2h12.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H5.8a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconTipRectangle/IconTipRectangle.tsx
var IconTipRectangle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTipRectangleMonochromeExtralight,
          "monochrome|light": IconTipRectangleMonochromeLight,
          "monochrome|regular": IconTipRectangleMonochromeRegular,
          "monochrome|medium": IconTipRectangleMonochromeMedium,
          "monochrome|semibold": IconTipRectangleMonochromeSemibold,
          "monochrome|bold": IconTipRectangleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTrashMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 1 0 0-2.4zM19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 1 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 1 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12m32.8 1.3H10.4V38a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM12.667 12.333a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1M20.333 13.333a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m4.333 1h17.334v15.833a2 2 0 0 1-2 2H9.333a2 2 0 0 1-2-2z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8zM9.5 9.1a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9M15.4 10a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m3.7.9h12.4V19a1.2 1.2 0 0 1-1.2 1.2H7A1.2 1.2 0 0 1 5.8 19z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6.75 1.45a.8.8 0 1 0 0 1.6h4.5a.8.8 0 0 0 0-1.6zM7.125 7.2a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8M11.675 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 1 0 1.6 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M13.4 5.8H4.6v8.45c0 .359.291.65.65.65h7.5a.65.65 0 0 0 .65-.65z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M6 1.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM6.333 6.361a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M10.417 7.111a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m10.583.9H4.167v7.434a.5.5 0 0 0 .5.5h6.666a.5.5 0 0 0 .5-.5z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6m2.3.6h5.6v5.4a.3.3 0 0 1-.3.3h-5a.3.3 0 0 1-.3-.3z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconTrash/IconTrash.tsx
var IconTrash = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTrashMonochromeExtralight,
          "monochrome|light": IconTrashMonochromeLight,
          "monochrome|regular": IconTrashMonochromeRegular,
          "monochrome|medium": IconTrashMonochromeMedium,
          "monochrome|semibold": IconTrashMonochromeSemibold,
          "monochrome|bold": IconTrashMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTrashFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 0 0 0-2.4z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 0 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12M19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 0 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m9.667 3.833a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7.666 1a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8z" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m7.4 2.6a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9m5.9.9a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5.95 2.25a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 0 1.6h-4.5a.8.8 0 0 1-.8-.8" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M7.925 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 0 0 1.6 0zm2.95-.8a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M5.25 2A.75.75 0 0 1 6 1.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 2" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m5.833 2.778a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0zm2.584-.75a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconTrashFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2zM.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6" })
        }
      );
    }
  )
);

// src/IconTrashFilled/IconTrashFilled.tsx
var IconTrashFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTrashFilledMonochromeExtralight,
          "monochrome|light": IconTrashFilledMonochromeLight,
          "monochrome|regular": IconTrashFilledMonochromeRegular,
          "monochrome|medium": IconTrashFilledMonochromeMedium,
          "monochrome|semibold": IconTrashFilledMonochromeSemibold,
          "monochrome|bold": IconTrashFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTruckMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M9 6.8A4.2 4.2 0 0 0 4.8 11v24A4.2 4.2 0 0 0 9 39.2h1.94a5.202 5.202 0 0 0 10.12 0h7.88a5.202 5.202 0 0 0 10.12 0H41a4.2 4.2 0 0 0 4.2-4.2V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.2V11A4.2 4.2 0 0 0 31 6.8zm30.06 30a5.21 5.21 0 0 0-3.86-3.86V25.2h7.6V35a1.8 1.8 0 0 1-1.8 1.8zm-6.26-3.86a5.21 5.21 0 0 0-3.86 3.86h-7.88a5.202 5.202 0 0 0-10.12 0H9A1.8 1.8 0 0 1 7.2 35V11A1.8 1.8 0 0 1 9 9.2h22a1.8 1.8 0 0 1 1.8 1.8zm2.4-17.74h1.946a1.8 1.8 0 0 1 1.61.995l3.302 6.605H35.2zM16 35.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6M31.2 38a2.8 2.8 0 1 1 5.6 0 2.8 2.8 0 0 1-5.6 0"
            }
          )
        }
      );
    }
  )
);
var IconTruckMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M3 7.333a3 3 0 0 1 3-3h14.667a3 3 0 0 1 3 3v1h1.097a3 3 0 0 1 2.683 1.659l2.57 5.138a3 3 0 0 1 .316 1.342v6.861a3 3 0 0 1-3 3h-1.138a3.668 3.668 0 0 1-7.057 0h-4.943a3.668 3.668 0 0 1-7.057 0H6a3 3 0 0 1-3-3zm20.667 3V15h4.048l-2.057-4.114a1 1 0 0 0-.894-.553zm-1 13.334a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m-12 0A1.664 1.664 0 0 0 9 25.333a1.664 1.664 0 0 0 3 1c.21-.278.333-.624.333-1a1.664 1.664 0 0 0-1.667-1.667M6 6.333a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1.138a3.668 3.668 0 0 1 7.057 0h4.943a3.67 3.67 0 0 1 2.529-2.528V7.333a1 1 0 0 0-1-1zM23.667 17v4.805a3.67 3.67 0 0 1 2.528 2.528h1.138a1 1 0 0 0 1-1V17z"
            }
          )
        }
      );
    }
  )
);
var IconTruckMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M2.1 5.5a2.4 2.4 0 0 1 2.4-2.4h11a2.4 2.4 0 0 1 2.4 2.4v.6h.673a2.4 2.4 0 0 1 2.147 1.327l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.4 2.4h-.742a2.901 2.901 0 0 1-5.516 0h-3.484a2.901 2.901 0 0 1-5.516 0H4.5a2.4 2.4 0 0 1-2.4-2.4zm15.8 2.4v3.2h2.644L19.11 8.232a.6.6 0 0 0-.537-.332zm3.2 9.6v-4.6h-3.2v3.342c.878.287 1.571.98 1.858 1.858h.742a.6.6 0 0 0 .6-.6M15.5 4.9h-11a.6.6 0 0 0-.6.6v12a.6.6 0 0 0 .6.6h.742a2.901 2.901 0 0 1 5.516 0h3.484a2.9 2.9 0 0 1 1.858-1.858V5.5a.6.6 0 0 0-.6-.6m1.5 13a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M6.9 19a1.099 1.099 0 1 0 2.2 0 1.099 1.099 0 0 0-1.733-.9c-.282.2-.467.528-.467.9"
            }
          )
        }
      );
    }
  )
);
var IconTruckMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M1.45 4.125c0-1.063.862-1.925 1.925-1.925h8.25c1.063 0 1.925.862 1.925 1.925v.325h.38c.729 0 1.395.412 1.721 1.064l1.446 2.89c.133.268.203.563.203.862v3.859a1.925 1.925 0 0 1-1.925 1.925h-.468a2.3 2.3 0 0 1-4.314 0H8.157a2.3 2.3 0 0 1-4.314 0h-.468a1.925 1.925 0 0 1-1.925-1.925zm12.1 1.925V8.2h1.656l-.986-1.97a.33.33 0 0 0-.29-.18zm2.15 7.075V9.8h-2.15v2.293c.627.232 1.124.73 1.357 1.357h.468c.18 0 .325-.146.325-.325M11.625 3.8h-8.25a.325.325 0 0 0-.325.325v9c0 .18.145.325.325.325h.468a2.3 2.3 0 0 1 4.314 0h2.436a2.3 2.3 0 0 1 1.357-1.357V4.125a.325.325 0 0 0-.325-.325M6 13.55a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4m6.75 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4"
            }
          )
        }
      );
    }
  )
);
var IconTruckMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h7.333c.967 0 1.75.783 1.75 1.75v.25h.299a1.75 1.75 0 0 1 1.565.967l1.285 2.57c.121.243.185.51.185.782v3.43a1.75 1.75 0 0 1-1.75 1.75h-.39a2.084 2.084 0 0 1-3.888 0H7.278a2.084 2.084 0 0 1-3.889 0H3a1.75 1.75 0 0 1-1.75-1.75zM12.083 7.25h1.37l-.848-1.695a.25.25 0 0 0-.223-.138h-.299zm0 1.5v1.973a2.1 2.1 0 0 1 1.195 1.194h.389a.25.25 0 0 0 .25-.25V8.75zm-1.5-5.083a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h.39a2.084 2.084 0 0 1 3.888 0h2.111a2.1 2.1 0 0 1 1.194-1.194V3.665m-5.25 8.416a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167m6 0a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167"
            }
          )
        }
      );
    }
  )
);
var IconTruckMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              d: "M1.4 3A1.6 1.6 0 0 1 3 1.4h3.333a1.6 1.6 0 0 1 1.578 1.333h.05A2.1 2.1 0 0 1 9.84 3.894l.538 1.076a2.1 2.1 0 0 1 .222.94v1.756a1.6 1.6 0 0 1-1.498 1.597 1.334 1.334 0 0 1-2.649.004H5.102a1.334 1.334 0 0 1-2.656-.1 1.6 1.6 0 0 1-1.046-1.5zm7.207 5.066H9a.4.4 0 0 0 .4-.4v-.91H7.95v1.033c.246.031.471.13.657.277m-1.124 1.2a.333.333 0 1 0 .59-.31.333.333 0 0 0-.59.31M4.11 9.111a.333.333 0 1 0-.667 0 .333.333 0 0 0 .667 0m2.622-1.044V3a.4.4 0 0 0-.4-.4H3a.4.4 0 0 0-.4.4v4.667a.4.4 0 0 0 .352.397c.227-.18.514-.286.826-.286.313 0 .601.108.829.289zm2.594-2.512-.022-.048-.538-1.076a.9.9 0 0 0-.805-.498H7.95v1.622z"
            }
          )
        }
      );
    }
  )
);

// src/IconTruck/IconTruck.tsx
var IconTruck = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTruckMonochromeExtralight,
          "monochrome|light": IconTruckMonochromeLight,
          "monochrome|regular": IconTruckMonochromeRegular,
          "monochrome|medium": IconTruckMonochromeMedium,
          "monochrome|semibold": IconTruckMonochromeSemibold,
          "monochrome|bold": IconTruckMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTruckFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 6.7A4.3 4.3 0 0 0 4.7 11v24A4.3 4.3 0 0 0 9 39.3h1.964a5.202 5.202 0 0 0 10.072 0h7.928a5.202 5.202 0 0 0 10.097-.1H40a4.19 4.19 0 0 0 2.94-1.2H43v-.06A4.19 4.19 0 0 0 44.2 35V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.3V11A4.3 4.3 0 0 0 31 6.7zm32.61 17.203q.023.048.045.097H35.3v-8.8h.846a1.8 1.8 0 0 1 1.61.995zM16 35.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6m18 0a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTruckFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3.133 7.333A2.867 2.867 0 0 1 6 4.467h14.667a2.867 2.867 0 0 1 2.866 2.866v1.002a3 3 0 0 1 2.58 1.657l2.57 5.139A3 3 0 0 1 29 16.472v6.861a3 3 0 0 1-2.803 2.994 3.668 3.668 0 0 1-7.094-.127H14.23a3.668 3.668 0 0 1-7.127 0H6a2.867 2.867 0 0 1-2.867-2.866zM26.882 16l-2.557-5.114a1 1 0 0 0-.792-.547V16zM9 25.334a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0m12 0a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTruckFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.35 5.5A2.15 2.15 0 0 1 4.5 3.35h11a2.15 2.15 0 0 1 2.15 2.15v.601a2.4 2.4 0 0 1 2.07 1.326l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.138 2.386 2.901 2.901 0 0 1-5.589-.236h-3.346a2.901 2.901 0 0 1-5.654 0H4.5a2.15 2.15 0 0 1-2.15-2.15zM19.994 12 18.11 8.232a.6.6 0 0 0-.46-.327V12zM6.9 19a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0m9 0a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTruckFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.45 4a1.8 1.8 0 0 1 1.8-1.8H11A1.8 1.8 0 0 1 12.8 4v.45h.457a1.8 1.8 0 0 1 1.61.995l1.493 2.986c.125.25.19.526.19.805v4.014a1.8 1.8 0 0 1-1.64 1.793 2.301 2.301 0 0 1-4.317.007H8.157a2.301 2.301 0 0 1-4.314 0H3.25a1.8 1.8 0 0 1-1.8-1.8zm13.406 5-1.42-2.84a.2.2 0 0 0-.18-.11H12.8V9zM5.3 14.25a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0m6.75 0a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTruckFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h6.6c.966 0 1.75.783 1.75 1.75v.4h.52c.511 0 .979.289 1.207.746l1.38 2.76c.094.188.143.395.143.604v3.74a1.35 1.35 0 0 1-1.27 1.347 2.084 2.084 0 0 1-3.941.152H7.498a.8.8 0 0 1-.21-.029 2.084 2.084 0 0 1-3.899.03H3a1.75 1.75 0 0 1-1.75-1.75zM13.33 8l-1.326-2.65a.15.15 0 0 0-.134-.083h-.52V8zM4.75 12.703a.583.583 0 1 0 .058-.292 1 1 0 0 0-.058.292m5.999-.036a.583.583 0 1 1 1.167 0 .583.583 0 0 1-1.167 0",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTruckFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M3 1.4A1.6 1.6 0 0 0 1.4 3v4.667a1.6 1.6 0 0 0 1.046 1.5 1.333 1.333 0 0 0 2.656.1h1.351a1.334 1.334 0 0 0 2.65-.004A1.6 1.6 0 0 0 10.6 7.666V5.91a2.1 2.1 0 0 0-.222-.939l-.61-1.222a1.84 1.84 0 0 0-1.855-1.003A1.6 1.6 0 0 0 6.333 1.4zm6.327 4.155H7.933V3.963a.635.635 0 0 1 .76.322l.612 1.222z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTruckFilled/IconTruckFilled.tsx
var IconTruckFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconTruckFilledMonochromeExtralight,
          "monochrome|light": IconTruckFilledMonochromeLight,
          "monochrome|regular": IconTruckFilledMonochromeRegular,
          "monochrome|medium": IconTruckFilledMonochromeMedium,
          "monochrome|semibold": IconTruckFilledMonochromeSemibold,
          "monochrome|bold": IconTruckFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconTvMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M144 390.001c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12s-5.373 12-12 12H156c-6.627 0-12-5.373-12-12M46 130.211c0-28.719 23.281-52 52-52h284c28.719 0 52 23.281 52 52v170c0 28.719-23.281 52-52 52H98c-28.719 0-52-23.281-52-52zm52-28c-15.464 0-28 12.536-28 28v170c0 15.464 12.536 28 28 28h284c15.464 0 28-12.536 28-28v-170c0-15.464-12.536-28-28-28z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTvMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M141 393.001c0-8.284 6.716-15 15-15h168c8.284 0 15 6.716 15 15s-6.716 15-15 15H156c-8.284 0-15-6.716-15-15M43 128.711c0-30.376 24.624-55 55-55h284c30.376 0 55 24.624 55 55v168c0 30.376-24.624 55-55 55H98c-30.376 0-55-24.624-55-55zm55-25c-13.807 0-25 11.193-25 25v168c0 13.807 11.193 25 25 25h284c13.807 0 25-11.193 25-25v-168c0-13.807-11.193-25-25-25z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTvMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M138 394.001c0-9.941 8.059-18 18-18h168c9.941 0 18 8.059 18 18s-8.059 18-18 18H156c-9.941 0-18-8.059-18-18M40 126.211c0-32.033 25.968-58 58-58h284c32.033 0 58 25.967 58 58v164c0 32.032-25.967 58-58 58H98c-32.032 0-58-25.968-58-58zm58-22c-12.15 0-22 9.85-22 22v164c0 12.15 9.85 22 22 22h284c12.15 0 22-9.85 22-22v-164c0-12.15-9.85-22-22-22z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTvMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M133.665 394c0-11.783 9.552-21.335 21.335-21.335h170c11.783 0 21.335 9.552 21.335 21.335s-9.552 21.335-21.335 21.335H155c-11.783 0-21.335-9.552-21.335-21.335M36.665 126.21c0-33.874 27.46-61.335 61.335-61.335h284c33.874 0 61.335 27.46 61.335 61.335v160c0 33.874-27.461 61.335-61.335 61.335H98c-33.874 0-61.335-27.461-61.335-61.335zM98 107.545c-10.308 0-18.665 8.357-18.665 18.665v160c0 10.308 8.357 18.665 18.665 18.665h284c10.308 0 18.665-8.357 18.665-18.665v-160c0-10.308-8.357-18.665-18.665-18.665z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTvMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M131.5 395.001c0-12.426 10.074-22.5 22.5-22.5h172c12.426 0 22.5 10.074 22.5 22.5s-10.074 22.5-22.5 22.5H154c-12.426 0-22.5-10.074-22.5-22.5M35.5 125.211c0-34.518 27.982-62.5 62.5-62.5h284c34.518 0 62.5 27.982 62.5 62.5v158c0 34.518-27.982 62.5-62.5 62.5H98c-34.518 0-62.5-27.982-62.5-62.5zm62.5-17.5c-9.665 0-17.5 7.835-17.5 17.5v158c0 9.665 7.835 17.5 17.5 17.5h284c9.665 0 17.5-7.835 17.5-17.5v-158c0-9.665-7.835-17.5-17.5-17.5z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconTvMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M129 396.001c0-13.255 10.745-24 24-24h174c13.255 0 24 10.745 24 24s-10.745 24-24 24H153c-13.255 0-24-10.745-24-24M34 124.211c0-35.346 28.654-64 64-64h284c35.346 0 64 28.654 64 64v158c0 35.346-28.654 64-64 64H98c-35.346 0-64-28.654-64-64zm64-16c-8.837 0-16 7.163-16 16v158c0 8.837 7.163 16 16 16h284c8.837 0 16-7.164 16-16v-158c0-8.837-7.163-16-16-16z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconTv/IconTv.tsx
var IconTv = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconTvMonochromeExtralight,
        "monochrome|light": IconTvMonochromeLight,
        "monochrome|regular": IconTvMonochromeRegular,
        "monochrome|medium": IconTvMonochromeMedium,
        "monochrome|semibold": IconTvMonochromeSemibold,
        "monochrome|bold": IconTvMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconUnderlineMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12 8.8a1.2 1.2 0 0 1 1.2 1.2v14c0 5.965 4.835 10.8 10.8 10.8S34.8 29.965 34.8 24V10a1.2 1.2 0 0 1 2.4 0v14c0 7.29-5.91 13.2-13.2 13.2S10.8 31.29 10.8 24V10A1.2 1.2 0 0 1 12 8.8M10.8 42a1.2 1.2 0 0 1 1.2-1.2h24a1.2 1.2 0 1 1 0 2.4H12a1.2 1.2 0 0 1-1.2-1.2",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconUnderlineMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 5.667a1 1 0 0 1 1 1V16a7 7 0 1 0 14 0V6.667a1 1 0 1 1 2 0V16a9 9 0 0 1-18 0V6.667a1 1 0 0 1 1-1M7 28a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconUnderlineMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6 4.1a.9.9 0 0 1 .9.9v7a5.1 5.1 0 0 0 10.2 0V5a.9.9 0 1 1 1.8 0v7a6.9 6.9 0 1 1-13.8 0V5a.9.9 0 0 1 .9-.9M5.1 21a.9.9 0 0 1 .9-.9h12a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconUnderlineMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4.5 2.95a.8.8 0 0 1 .8.8V9a3.7 3.7 0 1 0 7.4 0V3.75a.8.8 0 1 1 1.6 0V9A5.3 5.3 0 1 1 3.7 9V3.75a.8.8 0 0 1 .8-.8m-.8 12.8a.8.8 0 0 1 .8-.8h9a.8.8 0 1 1 0 1.6h-9a.8.8 0 0 1-.8-.8",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconUnderlineMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4 2.583a.75.75 0 0 1 .75.75V8a3.25 3.25 0 0 0 6.5 0V3.333a.75.75 0 0 1 1.5 0V8a4.75 4.75 0 1 1-9.5 0V3.333a.75.75 0 0 1 .75-.75M3.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconUnderlineMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3 1.9a.6.6 0 0 1 .6.6V6a2.4 2.4 0 1 0 4.8 0V2.5a.6.6 0 0 1 1.2 0V6a3.6 3.6 0 1 1-7.2 0V2.5a.6.6 0 0 1 .6-.6m-.6 8.6a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H3a.6.6 0 0 1-.6-.6",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconUnderline/IconUnderline.tsx
var IconUnderline = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconUnderlineMonochromeExtralight,
          "monochrome|light": IconUnderlineMonochromeLight,
          "monochrome|regular": IconUnderlineMonochromeRegular,
          "monochrome|medium": IconUnderlineMonochromeMedium,
          "monochrome|semibold": IconUnderlineMonochromeSemibold,
          "monochrome|bold": IconUnderlineMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconVideoMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M273.992 102.002h-168c-35.346 0-64 28.654-64 64v148c0 35.346 28.654 64 64 64h168c35.346 0 64-28.654 64-64v-2.857l62.476 53.551c19.461 16.68 49.524 2.853 49.524-22.778V138.086c0-25.631-30.063-39.458-49.524-22.778l-62.476 53.551v-2.857c0-35.346-28.654-64-64-64m64 98.467v79.066l78.095 66.939c3.892 3.336 9.905.57 9.905-4.556V138.086c0-5.126-6.013-7.892-9.905-4.556zm-24-34.467c0-22.091-17.908-40-40-40h-168c-22.091 0-40 17.909-40 40v148c0 22.091 17.909 40 40 40h168c22.092 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconVideoMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M273.996 96.006h-168c-38.66 0-70 31.34-70 70v148c0 38.66 31.34 70 70 70h168c37.905 0 68.774-30.129 69.964-67.745l56.512 48.439c19.46 16.68 49.524 2.853 49.524-22.778V138.09c0-25.631-30.064-39.458-49.524-22.778l-56.512 48.439c-1.19-37.617-32.059-67.745-69.964-67.745m70 107.226v73.547l76 65.143V138.09zm-30-37.226c0-22.092-17.909-40-40-40h-168c-22.091 0-40 17.908-40 40v148c0 22.091 17.909 40 40 40h168c22.091 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconVideoMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M274 90H106c-41.974 0-76 34.026-76 76v148c0 41.974 34.026 76 76 76h168c39.564 0 72.067-30.232 75.669-68.855l50.807 43.549c19.46 16.68 49.524 2.853 49.524-22.778V138.084c0-25.631-30.064-39.458-49.524-22.778l-50.807 43.549C346.068 120.232 313.564 90 274 90m76 115.986v68.028l64 54.857V151.129zM314 166c0-22.091-17.909-40-40-40H106c-22.091 0-40 17.909-40 40v148c0 22.091 17.909 40 40 40h168c22.091 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconVideoMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M274.007 83.335h-168c-45.656 0-82.667 37.011-82.667 82.667v148c0 45.655 37.011 82.666 82.667 82.666h168c41.456 0 75.784-30.515 81.749-70.31l44.727 38.338c19.46 16.68 49.523 2.853 49.523-22.778V138.085c0-25.63-30.063-39.457-49.523-22.777l-44.727 38.337c-5.964-39.794-40.293-70.31-81.749-70.31m82.666 125.719v61.895l50.667 43.429V165.626zm-42.666-43.052c0-22.092-17.909-40-40-40h-168c-22.092 0-40 17.908-40 40v148c0 22.091 17.908 40 40 40h168c22.091 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconVideoMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M273.996 81.001h-168c-46.944 0-85 38.056-85 85v148c0 46.944 38.056 85 85 85h168c42.125 0 77.093-30.643 83.828-70.855l42.643 36.551c19.46 16.68 49.524 2.853 49.524-22.777V138.087c0-25.631-30.064-39.458-49.524-22.778l-42.642 36.551c-6.734-40.214-41.703-70.859-83.829-70.859m85 188.881v-59.758l45.995-39.424v138.606zm-45-103.881c0-22.091-17.909-40-40-40h-168c-22.091 0-40 17.909-40 40v148c0 22.091 17.909 40 40 40h168c22.091 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconVideoMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M274.008 77.998h-168c-48.601 0-88 39.399-88 88v148c0 48.601 39.399 88 88 88h168c42.992 0 78.784-30.83 86.472-71.588l39.999 34.284c19.46 16.68 49.524 2.853 49.524-22.777V138.084c0-25.631-30.064-39.458-49.524-22.778l-39.998 34.284c-7.687-40.76-43.479-71.592-86.473-71.592m88 190.501v-56.998l39.995-34.281v125.561zm-48-102.501c0-22.091-17.909-40-40-40h-168c-22.092 0-40 17.909-40 40v148c0 22.091 17.908 40 40 40h168c22.091 0 40-17.909 40-40z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconVideo/IconVideo.tsx
var IconVideo = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconVideoMonochromeExtralight,
          "monochrome|light": IconVideoMonochromeLight,
          "monochrome|regular": IconVideoMonochromeRegular,
          "monochrome|medium": IconVideoMonochromeMedium,
          "monochrome|semibold": IconVideoMonochromeSemibold,
          "monochrome|bold": IconVideoMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconWifiMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.98 15.473c9.372-9.373 24.568-9.373 33.94 0l2.413 2.412a2 2 0 0 1-2.829 2.828l-2.412-2.412c-7.81-7.81-20.474-7.81-28.284 0l-2.412 2.412a2 2 0 1 1-2.829-2.828z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12.606 24.756c6.255-6.289 16.433-6.289 22.688 0l.586.59a2 2 0 0 1-2.836 2.82l-.586-.589c-4.691-4.717-12.325-4.717-17.016 0l-.586.59a2 2 0 1 1-2.836-2.822z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M26.65 31.758a3.903 3.903 0 1 0-5.4 5.637 3.903 3.903 0 0 0 5.4-5.637" })
          ]
        }
      );
    }
  )
);
var IconWifiMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.559 10.221c6.3-6.3 16.515-6.3 22.816 0l1.608 1.608a1.467 1.467 0 1 1-2.075 2.075L25.3 12.296c-5.155-5.155-13.512-5.155-18.667 0l-1.608 1.608a1.467 1.467 0 1 1-2.074-2.075z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M8.31 16.41c4.222-4.244 11.092-4.244 15.314 0l.39.393a1.467 1.467 0 0 1-2.08 2.069l-.39-.393a7.867 7.867 0 0 0-11.155 0l-.39.393a1.467 1.467 0 1 1-2.08-2.069z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M17.859 21.076a2.735 2.735 0 1 0-3.785 3.95 2.735 2.735 0 0 0 3.785-3.95" })
          ]
        }
      );
    }
  )
);
var IconWifiMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.348 7.595c4.765-4.765 12.49-4.765 17.254 0L21.808 8.8a1.2 1.2 0 0 1-1.697 1.697l-1.206-1.206c-3.828-3.827-10.033-3.827-13.86 0L3.84 10.498A1.2 1.2 0 0 1 2.142 8.8z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M6.161 12.237a8.2 8.2 0 0 1 11.628 0l.293.294a1.2 1.2 0 0 1-1.702 1.693l-.293-.295a5.8 5.8 0 0 0-8.224 0l-.293.295a1.2 1.2 0 0 1-1.702-1.693z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M13.473 15.734a2.152 2.152 0 1 0-2.977 3.108 2.152 2.152 0 0 0 2.977-3.108" })
          ]
        }
      );
    }
  )
);
var IconWifiMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.485 5.67a9.19 9.19 0 0 1 12.993 0l.904.904A.938.938 0 0 1 15.057 7.9l-.905-.905a7.313 7.313 0 0 0-10.341 0l-.905.905A.938.938 0 0 1 1.58 6.574z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.594 9.151a6.19 6.19 0 0 1 8.774 0l.22.221a.937.937 0 1 1-1.33 1.322l-.219-.22a4.313 4.313 0 0 0-6.115 0l-.22.22a.938.938 0 0 1-1.33-1.322z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M10.124 11.774a1.651 1.651 0 1 0-2.285 2.384 1.651 1.651 0 0 0 2.284-2.384" })
          ]
        }
      );
    }
  )
);
var IconWifiMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M2.185 5.017a8.2 8.2 0 0 1 11.597 0l.804.804a.867.867 0 0 1-1.226 1.226l-.804-.804a6.467 6.467 0 0 0-9.145 0l-.804.804A.867.867 0 0 1 1.38 5.82z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M4.06 8.112a5.533 5.533 0 0 1 7.847 0l.195.196a.867.867 0 1 1-1.23 1.223l-.194-.197a3.8 3.8 0 0 0-5.389 0l-.195.197a.867.867 0 1 1-1.23-1.223z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M9.022 10.442a1.501 1.501 0 1 0-2.077 2.168 1.501 1.501 0 0 0 2.077-2.168" })
          ]
        }
      );
    }
  )
);
var IconWifiMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.603 3.726a6.2 6.2 0 0 1 8.769 0l.603.603a.7.7 0 1 1-.99.99l-.603-.603a4.8 4.8 0 0 0-6.789 0l-.603.603A.7.7 0 1 1 1 4.33z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.01 6.047a4.2 4.2 0 0 1 5.955 0l.147.148a.7.7 0 0 1-.993.987l-.146-.147a2.8 2.8 0 0 0-3.97 0l-.147.147a.7.7 0 1 1-.993-.987z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M6.8 7.794a1.176 1.176 0 1 0-1.626 1.698 1.176 1.176 0 0 0 1.627-1.698" })
          ]
        }
      );
    }
  )
);

// src/IconWifi/IconWifi.tsx
var IconWifi = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconWifiMonochromeExtralight,
          "monochrome|light": IconWifiMonochromeLight,
          "monochrome|regular": IconWifiMonochromeRegular,
          "monochrome|medium": IconWifiMonochromeMedium,
          "monochrome|semibold": IconWifiMonochromeSemibold,
          "monochrome|bold": IconWifiMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconWonSignMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9.171 6.74a1.2 1.2 0 1 0-2.342.52l3.453 15.54H4a1.2 1.2 0 0 0 0 2.4h6.815l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L21.185 25.2h5.63l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L37.185 25.2H44a1.2 1.2 0 0 0 0-2.4h-6.282l3.453-15.54a1.2 1.2 0 0 0-2.342-.52l-3.57 16.06H28.74L25.172 6.74a1.2 1.2 0 0 0-2.343 0l-3.57 16.06H12.74zm4.103 18.46L16 37.468 18.726 25.2zm8.444-2.4h4.564L24 12.532zm7.556 2.4L32 37.468 34.726 25.2z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.667 16a1 1 0 0 1 1-1h26.666a1 1 0 1 1 0 2H2.667a1 1 0 0 1-1-1",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.117 3.69a1 1 0 0 1 1.193.76l4.357 19.607L15.024 4.45a1 1 0 0 1 1.952 0l4.358 19.607L25.69 4.45a1 1 0 0 1 1.952.434L23.286 24.49c-.464 2.088-3.44 2.088-3.905 0l-3.38-15.215-3.382 15.215c-.464 2.088-3.44 2.088-3.905 0L4.357 4.884a1 1 0 0 1 .76-1.193",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconWonSignMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M1.1 12a.9.9 0 0 1 .9-.9h20a.9.9 0 0 1 0 1.8H2a.9.9 0 0 1-.9-.9",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M3.805 4.121a.9.9 0 0 1 1.074.684l3.023 13.607q.012.043.018.049l.01.01a.12.12 0 0 0 .07.02.12.12 0 0 0 .07-.02l.01-.01a.2.2 0 0 0 .018-.049L11.12 4.805a.9.9 0 0 1 1.758 0l3.024 13.607q.01.043.017.049l.01.01a.12.12 0 0 0 .07.02c.037 0 .06-.012.07-.02l.01-.01a.2.2 0 0 0 .018-.049l3.024-13.607a.9.9 0 0 1 1.757.39l-3.024 13.607c-.441 1.984-3.269 1.984-3.71 0L12 9.15l-2.145 9.653c-.441 1.984-3.269 1.984-3.71 0L3.122 5.195a.9.9 0 0 1 .683-1.074",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
  )
);
var IconWonSignMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.826 2.969a.8.8 0 0 1 .955.607L4.808 8.2h2.384l1.027-4.624a.8.8 0 0 1 1.562 0L10.808 8.2h2.383l1.028-4.624a.8.8 0 1 1 1.562.347L14.83 8.2H16.5a.8.8 0 0 1 0 1.6h-2.025l-.962 4.329c-.36 1.618-2.666 1.618-3.026 0l-.962-4.33h-1.05l-.962 4.33c-.36 1.618-2.667 1.618-3.026 0l-.962-4.33H1.5a.8.8 0 1 1 0-1.6h1.67l-.951-4.276a.8.8 0 0 1 .607-.954m2.338 6.83L6 13.563 6.836 9.8zM8.83 8.2h.338L9 7.439zm2.333 1.6L12 13.563l.836-3.762z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M2.504 2.601a.75.75 0 0 1 .895.57l.906 4.08h2.056l.907-4.08a.75.75 0 0 1 1.464 0l.907 4.08h2.056l.906-4.08a.75.75 0 0 1 1.464.325l-.834 3.754h1.436a.75.75 0 0 1 0 1.5h-1.77l-.848 3.818c-.328 1.479-2.437 1.479-2.765 0L8.435 8.75h-.87l-.849 3.818c-.329 1.479-2.437 1.479-2.766 0L3.102 8.75H1.333a.75.75 0 0 1 0-1.5H2.77l-.835-3.754a.75.75 0 0 1 .57-.895m2.135 6.15.694 3.125.695-3.126zm3.259-1.5h.204L8 6.79zm2.074 1.5.695 3.125.694-3.126z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M1.87 1.914a.6.6 0 0 1 .716.456l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172 0l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172.26L9.97 5.4H11a.6.6 0 1 1 0 1.2H9.703l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L6.296 6.6h-.593l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L2.296 6.6H1a.6.6 0 0 1 0-1.2h1.03l-.616-2.77a.6.6 0 0 1 .456-.716M3.526 6.6 4 8.734 4.474 6.6zM5.97 5.4h.06L6 5.266zm1.556 1.2L8 8.734 8.474 6.6z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconWonSign/IconWonSign.tsx
var IconWonSign = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconWonSignMonochromeExtralight,
          "monochrome|light": IconWonSignMonochromeLight,
          "monochrome|regular": IconWonSignMonochromeRegular,
          "monochrome|medium": IconWonSignMonochromeMedium,
          "monochrome|semibold": IconWonSignMonochromeSemibold,
          "monochrome|bold": IconWonSignMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.554-27.833a1.2 1.2 0 0 0-2.306.666l1.637 5.667h-2.91a1.2 1.2 0 0 0 0 2.4h3.604l2.523 8.733a1.2 1.2 0 0 0 2.305 0L24 20.823l3.701 12.81a1.2 1.2 0 0 0 2.306 0l2.523-8.734h3.606a1.2 1.2 0 0 0 0-2.4h-2.913l1.637-5.666a1.2 1.2 0 0 0-2.305-.666l-3.701 12.81-3.7-12.81a1.2 1.2 0 0 0-2.307 0l-3.7 12.81z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13m-5.51-18.278a1 1 0 0 0-1.922.556L9.586 14.8H7.912a1 1 0 1 0 0 2h2.251l1.64 5.677a1 1 0 0 0 1.922 0L16 14.604l2.275 7.874a1 1 0 0 0 1.922 0l1.64-5.677h2.254a1 1 0 0 0 0-2h-1.676l1.017-3.523a1 1 0 1 0-1.921-.555l-2.275 7.875-2.275-7.875a1 1 0 0 0-1.921 0l-2.275 7.875z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.01 8a.9.9 0 0 0-1.729.5l.708 2.45H5.934a.9.9 0 1 0 0 1.8h1.575l1.2 4.15a.9.9 0 0 0 1.728 0L12 11.493l1.562 5.407a.9.9 0 0 0 1.73 0l1.198-4.15h1.578a.9.9 0 0 0 0-1.8H17.01l.708-2.45a.9.9 0 0 0-1.73-.5l-1.562 5.407L12.864 8a.9.9 0 0 0-1.729 0l-1.562 5.407z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16M6.128 5.965a.8.8 0 0 0-1.537.445l.485 1.677H4.45a.8.8 0 1 0 0 1.6h1.088l.873 3.023a.8.8 0 0 0 1.537 0L9 9.07l1.051 3.64a.8.8 0 0 0 1.537 0l.873-3.023h1.09a.8.8 0 1 0 0-1.6h-.627l.484-1.677a.8.8 0 0 0-1.537-.445l-1.051 3.64-1.052-3.64a.8.8 0 0 0-1.537 0l-1.052 3.64z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M5.567 5.064a.75.75 0 1 0-1.441.416l.399 1.38h-.466a.75.75 0 1 0 0 1.5h.899l.744 2.577a.75.75 0 0 0 1.441 0L8 7.974l.856 2.963a.75.75 0 0 0 1.441 0l.745-2.577h.9a.75.75 0 0 0 0-1.5h-.467l.399-1.38a.75.75 0 1 0-1.441-.417l-.856 2.963-.856-2.962a.75.75 0 0 0-1.441 0l-.856 2.962z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconWonSignCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.352 4.134a.6.6 0 1 0-1.153.333l.255.883H3.22a.6.6 0 0 0 0 1.2h.58l.511 1.767a.6.6 0 0 0 1.153 0L6 6.462l.536 1.855a.6.6 0 0 0 1.153 0l.51-1.767h.582a.6.6 0 0 0 0-1.2h-.235l.255-.883a.6.6 0 1 0-1.153-.333l-.536 1.854-.536-1.854a.6.6 0 0 0-1.152 0l-.536 1.854z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);

// src/IconWonSignCircleFilled/IconWonSignCircleFilled.tsx
var IconWonSignCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconWonSignCircleFilledMonochromeExtralight,
          "monochrome|light": IconWonSignCircleFilledMonochromeLight,
          "monochrome|regular": IconWonSignCircleFilledMonochromeRegular,
          "monochrome|medium": IconWonSignCircleFilledMonochromeMedium,
          "monochrome|semibold": IconWonSignCircleFilledMonochromeSemibold,
          "monochrome|bold": IconWonSignCircleFilledMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconXMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M381.515 81.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97L256.971 240l141.514 141.515.216.221c4.469 4.702 4.398 12.136-.216 16.749-4.613 4.614-12.047 4.685-16.749.216l-.221-.216L240 256.971 98.485 398.485c-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97L223.029 240 81.515 98.485l-.216-.221c-4.47-4.701-4.397-12.136.216-16.75 4.613-4.612 12.048-4.684 16.749-.215l.221.216L240 223.029z" })
        }
      );
    }
  )
);
var IconXMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M379.393 79.393c5.858-5.858 15.355-5.858 21.213 0s5.858 15.355 0 21.213L261.213 240l139.393 139.393.271.278c5.586 5.876 5.496 15.169-.271 20.935-5.766 5.767-15.059 5.857-20.935.271l-.278-.271L240 261.213 100.606 400.606c-5.858 5.858-15.355 5.858-21.213 0s-5.858-15.355 0-21.213L218.787 240 79.393 100.606c-5.858-5.858-5.858-15.355 0-21.213s15.355-5.858 21.213 0L240 218.787z" })
        }
      );
    }
  )
);
var IconXMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M377.272 77.272c7.03-7.03 18.426-7.03 25.455 0 7.03 7.03 7.03 18.426 0 25.455L265.455 240l137.272 137.272.325.332c6.704 7.052 6.595 18.204-.325 25.123-6.919 6.92-18.071 7.029-25.123.325l-.332-.325L240 265.455 102.727 402.727c-7.03 7.03-18.425 7.03-25.455 0-7.03-7.029-7.03-18.425 0-25.455L214.545 240 77.272 102.727c-7.03-7.03-7.03-18.425 0-25.455s18.426-7.03 25.455 0L240 214.545z" })
        }
      );
    }
  )
);
var IconXMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M374.915 74.914c8.332-8.332 21.84-8.332 30.172 0s8.332 21.84 0 30.172L270.173 240l134.914 134.914.385.394c7.945 8.359 7.816 21.576-.385 29.778s-21.419 8.33-29.778.385l-.394-.385-134.914-134.914-134.914 134.914c-8.332 8.332-21.84 8.332-30.172 0s-8.332-21.84 0-30.172L209.829 240 74.915 105.086c-8.332-8.332-8.332-21.84 0-30.172s21.84-8.332 30.172 0l134.914 134.914z" })
        }
      );
    }
  )
);
var IconXMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M374.09 74.09c8.787-8.787 23.034-8.787 31.82 0s8.787 23.034 0 31.82L271.821 240 405.91 374.09l.406.416c8.379 8.815 8.244 22.755-.406 31.404-8.649 8.65-22.589 8.785-31.404.406l-.416-.406L240 271.821 105.91 405.91c-8.786 8.787-23.033 8.787-31.82 0-8.787-8.786-8.787-23.033 0-31.82L208.18 240 74.09 105.91l-.405-.416c-8.38-8.814-8.244-22.754.405-31.404 8.65-8.65 22.59-8.784 31.404-.405l.416.405L240 208.18z" })
        }
      );
    }
  )
);
var IconXMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({ size = "1em", aspect = "width", ...props }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx("path", { d: "M373.03 73.03c9.372-9.373 24.568-9.373 33.941 0s9.373 24.568 0 33.941L273.942 240l133.029 133.03.433.443c8.937 9.402 8.793 24.272-.433 33.498s-24.096 9.37-33.498.433l-.443-.433L240 273.942 106.971 406.971c-9.373 9.373-24.569 9.373-33.942 0-9.372-9.373-9.372-24.569 0-33.941L206.06 240 73.029 106.971l-.432-.443c-8.938-9.403-8.794-24.272.433-33.499 9.226-9.226 24.095-9.37 33.498-.432l.443.433L240 206.058z" })
        }
      );
    }
  )
);

// src/IconX/IconX.tsx
var IconX = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef((props, ref) => {
    const { renderMode, weight, ...rest } = props;
    return createElement(
      {
        "monochrome|extralight": IconXMonochromeExtralight,
        "monochrome|light": IconXMonochromeLight,
        "monochrome|regular": IconXMonochromeRegular,
        "monochrome|medium": IconXMonochromeMedium,
        "monochrome|semibold": IconXMonochromeSemibold,
        "monochrome|bold": IconXMonochromeBold
      }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
      {
        ...rest,
        ref
      }
    );
  })
);
var IconXCircleMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M416 240c0-97.202-78.798-176-176-176S64 142.798 64 240s78.798 176 176 176v24c-110.457 0-200-89.543-200-200S129.543 40 240 40s200 89.543 200 200-89.543 200-200 200v-24c97.202 0 176-78.798 176-176" }),
            /* @__PURE__ */ jsx("path", { d: "M180.485 163.515c-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97L223.029 240l-59.514 59.515c-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0L240 256.971l59.515 59.514c4.686 4.687 12.284 4.687 16.97 0 4.687-4.686 4.687-12.284 0-16.97L256.971 240l59.514-59.515c4.687-4.686 4.687-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0L240 223.029z" })
          ]
        }
      );
    }
  )
);
var IconXCircleMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M410.005 239.998c0-93.888-76.112-170-170-170s-170 76.112-170 170 76.111 170 170 170v30c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200v-30c93.888 0 170-76.112 170-170" }),
            /* @__PURE__ */ jsx("path", { d: "M182.609 161.396c-5.858-5.858-15.355-5.858-21.213 0s-5.858 15.356 0 21.214l57.393 57.393-57.393 57.393c-5.858 5.858-5.858 15.356 0 21.213s15.355 5.858 21.213 0l57.393-57.393 57.394 57.393c5.858 5.858 15.355 5.858 21.213 0s5.858-15.355 0-21.213l-57.393-57.393 57.393-57.393c5.858-5.858 5.858-15.356 0-21.214s-15.355-5.858-21.213 0l-57.394 57.394z" })
          ]
        }
      );
    }
  )
);
var IconXCircleMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M404 240c0-90.575-73.425-164-164-164S76 149.425 76 240s73.425 164 164 164v36c-110.457 0-200-89.543-200-200S129.543 40 240 40s200 89.543 200 200-89.543 200-200 200v-36c90.575 0 164-73.425 164-164" }),
            /* @__PURE__ */ jsx("path", { d: "M184.728 159.272c-7.03-7.029-18.426-7.029-25.456 0-7.029 7.03-7.029 18.426 0 25.456L214.544 240l-55.272 55.272c-7.029 7.03-7.029 18.426 0 25.456 7.03 7.029 18.426 7.029 25.456 0L240 265.456l55.272 55.272c7.03 7.029 18.426 7.029 25.456 0 7.029-7.03 7.029-18.426 0-25.456L265.456 240l55.272-55.272c7.029-7.03 7.029-18.426 0-25.456-7.03-7.029-18.426-7.029-25.456 0L240 214.544z" })
          ]
        }
      );
    }
  )
);
var IconXCircleMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M397.33 240c0-86.891-70.439-157.33-157.33-157.33S82.67 153.109 82.67 240 153.109 397.33 240 397.33V440c-110.457 0-200-89.543-200-200S129.543 40 240 40s200 89.543 200 200-89.543 200-200 200v-42.67c86.891 0 157.33-70.439 157.33-157.33" }),
            /* @__PURE__ */ jsx("path", { d: "M187.085 156.915c-8.331-8.331-21.839-8.331-30.17 0s-8.331 21.839 0 30.17L209.83 240l-52.915 52.915c-8.331 8.331-8.331 21.839 0 30.17s21.839 8.331 30.17 0L240 270.17l52.915 52.915c8.331 8.331 21.839 8.331 30.17 0s8.331-21.839 0-30.17L270.17 240l52.915-52.915c8.331-8.331 8.331-21.839 0-30.17s-21.839-8.331-30.17 0L240 209.83z" })
          ]
        }
      );
    }
  )
);
var IconXCircleMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M394.99 240.005c0-85.604-69.396-155-155-155s-155 69.396-155 155 69.396 155 155 155v45c-110.457 0-200-89.543-200-200s89.543-200 200-200 200 89.543 200 200-89.543 200-200 200v-45c85.604 0 155-69.396 155-155" }),
            /* @__PURE__ */ jsx("path", { d: "M187.905 156.085c-8.787-8.787-23.033-8.787-31.82 0s-8.787 23.033 0 31.82l52.09 52.09-52.09 52.09c-8.787 8.787-8.787 23.033 0 31.82s23.033 8.787 31.82 0l52.09-52.09 52.09 52.09c8.787 8.787 23.033 8.787 31.82 0s8.787-23.033 0-31.82l-52.09-52.09 52.09-52.09c8.787-8.787 8.787-23.033 0-31.82s-23.033-8.787-31.82 0l-52.09 52.09z" })
          ]
        }
      );
    }
  )
);
var IconXCircleMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          fill: "currentColor",
          viewBox: "0 0 480 480",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx("path", { d: "M392 240c0-83.947-68.053-152-152-152S88 156.053 88 240s68.053 152 152 152v48c-110.457 0-200-89.543-200-200S129.543 40 240 40s200 89.543 200 200-89.543 200-200 200v-48c83.947 0 152-68.053 152-152" }),
            /* @__PURE__ */ jsx("path", { d: "M188.971 155.029c-9.373-9.372-24.569-9.372-33.942 0-9.372 9.373-9.372 24.569 0 33.942L206.059 240l-51.03 51.029c-9.372 9.373-9.372 24.569 0 33.942 9.373 9.372 24.569 9.372 33.942 0L240 273.941l51.029 51.03c9.373 9.372 24.569 9.372 33.942 0 9.372-9.373 9.372-24.569 0-33.942L273.941 240l51.03-51.029c9.372-9.373 9.372-24.569 0-33.942-9.373-9.372-24.569-9.372-33.942 0L240 206.059z" })
          ]
        }
      );
    }
  )
);

// src/IconXCircle/IconXCircle.tsx
var IconXCircle = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconXCircleMonochromeExtralight,
          "monochrome|light": IconXCircleMonochromeLight,
          "monochrome|regular": IconXCircleMonochromeRegular,
          "monochrome|medium": IconXCircleMonochromeMedium,
          "monochrome|semibold": IconXCircleMonochromeSemibold,
          "monochrome|bold": IconXCircleMonochromeBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-6.151 12.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 32 32",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M16 2.667C8.636 2.667 2.667 8.636 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667m-3.96 7.96a1 1 0 0 0-1.414 1.414l3.96 3.96-3.96 3.959a1 1 0 0 0 1.414 1.414l3.96-3.96 3.96 3.96a1 1 0 1 0 1.414-1.414L17.414 16l3.96-3.96a1 1 0 0 0-1.415-1.414L16 14.586z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 24 24",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M9.136 7.864a.9.9 0 0 0-1.272 1.272L10.727 12l-2.863 2.864a.9.9 0 0 0 1.272 1.272L12 13.273l2.864 2.863a.9.9 0 1 0 1.272-1.272L13.273 12l2.863-2.864a.9.9 0 1 0-1.272-1.272L12 10.727z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 18 18",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M6.94 5.81a.8.8 0 0 0-1.13 1.13L7.868 9l-2.06 2.06a.8.8 0 0 0 1.132 1.13L9 10.132l2.06 2.06a.8.8 0 0 0 1.13-1.132L10.132 9l2.06-2.06a.8.8 0 0 0-1.132-1.13L9 7.868z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 16 16",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 1.334a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.334M6.197 5.136a.75.75 0 0 0-1.06 1.06L6.938 8 5.136 9.803a.75.75 0 1 0 1.061 1.06L8 9.06l1.803 1.803a.75.75 0 1 0 1.06-1.06L9.062 8l1.803-1.803a.75.75 0 0 0-1.06-1.06L8 6.938z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledMonochromeBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 12 12",
          ref,
          ...props,
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M4.674 3.826a.6.6 0 1 0-.848.848L5.15 6 3.826 7.326a.6.6 0 1 0 .848.848L6 6.85l1.326 1.325a.6.6 0 1 0 .848-.848L6.85 6l1.325-1.326a.6.6 0 1 0-.848-.848L6 5.15z",
              clipRule: "evenodd"
            }
          )
        }
      );
    }
  )
);
var IconXCircleFilledPaletteExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteExtralight-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteExtralight-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-6.151 12.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteExtralight-palette1, black)",
                d: "M17.849 16.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledPaletteLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteLight-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteLight-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.955 20-20S35.046 4 24 4m-5.94 11.94a1.5 1.5 0 0 0-2.12 2.12L21.877 24l-5.939 5.94a1.5 1.5 0 0 0 2.122 2.12L24 26.123l5.94 5.939a1.5 1.5 0 1 0 2.12-2.121L26.121 24l5.94-5.94a1.5 1.5 0 1 0-2.122-2.12L24 21.879z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteLight-palette1, black)",
                d: "M18.06 15.94a1.5 1.5 0 0 0-2.12 2.12L21.877 24l-5.939 5.94a1.5 1.5 0 0 0 2.122 2.12L24 26.123l5.94 5.939a1.5 1.5 0 1 0 2.12-2.121L26.121 24l5.94-5.94a1.5 1.5 0 1 0-2.122-2.12L24 21.879z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledPaletteRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteRegular-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteRegular-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.727 11.727a1.8 1.8 0 0 0-2.546 2.546L21.454 24l-5.727 5.727a1.8 1.8 0 0 0 2.546 2.546L24 26.546l5.727 5.727a1.8 1.8 0 1 0 2.546-2.546L26.546 24l5.727-5.727a1.8 1.8 0 1 0-2.546-2.546L24 21.454z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteRegular-palette1, black)",
                d: "M18.273 15.727a1.8 1.8 0 0 0-2.546 2.546L21.454 24l-5.727 5.727a1.8 1.8 0 0 0 2.546 2.546L24 26.546l5.727 5.727a1.8 1.8 0 1 0 2.546-2.546L26.546 24l5.727-5.727a1.8 1.8 0 1 0-2.546-2.546L24 21.454z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledPaletteMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteMedium-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteMedium-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.491 11.492a2.133 2.133 0 0 0-3.017 3.017L20.983 24l-5.491 5.491a2.133 2.133 0 0 0 3.017 3.017L24 27.018l5.491 5.49a2.133 2.133 0 0 0 3.017-3.017L27.018 24l5.49-5.491a2.133 2.133 0 0 0-3.017-3.017L24 20.983z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteMedium-palette1, black)",
                d: "M18.509 15.492a2.133 2.133 0 0 0-3.017 3.017L20.983 24l-5.491 5.491a2.133 2.133 0 0 0 3.017 3.017L24 27.018l5.491 5.49a2.133 2.133 0 0 0 3.017-3.017L27.018 24l5.49-5.491a2.133 2.133 0 0 0-3.017-3.017L24 20.983z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledPaletteSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteSemibold-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteSemibold-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.955 4 24s8.954 20 20 20 20-8.954 20-20S35.045 4 24 4M18.59 15.41a2.25 2.25 0 1 0-3.182 3.181L20.82 24l-5.41 5.409a2.25 2.25 0 0 0 3.182 3.182l5.41-5.41 5.408 5.41a2.25 2.25 0 1 0 3.182-3.183L27.182 24l5.41-5.41a2.25 2.25 0 0 0-3.183-3.181L24 20.817z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteSemibold-palette1, black)",
                d: "M18.591 15.409a2.25 2.25 0 1 0-3.182 3.181L20.82 24l-5.41 5.409a2.25 2.25 0 0 0 3.182 3.182l5.41-5.41 5.408 5.41a2.25 2.25 0 1 0 3.182-3.183L27.182 24l5.41-5.41a2.25 2.25 0 0 0-3.183-3.181L24 20.817z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledPaletteBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      style,
      palette1,
      palette2,
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      const _style = {
        ...Object.fromEntries(
          Object.entries({
            palette1,
            palette2
          }).filter(([, v]) => v !== void 0).map(([k, v]) => [`--IconXCircleFilledPaletteBold-${k}`, v])
        ),
        ...style
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          style: _style,
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteBold-palette2, black)",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.303 11.303a2.4 2.4 0 1 0-3.394 3.394L20.606 24l-5.303 5.303a2.4 2.4 0 1 0 3.394 3.394L24 27.394l5.303 5.303a2.4 2.4 0 1 0 3.394-3.394L27.394 24l5.303-5.303a2.4 2.4 0 1 0-3.394-3.394L24 20.606z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "var(--IconXCircleFilledPaletteBold-palette1, black)",
                d: "M18.697 15.303a2.4 2.4 0 1 0-3.394 3.394L20.606 24l-5.303 5.303a2.4 2.4 0 1 0 3.394 3.394L24 27.394l5.303 5.303a2.4 2.4 0 1 0 3.394-3.394L27.394 24l5.303-5.303a2.4 2.4 0 1 0-3.394-3.394L24 20.606z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorExtralight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-6.151 12.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M17.849 16.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorLight = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.955 20-20S35.046 4 24 4m-5.94 11.94a1.5 1.5 0 0 0-2.12 2.12L21.877 24l-5.939 5.94a1.5 1.5 0 0 0 2.122 2.12L24 26.123l5.94 5.939a1.5 1.5 0 1 0 2.12-2.121L26.121 24l5.94-5.94a1.5 1.5 0 1 0-2.122-2.12L24 21.879z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M18.06 15.94a1.5 1.5 0 0 0-2.12 2.12L21.877 24l-5.939 5.94a1.5 1.5 0 0 0 2.122 2.12L24 26.123l5.94 5.939a1.5 1.5 0 1 0 2.12-2.121L26.121 24l5.94-5.94a1.5 1.5 0 1 0-2.122-2.12L24 21.879z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorRegular = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.727 11.727a1.8 1.8 0 0 0-2.546 2.546L21.454 24l-5.727 5.727a1.8 1.8 0 0 0 2.546 2.546L24 26.546l5.727 5.727a1.8 1.8 0 1 0 2.546-2.546L26.546 24l5.727-5.727a1.8 1.8 0 1 0-2.546-2.546L24 21.454z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M18.273 15.727a1.8 1.8 0 0 0-2.546 2.546L21.454 24l-5.727 5.727a1.8 1.8 0 0 0 2.546 2.546L24 26.546l5.727 5.727a1.8 1.8 0 1 0 2.546-2.546L26.546 24l5.727-5.727a1.8 1.8 0 1 0-2.546-2.546L24 21.454z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorMedium = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.491 11.492a2.133 2.133 0 0 0-3.017 3.017L20.983 24l-5.491 5.491a2.133 2.133 0 0 0 3.017 3.017L24 27.018l5.491 5.49a2.133 2.133 0 0 0 3.017-3.017L27.018 24l5.49-5.491a2.133 2.133 0 0 0-3.017-3.017L24 20.983z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M18.509 15.492a2.133 2.133 0 0 0-3.017 3.017L20.983 24l-5.491 5.491a2.133 2.133 0 0 0 3.017 3.017L24 27.018l5.491 5.49a2.133 2.133 0 0 0 3.017-3.017L27.018 24l5.49-5.491a2.133 2.133 0 0 0-3.017-3.017L24 20.983z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorSemibold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.955 4 24s8.954 20 20 20 20-8.954 20-20S35.045 4 24 4M18.59 15.41a2.25 2.25 0 1 0-3.182 3.181L20.82 24l-5.41 5.409a2.25 2.25 0 0 0 3.182 3.182l5.41-5.41 5.408 5.41a2.25 2.25 0 1 0 3.182-3.183L27.182 24l5.41-5.41a2.25 2.25 0 0 0-3.183-3.181L24 20.817z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M18.591 15.409a2.25 2.25 0 1 0-3.182 3.181L20.82 24l-5.41 5.409a2.25 2.25 0 0 0 3.182 3.182l5.41-5.41 5.408 5.41a2.25 2.25 0 1 0 3.182-3.183L27.182 24l5.41-5.41a2.25 2.25 0 0 0-3.183-3.181L24 20.817z"
              }
            )
          ]
        }
      );
    }
  )
);
var IconXCircleFilledMulticolorBold = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    ({
      size = "1em",
      aspect = "width",
      ...props
    }, ref) => {
      const [_sizeW, _sizeH] = (() => {
        if (aspect === "both") {
          return [size, size];
        }
        return aspect === "height" ? [void 0, size] : [size, void 0];
      })();
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: _sizeW,
          height: _sizeH,
          viewBox: "0 0 48 48",
          ref,
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-5.303 11.303a2.4 2.4 0 1 0-3.394 3.394L20.606 24l-5.303 5.303a2.4 2.4 0 1 0 3.394 3.394L24 27.394l5.303 5.303a2.4 2.4 0 1 0 3.394-3.394L27.394 24l5.303-5.303a2.4 2.4 0 1 0-3.394-3.394L24 20.606z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#fff",
                d: "M18.697 15.303a2.4 2.4 0 1 0-3.394 3.394L20.606 24l-5.303 5.303a2.4 2.4 0 1 0 3.394 3.394L24 27.394l5.303 5.303a2.4 2.4 0 1 0 3.394-3.394L27.394 24l5.303-5.303a2.4 2.4 0 1 0-3.394-3.394L24 20.606z"
              }
            )
          ]
        }
      );
    }
  )
);

// src/IconXCircleFilled/IconXCircleFilled.tsx
var IconXCircleFilled = /* @__PURE__ */ memo(
  /* @__PURE__ */ forwardRef(
    (props, ref) => {
      const { renderMode, weight, ...rest } = props;
      return createElement(
        {
          "monochrome|extralight": IconXCircleFilledMonochromeExtralight,
          "monochrome|light": IconXCircleFilledMonochromeLight,
          "monochrome|regular": IconXCircleFilledMonochromeRegular,
          "monochrome|medium": IconXCircleFilledMonochromeMedium,
          "monochrome|semibold": IconXCircleFilledMonochromeSemibold,
          "monochrome|bold": IconXCircleFilledMonochromeBold,
          "palette|extralight": IconXCircleFilledPaletteExtralight,
          "palette|light": IconXCircleFilledPaletteLight,
          "palette|regular": IconXCircleFilledPaletteRegular,
          "palette|medium": IconXCircleFilledPaletteMedium,
          "palette|semibold": IconXCircleFilledPaletteSemibold,
          "palette|bold": IconXCircleFilledPaletteBold,
          "multicolor|extralight": IconXCircleFilledMulticolorExtralight,
          "multicolor|light": IconXCircleFilledMulticolorLight,
          "multicolor|regular": IconXCircleFilledMulticolorRegular,
          "multicolor|medium": IconXCircleFilledMulticolorMedium,
          "multicolor|semibold": IconXCircleFilledMulticolorSemibold,
          "multicolor|bold": IconXCircleFilledMulticolorBold
        }[`${renderMode ?? "monochrome"}|${weight ?? ""}`] ?? (() => null),
        {
          ...rest,
          ref
        }
      );
    }
  )
);

export { IconAbcRectangleFilled, IconAr, IconArrowDown, IconArrowDownCircle, IconArrowDownCircleFilled, IconArrowDownToBracket, IconArrowDownToLine, IconArrowLeft, IconArrowLeftArrowRight, IconArrowLeftFromLine3Horizontal, IconArrowRight, IconArrowRightFromLine3Horizontal, IconArrowRightFromRectanglePortrait, IconArrowTriangleDown, IconArrowTriangleHeadClockwise, IconArrowTriangleRight, IconArrowTriangleUp, IconArrowUp, IconArrowUpArrowDown, IconArrowUpFromBracket, IconArrowUpRightFromSquare, IconArrowUpToLine, IconArrowUturnLeft, IconArrowUturnRight, IconAward, IconAwardFilled, IconBell, IconBellFilled, IconBlockQuote, IconBold, IconBookmark, IconBookmarkFilled, IconBubble, IconBubbleFilled, IconBubbleLeftBubbleRight, IconBubbleLeftBubbleRightFilled, IconBullhorn, IconBullhornFilled, IconCCircle, IconCCircleFilled, IconCalculator, IconCalendar, IconCalendarFilled, IconCamera, IconCameraFilled, IconCart, IconCheck, IconCheckCircle, IconCheckCircleFilled, IconCheckSeal, IconCheckSealFilled, IconChevronDown, IconChevronDownLeftChevronUpRight, IconChevronLeft, IconChevronRight, IconChevronUp, IconCircleFilled, IconClock, IconClockFilled, IconCreditCard, IconCreditCardFilled, IconCrownFilled, IconCubeBadgeSparkle, IconDesktop, IconDoubleQuoteClosing, IconDoubleQuoteOpening, IconEllipsis, IconEllipsisVertical, IconExclamationTriangle, IconExclamationTriangleFilled, IconEye, IconFaceSmilingSafetyHelmet, IconFaceSmilingSafetyHelmetFilled, IconFire, IconFireFilled, IconForwardFilled, IconFunnel, IconFunnelFilled, IconGear, IconGift, IconGiftFilled, IconGlobe, IconGripVertical, IconHashtag, IconHeadset, IconHeart, IconHeartFilled, IconHouse, IconHouseFilled, IconInfoCircle, IconInfoCircleFilled, IconItalic, IconLensViewfinder, IconLine3Horizontal, IconLine3VerticalIncrease, IconLink, IconListBullet, IconListBulletSquare, IconListBulletSquareFilled, IconLocationPinDot, IconLocationPinDotFilled, IconLock, IconLockFilled, IconMagnifyingGlass, IconMagnifyingGlassViewfinder, IconMinus, IconMobile, IconPCircle, IconPCircleFilled, IconPaperClip, IconPaperPlaneFilled, IconPause, IconPencil, IconPencilFilled, IconPerson, IconPersonBadgePlus, IconPersonFilled, IconPhone, IconPhoneFilled, IconPhoto, IconPin, IconPlayAppWindow, IconPlayCircle, IconPlayCircleFilled, IconPlayFilled, IconPlus, IconPlusCircle, IconPlusCircleFilled, IconPlusSquare, IconPlusSquareFilled, IconPoint3ConnectedSplitPath, IconQuestionCircle, IconQuestionCircleFilled, IconRectangleGrid1X2Filled, IconShield, IconShieldFilled, IconShoppingBag, IconSliderHorizontal, IconSpeakerSlashFilled, IconSpeakerWave2Filled, IconSpeakerXFilled, IconSquareAndPencil, IconSquareGrid2X2Filled, IconSquareOnSquare, IconSquareOnSquareFilled, IconStar, IconStarFilled, IconStore, IconStoreFilled, IconTag, IconTagFilled, IconTextAlignCenter, IconTextAlignLeft, IconTextAlignRight, IconTextDocument, IconTextDocumentFilled, IconTextJustifyLeft, IconTextRectangleOnRectangleAngled, IconTextRectangleOnRectangleAngledFilled, IconThumbsDown, IconThumbsDownFilled, IconThumbsUp, IconThumbsUpFilled, IconTicket, IconTicketFilled, IconTipRectangle, IconTrash, IconTrashFilled, IconTruck, IconTruckFilled, IconTv, IconUnderline, IconVideo, IconWifi, IconWonSign, IconWonSignCircleFilled, IconX, IconXCircle, IconXCircleFilled };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map